import g, { useState as Y, useContext as O, useRef as T, useCallback as X, useEffect as ee, useMemo as K, forwardRef as te, createContext as G, useReducer as zv, cloneElement as du, isValidElement as Ov, version as Hv } from "react";
import cu, { createPortal as Nd, flushSync as at } from "react-dom";
function ot(...e) {
  return (...t) => {
    for (let n of e) typeof n == "function" && n(...t);
  };
}
const ue = typeof document < "u" ? g.useLayoutEffect : () => {
}, Ua = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Vd = /* @__PURE__ */ g.createContext(Ua), Uv = /* @__PURE__ */ g.createContext(!1);
let jv = !!(typeof window < "u" && window.document && window.document.createElement), Vl = /* @__PURE__ */ new WeakMap();
function _v(e = !1) {
  let t = O(Vd), n = T(null);
  if (n.current === null && !e) {
    let r = (
      // @ts-ignore
      g.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current
    );
    if (r) {
      let a = Vl.get(r);
      a == null ? Vl.set(r, {
        id: t.current,
        state: r.memoizedState
      }) : r.memoizedState !== a.state && (t.current = a.id, Vl.delete(r));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function Wv(e) {
  let t = O(Vd);
  t === Ua && !jv && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = _v(!!e), r = t === Ua && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Gv(e) {
  let t = g.useId(), [n] = Y(Dt()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Ua.prefix}`;
  return e || `${r}-${t}`;
}
const qv = typeof g.useId == "function" ? Gv : Wv;
function Yv() {
  return !1;
}
function Zv() {
  return !0;
}
function Xv(e) {
  return () => {
  };
}
function Dt() {
  return typeof g.useSyncExternalStore == "function" ? g.useSyncExternalStore(Xv, Yv, Zv) : O(Uv);
}
function Jv(e) {
  let [t, n] = Y(e), r = T(t), a = T(null), l = T(() => {
    if (!a.current) return;
    let u = a.current.next();
    if (u.done) {
      a.current = null;
      return;
    }
    r.current === u.value ? l.current() : n(u.value);
  });
  ue(() => {
    r.current = t, a.current && l.current();
  });
  let i = X((u) => {
    a.current = u(r.current), l.current();
  }, [
    l
  ]);
  return [
    t,
    i
  ];
}
let Qv = !!(typeof window < "u" && window.document && window.document.createElement), ur = /* @__PURE__ */ new Map(), Vr;
typeof FinalizationRegistry < "u" && (Vr = new FinalizationRegistry((e) => {
  ur.delete(e);
}));
function ce(e) {
  let [t, n] = Y(e), r = T(null), a = qv(t), l = T(null);
  if (Vr && Vr.register(l, a), Qv) {
    const i = ur.get(a);
    i && !i.includes(r) ? i.push(r) : ur.set(a, [
      r
    ]);
  }
  return ue(() => {
    let i = a;
    return () => {
      Vr && Vr.unregister(l), ur.delete(i);
    };
  }, [
    a
  ]), ee(() => {
    let i = r.current;
    return i && n(i), () => {
      i && (r.current = null);
    };
  }), a;
}
function e5(e, t) {
  if (e === t) return e;
  let n = ur.get(e);
  if (n)
    return n.forEach((a) => a.current = t), t;
  let r = ur.get(t);
  return r ? (r.forEach((a) => a.current = e), e) : t;
}
function bt(e = []) {
  let t = ce(), [n, r] = Jv(t), a = X(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return ue(a, [
    t,
    a,
    ...e
  ]), n;
}
function xt(...e) {
  return e.length === 1 && e[0] ? e[0] : (t) => {
    let n = !1;
    const r = e.map((a) => {
      const l = Oo(a, t);
      return n ||= typeof l == "function", l;
    });
    if (n) return () => {
      r.forEach((a, l) => {
        typeof a == "function" ? a() : Oo(e[l], null);
      });
    };
  };
}
function Oo(e, t) {
  if (typeof e == "function") return e(t);
  e != null && (e.current = t);
}
function Ld(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var a = e.length;
    for (t = 0; t < a; t++) e[t] && (n = Ld(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function t5() {
  for (var e, t, n = 0, r = "", a = arguments.length; n < a; n++) (e = arguments[n]) && (t = Ld(e)) && (r && (r += " "), r += t);
  return r;
}
function z(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let a in r) {
      let l = t[a], i = r[a];
      typeof l == "function" && typeof i == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? t[a] = ot(l, i) : (a === "className" || a === "UNSAFE_className") && typeof l == "string" && typeof i == "string" ? t[a] = t5(l, i) : a === "id" && l && i ? t.id = e5(l, i) : a === "ref" && l && i ? t.ref = xt(l, i) : t[a] = i !== void 0 ? i : l;
    }
  }
  return t;
}
function $e(e) {
  const t = T(null), n = T(void 0), r = X((a) => {
    if (typeof e == "function") {
      const l = e, i = l(a);
      return () => {
        typeof i == "function" ? i() : l(null);
      };
    } else if (e)
      return e.current = a, () => {
        e.current = null;
      };
  }, [
    e
  ]);
  return K(() => ({
    get current() {
      return t.current;
    },
    set current(a) {
      t.current = a, n.current && (n.current(), n.current = void 0), a != null && (n.current = r(a));
    }
  }), [
    r
  ]);
}
const gt = /* @__PURE__ */ Symbol("default");
function me({ values: e, children: t }) {
  for (let [n, r] of e)
    t = /* @__PURE__ */ g.createElement(n.Provider, {
      value: r
    }, t);
  return t;
}
function le(e) {
  let { className: t, style: n, children: r, defaultClassName: a, defaultChildren: l, defaultStyle: i, values: u, render: o } = e;
  return K(() => {
    let d, s, c;
    return typeof t == "function" ? d = t({
      ...u,
      defaultClassName: a
    }) : d = t, typeof n == "function" ? s = n({
      ...u,
      defaultStyle: i || {}
    }) : s = n, typeof r == "function" ? c = r({
      ...u,
      defaultChildren: l
    }) : r == null ? c = l : c = r, {
      className: d ?? a,
      style: s || i ? {
        ...i,
        ...s
      } : void 0,
      children: c ?? l,
      "data-rac": "",
      render: o ? (f) => o(f, u) : void 0
    };
  }, [
    t,
    n,
    r,
    a,
    l,
    i,
    u,
    o
  ]);
}
function n5(e, t) {
  return (n) => t(typeof e == "function" ? e(n) : e, n);
}
function Oe(e, t) {
  let n = O(e);
  if (t === null)
    return null;
  if (n && typeof n == "object" && "slots" in n && n.slots) {
    let r = t || gt;
    if (!n.slots[r]) {
      let a = new Intl.ListFormat().format(Object.keys(n.slots).map((i) => `"${i}"`)), l = t ? `Invalid slot "${t}".` : "A slot prop is required.";
      throw new Error(`${l} Valid slot names are ${a}.`);
    }
    return n.slots[r];
  }
  return n;
}
function oe(e, t, n) {
  let r = Oe(n, e.slot) || {}, { ref: a, ...l } = r, i = $e(K(() => xt(t, a), [
    t,
    a
  ])), u = z(l, e);
  return "style" in l && l.style && "style" in e && e.style && (typeof l.style == "function" || typeof e.style == "function" ? u.style = (o) => {
    let d = typeof l.style == "function" ? l.style(o) : l.style, s = {
      ...o.defaultStyle,
      ...d
    }, c = typeof e.style == "function" ? e.style({
      ...o,
      defaultStyle: s
    }) : e.style;
    return {
      ...s,
      ...c
    };
  } : u.style = {
    ...l.style,
    ...e.style
  }), [
    u,
    i
  ];
}
function Je(e = !0) {
  let [t, n] = Y(e), r = T(!1), a = X((l) => {
    r.current = !0, n(!!l);
  }, []);
  return ue(() => {
    r.current || n(!1);
  }, []), [
    a,
    t
  ];
}
function Et(e) {
  const t = /^(data-.*)$/;
  let n = {};
  for (const r in e) t.test(r) || (n[r] = e[r]);
  return n;
}
function r5(e, t, n) {
  let { render: r, ...a } = t, l = T(null), i = K(() => xt(n, l), [
    n,
    l
  ]);
  ue(() => {
    process.env.NODE_ENV !== "production" && r && (l.current ? l.current.localName !== e && console.warn(`Unexpected DOM element returned by custom \`render\` function. Expected <${e}>, got <${l.current.localName}>. This may break the component behavior and accessibility.`) : console.warn("Ref was not connected to DOM element returned by custom `render` function. Did you forget to pass through or merge the `ref`?"));
  }, [
    e,
    r
  ]);
  let u = {
    ...a,
    ref: i
  };
  return r ? r(u, void 0) : /* @__PURE__ */ g.createElement(e, u);
}
const Ho = {}, Q = new Proxy({}, {
  get(e, t) {
    if (typeof t != "string") return;
    let n = Ho[t];
    return n || (n = /* @__PURE__ */ te(r5.bind(null, t)), Ho[t] = n), n;
  }
}), zd = "react-aria-clear-focus", gi = "react-aria-focus", he = (e) => e?.ownerDocument ?? document, ke = (e) => e && "window" in e && e.window === e ? e : he(e).defaultView || window;
function a5(e) {
  return e !== null && typeof e == "object" && "nodeType" in e && typeof e.nodeType == "number";
}
function l5(e) {
  return a5(e) && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE && "host" in e;
}
let i5 = !1;
function Ht() {
  return i5;
}
function ae(e, t) {
  if (!Ht()) return t && e ? e.contains(t) : !1;
  if (!e || !t) return !1;
  let n = t;
  for (; n !== null; ) {
    if (n === e) return !0;
    n.tagName === "SLOT" && n.assignedSlot ? n = n.assignedSlot.parentNode : l5(n) ? n = n.host : n = n.parentNode;
  }
  return !1;
}
const se = (e = document) => {
  if (!Ht()) return e.activeElement;
  let t = e.activeElement;
  for (; t && "shadowRoot" in t && t.shadowRoot?.activeElement; ) t = t.shadowRoot.activeElement;
  return t;
};
function W(e) {
  if (Ht() && e.target instanceof Element && e.target.shadowRoot) {
    if ("composedPath" in e) return e.composedPath()[0] ?? null;
    if ("composedPath" in e.nativeEvent) return e.nativeEvent.composedPath()[0] ?? null;
  }
  return e.target;
}
function qt(e) {
  if (!e) return !1;
  let t = e.getRootNode(), n = ke(e);
  if (!(t instanceof n.Document || t instanceof n.ShadowRoot)) return !1;
  let r = t.activeElement;
  return r != null && e.contains(r);
}
function fu(e) {
  let t = Od(he(e));
  t !== e && (t && yi(t, e), e && ja(e, t));
}
function yi(e, t) {
  e.dispatchEvent(new FocusEvent("blur", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusout", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function ja(e, t) {
  e.dispatchEvent(new FocusEvent("focus", {
    relatedTarget: t
  })), e.dispatchEvent(new FocusEvent("focusin", {
    bubbles: !0,
    relatedTarget: t
  }));
}
function Od(e) {
  let t = se(e), n = t?.getAttribute("aria-activedescendant");
  return n && e.getElementById(n) || t;
}
function Fe(e) {
  if (u5()) e.focus({
    preventScroll: !0
  });
  else {
    let t = o5(e);
    e.focus(), s5(t);
  }
}
let xa = null;
function u5() {
  if (xa == null) {
    xa = !1;
    try {
      document.createElement("div").focus({
        get preventScroll() {
          return xa = !0, !0;
        }
      });
    } catch {
    }
  }
  return xa;
}
function o5(e) {
  let t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement;
  for (; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function s5(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
const d5 = typeof Element < "u" && "checkVisibility" in Element.prototype;
function c5(e) {
  const t = ke(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement)) return !1;
  let { display: n, visibility: r } = e.style, a = n !== "none" && r !== "hidden" && r !== "collapse";
  if (a) {
    const { getComputedStyle: l } = ke(e);
    let { display: i, visibility: u } = l(e);
    a = i !== "none" && u !== "hidden" && u !== "collapse";
  }
  return a;
}
function f5(e, t) {
  return !e.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
  !e.hasAttribute("data-react-aria-prevent-focus") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function hu(e, t) {
  return d5 ? e.checkVisibility({
    visibilityProperty: !0
  }) && !e.closest("[data-react-aria-prevent-focus]") : e.nodeName !== "#comment" && c5(e) && f5(e, t) && (!e.parentElement || hu(e.parentElement, e));
}
const mu = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  '[contenteditable]:not([contenteditable^="false"])',
  "permission"
], h5 = mu.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
mu.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const m5 = mu.join(':not([hidden]):not([tabindex="-1"]),');
function pu(e, t) {
  return e.matches(h5) && !Hd(e) && (t?.skipVisibilityCheck || hu(e));
}
function _a(e) {
  return e.matches(m5) && hu(e) && !Hd(e);
}
function Hd(e) {
  let t = e;
  for (; t != null; ) {
    if (t instanceof ke(t).HTMLElement && t.inert) return !0;
    t = t.parentElement;
  }
  return !1;
}
function bu(e) {
  let t = e;
  return t.nativeEvent = e, t.isDefaultPrevented = () => t.defaultPrevented, t.isPropagationStopped = () => t.cancelBubble, t.persist = () => {
  }, t;
}
function Ud(e, t) {
  Object.defineProperty(e, "target", {
    value: t
  }), Object.defineProperty(e, "currentTarget", {
    value: t
  });
}
function jd(e) {
  let t = T({
    isFocused: !1,
    observer: null
  });
  return ue(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []), X((n) => {
    let r = W(n);
    if (r instanceof HTMLButtonElement || r instanceof HTMLInputElement || r instanceof HTMLTextAreaElement || r instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = r, l = (i) => {
        if (t.current.isFocused = !1, a.disabled) {
          let u = bu(i);
          e?.(u);
        }
        t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", l, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          t.current.observer?.disconnect();
          let i = a === se() ? null : se();
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: i
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: i
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    e
  ]);
}
let Wa = !1;
function Uo(e) {
  for (; e && !pu(e, {
    skipVisibilityCheck: !0
  }); ) e = e.parentElement;
  let t = ke(e), n = t.document.activeElement;
  if (!n || n === e) return;
  Wa = !0;
  let r = !1, a = (s) => {
    (W(s) === n || r) && s.stopImmediatePropagation();
  }, l = (s) => {
    (W(s) === n || r) && (s.stopImmediatePropagation(), !e && !r && (r = !0, Fe(n), o()));
  }, i = (s) => {
    (W(s) === e || r) && s.stopImmediatePropagation();
  }, u = (s) => {
    (W(s) === e || r) && (s.stopImmediatePropagation(), r || (r = !0, Fe(n), o()));
  };
  t.addEventListener("blur", a, !0), t.addEventListener("focusout", l, !0), t.addEventListener("focusin", u, !0), t.addEventListener("focus", i, !0);
  let o = () => {
    cancelAnimationFrame(d), t.removeEventListener("blur", a, !0), t.removeEventListener("focusout", l, !0), t.removeEventListener("focusin", u, !0), t.removeEventListener("focus", i, !0), Wa = !1, r = !1;
  }, d = requestAnimationFrame(o);
  return o;
}
function pl(e) {
  if (typeof window > "u" || window.navigator == null) return !1;
  let t = window.navigator.userAgentData?.brands;
  return Array.isArray(t) && t.some((n) => e.test(n.brand)) || e.test(window.navigator.userAgent);
}
function gu(e) {
  return typeof window < "u" && window.navigator != null ? e.test(window.navigator.userAgentData?.platform || window.navigator.platform) : !1;
}
function Xt(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const mn = Xt(function() {
  return gu(/^Mac/i);
}), _d = Xt(function() {
  return gu(/^iPhone/i);
}), Wd = Xt(function() {
  return gu(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  mn() && navigator.maxTouchPoints > 1;
}), vt = Xt(function() {
  return _d() || Wd();
}), p5 = Xt(function() {
  return mn() || vt();
}), Gd = Xt(function() {
  return pl(/AppleWebKit/i) && !qd();
}), qd = Xt(function() {
  return pl(/Chrome/i);
}), pn = Xt(function() {
  return pl(/Android/i);
}), b5 = Xt(function() {
  return pl(/Firefox/i);
});
function $i(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : pn() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function g5(e) {
  return !pn() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
const Yd = /* @__PURE__ */ G({
  isNative: !0,
  open: y5,
  useHref: (e) => e
});
function HC(e) {
  let { children: t, navigate: n, useHref: r } = e, a = K(() => ({
    isNative: !1,
    open: (l, i, u, o) => {
      Xd(l, (d) => {
        Zd(d, i) ? n(u, o) : It(d, i);
      });
    },
    useHref: r || ((l) => l)
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ g.createElement(Yd.Provider, {
    value: a
  }, t);
}
function Dr() {
  return O(Yd);
}
function Zd(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function It(e, t, n = !0) {
  let { metaKey: r, ctrlKey: a, altKey: l, shiftKey: i } = t;
  b5() && window.event?.type?.startsWith("key") && e.target === "_blank" && (mn() ? r = !0 : a = !0);
  let u = Gd() && mn() && !Wd() && process.env.NODE_ENV !== "test" ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: r,
    ctrlKey: a,
    altKey: l,
    shiftKey: i
  }) : new MouseEvent("click", {
    metaKey: r,
    ctrlKey: a,
    altKey: l,
    shiftKey: i,
    detail: 1,
    bubbles: !0,
    cancelable: !0
  });
  It.isOpening = n, Fe(e), e.dispatchEvent(u), It.isOpening = !1;
}
It.isOpening = !1;
function Xd(e, t) {
  if (e instanceof HTMLAnchorElement) t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function y5(e, t) {
  Xd(e, (n) => It(n, t));
}
function yu(e) {
  const n = Dr().useHref(e.href ?? "");
  return {
    "data-href": e.href ? n : void 0,
    "data-target": e.target,
    "data-rel": e.rel,
    "data-download": e.download,
    "data-ping": e.ping,
    "data-referrer-policy": e.referrerPolicy
  };
}
function bl(e) {
  const n = Dr().useHref(e?.href ?? "");
  let r = {};
  if (e)
    for (let a of [
      "href",
      "target",
      "rel",
      "download",
      "ping",
      "referrerPolicy"
    ]) a in e && (r[a] = a === "href" ? n : e[a]);
  return r;
}
function Jd(e, t, n, r) {
  !t.isNative && e.currentTarget instanceof HTMLAnchorElement && e.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
  !e.isDefaultPrevented() && Zd(e.currentTarget, e) && n && (e.preventDefault(), t.open(e.currentTarget, e, n, r));
}
let Yt = null, xr = "keyboard";
const Gr = /* @__PURE__ */ new Set();
let Ur = /* @__PURE__ */ new Map(), Kn = !1, vi = !1;
const $5 = {
  Tab: !0,
  Escape: !0
};
function gl(e, t) {
  for (let n of Gr) n(e, t);
}
function v5(e) {
  return !(e.metaKey || !mn() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Ga(e) {
  Kn = !0, !It.isOpening && v5(e) && (Yt = "keyboard", xr = "keyboard", gl("keyboard", e));
}
function nt(e) {
  Yt = "pointer", xr = "pointerType" in e ? e.pointerType : "mouse", (e.type === "mousedown" || e.type === "pointerdown") && (Kn = !0, gl("pointer", e));
}
function Qd(e) {
  !It.isOpening && $i(e) && (Kn = !0, Yt = "virtual", xr = "virtual");
}
function ec(e) {
  let t = ke(W(e)), n = he(W(e));
  W(e) === t || W(e) === n || Wa || !e.isTrusted || (!Kn && !vi && (Yt = "virtual", xr = "virtual", gl("virtual", e)), Kn = !1, vi = !1);
}
function tc() {
  Wa || (Kn = !1, vi = !0);
}
function qa(e) {
  if (typeof window > "u" || typeof document > "u") return;
  const t = ke(e), n = he(e);
  if (Ur.get(t)) return;
  let r = t.HTMLElement.prototype.focus;
  Reflect.defineProperty(t.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: function() {
      Kn = !0, r.apply(this, arguments);
    }
  }), n.addEventListener("keydown", Ga, !0), n.addEventListener("keyup", Ga, !0), n.addEventListener("click", Qd, !0), t.addEventListener("focus", ec, !0), t.addEventListener("blur", tc, !1), typeof PointerEvent < "u" ? (n.addEventListener("pointerdown", nt, !0), n.addEventListener("pointermove", nt, !0), n.addEventListener("pointerup", nt, !0)) : process.env.NODE_ENV === "test" && (n.addEventListener("mousedown", nt, !0), n.addEventListener("mousemove", nt, !0), n.addEventListener("mouseup", nt, !0)), t.addEventListener("beforeunload", () => {
    nc(e);
  }, {
    once: !0
  }), Ur.set(t, {
    focus: r
  });
}
const nc = (e, t) => {
  const n = ke(e), r = he(e);
  t && r.removeEventListener("DOMContentLoaded", t), Ur.has(n) && (Reflect.defineProperty(n.HTMLElement.prototype, "focus", {
    configurable: !0,
    writable: !0,
    value: Ur.get(n).focus
  }), r.removeEventListener("keydown", Ga, !0), r.removeEventListener("keyup", Ga, !0), r.removeEventListener("click", Qd, !0), n.removeEventListener("focus", ec, !0), n.removeEventListener("blur", tc, !1), typeof PointerEvent < "u" ? (r.removeEventListener("pointerdown", nt, !0), r.removeEventListener("pointermove", nt, !0), r.removeEventListener("pointerup", nt, !0)) : process.env.NODE_ENV === "test" && (r.removeEventListener("mousedown", nt, !0), r.removeEventListener("mousemove", nt, !0), r.removeEventListener("mouseup", nt, !0)), Ur.delete(n));
};
function D5(e) {
  const t = he(e);
  let n;
  return t.readyState !== "loading" ? qa(e) : (n = () => {
    qa(e);
  }, t.addEventListener("DOMContentLoaded", n)), () => nc(e, n);
}
typeof document < "u" && D5();
function Mt() {
  return Yt !== "pointer";
}
function yt() {
  return Yt;
}
function qr(e) {
  Yt = e, xr = e === "pointer" ? "mouse" : e, gl(e, null);
}
function x5() {
  return xr;
}
function yl() {
  qa();
  let [e, t] = Y(Yt);
  return ee(() => {
    let n = () => {
      t(Yt);
    };
    return Gr.add(n), () => {
      Gr.delete(n);
    };
  }, []), Dt() ? null : e;
}
const E5 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function C5(e, t, n) {
  let r = n ? W(n) : void 0, a = he(r), l = ke(r);
  const i = typeof l < "u" ? l.HTMLInputElement : HTMLInputElement, u = typeof l < "u" ? l.HTMLTextAreaElement : HTMLTextAreaElement, o = typeof l < "u" ? l.HTMLElement : HTMLElement, d = typeof l < "u" ? l.KeyboardEvent : KeyboardEvent;
  let s = se(a);
  return e = e || s instanceof i && !E5.has(s.type) || s instanceof u || s instanceof o && s.isContentEditable, !(e && t === "keyboard" && n instanceof d && !$5[n.key]);
}
function P5(e, t, n) {
  qa(), ee(() => {
    if (n?.enabled === !1) return;
    let r = (a, l) => {
      C5(!!n?.isTextInput, a, l) && e(Mt());
    };
    return Gr.add(r), () => {
      Gr.delete(r);
    };
  }, t);
}
var rc = {};
rc = {
  collectionLabel: "مقترحات"
};
var ac = {};
ac = {
  collectionLabel: "Предложения"
};
var lc = {};
lc = {
  collectionLabel: "Návrhy"
};
var ic = {};
ic = {
  collectionLabel: "Forslag"
};
var uc = {};
uc = {
  collectionLabel: "Empfehlungen"
};
var oc = {};
oc = {
  collectionLabel: "Προτάσεις"
};
var sc = {};
sc = {
  collectionLabel: "Suggestions"
};
var dc = {};
dc = {
  collectionLabel: "Sugerencias"
};
var cc = {};
cc = {
  collectionLabel: "Soovitused"
};
var fc = {};
fc = {
  collectionLabel: "Ehdotukset"
};
var hc = {};
hc = {
  collectionLabel: "Suggestions"
};
var mc = {};
mc = {
  collectionLabel: "הצעות"
};
var pc = {};
pc = {
  collectionLabel: "Prijedlozi"
};
var bc = {};
bc = {
  collectionLabel: "Javaslatok"
};
var gc = {};
gc = {
  collectionLabel: "Suggerimenti"
};
var yc = {};
yc = {
  collectionLabel: "候補"
};
var $c = {};
$c = {
  collectionLabel: "제안"
};
var vc = {};
vc = {
  collectionLabel: "Pasiūlymai"
};
var Dc = {};
Dc = {
  collectionLabel: "Ieteikumi"
};
var xc = {};
xc = {
  collectionLabel: "Forslag"
};
var Ec = {};
Ec = {
  collectionLabel: "Suggesties"
};
var Cc = {};
Cc = {
  collectionLabel: "Sugestie"
};
var Pc = {};
Pc = {
  collectionLabel: "Sugestões"
};
var wc = {};
wc = {
  collectionLabel: "Sugestões"
};
var Sc = {};
Sc = {
  collectionLabel: "Sugestii"
};
var kc = {};
kc = {
  collectionLabel: "Предложения"
};
var Bc = {};
Bc = {
  collectionLabel: "Návrhy"
};
var Fc = {};
Fc = {
  collectionLabel: "Predlogi"
};
var Ac = {};
Ac = {
  collectionLabel: "Predlozi"
};
var Rc = {};
Rc = {
  collectionLabel: "Förslag"
};
var Tc = {};
Tc = {
  collectionLabel: "Öneriler"
};
var Ic = {};
Ic = {
  collectionLabel: "Пропозиції"
};
var Mc = {};
Mc = {
  collectionLabel: "建议"
};
var Kc = {};
Kc = {
  collectionLabel: "建議"
};
var Nc = {};
Nc = {
  "ar-AE": rc,
  "bg-BG": ac,
  "cs-CZ": lc,
  "da-DK": ic,
  "de-DE": uc,
  "el-GR": oc,
  "en-US": sc,
  "es-ES": dc,
  "et-EE": cc,
  "fi-FI": fc,
  "fr-FR": hc,
  "he-IL": mc,
  "hr-HR": pc,
  "hu-HU": bc,
  "it-IT": gc,
  "ja-JP": yc,
  "ko-KR": $c,
  "lt-LT": vc,
  "lv-LV": Dc,
  "nb-NO": xc,
  "nl-NL": Ec,
  "pl-PL": Cc,
  "pt-BR": Pc,
  "pt-PT": wc,
  "ro-RO": Sc,
  "ru-RU": kc,
  "sk-SK": Bc,
  "sl-SI": Fc,
  "sr-SP": Ac,
  "sv-SE": Rc,
  "tr-TR": Tc,
  "uk-UA": Ic,
  "zh-CN": Mc,
  "zh-TW": Kc
};
function Bn(e) {
  return mn() ? e.metaKey : e.ctrlKey;
}
const w5 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function jr(e) {
  return e instanceof HTMLInputElement && !w5.has(e.type) || e instanceof HTMLTextAreaElement || e instanceof HTMLElement && e.isContentEditable;
}
const S5 = g.useInsertionEffect ?? ue;
function De(e) {
  const t = T(null);
  return S5(() => {
    t.current = e;
  }, [
    e
  ]), X((...n) => {
    const r = t.current;
    return r?.(...n);
  }, []);
}
function mt(e, t, n, r) {
  let a = De(n), l = n == null;
  ee(() => {
    if (l || !e.current) return;
    let i = e.current;
    return i.addEventListener(t, a, r), () => {
      i.removeEventListener(t, a, r);
    };
  }, [
    e,
    t,
    r,
    l
  ]);
}
function it(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": a } = e;
  return n = ce(n), a && r ? a = [
    .../* @__PURE__ */ new Set([
      n,
      ...a.trim().split(/\s+/)
    ])
  ].join(" ") : a && (a = a.trim().split(/\s+/).join(" ")), !r && !a && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": a
  };
}
const k5 = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), B5 = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function F5(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = (
      // @ts-ignore - this was implemented as a property by some browsers before it was standardized as a function.
      typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo
    );
    if (r) return r.direction === "rtl";
    if (n.script) return k5.has(n.script);
  }
  let t = e.split("-")[0];
  return B5.has(t);
}
const Vc = /* @__PURE__ */ Symbol.for("react-aria.i18n.locale");
function Lc() {
  let e = typeof window < "u" && window[Vc] || // @ts-ignore
  typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: F5(e) ? "rtl" : "ltr"
  };
}
let Di = Lc(), Lr = /* @__PURE__ */ new Set();
function jo() {
  Di = Lc();
  for (let e of Lr) e(Di);
}
function A5() {
  let e = Dt(), [t, n] = Y(Di);
  return ee(() => (Lr.size === 0 && window.addEventListener("languagechange", jo), Lr.add(n), () => {
    Lr.delete(n), Lr.size === 0 && window.removeEventListener("languagechange", jo);
  }), []), e ? {
    locale: typeof window < "u" && window[Vc] || "en-US",
    direction: "ltr"
  } : t;
}
const R5 = /* @__PURE__ */ g.createContext(null);
function de() {
  let e = A5();
  return O(R5) || e;
}
const T5 = /* @__PURE__ */ Symbol.for("react-aria.i18n.locale"), I5 = /* @__PURE__ */ Symbol.for("react-aria.i18n.strings");
let Ea;
class $t {
  constructor(t, n = "en-US") {
    this.strings = Object.fromEntries(Object.entries(t).filter(([, r]) => r)), this.defaultLocale = n;
  }
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let a = this.getStringsForLocale(n)[t];
    if (!a) throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return a;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = M5(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u") return null;
    let n = window[T5];
    if (Ea === void 0) {
      let a = window[I5];
      if (!a) return null;
      Ea = {};
      for (let l in a) Ea[l] = new $t({
        [n]: a[l]
      }, n);
    }
    let r = Ea?.[t];
    if (!r) throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
}
function M5(e, t, n = "en-US") {
  if (t[e]) return t[e];
  let r = K5(e);
  if (t[r]) return t[r];
  for (let a in t)
    if (a.startsWith(r + "-")) return t[a];
  return t[n];
}
function K5(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const _o = /* @__PURE__ */ new Map(), Wo = /* @__PURE__ */ new Map();
class $u {
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let a = n["=" + t];
    if (a) return typeof a == "function" ? a() : a;
    let l = this.locale + ":" + r, i = _o.get(l);
    i || (i = new Intl.PluralRules(this.locale, {
      type: r
    }), _o.set(l, i));
    let u = i.select(t);
    return a = n[u] || n.other, typeof a == "function" ? a() : a;
  }
  number(t) {
    let n = Wo.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), Wo.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
}
const Go = /* @__PURE__ */ new WeakMap();
function N5(e) {
  let t = Go.get(e);
  return t || (t = new $t(e), Go.set(e, t)), t;
}
function zc(e, t) {
  return t && $t.getGlobalDictionaryForPackage(t) || N5(e);
}
function xe(e, t) {
  let { locale: n } = de(), r = zc(e, t);
  return K(() => new $u(n, r), [
    n,
    r
  ]);
}
function V5(e) {
  return e && e.__esModule ? e.default : e;
}
function L5(e, t) {
  let { inputRef: n, collectionRef: r, filter: a, disableAutoFocusFirst: l = !1, disableVirtualFocus: i = !1 } = e, u = ce(), o = T(void 0), d = T(!1), s = T(null), c = yt() === "virtual" && (vt() || pn()), [f, h] = Y(!c && !i), [m, p] = Y(!1), [b, y] = Y(!1);
  ee(() => () => clearTimeout(o.current), []);
  let $ = De((_) => {
    !_.isTrusted && f && n.current && se(he(n.current)) !== n.current && x5() !== "touch" && n.current.focus();
    let B = W(_);
    _.isTrusted || !B || s.current === B.id || (clearTimeout(o.current), B !== r.current ? d.current ? (s.current = B.id, o.current = setTimeout(() => {
      t.setFocusedNodeId(B.id);
    }, 500)) : (s.current = B.id, t.setFocusedNodeId(B.id)) : s.current && !document.getElementById(s.current) && (s.current = null, t.setFocusedNodeId(null)), d.current = !1);
  }), [v, x] = Y(null), E = X((_) => {
    x(_), _ != null ? (_.getAttribute("tabindex") != null && h(!1), p(!0)) : p(!1);
  }, []);
  ue(() => (v?.addEventListener("focusin", $), () => {
    v?.removeEventListener("focusin", $);
  }), [
    v
  ]);
  let P = $e(K(() => xt(r, E), [
    r,
    E
  ])), C = X(() => {
    if (!r.current) {
      y(!0);
      return;
    }
    d.current = !0, r.current?.dispatchEvent(new CustomEvent(gi, {
      cancelable: !0,
      bubbles: !0,
      detail: {
        focusStrategy: "first"
      }
    }));
  }, [
    r
  ]), M = X((_) => {
    y(!1), fu(se()), s.current = null, t.setFocusedNodeId(null);
    let B = new CustomEvent(zd, {
      cancelable: !0,
      bubbles: !0,
      detail: {
        clearFocusKey: _
      }
    });
    clearTimeout(o.current), d.current = !1, r.current?.dispatchEvent(B);
  }, [
    r,
    t
  ]), F = T("");
  mt(n, "beforeinput", (_) => {
    let { inputType: B } = _;
    F.current = B;
  });
  let V = (_) => {
    (F.current === "insertText" || // IME composition (e.g. CJK input) reports 'insertCompositionText'/'insertFromComposition'
    // instead of 'insertText'. Treat these as forward typing so the first item gets virtual focus.
    F.current === "insertCompositionText" || F.current === "insertFromComposition") && !l ? C() : F.current && (F.current.includes("insert") || F.current.includes("delete") || F.current.includes("history")) && (M(!0), Od(document) === n.current && ja(n.current, null)), t.setInputValue(_);
  }, I = T(null), A = (_) => {
    if (I.current = W(_), _.nativeEvent.isComposing) return;
    let B = s.current;
    switch (B !== null && he(n.current).getElementById(B) == null && (s.current = null, B = null), _.key) {
      case "a":
        if (Bn(_)) return;
        break;
      case "Escape":
        if (_.isDefaultPrevented()) return;
        break;
      case " ":
        return;
      case "Tab":
        "continuePropagation" in _ && _.continuePropagation();
        return;
      case "Home":
      case "End":
      case "PageDown":
      case "PageUp":
      case "ArrowUp":
      case "ArrowDown":
      case "ArrowRight":
      case "ArrowLeft": {
        if ((_.key === "Home" || _.key === "End") && B == null && _.shiftKey) return;
        if (_.key === "ArrowRight" || _.key === "ArrowLeft") {
          if (B == null) {
            _.isPropagationStopped() || _.stopPropagation();
            return;
          }
          break;
        }
        _.preventDefault();
        let Z = new CustomEvent(gi, {
          cancelable: !0,
          bubbles: !0
        });
        r.current?.dispatchEvent(Z);
        break;
      }
    }
    _.isPropagationStopped() || _.stopPropagation();
    let L = !0;
    if (r.current !== null)
      if (B == null) L = r.current?.dispatchEvent(new KeyboardEvent(_.nativeEvent.type, _.nativeEvent)) || !1;
      else {
        let Z = document.getElementById(B);
        Z && (L = Z?.dispatchEvent(new KeyboardEvent(_.nativeEvent.type, _.nativeEvent)) || !1);
      }
    if (L) switch (_.key) {
      case "ArrowLeft":
      case "ArrowRight":
        M();
        break;
      case "Enter":
        B != null && document.getElementById(B)?.dispatchEvent(new PointerEvent("click", _.nativeEvent));
        break;
    }
    else
      _.preventDefault();
  }, U = De((_) => {
    if (W(_) === I.current) {
      _.stopImmediatePropagation();
      let B = s.current;
      B == null ? r.current?.dispatchEvent(new KeyboardEvent(_.type, _)) : document.getElementById(B)?.dispatchEvent(new KeyboardEvent(_.type, _));
    }
  });
  ee(() => (document.addEventListener("keyup", U, !0), () => {
    document.removeEventListener("keyup", U, !0);
  }), []);
  let D = xe(V5(Nc), "@react-aria/autocomplete"), N = it({
    id: u,
    "aria-label": D.format("collectionLabel")
  }), w = X((_, B) => a ? a(_, t.inputValue, B) : !0, [
    t.inputValue,
    a
  ]), R = (_) => {
    if (!_.isTrusted) return;
    let B = s.current ? document.getElementById(s.current) : null;
    B && yi(B, _.relatedTarget);
  }, H = (_) => {
    if (!_.isTrusted) return;
    if (s.current ? document.getElementById(s.current) : null) {
      let L = W(_);
      queueMicrotask(() => {
        yi(L, r.current), ja(r.current, L);
      });
    }
  }, k = (_) => {
    _.button !== 0 || _.pointerType === "touch" || s.current == null || n.current == null || W(_) === n.current && M();
  }, S = {
    value: t.inputValue,
    onChange: V
  }, j = {
    onKeyDown: A,
    "aria-activedescendant": t.focusedNodeId ?? void 0,
    onBlur: R,
    onFocus: H,
    onPointerDown: k
  };
  return S = {
    ...S,
    ...f && m && j,
    enterKeyHint: "go",
    "aria-controls": m ? u : void 0,
    // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
    "aria-autocomplete": "list",
    // This disable's iOS's autocorrect suggestions, since the autocomplete provides its own suggestions.
    autoCorrect: "off",
    // This disable's the macOS Safari spell check auto corrections.
    spellCheck: "false",
    autoComplete: "off"
  }, {
    inputProps: S,
    collectionProps: z(N, {
      shouldUseVirtualFocus: f,
      disallowTypeAhead: f,
      autoFocus: b ? "first" : !1
    }),
    collectionRef: P,
    filter: a != null ? w : void 0
  };
}
const z5 = typeof document < "u" ? g.useInsertionEffect ?? g.useLayoutEffect : () => {
};
function Pe(e, t, n) {
  let [r, a] = Y(e || t), l = T(r), i = T(e !== void 0), u = e !== void 0;
  ee(() => {
    let c = i.current;
    c !== u && process.env.NODE_ENV !== "production" && console.warn(`WARN: A component changed from ${c ? "controlled" : "uncontrolled"} to ${u ? "controlled" : "uncontrolled"}.`), i.current = u;
  }, [
    u
  ]);
  let o = u ? e : r;
  z5(() => {
    l.current = o;
  });
  let [, d] = zv(() => ({}), {}), s = X((c, ...f) => {
    let h = typeof c == "function" ? c(l.current) : c;
    Object.is(l.current, h) || (l.current = h, a(h), d(), n?.(h, ...f));
  }, [
    n
  ]);
  return [
    o,
    s
  ];
}
function O5(e) {
  let { onInputChange: t, inputValue: n, defaultInputValue: r = "" } = e, a = (d) => {
    t && t(d);
  }, [l, i] = Y(null), [u, o] = Pe(n, r, a);
  return {
    inputValue: u,
    setInputValue: o,
    focusedNodeId: l,
    setFocusedNodeId: i
  };
}
const H5 = /* @__PURE__ */ G(null), U5 = /* @__PURE__ */ G(null), Nn = /* @__PURE__ */ G(null), ca = /* @__PURE__ */ G(null);
function UC(e) {
  let t = Oe(H5, e.slot);
  e = z(t, e);
  let { filter: n, disableAutoFocusFirst: r } = e, a = O5(e), l = T(null), i = T(null), { inputProps: u, collectionProps: o, collectionRef: d, filter: s } = L5({
    ...Et(e),
    filter: n,
    disableAutoFocusFirst: r,
    inputRef: l,
    collectionRef: i
  }, a);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        U5,
        a
      ],
      [
        ca,
        {
          ...u,
          ref: l
        }
      ],
      [
        Nn,
        {
          ...o,
          filter: s,
          ref: d
        }
      ]
    ]
  }, e.children);
}
class st {
  constructor(t) {
    this.value = null, this.level = 0, this.hasChildNodes = !1, this.rendered = null, this.textValue = "", this["aria-label"] = void 0, this.index = 0, this.parentKey = null, this.prevKey = null, this.nextKey = null, this.firstChildKey = null, this.lastChildKey = null, this.props = {}, this.colSpan = null, this.colIndex = null, this.type = this.constructor.type, this.key = t;
  }
  get childNodes() {
    throw new Error("childNodes is not supported");
  }
  clone() {
    let t = new this.constructor(this.key);
    return t.value = this.value, t.level = this.level, t.hasChildNodes = this.hasChildNodes, t.rendered = this.rendered, t.textValue = this.textValue, t["aria-label"] = this["aria-label"], t.index = this.index, t.parentKey = this.parentKey, t.prevKey = this.prevKey, t.nextKey = this.nextKey, t.firstChildKey = this.firstChildKey, t.lastChildKey = this.lastChildKey, t.props = this.props, t.render = this.render, t.colSpan = this.colSpan, t.colIndex = this.colIndex, t;
  }
  filter(t, n, r) {
    let a = this.clone();
    return n.addDescendants(a, t), a;
  }
}
class $l extends st {
  filter(t, n, r) {
    let [a, l] = Hc(t, n, this.firstChildKey, r), i = this.clone();
    return i.firstChildKey = a, i.lastChildKey = l, i;
  }
}
const Co = class Co extends st {
};
Co.type = "header";
let xi = Co;
const Po = class Po extends st {
};
Po.type = "loader";
let Ya = Po;
const wo = class wo extends $l {
  filter(t, n, r) {
    if (r(this.textValue, this)) {
      let a = this.clone();
      return n.addDescendants(a, t), a;
    }
    return null;
  }
};
wo.type = "item";
let Yr = wo;
const So = class So extends $l {
  filter(t, n, r) {
    let a = super.filter(t, n, r);
    if (a && a.lastChildKey !== null) {
      let l = t.getItem(a.lastChildKey);
      if (l && l.type !== "header") return a;
    }
    return null;
  }
};
So.type = "section";
let Ei = So;
class Oc {
  get size() {
    return this.itemCount;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  *[Symbol.iterator]() {
    let t = this.firstKey != null ? this.keyMap.get(this.firstKey) : void 0;
    for (; t; )
      yield t, t = t.nextKey != null ? this.keyMap.get(t.nextKey) : void 0;
  }
  getChildren(t) {
    let n = this.keyMap;
    return {
      *[Symbol.iterator]() {
        let r = n.get(t), a = r?.firstChildKey != null ? n.get(r.firstChildKey) : null;
        for (; a; )
          yield a, a = a.nextKey != null ? n.get(a.nextKey) : void 0;
      }
    };
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.prevKey != null) {
      for (n = this.keyMap.get(n.prevKey); n && n.type !== "item" && n.lastChildKey != null; ) n = this.keyMap.get(n.lastChildKey);
      return n?.key ?? null;
    }
    return n.parentKey;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    if (!n) return null;
    if (n.type !== "item" && n.firstChildKey != null) return n.firstChildKey;
    for (; n; ) {
      if (n.nextKey != null) return n.nextKey;
      if (n.parentKey != null) n = this.keyMap.get(n.parentKey);
      else return null;
    }
    return null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    let t = this.lastKey != null ? this.keyMap.get(this.lastKey) : null;
    for (; t?.lastChildKey != null; ) t = this.keyMap.get(t.lastChildKey);
    return t?.key ?? null;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at() {
    throw new Error("Not implemented");
  }
  clone() {
    let t = this.constructor, n = new t();
    return n.keyMap = new Map(this.keyMap), n.firstKey = this.firstKey, n.lastKey = this.lastKey, n.itemCount = this.itemCount, n;
  }
  addNode(t) {
    if (this.frozen) throw new Error("Cannot add a node to a frozen collection");
    t.type === "item" && this.keyMap.get(t.key) == null && this.itemCount++, this.keyMap.set(t.key, t);
  }
  // Deeply add a node and its children to the collection from another collection, primarily used when filtering a collection
  addDescendants(t, n) {
    this.addNode(t);
    let r = n.getChildren(t.key);
    for (let a of r) this.addDescendants(a, n);
  }
  removeNode(t) {
    if (this.frozen) throw new Error("Cannot remove a node to a frozen collection");
    let n = this.keyMap.get(t);
    n != null && n.type === "item" && this.itemCount--, this.keyMap.delete(t);
  }
  commit(t, n, r = !1) {
    if (this.frozen) throw new Error("Cannot commit a frozen collection");
    this.firstKey = t, this.lastKey = n, this.frozen = !r;
  }
  filter(t) {
    let n = new this.constructor(), [r, a] = Hc(this, n, this.firstKey, t);
    return n?.commit(r, a), n;
  }
  constructor() {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.frozen = !1, this.itemCount = 0;
  }
}
function Hc(e, t, n, r) {
  if (n == null) return [
    null,
    null
  ];
  let a = null, l = null, i = e.getItem(n);
  for (; i != null; ) {
    let u = i.filter(e, t, r);
    u != null && (u.nextKey = null, l && (u.prevKey = l.key, l.nextKey = u.key), a == null && (a = u), t.addNode(u), l = u), i = i.nextKey != null ? e.getItem(i.nextKey) : null;
  }
  if (l && l.type === "separator") {
    let u = l.prevKey;
    t.removeNode(l.key), u != null ? (l = t.getItem(u), l.nextKey = null) : l = null;
  }
  return [
    a?.key ?? null,
    l?.key ?? null
  ];
}
class Uc {
  constructor(t) {
    this._firstChild = null, this._lastChild = null, this._previousSibling = null, this._nextSibling = null, this._parentNode = null, this._minInvalidChildIndex = null, this.ownerDocument = t;
  }
  *[Symbol.iterator]() {
    let t = this.firstChild;
    for (; t; )
      yield t, t = t.nextSibling;
  }
  get firstChild() {
    return this._firstChild;
  }
  set firstChild(t) {
    this._firstChild = t, this.ownerDocument.markDirty(this);
  }
  get lastChild() {
    return this._lastChild;
  }
  set lastChild(t) {
    this._lastChild = t, this.ownerDocument.markDirty(this);
  }
  get previousSibling() {
    return this._previousSibling;
  }
  set previousSibling(t) {
    this._previousSibling = t, this.ownerDocument.markDirty(this);
  }
  get nextSibling() {
    return this._nextSibling;
  }
  set nextSibling(t) {
    this._nextSibling = t, this.ownerDocument.markDirty(this);
  }
  get parentNode() {
    return this._parentNode;
  }
  set parentNode(t) {
    this._parentNode = t, this.ownerDocument.markDirty(this);
  }
  get isConnected() {
    return this.parentNode?.isConnected || !1;
  }
  invalidateChildIndices(t) {
    (this._minInvalidChildIndex == null || !this._minInvalidChildIndex.isConnected || t.index < this._minInvalidChildIndex.index) && (this._minInvalidChildIndex = t, this.ownerDocument.markDirty(this));
  }
  updateChildIndices() {
    let t = this._minInvalidChildIndex;
    for (; t; )
      t.index = t.previousSibling ? t.previousSibling.index + 1 : 0, t = t.nextSibling;
    this._minInvalidChildIndex = null;
  }
  appendChild(t) {
    t.parentNode && t.parentNode.removeChild(t), this.firstChild == null && (this.firstChild = t), this.lastChild ? (this.lastChild.nextSibling = t, t.index = this.lastChild.index + 1, t.previousSibling = this.lastChild) : (t.previousSibling = null, t.index = 0), t.parentNode = this, t.nextSibling = null, this.lastChild = t, this.ownerDocument.markDirty(this), this.isConnected && this.ownerDocument.queueUpdate();
  }
  insertBefore(t, n) {
    if (n == null) return this.appendChild(t);
    t.parentNode && t.parentNode.removeChild(t), t.nextSibling = n, t.previousSibling = n.previousSibling, t.index = n.index - 1, this.firstChild === n ? this.firstChild = t : n.previousSibling && (n.previousSibling.nextSibling = t), n.previousSibling = t, t.parentNode = n.parentNode, this.invalidateChildIndices(t), this.isConnected && this.ownerDocument.queueUpdate();
  }
  removeChild(t) {
    t.parentNode === this && (this._minInvalidChildIndex === t && (this._minInvalidChildIndex = null), t.nextSibling && (this.invalidateChildIndices(t.nextSibling), t.nextSibling.previousSibling = t.previousSibling), t.previousSibling && (t.previousSibling.nextSibling = t.nextSibling), this.firstChild === t && (this.firstChild = t.nextSibling), this.lastChild === t && (this.lastChild = t.previousSibling), t.parentNode = null, t.nextSibling = null, t.previousSibling = null, t.index = 0, this.ownerDocument.markDirty(t), this.isConnected && this.ownerDocument.queueUpdate());
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  get previousVisibleSibling() {
    let t = this.previousSibling;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
  get nextVisibleSibling() {
    let t = this.nextSibling;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get firstVisibleChild() {
    let t = this.firstChild;
    for (; t && t.isHidden; ) t = t.nextSibling;
    return t;
  }
  get lastVisibleChild() {
    let t = this.lastChild;
    for (; t && t.isHidden; ) t = t.previousSibling;
    return t;
  }
}
class or extends Uc {
  constructor(t, n) {
    super(n), this.nodeType = 8, this.isMutated = !0, this._index = 0, this.isHidden = !1, this.node = null;
  }
  get index() {
    return this._index;
  }
  set index(t) {
    this._index = t, this.ownerDocument.markDirty(this);
  }
  get level() {
    return this.parentNode instanceof or ? this.parentNode.level + (this.parentNode.node?.type === "item" ? 1 : 0) : 0;
  }
  /**
  * Lazily gets a mutable instance of a Node. If the node has already
  * been cloned during this update cycle, it just returns the existing one.
  */
  getMutableNode() {
    return this.node == null ? null : (this.isMutated || (this.node = this.node.clone(), this.isMutated = !0), this.ownerDocument.markDirty(this), this.node);
  }
  updateNode() {
    let t = this.nextVisibleSibling, n = this.getMutableNode();
    if (n != null && (n.index = this.index, n.level = this.level, n.parentKey = this.parentNode instanceof or ? this.parentNode.node?.key ?? null : null, n.prevKey = this.previousVisibleSibling?.node?.key ?? null, n.nextKey = t?.node?.key ?? null, n.hasChildNodes = !!this.firstChild, n.firstChildKey = this.firstVisibleChild?.node?.key ?? null, n.lastChildKey = this.lastVisibleChild?.node?.key ?? null, (n.colSpan != null || n.colIndex != null) && t)) {
      let r = (n.colIndex ?? n.index) + (n.colSpan ?? 1);
      if (t.node != null && r !== t.node.colIndex) {
        let a = t.getMutableNode();
        a.colIndex = r;
      }
    }
  }
  setProps(t, n, r, a, l) {
    let i, { value: u, textValue: o, id: d, ...s } = t;
    if (this.node == null ? (i = new r(d ?? `react-aria-${++this.ownerDocument.nodeId}`), this.node = i) : i = this.getMutableNode(), s.ref = n, i.props = s, i.rendered = a, i.render = l, i.value = u, t["aria-label"] && (i["aria-label"] = t["aria-label"]), i.textValue = o || (typeof s.children == "string" ? s.children : "") || t["aria-label"] || "", d != null && d !== i.key) throw new Error("Cannot change the id of an item");
    s.colSpan != null && (i.colSpan = s.colSpan), this.isConnected && this.ownerDocument.queueUpdate();
  }
  get style() {
    let t = this;
    return {
      get display() {
        return t.isHidden ? "none" : "";
      },
      set display(n) {
        let r = n === "none";
        if (t.isHidden !== r) {
          (t.parentNode?.firstVisibleChild === t || t.parentNode?.lastVisibleChild === t) && t.ownerDocument.markDirty(t.parentNode);
          let a = t.previousVisibleSibling, l = t.nextVisibleSibling;
          a && t.ownerDocument.markDirty(a), l && t.ownerDocument.markDirty(l), t.isHidden = r, t.ownerDocument.markDirty(t);
        }
      }
    };
  }
  hasAttribute() {
  }
  setAttribute() {
  }
  setAttributeNS() {
  }
  removeAttribute() {
  }
}
class j5 extends Uc {
  constructor(t) {
    super(null), this.nodeType = 11, this.ownerDocument = this, this.dirtyNodes = /* @__PURE__ */ new Set(), this.isSSR = !1, this.nodeId = 0, this.nodesByProps = /* @__PURE__ */ new WeakMap(), this.nextCollection = null, this.subscriptions = /* @__PURE__ */ new Set(), this.queuedRender = !1, this.inSubscription = !1, this.collection = t, this.nextCollection = t;
  }
  get isConnected() {
    return !0;
  }
  createElement(t) {
    return new or(t, this);
  }
  getMutableCollection() {
    return this.nextCollection || (this.nextCollection = this.collection.clone()), this.nextCollection;
  }
  markDirty(t) {
    this.dirtyNodes.add(t);
  }
  addNode(t) {
    if (t.isHidden || t.node == null) return;
    let n = this.getMutableCollection();
    if (!n.getItem(t.node.key)) for (let r of t) this.addNode(r);
    n.addNode(t.node);
  }
  removeNode(t) {
    for (let n of t) this.removeNode(n);
    t.node && this.getMutableCollection().removeNode(t.node.key);
  }
  /** Finalizes the collection update, updating all nodes and freezing the collection. */
  getCollection() {
    return this.inSubscription ? this.collection : (this.queuedRender = !1, this.updateCollection(), this.collection);
  }
  updateCollection() {
    for (let t of this.dirtyNodes) t instanceof or && (!t.isConnected || t.isHidden) ? this.removeNode(t) : t.updateChildIndices();
    for (let t of this.dirtyNodes) t instanceof or ? (t.isConnected && !t.isHidden && (t.updateNode(), this.addNode(t)), t.node && this.dirtyNodes.delete(t), t.isMutated = !1) : this.dirtyNodes.delete(t);
    this.nextCollection && (this.nextCollection.commit(this.firstVisibleChild?.node?.key ?? null, this.lastVisibleChild?.node?.key ?? null, this.isSSR), this.isSSR || (this.collection = this.nextCollection, this.nextCollection = null));
  }
  queueUpdate() {
    if (!(this.dirtyNodes.size === 0 || this.queuedRender)) {
      this.queuedRender = !0, this.inSubscription = !0, this.isSSR || (this.collection = this.collection.clone());
      for (let t of this.subscriptions) t();
      this.inSubscription = !1;
    }
  }
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  resetAfterSSR() {
    this.isSSR && (this.isSSR = !1, this.firstChild = null, this.lastChild = null, this.nodeId = 0);
  }
}
function vu(e) {
  let { children: t, items: n, idScope: r, addIdAndValue: a, dependencies: l = [] } = e, i = K(() => process.env.NODE_ENV !== "production" && typeof t == "function" ? t.toString() : void 0, [
    t
  ]), u = K(() => /* @__PURE__ */ new WeakMap(), [
    ...l,
    i
  ]);
  return K(() => {
    if (n && typeof t == "function") {
      let o = [];
      for (let d of n) {
        let s = _5(d) ? d : null, c = s ? u.get(s) : null;
        if (!c) {
          c = t(d);
          let f = c.props.id ?? d?.key ?? d?.id;
          r != null && c.props.id == null && f != null && (f = r + ":" + f);
          let h = f ?? o.length;
          c = du(c, a ? {
            key: h,
            id: f,
            value: d
          } : {
            key: h
          }), s && u.set(s, c);
        }
        o.push(c);
      }
      return o;
    } else if (typeof t != "function") return t;
  }, [
    t,
    n,
    u,
    r,
    a
  ]);
}
function _5(e) {
  switch (typeof e) {
    case "object":
      return e != null;
    case "function":
    case "symbol":
      return !0;
    default:
      return !1;
  }
}
let cn = /* @__PURE__ */ new Map(), Ci = /* @__PURE__ */ new Set();
function qo() {
  if (typeof window > "u") return;
  function e(r) {
    return "propertyName" in r;
  }
  let t = (r) => {
    let a = W(r);
    if (!e(r) || !a) return;
    let l = cn.get(a);
    l || (l = /* @__PURE__ */ new Set(), cn.set(a, l), a.addEventListener("transitioncancel", n, {
      once: !0
    })), l.add(r.propertyName);
  }, n = (r) => {
    let a = W(r);
    if (!e(r) || !a) return;
    let l = cn.get(a);
    if (l && (l.delete(r.propertyName), l.size === 0 && (a.removeEventListener("transitioncancel", n), cn.delete(a)), cn.size === 0)) {
      for (let i of Ci) i();
      Ci.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", n);
}
typeof document < "u" && (document.readyState !== "loading" ? qo() : document.addEventListener("DOMContentLoaded", qo));
function W5() {
  for (const [e] of cn)
    "isConnected" in e && !e.isConnected && cn.delete(e);
}
function jc(e) {
  requestAnimationFrame(() => {
    W5(), cn.size === 0 ? e() : Ci.add(e);
  });
}
function we(e) {
  if (!e.isConnected) return;
  const t = he(e);
  if (yt() === "virtual") {
    let n = se(t);
    jc(() => {
      const r = se(t);
      (r === n || r === t.body) && e.isConnected && Fe(e);
    });
  } else Fe(e);
}
function mr(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: a } = e;
  const l = X((o) => {
    if (W(o) === o.currentTarget)
      return r && r(o), a && a(!1), !0;
  }, [
    r,
    a
  ]), i = jd(l), u = X((o) => {
    let d = W(o);
    const s = he(d), c = s ? se(s) : se();
    d === o.currentTarget && d === c && (n && n(o), a && a(!0), i(o));
  }, [
    a,
    n,
    i
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || a || r) ? u : void 0,
      onBlur: !t && (r || a) ? l : void 0
    }
  };
}
function Yo(e) {
  if (!e) return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        t && process.env.NODE_ENV !== "production" ? console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.") : t = !0;
      },
      continuePropagation() {
        t = !1, typeof n.continuePropagation == "function" && n.continuePropagation();
      },
      isPropagationStopped() {
        return t;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function Er(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: Yo(e.onKeyDown),
      onKeyUp: Yo(e.onKeyUp)
    }
  };
}
function Du(e, t) {
  ue(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref && (e.ref.current = null);
      };
  });
}
let Za = /* @__PURE__ */ g.createContext(null);
function G5(e) {
  let t = O(Za) || {};
  Du(t, e);
  let { ref: n, ...r } = t;
  return r;
}
const q5 = /* @__PURE__ */ g.forwardRef(function(t, n) {
  let { children: r, ...a } = t, l = $e(n), i = {
    ...a,
    ref: l
  };
  return /* @__PURE__ */ g.createElement(Za.Provider, {
    value: i
  }, r);
});
function dt(e, t) {
  let { focusProps: n } = mr(e), { keyboardProps: r } = Er(e), a = z(n, r), l = G5(t), i = e.isDisabled ? {} : l, u = T(e.autoFocus);
  ee(() => {
    u.current && t.current && we(t.current), u.current = !1;
  }, [
    t
  ]);
  let o = e.excludeFromTabOrder ? -1 : 0;
  return e.isDisabled && (o = void 0), {
    focusableProps: z({
      ...a,
      tabIndex: o
    }, i)
  };
}
const jC = /* @__PURE__ */ te(({ children: e, ...t }, n) => {
  n = $e(n);
  let { focusableProps: r } = dt(t, n), a = g.Children.only(e);
  ee(() => {
    if (process.env.NODE_ENV === "production") return;
    let i = n.current;
    if (!i || !(i instanceof ke(i).Element)) {
      console.error("<Focusable> child must forward its ref to a DOM element.");
      return;
    }
    if (!t.isDisabled && !pu(i)) {
      console.warn("<Focusable> child must be focusable. Please ensure the tabIndex prop is passed through.");
      return;
    }
    if (i.localName !== "button" && i.localName !== "input" && i.localName !== "select" && i.localName !== "textarea" && i.localName !== "a" && i.localName !== "area" && i.localName !== "summary" && i.localName !== "img" && i.localName !== "svg") {
      let u = i.getAttribute("role");
      u ? (
        // https://w3c.github.io/aria/#widget_roles
        u !== "application" && u !== "button" && u !== "checkbox" && u !== "combobox" && u !== "gridcell" && u !== "link" && u !== "menuitem" && u !== "menuitemcheckbox" && u !== "menuitemradio" && u !== "option" && u !== "radio" && u !== "searchbox" && u !== "separator" && u !== "slider" && u !== "spinbutton" && u !== "switch" && u !== "tab" && u !== "tabpanel" && u !== "textbox" && u !== "treeitem" && // aria-describedby is also announced on these roles
        u !== "img" && u !== "meter" && u !== "progressbar" && console.warn(`<Focusable> child must have an interactive ARIA role. Got "${u}".`)
      ) : console.warn("<Focusable> child must have an interactive ARIA role.");
    }
  }, [
    n,
    t.isDisabled
  ]);
  let l = parseInt(g.version, 10) < 19 ? a.ref : a.props.ref;
  return /* @__PURE__ */ g.cloneElement(a, {
    ...z(r, a.props),
    // @ts-ignore
    ref: xt(l, n)
  });
});
typeof HTMLTemplateElement < "u" && (Object.defineProperty(HTMLTemplateElement.prototype, "firstChild", {
  configurable: !0,
  enumerable: !0,
  get: function() {
    return this.content.firstChild;
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "appendChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.appendChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "removeChild", {
  configurable: !0,
  enumerable: !0,
  value: function(e) {
    return this.content.removeChild(e);
  }
}), Object.defineProperty(HTMLTemplateElement.prototype, "insertBefore", {
  configurable: !0,
  enumerable: !0,
  value: function(e, t) {
    return this.content.insertBefore(e, t);
  }
}));
const Xa = /* @__PURE__ */ G(!1);
function Y5(e) {
  if (O(Xa))
    return /* @__PURE__ */ g.createElement(g.Fragment, null, e.children);
  let n = /* @__PURE__ */ g.createElement(Xa.Provider, {
    value: !0
  }, e.children);
  return /* @__PURE__ */ g.createElement("template", null, n);
}
function $n(e) {
  let t = (n, r) => O(Xa) ? null : e(n, r);
  return t.displayName = e.displayName || e.name, te(t);
}
function _c() {
  return O(Xa);
}
var Ca = { exports: {} }, Ll = {};
var Zo;
function Z5() {
  if (Zo) return Ll;
  Zo = 1;
  var e = g;
  function t(c, f) {
    return c === f && (c !== 0 || 1 / c === 1 / f) || c !== c && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, a = e.useEffect, l = e.useLayoutEffect, i = e.useDebugValue;
  function u(c, f) {
    var h = f(), m = r({ inst: { value: h, getSnapshot: f } }), p = m[0].inst, b = m[1];
    return l(
      function() {
        p.value = h, p.getSnapshot = f, o(p) && b({ inst: p });
      },
      [c, h, f]
    ), a(
      function() {
        return o(p) && b({ inst: p }), c(function() {
          o(p) && b({ inst: p });
        });
      },
      [c]
    ), i(h), h;
  }
  function o(c) {
    var f = c.getSnapshot;
    c = c.value;
    try {
      var h = f();
      return !n(c, h);
    } catch {
      return !0;
    }
  }
  function d(c, f) {
    return f();
  }
  var s = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? d : u;
  return Ll.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : s, Ll;
}
var zl = {};
var Xo;
function X5() {
  return Xo || (Xo = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(h, m) {
      return h === m && (h !== 0 || 1 / h === 1 / m) || h !== h && m !== m;
    }
    function t(h, m) {
      s || a.startTransition === void 0 || (s = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var p = m();
      if (!c) {
        var b = m();
        l(p, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), c = !0);
      }
      b = i({
        inst: { value: p, getSnapshot: m }
      });
      var y = b[0].inst, $ = b[1];
      return o(
        function() {
          y.value = p, y.getSnapshot = m, n(y) && $({ inst: y });
        },
        [h, p, m]
      ), u(
        function() {
          return n(y) && $({ inst: y }), h(function() {
            n(y) && $({ inst: y });
          });
        },
        [h]
      ), d(p), p;
    }
    function n(h) {
      var m = h.getSnapshot;
      h = h.value;
      try {
        var p = m();
        return !l(h, p);
      } catch {
        return !0;
      }
    }
    function r(h, m) {
      return m();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var a = g, l = typeof Object.is == "function" ? Object.is : e, i = a.useState, u = a.useEffect, o = a.useLayoutEffect, d = a.useDebugValue, s = !1, c = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    zl.useSyncExternalStore = a.useSyncExternalStore !== void 0 ? a.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), zl;
}
var Jo;
function J5() {
  return Jo || (Jo = 1, process.env.NODE_ENV === "production" ? Ca.exports = Z5() : Ca.exports = X5()), Ca.exports;
}
var xu = J5();
const Wc = /* @__PURE__ */ G(!1), Zr = /* @__PURE__ */ G(null);
function Hn(e) {
  if (O(Zr))
    return e.content;
  let { collection: n, document: r } = n2(e.createCollection);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(Y5, null, /* @__PURE__ */ g.createElement(Zr.Provider, {
    value: r
  }, e.content)), /* @__PURE__ */ g.createElement(Q5, {
    render: e.children,
    collection: n
  }));
}
function Q5({ collection: e, render: t }) {
  return t(e);
}
function e2(e, t, n) {
  let r = Dt(), a = T(r);
  a.current = r;
  let l = X(() => a.current ? n() : t(), [
    t,
    n
  ]);
  return xu.useSyncExternalStore(e, l);
}
const t2 = typeof g.useSyncExternalStore == "function" ? g.useSyncExternalStore : e2;
function n2(e) {
  let [t] = Y(() => new j5(e?.() || new Oc())), n = X((i) => t.subscribe(i), [
    t
  ]), r = X(() => {
    let i = t.getCollection();
    return t.isSSR && t.resetAfterSSR(), i;
  }, [
    t
  ]), a = X(() => (t.isSSR = !0, t.getCollection()), [
    t
  ]);
  return {
    collection: t2(n, r, a),
    document: t
  };
}
const Pi = /* @__PURE__ */ G(null);
function r2(e) {
  var n;
  return n = class extends st {
  }, n.type = e, n;
}
function Gc(e, t, n, r, a, l) {
  typeof e == "string" && (e = r2(e));
  let i = X((o) => {
    o?.setProps(t, n, e, r, l);
  }, [
    t,
    n,
    r,
    l,
    e
  ]), u = O(Pi);
  if (u) {
    let o = u.ownerDocument.nodesByProps.get(t);
    return o || (o = u.ownerDocument.createElement(e.type), o.setProps(t, n, e, r, l), u.appendChild(o), u.ownerDocument.updateCollection(), u.ownerDocument.nodesByProps.set(t, o)), a ? /* @__PURE__ */ g.createElement(Pi.Provider, {
      value: o
    }, a) : null;
  }
  return /* @__PURE__ */ g.createElement(e.type, {
    ref: i
  }, a);
}
function Ct(e, t) {
  let n = ({ node: a }) => t(a.props, a.props.ref, a), r = te((a, l) => {
    let i = O(Za);
    if (!O(Wc)) {
      if (t.length >= 3) throw new Error(t.name + " cannot be rendered outside a collection.");
      return t(a, l);
    }
    return Gc(e, a, l, "children" in a ? a.children : null, null, (o) => (
      // Forward FocusableContext to real DOM tree so tooltips work.
      /* @__PURE__ */ g.createElement(Za.Provider, {
        value: i
      }, /* @__PURE__ */ g.createElement(n, {
        node: o
      }))
    ));
  });
  return r.displayName = t.name, r;
}
function fa(e, t, n = qc) {
  let r = ({ node: l }) => t(l.props, l.props.ref, l), a = te((l, i) => {
    let u = n(l);
    return Gc(e, l, i, null, u, (o) => /* @__PURE__ */ g.createElement(r, {
      node: o
    })) ?? /* @__PURE__ */ g.createElement(g.Fragment, null);
  });
  return a.displayName = t.name, a;
}
function qc(e) {
  return vu({
    ...e,
    addIdAndValue: !0
  });
}
const Qo = /* @__PURE__ */ G(null);
function Jt(e) {
  let t = O(Qo), n = (t?.dependencies || []).concat(e.dependencies), r = e.idScope ?? t?.idScope, a = qc({
    ...e,
    idScope: r,
    dependencies: n
  });
  return O(Zr) && (a = /* @__PURE__ */ g.createElement(a2, null, a)), t = K(
    () => ({
      dependencies: n,
      idScope: r
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      ...n
    ]
  ), /* @__PURE__ */ g.createElement(Qo.Provider, {
    value: t
  }, a);
}
function a2({ children: e }) {
  let t = O(Zr), n = K(() => /* @__PURE__ */ g.createElement(Zr.Provider, {
    value: null
  }, /* @__PURE__ */ g.createElement(Wc.Provider, {
    value: !0
  }, e)), [
    e
  ]);
  return Dt() ? /* @__PURE__ */ g.createElement(Pi.Provider, {
    value: t
  }, n) : /* @__PURE__ */ Nd(n, t);
}
const Yc = /* @__PURE__ */ G(null), ha = {
  CollectionRoot({ collection: e, renderDropIndicator: t }) {
    return es(e, null, t);
  },
  CollectionBranch({ collection: e, parent: t, renderDropIndicator: n }) {
    return es(e, t, n);
  }
};
function es(e, t, n) {
  return vu({
    items: t ? e.getChildren(t.key) : e,
    dependencies: [
      n
    ],
    children(r) {
      if (r.type === "content") return /* @__PURE__ */ g.createElement(g.Fragment, null);
      let a = r.render(r);
      return !n || r.type !== "item" ? a : /* @__PURE__ */ g.createElement(g.Fragment, null, n({
        type: "item",
        key: r.key,
        dropPosition: "before"
      }), a, Zc(e, r, n));
    }
  });
}
function Zc(e, t, n) {
  let r = t.key, a = e.getKeyAfter(r), l = a != null ? e.getItem(a) : null;
  for (; l != null && l.type !== "item"; )
    a = e.getKeyAfter(l.key), l = a != null ? e.getItem(a) : null;
  let i = t.nextKey != null ? e.getItem(t.nextKey) : null;
  for (; i != null && i.type !== "item"; ) i = i.nextKey != null ? e.getItem(i.nextKey) : null;
  let u = [];
  if (i == null) {
    let o = t;
    for (; o?.type === "item" && (!l || o.parentKey !== l.parentKey && l.level < o.level); ) {
      let d = n({
        type: "item",
        key: o.key,
        dropPosition: "after"
      });
      /* @__PURE__ */ Ov(d) && u.push(/* @__PURE__ */ du(d, {
        key: `${o.key}-after`
      })), o = o.parentKey != null ? e.getItem(o.parentKey) : null;
    }
  }
  return u;
}
const ge = /* @__PURE__ */ G(ha);
function Eu(e) {
  return K(() => e != null ? /* @__PURE__ */ new Set([
    e
  ]) : null, [
    e
  ]);
}
const l2 = /* @__PURE__ */ new Set([
  "id"
]), i2 = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), u2 = /* @__PURE__ */ new Set([
  "href",
  "hrefLang",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), o2 = /* @__PURE__ */ new Set([
  "dir",
  "lang",
  "hidden",
  "inert",
  "translate"
]), ts = /* @__PURE__ */ new Set([
  "onClick",
  "onAuxClick",
  "onContextMenu",
  "onDoubleClick",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onTouchCancel",
  "onTouchEnd",
  "onTouchMove",
  "onTouchStart",
  "onPointerDown",
  "onPointerMove",
  "onPointerUp",
  "onPointerCancel",
  "onPointerEnter",
  "onPointerLeave",
  "onPointerOver",
  "onPointerOut",
  "onGotPointerCapture",
  "onLostPointerCapture",
  "onScroll",
  "onWheel",
  "onAnimationStart",
  "onAnimationEnd",
  "onAnimationIteration",
  "onTransitionCancel",
  "onTransitionEnd",
  "onTransitionRun",
  "onTransitionStart"
]), s2 = /^(data-.*)$/;
function J(e, t = {}) {
  let { labelable: n, isLink: r, global: a, events: l = a, propNames: i } = t, u = {};
  for (const o in e) Object.prototype.hasOwnProperty.call(e, o) && (l2.has(o) || n && i2.has(o) || r && u2.has(o) || a && o2.has(o) || l && (ts.has(o) || o.endsWith("Capture") && ts.has(o.slice(0, -7))) || i?.has(o) || s2.test(o)) && (u[o] = e[o]);
  return u;
}
let nr = "default", wi = "", Ma = /* @__PURE__ */ new WeakMap();
function Si(e) {
  if (vt()) {
    if (nr === "default") {
      const t = he(e);
      wi = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    nr = "disabled";
  } else if (e instanceof HTMLElement || e instanceof SVGElement) {
    let t = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    Ma.set(e, e.style[t]), e.style[t] = "none";
  }
}
function Ka(e) {
  if (vt()) {
    if (nr !== "disabled") return;
    nr = "restoring", setTimeout(() => {
      jc(() => {
        if (nr === "restoring") {
          const t = he(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = wi || ""), wi = "", nr = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && Ma.has(e)) {
    let t = Ma.get(e), n = "userSelect" in e.style ? "userSelect" : "webkitUserSelect";
    e.style[n] === "none" && (e.style[n] = t), e.getAttribute("style") === "" && e.removeAttribute("style"), Ma.delete(e);
  }
}
function ns(e) {
  return e?.defaultView?.__webpack_nonce__ || globalThis.__webpack_nonce__ || void 0;
}
let Ol = /* @__PURE__ */ new WeakMap();
function Xc(e) {
  let t = e ?? (typeof document < "u" ? document : void 0);
  if (!t) return ns(t);
  if (Ol.has(t)) return Ol.get(t);
  let n = t.querySelector('meta[property="csp-nonce"]'), r = n && n instanceof ke(n).HTMLMetaElement && (n.nonce || n.content) || ns(t) || void 0;
  return r !== void 0 && Ol.set(t, r), r;
}
const Xr = g.createContext({
  register: () => {
  }
});
Xr.displayName = "PressResponderContext";
function Qt() {
  let e = T(/* @__PURE__ */ new Map()), t = X((a, l, i, u) => {
    let o = u?.once ? (...d) => {
      e.current.delete(i), i(...d);
    } : i;
    e.current.set(i, {
      type: l,
      eventTarget: a,
      fn: o,
      options: u
    }), a.addEventListener(l, o, u);
  }, []), n = X((a, l, i, u) => {
    let o = e.current.get(i)?.fn || i;
    a.removeEventListener(l, o, u), e.current.delete(i);
  }, []), r = X(() => {
    e.current.forEach((a, l) => {
      n(a.eventTarget, a.type, l, a.options);
    });
  }, [
    n
  ]);
  return ee(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function d2(e) {
  let t = O(Xr);
  if (t) {
    let { register: n, ref: r, ...a } = t;
    e = z(a, e), n();
  }
  return Du(t, e.ref), e;
}
class Pa {
  #e;
  constructor(t, n, r, a) {
    this.#e = !0;
    const i = (a?.target ?? r.currentTarget)?.getBoundingClientRect();
    let u, o = 0, d, s = null;
    r.clientX != null && r.clientY != null && (d = r.clientX, s = r.clientY), i && (d != null && s != null ? (u = d - i.left, o = s - i.top) : (u = i.width / 2, o = i.height / 2)), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey, this.x = u, this.y = o, this.key = r.key;
  }
  continuePropagation() {
    this.#e = !1;
  }
  get shouldStopPropagation() {
    return this.#e;
  }
}
const rs = /* @__PURE__ */ Symbol("linkClicked"), as = "react-aria-pressable-style", ls = "data-react-aria-pressable";
function Xe(e) {
  let { onPress: t, onPressChange: n, onPressStart: r, onPressEnd: a, onPressUp: l, onClick: i, isDisabled: u, isPressed: o, preventFocusOnPress: d, shouldCancelOnPointerExit: s, allowTextSelectionOnPress: c, ref: f, ...h } = d2(e), [m, p] = Y(!1), b = T({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null,
    disposables: []
  }), { addGlobalListener: y, removeAllGlobalListeners: $ } = Qt(), v = X((D, N) => {
    let w = b.current;
    if (u || w.didFirePressStart) return !1;
    let R = !0;
    if (w.isTriggeringEvent = !0, r) {
      let H = new Pa("pressstart", N, D);
      r(H), R = H.shouldStopPropagation;
    }
    return n && n(!0), w.isTriggeringEvent = !1, w.didFirePressStart = !0, p(!0), R;
  }, [
    u,
    r,
    n
  ]), x = X((D, N, w = !0) => {
    let R = b.current;
    if (!R.didFirePressStart) return !1;
    R.didFirePressStart = !1, R.isTriggeringEvent = !0;
    let H = !0;
    if (a) {
      let k = new Pa("pressend", N, D);
      a(k), H = k.shouldStopPropagation;
    }
    if (n && n(!1), p(!1), t && w && !u) {
      let k = new Pa("press", N, D);
      t(k), H &&= k.shouldStopPropagation;
    }
    return R.isTriggeringEvent = !1, H;
  }, [
    u,
    a,
    n,
    t
  ]), E = De(x), P = X((D, N) => {
    let w = b.current;
    if (u) return !1;
    if (l) {
      w.isTriggeringEvent = !0;
      let R = new Pa("pressup", N, D);
      return l(R), w.isTriggeringEvent = !1, R.shouldStopPropagation;
    }
    return !0;
  }, [
    u,
    l
  ]), C = De(P), M = X((D) => {
    let N = b.current;
    if (N.isPressed && N.target) {
      N.didFirePressStart && N.pointerType != null && x(En(N.target, D), N.pointerType, !1), N.isPressed = !1, N.isOverTarget = !1, N.activePointerId = null, N.pointerType = null, $(), c || Ka(N.target);
      for (let w of N.disposables) w();
      N.disposables = [];
    }
  }, [
    c,
    $,
    x
  ]), F = De(M);
  ee(() => {
    u && b.current.isPressed && F({
      currentTarget: b.current.target,
      shiftKey: !1,
      ctrlKey: !1,
      metaKey: !1,
      altKey: !1
    });
  }, [
    u
  ]);
  let V = X((D) => {
    s && M(D);
  }, [
    s,
    M
  ]), I = X((D) => {
    u || i?.(D);
  }, [
    u,
    i
  ]), A = X((D, N) => {
    if (!u && i) {
      let w = new MouseEvent("click", D);
      Ud(w, N), i(bu(w));
    }
  }, [
    u,
    i
  ]), U = K(() => {
    let D = b.current, N = {
      onKeyDown(R) {
        if (Hl(R.nativeEvent, R.currentTarget) && ae(R.currentTarget, W(R))) {
          os(W(R), R.key) && R.preventDefault();
          let H = !0;
          !D.isPressed && !R.repeat && (D.target = R.currentTarget, D.isPressed = !0, D.pointerType = "keyboard", H = v(R, "keyboard"));
          let k = R.currentTarget, S = (j) => {
            Hl(j, k) && !j.repeat && ae(k, W(j)) && D.target && C(En(D.target, j), "keyboard");
          };
          y(he(R.currentTarget), "keyup", ot(S, w), !0), H && R.stopPropagation(), R.metaKey && mn() && D.metaKeyEvents?.set(R.key, R.nativeEvent);
        } else R.key === "Meta" && (D.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onClick(R) {
        if (!(R && !ae(R.currentTarget, W(R))) && R && R.button === 0 && !D.isTriggeringEvent && !It.isOpening) {
          let H = !0;
          if (u && R.preventDefault(), !D.ignoreEmulatedMouseEvents && !D.isPressed && (D.pointerType === "virtual" || $i(R.nativeEvent))) {
            let k = v(R, "virtual"), S = C(R, "virtual"), j = E(R, "virtual");
            I(R), H = k && S && j;
          } else if (D.isPressed && D.pointerType !== "keyboard") {
            let k = D.pointerType || R.nativeEvent.pointerType || "virtual", S = C(En(R.currentTarget, R), k), j = E(En(R.currentTarget, R), k, !0);
            H = S && j, D.isOverTarget = !1, I(R), F(R);
          }
          D.ignoreEmulatedMouseEvents = !1, H && R.stopPropagation();
        }
      }
    }, w = (R) => {
      if (D.isPressed && D.target && Hl(R, D.target)) {
        os(W(R), R.key) && R.preventDefault();
        let H = W(R), k = ae(D.target, H);
        E(En(D.target, R), "keyboard", k), k && A(R, D.target), $(), R.key !== "Enter" && Cu(D.target) && ae(D.target, H) && !R[rs] && (R[rs] = !0, It(D.target, R, !1)), D.isPressed = !1, D.metaKeyEvents?.delete(R.key);
      } else if (R.key === "Meta" && D.metaKeyEvents?.size) {
        let H = D.metaKeyEvents;
        D.metaKeyEvents = void 0;
        for (let k of H.values()) D.target?.dispatchEvent(new KeyboardEvent("keyup", k));
      }
    };
    if (typeof PointerEvent < "u") {
      N.onPointerDown = (k) => {
        if (k.button !== 0 || !ae(k.currentTarget, W(k))) return;
        if (g5(k.nativeEvent)) {
          D.pointerType = "virtual";
          return;
        }
        D.pointerType = k.pointerType;
        let S = !0;
        if (!D.isPressed) {
          D.isPressed = !0, D.isOverTarget = !0, D.activePointerId = k.pointerId, D.target = k.currentTarget, c || Si(D.target), S = v(k, D.pointerType);
          let j = W(k);
          "releasePointerCapture" in j && ("hasPointerCapture" in j ? j.hasPointerCapture(k.pointerId) && j.releasePointerCapture(k.pointerId) : j.releasePointerCapture(k.pointerId)), y(he(k.currentTarget), "pointerup", R, !1), y(he(k.currentTarget), "pointercancel", H, !1);
        }
        S && k.stopPropagation();
      }, N.onMouseDown = (k) => {
        if (ae(k.currentTarget, W(k)) && k.button === 0) {
          if (d) {
            let S = Uo(k.target);
            S && D.disposables.push(S);
          }
          k.stopPropagation();
        }
      }, N.onPointerUp = (k) => {
        !ae(k.currentTarget, W(k)) || D.pointerType === "virtual" || k.button === 0 && !D.isPressed && C(k, D.pointerType || k.pointerType);
      }, N.onPointerEnter = (k) => {
        k.pointerId === D.activePointerId && D.target && !D.isOverTarget && D.pointerType != null && (D.isOverTarget = !0, v(En(D.target, k), D.pointerType));
      }, N.onPointerLeave = (k) => {
        k.pointerId === D.activePointerId && D.target && D.isOverTarget && D.pointerType != null && (D.isOverTarget = !1, E(En(D.target, k), D.pointerType, !1), V(k));
      };
      let R = (k) => {
        if (k.pointerId === D.activePointerId && D.isPressed && k.button === 0 && D.target) {
          if (ae(D.target, W(k)) && D.pointerType != null) {
            let S = !1, j = setTimeout(() => {
              D.isPressed && D.target instanceof HTMLElement && (S ? F(k) : (Fe(D.target), D.target.click()));
            }, 80);
            y(k.currentTarget, "click", () => S = !0, !0), D.disposables.push(() => clearTimeout(j));
          } else
            F(k);
          D.isOverTarget = !1;
        }
      }, H = (k) => {
        F(k);
      };
      N.onDragStart = (k) => {
        ae(k.currentTarget, W(k)) && F(k);
      };
    } else if (process.env.NODE_ENV === "test") {
      N.onMouseDown = (k) => {
        if (k.button !== 0 || !ae(k.currentTarget, W(k))) return;
        if (D.ignoreEmulatedMouseEvents) {
          k.stopPropagation();
          return;
        }
        if (D.isPressed = !0, D.isOverTarget = !0, D.target = k.currentTarget, D.pointerType = $i(k.nativeEvent) ? "virtual" : "mouse", at(() => v(k, D.pointerType)) && k.stopPropagation(), d) {
          let j = Uo(k.target);
          j && D.disposables.push(j);
        }
        y(he(k.currentTarget), "mouseup", R, !1);
      }, N.onMouseEnter = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        let S = !0;
        D.isPressed && !D.ignoreEmulatedMouseEvents && D.pointerType != null && (D.isOverTarget = !0, S = v(k, D.pointerType)), S && k.stopPropagation();
      }, N.onMouseLeave = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        let S = !0;
        D.isPressed && !D.ignoreEmulatedMouseEvents && D.pointerType != null && (D.isOverTarget = !1, S = E(k, D.pointerType, !1), V(k)), S && k.stopPropagation();
      }, N.onMouseUp = (k) => {
        ae(k.currentTarget, W(k)) && !D.ignoreEmulatedMouseEvents && k.button === 0 && !D.isPressed && C(k, D.pointerType || "mouse");
      };
      let R = (k) => {
        if (k.button === 0) {
          if (D.ignoreEmulatedMouseEvents) {
            D.ignoreEmulatedMouseEvents = !1;
            return;
          }
          D.target && ae(D.target, W(k)) && D.pointerType != null || F(k), D.isOverTarget = !1;
        }
      };
      N.onTouchStart = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        let S = c2(k.nativeEvent);
        if (!S) return;
        D.activePointerId = S.identifier, D.ignoreEmulatedMouseEvents = !0, D.isOverTarget = !0, D.isPressed = !0, D.target = k.currentTarget, D.pointerType = "touch", c || Si(D.target), v(un(D.target, k), D.pointerType) && k.stopPropagation(), y(ke(k.currentTarget), "scroll", H, !0);
      }, N.onTouchMove = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        if (!D.isPressed) {
          k.stopPropagation();
          return;
        }
        let S = is(k.nativeEvent, D.activePointerId), j = !0;
        S && us(S, k.currentTarget) ? !D.isOverTarget && D.pointerType != null && (D.isOverTarget = !0, j = v(un(D.target, k), D.pointerType)) : D.isOverTarget && D.pointerType != null && (D.isOverTarget = !1, j = E(un(D.target, k), D.pointerType, !1), V(un(D.target, k))), j && k.stopPropagation();
      }, N.onTouchEnd = (k) => {
        if (!ae(k.currentTarget, W(k))) return;
        if (!D.isPressed) {
          k.stopPropagation();
          return;
        }
        let S = is(k.nativeEvent, D.activePointerId), j = !0;
        S && us(S, k.currentTarget) && D.pointerType != null ? (C(un(D.target, k), D.pointerType), j = E(un(D.target, k), D.pointerType), A(k.nativeEvent, D.target)) : D.isOverTarget && D.pointerType != null && (j = E(un(D.target, k), D.pointerType, !1)), j && k.stopPropagation(), D.isPressed = !1, D.activePointerId = null, D.isOverTarget = !1, D.ignoreEmulatedMouseEvents = !0, D.target && !c && Ka(D.target), $();
      }, N.onTouchCancel = (k) => {
        ae(k.currentTarget, W(k)) && (k.stopPropagation(), D.isPressed && F(un(D.target, k)));
      };
      let H = (k) => {
        D.isPressed && ae(W(k), D.target) && F({
          currentTarget: D.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      N.onDragStart = (k) => {
        ae(k.currentTarget, W(k)) && F(k);
      };
    }
    return N;
  }, [
    y,
    u,
    d,
    $,
    c,
    V,
    v,
    I,
    A
  ]);
  return ee(() => {
    if (!f || process.env.NODE_ENV === "test") return;
    const D = he(f.current);
    if (!D || !D.head || D.getElementById(as)) return;
    const N = D.createElement("style");
    N.id = as;
    let w = Xc(D);
    w && (N.nonce = w), N.textContent = `
@layer {
  [${ls}] {
    touch-action: pan-x pan-y pinch-zoom;
  }
}
    `.trim(), D.head.prepend(N);
  }, [
    f
  ]), ee(() => {
    let D = b.current;
    return () => {
      c || Ka(D.target ?? void 0);
      for (let N of D.disposables) N();
      D.disposables = [];
    };
  }, [
    c
  ]), {
    isPressed: o || m,
    pressProps: z(h, U, {
      [ls]: !0
    })
  };
}
function Cu(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function Hl(e, t) {
  const { key: n, code: r } = e, a = t, l = a.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(a instanceof ke(a).HTMLInputElement && !Jc(a, n) || a instanceof ke(a).HTMLTextAreaElement || a.isContentEditable) && // Links should only trigger with Enter key
  !((l === "link" || !l && Cu(a)) && n !== "Enter");
}
function c2(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function is(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const a = n[r];
    if (a.identifier === t) return a;
  }
  return null;
}
function un(e, t) {
  let n = 0, r = 0;
  return t.targetTouches && t.targetTouches.length === 1 && (n = t.targetTouches[0].clientX, r = t.targetTouches[0].clientY), {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r
  };
}
function En(e, t) {
  let n = t.clientX, r = t.clientY;
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey,
    clientX: n,
    clientY: r,
    key: t.key
  };
}
function f2(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function h2(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function us(e, t) {
  let n = t.getBoundingClientRect(), r = f2(e);
  return h2(n, r);
}
function m2(e) {
  return e instanceof HTMLInputElement ? !1 : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Cu(e);
}
function os(e, t) {
  return e instanceof HTMLInputElement ? !Jc(e, t) : m2(e);
}
const p2 = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Jc(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : p2.has(e.type);
}
function b2(e, t) {
  let { elementType: n = "a", onPress: r, onPressStart: a, onPressEnd: l, onClick: i, isDisabled: u, ...o } = e, d = {};
  n !== "a" && (d = {
    role: "link",
    tabIndex: u ? void 0 : 0
  });
  let { focusableProps: s } = dt(e, t), { pressProps: c, isPressed: f } = Xe({
    onPress: r,
    onPressStart: a,
    onPressEnd: l,
    onClick: i,
    isDisabled: u,
    ref: t
  }), h = J(o, {
    labelable: !0
  }), m = z(s, c), p = Dr(), b = bl(e);
  return {
    isPressed: f,
    linkProps: z(h, b, {
      ...m,
      ...d,
      "aria-disabled": u || void 0,
      "aria-current": e["aria-current"],
      onClick: (y) => {
        c.onClick?.(y), Jd(y, p, e.href, e.routerOptions);
      }
    })
  };
}
function ct(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: a } = e, l = T({
    isFocusWithin: !1
  }), { addGlobalListener: i, removeAllGlobalListeners: u } = Qt(), o = X((c) => {
    ae(c.currentTarget, W(c)) && l.current.isFocusWithin && !ae(c.currentTarget, c.relatedTarget) && (l.current.isFocusWithin = !1, u(), n && n(c), a && a(!1));
  }, [
    n,
    a,
    l,
    u
  ]), d = jd(o), s = X((c) => {
    if (!ae(c.currentTarget, W(c))) return;
    let f = W(c);
    const h = he(f), m = se(h);
    if (!l.current.isFocusWithin && m === f) {
      r && r(c), a && a(!0), l.current.isFocusWithin = !0, d(c);
      let p = c.currentTarget;
      i(h, "focus", (b) => {
        let y = W(b);
        if (l.current.isFocusWithin && !ae(p, y)) {
          let $ = new h.defaultView.FocusEvent("blur", {
            relatedTarget: y
          });
          Ud($, p);
          let v = bu($);
          o(v);
        }
      }, {
        capture: !0
      });
    }
  }, [
    r,
    a,
    d,
    i,
    o
  ]);
  return t ? {
    focusWithinProps: {
      // These cannot be null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: s,
      onBlur: o
    }
  };
}
function ye(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, a = T({
    isFocused: !1,
    isFocusVisible: t || Mt()
  }), [l, i] = Y(!1), [u, o] = Y(() => a.current.isFocused && a.current.isFocusVisible), d = X(() => o(a.current.isFocused && a.current.isFocusVisible), []), s = X((h) => {
    a.current.isFocused = h, a.current.isFocusVisible = Mt(), i(h), d();
  }, [
    d
  ]);
  P5((h) => {
    a.current.isFocusVisible = h, d();
  }, [
    n,
    l
  ], {
    enabled: l,
    isTextInput: n
  });
  let { focusProps: c } = mr({
    isDisabled: r,
    onFocusChange: s
  }), { focusWithinProps: f } = ct({
    isDisabled: !r,
    onFocusWithinChange: s
  });
  return {
    isFocused: l,
    isFocusVisible: u,
    focusProps: r ? f : c
  };
}
let Ja = !1, wa = 0;
function ki() {
  Ja = !0, setTimeout(() => {
    Ja = !1;
  }, 500);
}
function ss(e) {
  e.pointerType === "touch" && ki();
}
function g2() {
  let e = he(null);
  if (!(typeof e > "u"))
    return wa === 0 && (typeof PointerEvent < "u" ? e.addEventListener("pointerup", ss) : process.env.NODE_ENV === "test" && e.addEventListener("touchend", ki)), wa++, () => {
      wa--, !(wa > 0) && (typeof PointerEvent < "u" ? e.removeEventListener("pointerup", ss) : process.env.NODE_ENV === "test" && e.removeEventListener("touchend", ki));
    };
}
function ve(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: a } = e, [l, i] = Y(!1), u = T({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  ee(g2, []);
  let { addGlobalListener: o, removeAllGlobalListeners: d } = Qt(), { hoverProps: s, triggerHoverEnd: c } = K(() => {
    let f = (p, b) => {
      if (u.pointerType = b, a || b === "touch" || u.isHovered || !ae(p.currentTarget, W(p))) return;
      u.isHovered = !0;
      let y = p.currentTarget;
      u.target = y, o(he(W(p)), "pointerover", ($) => {
        u.isHovered && u.target && !ae(u.target, W($)) && h($, $.pointerType);
      }, {
        capture: !0
      }), t && t({
        type: "hoverstart",
        target: y,
        pointerType: b
      }), n && n(!0), i(!0);
    }, h = (p, b) => {
      let y = u.target;
      u.pointerType = "", u.target = null, !(b === "touch" || !u.isHovered || !y) && (u.isHovered = !1, d(), r && r({
        type: "hoverend",
        target: y,
        pointerType: b
      }), n && n(!1), i(!1));
    }, m = {};
    return typeof PointerEvent < "u" ? (m.onPointerEnter = (p) => {
      Ja && p.pointerType === "mouse" || f(p, p.pointerType);
    }, m.onPointerLeave = (p) => {
      !a && ae(p.currentTarget, W(p)) && h(p, p.pointerType);
    }) : process.env.NODE_ENV === "test" && (m.onTouchStart = () => {
      u.ignoreEmulatedMouseEvents = !0;
    }, m.onMouseEnter = (p) => {
      !u.ignoreEmulatedMouseEvents && !Ja && f(p, "mouse"), u.ignoreEmulatedMouseEvents = !1;
    }, m.onMouseLeave = (p) => {
      !a && ae(p.currentTarget, W(p)) && h(p, "mouse");
    }), {
      hoverProps: m,
      triggerHoverEnd: h
    };
  }, [
    t,
    n,
    r,
    a,
    u,
    o,
    d
  ]);
  return ee(() => {
    a && c({
      currentTarget: u.target
    }, u.pointerType);
  }, [
    a
  ]), {
    hoverProps: s,
    isHovered: l
  };
}
const Qc = /* @__PURE__ */ G(null), _C = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Qc);
  let r = t.href && !t.isDisabled ? "a" : "span", { linkProps: a, isPressed: l } = b2({
    ...t,
    elementType: r
  }, n), i = Q[r], { hoverProps: u, isHovered: o } = ve(t), { focusProps: d, isFocused: s, isFocusVisible: c } = ye(), f = le({
    ...t,
    defaultClassName: "react-aria-Link",
    values: {
      isCurrent: !!t["aria-current"],
      isDisabled: t.isDisabled || !1,
      isPressed: l,
      isHovered: o,
      isFocused: s,
      isFocusVisible: c
    }
  }), h = J(t, {
    global: !0
  });
  return delete h.onClick, /* @__PURE__ */ g.createElement(i, {
    ref: n,
    slot: t.slot || void 0,
    ...z(h, f, a, u, d),
    "data-focused": s || void 0,
    "data-hovered": o || void 0,
    "data-pressed": l || void 0,
    "data-focus-visible": c || void 0,
    "data-current": !!t["aria-current"] || void 0,
    "data-disabled": t.isDisabled || void 0
  }, f.children);
});
var ef = {};
ef = {
  breadcrumbs: "عناصر الواجهة"
};
var tf = {};
tf = {
  breadcrumbs: "Трохи хляб"
};
var nf = {};
nf = {
  breadcrumbs: "Popis cesty"
};
var rf = {};
rf = {
  breadcrumbs: "Brødkrummer"
};
var af = {};
af = {
  breadcrumbs: "Breadcrumbs"
};
var lf = {};
lf = {
  breadcrumbs: "Πλοηγήσεις breadcrumb"
};
var uf = {};
uf = {
  breadcrumbs: "Breadcrumbs"
};
var of = {};
of = {
  breadcrumbs: "Migas de pan"
};
var sf = {};
sf = {
  breadcrumbs: "Lingiread"
};
var df = {};
df = {
  breadcrumbs: "Navigointilinkit"
};
var cf = {};
cf = {
  breadcrumbs: "Chemin de navigation"
};
var ff = {};
ff = {
  breadcrumbs: "שבילי ניווט"
};
var hf = {};
hf = {
  breadcrumbs: "Navigacijski putovi"
};
var mf = {};
mf = {
  breadcrumbs: "Morzsamenü"
};
var pf = {};
pf = {
  breadcrumbs: "Breadcrumb"
};
var bf = {};
bf = {
  breadcrumbs: "パンくずリスト"
};
var gf = {};
gf = {
  breadcrumbs: "탐색 표시"
};
var yf = {};
yf = {
  breadcrumbs: "Naršymo kelias"
};
var $f = {};
$f = {
  breadcrumbs: "Atpakaļceļi"
};
var vf = {};
vf = {
  breadcrumbs: "Navigasjonsstier"
};
var Df = {};
Df = {
  breadcrumbs: "Broodkruimels"
};
var xf = {};
xf = {
  breadcrumbs: "Struktura nawigacyjna"
};
var Ef = {};
Ef = {
  breadcrumbs: "Caminho detalhado"
};
var Cf = {};
Cf = {
  breadcrumbs: "Categorias"
};
var Pf = {};
Pf = {
  breadcrumbs: "Miez de pâine"
};
var wf = {};
wf = {
  breadcrumbs: "Навигация"
};
var Sf = {};
Sf = {
  breadcrumbs: "Navigačné prvky Breadcrumbs"
};
var kf = {};
kf = {
  breadcrumbs: "Drobtine"
};
var Bf = {};
Bf = {
  breadcrumbs: "Putanje navigacije"
};
var Ff = {};
Ff = {
  breadcrumbs: "Sökvägar"
};
var Af = {};
Af = {
  breadcrumbs: "İçerik haritaları"
};
var Rf = {};
Rf = {
  breadcrumbs: "Навігаційна стежка"
};
var Tf = {};
Tf = {
  breadcrumbs: "导航栏"
};
var If = {};
If = {
  breadcrumbs: "導覽列"
};
var Mf = {};
Mf = {
  "ar-AE": ef,
  "bg-BG": tf,
  "cs-CZ": nf,
  "da-DK": rf,
  "de-DE": af,
  "el-GR": lf,
  "en-US": uf,
  "es-ES": of,
  "et-EE": sf,
  "fi-FI": df,
  "fr-FR": cf,
  "he-IL": ff,
  "hr-HR": hf,
  "hu-HU": mf,
  "it-IT": pf,
  "ja-JP": bf,
  "ko-KR": gf,
  "lt-LT": yf,
  "lv-LV": $f,
  "nb-NO": vf,
  "nl-NL": Df,
  "pl-PL": xf,
  "pt-BR": Ef,
  "pt-PT": Cf,
  "ro-RO": Pf,
  "ru-RU": wf,
  "sk-SK": Sf,
  "sl-SI": kf,
  "sr-SP": Bf,
  "sv-SE": Ff,
  "tr-TR": Af,
  "uk-UA": Rf,
  "zh-CN": Tf,
  "zh-TW": If
};
function y2(e) {
  return e && e.__esModule ? e.default : e;
}
function $2(e) {
  let { "aria-label": t, ...n } = e, r = xe(y2(Mf), "@react-aria/breadcrumbs");
  return {
    navProps: {
      ...J(n, {
        labelable: !0
      }),
      "aria-label": t || r.format("breadcrumbs")
    }
  };
}
const Bi = /* @__PURE__ */ G(null), WC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Bi);
  let { CollectionRoot: r } = O(ge), { navProps: a } = $2(t), l = J(t, {
    global: !0,
    labelable: !0
  });
  return /* @__PURE__ */ g.createElement(Hn, {
    content: /* @__PURE__ */ g.createElement(Jt, t)
  }, (i) => /* @__PURE__ */ g.createElement(Q.ol, {
    render: t.render,
    ref: n,
    ...z(l, a),
    slot: t.slot || void 0,
    style: t.style,
    className: t.className ?? "react-aria-Breadcrumbs"
  }, /* @__PURE__ */ g.createElement(Bi.Provider, {
    value: t
  }, /* @__PURE__ */ g.createElement(r, {
    collection: i
  }))));
}), ko = class ko extends st {
};
ko.type = "item";
let Fi = ko;
const GC = /* @__PURE__ */ Ct(Fi, function(t, n, r) {
  let a = r.nextKey == null, { isDisabled: l, onAction: i } = Oe(Bi), u = {
    "aria-current": a ? "page" : null,
    isDisabled: l || a,
    onPress: () => i?.(r.key)
  }, o = le({
    ...r.props,
    children: r.rendered,
    values: {
      isDisabled: l || a,
      isCurrent: a
    },
    defaultClassName: "react-aria-Breadcrumb"
  }), d = J(t, {
    global: !0,
    labelable: !0
  });
  return delete d.id, /* @__PURE__ */ g.createElement(Q.li, {
    ...d,
    ...o,
    ref: n,
    "data-disabled": l || a || void 0,
    "data-current": a || void 0
  }, /* @__PURE__ */ g.createElement(Qc.Provider, {
    value: u
  }, o.children));
}), Qe = /* @__PURE__ */ G({}), qC = /* @__PURE__ */ $n(function(t, n) {
  [t, n] = oe(t, n, Qe);
  let { elementType: r = "label", ...a } = t, l = Q[r];
  return /* @__PURE__ */ g.createElement(l, {
    className: "react-aria-Label",
    ...a,
    ref: n
  });
});
function ma(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": a, labelElementType: l = "label" } = e;
  t = ce(t);
  let i = ce(), u = {};
  n ? (r = r ? `${i} ${r}` : i, u = {
    id: i,
    htmlFor: l === "label" ? t : void 0
  }) : !r && !a && process.env.NODE_ENV !== "production" && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let o = it({
    id: t,
    "aria-label": a,
    "aria-labelledby": r
  });
  return {
    labelProps: u,
    fieldProps: o
  };
}
let Ul = /* @__PURE__ */ new Map(), Ai = !1;
try {
  Ai = new Intl.NumberFormat("de-DE", {
    signDisplay: "exceptZero"
  }).resolvedOptions().signDisplay === "exceptZero";
} catch {
}
let Qa = !1;
try {
  Qa = new Intl.NumberFormat("de-DE", {
    style: "unit",
    unit: "degree"
  }).resolvedOptions().style === "unit";
} catch {
}
const Kf = {
  degree: {
    narrow: {
      default: "°",
      "ja-JP": " 度",
      "zh-TW": "度",
      "sl-SI": " °"
    }
  }
};
class Kt {
  constructor(t, n = {}) {
    this.numberFormatter = v2(t, n), this.options = n;
  }
  /**
  * Formats a number value as a string, according to the locale and options provided to the
  * constructor.
  */
  format(t) {
    let n = "";
    if (!Ai && this.options.signDisplay != null ? n = D2(this.numberFormatter, this.options.signDisplay, t) : n = this.numberFormatter.format(t), this.options.style === "unit" && !Qa) {
      let { unit: r, unitDisplay: a = "short", locale: l } = this.resolvedOptions();
      if (!r) return n;
      let i = Kf[r]?.[a];
      n += i[l] || i.default;
    }
    return n;
  }
  /** Formats a number to an array of parts such as separators, digits, punctuation, and more. */
  formatToParts(t) {
    return this.numberFormatter.formatToParts(t);
  }
  /** Formats a number range as a string. */
  formatRange(t, n) {
    if (typeof this.numberFormatter.formatRange == "function") return this.numberFormatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.format(t)} – ${this.format(n)}`;
  }
  /** Formats a number range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.numberFormatter.formatRangeToParts == "function") return this.numberFormatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.numberFormatter.formatToParts(t), a = this.numberFormatter.formatToParts(n);
    return [
      ...r.map((l) => ({
        ...l,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((l) => ({
        ...l,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.numberFormatter.resolvedOptions();
    return !Ai && this.options.signDisplay != null && (t = {
      ...t,
      signDisplay: this.options.signDisplay
    }), !Qa && this.options.style === "unit" && (t = {
      ...t,
      style: "unit",
      unit: this.options.unit,
      unitDisplay: this.options.unitDisplay
    }), t;
  }
}
function v2(e, t = {}) {
  let { numberingSystem: n } = t;
  if (n && e.includes("-nu-") && (e.includes("-u-") || (e += "-u-"), e += `-nu-${n}`), t.style === "unit" && !Qa) {
    let { unit: l, unitDisplay: i = "short" } = t;
    if (!l) throw new Error('unit option must be provided with style: "unit"');
    if (!Kf[l]?.[i]) throw new Error(`Unsupported unit ${l} with unitDisplay = ${i}`);
    t = {
      ...t,
      style: "decimal"
    };
  }
  let r = e + (t ? Object.entries(t).sort((l, i) => l[0] < i[0] ? -1 : 1).join() : "");
  if (Ul.has(r)) return Ul.get(r);
  let a = new Intl.NumberFormat(e, t);
  return Ul.set(r, a), a;
}
function D2(e, t, n) {
  if (t === "auto") return e.format(n);
  if (t === "never") return e.format(Math.abs(n));
  {
    let r = !1;
    if (t === "always" ? r = n > 0 || Object.is(n, 0) : t === "exceptZero" && (Object.is(n, -0) || Object.is(n, 0) ? n = Math.abs(n) : r = n > 0), r) {
      let a = e.format(-n), l = e.format(n), i = a.replace(l, "").replace(/\u200e|\u061C/, "");
      return [
        ...i
      ].length !== 1 && console.warn("@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case"), a.replace(l, "!!!").replace(i, "+").replace("!!!", l);
    } else return e.format(n);
  }
}
const x2 = new RegExp("^.*\\(.*\\).*$"), E2 = [
  "latn",
  "arab",
  "hanidec",
  "deva",
  "beng",
  "fullwide"
];
class Pu {
  constructor(t, n = {}) {
    this.locale = t, this.options = n;
  }
  /**
  * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
  */
  parse(t) {
    return jl(this.locale, this.options, t).parse(t);
  }
  /**
  * Returns whether the given string could potentially be a valid number. This should be used to
  * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
  * of the minus/plus sign characters can be checked.
  */
  isValidPartialNumber(t, n, r) {
    return jl(this.locale, this.options, t).isValidPartialNumber(t, n, r);
  }
  /**
  * Returns a numbering system for which the given string is valid in the current locale.
  * If no numbering system could be detected, the default numbering system for the current
  * locale is returned.
  */
  getNumberingSystem(t) {
    return jl(this.locale, this.options, t).options.numberingSystem;
  }
}
const ds = /* @__PURE__ */ new Map();
function jl(e, t, n) {
  let r = cs(e, t);
  if (!e.includes("-nu-") && !r.isValidPartialNumber(n)) {
    for (let a of E2) if (a !== r.options.numberingSystem) {
      let l = cs(e + (e.includes("-u-") ? "-nu-" : "-u-nu-") + a, t);
      if (l.isValidPartialNumber(n)) return l;
    }
  }
  return r;
}
function cs(e, t) {
  let n = e + (t ? Object.entries(t).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : ""), r = ds.get(n);
  return r || (r = new C2(e, t), ds.set(n, r)), r;
}
class C2 {
  constructor(t, n = {}) {
    this.locale = t, n.roundingIncrement !== 1 && n.roundingIncrement != null && (n.maximumFractionDigits == null && n.minimumFractionDigits == null ? (n.maximumFractionDigits = 0, n.minimumFractionDigits = 0) : n.maximumFractionDigits == null ? n.maximumFractionDigits = n.minimumFractionDigits : n.minimumFractionDigits == null && (n.minimumFractionDigits = n.maximumFractionDigits)), this.formatter = new Intl.NumberFormat(t, n), this.options = this.formatter.resolvedOptions(), this.symbols = P2(t, this.formatter, this.options, n), this.options.style === "percent" && ((this.options.minimumFractionDigits ?? 0) > 18 || (this.options.maximumFractionDigits ?? 0) > 18) && console.warn("NumberParser cannot handle percentages with greater than 18 decimal places, please reduce the number in your options.");
  }
  parse(t) {
    let n = this.formatter.resolvedOptions().useGrouping, r = this.sanitize(t);
    if (!n && this.symbols.group && r.includes(this.symbols.group)) return NaN;
    if (this.symbols.group && (r = r.replaceAll(this.symbols.group, "")), this.symbols.decimal && (r = r.replace(this.symbols.decimal, ".")), this.symbols.minusSign && (r = r.replace(this.symbols.minusSign, "-")), r = r.replace(this.symbols.numeral, this.symbols.index), this.options.style === "percent") {
      let l = r.indexOf("-");
      r = r.replace("-", ""), r = r.replace("+", "");
      let i = r.indexOf(".");
      i === -1 && (i = r.length), r = r.replace(".", ""), i - 2 === 0 ? r = `0.${r}` : i - 2 === -1 ? r = `0.0${r}` : i - 2 === -2 ? r = "0.00" : r = `${r.slice(0, i - 2)}.${r.slice(i - 2)}`, l > -1 && (r = `-${r}`);
    }
    let a = r ? +r : NaN;
    if (isNaN(a)) return NaN;
    if (this.options.style === "percent") {
      let l = {
        ...this.options,
        style: "decimal",
        minimumFractionDigits: Math.min((this.options.minimumFractionDigits ?? 0) + 2, 20),
        maximumFractionDigits: Math.min((this.options.maximumFractionDigits ?? 0) + 2, 20)
      };
      return new Pu(this.locale, l).parse(new Kt(this.locale, l).format(a));
    }
    return this.options.currencySign === "accounting" && x2.test(t) && (a = -1 * a), a;
  }
  sanitize(t) {
    let n = this.formatter.resolvedOptions().useGrouping;
    return this.symbols.noNumeralUnits.length > 0 && this.symbols.noNumeralUnits.find((r) => r.unit === t) ? this.symbols.noNumeralUnits.find((r) => r.unit === t).value.toString() : (t = t.replace(this.symbols.literals, ""), this.symbols.minusSign && (t = t.replace("-", this.symbols.minusSign)), this.options.numberingSystem === "arab" && (this.symbols.decimal && (t = on(t, ",", this.symbols.decimal), t = on(t, "،", this.symbols.decimal)), this.symbols.group && n && (t = on(t, ".", this.symbols.group))), this.symbols.group === "’" && t.includes("'") && n && (t = on(t, "'", this.symbols.group)), this.symbols.group === "'" && t.includes("’") && n && (t = on(t, "’", this.symbols.group)), this.options.locale === "fr-FR" && this.symbols.group && n && (t = on(t, " ", this.symbols.group), t = on(t, /\u00A0/g, this.symbols.group)), t);
  }
  isValidPartialNumber(t, n = -1 / 0, r = 1 / 0) {
    let a = this.formatter.resolvedOptions().useGrouping;
    return t = this.sanitize(t), this.symbols.minusSign && t.startsWith(this.symbols.minusSign) && n < 0 ? t = t.slice(this.symbols.minusSign.length) : this.symbols.plusSign && t.startsWith(this.symbols.plusSign) && r > 0 && (t = t.slice(this.symbols.plusSign.length)), this.symbols.decimal && t.indexOf(this.symbols.decimal) > -1 && this.options.maximumFractionDigits === 0 ? !1 : (this.symbols.group && a && (t = on(t, this.symbols.group, "")), t = t.replace(this.symbols.numeral, ""), this.symbols.decimal && (t = t.replace(this.symbols.decimal, "")), t.length === 0);
  }
}
const fs = /* @__PURE__ */ new Set([
  "decimal",
  "fraction",
  "integer",
  "minusSign",
  "plusSign",
  "group"
]), hs = [
  0,
  4,
  2,
  1,
  11,
  20,
  3,
  7,
  100,
  21,
  0.1,
  1.1
];
function P2(e, t, n, r) {
  let a = new Intl.NumberFormat(e, {
    ...n,
    // Resets so we get the full range of symbols
    minimumSignificantDigits: 1,
    maximumSignificantDigits: 21,
    roundingIncrement: 1,
    roundingPriority: "auto",
    roundingMode: "halfExpand",
    useGrouping: !0
  }), l = a.formatToParts(-10000.111), i = a.formatToParts(10000.111), u = hs.map((P) => a.formatToParts(P)), o = u.map((P, C) => {
    let M = P.find((F) => F.type === "unit");
    return M && !P.some((F) => F.type === "integer" || F.type === "fraction") ? {
      unit: M.value,
      value: hs[C]
    } : null;
  }).filter((P) => !!P), d = l.find((P) => P.type === "minusSign")?.value ?? "-", s = i.find((P) => P.type === "plusSign")?.value;
  !s && (r?.signDisplay === "exceptZero" || r?.signDisplay === "always") && (s = "+");
  let f = new Intl.NumberFormat(e, {
    ...n,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).formatToParts(1e-3).find((P) => P.type === "decimal")?.value, h = l.find((P) => P.type === "group")?.value, m = l.filter((P) => !fs.has(P.type)).map((P) => ms(P.value)), p = u.flatMap((P) => P.filter((C) => !fs.has(C.type)).map((C) => ms(C.value))), b = [
    .../* @__PURE__ */ new Set([
      ...m,
      ...p
    ])
  ].sort((P, C) => C.length - P.length), y = b.length === 0 ? new RegExp("\\p{White_Space}|\\p{Cf}", "gu") : new RegExp(`${b.join("|")}|\\p{White_Space}|\\p{Cf}`, "gu"), $ = [
    ...new Intl.NumberFormat(n.locale, {
      useGrouping: !1
    }).format(9876543210)
  ].reverse(), v = new Map($.map((P, C) => [
    P,
    C
  ])), x = new RegExp(`[${$.join("")}]`, "g");
  return {
    minusSign: d,
    plusSign: s,
    decimal: f,
    group: h,
    literals: y,
    numeral: x,
    numerals: $,
    index: (P) => String(v.get(P)),
    noNumeralUnits: o
  };
}
function on(e, t, n) {
  return e.replaceAll ? e.replaceAll(t, n) : e.split(t).join(n);
}
function ms(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Ri(e = {}) {
  let { locale: t } = de();
  return K(() => new Kt(t, e), [
    t,
    e
  ]);
}
function Ve(e, t = -1 / 0, n = 1 / 0) {
  return Math.min(Math.max(e, t), n);
}
function Sa(e, t) {
  let n = e, r = 0, a = t.toString(), l = a.toLowerCase().indexOf("e-");
  if (l > 0) r = Math.abs(Math.floor(Math.log10(Math.abs(t)))) + l;
  else {
    let i = a.indexOf(".");
    i >= 0 && (r = a.length - i);
  }
  if (r > 0) {
    let i = Math.pow(10, r);
    n = Math.round(n * i) / i;
  }
  return n;
}
function Ne(e, t, n, r) {
  t = Number(t), n = Number(n);
  let a = (e - (isNaN(t) ? 0 : t)) % r, l = Sa(Math.abs(a) * 2 >= r ? e + Math.sign(a) * (r - Math.abs(a)) : e - a, r);
  return isNaN(t) ? !isNaN(n) && l > n && (l = Math.floor(Sa(n / r, r)) * r) : l < t ? l = t : !isNaN(n) && l > n && (l = t + Math.floor(Sa((n - t) / r, r)) * r), l = Sa(l, r), l;
}
function Ke(e, t, n = 10) {
  const r = Math.pow(n, t);
  return Math.round(e * r) / r;
}
function w2(e) {
  let { value: t = 0, minValue: n = 0, maxValue: r = 100, valueLabel: a, isIndeterminate: l, formatOptions: i = {
    style: "percent"
  } } = e, u = J(e, {
    labelable: !0
  }), { labelProps: o, fieldProps: d } = ma({
    ...e,
    // Progress bar is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  t = Ve(t, n, r);
  let s = (t - n) / (r - n), c = Ri(i);
  if (!l && !a) {
    let f = i.style === "percent" ? s : t;
    a = c.format(f);
  }
  return {
    progressBarProps: z(u, {
      ...d,
      "aria-valuenow": l ? void 0 : t,
      "aria-valuemin": n,
      "aria-valuemax": r,
      "aria-valuetext": l ? void 0 : a,
      role: "progressbar"
    }),
    labelProps: o
  };
}
const Nf = /* @__PURE__ */ G(null), YC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Nf);
  let { value: r = 0, minValue: a = 0, maxValue: l = 100, isIndeterminate: i = !1 } = t;
  r = Ve(r, a, l);
  let [u, o] = Je(!t["aria-label"] && !t["aria-labelledby"]), { progressBarProps: d, labelProps: s } = w2({
    ...t,
    label: o
  }), c = i ? void 0 : (r - a) / (l - a) * 100, f = le({
    ...t,
    defaultClassName: "react-aria-ProgressBar",
    values: {
      percentage: c,
      valueText: d["aria-valuetext"],
      isIndeterminate: i
    }
  }), h = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(h, f, d),
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ g.createElement(Qe.Provider, {
    value: {
      ...s,
      ref: u,
      elementType: "span"
    }
  }, f.children));
}), Vf = 7e3;
let sn = null;
function bn(e, t = "assertive", n = Vf) {
  sn ? sn.announce(e, t, n) : (sn = new k2(), (typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u") ? sn.announce(e, t, n) : setTimeout(() => {
    sn?.isAttached() && sn?.announce(e, t, n);
  }, 100));
}
function S2(e) {
  sn && sn.clear(e);
}
class k2 {
  constructor() {
    this.node = null, this.assertiveLog = null, this.politeLog = null, typeof document < "u" && (this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node));
  }
  isAttached() {
    return this.node?.isConnected;
  }
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = Vf) {
    if (!this.node) return;
    let a = document.createElement("div");
    typeof t == "object" ? (a.setAttribute("role", "img"), a.setAttribute("aria-labelledby", t["aria-labelledby"])) : a.textContent = t, n === "assertive" ? this.assertiveLog?.appendChild(a) : this.politeLog?.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && this.assertiveLog && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && this.politeLog && (this.politeLog.innerHTML = ""));
  }
}
function Lf(e, t) {
  let { elementType: n = "button", isDisabled: r, onPress: a, onPressStart: l, onPressEnd: i, onPressUp: u, onPressChange: o, preventFocusOnPress: d, allowFocusWhenDisabled: s, onClick: c, href: f, target: h, rel: m, type: p = "button" } = e, b;
  n === "button" ? b = {
    type: p,
    disabled: r,
    form: e.form,
    formAction: e.formAction,
    formEncType: e.formEncType,
    formMethod: e.formMethod,
    formNoValidate: e.formNoValidate,
    formTarget: e.formTarget,
    name: e.name,
    value: e.value
  } : b = {
    role: "button",
    href: n === "a" && !r ? f : void 0,
    target: n === "a" ? h : void 0,
    type: n === "input" ? p : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? m : void 0
  };
  let { pressProps: y, isPressed: $ } = Xe({
    onPressStart: l,
    onPressEnd: i,
    onPressChange: o,
    onPress: a,
    onPressUp: u,
    onClick: c,
    isDisabled: r,
    preventFocusOnPress: d,
    ref: t
  }), { focusableProps: v } = dt(e, t);
  s && (v.tabIndex = r ? -1 : v.tabIndex);
  let x = z(v, y, J(e, {
    labelable: !0
  }));
  return {
    isPressed: $,
    buttonProps: z(b, x, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      "aria-current": e["aria-current"],
      "aria-disabled": e["aria-disabled"]
    })
  };
}
const Ze = /* @__PURE__ */ G({}), ZC = /* @__PURE__ */ $n(function(t, n) {
  [t, n] = oe(t, n, Ze);
  let r = t, { isPending: a } = r, { buttonProps: l, isPressed: i } = Lf(t, n);
  l = F2(l, a);
  let { focusProps: u, isFocused: o, isFocusVisible: d } = ye(t), { hoverProps: s, isHovered: c } = ve({
    ...t,
    isDisabled: t.isDisabled || a
  }), f = {
    isHovered: c,
    isPressed: (r.isPressed || i) && !a,
    isFocused: o,
    isFocusVisible: d,
    isDisabled: t.isDisabled || !1,
    isPending: a ?? !1
  }, h = le({
    ...t,
    values: f,
    defaultClassName: "react-aria-Button"
  }), m = ce(l.id), p = ce(), b = l["aria-labelledby"];
  a && (b ? b = `${b} ${p}` : l["aria-label"] && (b = `${m} ${p}`));
  let y = T(a);
  ee(() => {
    let v = {
      "aria-labelledby": b || m
    };
    (!y.current && o && a || y.current && o && !a) && bn(v, "assertive"), y.current = a;
  }, [
    a,
    o,
    b,
    m
  ]);
  let $ = J(t, {
    global: !0
  });
  return delete $.onClick, /* @__PURE__ */ g.createElement(Q.button, {
    ...z($, h, l, u, s),
    // When the button is in a pending state, we want to stop implicit form submission (ie. when the user presses enter on a text input).
    // We do this by changing the button's type to button.
    type: l.type === "submit" && a ? "button" : l.type,
    id: m,
    ref: n,
    "aria-labelledby": b,
    slot: t.slot || void 0,
    "aria-disabled": a ? "true" : l["aria-disabled"],
    "data-disabled": t.isDisabled || void 0,
    "data-pressed": f.isPressed || void 0,
    "data-hovered": c || void 0,
    "data-focused": o || void 0,
    "data-pending": a || void 0,
    "data-focus-visible": d || void 0
  }, /* @__PURE__ */ g.createElement(Nf.Provider, {
    value: {
      id: p
    }
  }, h.children));
}), B2 = /Focus|Blur|Hover|Pointer(Enter|Leave|Over|Out)|Mouse(Enter|Leave|Over|Out)/;
function F2(e, t) {
  if (t) {
    for (const n in e) n.startsWith("on") && !B2.test(n) && (e[n] = void 0);
    e.href = void 0, e.target = void 0;
  }
  return e;
}
const wu = /* @__PURE__ */ G({}), XC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, wu);
  let { children: r, level: a = 3, className: l, ...i } = t, u = Q[`h${a}`];
  return /* @__PURE__ */ g.createElement(u, {
    ...i,
    ref: n,
    className: l ?? "react-aria-Heading"
  }, r);
}), _e = /* @__PURE__ */ G({}), A2 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, _e);
  let { elementType: r = "span", ...a } = t, l = Q[r];
  return /* @__PURE__ */ g.createElement(l, {
    className: "react-aria-Text",
    ...a,
    ref: n
  });
});
var zf = {};
zf = {
  dateRange: (e) => `${e.startDate} إلى ${e.endDate}`,
  dateSelected: (e) => `${e.date} المحدد`,
  finishRangeSelectionPrompt: "انقر لإنهاء عملية تحديد نطاق التاريخ",
  maximumDate: "آخر تاريخ متاح",
  minimumDate: "أول تاريخ متاح",
  next: "التالي",
  previous: "السابق",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.dateRange}`,
  startRangeSelectionPrompt: "انقر لبدء عملية تحديد نطاق التاريخ",
  todayDate: (e) => `اليوم، ${e.date}`,
  todayDateSelected: (e) => `اليوم، ${e.date} محدد`
};
var Of = {};
Of = {
  dateRange: (e) => `${e.startDate} до ${e.endDate}`,
  dateSelected: (e) => `Избрано е ${e.date}`,
  finishRangeSelectionPrompt: "Натиснете, за да довършите избора на времеви интервал",
  maximumDate: "Последна налична дата",
  minimumDate: "Първа налична дата",
  next: "Напред",
  previous: "Назад",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натиснете, за да пристъпите към избора на времеви интервал",
  todayDate: (e) => `Днес, ${e.date}`,
  todayDateSelected: (e) => `Днес, ${e.date} са избрани`
};
var Hf = {};
Hf = {
  dateRange: (e) => `${e.startDate} až ${e.endDate}`,
  dateSelected: (e) => `Vybráno ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výběr rozsahu dat",
  maximumDate: "Poslední dostupné datum",
  minimumDate: "První dostupné datum",
  next: "Další",
  previous: "Předchozí",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím zahájíte výběr rozsahu dat",
  todayDate: (e) => `Dnes, ${e.date}`,
  todayDateSelected: (e) => `Dnes, vybráno ${e.date}`
};
var Uf = {};
Uf = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klik for at fuldføre valg af datoområde",
  maximumDate: "Sidste ledige dato",
  minimumDate: "Første ledige dato",
  next: "Næste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik for at starte valg af datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var jf = {};
jf = {
  dateRange: (e) => `${e.startDate} bis ${e.endDate}`,
  dateSelected: (e) => `${e.date} ausgewählt`,
  finishRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beenden",
  maximumDate: "Letztes verfügbares Datum",
  minimumDate: "Erstes verfügbares Datum",
  next: "Weiter",
  previous: "Zurück",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicken, um die Auswahl des Datumsbereichs zu beginnen",
  todayDate: (e) => `Heute, ${e.date}`,
  todayDateSelected: (e) => `Heute, ${e.date} ausgewählt`
};
var _f = {};
_f = {
  dateRange: (e) => `${e.startDate} έως ${e.endDate}`,
  dateSelected: (e) => `Επιλέχθηκε ${e.date}`,
  finishRangeSelectionPrompt: "Κάντε κλικ για να ολοκληρώσετε την επιλογή εύρους ημερομηνιών",
  maximumDate: "Τελευταία διαθέσιμη ημερομηνία",
  minimumDate: "Πρώτη διαθέσιμη ημερομηνία",
  next: "Επόμενο",
  previous: "Προηγούμενο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.dateRange}`,
  startRangeSelectionPrompt: "Κάντε κλικ για να ξεκινήσετε την επιλογή εύρους ημερομηνιών",
  todayDate: (e) => `Σήμερα, ${e.date}`,
  todayDateSelected: (e) => `Σήμερα, επιλέχτηκε ${e.date}`
};
var Wf = {};
Wf = {
  previous: "Previous",
  next: "Next",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.dateRange}`,
  todayDate: (e) => `Today, ${e.date}`,
  todayDateSelected: (e) => `Today, ${e.date} selected`,
  dateSelected: (e) => `${e.date} selected`,
  startRangeSelectionPrompt: "Click to start selecting date range",
  finishRangeSelectionPrompt: "Click to finish selecting date range",
  minimumDate: "First available date",
  maximumDate: "Last available date",
  dateRange: (e) => `${e.startDate} to ${e.endDate}`
};
var Gf = {};
Gf = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} seleccionado`,
  finishRangeSelectionPrompt: "Haga clic para terminar de seleccionar rango de fechas",
  maximumDate: "Última fecha disponible",
  minimumDate: "Primera fecha disponible",
  next: "Siguiente",
  previous: "Anterior",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo seleccionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Haga clic para comenzar a seleccionar un rango de fechas",
  todayDate: (e) => `Hoy, ${e.date}`,
  todayDateSelected: (e) => `Hoy, ${e.date} seleccionado`
};
var qf = {};
qf = {
  dateRange: (e) => `${e.startDate} kuni ${e.endDate}`,
  dateSelected: (e) => `${e.date} valitud`,
  finishRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimise lõpetamiseks",
  maximumDate: "Viimane saadaolev kuupäev",
  minimumDate: "Esimene saadaolev kuupäev",
  next: "Järgmine",
  previous: "Eelmine",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klõpsake kuupäevavahemiku valimiseks",
  todayDate: (e) => `Täna, ${e.date}`,
  todayDateSelected: (e) => `Täna, ${e.date} valitud`
};
var Yf = {};
Yf = {
  dateRange: (e) => `${e.startDate} – ${e.endDate}`,
  dateSelected: (e) => `${e.date} valittu`,
  finishRangeSelectionPrompt: "Lopeta päivämääräalueen valinta napsauttamalla tätä.",
  maximumDate: "Viimeinen varattavissa oleva päivämäärä",
  minimumDate: "Ensimmäinen varattavissa oleva päivämäärä",
  next: "Seuraava",
  previous: "Edellinen",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.dateRange}`,
  startRangeSelectionPrompt: "Aloita päivämääräalueen valinta napsauttamalla tätä.",
  todayDate: (e) => `Tänään, ${e.date}`,
  todayDateSelected: (e) => `Tänään, ${e.date} valittu`
};
var Zf = {};
Zf = {
  dateRange: (e) => `${e.startDate} à ${e.endDate}`,
  dateSelected: (e) => `${e.date} sélectionné`,
  finishRangeSelectionPrompt: "Cliquer pour finir de sélectionner la plage de dates",
  maximumDate: "Dernière date disponible",
  minimumDate: "Première date disponible",
  next: "Suivant",
  previous: "Précédent",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.dateRange}`,
  startRangeSelectionPrompt: "Cliquer pour commencer à sélectionner la plage de dates",
  todayDate: (e) => `Aujourd'hui, ${e.date}`,
  todayDateSelected: (e) => `Aujourd’hui, ${e.date} sélectionné`
};
var Xf = {};
Xf = {
  dateRange: (e) => `${e.startDate} עד ${e.endDate}`,
  dateSelected: (e) => `${e.date} נבחר`,
  finishRangeSelectionPrompt: "חץ כדי לסיים את בחירת טווח התאריכים",
  maximumDate: "תאריך פנוי אחרון",
  minimumDate: "תאריך פנוי ראשון",
  next: "הבא",
  previous: "הקודם",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.dateRange}`,
  startRangeSelectionPrompt: "לחץ כדי להתחיל בבחירת טווח התאריכים",
  todayDate: (e) => `היום, ${e.date}`,
  todayDateSelected: (e) => `היום, ${e.date} נבחר`
};
var Jf = {};
Jf = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} odabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite raspon odabranih datuma",
  maximumDate: "Posljednji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sljedeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete raspon odabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, odabran ${e.date}`
};
var Qf = {};
Qf = {
  dateRange: (e) => `${e.startDate}–${e.endDate}`,
  dateSelected: (e) => `${e.date} kiválasztva`,
  finishRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének befejezéséhez",
  maximumDate: "Utolsó elérhető dátum",
  minimumDate: "Az első elérhető dátum",
  next: "Következő",
  previous: "Előző",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kattintson a dátumtartomány kijelölésének indításához",
  todayDate: (e) => `Ma, ${e.date}`,
  todayDateSelected: (e) => `Ma, ${e.date} kijelölve`
};
var e4 = {};
e4 = {
  dateRange: (e) => `Da ${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selezionata`,
  finishRangeSelectionPrompt: "Fai clic per completare la selezione dell’intervallo di date",
  maximumDate: "Ultima data disponibile",
  minimumDate: "Prima data disponibile",
  next: "Successivo",
  previous: "Precedente",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: ${e.dateRange}`,
  startRangeSelectionPrompt: "Fai clic per selezionare l’intervallo di date",
  todayDate: (e) => `Oggi, ${e.date}`,
  todayDateSelected: (e) => `Oggi, ${e.date} selezionata`
};
var t4 = {};
t4 = {
  dateRange: (e) => `${e.startDate} から ${e.endDate}`,
  dateSelected: (e) => `${e.date} を選択`,
  finishRangeSelectionPrompt: "クリックして日付範囲の選択を終了",
  maximumDate: "最終利用可能日",
  minimumDate: "最初の利用可能日",
  next: "次へ",
  previous: "前へ",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.dateRange}`,
  startRangeSelectionPrompt: "クリックして日付範囲の選択を開始",
  todayDate: (e) => `本日、${e.date}`,
  todayDateSelected: (e) => `本日、${e.date} を選択`
};
var n4 = {};
n4 = {
  dateRange: (e) => `${e.startDate} ~ ${e.endDate}`,
  dateSelected: (e) => `${e.date} 선택됨`,
  finishRangeSelectionPrompt: "날짜 범위 선택을 완료하려면 클릭하십시오.",
  maximumDate: "마지막으로 사용 가능한 일자",
  minimumDate: "처음으로 사용 가능한 일자",
  next: "다음",
  previous: "이전",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.dateRange}`,
  startRangeSelectionPrompt: "날짜 범위 선택을 시작하려면 클릭하십시오.",
  todayDate: (e) => `오늘, ${e.date}`,
  todayDateSelected: (e) => `오늘, ${e.date} 선택됨`
};
var r4 = {};
r4 = {
  dateRange: (e) => `Nuo ${e.startDate} iki ${e.endDate}`,
  dateSelected: (e) => `Pasirinkta ${e.date}`,
  finishRangeSelectionPrompt: "Spustelėkite, kad baigtumėte pasirinkti datų intervalą",
  maximumDate: "Paskutinė galima data",
  minimumDate: "Pirmoji galima data",
  next: "Paskesnis",
  previous: "Ankstesnis",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: ${e.dateRange}`,
  startRangeSelectionPrompt: "Spustelėkite, kad pradėtumėte pasirinkti datų intervalą",
  todayDate: (e) => `Šiandien, ${e.date}`,
  todayDateSelected: (e) => `Šiandien, pasirinkta ${e.date}`
};
var a4 = {};
a4 = {
  dateRange: (e) => `No ${e.startDate} līdz ${e.endDate}`,
  dateSelected: (e) => `Atlasīts: ${e.date}`,
  finishRangeSelectionPrompt: "Noklikšķiniet, lai pabeigtu datumu diapazona atlasi",
  maximumDate: "Pēdējais pieejamais datums",
  minimumDate: "Pirmais pieejamais datums",
  next: "Tālāk",
  previous: "Atpakaļ",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: ${e.dateRange}`,
  startRangeSelectionPrompt: "Noklikšķiniet, lai sāktu datumu diapazona atlasi",
  todayDate: (e) => `Šodien, ${e.date}`,
  todayDateSelected: (e) => `Atlasīta šodiena, ${e.date}`
};
var l4 = {};
l4 = {
  dateRange: (e) => `${e.startDate} til ${e.endDate}`,
  dateSelected: (e) => `${e.date} valgt`,
  finishRangeSelectionPrompt: "Klikk for å fullføre valg av datoområde",
  maximumDate: "Siste tilgjengelige dato",
  minimumDate: "Første tilgjengelige dato",
  next: "Neste",
  previous: "Forrige",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klikk for å starte valg av datoområde",
  todayDate: (e) => `I dag, ${e.date}`,
  todayDateSelected: (e) => `I dag, ${e.date} valgt`
};
var i4 = {};
i4 = {
  dateRange: (e) => `${e.startDate} tot ${e.endDate}`,
  dateSelected: (e) => `${e.date} geselecteerd`,
  finishRangeSelectionPrompt: "Klik om de selectie van het datumbereik te voltooien",
  maximumDate: "Laatste beschikbare datum",
  minimumDate: "Eerste beschikbare datum",
  next: "Volgende",
  previous: "Vorige",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klik om het datumbereik te selecteren",
  todayDate: (e) => `Vandaag, ${e.date}`,
  todayDateSelected: (e) => `Vandaag, ${e.date} geselecteerd`
};
var u4 = {};
u4 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Wybrano ${e.date}`,
  finishRangeSelectionPrompt: "Kliknij, aby zakończyć wybór zakresu dat",
  maximumDate: "Ostatnia dostępna data",
  minimumDate: "Pierwsza dostępna data",
  next: "Dalej",
  previous: "Wstecz",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknij, aby rozpocząć wybór zakresu dat",
  todayDate: (e) => `Dzisiaj, ${e.date}`,
  todayDateSelected: (e) => `Dzisiaj wybrano ${e.date}`
};
var o4 = {};
o4 = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para concluir a seleção do intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para iniciar a seleção do intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var s4 = {};
s4 = {
  dateRange: (e) => `${e.startDate} a ${e.endDate}`,
  dateSelected: (e) => `${e.date} selecionado`,
  finishRangeSelectionPrompt: "Clique para terminar de selecionar o intervalo de datas",
  maximumDate: "Última data disponível",
  minimumDate: "Primeira data disponível",
  next: "Próximo",
  previous: "Anterior",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.dateRange}`,
  startRangeSelectionPrompt: "Clique para começar a selecionar o intervalo de datas",
  todayDate: (e) => `Hoje, ${e.date}`,
  todayDateSelected: (e) => `Hoje, ${e.date} selecionado`
};
var d4 = {};
d4 = {
  dateRange: (e) => `De la ${e.startDate} până la ${e.endDate}`,
  dateSelected: (e) => `${e.date} selectată`,
  finishRangeSelectionPrompt: "Apăsaţi pentru a finaliza selecţia razei pentru dată",
  maximumDate: "Ultima dată disponibilă",
  minimumDate: "Prima dată disponibilă",
  next: "Următorul",
  previous: "Înainte",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: ${e.dateRange}`,
  startRangeSelectionPrompt: "Apăsaţi pentru a începe selecţia razei pentru dată",
  todayDate: (e) => `Astăzi, ${e.date}`,
  todayDateSelected: (e) => `Azi, ${e.date} selectată`
};
var c4 = {};
c4 = {
  dateRange: (e) => `С ${e.startDate} по ${e.endDate}`,
  dateSelected: (e) => `Выбрано ${e.date}`,
  finishRangeSelectionPrompt: "Щелкните, чтобы завершить выбор диапазона дат",
  maximumDate: "Последняя доступная дата",
  minimumDate: "Первая доступная дата",
  next: "Далее",
  previous: "Назад",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Щелкните, чтобы начать выбор диапазона дат",
  todayDate: (e) => `Сегодня, ${e.date}`,
  todayDateSelected: (e) => `Сегодня, выбрано ${e.date}`
};
var f4 = {};
f4 = {
  dateRange: (e) => `Od ${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `Vybratý dátum ${e.date}`,
  finishRangeSelectionPrompt: "Kliknutím dokončíte výber rozsahu dátumov",
  maximumDate: "Posledný dostupný dátum",
  minimumDate: "Prvý dostupný dátum",
  next: "Nasledujúce",
  previous: "Predchádzajúce",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknutím spustíte výber rozsahu dátumov",
  todayDate: (e) => `Dnes ${e.date}`,
  todayDateSelected: (e) => `Vybratý dnešný dátum ${e.date}`
};
var h4 = {};
h4 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izbrano`,
  finishRangeSelectionPrompt: "Kliknite za dokončanje izbire datumskega obsega",
  maximumDate: "Zadnji razpoložljivi datum",
  minimumDate: "Prvi razpoložljivi datum",
  next: "Naprej",
  previous: "Nazaj",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite za začetek izbire datumskega obsega",
  todayDate: (e) => `Danes, ${e.date}`,
  todayDateSelected: (e) => `Danes, ${e.date} izbrano`
};
var m4 = {};
m4 = {
  dateRange: (e) => `${e.startDate} do ${e.endDate}`,
  dateSelected: (e) => `${e.date} izabran`,
  finishRangeSelectionPrompt: "Kliknite da dovršite opseg izabranih datuma",
  maximumDate: "Zadnji raspoloživi datum",
  minimumDate: "Prvi raspoloživi datum",
  next: "Sledeći",
  previous: "Prethodni",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani period: ${e.dateRange}`,
  startRangeSelectionPrompt: "Kliknite da započnete opseg izabranih datuma",
  todayDate: (e) => `Danas, ${e.date}`,
  todayDateSelected: (e) => `Danas, izabran ${e.date}`
};
var p4 = {};
p4 = {
  dateRange: (e) => `${e.startDate} till ${e.endDate}`,
  dateSelected: (e) => `${e.date} har valts`,
  finishRangeSelectionPrompt: "Klicka för att avsluta val av datumintervall",
  maximumDate: "Sista tillgängliga datum",
  minimumDate: "Första tillgängliga datum",
  next: "Nästa",
  previous: "Föregående",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.dateRange}`,
  startRangeSelectionPrompt: "Klicka för att välja datumintervall",
  todayDate: (e) => `Idag, ${e.date}`,
  todayDateSelected: (e) => `Idag, ${e.date} har valts`
};
var b4 = {};
b4 = {
  dateRange: (e) => `${e.startDate} - ${e.endDate}`,
  dateSelected: (e) => `${e.date} seçildi`,
  finishRangeSelectionPrompt: "Tarih aralığı seçimini tamamlamak için tıklayın",
  maximumDate: "Son müsait tarih",
  minimumDate: "İlk müsait tarih",
  next: "Sonraki",
  previous: "Önceki",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.dateRange}`,
  startRangeSelectionPrompt: "Tarih aralığı seçimini başlatmak için tıklayın",
  todayDate: (e) => `Bugün, ${e.date}`,
  todayDateSelected: (e) => `Bugün, ${e.date} seçildi`
};
var g4 = {};
g4 = {
  dateRange: (e) => `${e.startDate} — ${e.endDate}`,
  dateSelected: (e) => `Вибрано ${e.date}`,
  finishRangeSelectionPrompt: "Натисніть, щоб завершити вибір діапазону дат",
  maximumDate: "Остання доступна дата",
  minimumDate: "Перша доступна дата",
  next: "Наступний",
  previous: "Попередній",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.dateRange}`,
  startRangeSelectionPrompt: "Натисніть, щоб почати вибір діапазону дат",
  todayDate: (e) => `Сьогодні, ${e.date}`,
  todayDateSelected: (e) => `Сьогодні, вибрано ${e.date}`
};
var y4 = {};
y4 = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已选择 ${e.date}`,
  finishRangeSelectionPrompt: "单击以完成选择日期范围",
  maximumDate: "最后一个可用日期",
  minimumDate: "第一个可用日期",
  next: "下一页",
  previous: "上一页",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.dateRange}`,
  startRangeSelectionPrompt: "单击以开始选择日期范围",
  todayDate: (e) => `今天，即 ${e.date}`,
  todayDateSelected: (e) => `已选择今天，即 ${e.date}`
};
var $4 = {};
$4 = {
  dateRange: (e) => `${e.startDate} 至 ${e.endDate}`,
  dateSelected: (e) => `已選取 ${e.date}`,
  finishRangeSelectionPrompt: "按一下以完成選取日期範圍",
  maximumDate: "最後一個可用日期",
  minimumDate: "第一個可用日期",
  next: "下一頁",
  previous: "上一頁",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.dateRange}`,
  startRangeSelectionPrompt: "按一下以開始選取日期範圍",
  todayDate: (e) => `今天，${e.date}`,
  todayDateSelected: (e) => `已選取今天，${e.date}`
};
var pa = {};
pa = {
  "ar-AE": zf,
  "bg-BG": Of,
  "cs-CZ": Hf,
  "da-DK": Uf,
  "de-DE": jf,
  "el-GR": _f,
  "en-US": Wf,
  "es-ES": Gf,
  "et-EE": qf,
  "fi-FI": Yf,
  "fr-FR": Zf,
  "he-IL": Xf,
  "hr-HR": Jf,
  "hu-HU": Qf,
  "it-IT": e4,
  "ja-JP": t4,
  "ko-KR": n4,
  "lt-LT": r4,
  "lv-LV": a4,
  "nb-NO": l4,
  "nl-NL": i4,
  "pl-PL": u4,
  "pt-BR": o4,
  "pt-PT": s4,
  "ro-RO": d4,
  "ru-RU": c4,
  "sk-SK": f4,
  "sl-SI": h4,
  "sr-SP": m4,
  "sv-SE": p4,
  "tr-TR": b4,
  "uk-UA": g4,
  "zh-CN": y4,
  "zh-TW": $4
};
function v4(e, t) {
  let n = T(null);
  return e && n.current && t(e, n.current) && (e = n.current), n.current = e, e;
}
function sr(e, t) {
  return e - t * Math.floor(e / t);
}
const D4 = 1721426;
function Rn(e, t, n, r) {
  t = ba(e, t);
  let a = t - 1, l = -2;
  return n <= 2 ? l = 0 : fn(t) && (l = -1), D4 - 1 + 365 * a + Math.floor(a / 4) - Math.floor(a / 100) + Math.floor(a / 400) + Math.floor((367 * n - 362) / 12 + l + r);
}
function fn(e) {
  return e % 4 === 0 && (e % 100 !== 0 || e % 400 === 0);
}
function ba(e, t) {
  return e === "BC" ? 1 - t : t;
}
function vl(e) {
  let t = "AD";
  return e <= 0 && (t = "BC", e = 1 - e), [
    t,
    e
  ];
}
const R2 = {
  standard: [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ],
  leapyear: [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ]
};
class je {
  fromJulianDay(t) {
    let n = t, r = n - D4, a = Math.floor(r / 146097), l = sr(r, 146097), i = Math.floor(l / 36524), u = sr(l, 36524), o = Math.floor(u / 1461), d = sr(u, 1461), s = Math.floor(d / 365), c = a * 400 + i * 100 + o * 4 + s + (i !== 4 && s !== 4 ? 1 : 0), [f, h] = vl(c), m = n - Rn(f, h, 1, 1), p = 2;
    n < Rn(f, h, 3, 1) ? p = 0 : fn(h) && (p = 1);
    let b = Math.floor(((m + p) * 12 + 373) / 367), y = n - Rn(f, h, b, 1) + 1;
    return new Re(f, h, b, y);
  }
  toJulianDay(t) {
    return Rn(t.era, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    return R2[fn(t.year) ? "leapyear" : "standard"][t.month - 1];
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getMonthsInYear(t) {
    return 12;
  }
  getDaysInYear(t) {
    return fn(t.year) ? 366 : 365;
  }
  getMaximumMonthsInYear() {
    return 12;
  }
  getMaximumDaysInMonth() {
    return 31;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getYearsInEra(t) {
    return 9999;
  }
  getEras() {
    return [
      "BC",
      "AD"
    ];
  }
  isInverseEra(t) {
    return t.era === "BC";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BC" ? "AD" : "BC", t.year = 1 - t.year);
  }
  constructor() {
    this.identifier = "gregory";
  }
}
const T2 = {
  "001": 1,
  AD: 1,
  AE: 6,
  AF: 6,
  AI: 1,
  AL: 1,
  AM: 1,
  AN: 1,
  AR: 1,
  AT: 1,
  AU: 1,
  AX: 1,
  AZ: 1,
  BA: 1,
  BE: 1,
  BG: 1,
  BH: 6,
  BM: 1,
  BN: 1,
  BY: 1,
  CH: 1,
  CL: 1,
  CM: 1,
  CN: 1,
  CR: 1,
  CY: 1,
  CZ: 1,
  DE: 1,
  DJ: 6,
  DK: 1,
  DZ: 6,
  EC: 1,
  EE: 1,
  EG: 6,
  ES: 1,
  FI: 1,
  FJ: 1,
  FO: 1,
  FR: 1,
  GB: 1,
  GE: 1,
  GF: 1,
  GP: 1,
  GR: 1,
  HR: 1,
  HU: 1,
  IE: 1,
  IQ: 6,
  IR: 6,
  IS: 1,
  IT: 1,
  JO: 6,
  KG: 1,
  KW: 6,
  KZ: 1,
  LB: 1,
  LI: 1,
  LK: 1,
  LT: 1,
  LU: 1,
  LV: 1,
  LY: 6,
  MC: 1,
  MD: 1,
  ME: 1,
  MK: 1,
  MN: 1,
  MQ: 1,
  MV: 5,
  MY: 1,
  NL: 1,
  NO: 1,
  NZ: 1,
  OM: 6,
  PL: 1,
  QA: 6,
  RE: 1,
  RO: 1,
  RS: 1,
  RU: 1,
  SD: 6,
  SE: 1,
  SI: 1,
  SK: 1,
  SM: 1,
  SY: 6,
  TJ: 1,
  TM: 1,
  TR: 1,
  UA: 1,
  UY: 1,
  UZ: 1,
  VA: 1,
  VN: 1,
  XK: 1
};
function Be(e, t) {
  return t = Se(t, e.calendar), e.era === t.era && e.year === t.year && e.month === t.month && e.day === t.day;
}
function I2(e, t) {
  return t = Se(t, e.calendar), e = Vn(e), t = Vn(t), e.era === t.era && e.year === t.year && e.month === t.month;
}
function M2(e, t) {
  return Dl(e.calendar, t.calendar) && Be(e, t);
}
function Dl(e, t) {
  return e.isEqual?.(t) ?? t.isEqual?.(e) ?? e.identifier === t.identifier;
}
function x4(e, t) {
  return Be(e, ku(t));
}
const K2 = {
  sun: 0,
  mon: 1,
  tue: 2,
  wed: 3,
  thu: 4,
  fri: 5,
  sat: 6
};
function Su(e, t, n) {
  let r = e.calendar.toJulianDay(e), a = n ? K2[n] : O2(t), l = Math.ceil(r + 1 - a) % 7;
  return l < 0 && (l += 7), l;
}
function E4(e) {
  return _t(Date.now(), e);
}
function ku(e) {
  return lt(E4(e));
}
function C4(e, t) {
  return e.calendar.toJulianDay(e) - t.calendar.toJulianDay(t);
}
function P4(e, t) {
  return ps(e) - ps(t);
}
function ps(e) {
  return e.hour * 36e5 + e.minute * 6e4 + e.second * 1e3 + e.millisecond;
}
let _l = null, N2 = !1;
function xl() {
  return _l == null && (_l = new Intl.DateTimeFormat().resolvedOptions().timeZone), _l;
}
function w4() {
  return N2;
}
function Vn(e) {
  return e.subtract({
    days: e.day - 1
  });
}
function el(e) {
  return e.add({
    days: e.calendar.getDaysInMonth(e) - e.day
  });
}
function V2(e) {
  return Vn(e.subtract({
    months: e.month - 1
  }));
}
function Jr(e, t, n) {
  let r = Su(e, t, n);
  return e.subtract({
    days: r
  });
}
function L2(e, t, n) {
  return Jr(e, t, n).add({
    days: 6
  });
}
const bs = /* @__PURE__ */ new Map(), Wl = /* @__PURE__ */ new Map();
function z2(e) {
  if (Intl.Locale) {
    let n = bs.get(e);
    return n || (n = new Intl.Locale(e).maximize().region, n && bs.set(e, n)), n;
  }
  let t = e.split("-")[1];
  return t === "u" ? void 0 : t;
}
function O2(e) {
  let t = Wl.get(e);
  if (!t) {
    if (Intl.Locale) {
      let r = new Intl.Locale(e);
      if ("getWeekInfo" in r && (t = r.getWeekInfo(), t))
        return Wl.set(e, t), t.firstDay;
    }
    let n = z2(e);
    if (e.includes("-fw-")) {
      let r = e.split("-fw-")[1].split("-")[0];
      r === "mon" ? t = {
        firstDay: 1
      } : r === "tue" ? t = {
        firstDay: 2
      } : r === "wed" ? t = {
        firstDay: 3
      } : r === "thu" ? t = {
        firstDay: 4
      } : r === "fri" ? t = {
        firstDay: 5
      } : r === "sat" ? t = {
        firstDay: 6
      } : t = {
        firstDay: 0
      };
    } else e.includes("-ca-iso8601") ? t = {
      firstDay: 1
    } : t = {
      firstDay: n && T2[n] || 0
    };
    Wl.set(e, t);
  }
  return t.firstDay;
}
function H2(e, t, n) {
  let r = e.calendar.getDaysInMonth(e);
  return Math.ceil((Su(Vn(e), t, n) + r) / 7);
}
function S4(e, t) {
  return e && t ? e.compare(t) <= 0 ? e : t : e || t;
}
function k4(e, t) {
  return e && t ? e.compare(t) >= 0 ? e : t : e || t;
}
function pr(e) {
  e = Se(e, new je());
  let t = ba(e.era, e.year);
  return B4(t, e.month, e.day, e.hour, e.minute, e.second, e.millisecond);
}
function B4(e, t, n, r, a, l, i) {
  let u = /* @__PURE__ */ new Date();
  return u.setUTCHours(r, a, l, i), u.setUTCFullYear(e, t - 1, n), u.getTime();
}
function Ti(e, t) {
  if (t === "UTC") return 0;
  if (e > 0 && t === xl() && !w4()) return new Date(e).getTimezoneOffset() * -6e4;
  let { year: n, month: r, day: a, hour: l, minute: i, second: u } = F4(e, t);
  return B4(n, r, a, l, i, u, 0) - Math.floor(e / 1e3) * 1e3;
}
const gs = /* @__PURE__ */ new Map();
function F4(e, t) {
  let n = gs.get(t);
  n || (n = new Intl.DateTimeFormat("en-US", {
    timeZone: t,
    hour12: !1,
    era: "short",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric"
  }), gs.set(t, n));
  let r = n.formatToParts(new Date(e)), a = {};
  for (let l of r) l.type !== "literal" && (a[l.type] = l.value);
  return {
    // Firefox returns B instead of BC... https://bugzilla.mozilla.org/show_bug.cgi?id=1752253
    year: a.era === "BC" || a.era === "B" ? -a.year + 1 : +a.year,
    month: +a.month,
    day: +a.day,
    hour: a.hour === "24" ? 0 : +a.hour,
    minute: +a.minute,
    second: +a.second
  };
}
const ys = 864e5;
function U2(e, t, n, r) {
  return (n === r ? [
    n
  ] : [
    n,
    r
  ]).filter((l) => j2(e, t, l));
}
function j2(e, t, n) {
  let r = F4(n, t);
  return e.year === r.year && e.month === r.month && e.day === r.day && e.hour === r.hour && e.minute === r.minute && e.second === r.second;
}
function Ut(e, t, n = "compatible") {
  let r = Zt(e);
  if (t === "UTC") return pr(r);
  if (t === xl() && n === "compatible" && !w4()) {
    r = Se(r, new je());
    let o = /* @__PURE__ */ new Date(), d = ba(r.era, r.year);
    return o.setFullYear(d, r.month - 1, r.day), o.setHours(r.hour, r.minute, r.second, r.millisecond), o.getTime();
  }
  let a = pr(r), l = Ti(a - ys, t), i = Ti(a + ys, t), u = U2(r, t, a - l, a - i);
  if (u.length === 1) return u[0];
  if (u.length > 1) switch (n) {
    // 'compatible' means 'earlier' for "fall back" transitions
    case "compatible":
    case "earlier":
      return u[0];
    case "later":
      return u[u.length - 1];
    case "reject":
      throw new RangeError("Multiple possible absolute times found");
  }
  switch (n) {
    case "earlier":
      return Math.min(a - l, a - i);
    // 'compatible' means 'later' for "spring forward" transitions
    case "compatible":
    case "later":
      return Math.max(a - l, a - i);
    case "reject":
      throw new RangeError("No such absolute time found");
  }
}
function A4(e, t, n = "compatible") {
  return new Date(Ut(e, t, n));
}
function _t(e, t) {
  let n = Ti(e, t), r = new Date(e + n), a = r.getUTCFullYear(), l = r.getUTCMonth() + 1, i = r.getUTCDate(), u = r.getUTCHours(), o = r.getUTCMinutes(), d = r.getUTCSeconds(), s = r.getUTCMilliseconds();
  return new ta(a < 1 ? "BC" : "AD", a < 1 ? -a + 1 : a, l, i, t, n, u, o, d, s);
}
function lt(e) {
  return new Re(e.calendar, e.era, e.year, e.month, e.day);
}
function Zt(e, t) {
  let n = 0, r = 0, a = 0, l = 0;
  if ("timeZone" in e) ({ hour: n, minute: r, second: a, millisecond: l } = e);
  else if ("hour" in e && !t) return e;
  return t && ({ hour: n, minute: r, second: a, millisecond: l } = t), new ea(e.calendar, e.era, e.year, e.month, e.day, n, r, a, l);
}
function Se(e, t) {
  if (Dl(e.calendar, t)) return e;
  let n = t.fromJulianDay(e.calendar.toJulianDay(e)), r = e.copy();
  return r.calendar = t, r.era = n.era, r.year = n.year, r.month = n.month, r.day = n.day, Ln(r), r;
}
function _2(e, t, n) {
  if (e instanceof ta)
    return e.timeZone === t ? e : R4(e, t);
  let r = Ut(e, t, n);
  return _t(r, t);
}
function W2(e) {
  let t = pr(e) - e.offset;
  return new Date(t);
}
function R4(e, t) {
  let n = pr(e) - e.offset;
  return Se(_t(n, t), e.calendar);
}
function G2(e) {
  return R4(e, xl());
}
const Mr = 36e5;
function El(e, t) {
  let n = e.copy(), r = "hour" in n ? K4(n, t) : 0;
  Ii(n, t.years || 0), n.calendar.balanceYearMonth && n.calendar.balanceYearMonth(n, e), n.month += t.months || 0, Mi(n), T4(n), n.day += (t.weeks || 0) * 7, n.day += t.days || 0, n.day += r, q2(n), n.calendar.balanceDate && n.calendar.balanceDate(n), n.year < 1 && (n.year = 1, n.month = 1, n.day = 1);
  let a = n.calendar.getYearsInEra(n);
  if (n.year > a) {
    let i = n.calendar.isInverseEra?.(n);
    n.year = a, n.month = i ? 1 : n.calendar.getMonthsInYear(n), n.day = i ? 1 : n.calendar.getDaysInMonth(n);
  }
  n.month < 1 && (n.month = 1, n.day = 1);
  let l = n.calendar.getMonthsInYear(n);
  return n.month > l && (n.month = l, n.day = n.calendar.getDaysInMonth(n)), n.day = Math.max(1, Math.min(n.calendar.getDaysInMonth(n), n.day)), n;
}
function Ii(e, t) {
  e.calendar.isInverseEra?.(e) && (t = -t), e.year += t;
}
function Mi(e) {
  for (; e.month < 1; )
    Ii(e, -1), e.month += e.calendar.getMonthsInYear(e);
  let t = 0;
  for (; e.month > (t = e.calendar.getMonthsInYear(e)); )
    e.month -= t, Ii(e, 1);
}
function q2(e) {
  for (; e.day < 1; )
    e.month--, Mi(e), e.day += e.calendar.getDaysInMonth(e);
  for (; e.day > e.calendar.getDaysInMonth(e); )
    e.day -= e.calendar.getDaysInMonth(e), e.month++, Mi(e);
}
function T4(e) {
  e.month = Math.max(1, Math.min(e.calendar.getMonthsInYear(e), e.month)), e.day = Math.max(1, Math.min(e.calendar.getDaysInMonth(e), e.day));
}
function Ln(e) {
  e.calendar.constrainDate && e.calendar.constrainDate(e), e.year = Math.max(1, Math.min(e.calendar.getYearsInEra(e), e.year)), T4(e);
}
function Bu(e) {
  let t = {};
  for (let n in e) typeof e[n] == "number" && (t[n] = -e[n]);
  return t;
}
function I4(e, t) {
  return El(e, Bu(t));
}
function Fu(e, t) {
  let n = e.copy();
  return t.era != null && (n.era = t.era), t.year != null && (n.year = t.year), t.month != null && (n.month = t.month), t.day != null && (n.day = t.day), Ln(n), n;
}
function Qr(e, t) {
  let n = e.copy();
  return t.hour != null && (n.hour = t.hour), t.minute != null && (n.minute = t.minute), t.second != null && (n.second = t.second), t.millisecond != null && (n.millisecond = t.millisecond), M4(n), n;
}
function Y2(e) {
  e.second += Math.floor(e.millisecond / 1e3), e.millisecond = ka(e.millisecond, 1e3), e.minute += Math.floor(e.second / 60), e.second = ka(e.second, 60), e.hour += Math.floor(e.minute / 60), e.minute = ka(e.minute, 60);
  let t = Math.floor(e.hour / 24);
  return e.hour = ka(e.hour, 24), t;
}
function M4(e) {
  e.millisecond = Math.max(0, Math.min(e.millisecond, 1e3)), e.second = Math.max(0, Math.min(e.second, 59)), e.minute = Math.max(0, Math.min(e.minute, 59)), e.hour = Math.max(0, Math.min(e.hour, 23));
}
function ka(e, t) {
  let n = e % t;
  return n < 0 && (n += t), n;
}
function K4(e, t) {
  return e.hour += t.hours || 0, e.minute += t.minutes || 0, e.second += t.seconds || 0, e.millisecond += t.milliseconds || 0, Y2(e);
}
function N4(e, t) {
  let n = e.copy();
  return K4(n, t), n;
}
function Z2(e, t) {
  return N4(e, Bu(t));
}
function Au(e, t, n, r) {
  let a = e.copy();
  switch (t) {
    case "era": {
      let l = e.calendar.getEras(), i = l.indexOf(e.era);
      if (i < 0) throw new Error("Invalid era: " + e.era);
      i = Wt(i, n, 0, l.length - 1, r?.round), a.era = l[i], Ln(a);
      break;
    }
    case "year":
      a.calendar.isInverseEra?.(a) && (n = -n), a.year = Wt(e.year, n, -1 / 0, 9999, r?.round), a.year === -1 / 0 && (a.year = 1), a.calendar.balanceYearMonth && a.calendar.balanceYearMonth(a, e);
      break;
    case "month":
      a.month = Wt(e.month, n, 1, e.calendar.getMonthsInYear(e), r?.round);
      break;
    case "day":
      a.day = Wt(e.day, n, 1, e.calendar.getDaysInMonth(e), r?.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return e.calendar.balanceDate && e.calendar.balanceDate(a), Ln(a), a;
}
function Ru(e, t, n, r) {
  let a = e.copy();
  switch (t) {
    case "hour": {
      let l = e.hour, i = 0, u = 23;
      if (r?.hourCycle === 12) {
        let o = l >= 12;
        i = o ? 12 : 0, u = o ? 23 : 11;
      }
      a.hour = Wt(l, n, i, u, r?.round);
      break;
    }
    case "minute":
      a.minute = Wt(e.minute, n, 0, 59, r?.round);
      break;
    case "second":
      a.second = Wt(e.second, n, 0, 59, r?.round);
      break;
    case "millisecond":
      a.millisecond = Wt(e.millisecond, n, 0, 999, r?.round);
      break;
    default:
      throw new Error("Unsupported field " + t);
  }
  return a;
}
function Wt(e, t, n, r, a = !1) {
  if (a) {
    e += Math.sign(t), e < n && (e = r);
    let l = Math.abs(t);
    t > 0 ? e = Math.ceil(e / l) * l : e = Math.floor(e / l) * l, e > r && (e = n);
  } else
    e += t, e < n ? e = r - (n - e - 1) : e > r && (e = n + (e - r - 1));
  return e;
}
function V4(e, t) {
  let n;
  if (t.years != null && t.years !== 0 || t.months != null && t.months !== 0 || t.weeks != null && t.weeks !== 0 || t.days != null && t.days !== 0) {
    let a = El(Zt(e), {
      years: t.years,
      months: t.months,
      weeks: t.weeks,
      days: t.days
    });
    n = Ut(a, e.timeZone);
  } else
    n = pr(e) - e.offset;
  n += t.milliseconds || 0, n += (t.seconds || 0) * 1e3, n += (t.minutes || 0) * 6e4, n += (t.hours || 0) * 36e5;
  let r = _t(n, e.timeZone);
  return Se(r, e.calendar);
}
function X2(e, t) {
  return V4(e, Bu(t));
}
function J2(e, t, n, r) {
  switch (t) {
    case "hour": {
      let a = 0, l = 23;
      if (r?.hourCycle === 12) {
        let m = e.hour >= 12;
        a = m ? 12 : 0, l = m ? 23 : 11;
      }
      let i = Zt(e), u = Se(Qr(i, {
        hour: a
      }), new je()), o = [
        Ut(u, e.timeZone, "earlier"),
        Ut(u, e.timeZone, "later")
      ].filter((m) => _t(m, e.timeZone).day === u.day)[0], d = Se(Qr(i, {
        hour: l
      }), new je()), s = [
        Ut(d, e.timeZone, "earlier"),
        Ut(d, e.timeZone, "later")
      ].filter((m) => _t(m, e.timeZone).day === d.day).pop(), c = pr(e) - e.offset, f = Math.floor(c / Mr), h = c % Mr;
      return c = Wt(f, n, Math.floor(o / Mr), Math.floor(s / Mr), r?.round) * Mr + h, Se(_t(c, e.timeZone), e.calendar);
    }
    case "minute":
    case "second":
    case "millisecond":
      return Ru(e, t, n, r);
    case "era":
    case "year":
    case "month":
    case "day": {
      let a = Au(Zt(e), t, n, r), l = Ut(a, e.timeZone);
      return Se(_t(l, e.timeZone), e.calendar);
    }
    default:
      throw new Error("Unsupported field " + t);
  }
}
function Q2(e, t, n) {
  let r = Zt(e), a = Qr(Fu(r, t), t);
  if (a.compare(r) === 0) return e;
  let l = Ut(a, e.timeZone, n);
  return Se(_t(l, e.timeZone), e.calendar);
}
const e6 = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})$/, t6 = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?$/, L4 = /^([+-]\d{6}|\d{4})-(\d{2})-(\d{2})(?:T(\d{2}))?(?::(\d{2}))?(?::(\d{2}))?(\.\d+)?(?:(?:([+-]\d{2})(?::?(\d{2}))?)|Z)$/;
function n6(e) {
  let t = e.match(e6);
  if (!t)
    throw L4.test(e) ? new Error(`Invalid ISO 8601 date string: ${e}. Use parseAbsolute() instead.`) : new Error("Invalid ISO 8601 date string: " + e);
  let n = new Re(Rt(t[1], 0, 9999), Rt(t[2], 1, 12), 1);
  return n.day = Rt(t[3], 1, n.calendar.getDaysInMonth(n)), n;
}
function r6(e) {
  let t = e.match(t6);
  if (!t)
    throw L4.test(e) ? new Error(`Invalid ISO 8601 date time string: ${e}. Use parseAbsolute() instead.`) : new Error("Invalid ISO 8601 date time string: " + e);
  let n = Rt(t[1], -9999, 9999), r = n < 1 ? "BC" : "AD", a = new ea(r, n < 1 ? -n + 1 : n, Rt(t[2], 1, 12), 1, t[4] ? Rt(t[4], 0, 23) : 0, t[5] ? Rt(t[5], 0, 59) : 0, t[6] ? Rt(t[6], 0, 59) : 0, t[7] ? Rt(t[7], 0, 1 / 0) * 1e3 : 0);
  return a.day = Rt(t[3], 0, a.calendar.getDaysInMonth(a)), a;
}
function Rt(e, t, n) {
  let r = Number(e);
  if (r < t || r > n) throw new RangeError(`Value out of range: ${t} <= ${r} <= ${n}`);
  return r;
}
function z4(e) {
  return `${String(e.hour).padStart(2, "0")}:${String(e.minute).padStart(2, "0")}:${String(e.second).padStart(2, "0")}${e.millisecond ? String(e.millisecond / 1e3).slice(1) : ""}`;
}
function O4(e) {
  let t = Se(e, new je()), n;
  return t.era === "BC" ? n = t.year === 1 ? "0000" : "-" + String(Math.abs(1 - t.year)).padStart(6, "00") : n = String(t.year).padStart(4, "0"), `${n}-${String(t.month).padStart(2, "0")}-${String(t.day).padStart(2, "0")}`;
}
function H4(e) {
  return `${O4(e)}T${z4(e)}`;
}
function a6(e) {
  let t = Math.sign(e) < 0 ? "-" : "+";
  e = Math.abs(e);
  let n = Math.floor(e / 36e5), r = Math.floor(e % 36e5 / 6e4), a = Math.floor(e % 36e5 % 6e4 / 1e3), l = `${t}${String(n).padStart(2, "0")}:${String(r).padStart(2, "0")}`;
  return a !== 0 && (l += `:${String(a).padStart(2, "0")}`), l;
}
function l6(e) {
  return `${H4(e)}${a6(e.offset)}[${e.timeZone}]`;
}
function Tu(e) {
  let t = typeof e[0] == "object" ? e.shift() : new je(), n;
  if (typeof e[0] == "string") n = e.shift();
  else {
    let i = t.getEras();
    n = i[i.length - 1];
  }
  let r = e.shift(), a = e.shift(), l = e.shift();
  return [
    t,
    n,
    r,
    a,
    l
  ];
}
class Re {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // i.e. a ZonedDateTime should not be be passable to a parameter that expects CalendarDate.
  // If that behavior is desired, use the AnyCalendarDate interface instead.
  // @ts-ignore
  #e;
  constructor(...t) {
    let [n, r, a, l, i] = Tu(t);
    this.calendar = n, this.era = r, this.year = a, this.month = l, this.day = i, Ln(this);
  }
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new Re(this.calendar, this.era, this.year, this.month, this.day) : new Re(this.calendar, this.year, this.month, this.day);
  }
  /** Returns a new `CalendarDate` with the given duration added to it. */
  add(t) {
    return El(this, t);
  }
  /** Returns a new `CalendarDate` with the given duration subtracted from it. */
  subtract(t) {
    return I4(this, t);
  }
  /**
  * Returns a new `CalendarDate` with the given fields set to the provided values. Other fields
  * will be constrained accordingly.
  */
  set(t) {
    return Fu(this, t);
  }
  /**
  * Returns a new `CalendarDate` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return Au(this, t, n, r);
  }
  /**
  * Converts the date to a native JavaScript Date object, with the time set to midnight in the
  * given time zone.
  */
  toDate(t) {
    return A4(this, t);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return O4(this);
  }
  /**
  * Compares this date with another. A negative result indicates that this date is before the given
  * one, and a positive date indicates that it is after.
  */
  compare(t) {
    return C4(this, t);
  }
}
class Iu {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // @ts-ignore
  #e;
  constructor(t = 0, n = 0, r = 0, a = 0) {
    this.hour = t, this.minute = n, this.second = r, this.millisecond = a, M4(this);
  }
  /** Returns a copy of this time. */
  copy() {
    return new Iu(this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `Time` with the given duration added to it. */
  add(t) {
    return N4(this, t);
  }
  /** Returns a new `Time` with the given duration subtracted from it. */
  subtract(t) {
    return Z2(this, t);
  }
  /**
  * Returns a new `Time` with the given fields set to the provided values. Other fields will be
  * constrained accordingly.
  */
  set(t) {
    return Qr(this, t);
  }
  /**
  * Returns a new `Time` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return Ru(this, t, n, r);
  }
  /** Converts the time to an ISO 8601 formatted string. */
  toString() {
    return z4(this);
  }
  /**
  * Compares this time with another. A negative result indicates that this time is before the given
  * one, and a positive time indicates that it is after.
  */
  compare(t) {
    return P4(this, t);
  }
}
class ea {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // @ts-ignore
  #e;
  constructor(...t) {
    let [n, r, a, l, i] = Tu(t);
    this.calendar = n, this.era = r, this.year = a, this.month = l, this.day = i, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, Ln(this);
  }
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new ea(this.calendar, this.era, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond) : new ea(this.calendar, this.year, this.month, this.day, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `CalendarDateTime` with the given duration added to it. */
  add(t) {
    return El(this, t);
  }
  /** Returns a new `CalendarDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return I4(this, t);
  }
  /**
  * Returns a new `CalendarDateTime` with the given fields set to the provided values. Other fields
  * will be constrained accordingly.
  */
  set(t) {
    return Fu(Qr(this, t), t);
  }
  /**
  * Returns a new `CalendarDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    switch (t) {
      case "era":
      case "year":
      case "month":
      case "day":
        return Au(this, t, n, r);
      default:
        return Ru(this, t, n, r);
    }
  }
  /** Converts the date to a native JavaScript Date object in the given time zone. */
  toDate(t, n) {
    return A4(this, t, n);
  }
  /** Converts the date to an ISO 8601 formatted string. */
  toString() {
    return H4(this);
  }
  /**
  * Compares this date with another. A negative result indicates that this date is before the given
  * one, and a positive date indicates that it is after.
  */
  compare(t) {
    let n = C4(this, t);
    return n === 0 ? P4(this, Zt(t)) : n;
  }
}
class ta {
  // This prevents TypeScript from allowing other types with the same fields to match.
  // @ts-ignore
  #e;
  constructor(...t) {
    let [n, r, a, l, i] = Tu(t), u = t.shift(), o = t.shift();
    this.calendar = n, this.era = r, this.year = a, this.month = l, this.day = i, this.timeZone = u, this.offset = o, this.hour = t.shift() || 0, this.minute = t.shift() || 0, this.second = t.shift() || 0, this.millisecond = t.shift() || 0, Ln(this);
  }
  /** Returns a copy of this date. */
  copy() {
    return this.era ? new ta(this.calendar, this.era, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond) : new ta(this.calendar, this.year, this.month, this.day, this.timeZone, this.offset, this.hour, this.minute, this.second, this.millisecond);
  }
  /** Returns a new `ZonedDateTime` with the given duration added to it. */
  add(t) {
    return V4(this, t);
  }
  /** Returns a new `ZonedDateTime` with the given duration subtracted from it. */
  subtract(t) {
    return X2(this, t);
  }
  /**
  * Returns a new `ZonedDateTime` with the given fields set to the provided values. Other fields
  * will be constrained accordingly.
  */
  set(t, n) {
    return Q2(this, t, n);
  }
  /**
  * Returns a new `ZonedDateTime` with the given field adjusted by a specified amount.
  * When the resulting value reaches the limits of the field, it wraps around.
  */
  cycle(t, n, r) {
    return J2(this, t, n, r);
  }
  /** Converts the date to a native JavaScript Date object. */
  toDate() {
    return W2(this);
  }
  /**
  * Converts the date to an ISO 8601 formatted string, including the UTC offset and time zone
  * identifier.
  */
  toString() {
    return l6(this);
  }
  /** Converts the date to an ISO 8601 formatted string in UTC. */
  toAbsoluteString() {
    return this.toDate().toISOString();
  }
  /**
  * Compares this date with another. A negative result indicates that this date is before the given
  * one, and a positive date indicates that it is after.
  */
  compare(t) {
    return this.toDate().getTime() - _2(t, this.timeZone).toDate().getTime();
  }
}
const dr = [
  [
    1868,
    9,
    8
  ],
  [
    1912,
    7,
    30
  ],
  [
    1926,
    12,
    25
  ],
  [
    1989,
    1,
    8
  ],
  [
    2019,
    5,
    1
  ]
], i6 = [
  [
    1912,
    7,
    29
  ],
  [
    1926,
    12,
    24
  ],
  [
    1989,
    1,
    7
  ],
  [
    2019,
    4,
    30
  ]
], Na = [
  1867,
  1911,
  1925,
  1988,
  2018
], dn = [
  "meiji",
  "taisho",
  "showa",
  "heisei",
  "reiwa"
];
function $s(e) {
  const t = dr.findIndex(([n, r, a]) => e.year < n || e.year === n && e.month < r || e.year === n && e.month === r && e.day < a);
  return t === -1 ? dr.length - 1 : t === 0 ? 0 : t - 1;
}
function Gl(e) {
  let t = Na[dn.indexOf(e.era)];
  if (!t) throw new Error("Unknown era: " + e.era);
  return new Re(e.year + t, e.month, e.day);
}
class u6 extends je {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = $s(n);
    return new Re(this, dn[r], n.year - Na[r], n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(Gl(t));
  }
  balanceDate(t) {
    let n = Gl(t), r = $s(n);
    dn[r] !== t.era && (t.era = dn[r], t.year = n.year - Na[r]), this.constrainDate(t);
  }
  constrainDate(t) {
    let n = dn.indexOf(t.era), r = i6[n];
    if (r != null) {
      let [a, l, i] = r, u = a - Na[n];
      t.year = Math.max(1, Math.min(u, t.year)), t.year === u && (t.month = Math.min(l, t.month), t.month === l && (t.day = Math.min(i, t.day)));
    }
    if (t.year === 1 && n >= 0) {
      let [, a, l] = dr[n];
      t.month = Math.max(a, t.month), t.month === a && (t.day = Math.max(l, t.day));
    }
  }
  getEras() {
    return dn;
  }
  getYearsInEra(t) {
    let n = dn.indexOf(t.era), r = dr[n], a = dr[n + 1];
    if (a == null)
      return 9999 - r[0] + 1;
    let l = a[0] - r[0];
    return (t.month < a[1] || t.month === a[1] && t.day < a[2]) && l++, l;
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(Gl(t));
  }
  getMinimumMonthInYear(t) {
    let n = vs(t);
    return n ? n[1] : 1;
  }
  getMinimumDayInMonth(t) {
    let n = vs(t);
    return n && t.month === n[1] ? n[2] : 1;
  }
  constructor(...t) {
    super(...t), this.identifier = "japanese";
  }
}
function vs(e) {
  if (e.year === 1) {
    let t = dn.indexOf(e.era);
    return dr[t];
  }
}
const U4 = -543;
class o6 extends je {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = ba(n.era, n.year);
    return new Re(this, r - U4, n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(Ds(t));
  }
  getEras() {
    return [
      "BE"
    ];
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(Ds(t));
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "buddhist";
  }
}
function Ds(e) {
  let [t, n] = vl(e.year + U4);
  return new Re(t, n, e.month, e.day);
}
const tl = 1911;
function j4(e) {
  return e.era === "minguo" ? e.year + tl : 1 - e.year + tl;
}
function xs(e) {
  let t = e - tl;
  return t > 0 ? [
    "minguo",
    t
  ] : [
    "before_minguo",
    1 - t
  ];
}
class s6 extends je {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = ba(n.era, n.year), [a, l] = xs(r);
    return new Re(this, a, l, n.month, n.day);
  }
  toJulianDay(t) {
    return super.toJulianDay(Es(t));
  }
  getEras() {
    return [
      "before_minguo",
      "minguo"
    ];
  }
  balanceDate(t) {
    let [n, r] = xs(j4(t));
    t.era = n, t.year = r;
  }
  isInverseEra(t) {
    return t.era === "before_minguo";
  }
  getDaysInMonth(t) {
    return super.getDaysInMonth(Es(t));
  }
  getYearsInEra(t) {
    return t.era === "before_minguo" ? 9999 : 9999 - tl;
  }
  constructor(...t) {
    super(...t), this.identifier = "roc";
  }
}
function Es(e) {
  let [t, n] = vl(j4(e));
  return new Re(t, n, e.month, e.day);
}
const Cs = 1948320, Ps = [
  0,
  31,
  62,
  93,
  124,
  155,
  186,
  216,
  246,
  276,
  306,
  336
  // Esfand
];
class d6 {
  fromJulianDay(t) {
    let n = t - Cs, r = 1 + Math.floor((33 * n + 3) / 12053), a = 365 * (r - 1) + Math.floor((8 * r + 21) / 33), l = n - a, i = l < 216 ? Math.floor(l / 31) : Math.floor((l - 6) / 30), u = l - Ps[i] + 1;
    return new Re(this, r, i + 1, u);
  }
  toJulianDay(t) {
    let n = Cs - 1 + 365 * (t.year - 1) + Math.floor((8 * t.year + 21) / 33);
    return n += Ps[t.month - 1], n += t.day, n;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInMonth(t) {
    return t.month <= 6 ? 31 : t.month <= 11 || sr(25 * t.year + 11, 33) < 8 ? 30 : 29;
  }
  getMaximumMonthsInYear() {
    return 12;
  }
  getMaximumDaysInMonth() {
    return 31;
  }
  getEras() {
    return [
      "AP"
    ];
  }
  getYearsInEra() {
    return 9377;
  }
  constructor() {
    this.identifier = "persian";
  }
}
const ql = 78, ws = 80;
class c6 extends je {
  fromJulianDay(t) {
    let n = super.fromJulianDay(t), r = n.year - ql, a = t - Rn(n.era, n.year, 1, 1), l;
    a < ws ? (r--, l = fn(n.year - 1) ? 31 : 30, a += l + 155 + 90 + 10) : (l = fn(n.year) ? 31 : 30, a -= ws);
    let i, u;
    if (a < l)
      i = 1, u = a + 1;
    else {
      let o = a - l;
      o < 155 ? (i = Math.floor(o / 31) + 2, u = o % 31 + 1) : (o -= 155, i = Math.floor(o / 30) + 7, u = o % 30 + 1);
    }
    return new Re(this, r, i, u);
  }
  toJulianDay(t) {
    let n = t.year + ql, [r, a] = vl(n), l, i;
    return fn(a) ? (l = 31, i = Rn(r, a, 3, 21)) : (l = 30, i = Rn(r, a, 3, 22)), t.month === 1 ? i + t.day - 1 : (i += l + Math.min(t.month - 2, 5) * 31, t.month >= 8 && (i += (t.month - 7) * 30), i += t.day - 1, i);
  }
  getDaysInMonth(t) {
    return t.month === 1 && fn(t.year + ql) || t.month >= 2 && t.month <= 6 ? 31 : 30;
  }
  getYearsInEra() {
    return 9919;
  }
  getEras() {
    return [
      "saka"
    ];
  }
  balanceDate() {
  }
  constructor(...t) {
    super(...t), this.identifier = "indian";
  }
}
const nl = 1948440, Ss = 1948439, tt = 1300, Jn = 1600, f6 = 460322;
function rl(e, t, n, r) {
  return r + Math.ceil(29.5 * (n - 1)) + (t - 1) * 354 + Math.floor((3 + 11 * t) / 30) + e - 1;
}
function _4(e, t, n) {
  let r = Math.floor((30 * (n - t) + 10646) / 10631), a = Math.min(12, Math.ceil((n - (29 + rl(t, r, 1, 1))) / 29.5) + 1), l = n - rl(t, r, a, 1) + 1;
  return new Re(e, r, a, l);
}
function ks(e) {
  return (14 + 11 * e) % 30 < 11;
}
class Mu {
  fromJulianDay(t) {
    return _4(this, nl, t);
  }
  toJulianDay(t) {
    return rl(nl, t.year, t.month, t.day);
  }
  getDaysInMonth(t) {
    let n = 29 + t.month % 2;
    return t.month === 12 && ks(t.year) && n++, n;
  }
  getMonthsInYear() {
    return 12;
  }
  getDaysInYear(t) {
    return ks(t.year) ? 355 : 354;
  }
  getMaximumMonthsInYear() {
    return 12;
  }
  getMaximumDaysInMonth() {
    return 30;
  }
  getYearsInEra() {
    return 9665;
  }
  getEras() {
    return [
      "AH"
    ];
  }
  constructor() {
    this.identifier = "islamic-civil";
  }
}
class h6 extends Mu {
  fromJulianDay(t) {
    return _4(this, Ss, t);
  }
  toJulianDay(t) {
    return rl(Ss, t.year, t.month, t.day);
  }
  constructor(...t) {
    super(...t), this.identifier = "islamic-tbla";
  }
}
const m6 = "qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=";
let Ki, cr;
function Va(e) {
  return f6 + cr[e - tt];
}
function zr(e, t) {
  let n = e - tt, r = 1 << 11 - (t - 1);
  return (Ki[n] & r) === 0 ? 29 : 30;
}
function Bs(e, t) {
  let n = Va(e);
  for (let r = 1; r < t; r++) n += zr(e, r);
  return n;
}
function Fs(e) {
  return cr[e + 1 - tt] - cr[e - tt];
}
class p6 extends Mu {
  constructor() {
    if (super(), this.identifier = "islamic-umalqura", Ki || (Ki = new Uint16Array(Uint8Array.from(atob(m6), (t) => t.charCodeAt(0)).buffer)), !cr) {
      cr = new Uint32Array(Jn - tt + 1);
      let t = 0;
      for (let n = tt; n <= Jn; n++) {
        cr[n - tt] = t;
        for (let r = 1; r <= 12; r++) t += zr(n, r);
      }
    }
  }
  fromJulianDay(t) {
    let n = t - nl, r = Va(tt), a = Va(Jn);
    if (n < r || n > a) return super.fromJulianDay(t);
    {
      let l = tt - 1, i = 1, u = 1;
      for (; u > 0; ) {
        l++, u = n - Va(l) + 1;
        let o = Fs(l);
        if (u === o) {
          i = 12;
          break;
        } else if (u < o) {
          let d = zr(l, i);
          for (i = 1; u > d; )
            u -= d, i++, d = zr(l, i);
          break;
        }
      }
      return new Re(this, l, i, n - Bs(l, i) + 1);
    }
  }
  toJulianDay(t) {
    return t.year < tt || t.year > Jn ? super.toJulianDay(t) : nl + Bs(t.year, t.month) + (t.day - 1);
  }
  getDaysInMonth(t) {
    return t.year < tt || t.year > Jn ? super.getDaysInMonth(t) : zr(t.year, t.month);
  }
  getDaysInYear(t) {
    return t.year < tt || t.year > Jn ? super.getDaysInYear(t) : Fs(t.year);
  }
}
const As = 347997, W4 = 1080, G4 = 24 * W4, b6 = 29, g6 = 12 * W4 + 793, y6 = b6 * G4 + g6;
function Fn(e) {
  return sr(e * 7 + 1, 19) < 7;
}
function La(e) {
  let t = Math.floor((235 * e - 234) / 19), n = 12084 + 13753 * t, r = t * 29 + Math.floor(n / 25920);
  return sr(3 * (r + 1), 7) < 3 && (r += 1), r;
}
function $6(e) {
  let t = La(e - 1), n = La(e);
  return La(e + 1) - n === 356 ? 2 : n - t === 382 ? 1 : 0;
}
function _r(e) {
  return La(e) + $6(e);
}
function q4(e) {
  return _r(e + 1) - _r(e);
}
function v6(e) {
  let t = q4(e);
  switch (t > 380 && (t -= 30), t) {
    case 353:
      return 0;
    // deficient
    case 354:
      return 1;
    // normal
    case 355:
      return 2;
  }
}
function Ba(e, t) {
  if (t >= 6 && !Fn(e) && t++, t === 4 || t === 7 || t === 9 || t === 11 || t === 13) return 29;
  let n = v6(e);
  return t === 2 ? n === 2 ? 30 : 29 : t === 3 ? n === 0 ? 29 : 30 : t === 6 ? Fn(e) ? 30 : 0 : 30;
}
class D6 {
  fromJulianDay(t) {
    let n = t - As, r = n * G4 / y6, a = Math.floor((19 * r + 234) / 235) + 1, l = _r(a), i = Math.floor(n - l);
    for (; i < 1; )
      a--, l = _r(a), i = Math.floor(n - l);
    let u = 1, o = 0;
    for (; o < i; )
      o += Ba(a, u), u++;
    u--, o -= Ba(a, u);
    let d = i - o;
    return new Re(this, a, u, d);
  }
  toJulianDay(t) {
    let n = _r(t.year);
    for (let r = 1; r < t.month; r++) n += Ba(t.year, r);
    return n + t.day + As;
  }
  getDaysInMonth(t) {
    return Ba(t.year, t.month);
  }
  getMonthsInYear(t) {
    return Fn(t.year) ? 13 : 12;
  }
  getDaysInYear(t) {
    return q4(t.year);
  }
  getMaximumMonthsInYear() {
    return 13;
  }
  getMaximumDaysInMonth() {
    return 30;
  }
  getYearsInEra() {
    return 9999;
  }
  getEras() {
    return [
      "AM"
    ];
  }
  balanceYearMonth(t, n) {
    n.year !== t.year && (Fn(n.year) && !Fn(t.year) && n.month > 6 ? t.month-- : !Fn(n.year) && Fn(t.year) && n.month > 6 && t.month++);
  }
  constructor() {
    this.identifier = "hebrew";
  }
}
const Ni = 1723856, Rs = 1824665, Vi = 5500;
function al(e, t, n, r) {
  return e + // difference from Julian epoch to 1,1,1
  365 * t + // number of days from years
  Math.floor(t / 4) + // extra day of leap year
  30 * (n - 1) + // number of days from months (1 based)
  r - 1;
}
function Ku(e, t) {
  let n = Math.floor(4 * (t - e) / 1461), r = 1 + Math.floor((t - al(e, n, 1, 1)) / 30), a = t + 1 - al(e, n, r, 1);
  return [
    n,
    r,
    a
  ];
}
function Y4(e) {
  return Math.floor(e % 4 / 3);
}
function Z4(e, t) {
  return t % 13 !== 0 ? 30 : Y4(e) + 5;
}
class Nu {
  fromJulianDay(t) {
    let [n, r, a] = Ku(Ni, t), l = "AM";
    return n <= 0 && (l = "AA", n += Vi), new Re(this, l, n, r, a);
  }
  toJulianDay(t) {
    let n = t.year;
    return t.era === "AA" && (n -= Vi), al(Ni, n, t.month, t.day);
  }
  getDaysInMonth(t) {
    return Z4(t.year, t.month);
  }
  getMonthsInYear() {
    return 13;
  }
  getDaysInYear(t) {
    return 365 + Y4(t.year);
  }
  getMaximumMonthsInYear() {
    return 13;
  }
  getMaximumDaysInMonth() {
    return 30;
  }
  getYearsInEra(t) {
    return t.era === "AA" ? 9999 : 9991;
  }
  getEras() {
    return [
      "AA",
      "AM"
    ];
  }
  constructor() {
    this.identifier = "ethiopic";
  }
}
class x6 extends Nu {
  fromJulianDay(t) {
    let [n, r, a] = Ku(Ni, t);
    return n += Vi, new Re(this, "AA", n, r, a);
  }
  getEras() {
    return [
      "AA"
    ];
  }
  getYearsInEra() {
    return 9999;
  }
  constructor(...t) {
    super(...t), this.identifier = "ethioaa";
  }
}
class E6 extends Nu {
  fromJulianDay(t) {
    let [n, r, a] = Ku(Rs, t), l = "CE";
    return n <= 0 && (l = "BCE", n = 1 - n), new Re(this, l, n, r, a);
  }
  toJulianDay(t) {
    let n = t.year;
    return t.era === "BCE" && (n = 1 - n), al(Rs, n, t.month, t.day);
  }
  getDaysInMonth(t) {
    let n = t.year;
    return t.era === "BCE" && (n = 1 - n), Z4(n, t.month);
  }
  isInverseEra(t) {
    return t.era === "BCE";
  }
  balanceDate(t) {
    t.year <= 0 && (t.era = t.era === "BCE" ? "CE" : "BCE", t.year = 1 - t.year);
  }
  getEras() {
    return [
      "BCE",
      "CE"
    ];
  }
  getYearsInEra(t) {
    return t.era === "BCE" ? 9999 : 9715;
  }
  constructor(...t) {
    super(...t), this.identifier = "coptic";
  }
}
function X4(e) {
  switch (e) {
    case "buddhist":
      return new o6();
    case "ethiopic":
      return new Nu();
    case "ethioaa":
      return new x6();
    case "coptic":
      return new E6();
    case "hebrew":
      return new D6();
    case "indian":
      return new c6();
    case "islamic-civil":
      return new Mu();
    case "islamic-tbla":
      return new h6();
    case "islamic-umalqura":
      return new p6();
    case "japanese":
      return new u6();
    case "persian":
      return new d6();
    case "roc":
      return new s6();
    default:
      return new je();
  }
}
let Yl = /* @__PURE__ */ new Map();
class Gt {
  constructor(t, n = {}) {
    this.formatter = J4(t, n), this.options = n;
  }
  /**
  * Formats a date as a string according to the locale and format options passed to the
  * constructor.
  */
  format(t) {
    return this.formatter.format(t);
  }
  /** Formats a date to an array of parts such as separators, numbers, punctuation, and more. */
  formatToParts(t) {
    return this.formatter.formatToParts(t);
  }
  /** Formats a date range as a string. */
  formatRange(t, n) {
    if (typeof this.formatter.formatRange == "function")
      return this.formatter.formatRange(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    return `${this.formatter.format(t)} – ${this.formatter.format(n)}`;
  }
  /** Formats a date range as an array of parts. */
  formatRangeToParts(t, n) {
    if (typeof this.formatter.formatRangeToParts == "function")
      return this.formatter.formatRangeToParts(t, n);
    if (n < t) throw new RangeError("End date must be >= start date");
    let r = this.formatter.formatToParts(t), a = this.formatter.formatToParts(n);
    return [
      ...r.map((l) => ({
        ...l,
        source: "startRange"
      })),
      {
        type: "literal",
        value: " – ",
        source: "shared"
      },
      ...a.map((l) => ({
        ...l,
        source: "endRange"
      }))
    ];
  }
  /** Returns the resolved formatting options based on the values passed to the constructor. */
  resolvedOptions() {
    let t = this.formatter.resolvedOptions();
    return w6() && (this.resolvedHourCycle || (this.resolvedHourCycle = S6(t.locale, this.options)), t.hourCycle = this.resolvedHourCycle, t.hour12 = this.resolvedHourCycle === "h11" || this.resolvedHourCycle === "h12"), t.calendar === "ethiopic-amete-alem" && (t.calendar = "ethioaa"), t;
  }
}
const C6 = {
  true: {
    // Only Japanese uses the h11 style for 12 hour time. All others use h12.
    ja: "h11"
  },
  false: {}
};
function J4(e, t = {}) {
  if (typeof t.hour12 == "boolean" && P6()) {
    t = {
      ...t
    };
    let a = C6[String(t.hour12)][e.split("-")[0]], l = t.hour12 ? "h12" : "h23";
    t.hourCycle = a ?? l, delete t.hour12;
  }
  let n = e + (t ? Object.entries(t).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : "");
  if (Yl.has(n)) return Yl.get(n);
  let r = new Intl.DateTimeFormat(e, t);
  return Yl.set(n, r), r;
}
let Zl = null;
function P6() {
  return Zl == null && (Zl = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    hour12: !1
  }).format(new Date(2020, 2, 3, 0)) === "24"), Zl;
}
let Xl = null;
function w6() {
  return Xl == null && (Xl = new Intl.DateTimeFormat("fr", {
    hour: "numeric",
    hour12: !1
  }).resolvedOptions().hourCycle === "h12"), Xl;
}
function S6(e, t) {
  if (!t.timeStyle && !t.hour) return;
  e = e.replace(/(-u-)?-nu-[a-zA-Z0-9]+/, ""), e += (e.includes("-u-") ? "" : "-u") + "-nu-latn";
  let n = J4(e, {
    ...t,
    timeZone: void 0
    // use local timezone
  }), r = parseInt(n.formatToParts(new Date(2020, 2, 3, 0)).find((l) => l.type === "hour").value, 10), a = parseInt(n.formatToParts(new Date(2020, 2, 3, 23)).find((l) => l.type === "hour").value, 10);
  if (r === 0 && a === 23) return "h23";
  if (r === 24 && a === 23) return "h24";
  if (r === 0 && a === 11) return "h11";
  if (r === 12 && a === 11) return "h12";
  throw new Error("Unexpected hour cycle result");
}
function Tt(e) {
  e = v4(e ?? {}, k6);
  let { locale: t } = de();
  return K(() => new Gt(t, e), [
    t,
    e
  ]);
}
function k6(e, t) {
  if (e === t) return !0;
  let n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let a of n)
    if (t[a] !== e[a]) return !1;
  return !0;
}
function Q4(e) {
  return e && e.__esModule ? e.default : e;
}
const Vu = /* @__PURE__ */ new WeakMap();
function na(e) {
  return e?.calendar.identifier === "gregory" && e.era === "BC" ? "short" : void 0;
}
function B6(e) {
  let t = xe(Q4(pa), "@react-aria/calendar"), n, r;
  "highlightedRange" in e ? { start: n, end: r } = e.highlightedRange || {} : (n = Array.isArray(e.value) ? e.value[0] : e.value ?? void 0, r = Array.isArray(e.value) ? e.value.at(-1) : e.value ?? void 0);
  let a = Tt({
    weekday: "long",
    month: "long",
    year: "numeric",
    day: "numeric",
    era: na(n) || na(r),
    timeZone: e.timeZone
  }), { locale: l } = de(), i = K(() => new Intl.ListFormat(l), [
    l
  ]), u = "anchorDate" in e ? e.anchorDate : null;
  return K(() => {
    if (!u && n && r) {
      if (Be(n, r)) {
        let o = a.format(n.toDate(e.timeZone));
        return t.format("selectedDateDescription", {
          date: o
        });
      } else if ("highlightedRange" in e) {
        let o = zi(a, t, n, r, e.timeZone);
        return t.format("selectedRangeDescription", {
          dateRange: o
        });
      } else if (Array.isArray(e.value)) {
        let o = e.value.map((s) => a.format(s.toDate(e.timeZone))), d = i.format(o);
        return t.format("selectedDateDescription", {
          date: d
        });
      }
    }
    return "";
  }, [
    n,
    r,
    u,
    e,
    t,
    a,
    i
  ]);
}
function Li(e, t, n, r) {
  let a = xe(Q4(pa), "@react-aria/calendar"), l = na(e) || na(t), i = Tt({
    month: "long",
    year: "numeric",
    era: l,
    calendar: e.calendar.identifier,
    timeZone: n
  }), u = Tt({
    month: "long",
    year: "numeric",
    day: "numeric",
    era: l,
    calendar: e.calendar.identifier,
    timeZone: n
  });
  return K(() => {
    if (Be(e, Vn(e))) {
      let o = e, d = t;
      if (e.calendar.getFormattableMonth && (o = e.calendar.getFormattableMonth(e)), t.calendar.getFormattableMonth && (d = t.calendar.getFormattableMonth(t)), Be(t, el(e))) return i.format(o.toDate(n));
      if (Be(t, el(t))) return r ? zi(i, a, o, d, n) : i.formatRange(o.toDate(n), d.toDate(n));
    }
    return r ? zi(u, a, e, t, n) : u.formatRange(e.toDate(n), t.toDate(n));
  }, [
    e,
    t,
    i,
    u,
    a,
    n,
    r
  ]);
}
function zi(e, t, n, r, a) {
  let l = e.formatRangeToParts(n.toDate(a), r.toDate(a)), i = -1;
  for (let d = 0; d < l.length; d++) {
    let s = l[d];
    if (s.source === "shared" && s.type === "literal") i = d;
    else if (s.source === "endRange") break;
  }
  let u = "", o = "";
  for (let d = 0; d < l.length; d++)
    d < i ? u += l[d].value : d > i && (o += l[d].value);
  return t.format("dateRange", {
    startDate: u,
    endDate: o
  });
}
function ll(e, t) {
  const n = T(!0), r = T(null);
  let a = De(e);
  ee(() => (n.current = !0, () => {
    n.current = !1;
  }), []), ee(() => {
    let l = r.current;
    n.current ? n.current = !1 : (!l || t.some((i, u) => !Object.is(i, l[u]))) && a(), r.current = t;
  }, t);
}
function F6(e) {
  return e && e.__esModule ? e.default : e;
}
function A6(e, t) {
  let n = xe(F6(pa), "@react-aria/calendar"), r = J(e), a = Li(t.visibleRange.start, t.visibleRange.end, t.timeZone, !1), l = Li(t.visibleRange.start, t.visibleRange.end, t.timeZone, !0);
  ll(() => {
    t.isFocused || bn(l);
  }, [
    l
  ]);
  let i = B6(t);
  ll(() => {
    i && bn(i, "polite", 4e3);
  }, [
    i
  ]);
  let u = bt([
    !!e.errorMessage,
    e.isInvalid,
    e.validationState
  ]);
  Vu.set(t, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: e["aria-labelledby"],
    errorMessageId: u,
    selectedDateDescription: i
  });
  let [o, d] = Y(!1), s = e.isDisabled || t.isNextVisibleRangeInvalid();
  s && o && (d(!1), t.setFocused(!0));
  let [c, f] = Y(!1), h = e.isDisabled || t.isPreviousVisibleRangeInvalid();
  h && c && (f(!1), t.setFocused(!0));
  let m = it({
    id: e.id,
    "aria-label": [
      e["aria-label"],
      l
    ].filter(Boolean).join(", "),
    "aria-labelledby": e["aria-labelledby"]
  });
  return {
    calendarProps: z(r, m, {
      role: "application",
      "aria-details": e["aria-details"] || void 0,
      "aria-describedby": e["aria-describedby"] || void 0
    }),
    nextButtonProps: {
      onPress: () => t.focusNextPage(),
      "aria-label": n.format("next"),
      isDisabled: s,
      onFocusChange: d
    },
    prevButtonProps: {
      onPress: () => t.focusPreviousPage(),
      "aria-label": n.format("previous"),
      isDisabled: h,
      onFocusChange: f
    },
    errorMessageProps: {
      id: u
    },
    title: a
  };
}
function R6(e, t) {
  return A6(e, t);
}
function T6(e, t) {
  let { startDate: n = t.visibleRange.start, endDate: r = t.visibleRange.end, firstDayOfWeek: a } = e, { direction: l } = de(), i = (p) => {
    switch (p.key) {
      case "Enter":
      case " ":
        p.preventDefault(), t.selectFocusedDate();
        break;
      case "PageUp":
        p.preventDefault(), p.stopPropagation(), t.focusPreviousSection(p.shiftKey);
        break;
      case "PageDown":
        p.preventDefault(), p.stopPropagation(), t.focusNextSection(p.shiftKey);
        break;
      case "End":
        p.preventDefault(), p.stopPropagation(), t.focusSectionEnd();
        break;
      case "Home":
        p.preventDefault(), p.stopPropagation(), t.focusSectionStart();
        break;
      case "ArrowLeft":
        p.preventDefault(), p.stopPropagation(), l === "rtl" ? t.focusNextDay() : t.focusPreviousDay();
        break;
      case "ArrowUp":
        p.preventDefault(), p.stopPropagation(), t.focusPreviousRow();
        break;
      case "ArrowRight":
        p.preventDefault(), p.stopPropagation(), l === "rtl" ? t.focusPreviousDay() : t.focusNextDay();
        break;
      case "ArrowDown":
        p.preventDefault(), p.stopPropagation(), t.focusNextRow();
        break;
      case "Escape":
        "setAnchorDate" in t && (p.preventDefault(), t.setAnchorDate(null));
        break;
    }
  }, u = Li(n, r, t.timeZone, !0), { ariaLabel: o, ariaLabelledBy: d } = Vu.get(t), s = it({
    "aria-label": [
      o,
      u
    ].filter(Boolean).join(", "),
    "aria-labelledby": d
  }), c = Tt({
    weekday: e.weekdayStyle || "narrow",
    timeZone: t.timeZone
  }), { locale: f } = de(), h = K(() => {
    let p = t.visibleDuration.days && t.visibleDuration.days < 7, b = p ? n : Jr(ku(t.timeZone), f, a), y = p ? t.visibleDuration.days : 7;
    return [
      ...new Array(y).keys()
    ].map(($) => {
      let x = b.add({
        days: $
      }).toDate(t.timeZone);
      return c.format(x);
    });
  }, [
    f,
    t.timeZone,
    c,
    a,
    n,
    t.visibleDuration.days
  ]), m = t.getWeeksInMonth(n);
  return {
    gridProps: z(s, {
      role: "grid",
      "aria-readonly": t.isReadOnly || void 0,
      "aria-disabled": t.isDisabled || void 0,
      "aria-multiselectable": "highlightedRange" in t || t.selectionMode === "multiple" || void 0,
      onKeyDown: i,
      onFocus: () => t.setFocused(!0),
      onBlur: () => t.setFocused(!1)
    }),
    headerProps: {
      // Column headers are hidden to screen readers to make navigating with a touch screen reader easier.
      // The day names are already included in the label of each cell, so there's no need to announce them twice.
      "aria-hidden": !0
    },
    weekDays: h,
    weeksInMonth: m
  };
}
function gn(e, t) {
  if (!e) return !1;
  let n = window.getComputedStyle(e), r = document.scrollingElement || document.documentElement, a = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return e === r && n.overflow !== "hidden" && (a = !0), a && t && (a = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), a;
}
function Le(e, t) {
  let n = e;
  for (gn(n, t) && (n = n.parentElement); n && !gn(n, t); ) n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
function Jl(e, t) {
  let n = [], r = document.scrollingElement || document.documentElement;
  for (; e && (gn(e, t) && n.push(e), e !== r); )
    e = e.parentElement;
  return n;
}
function za(e, t, n = {}) {
  let { block: r = "nearest", inline: a = "nearest" } = n;
  if (e === t) return;
  let l = e.scrollTop, i = e.scrollLeft, u = t.getBoundingClientRect(), o = e.getBoundingClientRect(), d = window.getComputedStyle(t), s = window.getComputedStyle(e), c = document.scrollingElement || document.documentElement, f = e === c, h = e === c ? 0 : o.top, m = e === c ? e.clientHeight : o.bottom, p = e === c ? 0 : o.left, b = e === c ? e.clientWidth : o.right, y = parseFloat(d.scrollMarginTop) || 0, $ = parseFloat(d.scrollMarginBottom) || 0, v = parseFloat(d.scrollMarginLeft) || 0, x = parseFloat(d.scrollMarginRight) || 0, E = parseFloat(s.scrollPaddingTop) || 0, P = parseFloat(s.scrollPaddingBottom) || 0, C = parseFloat(s.scrollPaddingLeft) || 0, M = parseFloat(s.scrollPaddingRight) || 0, F = parseFloat(s.borderTopWidth) || 0, V = parseFloat(s.borderBottomWidth) || 0, I = parseFloat(s.borderLeftWidth) || 0, A = parseFloat(s.borderRightWidth) || 0, U = u.top - y, D = u.bottom + $, N = u.left - v, w = u.right + x, R = e === c ? 0 : I + A, H = e === c ? 0 : F + V, k = e === c ? 0 : e.offsetWidth - e.clientWidth - R, S = e === c ? 0 : e.offsetHeight - e.clientHeight - H, j = h + (f ? 0 : F) + E, _ = m - (f ? 0 : V) - P - S, B = p + (f ? 0 : I) + C, L = b - (f ? 0 : A) - M;
  s.direction === "rtl" && !vt() ? B += k : L -= k;
  let Z = U < j || D > _, ie = N < B || w > L;
  if (Z && r === "start") l += U - j;
  else if (Z && r === "center") l += (U + D) / 2 - (j + _) / 2;
  else if (Z && r === "end") l += D - _;
  else if (Z && r === "nearest") {
    let q = U - j, re = D - _;
    l += Math.abs(q) <= Math.abs(re) ? q : re;
  }
  if (ie && a === "start") i += N - B;
  else if (ie && a === "center") i += (N + w) / 2 - (B + L) / 2;
  else if (ie && a === "end") i += w - L;
  else if (ie && a === "nearest") {
    let q = N - B, re = w - L;
    i += Math.abs(q) <= Math.abs(re) ? q : re;
  }
  if (process.env.NODE_ENV === "test") {
    e.scrollLeft = i, e.scrollTop = l;
    return;
  }
  e.scrollTo({
    left: i,
    top: l
  });
}
function ze(e, t = {}) {
  let { containingElement: n } = t;
  if (e && e.isConnected) {
    let r = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(r).overflow === "hidden") {
      let { left: l, top: i } = e.getBoundingClientRect(), u = Jl(e, !0);
      for (let s of u) za(s, e);
      let { left: o, top: d } = e.getBoundingClientRect();
      if (Math.abs(l - o) > 1 || Math.abs(i - d) > 1) {
        u = n ? Jl(n, !0) : [];
        for (let s of u) za(s, n, {
          block: "center",
          inline: "center"
        });
        for (let s of Jl(e, !0)) za(s, e);
      }
    } else {
      let { left: l, top: i } = e.getBoundingClientRect();
      e?.scrollIntoView?.({
        block: "nearest"
      });
      let { left: u, top: o } = e.getBoundingClientRect();
      (Math.abs(l - u) > 1 || Math.abs(i - o) > 1) && (n?.scrollIntoView?.({
        block: "center",
        inline: "center"
      }), e.scrollIntoView?.({
        block: "nearest"
      }));
    }
  }
}
let I6 = 0;
const Ql = /* @__PURE__ */ new Map();
function en(e) {
  let [t, n] = Y();
  return ue(() => {
    if (!e) return;
    let r = Ql.get(e);
    if (r)
      n(r.element.id);
    else {
      let a = `react-aria-description-${I6++}`;
      n(a);
      let l = document.createElement("div");
      l.id = a, l.style.display = "none", l.textContent = e, document.body.appendChild(l), r = {
        refCount: 0,
        element: l
      }, Ql.set(e, r);
    }
    return r.refCount++, () => {
      r && --r.refCount === 0 && (r.element.remove(), Ql.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
function M6(e) {
  return e && e.__esModule ? e.default : e;
}
function K6(e, t, n) {
  let { date: r, isDisabled: a } = e, { errorMessageId: l, selectedDateDescription: i } = Vu.get(t), u = xe(M6(pa), "@react-aria/calendar"), o = Tt({
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
    era: na(r),
    timeZone: t.timeZone
  }), d = t.isCellFocused(r) && !e.isOutsideMonth;
  a = a || t.isCellDisabled(r) || !!e.isOutsideMonth;
  let s = t.isCellUnavailable(r), c = !a && !s, f = t.isSelected(r) && c, h = !1;
  t.isValueInvalid && ("highlightedRange" in t ? h = !t.anchorDate && t.highlightedRange != null && r.compare(t.highlightedRange.start) >= 0 && r.compare(t.highlightedRange.end) <= 0 : Array.isArray(t.value) ? h = t.value.some((I) => Be(I, r)) : t.value && (h = Be(t.value, r))), h && !a && (f = !0), r = v4(r, M2);
  let m = K(() => r.toDate(t.timeZone), [
    r,
    t.timeZone
  ]), p = x4(r, t.timeZone), b = K(() => {
    let I = "";
    return "highlightedRange" in t && t.value && !t.anchorDate && (Be(r, t.value.start) || Be(r, t.value.end)) && (I = i + ", "), I += o.format(m), p ? I = u.format(f ? "todayDateSelected" : "todayDate", {
      date: I
    }) : f && (I = u.format("dateSelected", {
      date: I
    })), t.minValue && Be(r, t.minValue) ? I += ", " + u.format("minimumDate") : t.maxValue && Be(r, t.maxValue) && (I += ", " + u.format("maximumDate")), I;
  }, [
    o,
    m,
    u,
    f,
    p,
    r,
    t,
    i
  ]), y = "";
  "anchorDate" in t && d && !t.isReadOnly && c && (t.anchorDate ? y = u.format("finishRangeSelectionPrompt") : y = u.format("startRangeSelectionPrompt"));
  let $ = en(y), v = T(!1), x = T(!1), E = T(void 0), { pressProps: P, isPressed: C } = Xe({
    // When dragging to select a range, we don't want dragging over the original anchor
    // again to trigger onPressStart. Cancel presses immediately when the pointer exits.
    shouldCancelOnPointerExit: "anchorDate" in t && !!t.anchorDate,
    preventFocusOnPress: !0,
    isDisabled: !c || t.isReadOnly,
    onPressStart(I) {
      if (t.isReadOnly) {
        t.setFocusedDate(r), t.setFocused(!0);
        return;
      }
      if ("highlightedRange" in t && !t.anchorDate && (I.pointerType === "mouse" || I.pointerType === "touch")) {
        if (t.highlightedRange && !h) {
          if (Be(r, t.highlightedRange.start)) {
            t.setAnchorDate(t.highlightedRange.end), t.setFocusedDate(r), t.setFocused(!0), t.setDragging(!0), x.current = !0;
            return;
          } else if (Be(r, t.highlightedRange.end)) {
            t.setAnchorDate(t.highlightedRange.start), t.setFocusedDate(r), t.setFocused(!0), t.setDragging(!0), x.current = !0;
            return;
          }
        }
        let A = () => {
          t.setDragging(!0), E.current = void 0, t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0), v.current = !0;
        };
        I.pointerType === "touch" ? E.current = setTimeout(A, 200) : A();
      }
    },
    onPressEnd() {
      x.current = !1, v.current = !1, clearTimeout(E.current), E.current = void 0;
    },
    onPress() {
      !("anchorDate" in t) && !t.isReadOnly && (t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0));
    },
    onPressUp(I) {
      t.isReadOnly || ("anchorDate" in t && E.current && (t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0)), "anchorDate" in t && (x.current ? t.setAnchorDate(r) : t.anchorDate && !v.current ? (t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0)) : I.pointerType === "keyboard" && !t.anchorDate ? (t.selectDate(r), t.focusNearestAvailableDate(r)) : I.pointerType === "virtual" && (t.selectDate(r), t.setFocusedDate(r), t.setFocused(!0))));
    }
  }), M;
  a || (M = Be(r, t.focusedDate) ? 0 : -1), ee(() => {
    d && n.current && (Fe(n.current), yt() !== "pointer" && se() === n.current && ze(n.current, {
      containingElement: Le(n.current)
    }));
  }, [
    d,
    n
  ]);
  let F = Tt({
    day: "numeric",
    timeZone: t.timeZone,
    calendar: r.calendar.identifier
  }), V = K(() => F.formatToParts(m).find((I) => I.type === "day").value, [
    F,
    m
  ]);
  return {
    cellProps: {
      role: "gridcell",
      "aria-disabled": !c || void 0,
      "aria-selected": f || void 0,
      "aria-invalid": h || void 0
    },
    buttonProps: z(P, {
      onFocus() {
        a || (t.setFocusedDate(r), t.setFocused(!0));
      },
      tabIndex: M,
      role: "button",
      "aria-disabled": !c || void 0,
      "aria-label": b,
      "aria-invalid": h || void 0,
      "aria-describedby": [
        h ? l : void 0,
        $["aria-describedby"]
      ].filter(Boolean).join(" ") || void 0,
      onPointerEnter(I) {
        "highlightDate" in t && (I.pointerType !== "touch" || t.isDragging) && c && t.highlightDate(r);
      },
      onPointerDown(I) {
        let A = W(I);
        A instanceof HTMLElement && "releasePointerCapture" in A && ("hasPointerCapture" in A ? A.hasPointerCapture(I.pointerId) && A.releasePointerCapture(I.pointerId) : A.releasePointerCapture(I.pointerId));
      },
      onContextMenu(I) {
        I.preventDefault();
      }
    }),
    isPressed: C,
    isFocused: d,
    isSelected: f,
    isDisabled: a,
    isUnavailable: s,
    isOutsideVisibleRange: r.compare(t.visibleRange.start) < 0 || r.compare(t.visibleRange.end) > 0,
    isInvalid: h,
    formattedDate: V
  };
}
function Fa(e, t, n) {
  return t != null && e.compare(t) < 0 || n != null && e.compare(n) > 0;
}
function Ts(e, t, n, r, a) {
  let l = {};
  for (let u in t)
    l[u] = Math.floor(t[u] / 2), l[u] > 0 && t[u] % 2 === 0 && l[u]--;
  let i = Tn(e, t, n).subtract(l);
  return ra(e, i, t, n, r, a);
}
function Tn(e, t, n, r, a) {
  let l = e;
  return t.years ? l = V2(e) : t.months ? l = Vn(e) : (t.weeks || t.days && t.days > 7) && (l = Jr(e, n)), ra(e, l, t, n, r, a);
}
function Oi(e, t, n, r, a) {
  let l = {
    ...t
  };
  l.days ? l.days-- : l.weeks ? l.weeks-- : l.months ? l.months-- : l.years && l.years--;
  let i = Tn(e, t, n).subtract(l);
  return ra(e, i, t, n, r, a);
}
function ra(e, t, n, r, a, l) {
  if (a && e.compare(a) >= 0) {
    let i = k4(t, Tn(lt(a), n, r));
    i && (t = i);
  }
  if (l && e.compare(l) <= 0) {
    let i = S4(t, Oi(lt(l), n, r));
    i && (t = i);
  }
  return t;
}
function Ot(e, t, n) {
  if (t) {
    let r = k4(e, lt(t));
    r && (e = r);
  }
  if (n) {
    let r = S4(e, lt(n));
    r && (e = r);
  }
  return e;
}
function N6(e, t, n) {
  if (!n) return e;
  for (; e.compare(t) >= 0 && n(e); ) e = e.subtract({
    days: 1
  });
  return e.compare(t) >= 0 ? e : null;
}
function V6(e, t) {
  return e === t ? !0 : e.days === t.days && e.weeks === t.weeks && e.months === t.months && e.years === t.years;
}
function L6(e) {
  let t = K(() => new Gt(e.locale), [
    e.locale
  ]), n = K(() => t.resolvedOptions(), [
    t
  ]), { locale: r, createCalendar: a, visibleDuration: l = {
    months: 1
  }, minValue: i, maxValue: u, selectionAlignment: o, isDateUnavailable: d, pageBehavior: s = "visible", selectionMode: c = "single", firstDayOfWeek: f, weeksInMonth: h } = e, m = K(() => a(n.calendar), [
    a,
    n.calendar
  ]), [p, b] = Pe(e.value, e.defaultValue ?? null, e.onChange), y = K(() => Array.isArray(p) ? p.map((L) => Se(lt(L), m)) : p ? Se(lt(p), m) : null, [
    p,
    m
  ]), $ = K(() => {
    let L = Array.isArray(p) ? p[0] : p;
    return L && "timeZone" in L ? L.timeZone : n.timeZone;
  }, [
    p,
    n.timeZone
  ]), v = K(() => e.focusedValue ? Ot(Se(lt(e.focusedValue), m), i, u) : void 0, [
    e.focusedValue,
    m,
    i,
    u
  ]), x = K(() => e.defaultFocusedValue ? Ot(Se(lt(e.defaultFocusedValue), m), i, u) : Ot(y ? Array.isArray(y) ? y[0] : y : Se(ku($), m), i, u), [
    e.defaultFocusedValue,
    y,
    $,
    m,
    i,
    u
  ]), [E, P] = Pe(v, x, e.onFocusChange), C = () => {
    switch (o) {
      case "start":
        return Tn(E, l, r, i, u);
      case "end":
        return Oi(E, l, r, i, u);
      default:
        return Ts(E, l, r, i, u);
    }
  }, [M, F] = Y(C), [V, I] = Y(e.autoFocus || !1), [A, U] = Y(l);
  V6(l, A) || (U(l), F(C()));
  let D = K(() => {
    let L = {
      ...l
    };
    return L.days ? L.days-- : L.days = -1, M.add(L);
  }, [
    M,
    l
  ]), [N, w] = Y(m);
  if (!Dl(m, N)) {
    let L = Se(E, m);
    F(Ts(L, l, r, i, u)), P(L), w(m);
  }
  Fa(E, i, u) ? P(Ot(E, i, u)) : E.compare(M) < 0 ? F(Oi(E, l, r, i, u)) : E.compare(D) > 0 && F(Tn(E, l, r, i, u));
  function R(L) {
    L = Ot(L, i, u), P(L);
  }
  function H(L) {
    let Z = Ot(L, i, u), ie = N6(Z, M, d);
    if (!ie) return null;
    let q = Array.isArray(p) ? p[0] : p, re = Se(ie, q?.calendar || new je());
    return q && "hour" in q ? q.set(re) : re;
  }
  function k(L) {
    if (!e.isDisabled && !e.isReadOnly) {
      if (L === null) {
        b(c === "multiple" ? [] : null);
        return;
      }
      if (Array.isArray(L)) b(L.map(H).filter(Boolean));
      else {
        let Z = H(L);
        Z && b(Z);
      }
    }
  }
  let S = K(() => y ? Array.isArray(y) ? y.some((L) => d?.(L) || Fa(L, i, u)) : d?.(y) || Fa(y, i, u) : !1, [
    y,
    d,
    i,
    u
  ]), j = e.isInvalid || e.validationState === "invalid" || S, _ = j ? "invalid" : null, B = K(() => s === "visible" ? l : ei(l), [
    s,
    l
  ]);
  return {
    isDisabled: e.isDisabled ?? !1,
    isReadOnly: e.isReadOnly ?? !1,
    value: y,
    setValue: k,
    selectionMode: c,
    visibleDuration: l,
    visibleRange: {
      start: M,
      end: D
    },
    minValue: i,
    maxValue: u,
    focusedDate: E,
    timeZone: $,
    validationState: _,
    isValueInvalid: j,
    setFocusedDate(L) {
      R(L);
    },
    focusNextDay() {
      R(E.add({
        days: 1
      }));
    },
    focusPreviousDay() {
      R(E.subtract({
        days: 1
      }));
    },
    focusNextRow() {
      l.days ? this.focusNextPage() : (l.weeks || l.months || l.years) && R(E.add({
        weeks: 1
      }));
    },
    focusPreviousRow() {
      l.days ? this.focusPreviousPage() : (l.weeks || l.months || l.years) && R(E.subtract({
        weeks: 1
      }));
    },
    focusNextPage() {
      let L = M.add(B);
      P(Ot(E.add(B), i, u)), F(Tn(ra(E, L, B, r, i, u), B, r));
    },
    focusPreviousPage() {
      let L = M.subtract(B);
      P(Ot(E.subtract(B), i, u)), F(Tn(ra(E, L, B, r, i, u), B, r));
    },
    focusSectionStart() {
      l.days ? R(M) : l.weeks ? R(Jr(E, r)) : (l.months || l.years) && R(Vn(E));
    },
    focusSectionEnd() {
      l.days ? R(D) : l.weeks ? R(L2(E, r)) : (l.months || l.years) && R(el(E));
    },
    focusNextSection(L) {
      if (!L && !l.days) {
        R(E.add(ei(l)));
        return;
      }
      l.days ? this.focusNextPage() : l.weeks ? R(E.add({
        months: 1
      })) : (l.months || l.years) && R(E.add({
        years: 1
      }));
    },
    focusPreviousSection(L) {
      if (!L && !l.days) {
        R(E.subtract(ei(l)));
        return;
      }
      l.days ? this.focusPreviousPage() : l.weeks ? R(E.subtract({
        months: 1
      })) : (l.months || l.years) && R(E.subtract({
        years: 1
      }));
    },
    selectFocusedDate() {
      d && d(E) || this.selectDate(E);
    },
    selectDate(L) {
      if (!(e.isDisabled || e.isReadOnly))
        if (c === "multiple" && L != null) {
          let Z = H(L);
          if (!Z) return;
          let ie = [];
          Array.isArray(p) ? ie = p : p != null && (ie = [
            p
          ]);
          let q = ie.findIndex((fe) => Be(fe, Z)), re = q >= 0 ? ie.slice(0, q).concat(ie.slice(q + 1)) : [
            ...ie,
            Z
          ];
          b(re);
        } else k(L);
    },
    isFocused: V,
    setFocused: I,
    isInvalid(L) {
      return Fa(L, i, u);
    },
    isSelected(L) {
      return !y || this.isCellDisabled(L) || this.isCellUnavailable(L) ? !1 : Array.isArray(y) ? y.some((Z) => Be(Z, L)) : Be(L, y);
    },
    isCellFocused(L) {
      return V && E && Be(L, E);
    },
    isCellDisabled(L) {
      return e.isDisabled || L.compare(M) < 0 || L.compare(D) > 0 || this.isInvalid(L);
    },
    isCellUnavailable(L) {
      return e.isDateUnavailable ? e.isDateUnavailable(L) : !1;
    },
    isPreviousVisibleRangeInvalid() {
      let L = M.subtract({
        days: 1
      });
      return Be(L, M) || this.isInvalid(L);
    },
    isNextVisibleRangeInvalid() {
      let L = D.add({
        days: 1
      });
      return Be(L, D) || this.isInvalid(L);
    },
    getDatesInWeek(L, Z = M) {
      let ie = Z.add({
        weeks: L
      }), q = [], re = l.days && l.days < 7 ? l.days : 7;
      if (re === 7) {
        ie = Jr(ie, r, f);
        let fe = Su(ie, r, f);
        for (let et = 0; et < fe; et++) q.push(null);
      }
      for (; q.length < re; ) {
        q.push(ie);
        let fe = ie.add({
          days: 1
        });
        if (Be(ie, fe)) break;
        ie = fe;
      }
      for (; q.length < re; ) q.push(null);
      return q;
    },
    getWeeksInMonth(L = M) {
      let Z = h || H2(L, r, f);
      return (l.weeks || l.days) && (Z = l.weeks ?? 0, l.days && (Z += Math.ceil(l.days / 7))), Z;
    }
  };
}
function ei(e) {
  let t = {
    ...e
  };
  for (let n in e) t[n] = 1;
  return t;
}
const Is = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function tn(e = {}) {
  let { style: t, isFocusable: n } = e, [r, a] = Y(!1), { focusWithinProps: l } = ct({
    isDisabled: !n,
    onFocusWithinChange: (u) => a(u)
  }), i = K(() => r ? t : t ? {
    ...Is,
    ...t
  } : Is, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...l,
      style: i
    }
  };
}
function br(e) {
  let { children: t, elementType: n = "div", isFocusable: r, style: a, ...l } = e, { visuallyHiddenProps: i } = tn(e);
  return /* @__PURE__ */ g.createElement(n, z(l, i), t);
}
const il = /* @__PURE__ */ G(null), z6 = /* @__PURE__ */ G(null), Cl = /* @__PURE__ */ G(null), Lu = /* @__PURE__ */ G(null), JC = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, il);
  let { locale: r } = de(), a = L6({
    ...t,
    locale: r,
    createCalendar: t.createCalendar || X4
  }), { calendarProps: l, prevButtonProps: i, nextButtonProps: u, errorMessageProps: o, title: d } = R6(t, a), s = le({
    ...t,
    values: {
      state: a,
      isDisabled: t.isDisabled || !1,
      isInvalid: a.isValueInvalid
    },
    defaultClassName: "react-aria-Calendar"
  }), c = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(c, s, l),
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": a.isValueInvalid || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Ze,
        {
          slots: {
            previous: i,
            next: u
          }
        }
      ],
      [
        wu,
        {
          "aria-hidden": !0,
          level: 2,
          children: d
        }
      ],
      [
        Cl,
        a
      ],
      [
        il,
        t
      ],
      [
        _e,
        {
          slots: {
            errorMessage: o
          }
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(br, null, /* @__PURE__ */ g.createElement("h2", null, l["aria-label"])), s.children, /* @__PURE__ */ g.createElement(br, null, /* @__PURE__ */ g.createElement("button", {
    "aria-label": u["aria-label"],
    disabled: u.isDisabled,
    onClick: () => a.focusNextPage(),
    tabIndex: -1
  }))));
}), Pl = /* @__PURE__ */ G(null), QC = /* @__PURE__ */ te(function(t, n) {
  let r = O(Cl), a = O(Lu), l = Oe(il), i = Oe(z6), u = r ?? a, o = u.visibleRange.start;
  t.offset && (o = o.add(t.offset));
  let d = l?.firstDayOfWeek ?? i?.firstDayOfWeek, { gridProps: s, headerProps: c, weekDays: f, weeksInMonth: h } = T6({
    startDate: o,
    endDate: el(o),
    weekdayStyle: t.weekdayStyle,
    firstDayOfWeek: d
  }, u), m = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Pl.Provider, {
    value: {
      headerProps: c,
      weekDays: f,
      startDate: o,
      weeksInMonth: h
    }
  }, /* @__PURE__ */ g.createElement(Q.table, {
    render: t.render,
    ...z(m, s),
    ref: n,
    style: t.style,
    cellPadding: 0,
    className: t.className ?? "react-aria-CalendarGrid"
  }, typeof t.children != "function" ? t.children : /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(H6, null, (p) => /* @__PURE__ */ g.createElement(j6, null, p)), /* @__PURE__ */ g.createElement(W6, null, t.children))));
});
function O6(e, t) {
  let { children: n, style: r, className: a } = e, { headerProps: l, weekDays: i } = O(Pl), u = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.thead, {
    render: e.render,
    ...z(u, l),
    ref: t,
    style: r,
    className: a ?? "react-aria-CalendarGridHeader"
  }, /* @__PURE__ */ g.createElement("tr", null, i.map((o, d) => /* @__PURE__ */ g.cloneElement(n(o), {
    key: d
  }))));
}
const H6 = /* @__PURE__ */ te(O6);
function U6(e, t) {
  let { children: n, style: r, className: a } = e, l = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.th, {
    render: e.render,
    ...l,
    ref: t,
    style: r,
    className: a || "react-aria-CalendarHeaderCell"
  }, n);
}
const j6 = /* @__PURE__ */ te(U6);
function _6(e, t) {
  let { children: n, style: r, className: a } = e, l = O(Cl), i = O(Lu), u = l ?? i, { startDate: o, weeksInMonth: d } = O(Pl), s = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.tbody, {
    render: e.render,
    ...s,
    ref: t,
    style: r,
    className: a ?? "react-aria-CalendarGridBody"
  }, [
    ...new Array(d).keys()
  ].map((c) => /* @__PURE__ */ g.createElement("tr", {
    key: c
  }, u.getDatesInWeek(c, o).map((f, h) => f ? /* @__PURE__ */ g.cloneElement(n(f), {
    key: h
  }) : /* @__PURE__ */ g.createElement("td", {
    key: h
  })))));
}
const W6 = /* @__PURE__ */ te(_6), e9 = /* @__PURE__ */ te(function({ date: t, ...n }, r) {
  let a = O(Cl), l = O(Lu), i = a ?? l, { startDate: u } = O(Pl) ?? {
    startDate: i.visibleRange.start
  }, o = i.visibleDuration.days || i.visibleDuration.weeks ? !1 : !I2(u, t), d = x4(t, i.timeZone), s = T(null), { cellProps: c, buttonProps: f, ...h } = K6({
    date: t,
    isOutsideMonth: o
  }, i, s), { hoverProps: m, isHovered: p } = ve({
    ...n,
    isDisabled: h.isDisabled || h.isUnavailable
  }), { focusProps: b, isFocusVisible: y } = ye();
  y &&= h.isFocused;
  let $ = !1, v = !1;
  "highlightedRange" in i && i.highlightedRange && ($ = Be(t, i.highlightedRange.start), v = Be(t, i.highlightedRange.end));
  let x = le({
    ...n,
    defaultChildren: h.formattedDate,
    defaultClassName: "react-aria-CalendarCell",
    values: {
      date: t,
      isHovered: p,
      isOutsideMonth: o,
      isFocusVisible: y,
      isSelectionStart: $,
      isSelectionEnd: v,
      isToday: d,
      ...h
    }
  }), E = {
    "data-focused": h.isFocused || void 0,
    "data-hovered": p || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-unavailable": h.isUnavailable || void 0,
    "data-disabled": h.isDisabled || void 0,
    "data-focus-visible": y || void 0,
    "data-outside-visible-range": h.isOutsideVisibleRange || void 0,
    "data-outside-month": o || void 0,
    "data-selected": h.isSelected || void 0,
    "data-selection-start": $ || void 0,
    "data-selection-end": v || void 0,
    "data-invalid": h.isInvalid || void 0,
    "data-today": d || void 0
  }, P = J(n, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement("td", {
    ...c,
    ref: r
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(P, f, b, m, E, x),
    ref: s
  }));
}), nn = /* @__PURE__ */ G(null), t9 = /* @__PURE__ */ te(function(t, n) {
  return O(nn)?.isInvalid ? /* @__PURE__ */ g.createElement(G6, {
    ...t,
    ref: n
  }) : null;
}), G6 = /* @__PURE__ */ te((e, t) => {
  let n = O(nn), { elementType: r, ...a } = e, l = J(a, {
    global: !0
  }), i = le({
    ...a,
    defaultClassName: "react-aria-FieldError",
    defaultChildren: n.validationErrors.length === 0 ? void 0 : n.validationErrors.join(" "),
    values: n
  });
  return i.children == null ? null : /* @__PURE__ */ g.createElement(A2, {
    slot: "errorMessage",
    elementType: r,
    ...l,
    ...i,
    ref: t
  });
}), eh = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, th = {
  ...eh,
  customError: !0,
  valid: !1
}, tr = {
  isInvalid: !1,
  validationDetails: eh,
  validationErrors: []
}, q6 = G({}), zn = "__reactAriaFormValidationState";
function rn(e) {
  if (e[zn]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: a, commitValidation: l } = e[zn];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: a,
      commitValidation: l
    };
  }
  return Y6(e);
}
function Y6(e) {
  let { isInvalid: t, validationState: n, name: r, value: a, builtinValidation: l, validate: i, validationBehavior: u = "aria" } = e;
  n && (t ||= n === "invalid");
  let o = t !== void 0 ? {
    isInvalid: t,
    validationErrors: [],
    validationDetails: th
  } : null, d = K(() => {
    if (!i || a == null) return null;
    let V = Z6(i, a);
    return Ms(V);
  }, [
    i,
    a
  ]);
  l?.validationDetails.valid && (l = void 0);
  let s = O(q6), c = K(() => r ? Array.isArray(r) ? r.flatMap((V) => Hi(s[V])) : Hi(s[r]) : [], [
    s,
    r
  ]), [f, h] = Y(s), [m, p] = Y(!1);
  s !== f && (h(s), p(!1));
  let b = K(() => Ms(m ? [] : c), [
    m,
    c
  ]), y = T(tr), [$, v] = Y(tr), x = T(tr), E = () => {
    if (!P) return;
    C(!1);
    let V = d || l || y.current;
    ti(V, x.current) || (x.current = V, v(V));
  }, [P, C] = Y(!1);
  return ee(E), {
    realtimeValidation: o || b || d || l || tr,
    displayValidation: u === "native" ? o || b || $ : o || b || d || l || $,
    updateValidation(V) {
      u === "aria" && !ti($, V) ? v(V) : y.current = V;
    },
    resetValidation() {
      let V = tr;
      ti(V, x.current) || (x.current = V, v(V)), u === "native" && C(!1), p(!0);
    },
    commitValidation() {
      u === "native" && C(!0), p(!0);
    }
  };
}
function Hi(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function Z6(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean") return Hi(n);
  }
  return [];
}
function Ms(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: th
  } : null;
}
function ti(e, t) {
  return e === t ? !0 : !!e && !!t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
const Un = /* @__PURE__ */ G(null), X6 = /* @__PURE__ */ new WeakMap();
function Cr(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: a } = e, { labelProps: l, fieldProps: i } = ma(e), u = bt([
    !!t,
    !!n,
    r,
    a
  ]), o = bt([
    !!t,
    !!n,
    r,
    a
  ]);
  return i = z(i, {
    "aria-describedby": [
      u,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      o,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: l,
    fieldProps: i,
    descriptionProps: {
      id: u
    },
    errorMessageProps: {
      id: o
    }
  };
}
function an(e, t, n) {
  let r = De((a) => {
    n && !a.defaultPrevented && n(t);
  });
  ee(() => {
    let a = e?.current?.form;
    return a?.addEventListener("reset", r), () => {
      a?.removeEventListener("reset", r);
    };
  }, [
    e
  ]);
}
function ga(e, t, n) {
  let { validationBehavior: r, focus: a } = e;
  ue(() => {
    if (r === "native" && n?.current && "setCustomValidity" in n.current && !n.current.disabled) {
      let d = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(d), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(Q6(n.current));
    }
  });
  let l = T(!1), i = De(() => {
    l.current || t.resetValidation();
  }), u = De((d) => {
    t.displayValidation.isInvalid || t.commitValidation();
    let s = n?.current?.form;
    !d.defaultPrevented && n && s && eD(s) === n.current && (a ? a() : n.current?.focus(), qr("keyboard")), d.preventDefault();
  }), o = De(() => {
    t.commitValidation();
  });
  ee(() => {
    let d = n?.current;
    if (!d) return;
    let s = d.form, c = s?.reset;
    return s && (s.reset = () => {
      l.current = !window.event || window.event.type === "message" && W(window.event) instanceof MessagePort, c?.call(s), l.current = !1;
    }), d.addEventListener("invalid", u), d.addEventListener("change", o), s?.addEventListener("reset", i), () => {
      d.removeEventListener("invalid", u), d.removeEventListener("change", o), s?.removeEventListener("reset", i), s && (s.reset = c);
    };
  }, [
    n,
    r
  ]);
}
function J6(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function Q6(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: J6(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function eD(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let n = e.elements[t];
    if (n.validity?.valid === !1) return n;
  }
  return null;
}
function tD(e = !0) {
  let [t, n] = Y(e), r = T(!1), a = X((l) => {
    r.current = !0, n(!!l);
  }, []);
  return ue(() => {
    r.current || n(!1);
  }, []), [
    a,
    t
  ];
}
function Ui(e = !0) {
  let t = ce(), [n, r] = tD(e);
  return {
    id: r ? t : void 0,
    ref: n
  };
}
function nh(e, t, n) {
  let { isDisabled: r = !1, isReadOnly: a = !1, value: l, name: i, form: u, children: o, isRequired: d, validationBehavior: s = "aria", "aria-label": c, "aria-labelledby": f, "aria-describedby": h, onPressStart: m, onPressEnd: p, onPressChange: b, onPress: y, onPressUp: $, onClick: v } = e, x = rn({
    ...e,
    value: t.isSelected
  }), { isInvalid: E, validationErrors: P, validationDetails: C } = x.displayValidation;
  ga(e, x, n);
  let M = (j) => {
    j.stopPropagation(), t.setSelected(W(j).checked);
  }, F = o != null, V = c != null || f != null;
  !F && !V && process.env.NODE_ENV !== "production" && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: I, isPressed: A } = Xe({
    onPressStart: m,
    onPressEnd: p,
    onPressChange: b,
    onPress: y,
    onPressUp: $,
    onClick: v,
    isDisabled: r
  }), [U, D] = Y(!1), { pressProps: N } = Xe({
    onPressStart(j) {
      if (j.pointerType === "keyboard" || j.pointerType === "virtual") {
        j.continuePropagation();
        return;
      }
      m?.(j), b?.(!0), D(!0);
    },
    onPressEnd(j) {
      if (j.pointerType === "keyboard" || j.pointerType === "virtual") {
        j.continuePropagation();
        return;
      }
      p?.(j), b?.(!1), D(!1);
    },
    onPressUp(j) {
      if (j.pointerType === "keyboard" || j.pointerType === "virtual") {
        j.continuePropagation();
        return;
      }
      $?.(j);
    },
    onClick: v,
    onPress(j) {
      if (j.pointerType === "keyboard" || j.pointerType === "virtual") {
        j.continuePropagation();
        return;
      }
      y?.(j), t.toggle(), n.current?.focus();
      let { [zn]: _ } = e, { commitValidation: B } = _ || x;
      B();
    },
    isDisabled: r || a
  }), { focusableProps: w } = dt(e, n), R = z(I, w), H = J(e, {
    labelable: !0
  });
  an(n, t.defaultSelected, t.setSelected);
  let k = Ui(), S = Ui();
  return {
    labelProps: z(N, {
      onClick: (j) => j.preventDefault()
    }),
    inputProps: z(H, {
      checked: t.isSelected,
      "aria-required": d && s === "aria" || void 0,
      required: d && s === "native",
      "aria-invalid": E || e.validationState === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-controls": e["aria-controls"],
      "aria-readonly": a || void 0,
      "aria-describedby": [
        k.id,
        S.id,
        h
      ].filter(Boolean).join(" ") || void 0,
      onChange: M,
      disabled: r,
      ...l == null ? {} : {
        value: l
      },
      name: i,
      form: u,
      type: "checkbox",
      ...R
    }),
    descriptionProps: k,
    errorMessageProps: S,
    isSelected: t.isSelected,
    isPressed: A || U,
    isDisabled: r,
    isReadOnly: a,
    isInvalid: E || e.validationState === "invalid",
    validationErrors: P,
    validationDetails: C
  };
}
function rh(e, t, n) {
  let { labelProps: r, inputProps: a, descriptionProps: l, errorMessageProps: i, isSelected: u, isPressed: o, isDisabled: d, isReadOnly: s, isInvalid: c, validationErrors: f, validationDetails: h } = nh(e, t, n), { isIndeterminate: m } = e;
  return ee(() => {
    n.current && (n.current.indeterminate = !!m);
  }), {
    labelProps: z(r, K(() => ({
      // Prevent label from being focused when mouse down on it.
      // Note, this does not prevent the input from being focused in the `click` event.
      onMouseDown: (p) => p.preventDefault()
    }), [])),
    inputProps: a,
    descriptionProps: l,
    errorMessageProps: i,
    isSelected: u,
    isPressed: o,
    isDisabled: d,
    isReadOnly: s,
    isInvalid: c,
    validationErrors: f,
    validationDetails: h
  };
}
function wl(e = {}) {
  let { isReadOnly: t } = e, [n, r] = Pe(e.isSelected, e.defaultSelected || !1, e.onChange), [a] = Y(n);
  function l(u) {
    t || r(u);
  }
  function i() {
    t || r(!n);
  }
  return {
    isSelected: n,
    defaultSelected: e.defaultSelected ?? a,
    setSelected: l,
    toggle: i
  };
}
function nD(e, t, n) {
  const r = wl({
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isSelected: t.isSelected(e.value),
    defaultSelected: t.defaultValue.includes(e.value),
    onChange(p) {
      p ? t.addValue(e.value) : t.removeValue(e.value), e.onChange && e.onChange(p);
    }
  });
  let { name: a, form: l, descriptionId: i, errorMessageId: u, validationBehavior: o } = X6.get(t);
  o = e.validationBehavior ?? o;
  let { realtimeValidation: d } = rn({
    ...e,
    value: r.isSelected,
    // Server validation is handled at the group level.
    name: void 0,
    validationBehavior: "aria"
  }), s = T(tr), c = () => {
    t.setInvalid(e.value, d.isInvalid ? d : s.current);
  };
  ee(c);
  let f = t.realtimeValidation.isInvalid ? t.realtimeValidation : d, h = o === "native" ? t.displayValidation : f, m = rh({
    ...e,
    isReadOnly: e.isReadOnly || t.isReadOnly,
    isDisabled: e.isDisabled || t.isDisabled,
    name: e.name || a,
    form: e.form || l,
    isRequired: e.isRequired ?? t.isRequired,
    validationBehavior: o,
    [zn]: {
      realtimeValidation: f,
      displayValidation: h,
      resetValidation: t.resetValidation,
      commitValidation: t.commitValidation,
      updateValidation(p) {
        s.current = p, c();
      }
    }
  }, r, n);
  return {
    ...m,
    inputProps: {
      ...m.inputProps,
      "aria-describedby": [
        m.inputProps["aria-describedby"],
        t.isInvalid ? u : null,
        i
      ].filter(Boolean).join(" ") || void 0
    }
  };
}
const zu = /* @__PURE__ */ G(null), ah = /* @__PURE__ */ G(null), rD = /* @__PURE__ */ G(null), lh = /* @__PURE__ */ G(null);
function aD(e, t) {
  let { validationBehavior: n } = Oe(Un) || {}, r = e.validationBehavior ?? n ?? "native", a = O(rD), l = $e(K(() => xt(t, e.inputRef !== void 0 ? e.inputRef : null), [
    t,
    e.inputRef
  ])), i = {
    ...Et(e),
    children: typeof e.children == "function" ? !0 : e.children,
    value: e.value,
    validationBehavior: r
  };
  return [
    a ? nD(i, a, l) : rh(i, wl(e), l),
    l
  ];
}
const n9 = /* @__PURE__ */ te(function(t, n) {
  let { inputRef: r = null, ...a } = t;
  [t, n] = oe(a, n, zu);
  let [l, i] = aD(t, r);
  return /* @__PURE__ */ g.createElement(lh.Provider, {
    value: {
      ...l,
      inputRef: i,
      defaultClassName: "react-aria-Checkbox",
      isIndeterminate: t.isIndeterminate,
      isRequired: t.isRequired
    }
  }, /* @__PURE__ */ g.createElement(lD, {
    ...t,
    ref: n
  }));
}), lD = /* @__PURE__ */ te(function(t, n) {
  let { labelProps: r, inputProps: a, isSelected: l, isDisabled: i, isReadOnly: u, isPressed: o, isInvalid: d, inputRef: s, defaultClassName: c, isIndeterminate: f, isRequired: h } = O(lh), { isFocused: m, isFocusVisible: p, focusProps: b } = ye(), y = i || u, { hoverProps: $, isHovered: v } = ve({
    ...t,
    isDisabled: y
  }), x = le({
    ...t,
    defaultClassName: c,
    values: {
      isSelected: l,
      isIndeterminate: f || !1,
      isPressed: o,
      isHovered: v,
      isFocused: m,
      isFocusVisible: p,
      isDisabled: i,
      isReadOnly: u,
      isInvalid: d,
      isRequired: h || !1
    }
  }), E = J(t, {
    global: !0
  });
  return delete E.id, delete E.onClick, /* @__PURE__ */ g.createElement(Q.label, {
    ...z(E, r, $, x),
    ref: n,
    slot: t.slot || void 0,
    "data-selected": l || void 0,
    "data-indeterminate": f || void 0,
    "data-pressed": o || void 0,
    "data-hovered": v || void 0,
    "data-focused": m || void 0,
    "data-focus-visible": p || void 0,
    "data-disabled": i || void 0,
    "data-readonly": u || void 0,
    "data-invalid": d || void 0,
    "data-required": h || void 0
  }, /* @__PURE__ */ g.createElement(br, {
    elementType: "span"
  }, /* @__PURE__ */ g.createElement("input", {
    ...z(a, b),
    ref: s
  })), x.children);
}), Ou = /* @__PURE__ */ G(null), r9 = /* @__PURE__ */ te(function(t, n) {
  let { state: r, thumbProps: a, inputXRef: l, inputYRef: i, xInputProps: u, yInputProps: o, isDisabled: d = !1 } = O(Ou), { focusProps: s, isFocused: c, isFocusVisible: f } = ye(), { hoverProps: h, isHovered: m } = ve(t), p = le({
    ...t,
    defaultClassName: "react-aria-ColorThumb",
    defaultStyle: {
      ...a.style,
      backgroundColor: r.getDisplayColor().toString()
    },
    values: {
      color: r.getDisplayColor(),
      isHovered: m,
      isDragging: r.isDragging,
      isFocused: c,
      isFocusVisible: f,
      isDisabled: d
    }
  }), b = J(t, {
    global: !0
  });
  return delete b.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(a, h, b),
    ...p,
    ref: n,
    "data-hovered": m || void 0,
    "data-dragging": r.isDragging || void 0,
    "data-focused": c || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": d || void 0
  }, /* @__PURE__ */ g.createElement("input", {
    ref: l,
    ...u,
    ...s
  }), o && /* @__PURE__ */ g.createElement("input", {
    ref: i,
    ...o,
    ...s
  }), p.children);
});
var ih = {};
ih = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "أداة انتقاء اللون",
  colorSwatch: "تغيير الألوان",
  transparent: "شفاف",
  twoDimensionalSlider: "مُنزلق 2D"
};
var uh = {};
uh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Средство за избиране на цвят",
  colorSwatch: "цветна мостра",
  transparent: "прозрачен",
  twoDimensionalSlider: "2D плъзгач"
};
var oh = {};
oh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Výběr barvy",
  colorSwatch: "barevný vzorek",
  transparent: "průhledný",
  twoDimensionalSlider: "2D posuvník"
};
var sh = {};
sh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Farvevælger",
  colorSwatch: "farveprøve",
  transparent: "gennemsigtig",
  twoDimensionalSlider: "2D-skyder"
};
var dh = {};
dh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Farbwähler",
  colorSwatch: "Farbfeld",
  transparent: "transparent",
  twoDimensionalSlider: "2D-Schieberegler"
};
var ch = {};
ch = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Επιλογέας χρωμάτων",
  colorSwatch: "χρωματικό δείγμα",
  transparent: "διαφανές",
  twoDimensionalSlider: "Ρυθμιστικό 2D"
};
var fh = {};
fh = {
  colorPicker: "Color picker",
  twoDimensionalSlider: "2D slider",
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorSwatch: "color swatch",
  transparent: "transparent"
};
var hh = {};
hh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Selector de color",
  colorSwatch: "muestra de color",
  transparent: "transparente",
  twoDimensionalSlider: "Regulador 2D"
};
var mh = {};
mh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Värvivalija",
  colorSwatch: "värvinäidis",
  transparent: "läbipaistev",
  twoDimensionalSlider: "2D-liugur"
};
var ph = {};
ph = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Värimuokkain",
  colorSwatch: "värimalli",
  transparent: "läpinäkyvä",
  twoDimensionalSlider: "2D-liukusäädin"
};
var bh = {};
bh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name} : ${e.value}`,
  colorPicker: "Sélecteur de couleurs",
  colorSwatch: "Échantillon de couleurs",
  transparent: "Transparent",
  twoDimensionalSlider: "Curseur 2D"
};
var gh = {};
gh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "בוחר הצבעים",
  colorSwatch: "דוגמית צבע",
  transparent: "שקוף",
  twoDimensionalSlider: "מחוון דו מימדי"
};
var yh = {};
yh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Odabir boje",
  colorSwatch: "uzorak boje",
  transparent: "transparentno",
  twoDimensionalSlider: "2D klizač"
};
var $h = {};
$h = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Színválasztó",
  colorSwatch: "színtár",
  transparent: "átlátszó",
  twoDimensionalSlider: "2D-csúszka"
};
var vh = {};
vh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Selettore colore",
  colorSwatch: "campione di colore",
  transparent: "trasparente",
  twoDimensionalSlider: "Cursore 2D"
};
var Dh = {};
Dh = {
  colorInputLabel: (e) => `${e.label}、${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name} : ${e.value}`,
  colorPicker: "カラーピッカー",
  colorSwatch: "カラースウォッチ",
  transparent: "透明",
  twoDimensionalSlider: "2D スライダー"
};
var xh = {};
xh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "색상 피커",
  colorSwatch: "색상 견본",
  transparent: "투명도",
  twoDimensionalSlider: "2D 슬라이더"
};
var Eh = {};
Eh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Spalvų parinkiklis",
  colorSwatch: "spalvų pavyzdys",
  transparent: "skaidrus",
  twoDimensionalSlider: "2D slankiklis"
};
var Ch = {};
Ch = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Krāsu atlasītājs",
  colorSwatch: "krāsu paraugs",
  transparent: "caurspīdīgs",
  twoDimensionalSlider: "2D slīdnis"
};
var Ph = {};
Ph = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Fargevelger",
  colorSwatch: "fargekart",
  transparent: "gjennomsiktig",
  twoDimensionalSlider: "2D-glidebryter"
};
var wh = {};
wh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Kleurkiezer",
  colorSwatch: "kleurstaal",
  transparent: "transparant",
  twoDimensionalSlider: "2D-schuifregelaar"
};
var Sh = {};
Sh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Próbnik kolorów",
  colorSwatch: "próbka koloru",
  transparent: "przezroczysty",
  twoDimensionalSlider: "Suwak 2D"
};
var kh = {};
kh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Seletor de cores",
  colorSwatch: "amostra de cores",
  transparent: "transparente",
  twoDimensionalSlider: "Controle deslizante 2D"
};
var Bh = {};
Bh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Seletor de cores",
  colorSwatch: "amostra de cor",
  transparent: "transparente",
  twoDimensionalSlider: "Controle deslizante 2D"
};
var Fh = {};
Fh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Selector de culori",
  colorSwatch: "specimen de culoare",
  transparent: "transparent",
  twoDimensionalSlider: "Glisor 2D"
};
var Ah = {};
Ah = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Палитра цветов",
  colorSwatch: "цветовой образец",
  transparent: "прозрачный",
  twoDimensionalSlider: "Ползунок 2D"
};
var Rh = {};
Rh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Výber farieb",
  colorSwatch: "vzorkovník farieb",
  transparent: "transparentný",
  twoDimensionalSlider: "2D jazdec"
};
var Th = {};
Th = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Izbirnik barv",
  colorSwatch: "barvna paleta",
  transparent: "prozorno",
  twoDimensionalSlider: "2D drsnik"
};
var Ih = {};
Ih = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Birač boja",
  colorSwatch: "Uzorak boje",
  transparent: "providno",
  twoDimensionalSlider: "2D klizač"
};
var Mh = {};
Mh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Färgväljaren",
  colorSwatch: "färgruta",
  transparent: "genomskinlig",
  twoDimensionalSlider: "2D-reglage"
};
var Kh = {};
Kh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Renk Seçici",
  colorSwatch: "renk örneği",
  transparent: "saydam",
  twoDimensionalSlider: "2D sürgü"
};
var Nh = {};
Nh = {
  colorInputLabel: (e) => `${e.label}, ${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}: ${e.value}`,
  colorPicker: "Палітра кольорів",
  colorSwatch: "зразок кольору",
  transparent: "прозорий",
  twoDimensionalSlider: "Повзунок 2D"
};
var Vh = {};
Vh = {
  colorInputLabel: (e) => `${e.label}、${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}：${e.value}`,
  colorPicker: "拾色器",
  colorSwatch: "颜色色板",
  transparent: "透明",
  twoDimensionalSlider: "2D 滑块"
};
var Lh = {};
Lh = {
  colorInputLabel: (e) => `${e.label}，${e.channelLabel}`,
  colorNameAndValue: (e) => `${e.name}：${e.value}`,
  colorPicker: "檢色器",
  colorSwatch: "色票",
  transparent: "透明",
  twoDimensionalSlider: "2D 滑桿"
};
var Hu = {};
Hu = {
  "ar-AE": ih,
  "bg-BG": uh,
  "cs-CZ": oh,
  "da-DK": sh,
  "de-DE": dh,
  "el-GR": ch,
  "en-US": fh,
  "es-ES": hh,
  "et-EE": mh,
  "fi-FI": ph,
  "fr-FR": bh,
  "he-IL": gh,
  "hr-HR": yh,
  "hu-HU": $h,
  "it-IT": vh,
  "ja-JP": Dh,
  "ko-KR": xh,
  "lt-LT": Eh,
  "lv-LV": Ch,
  "nb-NO": Ph,
  "nl-NL": wh,
  "pl-PL": Sh,
  "pt-BR": kh,
  "pt-PT": Bh,
  "ro-RO": Fh,
  "ru-RU": Ah,
  "sk-SK": Rh,
  "sl-SI": Th,
  "sr-SP": Ih,
  "sv-SE": Mh,
  "tr-TR": Kh,
  "uk-UA": Nh,
  "zh-CN": Vh,
  "zh-TW": Lh
};
var zh = {};
zh = {
  alpha: "ألفا",
  black: "أسود",
  blue: "أزرق",
  "blue purple": "أرجواني مزرق",
  brightness: "السطوع",
  brown: "بني",
  "brown yellow": "أصفر بني",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "سماوي",
  "cyan blue": "أزرق سماوي",
  dark: "داكن",
  gray: "رمادي",
  grayish: "مائل للرمادي",
  green: "أخضر",
  "green cyan": "سماوي مخضر",
  hue: "درجة اللون",
  light: "فاتح",
  lightness: "الإضاءة",
  magenta: "أرجواني",
  "magenta pink": "أرجواني وردي",
  orange: "برتقالي",
  "orange yellow": "أصفر برتقالي",
  pale: "باهت",
  pink: "وردي",
  "pink red": "أحمر وردي",
  purple: "أرجواني",
  "purple magenta": "بنفسجي",
  red: "أحمر",
  "red orange": "برتقالي محمر",
  saturation: "التشبع",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} شفاف`,
  "very dark": "داكن جدًا",
  "very light": "فاتح جدًا",
  vibrant: "ساطع",
  white: "أبيض",
  yellow: "أصفر",
  "yellow green": "أخضر مصفر"
};
var Oh = {};
Oh = {
  alpha: "Алфа",
  black: "черно",
  blue: "Синьо",
  "blue purple": "синьо лилаво",
  brightness: "Яркост",
  brown: "кафяво",
  "brown yellow": "кафяво жълто",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "циан",
  "cyan blue": "циан синьо",
  dark: "тъмно",
  gray: "сиво",
  grayish: "сивкав",
  green: "Зелено",
  "green cyan": "зелен циан",
  hue: "Оттенък",
  light: "светло",
  lightness: "Лекота",
  magenta: "магента",
  "magenta pink": "магента розово",
  orange: "оранжево",
  "orange yellow": "оранжево жълто",
  pale: "бледо",
  pink: "розово",
  "pink red": "розово червено",
  purple: "лилаво",
  "purple magenta": "лилаво магента",
  red: "Червено",
  "red orange": "червен портокал",
  saturation: "Наситеност",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} прозрачен`,
  "very dark": "много тъмно",
  "very light": "много светло",
  vibrant: " ярко",
  white: "бяло",
  yellow: "жълто",
  "yellow green": "жълто зелен"
};
var Hh = {};
Hh = {
  alpha: "Alfa",
  black: "černá",
  blue: "Modrá",
  "blue purple": "modrofialová",
  brightness: "Jas",
  brown: "hnědá",
  "brown yellow": "hnědožlutá",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "tyrkysová",
  "cyan blue": "tyrkysovomodrá",
  dark: "tmavá",
  gray: "šedá",
  grayish: "našedlá",
  green: "Zelená",
  "green cyan": "zelenotyrkysová",
  hue: "Odstín",
  light: "světlá",
  lightness: "Světlost",
  magenta: "purpurová",
  "magenta pink": "purpurově růžová",
  orange: "oranžová",
  "orange yellow": "oranžovožlutá",
  pale: "bledá",
  pink: "růžová",
  "pink red": "růžovočervená",
  purple: "fialová",
  "purple magenta": "fialově purpurová",
  red: "Červená",
  "red orange": "červenooranžová",
  saturation: "Sytost",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} průhledné`,
  "very dark": "velmi tmavá",
  "very light": "velmi světlá",
  vibrant: "zářivá",
  white: "bílá",
  yellow: "žlutá",
  "yellow green": "žlutozelená"
};
var Uh = {};
Uh = {
  alpha: "Alfa",
  black: "sort",
  blue: "Blå",
  "blue purple": "blålilla",
  brightness: "Lysstyrke",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyan",
  "cyan blue": "cyan blå",
  dark: "mørk",
  gray: "grå",
  grayish: "grålig",
  green: "Grøn",
  "green cyan": "grøn cyan",
  hue: "Tone",
  light: "lys",
  lightness: "Lyshed",
  magenta: "magenta",
  "magenta pink": "magenta pink",
  orange: "orange",
  "orange yellow": "orangegul",
  pale: "bleg",
  pink: "lyserød",
  "pink red": "lyserødlig rød",
  purple: "lilla",
  "purple magenta": "lilla magenta",
  red: "Rød",
  "red orange": "rødorange",
  saturation: "Farvemætning",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} gennemsigtig`,
  "very dark": "meget mørk",
  "very light": "meget lys",
  vibrant: "klar",
  white: "hvid",
  yellow: "gul",
  "yellow green": "gulgrøn"
};
var jh = {};
jh = {
  alpha: "Alpha",
  black: "Schwarz",
  blue: "Blau",
  "blue purple": "Blaulila",
  brightness: "Helligkeit",
  brown: "Braun",
  "brown yellow": "Braungelb",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "Cyan",
  "cyan blue": "Cyanblau",
  dark: "dunkles",
  gray: "Grau",
  grayish: "gräuliches",
  green: "Grün",
  "green cyan": "Grüncyan",
  hue: "Farbton",
  light: "helles",
  lightness: "Leuchtkraft",
  magenta: "Magenta",
  "magenta pink": "Magentarosa",
  orange: "Orange",
  "orange yellow": "Orangegelb",
  pale: "blasses",
  pink: "Rosa",
  "pink red": "Rosarot",
  purple: "Lila",
  "purple magenta": "Lilamagenta",
  red: "Rot",
  "red orange": "Rotorange",
  saturation: "Sättigung",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, zu ${e.percentTransparent} transparent`,
  "very dark": "sehr dunkles",
  "very light": "sehr helles",
  vibrant: "lebhaftes",
  white: "Weiß",
  yellow: "Gelb",
  "yellow green": "Gelbgrün"
};
var _h = {};
_h = {
  alpha: "Άλφα",
  black: "μαύρο",
  blue: "Μπλε",
  "blue purple": "μπλε μωβ",
  brightness: "Φωτεινότητα",
  brown: "καφέ",
  "brown yellow": "καφέ κίτρινο",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "κυανό",
  "cyan blue": "κυανό μπλε",
  dark: "σκούρο",
  gray: "γκρι",
  grayish: "γκριζωπό",
  green: "Πράσινο",
  "green cyan": "πράσινο κυανό",
  hue: "Τόνος",
  light: "ανοιχτό",
  lightness: "Φωτεινότητα",
  magenta: "ματζέντα",
  "magenta pink": "ματζέντα ροζ",
  orange: "πορτοκαλί",
  "orange yellow": "πορτοκαλί κίτρινο",
  pale: "ανοιχτό",
  pink: "ροζ",
  "pink red": "ροζ κόκκινο",
  purple: "μωβ",
  "purple magenta": "μωβ ματζέντα",
  red: "Κόκκινο",
  "red orange": "κόκκινο πορτοκαλί",
  saturation: "Κορεσμός",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} διαφανές`,
  "very dark": "πολύ σκούρο",
  "very light": "πολύ ανοιχτό",
  vibrant: "έντονο",
  white: "λευκό",
  yellow: "κίτρινο",
  "yellow green": "κίτρινο πράσινο"
};
var Wh = {};
Wh = {
  hue: "Hue",
  saturation: "Saturation",
  lightness: "Lightness",
  brightness: "Brightness",
  red: "Red",
  green: "Green",
  blue: "Blue",
  alpha: "Alpha",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparent`,
  "very dark": "very dark",
  dark: "dark",
  light: "light",
  "very light": "very light",
  pale: "pale",
  grayish: "grayish",
  vibrant: "vibrant",
  black: "black",
  white: "white",
  gray: "gray",
  pink: "pink",
  "pink red": "pink red",
  "red orange": "red orange",
  brown: "brown",
  orange: "orange",
  "orange yellow": "orange yellow",
  "brown yellow": "brown yellow",
  yellow: "yellow",
  "yellow green": "yellow green",
  "green cyan": "green cyan",
  cyan: "cyan",
  "cyan blue": "cyan blue",
  "blue purple": "blue purple",
  purple: "purple",
  "purple magenta": "purple magenta",
  magenta: "magenta",
  "magenta pink": "magenta pink"
};
var Gh = {};
Gh = {
  alpha: "Alpha",
  black: "negro",
  blue: "Azul",
  "blue purple": "púrpura azulado",
  brightness: "Brillo",
  brown: "marrón",
  "brown yellow": "amarillo amarronado",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cian",
  "cyan blue": "azul cian",
  dark: "oscuro",
  gray: "gris",
  grayish: "grisáceo",
  green: "Verde",
  "green cyan": "cian verdoso",
  hue: "Tono",
  light: "claro",
  lightness: "Luminosidad",
  magenta: "magenta",
  "magenta pink": "rosa magenta",
  orange: "naranja",
  "orange yellow": "amarillo anaranjado",
  pale: "pálido",
  pink: "rosa",
  "pink red": "rojo rosado",
  purple: "morado",
  "purple magenta": "magenta violáceo",
  red: "Rojo",
  "red orange": "naranja rojizo",
  saturation: "Saturación",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparente`,
  "very dark": "muy oscuro",
  "very light": "muy claro",
  vibrant: "intenso",
  white: "blanco",
  yellow: "amarillo",
  "yellow green": "verde amarillento"
};
var qh = {};
qh = {
  alpha: "Alfa",
  black: "must",
  blue: "Sinine",
  "blue purple": "sinakaslilla",
  brightness: "Heledus",
  brown: "pruun",
  "brown yellow": "pruunikaskollane",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "tsüaan",
  "cyan blue": "tsüaansinine",
  dark: "tume",
  gray: "hall",
  grayish: "hallikas",
  green: "Roheline",
  "green cyan": "tsüaanroheline",
  hue: "Värv",
  light: "valgus",
  lightness: "Valgus",
  magenta: "magentapunane",
  "magenta pink": "magentaroosa",
  orange: "oranž",
  "orange yellow": "oranžikaskollane",
  pale: "kahvatu",
  pink: "roosa",
  "pink red": "vaarikapunane",
  purple: "lilla",
  "purple magenta": "purpurne magenta",
  red: "Punane",
  "red orange": "punakasoranž",
  saturation: "Küllastus",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} läbipaistev`,
  "very dark": "väga tume",
  "very light": "väga hele",
  vibrant: "ere",
  white: "valge",
  yellow: "kollane",
  "yellow green": "kollakasroheline"
};
var Yh = {};
Yh = {
  alpha: "Alpha",
  black: "musta",
  blue: "Sininen",
  "blue purple": "sinivioletti",
  brightness: "Kirkkaus",
  brown: "ruskea",
  "brown yellow": "ruskeankeltainen",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "syaani",
  "cyan blue": "syaaninsininen",
  dark: "tumma",
  gray: "harmaa",
  grayish: "harmahtava",
  green: "Vihreä",
  "green cyan": "vihreänsyaani",
  hue: "Sävy",
  light: "vaalea",
  lightness: "Valomäärä",
  magenta: "magenta",
  "magenta pink": "magentapinkki",
  orange: "oranssi",
  "orange yellow": "oranssinkeltainen",
  pale: "vaalea",
  pink: "pinkki",
  "pink red": "vaaleanpunainen",
  purple: "violetti",
  "purple magenta": "violettimagenta",
  red: "Punainen",
  "red orange": "punaoranssi",
  saturation: "Värikylläisyys",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} läpinäkyvä`,
  "very dark": "hyvin tumma",
  "very light": "erittäin vaalea",
  vibrant: "eloisa",
  white: "valkea",
  yellow: "keltainen",
  "yellow green": "keltavihreä"
};
var Zh = {};
Zh = {
  alpha: "Alpha",
  black: "Noir",
  blue: "Bleu",
  "blue purple": "Violet bleu",
  brightness: "Luminosité",
  brown: "Brun",
  "brown yellow": "Jaune brun",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "Cyan",
  "cyan blue": "Bleu cyan",
  dark: "Sombre",
  gray: "Gris",
  grayish: "Grisâtre",
  green: "Vert",
  "green cyan": "Cyan vert",
  hue: "Teinte",
  light: "Clair",
  lightness: "Luminosité",
  magenta: "Magenta",
  "magenta pink": "Rose magenta",
  orange: "Orange",
  "orange yellow": "Jaune orangé",
  pale: "Pâle",
  pink: "Rose",
  "pink red": "Rouge rosé",
  purple: "Violet",
  "purple magenta": "Magenta violet",
  red: "Rouge",
  "red orange": "Orange rouge",
  saturation: "Saturation",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparent`,
  "very dark": "Très sombre",
  "very light": "Très clair",
  vibrant: "Vif",
  white: "Blanc",
  yellow: "Jaune",
  "yellow green": "Vert jaune"
};
var Xh = {};
Xh = {
  alpha: "אלפא",
  black: "שחור",
  blue: "כחול",
  "blue purple": "כחול סגול",
  brightness: "בהירות",
  brown: "חום",
  "brown yellow": "חום צהוב",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "טורקיז",
  "cyan blue": "כחול ציאן",
  dark: "כהה",
  gray: "אפור",
  grayish: "אפרפר",
  green: "ירוק",
  "green cyan": "ציאן ירוק",
  hue: "גוון",
  light: "אור",
  lightness: "כמות אור",
  magenta: "מג'נטה",
  "magenta pink": "ורוד מג'נטה",
  orange: "כתום",
  "orange yellow": "כתום צהוב",
  pale: "חיוור",
  pink: "ורוד",
  "pink red": "ורוד אדום",
  purple: "סגול",
  "purple magenta": "מג'נטה סגול",
  red: "אדום",
  "red orange": "כתום אדום",
  saturation: "רוויה",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} שקוף`,
  "very dark": "כהה מאוד",
  "very light": "בהיר מאוד",
  vibrant: "תוסס",
  white: "לבן",
  yellow: "צהוב",
  "yellow green": "צהוב ירוק"
};
var Jh = {};
Jh = {
  alpha: "Alfa",
  black: "crno",
  blue: "Plava",
  "blue purple": "plavo ljubičasta",
  brightness: "Svjetlina",
  brown: "smeđa",
  "brown yellow": "smeđe žuta",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cijan",
  "cyan blue": "cijan plava",
  dark: "tamno",
  gray: "siva",
  grayish: "sivkasto",
  green: "Zelena",
  "green cyan": "zelena cijan",
  hue: "Nijansa",
  light: "svjetlo",
  lightness: "Osvijetljenost",
  magenta: "magenta",
  "magenta pink": "magentno ružičasta",
  orange: "narančasta",
  "orange yellow": "narančasto žuta",
  pale: "blijeda",
  pink: "ružičasta",
  "pink red": "ružičasto crvena",
  purple: "ljubičasta",
  "purple magenta": "ljubičasta magenta",
  red: "Crvena",
  "red orange": "crveno narančasta",
  saturation: "Zasićenost",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} prozirnosti`,
  "very dark": "jako tamna",
  "very light": "vrlo svijetlo",
  vibrant: "vibrantna",
  white: "bijela",
  yellow: "žuto",
  "yellow green": "žuto zelena"
};
var Qh = {};
Qh = {
  alpha: "Alfa",
  black: "fekete",
  blue: "Kék",
  "blue purple": "kék lila",
  brightness: "Fényesség",
  brown: "barna",
  "brown yellow": "barna sárga",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciánkék",
  "cyan blue": "ciánkék",
  dark: "sötét",
  gray: "szürke",
  grayish: "szürkés",
  green: "Zöld",
  "green cyan": "zöld ciánkék",
  hue: "Színárnyalat",
  light: "világos",
  lightness: "Világosság",
  magenta: "bíbor",
  "magenta pink": "bíbor rózsaszín",
  orange: "narancs",
  "orange yellow": "narancssárga",
  pale: "halvány",
  pink: "rózsaszín",
  "pink red": "rózsaszín piros",
  purple: "lila",
  "purple magenta": "lila bíbor",
  red: "Piros",
  "red orange": "piros narancs",
  saturation: "Telítettség",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} átlátszó`,
  "very dark": "nagyon sötét",
  "very light": "nagyon világos",
  vibrant: "élénk",
  white: "fehér",
  yellow: "sárga",
  "yellow green": "sárga zöld"
};
var e3 = {};
e3 = {
  alpha: "Alfa",
  black: "nero",
  blue: "Blu",
  "blue purple": "blu viola",
  brightness: "Luminosità",
  brown: "marrone",
  "brown yellow": "giallo bruno",
  colorName: (e) => `${e.hue} ${e.chroma} ${e.lightness}`,
  cyan: "ciano",
  "cyan blue": "blu ciano",
  dark: "scuro",
  gray: "grigio",
  grayish: "grigiastro",
  green: "Verde",
  "green cyan": "verde ciano",
  hue: "Tonalità",
  light: "chiaro",
  lightness: "Luminosità",
  magenta: "magenta",
  "magenta pink": "rosa magenta",
  orange: "arancio",
  "orange yellow": "giallo arancio",
  pale: "tenue",
  pink: "rosa",
  "pink red": "rosa rosso",
  purple: "viola",
  "purple magenta": "viola magenta",
  red: "Rosso",
  "red orange": "rosso arancio",
  saturation: "Saturazione",
  transparentColorName: (e) => `${e.hue} ${e.chroma} ${e.lightness}, trasparenza ${e.percentTransparent}`,
  "very dark": "molto scuro",
  "very light": "molto chiaro",
  vibrant: "vivace",
  white: "bianco",
  yellow: "giallo",
  "yellow green": "giallo verde"
};
var t3 = {};
t3 = {
  alpha: "アルファ",
  black: "ブラック",
  blue: "青",
  "blue purple": "ブルーパープル",
  brightness: "明るさ",
  brown: "ブラウン",
  "brown yellow": "ブラウンイエロー",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "シアン",
  "cyan blue": "シアンブルー",
  dark: "ダーク",
  gray: "グレー",
  grayish: "グレイッシュ",
  green: "緑",
  "green cyan": "グリーンシアン",
  hue: "色相",
  light: "ライト",
  lightness: "明度",
  magenta: "マゼンタ",
  "magenta pink": "マゼンタピンク",
  orange: "オレンジ",
  "orange yellow": "オレンジイエロー",
  pale: "ペール",
  pink: "ピンク",
  "pink red": "ピンクレッド",
  purple: "パープル",
  "purple magenta": "パープルマゼンタ",
  red: "赤",
  "red orange": "レッドオレンジ",
  saturation: "彩度",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} 透明`,
  "very dark": "最も暗い",
  "very light": "ベリーライト",
  vibrant: "鮮やか",
  white: "ホワイト",
  yellow: "イエロー",
  "yellow green": "イエローグリーン"
};
var n3 = {};
n3 = {
  alpha: "알파",
  black: "검은색",
  blue: "파랑",
  "blue purple": "청자색",
  brightness: "명도",
  brown: "갈색",
  "brown yellow": "황갈색",
  colorName: (e) => `${e.lightness}, ${e.chroma}, ${e.hue}`,
  cyan: "청록색",
  "cyan blue": "청록색",
  dark: "다크",
  gray: "회색",
  grayish: "회갈색",
  green: "초록",
  "green cyan": "청록색",
  hue: "색조",
  light: "라이트",
  lightness: "밝기",
  magenta: "자홍색",
  "magenta pink": "마젠타 핑크",
  orange: "주황색",
  "orange yellow": "불그스름한 노랑",
  pale: "흙색",
  pink: "분홍색",
  "pink red": "핑크 레드",
  purple: "자주색",
  "purple magenta": "보라빛 자홍색",
  red: "빨강",
  "red orange": "붉은 주황색",
  saturation: "채도",
  transparentColorName: (e) => `${e.lightness}, ${e.chroma}, ${e.hue}, ${e.percentTransparent} 투명도`,
  "very dark": "매우 어두운",
  "very light": "매우 연함",
  vibrant: "강렬한",
  white: "흰색",
  yellow: "노란색",
  "yellow green": "연두색"
};
var r3 = {};
r3 = {
  alpha: "Alfa",
  black: "juoda",
  blue: "Mėlyna",
  "blue purple": "melsvai violetinė",
  brightness: "Ryškumas",
  brown: "ruda",
  "brown yellow": "rusvai geltona",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "žalsvai mėlyna",
  "cyan blue": "žalsvai mėlyna",
  dark: "tamsi",
  gray: "pilka",
  grayish: "pilkšva",
  green: "Žalia",
  "green cyan": "žalsvai mėlyna",
  hue: "Atspalvis",
  light: "šviesi",
  lightness: "Šviesumas",
  magenta: "rausvai raudona",
  "magenta pink": "purpurinė",
  orange: "oranžinė",
  "orange yellow": "oranžinio atspalvio geltona",
  pale: "blyški",
  pink: "rožinė",
  "pink red": "rožinė raudona",
  purple: "violetinė",
  "purple magenta": "purpurinė rausvai raudona",
  red: "Raudona",
  "red orange": "rausvai oranžinė",
  saturation: "Įsotinimas",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} skaidri`,
  "very dark": "labai tamsi",
  "very light": "labai šviesi",
  vibrant: "ryški",
  white: "balta",
  yellow: "geltona",
  "yellow green": "gelsvai žalia"
};
var a3 = {};
a3 = {
  alpha: "Alfa",
  black: "melns",
  blue: "Zila",
  "blue purple": "zili violets",
  brightness: "Spilgtums",
  brown: "brūns",
  "brown yellow": "brūni dzeltens",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciāns",
  "cyan blue": "ciāna zils",
  dark: "tumšs",
  gray: "pelēks",
  grayish: "pelēcīgs",
  green: "Zaļa",
  "green cyan": "zaļš ciāns",
  hue: "Nokrāsa",
  light: "gaišs",
  lightness: "Gaišums",
  magenta: "fuksiju",
  "magenta pink": "fuksiju rozā",
  orange: "oranžs",
  "orange yellow": "oranži dzeltens",
  pale: "bāls",
  pink: "rozā",
  "pink red": "rozīgi sarkans",
  purple: "violets",
  "purple magenta": "violets fuksiju",
  red: "Sarkana",
  "red orange": "sarkanīgi oranžs",
  saturation: "Piesātinājums",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} caurspīdīgs`,
  "very dark": "ļoti tumšs",
  "very light": "ļoti gaišs",
  vibrant: "košs",
  white: "balts",
  yellow: "dzeltens",
  "yellow green": "dzelteni zaļš"
};
var l3 = {};
l3 = {
  alpha: "Alfa",
  black: "svart",
  blue: "Blå",
  "blue purple": "blålilla",
  brightness: "Lysstyrke",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyan",
  "cyan blue": "cyanblå",
  dark: "mørk",
  gray: "grå",
  grayish: "gråaktig",
  green: "Grønn",
  "green cyan": "grønncyan",
  hue: "Fargetone",
  light: "lys",
  lightness: "Lyshet",
  magenta: "magenta",
  "magenta pink": "magentarosa",
  orange: "oransje",
  "orange yellow": "oransjegul",
  pale: "blek",
  pink: "rosa",
  "pink red": "rosarød",
  purple: "lilla",
  "purple magenta": "lillamagenta",
  red: "Rød",
  "red orange": "rødoransje",
  saturation: "Metning",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} gjennomsiktig`,
  "very dark": "svært mørk",
  "very light": "svært lys",
  vibrant: "levende",
  white: "hvit",
  yellow: "gul",
  "yellow green": "gulgrønn"
};
var i3 = {};
i3 = {
  alpha: "Alfa",
  black: "zwart",
  blue: "Blauw",
  "blue purple": "paarsblauw",
  brightness: "Helderheid",
  brown: "bruin",
  "brown yellow": "bruingeel",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyaan",
  "cyan blue": "cyaanblauw",
  dark: "donker",
  gray: "grijs",
  grayish: "grijsachtig",
  green: "Groen",
  "green cyan": "cyaangroen",
  hue: "Kleurtoon",
  light: "licht",
  lightness: "Lichtsterkte",
  magenta: "magenta",
  "magenta pink": "magentaroze",
  orange: "oranje",
  "orange yellow": "oranjegeel",
  pale: "bleek",
  pink: "roze",
  "pink red": "rozerood",
  purple: "paars",
  "purple magenta": "magentapaars",
  red: "Rood",
  "red orange": "roodoranje",
  saturation: "Verzadiging",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparant`,
  "very dark": "heel donker",
  "very light": "heel licht",
  vibrant: "levendig",
  white: "wit",
  yellow: "geel",
  "yellow green": "geelgroen"
};
var u3 = {};
u3 = {
  alpha: "Alfa",
  black: "czarny",
  blue: "Niebieski",
  "blue purple": "niebiesko-fioletowy",
  brightness: "Jasność",
  brown: "brązowy",
  "brown yellow": "brązowo-żółty",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyjanowy",
  "cyan blue": "cyjanowo-niebieski",
  dark: "ciemny",
  gray: "szary",
  grayish: "szarawy",
  green: "Zielony",
  "green cyan": "zielono-cyjanowy",
  hue: "Odcień",
  light: "jasny",
  lightness: "Jaskrawość",
  magenta: "purpurowy",
  "magenta pink": "purpurowo-różowy",
  orange: "pomarańczowy",
  "orange yellow": "pomarańczowo-żółty",
  pale: "blady",
  pink: "różowy",
  "pink red": "różowo-czerwony",
  purple: "fioletowy",
  "purple magenta": "fioletowo-purpurowy",
  red: "Czerwony",
  "red orange": "czerwono-pomarańczowy",
  saturation: "Nasycenie",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} przezroczystości`,
  "very dark": "bardzo ciemny",
  "very light": "bardzo jasny",
  vibrant: "intensywny",
  white: "biały",
  yellow: "żółty",
  "yellow green": "żółto-zielony"
};
var o3 = {};
o3 = {
  alpha: "Alfa",
  black: "preto",
  blue: "Azul",
  "blue purple": "roxo azulado",
  brightness: "Brilho",
  brown: "marrom",
  "brown yellow": "marrom amarelado",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciano",
  "cyan blue": "azul-ciano",
  dark: "escuro",
  gray: "cinza",
  grayish: "acinzentado",
  green: "Verde",
  "green cyan": "verde-ciano",
  hue: "Matiz",
  light: "claro",
  lightness: "Luminosidade",
  magenta: "magenta",
  "magenta pink": "rosa-magenta",
  orange: "laranja",
  "orange yellow": "amarelo alaranjado",
  pale: "pálido",
  pink: "rosa",
  "pink red": "rosa avermelhado",
  purple: "roxo",
  "purple magenta": "roxo-magenta",
  red: "Vermelho",
  "red orange": "laranja avermelhado",
  saturation: "Saturação",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparente`,
  "very dark": "muito escuro",
  "very light": "muito claro",
  vibrant: "vibrante",
  white: "branco",
  yellow: "amarelo",
  "yellow green": "verde amarelado"
};
var s3 = {};
s3 = {
  alpha: "Alfa",
  black: "preto",
  blue: "Azul",
  "blue purple": "azul-púrpura",
  brightness: "Luminosidade",
  brown: "castanho",
  "brown yellow": "amarelo-castanho",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "ciano",
  "cyan blue": "azul-ciano",
  dark: "escuro",
  gray: "cinzento",
  grayish: "acinzentado",
  green: "Verde",
  "green cyan": "verde-ciano",
  hue: "Tonalidade",
  light: "claro",
  lightness: "Claridade",
  magenta: "magenta",
  "magenta pink": "rosa-magenta",
  orange: "laranja",
  "orange yellow": "amarelo-laranja",
  pale: "pálido",
  pink: "cor-de-rosa",
  "pink red": "vermelho-rosa",
  purple: "púrpura",
  "purple magenta": "púrpura-magenta",
  red: "Vermelho",
  "red orange": "laranja-vermelho",
  saturation: "Saturação",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparente`,
  "very dark": "muito escuro",
  "very light": "muito claro",
  vibrant: "vibrante",
  white: "branco",
  yellow: "amarelo",
  "yellow green": "verde-amarelo"
};
var d3 = {};
d3 = {
  alpha: "Alfa",
  black: "negru",
  blue: "Albastru",
  "blue purple": "albastru-violet",
  brightness: "Luminozitate",
  brown: "maro",
  "brown yellow": "galben maro",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "bleu",
  "cyan blue": "albastru-bleu",
  dark: "închis",
  gray: "gri",
  grayish: "cenușiu",
  green: "Verde",
  "green cyan": "verde bleu",
  hue: "Nuanță",
  light: "deschis",
  lightness: "Luminozitate",
  magenta: "fucsia",
  "magenta pink": "roz-fucsia",
  orange: "portocaliu",
  "orange yellow": "galben-portocaliu",
  pale: "pal",
  pink: "roz",
  "pink red": "roz-roșu",
  purple: "violet",
  "purple magenta": "violet-fucsia",
  red: "Roșu",
  "red orange": "portocaliu-roșu",
  saturation: "Saturație",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} transparent`,
  "very dark": "foarte închis",
  "very light": "foarte deschis",
  vibrant: "plin de viață",
  white: "alb",
  yellow: "galben",
  "yellow green": "galben-verde"
};
var c3 = {};
c3 = {
  alpha: "Альфа",
  black: "черный",
  blue: "Синий",
  "blue purple": "сине-фиолетовый",
  brightness: "Яркость",
  brown: "коричневый",
  "brown yellow": "коричнево-желтый",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "голубой",
  "cyan blue": "цвет морской волны",
  dark: "темный",
  gray: "серый",
  grayish: "сероватый",
  green: "Зеленый",
  "green cyan": "сине-зеленый",
  hue: "Оттенок",
  light: "светлый",
  lightness: "Освещенность",
  magenta: "пурпурный",
  "magenta pink": "пурпурно-розовый",
  orange: "оранжевый",
  "orange yellow": "оранжево-желтый",
  pale: "бледный",
  pink: "розовый",
  "pink red": "розово-красный",
  purple: "фиолетовый",
  "purple magenta": "фиолетово-пурпурный",
  red: "Красный",
  "red orange": "красно-оранжевый",
  saturation: "Насыщенность",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, прозрачный на ${e.percentTransparent}`,
  "very dark": "очень темный",
  "very light": "очень светлый",
  vibrant: "яркий",
  white: "белый",
  yellow: "желтый",
  "yellow green": "желто-зеленый"
};
var f3 = {};
f3 = {
  alpha: "Alfa",
  black: "čierna",
  blue: "Modrá",
  "blue purple": "modrofialová",
  brightness: "Jas",
  brown: "hnedá",
  "brown yellow": "hnedožltá",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "azúrová",
  "cyan blue": "azúrová modrá",
  dark: "tmavá",
  gray: "sivá",
  grayish: "sivastá",
  green: "Zelená",
  "green cyan": "zelená azúrová",
  hue: "Odtieň",
  light: "svetlá",
  lightness: "Svetlosť",
  magenta: "purpurová",
  "magenta pink": "ružová purpurová",
  orange: "oranžová",
  "orange yellow": "oranžovožltá",
  pale: "bledá",
  pink: "ružová",
  "pink red": "ružovočervená",
  purple: "fialová",
  "purple magenta": "fialová purpurová",
  red: "Červená",
  "red orange": "červenooranžová",
  saturation: "Sýtosť",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} priehľadná`,
  "very dark": "veľmi tmavá",
  "very light": "veľmi svetlá",
  vibrant: "energická",
  white: "biela",
  yellow: "žltá",
  "yellow green": "žltozelená"
};
var h3 = {};
h3 = {
  alpha: "Alfa",
  black: "črna",
  blue: "Modra",
  "blue purple": "modro vijolična",
  brightness: "Svetlost",
  brown: "rjava",
  "brown yellow": "rjavo rumena",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cian",
  "cyan blue": "cian modra",
  dark: "temna",
  gray: "siva",
  grayish: "sivkasta",
  green: "Zelena",
  "green cyan": "zelena cian",
  hue: "Barva",
  light: "svetla",
  lightness: "Lahkost",
  magenta: "škrlatna",
  "magenta pink": "škrlatno roza",
  orange: "oranžna",
  "orange yellow": "oranžno rumena",
  pale: "bleda",
  pink: "roza",
  "pink red": "roza rdeča",
  purple: "vijolična",
  "purple magenta": "vijolično škrlatna",
  red: "Rdeča",
  "red orange": "rdeče oranžna",
  saturation: "Nasičenost",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} prozorna`,
  "very dark": "zelo temna",
  "very light": "zelo svetla",
  vibrant: "živahna",
  white: "bela",
  yellow: "rumena",
  "yellow green": "rumeno zelena"
};
var m3 = {};
m3 = {
  alpha: "Alfa",
  black: "crno",
  blue: "Plava",
  "blue purple": "plavoljubičasta",
  brightness: "Osvetljenost",
  brown: "smeđa",
  "brown yellow": "smeđežuta",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cijan",
  "cyan blue": "cijan plava",
  dark: "tamno",
  gray: "siva",
  grayish: "sivkasta",
  green: "Zelena",
  "green cyan": "zeleno cijan",
  hue: "Nijansa",
  light: "svetla",
  lightness: "Osvetljenje",
  magenta: "purpurnocrvena",
  "magenta pink": "magenta ružičasta",
  orange: "narandžasta",
  "orange yellow": "narandžastožuta",
  pale: "bledo",
  pink: "ružičasta",
  "pink red": "ružičastocrvena",
  purple: "ljubičasta",
  "purple magenta": "ljubičasta magenta",
  red: "Crvena",
  "red orange": "crvenonarandžasta",
  saturation: "Zasićenje",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} prozirna`,
  "very dark": "veoma tamno",
  "very light": "vrlo svetlo",
  vibrant: "živopisna",
  white: "bela",
  yellow: "žuto",
  "yellow green": "žutozelena"
};
var p3 = {};
p3 = {
  alpha: "Alfa",
  black: "svart",
  blue: "Blått",
  "blue purple": "blålila",
  brightness: "Ljusstyrka",
  brown: "brun",
  "brown yellow": "brungul",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "cyan",
  "cyan blue": "cyanblå",
  dark: "mörk",
  gray: "grå",
  grayish: "gråaktig",
  green: "Grönt",
  "green cyan": "grön cyan",
  hue: "Nyans",
  light: "ljus",
  lightness: "Ljushet",
  magenta: "magenta",
  "magenta pink": "magentarosa",
  orange: "orange",
  "orange yellow": "orangegul",
  pale: "blek",
  pink: "rosa",
  "pink red": "rosaröd",
  purple: "lila",
  "purple magenta": "lila magenta",
  red: "Rött",
  "red orange": "rödorange",
  saturation: "Mättnad",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} genomskinlig`,
  "very dark": "mycket mörk",
  "very light": "mycket ljus",
  vibrant: "livfull",
  white: "vit",
  yellow: "gul",
  "yellow green": "gulgrön"
};
var b3 = {};
b3 = {
  alpha: "Alfa",
  black: "siyah",
  blue: "Mavi",
  "blue purple": "mavi mor",
  brightness: "Parlaklık",
  brown: "kahverengi",
  "brown yellow": "kahverengi sarı",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "camgöbeği",
  "cyan blue": "camgöbeği mavi",
  dark: "koyu",
  gray: "gri",
  grayish: "grimsi",
  green: "Yeşil",
  "green cyan": "yeşil camgöbeği",
  hue: "Ton",
  light: "açık",
  lightness: "Canlılık",
  magenta: "eflatun",
  "magenta pink": "eflatun pembe",
  orange: "turuncu",
  "orange yellow": "turuncu sarı",
  pale: "solgun",
  pink: "pembe",
  "pink red": "pembe kırmızı",
  purple: "mor",
  "purple magenta": "mor eflatun",
  red: "Kırmızı",
  "red orange": "kırmızı portakal",
  saturation: "Doygunluk",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} saydam`,
  "very dark": "çok koyu",
  "very light": "çok açık",
  vibrant: "canlı",
  white: "beyaz",
  yellow: "sarı",
  "yellow green": "sarı yeşil"
};
var g3 = {};
g3 = {
  alpha: "Альфа",
  black: "чорний",
  blue: "Синій",
  "blue purple": "синьо-фіолетовий",
  brightness: "Яскравість",
  brown: "коричневий",
  "brown yellow": "коричнево-жовтий",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "блакитний",
  "cyan blue": "синьо-блакитний",
  dark: "темний",
  gray: "сірий",
  grayish: "сіруватий",
  green: "Зелений",
  "green cyan": "зелено-блакитний",
  hue: "Тон",
  light: "світлий",
  lightness: "Освітленість",
  magenta: "пурпуровий",
  "magenta pink": "пурпурово-рожевий",
  orange: "помаранчевий",
  "orange yellow": "помаранчево-жовтий",
  pale: "блідий",
  pink: "рожевий",
  "pink red": "рожево-червоний",
  purple: "фіолетовий",
  "purple magenta": "фіолетово-пурпуровий",
  red: "Червоний",
  "red orange": "червоно-помаранчевий",
  saturation: "Насиченість",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, прозорий на ${e.percentTransparent}`,
  "very dark": "дуже темний",
  "very light": "дуже світлий",
  vibrant: "яскравий",
  white: "білий",
  yellow: "жовтий",
  "yellow green": "жовто-зелений"
};
var y3 = {};
y3 = {
  alpha: "Alpha",
  black: "黑色",
  blue: "蓝色",
  "blue purple": "蓝紫色",
  brightness: "亮度",
  brown: "棕色的",
  "brown yellow": "棕黄色",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "蓝绿色",
  "cyan blue": "青蓝色",
  dark: "深色",
  gray: "灰色",
  grayish: "浅灰色的",
  green: "绿色",
  "green cyan": "绿青色",
  hue: "色相",
  light: "浅色",
  lightness: "明亮度",
  magenta: "紫红色",
  "magenta pink": "紫粉色",
  orange: "橙色",
  "orange yellow": "橙黄色",
  pale: "苍白的",
  pink: "粉色",
  "pink red": "粉红色",
  purple: "紫色",
  "purple magenta": "紫洋红色",
  red: "红色",
  "red orange": "红橙色",
  saturation: "饱和度",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} 透明`,
  "very dark": "很暗",
  "very light": "很浅",
  vibrant: "生机勃勃",
  white: "白色",
  yellow: "黄色",
  "yellow green": "黄色/绿色"
};
var $3 = {};
$3 = {
  alpha: "Alpha",
  black: "黑",
  blue: "藍色",
  "blue purple": "藍紫",
  brightness: "亮度",
  brown: "棕",
  "brown yellow": "棕黃",
  colorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}`,
  cyan: "青",
  "cyan blue": "青藍",
  dark: "暗",
  gray: "灰",
  grayish: "偏灰",
  green: "綠色",
  "green cyan": "青綠",
  hue: "色相",
  light: "淺",
  lightness: "明亮",
  magenta: "洋紅",
  "magenta pink": "淺洋紅",
  orange: "橙",
  "orange yellow": "橙黃",
  pale: "淡",
  pink: "粉紅",
  "pink red": "粉紅",
  purple: "紫",
  "purple magenta": "紫洋紅",
  red: "紅色",
  "red orange": "橙紅",
  saturation: "飽和度",
  transparentColorName: (e) => `${e.lightness} ${e.chroma} ${e.hue}, ${e.percentTransparent} 透明`,
  "very dark": "很暗",
  "very light": "很淺",
  vibrant: "鮮豔",
  white: "白",
  yellow: "黃",
  "yellow green": "黃綠"
};
var v3 = {};
v3 = {
  "ar-AE": zh,
  "bg-BG": Oh,
  "cs-CZ": Hh,
  "da-DK": Uh,
  "de-DE": jh,
  "el-GR": _h,
  "en-US": Wh,
  "es-ES": Gh,
  "et-EE": qh,
  "fi-FI": Yh,
  "fr-FR": Zh,
  "he-IL": Xh,
  "hr-HR": Jh,
  "hu-HU": Qh,
  "it-IT": e3,
  "ja-JP": t3,
  "ko-KR": n3,
  "lt-LT": r3,
  "lv-LV": a3,
  "nb-NO": l3,
  "nl-NL": i3,
  "pl-PL": u3,
  "pt-BR": o3,
  "pt-PT": s3,
  "ro-RO": d3,
  "ru-RU": c3,
  "sk-SK": f3,
  "sl-SI": h3,
  "sr-SP": m3,
  "sv-SE": p3,
  "tr-TR": b3,
  "uk-UA": g3,
  "zh-CN": y3,
  "zh-TW": $3
};
function iD(e) {
  return e && e.__esModule ? e.default : e;
}
let ni = new $t(iD(v3));
function Ye(e) {
  let t = aa.parse(e) || la.parse(e) || ia.parse(e);
  if (t) return t;
  throw new Error("Invalid color value: " + e);
}
function fr(e) {
  return typeof e == "string" ? Ye(e) : e;
}
function D3(e) {
  return e === 360 ? e : (e % 360 + 360) % 360;
}
const Ks = 0.68, uD = 0.85, Ns = 0.55, Vs = 1e-3, ri = [
  [
    0,
    "pink"
  ],
  [
    15,
    "red"
  ],
  [
    48,
    "orange"
  ],
  [
    94,
    "yellow"
  ],
  [
    135,
    "green"
  ],
  [
    175,
    "cyan"
  ],
  [
    264,
    "blue"
  ],
  [
    284,
    "purple"
  ],
  [
    320,
    "magenta"
  ],
  [
    349,
    "pink"
  ]
];
class Uu {
  toHexInt() {
    return this.toFormat("rgb").toHexInt();
  }
  getChannelValue(t) {
    if (t in this) return this[t];
    throw new Error("Unsupported color channel: " + t);
  }
  withChannelValue(t, n) {
    if (t in this) {
      let r = this.clone();
      return r[t] = n, r;
    }
    throw new Error("Unsupported color channel: " + t);
  }
  getChannelName(t, n) {
    return ($t.getGlobalDictionaryForPackage("@react-stately/color") || ni).getStringForLocale(t, n);
  }
  getColorSpaceAxes(t) {
    let { xChannel: n, yChannel: r } = t, a = n || this.getColorChannels().find((u) => u !== r), l = r || this.getColorChannels().find((u) => u !== a), i = this.getColorChannels().find((u) => u !== a && u !== l);
    return {
      xChannel: a,
      yChannel: l,
      zChannel: i
    };
  }
  getColorName(t) {
    let [n, r, a] = Ls(this), l = $t.getGlobalDictionaryForPackage("@react-stately/color") || ni;
    if (n > 0.999) return l.getStringForLocale("white", t);
    if (n < 1e-3) return l.getStringForLocale("black", t);
    let i;
    [i, n] = this.getOklchHue(n, r, a, t);
    let u = "", o = "";
    r <= 0.1 && r >= Vs ? n >= 0.7 ? o = "pale" : o = "grayish" : r >= 0.15 && (o = "vibrant"), n < 0.3 ? u = "very dark" : n < Ns ? u = "dark" : n < 0.7 || (n < 0.85 ? u = "light" : u = "very light"), o && (o = l.getStringForLocale(o, t)), u && (u = l.getStringForLocale(u, t));
    let d = this.getChannelValue("alpha"), s = new $u(t, l);
    if (d < 1) {
      let c = new Kt(t, {
        style: "percent"
      }).format(1 - d);
      return s.format("transparentColorName", {
        lightness: u,
        chroma: o,
        hue: i,
        percentTransparent: c
      }).replace(/\s+/g, " ").trim();
    } else return s.format("colorName", {
      lightness: u,
      chroma: o,
      hue: i
    }).replace(/\s+/g, " ").trim();
  }
  getOklchHue(t, n, r, a) {
    let l = $t.getGlobalDictionaryForPackage("@react-stately/color") || ni;
    if (n < Vs) return [
      l.getStringForLocale("gray", a),
      t
    ];
    for (let i = 0; i < ri.length; i++) {
      let [u, o] = ri[i], [d, s] = ri[i + 1] || [
        360,
        "pink"
      ];
      if (r >= u && r < d)
        return o === "orange" && (t < Ks ? o = "brown" : t = t - Ks + Ns), r > u + (d - u) / 2 && o !== s ? o = `${o} ${s}` : o === "yellow" && t < uD && (o = "yellow green"), [
          l.getStringForLocale(o, a).toLocaleLowerCase(a),
          t
        ];
    }
    throw new Error("Unexpected hue");
  }
  getHueName(t) {
    let [n, r, a] = Ls(this), [l] = this.getOklchHue(n, r, a, t);
    return l;
  }
}
const ar = class ar extends Uu {
  constructor(t, n, r, a) {
    super(), this.red = t, this.green = n, this.blue = r, this.alpha = a;
  }
  static parse(t) {
    let n = [];
    if (/^#[\da-f]+$/i.test(t) && [
      4,
      5,
      7,
      9
    ].includes(t.length)) {
      const a = (t.length < 6 ? t.replace(/[^#]/gi, "$&$&") : t).slice(1).split("");
      for (; a.length > 0; ) n.push(parseInt(a.splice(0, 2).join(""), 16));
      n[3] = n[3] !== void 0 ? n[3] / 255 : void 0;
    }
    const r = t.match(/^rgba?\((.*)\)$/);
    if (r?.[1] && (n = r[1].split(",").map((a) => Number(a.trim())), n = n.map((a, l) => Ve(a ?? 0, 0, l < 3 ? 255 : 1))), !(n[0] === void 0 || n[1] === void 0 || n[2] === void 0))
      return n.length < 3 ? void 0 : new ar(n[0], n[1], n[2], n[3] ?? 1);
  }
  toString(t = "css") {
    switch (t) {
      case "hex":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0")).toUpperCase();
      case "hexa":
        return "#" + (this.red.toString(16).padStart(2, "0") + this.green.toString(16).padStart(2, "0") + this.blue.toString(16).padStart(2, "0") + Math.round(this.alpha * 255).toString(16).padStart(2, "0")).toUpperCase();
      case "rgb":
        return `rgb(${this.red}, ${this.green}, ${this.blue})`;
      case "css":
      case "rgba":
        return `rgba(${this.red}, ${this.green}, ${this.blue}, ${this.alpha})`;
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hex":
      case "hexa":
      case "rgb":
      case "rgba":
        return this;
      case "hsb":
      case "hsba":
        return this.toHSB();
      case "hsl":
      case "hsla":
        return this.toHSL();
      default:
        throw new Error("Unsupported color conversion: rgb -> " + t);
    }
  }
  toHexInt() {
    return this.red << 16 | this.green << 8 | this.blue;
  }
  /**
  * Converts an RGB color value to HSB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
  *
  * @returns An HSBColor object.
  */
  toHSB() {
    const t = this.red / 255, n = this.green / 255, r = this.blue / 255, a = Math.min(t, n, r), l = Math.max(t, n, r), i = l - a, u = l === 0 ? 0 : i / l;
    let o = 0;
    if (i !== 0) {
      switch (l) {
        case t:
          o = (n - r) / i + (n < r ? 6 : 0);
          break;
        case n:
          o = (r - t) / i + 2;
          break;
        case r:
          o = (t - n) / i + 4;
          break;
      }
      o /= 6;
    }
    return new la(Ke(o * 360, 2), Ke(u * 100, 2), Ke(l * 100, 2), this.alpha);
  }
  /**
  * Converts an RGB color value to HSL.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#From_RGB.
  *
  * @returns An HSLColor object.
  */
  toHSL() {
    const t = this.red / 255, n = this.green / 255, r = this.blue / 255, a = Math.min(t, n, r), l = Math.max(t, n, r), i = (l + a) / 2, u = l - a;
    let o, d;
    if (u === 0) o = d = 0;
    else {
      switch (d = u / (i < 0.5 ? l + a : 2 - l - a), l) {
        case t:
          o = (n - r) / u + (n < r ? 6 : 0);
          break;
        case n:
          o = (r - t) / u + 2;
          break;
        case r:
        default:
          o = (t - n) / u + 4;
          break;
      }
      o /= 6;
    }
    return new ia(Ke(o * 360, 2), Ke(d * 100, 2), Ke(i * 100, 2), this.alpha);
  }
  clone() {
    return new ar(this.red, this.green, this.blue, this.alpha);
  }
  getChannelRange(t) {
    switch (t) {
      case "red":
      case "green":
      case "blue":
        return {
          minValue: 0,
          maxValue: 255,
          step: 1,
          pageSize: 17
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "red":
      case "green":
      case "blue":
        return {
          style: "decimal"
        };
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, n) {
    let r = this.getChannelFormatOptions(t), a = this.getChannelValue(t);
    return new Kt(n, r).format(a);
  }
  getColorSpace() {
    return "rgb";
  }
  getColorChannels() {
    return ar.colorChannels;
  }
};
ar.colorChannels = [
  "red",
  "green",
  "blue"
];
let aa = ar;
const oD = /hsb\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsba\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, lr = class lr extends Uu {
  constructor(t, n, r, a) {
    super(), this.hue = t, this.saturation = n, this.brightness = r, this.alpha = a;
  }
  static parse(t) {
    let n;
    if (n = t.match(oD)) {
      const [r, a, l, i] = (n[1] ?? n[2]).split(",").map((u) => Number(u.trim().replace("%", "")));
      return new lr(D3(r), Ve(a, 0, 100), Ve(l, 0, 100), Ve(i ?? 1, 0, 1));
    }
  }
  toString(t = "css") {
    switch (t) {
      case "css":
        return this.toHSL().toString("css");
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsb":
        return `hsb(${this.hue}, ${Ke(this.saturation, 2)}%, ${Ke(this.brightness, 2)}%)`;
      case "hsba":
        return `hsba(${this.hue}, ${Ke(this.saturation, 2)}%, ${Ke(this.brightness, 2)}%, ${this.alpha})`;
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hsb":
      case "hsba":
        return this;
      case "hsl":
      case "hsla":
        return this.toHSL();
      case "rgb":
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsb -> " + t);
    }
  }
  /**
  * Converts a HSB color to HSL.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_HSL.
  *
  * @returns An HSLColor object.
  */
  toHSL() {
    let t = this.saturation / 100, n = this.brightness / 100, r = n * (1 - t / 2);
    return t = r === 0 || r === 1 ? 0 : (n - r) / Math.min(r, 1 - r), new ia(Ke(this.hue, 2), Ke(t * 100, 2), Ke(r * 100, 2), this.alpha);
  }
  /**
  * Converts a HSV color value to RGB. Conversion formula adapted from
  * https://en.wikipedia.org/wiki/HSL_and_HSV#HSV_to_RGB_alternative.
  *
  * @returns An RGBColor object.
  */
  toRGB() {
    let t = this.hue, n = this.saturation / 100, r = this.brightness / 100, a = (l, i = (l + t / 60) % 6) => r - n * r * Math.max(Math.min(i, 4 - i, 1), 0);
    return new aa(Math.round(a(5) * 255), Math.round(a(3) * 255), Math.round(a(1) * 255), this.alpha);
  }
  clone() {
    return new lr(this.hue, this.saturation, this.brightness, this.alpha);
  }
  getChannelRange(t) {
    switch (t) {
      case "hue":
        return {
          minValue: 0,
          maxValue: 360,
          step: 1,
          pageSize: 15
        };
      case "saturation":
      case "brightness":
        return {
          minValue: 0,
          maxValue: 100,
          step: 1,
          pageSize: 10
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "hue":
        return {
          style: "unit",
          unit: "degree",
          unitDisplay: "narrow"
        };
      case "saturation":
      case "brightness":
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, n) {
    let r = this.getChannelFormatOptions(t), a = this.getChannelValue(t);
    return (t === "saturation" || t === "brightness") && (a /= 100), new Kt(n, r).format(a);
  }
  getColorSpace() {
    return "hsb";
  }
  getColorChannels() {
    return lr.colorChannels;
  }
};
lr.colorChannels = [
  "hue",
  "saturation",
  "brightness"
];
let la = lr;
const sD = /hsl\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%)\)|hsla\(([-+]?\d+(?:.\d+)?\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d+(?:.\d+)?%\s*,\s*[-+]?\d(.\d+)?)\)/, ir = class ir extends Uu {
  constructor(t, n, r, a) {
    super(), this.hue = t, this.saturation = n, this.lightness = r, this.alpha = a;
  }
  static parse(t) {
    let n;
    if (n = t.match(sD)) {
      const [r, a, l, i] = (n[1] ?? n[2]).split(",").map((u) => Number(u.trim().replace("%", "")));
      return new ir(D3(r), Ve(a, 0, 100), Ve(l, 0, 100), Ve(i ?? 1, 0, 1));
    }
  }
  toString(t = "css") {
    switch (t) {
      case "hex":
        return this.toRGB().toString("hex");
      case "hexa":
        return this.toRGB().toString("hexa");
      case "hsl":
        return `hsl(${this.hue}, ${Ke(this.saturation, 2)}%, ${Ke(this.lightness, 2)}%)`;
      case "css":
      case "hsla":
        return `hsla(${this.hue}, ${Ke(this.saturation, 2)}%, ${Ke(this.lightness, 2)}%, ${this.alpha})`;
      default:
        return this.toFormat(t).toString(t);
    }
  }
  toFormat(t) {
    switch (t) {
      case "hsl":
      case "hsla":
        return this;
      case "hsb":
      case "hsba":
        return this.toHSB();
      case "rgb":
      case "rgba":
        return this.toRGB();
      default:
        throw new Error("Unsupported color conversion: hsl -> " + t);
    }
  }
  /**
  * Converts a HSL color to HSB.
  * Conversion formula adapted from https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_HSV.
  *
  * @returns An HSBColor object.
  */
  toHSB() {
    let t = this.saturation / 100, n = this.lightness / 100, r = n + t * Math.min(n, 1 - n);
    return t = r === 0 ? 0 : 2 * (1 - n / r), new la(Ke(this.hue, 2), Ke(t * 100, 2), Ke(r * 100, 2), this.alpha);
  }
  /**
  * Converts a HSL color to RGB. Conversion formula adapted from
  * https://en.wikipedia.org/wiki/HSL_and_HSV#HSL_to_RGB_alternative.
  *
  * @returns An RGBColor object.
  */
  toRGB() {
    let t = this.hue, n = this.saturation / 100, r = this.lightness / 100, a = n * Math.min(r, 1 - r), l = (i, u = (i + t / 30) % 12) => r - a * Math.max(Math.min(u - 3, 9 - u, 1), -1);
    return new aa(Math.round(l(0) * 255), Math.round(l(8) * 255), Math.round(l(4) * 255), this.alpha);
  }
  clone() {
    return new ir(this.hue, this.saturation, this.lightness, this.alpha);
  }
  getChannelRange(t) {
    switch (t) {
      case "hue":
        return {
          minValue: 0,
          maxValue: 360,
          step: 1,
          pageSize: 15
        };
      case "saturation":
      case "lightness":
        return {
          minValue: 0,
          maxValue: 100,
          step: 1,
          pageSize: 10
        };
      case "alpha":
        return {
          minValue: 0,
          maxValue: 1,
          step: 0.01,
          pageSize: 0.1
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  getChannelFormatOptions(t) {
    switch (t) {
      case "hue":
        return {
          style: "unit",
          unit: "degree",
          unitDisplay: "narrow"
        };
      case "saturation":
      case "lightness":
      case "alpha":
        return {
          style: "percent"
        };
      default:
        throw new Error("Unknown color channel: " + t);
    }
  }
  formatChannelValue(t, n) {
    let r = this.getChannelFormatOptions(t), a = this.getChannelValue(t);
    return (t === "saturation" || t === "lightness") && (a /= 100), new Kt(n, r).format(a);
  }
  getColorSpace() {
    return "hsl";
  }
  getColorChannels() {
    return ir.colorChannels;
  }
};
ir.colorChannels = [
  "hue",
  "saturation",
  "lightness"
];
let ia = ir;
function Ls(e) {
  let t = e.toFormat("rgb"), n = t.getChannelValue("red") / 255, r = t.getChannelValue("green") / 255, a = t.getChannelValue("blue") / 255;
  [n, r, a] = cD(n, r, a);
  let [l, i, u] = fD(n, r, a), [o, d, s] = hD(l, i, u);
  return dD(o, d, s);
}
function dD(e, t, n) {
  var r = Math.atan2(n, t) * 180 / Math.PI;
  return [
    e,
    Math.sqrt(t ** 2 + n ** 2),
    r >= 0 ? r : r + 360
    // Hue, in degrees [0 to 360)
  ];
}
function cD(e, t, n) {
  return [
    ai(e),
    ai(t),
    ai(n)
  ];
}
function ai(e) {
  let t = e < 0 ? -1 : 1, n = Math.abs(e);
  return n <= 0.04045 ? e / 12.92 : t * Math.pow((n + 0.055) / 1.055, 2.4);
}
function fD(e, t, n) {
  return ji([
    0.4123907992659595,
    0.35758433938387796,
    0.1804807884018343,
    0.21263900587151036,
    0.7151686787677559,
    0.07219231536073371,
    0.01933081871559185,
    0.11919477979462599,
    0.9505321522496606
  ], e, t, n);
}
function hD(e, t, n) {
  const r = [
    0.819022437996703,
    0.3619062600528904,
    -0.1288737815209879,
    0.0329836539323885,
    0.9292868615863434,
    0.0361446663506424,
    0.0481771893596242,
    0.2642395317527308,
    0.6335478284694309
  ], a = [
    0.210454268309314,
    0.7936177747023054,
    -0.0040720430116193,
    1.9779985324311684,
    -2.42859224204858,
    0.450593709617411,
    0.0259040424655478,
    0.7827717124575296,
    -0.8086757549230774
  ];
  let [l, i, u] = ji(r, e, t, n);
  return ji(a, Math.cbrt(l), Math.cbrt(i), Math.cbrt(u));
}
function ji(e, t, n, r) {
  let a = e[0] * t + e[1] * n + e[2] * r, l = e[3] * t + e[4] * n + e[5] * r, i = e[6] * t + e[7] * n + e[8] * r;
  return [
    a,
    l,
    i
  ];
}
const x3 = (e) => [
  0,
  60,
  120,
  180,
  240,
  300,
  360
].map((t) => e.withChannelValue("hue", t).toString("css")).join(", "), E3 = (e) => `${e.withChannelValue("saturation", 0)}, transparent`, mD = {
  hue: x3,
  saturation: E3,
  lightness: () => "black, transparent, white"
}, pD = {
  hue: x3,
  saturation: E3,
  brightness: () => "black, transparent"
};
function bD({ direction: e, state: t, zChannel: n, xChannel: r, yChannel: a }) {
  return K(() => {
    let i = e === "rtl" ? "left" : "right", u = {}, o = t.value.getChannelValue(n);
    switch (t.value.getColorSpace()) {
      case "rgb": {
        let f = Ye("rgb(0, 0, 0)");
        u = {
          background: [
            // The screen blend mode multiplies the inverse of each channel, e.g. 1 - (1 - a) * (1 - b).
            // Create a layer for each channel, with the other channels as 0. After blending, this should
            // result in the gradients being combined channel by channel.
            `linear-gradient(to ${i}, ${f.withChannelValue(r, 0)}, ${f.withChannelValue(r, 255)})`,
            `linear-gradient(to top, ${f.withChannelValue(a, 0)}, ${f.withChannelValue(a, 255)})`,
            f.withChannelValue(n, o)
          ].join(","),
          backgroundBlendMode: "screen"
        };
        break;
      }
      case "hsl": {
        let f = t.value.getColorChannels(), h = Ye("hsl(0, 100%, 50%)").withChannelValue(n, o), m = f.filter((p) => p !== n).map((p) => `linear-gradient(to ${p === r ? i : "top"}, ${mD[p](h)})`).reverse();
        n === "hue" && m.push(h.toString("css")), u = {
          background: m.join(", ")
        };
        break;
      }
      case "hsb": {
        let f = t.value.getColorChannels(), h = Ye("hsb(0, 100%, 100%)").withChannelValue(n, o), m = f.filter((p) => p !== n).map((p) => `linear-gradient(to ${p === r ? i : "top"}, ${pD[p](h)})`).reverse();
        n === "hue" && m.push(h.toString("css")), u = {
          background: m.join(", ")
        };
        break;
      }
    }
    let { x: d, y: s } = t.getThumbPosition();
    e === "rtl" && (d = 1 - d);
    let c = {
      forcedColorAdjust: "none"
    };
    return {
      colorAreaStyleProps: {
        style: {
          position: "relative",
          touchAction: "none",
          ...c,
          ...u
        }
      },
      thumbStyleProps: {
        style: {
          position: "absolute",
          left: `${d * 100}%`,
          top: `${s * 100}%`,
          transform: "translate(-50%, -50%)",
          touchAction: "none",
          ...c
        }
      }
    };
  }, [
    e,
    t,
    n,
    r,
    a
  ]);
}
function ua(e) {
  let { onMoveStart: t, onMove: n, onMoveEnd: r } = e, a = T({
    didMove: !1,
    lastPosition: null,
    id: null
  }), { addGlobalListener: l, removeGlobalListener: i } = Qt(), u = X((f, h, m, p) => {
    m === 0 && p === 0 || (a.current.didMove || (a.current.didMove = !0, t?.({
      type: "movestart",
      pointerType: h,
      shiftKey: f.shiftKey,
      metaKey: f.metaKey,
      ctrlKey: f.ctrlKey,
      altKey: f.altKey
    })), n?.({
      type: "move",
      pointerType: h,
      deltaX: m,
      deltaY: p,
      shiftKey: f.shiftKey,
      metaKey: f.metaKey,
      ctrlKey: f.ctrlKey,
      altKey: f.altKey
    }));
  }, [
    t,
    n,
    a
  ]), o = De(u), d = X((f, h) => {
    Ka(), a.current.didMove && r?.({
      type: "moveend",
      pointerType: h,
      shiftKey: f.shiftKey,
      metaKey: f.metaKey,
      ctrlKey: f.ctrlKey,
      altKey: f.altKey
    });
  }, [
    r,
    a
  ]), s = De(d);
  return {
    moveProps: K(() => {
      let f = {}, h = () => {
        Si(), a.current.didMove = !1;
      };
      if (typeof PointerEvent > "u" && process.env.NODE_ENV === "test") {
        let p = (v) => {
          v.button === 0 && (o(v, "mouse", v.pageX - (a.current.lastPosition?.pageX ?? 0), v.pageY - (a.current.lastPosition?.pageY ?? 0)), a.current.lastPosition = {
            pageX: v.pageX,
            pageY: v.pageY
          });
        }, b = (v) => {
          if (v.button === 0) {
            s(v, "mouse");
            let x = ke(W(v));
            i(x, "mousemove", p, !1), i(x, "mouseup", b, !1);
          }
        };
        f.onMouseDown = (v) => {
          if (v.button === 0) {
            h(), v.stopPropagation(), v.preventDefault(), a.current.lastPosition = {
              pageX: v.pageX,
              pageY: v.pageY
            };
            let x = ke(W(v));
            l(x, "mousemove", p, !1), l(x, "mouseup", b, !1);
          }
        };
        let y = (v) => {
          let x = [
            ...v.changedTouches
          ].findIndex(({ identifier: E }) => E === a.current.id);
          if (x >= 0) {
            let { pageX: E, pageY: P } = v.changedTouches[x];
            o(v, "touch", E - (a.current.lastPosition?.pageX ?? 0), P - (a.current.lastPosition?.pageY ?? 0)), a.current.lastPosition = {
              pageX: E,
              pageY: P
            };
          }
        }, $ = (v) => {
          if ([
            ...v.changedTouches
          ].findIndex(({ identifier: E }) => E === a.current.id) >= 0) {
            s(v, "touch"), a.current.id = null;
            let E = ke(W(v));
            i(E, "touchmove", y), i(E, "touchend", $), i(E, "touchcancel", $);
          }
        };
        f.onTouchStart = (v) => {
          if (v.changedTouches.length === 0 || a.current.id != null) return;
          let { pageX: x, pageY: E, identifier: P } = v.changedTouches[0];
          h(), v.stopPropagation(), v.preventDefault(), a.current.lastPosition = {
            pageX: x,
            pageY: E
          }, a.current.id = P;
          let C = ke(W(v));
          l(C, "touchmove", y, !1), l(C, "touchend", $, !1), l(C, "touchcancel", $, !1);
        };
      } else {
        let p = (y) => {
          if (y.pointerId === a.current.id) {
            let $ = y.pointerType || "mouse";
            o(y, $, y.pageX - (a.current.lastPosition?.pageX ?? 0), y.pageY - (a.current.lastPosition?.pageY ?? 0)), a.current.lastPosition = {
              pageX: y.pageX,
              pageY: y.pageY
            };
          }
        }, b = (y) => {
          if (y.pointerId === a.current.id) {
            let $ = y.pointerType || "mouse";
            s(y, $), a.current.id = null;
            let v = ke(W(y));
            i(v, "pointermove", p, !1), i(v, "pointerup", b, !1), i(v, "pointercancel", b, !1);
          }
        };
        f.onPointerDown = (y) => {
          if (y.button === 0 && a.current.id == null) {
            h(), y.stopPropagation(), y.preventDefault(), a.current.lastPosition = {
              pageX: y.pageX,
              pageY: y.pageY
            }, a.current.id = y.pointerId;
            let $ = ke(W(y));
            l($, "pointermove", p, !1), l($, "pointerup", b, !1), l($, "pointercancel", b, !1);
          }
        };
      }
      let m = (p, b, y) => {
        h(), o(p, "keyboard", b, y), s(p, "keyboard");
      };
      return f.onKeyDown = (p) => {
        switch (p.key) {
          case "Left":
          case "ArrowLeft":
            p.preventDefault(), p.stopPropagation(), m(p, -1, 0);
            break;
          case "Right":
          case "ArrowRight":
            p.preventDefault(), p.stopPropagation(), m(p, 1, 0);
            break;
          case "Up":
          case "ArrowUp":
            p.preventDefault(), p.stopPropagation(), m(p, 0, -1);
            break;
          case "Down":
          case "ArrowDown":
            p.preventDefault(), p.stopPropagation(), m(p, 0, 1);
            break;
        }
      }, f;
    }, [
      l,
      i,
      a
    ])
  };
}
function gD(e) {
  return e && e.__esModule ? e.default : e;
}
function yD(e, t) {
  let { isDisabled: n, inputXRef: r, inputYRef: a, containerRef: l, "aria-label": i, xName: u, yName: o, form: d } = e, s = xe(gD(Hu), "@react-aria/color"), { addGlobalListener: c, removeGlobalListener: f } = Qt(), { direction: h, locale: m } = de(), [p, b] = Y(null), y = X((ne = r) => {
    ne.current && Fe(ne.current);
  }, [
    r
  ]);
  an(r, t.defaultValue, t.setValue);
  let [$, v] = Y(!1), [x, E] = Y(!1), { xChannel: P, yChannel: C, zChannel: M } = t.channels, F = t.xChannelStep, V = t.yChannelStep, I = T(null), { keyboardProps: A } = Er({
    onKeyDown(ne) {
      if (!/^(PageUp|PageDown|Home|End)$/.test(ne.key)) {
        ne.continuePropagation();
        return;
      }
      ne.preventDefault(), t.setDragging(!0), v(!0);
      let Ee;
      switch (ne.key) {
        case "PageUp":
          t.incrementY(t.yChannelPageStep), Ee = "y";
          break;
        case "PageDown":
          t.decrementY(t.yChannelPageStep), Ee = "y";
          break;
        case "Home":
          h === "rtl" ? t.incrementX(t.xChannelPageStep) : t.decrementX(t.xChannelPageStep), Ee = "x";
          break;
        case "End":
          h === "rtl" ? t.decrementX(t.xChannelPageStep) : t.incrementX(t.xChannelPageStep), Ee = "x";
          break;
      }
      t.setDragging(!1), Ee && (y(Ee === "x" ? r : a), b(Ee));
    }
  }), U = {
    onMoveStart() {
      I.current = null, t.setDragging(!0);
    },
    onMove({ deltaX: ne, deltaY: Ee, pointerType: Dn, shiftKey: Yn }) {
      let { incrementX: xn, decrementX: Rr, incrementY: Zn, decrementY: wt, xChannelPageStep: St, xChannelStep: kt, yChannelPageStep: Tr, yChannelStep: Ir, getThumbPosition: Kl, setColorFromPoint: Nl } = t;
      I.current == null && (I.current = Kl());
      let { width: Ae, height: Xn } = l.current?.getBoundingClientRect() || {
        width: 0,
        height: 0
      }, Vo = ne !== 0 || Ee !== 0;
      if (Dn === "keyboard") {
        let Lo = Yn && St > kt ? St : kt, zo = Yn && Tr > Ir ? Tr : Ir;
        ne > 0 && h === "ltr" || ne < 0 && h === "rtl" ? xn(Lo) : ne < 0 && h === "ltr" || ne > 0 && h === "rtl" ? Rr(Lo) : Ee > 0 ? wt(zo) : Ee < 0 && Zn(zo), v(Vo), p = Vo && Math.abs(Ee) > Math.abs(ne) ? "y" : "x", b(p);
      } else
        I.current.x += (h === "rtl" ? -1 : 1) * ne / Ae, I.current.y += Ee / Xn, Nl(I.current.x, I.current.y);
    },
    onMoveEnd() {
      R.current = !1, t.setDragging(!1), y(p === "x" ? r : a);
    }
  }, { moveProps: D } = ua(U), { focusWithinProps: N } = ct({
    onFocusWithinChange: (ne) => {
      ne || (v(!1), E(!1));
    }
  }), w = T(void 0), R = T(!1), { moveProps: H } = ua({
    onMoveStart() {
      R.current && U.onMoveStart();
    },
    onMove(ne) {
      R.current && U.onMove(ne);
    },
    onMoveEnd() {
      R.current && U.onMoveEnd();
    }
  }), k = (ne) => {
    t.isDragging || (w.current = ne, v(!1), y(), t.setDragging(!0), typeof PointerEvent < "u" ? c(window, "pointerup", S, !1) : (c(window, "mouseup", S, !1), c(window, "touchend", S, !1)));
  }, S = (ne) => {
    (ne.pointerId ?? ne.changedTouches?.[0].identifier) === w.current && (v(!1), y(), t.setDragging(!1), w.current = void 0, R.current = !1, typeof PointerEvent < "u" ? f(window, "pointerup", S, !1) : (f(window, "mouseup", S, !1), f(window, "touchend", S, !1)));
  }, j = (ne, Ee, Dn, Yn) => {
    let xn = ne.getBoundingClientRect(), { width: Rr, height: Zn } = xn, wt = (Dn - xn.x) / Rr, St = (Yn - xn.y) / Zn;
    h === "rtl" && (wt = 1 - wt), wt >= 0 && wt <= 1 && St >= 0 && St <= 1 && !t.isDragging && w.current === void 0 && (R.current = !0, v(!1), w.current = Ee, t.setColorFromPoint(wt, St), y(), t.setDragging(!0), typeof PointerEvent < "u" ? c(window, "pointerup", _, !1) : (c(window, "mouseup", _, !1), c(window, "touchend", _, !1)));
  }, _ = (ne) => {
    let Ee = ne.pointerId ?? ne.changedTouches?.[0].identifier;
    R.current && Ee === w.current && (R.current = !1, v(!1), w.current = void 0, t.setDragging(!1), y(), typeof PointerEvent < "u" ? f(window, "pointerup", _, !1) : (f(window, "mouseup", _, !1), f(window, "touchend", _, !1)));
  }, B = n ? {} : z({
    ...typeof PointerEvent < "u" ? {
      onPointerDown: (ne) => {
        ne.pointerType === "mouse" && (ne.button !== 0 || ne.altKey || ne.ctrlKey || ne.metaKey) || j(ne.currentTarget, ne.pointerId, ne.clientX, ne.clientY);
      }
    } : {
      onMouseDown: (ne) => {
        ne.button !== 0 || ne.altKey || ne.ctrlKey || ne.metaKey || j(ne.currentTarget, void 0, ne.clientX, ne.clientY);
      },
      onTouchStart: (ne) => {
        j(ne.currentTarget, ne.changedTouches[0].identifier, ne.changedTouches[0].clientX, ne.changedTouches[0].clientY);
      }
    }
  }, H), L = n ? {} : z({
    ...typeof PointerEvent < "u" ? {
      onPointerDown: (ne) => {
        ne.pointerType === "mouse" && (ne.button !== 0 || ne.altKey || ne.ctrlKey || ne.metaKey) || k(ne.pointerId);
      }
    } : {
      onMouseDown: (ne) => {
        ne.button !== 0 || ne.altKey || ne.ctrlKey || ne.metaKey || k(void 0);
      },
      onTouchStart: (ne) => {
        k(ne.changedTouches[0].identifier);
      }
    }
  }, N, A, D), { focusProps: Z } = mr({
    onFocus: () => {
      b("x");
    }
  }), { focusProps: ie } = mr({
    onFocus: () => {
      b("y");
    }
  });
  const q = (ne) => {
    const { target: Ee } = ne;
    E(!0), Ee === r.current ? t.setXValue(parseFloat(Ee.value)) : Ee === a.current && t.setYValue(parseFloat(Ee.value));
  };
  let re = vt() || pn(), fe = t.getDisplayColor();
  const et = X((ne) => `${x || $ ? s.format("colorNameAndValue", {
    name: fe.getChannelName(ne, m),
    value: fe.formatChannelValue(ne, m)
  }) : [
    s.format("colorNameAndValue", {
      name: fe.getChannelName(ne, m),
      value: fe.formatChannelValue(ne, m)
    }),
    s.format("colorNameAndValue", {
      name: fe.getChannelName(ne === C ? P : C, m),
      value: fe.formatChannelValue(ne === C ? P : C, m)
    }),
    s.format("colorNameAndValue", {
      name: fe.getChannelName(M, m),
      value: fe.formatChannelValue(M, m)
    })
  ].join(", ")}, ${fe.getColorName(m)}`, [
    m,
    fe,
    s,
    x,
    $,
    P,
    C,
    M
  ]);
  let ft = s.format("colorPicker"), Wn = it({
    ...e,
    "aria-label": i ? s.format("colorInputLabel", {
      label: i,
      channelLabel: ft
    }) : ft
  }), zt = it({
    ...e,
    "aria-label": i ? s.format("colorInputLabel", {
      label: i,
      channelLabel: ft
    }) : ft
  }), Gn = it({
    ...e,
    "aria-label": i ? `${i}, ${ft}` : void 0
  }, re ? ft : void 0), qn = s.format("twoDimensionalSlider"), { visuallyHiddenProps: pe } = tn({
    style: {
      opacity: "0.0001",
      width: "100%",
      height: "100%",
      pointerEvents: "none"
    }
  }), { colorAreaStyleProps: ln, thumbStyleProps: Da } = bD({
    direction: h,
    state: t,
    xChannel: P,
    yChannel: C,
    zChannel: M
  });
  return {
    colorAreaProps: {
      ...Gn,
      ...B,
      ...ln,
      role: "group"
    },
    thumbProps: {
      ...L,
      ...Da,
      role: "presentation"
    },
    xInputProps: {
      ...Wn,
      ...pe,
      ...Z,
      type: "range",
      min: t.value.getChannelRange(P).minValue,
      max: t.value.getChannelRange(P).maxValue,
      step: F,
      "aria-roledescription": qn,
      "aria-valuetext": et(P),
      "aria-orientation": "horizontal",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"],
      disabled: n,
      value: t.value.getChannelValue(P),
      name: u,
      form: d,
      tabIndex: re || !p || p === "x" ? void 0 : -1,
      /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused control when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */
      "aria-hidden": re || !p || p === "x" || $ ? void 0 : "true",
      onChange: q
    },
    yInputProps: {
      ...zt,
      ...pe,
      ...ie,
      type: "range",
      min: t.value.getChannelRange(C).minValue,
      max: t.value.getChannelRange(C).maxValue,
      step: V,
      "aria-roledescription": qn,
      "aria-valuetext": et(C),
      "aria-orientation": "vertical",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"],
      disabled: n,
      value: t.value.getChannelValue(C),
      name: o,
      form: d,
      tabIndex: re || p === "y" ? void 0 : -1,
      /*
        So that only a single "2d slider" control shows up when listing form elements for screen readers,
        add aria-hidden="true" to the unfocused input when the value has not changed via the keyboard,
        but remove aria-hidden to reveal the input for each channel when the value has changed with the keyboard.
      */
      "aria-hidden": re || p === "y" || $ ? void 0 : "true",
      onChange: q
    }
  };
}
const $D = Ye("#ffffff");
function vD(e) {
  let { value: t, defaultValue: n, colorSpace: r, xChannel: a, yChannel: l, onChange: i, onChangeEnd: u } = e;
  !t && !n && (n = $D), t && (t = fr(t)), n && (n = fr(n));
  let [o, d] = Pe(t, n, i), [s] = Y(o), c = K(() => r && o ? o.toFormat(r) : o, [
    o,
    r
  ]), f = T(c), h = (w) => {
    f.current = w, d(w);
  }, m = K(() => c.getColorSpaceAxes({
    xChannel: a,
    yChannel: l
  }), [
    c,
    a,
    l
  ]), p = c.getChannelRange(m.xChannel), b = c.getChannelRange(m.yChannel), { minValue: y, maxValue: $, step: v, pageSize: x } = p, { minValue: E, maxValue: P, step: C, pageSize: M } = b, [F, V] = Y(!1), I = T(!1), A = c.getChannelValue(m.xChannel), U = c.getChannelValue(m.yChannel), D = (w) => {
    if (w === A) return;
    let R = c.withChannelValue(m.xChannel, w);
    h(R);
  }, N = (w) => {
    if (w === U) return;
    let R = c.withChannelValue(m.yChannel, w);
    h(R);
  };
  return {
    channels: m,
    xChannelStep: v,
    yChannelStep: C,
    xChannelPageStep: x,
    yChannelPageStep: M,
    value: c,
    defaultValue: t !== void 0 ? s : n,
    setValue(w) {
      h(fr(w));
    },
    xValue: A,
    setXValue: D,
    yValue: U,
    setYValue: N,
    setColorFromPoint(w, R) {
      let H = y + Ve(w, 0, 1) * ($ - y), k = E + (1 - Ve(R, 0, 1)) * (P - E), S;
      H !== A && (H = Ne(H, y, $, v), S = c.withChannelValue(m.xChannel, H)), k !== U && (k = Ne(k, E, P, C), S = (S || c).withChannelValue(m.yChannel, k)), S && h(S);
    },
    getThumbPosition() {
      let w = (A - y) / ($ - y), R = 1 - (U - E) / (P - E);
      return {
        x: w,
        y: R
      };
    },
    incrementX(w = 1) {
      D(A + w > $ ? $ : Ne(A + w, y, $, v));
    },
    incrementY(w = 1) {
      N(U + w > P ? P : Ne(U + w, E, P, C));
    },
    decrementX(w = 1) {
      D(Ne(A - w, y, $, v));
    },
    decrementY(w = 1) {
      N(Ne(U - w, E, P, C));
    },
    setDragging(w) {
      let R = I.current;
      I.current = w, u && !w && R && u(f.current), V(w);
    },
    isDragging: F,
    getDisplayColor() {
      return c.withChannelValue("alpha", 1);
    }
  };
}
const C3 = /* @__PURE__ */ G(null), DD = /* @__PURE__ */ G(null), a9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, C3);
  let r = T(null), a = T(null), l = vD(t), { colorAreaProps: i, xInputProps: u, yInputProps: o, thumbProps: d } = yD({
    ...t,
    inputXRef: r,
    inputYRef: a,
    containerRef: n
  }, l), s = le({
    ...t,
    defaultClassName: "react-aria-ColorArea",
    defaultStyle: i.style,
    values: {
      state: l,
      isDisabled: t.isDisabled || !1
    }
  }), c = J(t, {
    global: !0
  });
  return delete c.id, /* @__PURE__ */ g.createElement(Q.div, {
    ref: n,
    ...z(c, i, s),
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        DD,
        l
      ],
      [
        Ou,
        {
          state: l,
          thumbProps: d,
          inputXRef: r,
          xInputProps: u,
          inputYRef: a,
          yInputProps: o,
          isDisabled: t.isDisabled
        }
      ]
    ]
  }, s.children));
}), vn = /* @__PURE__ */ G({}), xD = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, vn);
  let { isDisabled: r, isInvalid: a, isReadOnly: l, onHoverStart: i, onHoverChange: u, onHoverEnd: o, ...d } = t;
  r ??= !!t["aria-disabled"] && t["aria-disabled"] !== "false", a ??= !!t["aria-invalid"] && t["aria-invalid"] !== "false";
  let { hoverProps: s, isHovered: c } = ve({
    onHoverStart: i,
    onHoverChange: u,
    onHoverEnd: o,
    isDisabled: r
  }), { isFocused: f, isFocusVisible: h, focusProps: m } = ye({
    within: !0
  }), p = le({
    ...t,
    values: {
      isHovered: c,
      isFocusWithin: f,
      isFocusVisible: h,
      isDisabled: r,
      isInvalid: a
    },
    defaultClassName: "react-aria-Group"
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(d, m, s),
    ...p,
    ref: n,
    role: t.role ?? "group",
    slot: t.slot ?? void 0,
    "data-focus-within": f || void 0,
    "data-hovered": c || void 0,
    "data-focus-visible": h || void 0,
    "data-disabled": r || void 0,
    "data-invalid": a || void 0,
    "data-readonly": l || void 0
  }, p.children);
}), Pr = /* @__PURE__ */ G({});
let ED = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...a } = e;
  return a;
};
const CD = /* @__PURE__ */ $n(function(t, n) {
  [t, n] = oe(t, n, Pr);
  let { hoverProps: r, isHovered: a } = ve({
    ...t,
    isDisabled: t.disabled
  }), { isFocused: l, isFocusVisible: i, focusProps: u } = ye({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), o = !!t["aria-invalid"] && t["aria-invalid"] !== "false", d = le({
    ...t,
    values: {
      isHovered: a,
      isFocused: l,
      isFocusVisible: i,
      isDisabled: t.disabled || !1,
      isInvalid: o
    },
    defaultClassName: "react-aria-Input"
  });
  return /* @__PURE__ */ g.createElement(Q.input, {
    ...z(ED(t), u, r),
    ...d,
    ref: n,
    "data-focused": l || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": a || void 0,
    "data-focus-visible": i || void 0,
    "data-invalid": o || void 0
  });
});
function ju(e, t) {
  let { inputElementType: n = "input", isDisabled: r = !1, isRequired: a = !1, isReadOnly: l = !1, type: i = "text", validationBehavior: u = "aria" } = e, [o, d] = Pe(e.value, e.defaultValue || "", e.onChange), { focusableProps: s } = dt(e, t), c = rn({
    ...e,
    value: o
  }), { isInvalid: f, validationErrors: h, validationDetails: m } = c.displayValidation, { labelProps: p, fieldProps: b, descriptionProps: y, errorMessageProps: $ } = Cr({
    ...e,
    isInvalid: f,
    errorMessage: e.errorMessage || h
  }), v = J(e, {
    labelable: !0
  });
  const x = {
    type: i,
    pattern: e.pattern
  };
  let [E] = Y(o);
  return an(t, e.defaultValue ?? E, d), ga(e, c, t), {
    labelProps: p,
    inputProps: z(v, n === "input" ? x : void 0, {
      disabled: r,
      readOnly: l,
      required: a && u === "native",
      "aria-required": a && u === "aria" || void 0,
      "aria-invalid": f || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-activedescendant": e["aria-activedescendant"],
      "aria-autocomplete": e["aria-autocomplete"],
      "aria-haspopup": e["aria-haspopup"],
      "aria-controls": e["aria-controls"],
      value: o,
      onChange: (P) => d(W(P).value),
      autoComplete: e.autoComplete,
      autoCapitalize: e.autoCapitalize,
      maxLength: e.maxLength,
      minLength: e.minLength,
      name: e.name,
      form: e.form,
      placeholder: e.placeholder,
      inputMode: e.inputMode,
      autoCorrect: e.autoCorrect,
      spellCheck: e.spellCheck,
      [parseInt(g.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: e.enterKeyHint,
      // Clipboard events
      onCopy: e.onCopy,
      onCut: e.onCut,
      onPaste: e.onPaste,
      // Composition events
      onCompositionEnd: e.onCompositionEnd,
      onCompositionStart: e.onCompositionStart,
      onCompositionUpdate: e.onCompositionUpdate,
      // Selection events
      onSelect: e.onSelect,
      // Input events
      onBeforeInput: e.onBeforeInput,
      onInput: e.onInput,
      ...s,
      ...b
    }),
    descriptionProps: y,
    errorMessageProps: $,
    isInvalid: f,
    validationErrors: h,
    validationDetails: m
  };
}
function zs() {
  return typeof window < "u" && window.InputEvent && typeof InputEvent.prototype.getTargetRanges == "function";
}
function P3(e, t, n) {
  let r = De((c) => {
    let f = n.current;
    if (!f) return;
    let h = null;
    switch (c.inputType) {
      case "historyUndo":
      case "historyRedo":
        return;
      case "insertLineBreak":
        return;
      case "deleteContent":
      case "deleteByCut":
      case "deleteByDrag":
        h = f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentForward":
        h = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd + 1) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteContentBackward":
        h = f.selectionEnd === f.selectionStart ? f.value.slice(0, f.selectionStart - 1) + f.value.slice(f.selectionStart) : f.value.slice(0, f.selectionStart) + f.value.slice(f.selectionEnd);
        break;
      case "deleteSoftLineBackward":
      case "deleteHardLineBackward":
        h = f.value.slice(f.selectionStart);
        break;
      default:
        c.data != null && (h = f.value.slice(0, f.selectionStart) + c.data + f.value.slice(f.selectionEnd));
        break;
    }
    (h == null || !t.validate(h)) && c.preventDefault();
  });
  ee(() => {
    if (!zs() || !n.current) return;
    let c = n.current;
    return c.addEventListener("beforeinput", r, !1), () => {
      c.removeEventListener("beforeinput", r, !1);
    };
  }, [
    n
  ]);
  let a = zs() ? null : (c) => {
    let f = W(c).value.slice(0, W(c).selectionStart) + c.data + W(c).value.slice(W(c).selectionEnd);
    t.validate(f) || c.preventDefault();
  }, { labelProps: l, inputProps: i, descriptionProps: u, errorMessageProps: o, ...d } = ju(e, n), s = T(null);
  return {
    inputProps: z(i, {
      onBeforeInput: a,
      onCompositionStart() {
        let { value: c, selectionStart: f, selectionEnd: h } = n.current;
        s.current = {
          value: c,
          selectionStart: f,
          selectionEnd: h
        };
      },
      onCompositionEnd() {
        if (n.current && !t.validate(n.current.value)) {
          let { value: c, selectionStart: f, selectionEnd: h } = s.current;
          n.current.value = c, n.current.setSelectionRange(f, h), t.setInputValue(c);
        }
      }
    }),
    labelProps: l,
    descriptionProps: u,
    errorMessageProps: o,
    ...d
  };
}
function w3(e, t) {
  let { onScroll: n, isDisabled: r } = e, a = X((l) => {
    l.ctrlKey || (l.preventDefault(), l.stopPropagation(), n && n({
      deltaX: l.deltaX,
      deltaY: l.deltaY
    }));
  }, [
    n
  ]);
  mt(t, "wheel", r ? void 0 : a);
}
var S3 = {};
S3 = {
  Empty: "فارغ"
};
var k3 = {};
k3 = {
  Empty: "Изпразни"
};
var B3 = {};
B3 = {
  Empty: "Prázdné"
};
var F3 = {};
F3 = {
  Empty: "Tom"
};
var A3 = {};
A3 = {
  Empty: "Leer"
};
var R3 = {};
R3 = {
  Empty: "Άδειο"
};
var T3 = {};
T3 = {
  Empty: "Empty"
};
var I3 = {};
I3 = {
  Empty: "Vacío"
};
var M3 = {};
M3 = {
  Empty: "Tühjenda"
};
var K3 = {};
K3 = {
  Empty: "Tyhjä"
};
var N3 = {};
N3 = {
  Empty: "Vide"
};
var V3 = {};
V3 = {
  Empty: "ריק"
};
var L3 = {};
L3 = {
  Empty: "Prazno"
};
var z3 = {};
z3 = {
  Empty: "Üres"
};
var O3 = {};
O3 = {
  Empty: "Vuoto"
};
var H3 = {};
H3 = {
  Empty: "空"
};
var U3 = {};
U3 = {
  Empty: "비어 있음"
};
var j3 = {};
j3 = {
  Empty: "Tuščias"
};
var _3 = {};
_3 = {
  Empty: "Tukšs"
};
var W3 = {};
W3 = {
  Empty: "Tom"
};
var G3 = {};
G3 = {
  Empty: "Leeg"
};
var q3 = {};
q3 = {
  Empty: "Pusty"
};
var Y3 = {};
Y3 = {
  Empty: "Vazio"
};
var Z3 = {};
Z3 = {
  Empty: "Vazio"
};
var X3 = {};
X3 = {
  Empty: "Gol"
};
var J3 = {};
J3 = {
  Empty: "Не заполнено"
};
var Q3 = {};
Q3 = {
  Empty: "Prázdne"
};
var em = {};
em = {
  Empty: "Prazen"
};
var tm = {};
tm = {
  Empty: "Prazno"
};
var nm = {};
nm = {
  Empty: "Tomt"
};
var rm = {};
rm = {
  Empty: "Boş"
};
var am = {};
am = {
  Empty: "Пусто"
};
var lm = {};
lm = {
  Empty: "空"
};
var im = {};
im = {
  Empty: "空白"
};
var um = {};
um = {
  "ar-AE": S3,
  "bg-BG": k3,
  "cs-CZ": B3,
  "da-DK": F3,
  "de-DE": A3,
  "el-GR": R3,
  "en-US": T3,
  "es-ES": I3,
  "et-EE": M3,
  "fi-FI": K3,
  "fr-FR": N3,
  "he-IL": V3,
  "hr-HR": L3,
  "hu-HU": z3,
  "it-IT": O3,
  "ja-JP": H3,
  "ko-KR": U3,
  "lt-LT": j3,
  "lv-LV": _3,
  "nb-NO": W3,
  "nl-NL": G3,
  "pl-PL": q3,
  "pt-BR": Y3,
  "pt-PT": Z3,
  "ro-RO": X3,
  "ru-RU": J3,
  "sk-SK": Q3,
  "sl-SI": em,
  "sr-SP": tm,
  "sv-SE": nm,
  "tr-TR": rm,
  "uk-UA": am,
  "zh-CN": lm,
  "zh-TW": im
};
function PD(e) {
  return e && e.__esModule ? e.default : e;
}
const Os = () => {
};
function _u(e) {
  const t = T(void 0);
  let { value: n, textValue: r, minValue: a, maxValue: l, isDisabled: i, isReadOnly: u, isRequired: o, onIncrement: d, onIncrementPage: s, onDecrement: c, onDecrementPage: f, onDecrementToMin: h, onIncrementToMax: m } = e;
  const p = xe(PD(um), "@react-aria/spinbutton");
  let b = T(!1);
  const y = X(() => {
    clearTimeout(t.current), b.current = !1;
  }, []), $ = De(() => {
    y();
  });
  ee(() => () => $(), []);
  let v = (B) => {
    if (!(B.ctrlKey || B.metaKey || B.shiftKey || B.altKey || u || B.nativeEvent.isComposing))
      switch (B.key) {
        case "PageUp":
          if (s) {
            B.preventDefault(), s?.();
            break;
          }
        // fallthrough!
        case "ArrowUp":
        case "Up":
          d && (B.preventDefault(), d?.());
          break;
        case "PageDown":
          if (f) {
            B.preventDefault(), f?.();
            break;
          }
        // fallthrough
        case "ArrowDown":
        case "Down":
          c && (B.preventDefault(), c?.());
          break;
        case "Home":
          h && (B.preventDefault(), h?.());
          break;
        case "End":
          m && (B.preventDefault(), m?.());
          break;
      }
  }, x = T(!1), E = () => {
    x.current = !0;
  }, P = () => {
    x.current = !1;
  }, C = r === "" ? p.format("Empty") : (r || `${n}`).replace("-", "−");
  ee(() => {
    x.current && (S2("assertive"), bn(C, "assertive"));
  }, [
    C
  ]);
  let M = X(() => {
    y();
  }, [
    y
  ]);
  const F = De(d ?? Os), V = De(c ?? Os), I = De(() => {
    (l === void 0 || isNaN(l) || n === void 0 || isNaN(n) || n < l) && (F(), A(60));
  }), A = De((B) => {
    $(), b.current = !0, t.current = window.setTimeout(I, B);
  }), U = De(() => {
    (a === void 0 || isNaN(a) || n === void 0 || isNaN(n) || n > a) && (V(), D(60));
  }), D = De((B) => {
    $(), b.current = !0, t.current = window.setTimeout(U, B);
  });
  let N = (B) => {
    B.preventDefault();
  }, { addGlobalListener: w, removeAllGlobalListeners: R } = Qt(), H = T(!1), [k, S] = Y(null);
  ee(() => {
    k === "touch" ? A(600) : k ? A(400) : k || $();
  }, [
    k
  ]);
  let [j, _] = Y(null);
  return ee(() => {
    j === "touch" ? D(600) : j ? D(400) : j || $();
  }, [
    j
  ]), {
    spinButtonProps: {
      role: "spinbutton",
      "aria-valuenow": n !== void 0 && !isNaN(n) ? n : void 0,
      "aria-valuetext": C,
      "aria-valuemin": a,
      "aria-valuemax": l,
      "aria-disabled": i || void 0,
      "aria-readonly": u || void 0,
      "aria-required": o || void 0,
      onKeyDown: v,
      onFocus: E,
      onBlur: P
    },
    incrementButtonProps: {
      onPressStart: (B) => {
        y(), B.pointerType !== "touch" ? (d?.(), S("mouse")) : (w(window, "pointercancel", M, {
          capture: !0
        }), H.current = !1, S("touch")), w(window, "contextmenu", N);
      },
      onPressUp: (B) => {
        y(), B.pointerType === "touch" && (H.current = !0), R(), S(null);
      },
      onPressEnd: (B) => {
        y(), B.pointerType === "touch" && !b.current && H.current && d?.(), H.current = !1, S(null);
      },
      onFocus: E,
      onBlur: P
    },
    decrementButtonProps: {
      onPressStart: (B) => {
        y(), B.pointerType !== "touch" ? (c?.(), _("mouse")) : (w(window, "pointercancel", M, {
          capture: !0
        }), H.current = !1, _("touch"));
      },
      onPressUp: (B) => {
        y(), B.pointerType === "touch" && (H.current = !0), R(), _(null);
      },
      onPressEnd: (B) => {
        y(), B.pointerType === "touch" && !b.current && H.current && c?.(), H.current = !1, _(null);
      },
      onFocus: E,
      onBlur: P
    }
  };
}
function wD(e, t, n) {
  let { isDisabled: r, isReadOnly: a, isRequired: l, isWheelDisabled: i, validationBehavior: u = "aria" } = e, { colorValue: o, inputValue: d, increment: s, decrement: c, incrementToMax: f, decrementToMin: h, commit: m } = t, p = ce(), { spinButtonProps: b } = _u({
    isDisabled: r,
    isReadOnly: a,
    isRequired: l,
    maxValue: 16777215,
    minValue: 0,
    onIncrement: s,
    onIncrementToMax: f,
    onDecrement: c,
    onDecrementToMin: h,
    value: o ? o.toHexInt() : void 0,
    textValue: o ? o.toString("hex") : void 0
  }), [y, $] = Y(!1), { focusWithinProps: v } = ct({
    isDisabled: r,
    onFocusWithinChange: $
  }), x = X((F) => {
    Math.abs(F.deltaY) <= Math.abs(F.deltaX) || (F.deltaY > 0 ? s() : F.deltaY < 0 && c());
  }, [
    c,
    s
  ]);
  w3({
    onScroll: x,
    isDisabled: i || r || a || !y
  }, n);
  let P = (F) => {
    t.validate(F) && t.setInputValue(F);
  }, { inputProps: C, ...M } = P3({
    ...e,
    id: p,
    value: d,
    // Intentionally invalid value that will be ignored by onChange during form reset
    // This is handled separately below.
    defaultValue: "!",
    validate: void 0,
    [zn]: t,
    type: "text",
    autoComplete: "off",
    onChange: P
  }, t, n);
  return an(n, t.defaultColorValue, t.setColorValue), C = z(C, b, v, {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false",
    onBlur: m
  }), u === "native" && (C["aria-required"] = void 0), {
    inputProps: C,
    ...M
  };
}
var om = {};
om = {
  decrease: (e) => `خفض ${e.fieldLabel}`,
  increase: (e) => `زيادة ${e.fieldLabel}`,
  numberField: "حقل رقمي"
};
var sm = {};
sm = {
  decrease: (e) => `Намаляване ${e.fieldLabel}`,
  increase: (e) => `Усилване ${e.fieldLabel}`,
  numberField: "Номер на полето"
};
var dm = {};
dm = {
  decrease: (e) => `Snížit ${e.fieldLabel}`,
  increase: (e) => `Zvýšit ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var cm = {};
cm = {
  decrease: (e) => `Reducer ${e.fieldLabel}`,
  increase: (e) => `Øg ${e.fieldLabel}`,
  numberField: "Talfelt"
};
var fm = {};
fm = {
  decrease: (e) => `${e.fieldLabel} verringern`,
  increase: (e) => `${e.fieldLabel} erhöhen`,
  numberField: "Nummernfeld"
};
var hm = {};
hm = {
  decrease: (e) => `Μείωση ${e.fieldLabel}`,
  increase: (e) => `Αύξηση ${e.fieldLabel}`,
  numberField: "Πεδίο αριθμού"
};
var mm = {};
mm = {
  decrease: (e) => `Decrease ${e.fieldLabel}`,
  increase: (e) => `Increase ${e.fieldLabel}`,
  numberField: "Number field"
};
var pm = {};
pm = {
  decrease: (e) => `Reducir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var bm = {};
bm = {
  decrease: (e) => `Vähenda ${e.fieldLabel}`,
  increase: (e) => `Suurenda ${e.fieldLabel}`,
  numberField: "Numbri väli"
};
var gm = {};
gm = {
  decrease: (e) => `Vähennä ${e.fieldLabel}`,
  increase: (e) => `Lisää ${e.fieldLabel}`,
  numberField: "Numerokenttä"
};
var ym = {};
ym = {
  decrease: (e) => `Diminuer ${e.fieldLabel}`,
  increase: (e) => `Augmenter ${e.fieldLabel}`,
  numberField: "Champ de nombre"
};
var $m = {};
$m = {
  decrease: (e) => `הקטן ${e.fieldLabel}`,
  increase: (e) => `הגדל ${e.fieldLabel}`,
  numberField: "שדה מספר"
};
var vm = {};
vm = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var Dm = {};
Dm = {
  decrease: (e) => `${e.fieldLabel} csökkentése`,
  increase: (e) => `${e.fieldLabel} növelése`,
  numberField: "Számmező"
};
var xm = {};
xm = {
  decrease: (e) => `Riduci ${e.fieldLabel}`,
  increase: (e) => `Aumenta ${e.fieldLabel}`,
  numberField: "Campo numero"
};
var Em = {};
Em = {
  decrease: (e) => `${e.fieldLabel}を縮小`,
  increase: (e) => `${e.fieldLabel}を拡大`,
  numberField: "数値フィールド"
};
var Cm = {};
Cm = {
  decrease: (e) => `${e.fieldLabel} 감소`,
  increase: (e) => `${e.fieldLabel} 증가`,
  numberField: "번호 필드"
};
var Pm = {};
Pm = {
  decrease: (e) => `Sumažinti ${e.fieldLabel}`,
  increase: (e) => `Padidinti ${e.fieldLabel}`,
  numberField: "Numerio laukas"
};
var wm = {};
wm = {
  decrease: (e) => `Samazināšana ${e.fieldLabel}`,
  increase: (e) => `Palielināšana ${e.fieldLabel}`,
  numberField: "Skaitļu lauks"
};
var Sm = {};
Sm = {
  decrease: (e) => `Reduser ${e.fieldLabel}`,
  increase: (e) => `Øk ${e.fieldLabel}`,
  numberField: "Tallfelt"
};
var km = {};
km = {
  decrease: (e) => `${e.fieldLabel} verlagen`,
  increase: (e) => `${e.fieldLabel} verhogen`,
  numberField: "Getalveld"
};
var Bm = {};
Bm = {
  decrease: (e) => `Zmniejsz ${e.fieldLabel}`,
  increase: (e) => `Zwiększ ${e.fieldLabel}`,
  numberField: "Pole numeru"
};
var Fm = {};
Fm = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo de número"
};
var Am = {};
Am = {
  decrease: (e) => `Diminuir ${e.fieldLabel}`,
  increase: (e) => `Aumentar ${e.fieldLabel}`,
  numberField: "Campo numérico"
};
var Rm = {};
Rm = {
  decrease: (e) => `Scădere ${e.fieldLabel}`,
  increase: (e) => `Creștere ${e.fieldLabel}`,
  numberField: "Câmp numeric"
};
var Tm = {};
Tm = {
  decrease: (e) => `Уменьшение ${e.fieldLabel}`,
  increase: (e) => `Увеличение ${e.fieldLabel}`,
  numberField: "Числовое поле"
};
var Im = {};
Im = {
  decrease: (e) => `Znížiť ${e.fieldLabel}`,
  increase: (e) => `Zvýšiť ${e.fieldLabel}`,
  numberField: "Číselné pole"
};
var Mm = {};
Mm = {
  decrease: (e) => `Upadati ${e.fieldLabel}`,
  increase: (e) => `Povečajte ${e.fieldLabel}`,
  numberField: "Številčno polje"
};
var Km = {};
Km = {
  decrease: (e) => `Smanji ${e.fieldLabel}`,
  increase: (e) => `Povećaj ${e.fieldLabel}`,
  numberField: "Polje broja"
};
var Nm = {};
Nm = {
  decrease: (e) => `Minska ${e.fieldLabel}`,
  increase: (e) => `Öka ${e.fieldLabel}`,
  numberField: "Nummerfält"
};
var Vm = {};
Vm = {
  decrease: (e) => `${e.fieldLabel} azalt`,
  increase: (e) => `${e.fieldLabel} arttır`,
  numberField: "Sayı alanı"
};
var Lm = {};
Lm = {
  decrease: (e) => `Зменшити ${e.fieldLabel}`,
  increase: (e) => `Збільшити ${e.fieldLabel}`,
  numberField: "Поле номера"
};
var zm = {};
zm = {
  decrease: (e) => `降低 ${e.fieldLabel}`,
  increase: (e) => `提高 ${e.fieldLabel}`,
  numberField: "数字字段"
};
var Om = {};
Om = {
  decrease: (e) => `縮小 ${e.fieldLabel}`,
  increase: (e) => `放大 ${e.fieldLabel}`,
  numberField: "數字欄位"
};
var Hm = {};
Hm = {
  "ar-AE": om,
  "bg-BG": sm,
  "cs-CZ": dm,
  "da-DK": cm,
  "de-DE": fm,
  "el-GR": hm,
  "en-US": mm,
  "es-ES": pm,
  "et-EE": bm,
  "fi-FI": gm,
  "fr-FR": ym,
  "he-IL": $m,
  "hr-HR": vm,
  "hu-HU": Dm,
  "it-IT": xm,
  "ja-JP": Em,
  "ko-KR": Cm,
  "lt-LT": Pm,
  "lv-LV": wm,
  "nb-NO": Sm,
  "nl-NL": km,
  "pl-PL": Bm,
  "pt-BR": Fm,
  "pt-PT": Am,
  "ro-RO": Rm,
  "ru-RU": Tm,
  "sk-SK": Im,
  "sl-SI": Mm,
  "sr-SP": Km,
  "sv-SE": Nm,
  "tr-TR": Vm,
  "uk-UA": Lm,
  "zh-CN": zm,
  "zh-TW": Om
};
function SD(e) {
  return e && e.__esModule ? e.default : e;
}
function Um(e, t, n) {
  let { id: r, decrementAriaLabel: a, incrementAriaLabel: l, isDisabled: i, isReadOnly: u, isRequired: o, minValue: d, maxValue: s, autoFocus: c, label: f, formatOptions: h, onBlur: m = () => {
  }, onFocus: p, onFocusChange: b, onKeyDown: y, onKeyUp: $, description: v, errorMessage: x, isWheelDisabled: E, ...P } = e, { increment: C, incrementToMax: M, decrement: F, decrementToMin: V, numberValue: I, inputValue: A, commit: U, commitValidation: D } = t;
  const N = xe(SD(Hm), "@react-aria/numberfield");
  let w = X(() => {
    let Ae = n.current?.value ?? "";
    at(() => {
      U();
    }), n.current?.value !== Ae && bn(n.current?.value ?? "", "assertive");
  }, [
    U,
    n
  ]), R = ce(r), { focusProps: H } = mr({
    onBlur() {
      w();
    }
  }), k = Ri(h), S = K(() => k.resolvedOptions(), [
    k
  ]), j = Ri({
    ...h,
    currencySign: void 0
  }), _ = K(() => isNaN(I) ? "" : j.format(I), [
    j,
    I
  ]), { spinButtonProps: B, incrementButtonProps: L, decrementButtonProps: Z } = _u({
    isDisabled: i,
    isReadOnly: u,
    isRequired: o,
    maxValue: s,
    minValue: d,
    onIncrement: C,
    onIncrementToMax: M,
    onDecrement: F,
    onDecrementToMin: V,
    value: I,
    textValue: _
  }), [ie, q] = Y(!1), { focusWithinProps: re } = ct({
    isDisabled: i,
    onFocusWithinChange: q
  }), fe = X((Ae) => {
    Math.abs(Ae.deltaY) <= Math.abs(Ae.deltaX) || (Ae.deltaY > 0 ? C() : Ae.deltaY < 0 && F());
  }, [
    F,
    C
  ]);
  w3({
    onScroll: fe,
    isDisabled: E || i || u || !ie
  }, n);
  let ft = (S.maximumFractionDigits ?? 0) > 0, Wn = t.minValue === void 0 || isNaN(t.minValue) || t.minValue < 0, zt = "numeric";
  _d() ? Wn ? zt = "text" : ft && (zt = "decimal") : pn() && (Wn ? zt = "numeric" : ft && (zt = "decimal"));
  let Gn = (Ae) => {
    t.validate(Ae) && t.setInputValue(Ae);
  }, qn = (Ae) => {
    e.onPaste?.(Ae);
    let Xn = W(Ae);
    Xn && (Xn.selectionEnd ?? -1) - (Xn.selectionStart ?? 0) === Xn.value.length && (Ae.preventDefault(), U(Ae.clipboardData?.getData?.("text/plain")?.trim() ?? ""));
  }, pe = J(e), ln = X((Ae) => {
    Ae.nativeEvent.isComposing || (Ae.key === "Enter" ? (at(() => {
      U();
    }), D()) : Ae.continuePropagation());
  }, [
    U,
    D
  ]), { isInvalid: Da, validationErrors: ne, validationDetails: Ee } = t.displayValidation, { labelProps: Dn, inputProps: Yn, descriptionProps: xn, errorMessageProps: Rr } = P3({
    ...P,
    ...pe,
    // These props are added to a hidden input rather than the formatted textfield.
    name: void 0,
    form: void 0,
    label: f,
    autoFocus: c,
    isDisabled: i,
    isReadOnly: u,
    isRequired: o,
    validate: void 0,
    [zn]: t,
    value: A,
    defaultValue: "!",
    autoComplete: "off",
    "aria-label": e["aria-label"] || void 0,
    "aria-labelledby": e["aria-labelledby"] || void 0,
    id: R,
    type: "text",
    inputMode: zt,
    onChange: Gn,
    onBlur: m,
    onFocus: p,
    onFocusChange: b,
    onKeyDown: K(() => ot(ln, y), [
      ln,
      y
    ]),
    onKeyUp: $,
    onPaste: qn,
    description: v,
    errorMessage: x
  }, t, n);
  an(n, t.defaultNumberValue, t.setNumberValue), kD(t, e.validationBehavior, e.commitBehavior, n, t.minValue, t.maxValue, e.step, t.numberValue);
  let Zn = z(B, H, Yn, {
    // override the spinbutton role, we can't focus a spin button with VO
    role: null,
    // ignore aria-roledescription on iOS so that required state will announce when it is present
    "aria-roledescription": vt() ? null : N.format("numberField"),
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuenow": null,
    "aria-valuetext": null,
    autoCorrect: "off",
    spellCheck: "false"
  });
  e.validationBehavior === "native" && (Zn["aria-required"] = void 0);
  let wt = (Ae) => {
    se() !== n.current && (Ae.pointerType === "mouse" ? n.current?.focus() : Ae.target.focus());
  }, St = e["aria-label"] || (typeof e.label == "string" ? e.label : ""), kt;
  St || (kt = e.label != null ? Dn.id : e["aria-labelledby"]);
  let Tr = ce(), Ir = ce(), Kl = z(L, {
    "aria-label": l || N.format("increase", {
      fieldLabel: St
    }).trim(),
    id: kt && !l ? Tr : null,
    "aria-labelledby": kt && !l ? `${Tr} ${kt}` : null,
    "aria-controls": R,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canIncrement,
    onPressStart: wt
  }), Nl = z(Z, {
    "aria-label": a || N.format("decrease", {
      fieldLabel: St
    }).trim(),
    id: kt && !a ? Ir : null,
    "aria-labelledby": kt && !a ? `${Ir} ${kt}` : null,
    "aria-controls": R,
    excludeFromTabOrder: !0,
    preventFocusOnPress: !0,
    allowFocusWhenDisabled: !0,
    isDisabled: !t.canDecrement,
    onPressStart: wt
  });
  return {
    groupProps: {
      ...re,
      role: "group",
      "aria-disabled": i,
      "aria-invalid": Da ? "true" : void 0
    },
    labelProps: Dn,
    inputProps: Zn,
    incrementButtonProps: Kl,
    decrementButtonProps: Nl,
    errorMessageProps: Rr,
    descriptionProps: xn,
    isInvalid: Da,
    validationErrors: ne,
    validationDetails: Ee
  };
}
let He = null;
function kD(e, t, n, r, a, l, i, u) {
  ue(() => {
    let o = r.current;
    if (n !== "validate" || e.realtimeValidation.isInvalid || !o || o.disabled || (!He && typeof document < "u" && (He = document.createElement("input"), He.type = "number"), !He))
      return;
    He.min = a != null && !isNaN(a) ? String(a) : "", He.max = l != null && !isNaN(l) ? String(l) : "", He.step = i != null && !isNaN(i) ? String(i) : "", He.value = u != null && !isNaN(u) ? String(u) : "";
    let d = o.validity.valid && He.validity.valid, s = o.validationMessage || He.validationMessage, c = {
      isInvalid: !d,
      validationErrors: s ? [
        s
      ] : [],
      validationDetails: {
        badInput: o.validity.badInput,
        customError: o.validity.customError,
        patternMismatch: o.validity.patternMismatch,
        rangeOverflow: He.validity.rangeOverflow,
        rangeUnderflow: He.validity.rangeUnderflow,
        stepMismatch: He.validity.stepMismatch,
        tooLong: o.validity.tooLong,
        tooShort: o.validity.tooShort,
        typeMismatch: o.validity.typeMismatch,
        valueMissing: o.validity.valueMissing,
        valid: d
      }
    };
    e.updateValidation(c), t === "native" && !He.validity.valid && o.setCustomValidity(He.validationMessage);
  });
}
function BD(e, t, n) {
  let { locale: r } = de();
  return Um({
    ...e,
    value: void 0,
    defaultValue: void 0,
    onChange: void 0,
    validate: void 0,
    // Provide a default aria-label if no other label is provided.
    "aria-label": e["aria-label"] || (e.label || e["aria-labelledby"] ? void 0 : t.colorValue.getChannelName(e.channel, r))
  }, t, n);
}
function On(e) {
  return K(() => {
    if (typeof e == "string") try {
      return Ye(e);
    } catch {
      return;
    }
    return e;
  }, [
    e
  ]);
}
const ul = Ye("#000000"), jm = Ye("#FFFFFF"), FD = ul.toHexInt(), AD = jm.toHexInt();
function RD(e) {
  let { value: t, defaultValue: n, onChange: r } = e, { step: a } = ul.getChannelRange("red"), l = On(n), [i, u] = Pe(On(t), l, r), [o] = Y(i), [d, s] = Y(() => (t || n) && i ? i.toString("hex") : ""), c = rn({
    ...e,
    value: i
  }), f = (P) => {
    if (!i || !P) {
      u(P);
      return;
    }
    if (P.toHexInt() !== i.toHexInt()) {
      u(P);
      return;
    }
  }, [h, m] = Y(i);
  h !== i && (s(i ? i.toString("hex") : ""), m(i));
  let p = K(() => {
    let P;
    try {
      P = Ye(d.startsWith("#") ? d : `#${d}`);
    } catch {
      P = null;
    }
    return P;
  }, [
    d
  ]);
  return {
    ...c,
    validate: (P) => P === "" || !!P.match(/^#?[0-9a-f]{0,6}$/i)?.[0],
    colorValue: i,
    defaultColorValue: l ?? o,
    setColorValue: u,
    inputValue: d,
    setInputValue: s,
    commit: () => {
      if (!d.length) {
        f(null), s(t === void 0 || i === null ? "" : i.toString("hex"));
        return;
      }
      if (p == null) {
        s(i ? i.toString("hex") : "");
        return;
      }
      f(p);
      let P = "";
      i && (P = i.toString("hex")), s(P), c.commitValidation();
    },
    increment: () => {
      let P = Hs(p, a);
      P === i && s(P.toString("hex")), f(P), c.commitValidation();
    },
    incrementToMax: () => f(jm),
    decrement: () => {
      let P = Hs(p, -a);
      P === i && s(P.toString("hex")), f(P), c.commitValidation();
    },
    decrementToMin: () => f(ul)
  };
}
function Hs(e, t) {
  let n = e || ul, r = n.toHexInt(), a = Math.min(Math.max(r + t, FD), AD);
  if (a !== r) {
    let l = `#${a.toString(16).padStart(6, "0").toUpperCase()}`;
    n = Ye(l);
  }
  return n;
}
function _m(e) {
  let { minValue: t, maxValue: n, step: r, formatOptions: a, value: l, defaultValue: i = NaN, onChange: u, locale: o, isDisabled: d, isReadOnly: s, commitBehavior: c = "snap" } = e;
  l === null && (l = NaN);
  let f = X((Z) => r === void 0 || isNaN(r) ? Ve(Z, t, n) : Ne(Z, t, n, r), [
    r,
    t,
    n
  ]);
  l !== void 0 && !isNaN(l) && c === "snap" && (l = f(l)), !isNaN(i) && c === "snap" && (i = f(i));
  let [h, m] = Pe(l, isNaN(i) ? NaN : i, u), [p] = Y(h), [b, y] = Y(() => isNaN(h) ? "" : new Kt(o, a).format(h)), $ = K(() => new Pu(o, a), [
    o,
    a
  ]), v = K(() => $.getNumberingSystem(b), [
    $,
    b
  ]), x = K(() => new Kt(o, {
    ...a,
    numberingSystem: v
  }), [
    o,
    a,
    v
  ]), E = K(() => x.resolvedOptions(), [
    x
  ]), P = X((Z) => isNaN(Z) || Z === null ? "" : x.format(Z), [
    x
  ]), C = rn({
    ...e,
    value: h
  }), M = r !== void 0 && !isNaN(r) ? r : 1;
  E.style === "percent" && (r === void 0 || isNaN(r)) && (M = 0.01);
  let [F, V] = Y(h), [I, A] = Y(o), [U, D] = Y(a);
  (!Object.is(h, F) || o !== I || !TD(a, U)) && (y(P(h)), V(h), A(o), D(a));
  let N = K(() => $.parse(b), [
    $,
    b
  ]), w = (Z) => {
    let ie = Z === void 0 ? b : Z, q = N;
    if (Z !== void 0 && (q = $.parse(ie)), !ie.length) {
      m(NaN), y(l === void 0 ? "" : P(h));
      return;
    }
    if (isNaN(q)) {
      y(P(h));
      return;
    }
    let re = c === "snap" ? f(q) : q;
    re = $.parse(P(re));
    let fe = re !== h;
    m(re), y(P(l === void 0 ? re : h)), fe && C.commitValidation();
  }, R = (Z, ie = 0) => {
    let q = N;
    if (isNaN(q)) {
      let re = isNaN(ie) ? 0 : ie;
      return Ne(re, t, n, M);
    } else {
      let re = Ne(q, t, n, M);
      return Z === "+" && re > q || Z === "-" && re < q ? re : Ne(li(Z, q, M), t, n, M);
    }
  }, H = () => {
    let Z = R("+", t);
    Z === h && y(P(Z)), m(Z), C.commitValidation();
  }, k = () => {
    let Z = R("-", n);
    Z === h && y(P(Z)), m(Z), C.commitValidation();
  }, S = () => {
    n != null && (m(Ne(n, t, n, M)), C.commitValidation());
  }, j = () => {
    t != null && (m(t), C.commitValidation());
  }, _ = K(() => !d && !s && (isNaN(N) || n === void 0 || isNaN(n) || Ne(N, t, n, M) > N || li("+", N, M) <= n), [
    d,
    s,
    t,
    n,
    M,
    N
  ]), B = K(() => !d && !s && (isNaN(N) || t === void 0 || isNaN(t) || Ne(N, t, n, M) < N || li("-", N, M) >= t), [
    d,
    s,
    t,
    n,
    M,
    N
  ]);
  return {
    ...C,
    validate: (Z) => $.isValidPartialNumber(Z, t, n),
    increment: H,
    incrementToMax: S,
    decrement: k,
    decrementToMin: j,
    canIncrement: _,
    canDecrement: B,
    minValue: t,
    maxValue: n,
    numberValue: N,
    defaultNumberValue: isNaN(i) ? p : i,
    setNumberValue: m,
    setInputValue: y,
    inputValue: b,
    commit: w
  };
}
function TD(e, t) {
  if (e === t) return !0;
  if (!e || !t) return !1;
  let n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  for (let a of n)
    if (t[a] !== e[a]) return !1;
  return !0;
}
function li(e, t, n) {
  let r = e === "+" ? t + n : t - n;
  if (t % 1 !== 0 || n % 1 !== 0) {
    const a = t.toString().split("."), l = n.toString().split("."), i = a[1] && a[1].length || 0, u = l[1] && l[1].length || 0, o = Math.pow(10, Math.max(i, u));
    t = Math.round(t * o), n = Math.round(n * o), r = e === "+" ? t + n : t - n, r /= o;
  }
  return r;
}
function ID(e) {
  let { channel: t, colorSpace: n, locale: r } = e, a = On(e.value), l = On(e.defaultValue), [i, u] = Pe(a, l ?? null, e.onChange), o = Us(i, n), [d] = Y(i), s = l ?? d, c = Us(s, n), f = o.getChannelValue(t), h = o.getChannelRange(t), m = K(() => o.getChannelFormatOptions(t), [
    o,
    t
  ]), p = m.style === "percent" && h.maxValue === 100 ? 100 : 1;
  return {
    ..._m({
      locale: r,
      value: i === null ? NaN : f / p,
      defaultValue: s === null ? NaN : c.getChannelValue(t) / p,
      onChange: (y) => {
        Number.isNaN(y) ? u(null) : u(o.withChannelValue(t, y * p));
      },
      minValue: h.minValue / p,
      maxValue: h.maxValue / p,
      step: h.step / p,
      formatOptions: m
    }),
    colorValue: o,
    defaultColorValue: s,
    setColorValue: u
  };
}
function Us(e, t) {
  let n = On("#000");
  return K(() => {
    let r = e || n;
    return t && r ? r.toFormat(t) : r;
  }, [
    n,
    e,
    t
  ]);
}
const Wm = /* @__PURE__ */ G(null), MD = /* @__PURE__ */ G(null), l9 = /* @__PURE__ */ te(function(t, n) {
  return [t, n] = oe(t, n, Wm), t.channel ? /* @__PURE__ */ g.createElement(KD, {
    ...t,
    channel: t.channel,
    forwardedRef: n
  }) : /* @__PURE__ */ g.createElement(ND, {
    ...t,
    forwardedRef: n
  });
});
function KD(e) {
  let { locale: t } = de(), n = ID({
    ...e,
    locale: t
  }), r = T(null), [a, l] = Je(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: i, inputProps: u, descriptionProps: o, errorMessageProps: d, ...s } = BD({
    ...Et(e),
    label: l,
    validationBehavior: e.validationBehavior ?? "native"
  }, n, r);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, Gm(e, n, e.forwardedRef, u, r, i, a, o, d, s), e.name && /* @__PURE__ */ g.createElement("input", {
    type: "hidden",
    name: e.name,
    form: e.form,
    value: isNaN(n.numberValue) ? "" : n.numberValue
  }));
}
function ND(e) {
  let t = RD({
    ...e,
    validationBehavior: e.validationBehavior ?? "native"
  }), n = T(null), [r, a] = Je(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: l, inputProps: i, descriptionProps: u, errorMessageProps: o, ...d } = wD({
    ...Et(e),
    label: a,
    validationBehavior: e.validationBehavior ?? "native"
  }, t, n);
  return Gm(e, t, e.forwardedRef, i, n, l, r, u, o, d);
}
function Gm(e, t, n, r, a, l, i, u, o, d) {
  let s = le({
    ...e,
    values: {
      state: t,
      channel: e.channel || "hex",
      isDisabled: e.isDisabled || !1,
      isInvalid: d.isInvalid || !1,
      isReadOnly: e.isReadOnly || !1,
      isRequired: e.isRequired || !1
    },
    defaultClassName: "react-aria-ColorField"
  }), c = J(e, {
    global: !0
  });
  return delete c.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        MD,
        t
      ],
      [
        Pr,
        {
          ...r,
          ref: a
        }
      ],
      [
        Qe,
        {
          ...l,
          ref: i
        }
      ],
      [
        vn,
        {
          role: "presentation",
          isInvalid: d.isInvalid,
          isDisabled: e.isDisabled || !1
        }
      ],
      [
        _e,
        {
          slots: {
            description: u,
            errorMessage: o
          }
        }
      ],
      [
        nn,
        d
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...c,
    ...s,
    ref: n,
    slot: e.slot || void 0,
    "data-channel": e.channel || "hex",
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": d.isInvalid || void 0,
    "data-readonly": e.isReadOnly || void 0,
    "data-required": e.isRequired || void 0
  }));
}
const Wu = /* @__PURE__ */ new WeakMap();
function _i(e, t) {
  let n = Wu.get(e);
  if (!n) throw new Error("Unknown slider state");
  return `${n.id}-${t}`;
}
function VD(e, t, n) {
  let { labelProps: r, fieldProps: a } = ma(e), l = e.orientation === "vertical";
  Wu.set(t, {
    id: r.id ?? a.id,
    "aria-describedby": e["aria-describedby"],
    "aria-details": e["aria-details"]
  });
  let { direction: i } = de(), { addGlobalListener: u, removeGlobalListener: o } = Qt();
  const d = T(null), s = i === "rtl", c = T(null), { moveProps: f } = ua({
    onMoveStart() {
      c.current = null;
    },
    onMove({ deltaX: b, deltaY: y }) {
      if (!n.current) return;
      let { height: $, width: v } = n.current.getBoundingClientRect(), x = l ? $ : v;
      c.current == null && d.current != null && (c.current = t.getThumbPercent(d.current) * x);
      let E = l ? y : b;
      if ((l || s) && (E = -E), c.current += E, d.current != null && n.current) {
        const P = Ve(c.current / x, 0, 1);
        t.setThumbPercent(d.current, P);
      }
    },
    onMoveEnd() {
      d.current != null && (t.setThumbDragging(d.current, !1), d.current = null);
    }
  });
  let h = T(void 0), m = (b, y, $, v) => {
    if (n.current && !e.isDisabled && t.values.every((x, E) => !t.isThumbDragging(E))) {
      let { height: x, width: E, top: P, left: C } = n.current.getBoundingClientRect(), M = l ? x : E, A = ((l ? v : $) - (l ? P : C)) / M;
      (i === "rtl" || l) && (A = 1 - A);
      let U = t.getPercentValue(A), D, N = t.values.findIndex((w) => U - w < 0);
      if (N === 0)
        D = N;
      else if (N === -1)
        D = t.values.length - 1;
      else {
        let w = t.values[N - 1], R = t.values[N];
        Math.abs(w - U) < Math.abs(R - U) ? D = N - 1 : D = N;
      }
      D >= 0 && t.isThumbEditable(D) ? (b.preventDefault(), d.current = D, t.setFocusedThumb(D), h.current = y, t.setThumbDragging(d.current, !0), t.setThumbValue(D, U), u(window, "mouseup", p, !1), u(window, "touchend", p, !1), u(window, "pointerup", p, !1)) : d.current = null;
    }
  }, p = (b) => {
    (b.pointerId ?? b.changedTouches?.[0].identifier) === h.current && (d.current != null && (t.setThumbDragging(d.current, !1), d.current = null), o(window, "mouseup", p, !1), o(window, "touchend", p, !1), o(window, "pointerup", p, !1));
  };
  return "htmlFor" in r && r.htmlFor && (delete r.htmlFor, r.onClick = () => {
    document.getElementById(_i(t, 0))?.focus(), qr("keyboard");
  }), {
    labelProps: r,
    // The root element of the Slider will have role="group" to group together
    // all the thumb inputs in the Slider.  The label of the Slider will
    // be used to label the group.
    groupProps: {
      role: "group",
      ...a
    },
    trackProps: z({
      onMouseDown(b) {
        b.button !== 0 || b.altKey || b.ctrlKey || b.metaKey || m(b, void 0, b.clientX, b.clientY);
      },
      onPointerDown(b) {
        b.pointerType === "mouse" && (b.button !== 0 || b.altKey || b.ctrlKey || b.metaKey) || m(b, b.pointerId, b.clientX, b.clientY);
      },
      onTouchStart(b) {
        m(b, b.changedTouches[0].identifier, b.changedTouches[0].clientX, b.changedTouches[0].clientY);
      },
      style: {
        position: "relative",
        touchAction: "none"
      }
    }, f),
    outputProps: {
      htmlFor: t.values.map((b, y) => _i(t, y)).join(" "),
      "aria-live": "off"
    }
  };
}
function LD(e, t) {
  let { index: n = 0, isRequired: r, validationState: a, isInvalid: l, trackRef: i, inputRef: u, orientation: o = t.orientation, name: d, form: s } = e, c = e.isDisabled || t.isDisabled, f = o === "vertical", { direction: h } = de(), { addGlobalListener: m, removeGlobalListener: p } = Qt(), b = Wu.get(t);
  const { labelProps: y, fieldProps: $ } = ma({
    ...e,
    id: _i(t, n),
    "aria-labelledby": `${b.id} ${e["aria-labelledby"] ?? ""}`.trim()
  }), v = t.values[n], x = X(() => {
    u.current && Fe(u.current);
  }, [
    u
  ]), E = t.focusedThumb === n;
  ee(() => {
    E && x();
  }, [
    E,
    x
  ]);
  let P = h === "rtl", C = T(null), { keyboardProps: M } = Er({
    onKeyDown(w) {
      let { getThumbMaxValue: R, getThumbMinValue: H, decrementThumb: k, incrementThumb: S, setThumbValue: j, setThumbDragging: _, pageSize: B } = t;
      if (!/^(PageUp|PageDown|Home|End)$/.test(w.key)) {
        w.continuePropagation();
        return;
      }
      switch (w.preventDefault(), _(n, !0), w.key) {
        case "PageUp":
          S(n, B);
          break;
        case "PageDown":
          k(n, B);
          break;
        case "Home":
          j(n, H(n));
          break;
        case "End":
          j(n, R(n));
          break;
      }
      _(n, !1);
    }
  }), { moveProps: F } = ua({
    onMoveStart() {
      C.current = null, t.setThumbDragging(n, !0);
    },
    onMove({ deltaX: w, deltaY: R, pointerType: H, shiftKey: k }) {
      const { getThumbPercent: S, setThumbPercent: j, decrementThumb: _, incrementThumb: B, step: L, pageSize: Z } = t;
      if (!i.current) return;
      let { width: ie, height: q } = i.current.getBoundingClientRect(), re = f ? q : ie;
      if (C.current == null && (C.current = S(n) * re), H === "keyboard")
        w > 0 && P || w < 0 && !P || R > 0 ? _(n, k ? Z : L) : B(n, k ? Z : L);
      else {
        let fe = f ? R : w;
        (f || P) && (fe = -fe), C.current += fe, j(n, Ve(C.current / re, 0, 1));
      }
    },
    onMoveEnd() {
      t.setThumbDragging(n, !1);
    }
  });
  t.setThumbEditable(n, !c);
  const { focusableProps: V } = dt(z(e, {
    onFocus: () => t.setFocusedThumb(n),
    onBlur: () => t.setFocusedThumb(void 0)
  }), u);
  let I = T(void 0), A = (w) => {
    x(), I.current = w, t.setThumbDragging(n, !0), m(window, "mouseup", U, !1), m(window, "touchend", U, !1), m(window, "pointerup", U, !1);
  }, U = (w) => {
    (w.pointerId ?? w.changedTouches?.[0].identifier) === I.current && (x(), t.setThumbDragging(n, !1), p(window, "mouseup", U, !1), p(window, "touchend", U, !1), p(window, "pointerup", U, !1));
  }, D = t.getThumbPercent(n);
  (f || h === "rtl") && (D = 1 - D);
  let N = c ? {} : z(M, F, {
    onMouseDown: (w) => {
      w.button !== 0 || w.altKey || w.ctrlKey || w.metaKey || A();
    },
    onPointerDown: (w) => {
      w.button !== 0 || w.altKey || w.ctrlKey || w.metaKey || A(w.pointerId);
    },
    onTouchStart: (w) => {
      A(w.changedTouches[0].identifier);
    }
  });
  return an(u, t.defaultValues[n], (w) => {
    t.setThumbValue(n, w);
  }), {
    inputProps: z(V, $, {
      type: "range",
      tabIndex: c ? void 0 : 0,
      min: t.getThumbMinValue(n),
      max: t.getThumbMaxValue(n),
      step: t.step,
      value: v,
      name: d,
      form: s,
      disabled: c,
      "aria-orientation": o,
      "aria-valuetext": t.getThumbValueLabel(n),
      "aria-required": r || void 0,
      "aria-invalid": l || a === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-describedby": [
        b["aria-describedby"],
        e["aria-describedby"]
      ].filter(Boolean).join(" "),
      "aria-details": [
        b["aria-details"],
        e["aria-details"]
      ].filter(Boolean).join(" "),
      onChange: (w) => {
        t.setThumbValue(n, parseFloat(W(w).value));
      }
    }),
    thumbProps: {
      ...N,
      style: {
        position: "absolute",
        [f ? "top" : "left"]: `${D * 100}%`,
        transform: "translate(-50%, -50%)",
        touchAction: "none"
      }
    },
    labelProps: y,
    isDragging: t.isThumbDragging(n),
    isDisabled: c,
    isFocused: E
  };
}
const zD = 0, OD = 100, HD = 1;
function UD(e) {
  const { isDisabled: t = !1, minValue: n = zD, maxValue: r = OD, numberFormatter: a, step: l = HD, orientation: i = "horizontal" } = e;
  let u = K(() => {
    let B = (r - n) / 10;
    return B = Ne(B, 0, B + l, l), Math.max(B, l);
  }, [
    l,
    r,
    n
  ]), o = X((B) => B?.map((L, Z) => {
    let ie = Z === 0 ? n : B[Z - 1], q = Z === B.length - 1 ? r : B[Z + 1];
    return Ne(L, ie, q, l);
  }), [
    n,
    r,
    l
  ]), d = K(() => o(_s(e.value)), [
    e.value,
    o
  ]), s = K(() => o(_s(e.defaultValue) ?? [
    n
  ]), [
    e.defaultValue,
    n,
    o
  ]), c = Ws(e.value, e.defaultValue, e.onChange), f = Ws(e.value, e.defaultValue, e.onChangeEnd);
  const [h, m] = Pe(d, s, c);
  let [p] = Y(h);
  const [b, y] = Y(new Array(h.length).fill(!1)), $ = T(new Array(h.length).fill(!0)), [v, x] = Y(void 0), E = T(h), P = T(b);
  let C = (B) => {
    E.current = B, m(B);
  }, M = (B) => {
    P.current = B, y(B);
  };
  function F(B) {
    return (B - n) / (r - n);
  }
  function V(B) {
    return B === 0 ? n : h[B - 1];
  }
  function I(B) {
    return B === h.length - 1 ? r : h[B + 1];
  }
  function A(B) {
    return $.current[B];
  }
  function U(B, L) {
    $.current[B] = L;
  }
  function D(B, L) {
    if (t || !A(B)) return;
    const Z = V(B), ie = I(B);
    L = Ne(L, Z, ie, l);
    let q = js(E.current, B, L);
    C(q);
  }
  function N(B, L) {
    if (t || !A(B)) return;
    L && (E.current = h);
    const Z = P.current[B];
    P.current = js(P.current, B, L), M(P.current), f && Z && !P.current.some(Boolean) && f(E.current);
  }
  let w = T(null);
  function R(B = h) {
    switch (typeof B == "number" && (B = [
      B
    ]), B.length) {
      case 0:
        return "";
      case 1:
        return a.format(B[0]);
      case 2:
        return a.formatRange(B[0], B[1]);
      default: {
        let L = B.map((ie) => a.format(ie)), Z = w.current;
        return (!Z || Z.resolvedOptions().locale !== a.resolvedOptions().locale) && (Z = w.current = new Intl.ListFormat(a.resolvedOptions().locale, {
          type: "unit"
        })), Z.format(L);
      }
    }
  }
  function H(B, L) {
    D(B, S(L));
  }
  function k(B) {
    return Math.round((B - n) / l) * l + n;
  }
  function S(B) {
    const L = B * (r - n) + n;
    return Ve(k(L), n, r);
  }
  function j(B, L = 1) {
    let Z = Math.max(L, l);
    D(B, Ne(h[B] + Z, n, r, l));
  }
  function _(B, L = 1) {
    let Z = Math.max(L, l);
    D(B, Ne(h[B] - Z, n, r, l));
  }
  return {
    values: h,
    defaultValues: e.defaultValue !== void 0 ? s : p,
    getThumbValue: (B) => h[B],
    setThumbValue: D,
    setThumbPercent: H,
    isThumbDragging: (B) => b[B],
    setThumbDragging: N,
    focusedThumb: v,
    setFocusedThumb: x,
    getThumbPercent: (B) => F(h[B]),
    getValuePercent: F,
    getThumbValueLabel: (B) => R(h[B]),
    getFormattedValue: R,
    getThumbMinValue: V,
    getThumbMaxValue: I,
    getPercentValue: S,
    isThumbEditable: A,
    setThumbEditable: U,
    incrementThumb: j,
    decrementThumb: _,
    step: l,
    pageSize: u,
    orientation: i,
    isDisabled: t
  };
}
function js(e, t, n) {
  return e[t] === n ? e : [
    ...e.slice(0, t),
    n,
    ...e.slice(t + 1)
  ];
}
function _s(e) {
  if (e != null)
    return Array.isArray(e) ? e : [
      e
    ];
}
function Ws(e, t, n) {
  return (r) => {
    n?.(typeof e == "number" || typeof t == "number" ? r[0] : r);
  };
}
const qm = /* @__PURE__ */ G(null), Ym = /* @__PURE__ */ G(null), jD = /* @__PURE__ */ G(null), i9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Ym);
  let r = O(qm), { onHoverStart: a, onHoverEnd: l, onHoverChange: i, ...u } = t, { hoverProps: o, isHovered: d } = ve({
    onHoverStart: a,
    onHoverEnd: l,
    onHoverChange: i
  }), s = le({
    ...t,
    defaultClassName: "react-aria-SliderTrack",
    values: {
      orientation: r.orientation,
      isDisabled: r.isDisabled,
      isHovered: d,
      state: r
    }
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(u, o),
    ...s,
    ref: n,
    "data-hovered": d || void 0,
    "data-orientation": r.orientation || void 0,
    "data-disabled": r.isDisabled || void 0
  });
});
function _D(e, t) {
  let { trackRef: n, inputRef: r, orientation: a, channel: l, "aria-label": i, name: u, form: o } = e, { locale: d, direction: s } = de();
  !e.label && !i && !e["aria-labelledby"] && (i = t.value.getChannelName(l, d));
  let { groupProps: c, trackProps: f, labelProps: h, outputProps: m } = VD(
    // @ts-ignore - ignore unused incompatible props
    {
      ...e,
      "aria-label": i
    },
    t,
    n
  ), { inputProps: p, thumbProps: b } = LD({
    index: 0,
    orientation: a,
    isDisabled: e.isDisabled,
    name: u,
    form: o,
    trackRef: n,
    inputRef: r
  }, t), y = t.getDisplayColor(), $ = () => {
    let E;
    switch (a === "vertical" ? E = "top" : s === "ltr" ? E = "right" : E = "left", l) {
      case "hue": {
        let P = [
          0,
          60,
          120,
          180,
          240,
          300,
          360
        ].map((C) => y.withChannelValue("hue", C).toString("css")).join(", ");
        return `linear-gradient(to ${E}, ${P})`;
      }
      case "lightness": {
        let P = t.getThumbMinValue(0), C = t.getThumbMaxValue(0), M = y.withChannelValue(l, P).toString("css"), F = y.withChannelValue(l, (C - P) / 2).toString("css"), V = y.withChannelValue(l, C).toString("css");
        return `linear-gradient(to ${E}, ${M}, ${F}, ${V})`;
      }
      case "saturation":
      case "brightness":
      case "red":
      case "green":
      case "blue":
      case "alpha": {
        let P = y.withChannelValue(l, t.getThumbMinValue(0)).toString("css"), C = y.withChannelValue(l, t.getThumbMaxValue(0)).toString("css");
        return `linear-gradient(to ${E}, ${P}, ${C})`;
      }
      default:
        throw new Error("Unknown color channel: " + l);
    }
  }, v = {
    forcedColorAdjust: "none"
  };
  l === "hue" ? p["aria-valuetext"] += `, ${y.getHueName(d)}` : l !== "alpha" && (p["aria-valuetext"] += `, ${y.getColorName(d)}`);
  let { visuallyHiddenProps: x } = tn({
    style: {
      opacity: "0.0001",
      width: "100%",
      height: "100%",
      pointerEvents: "none"
    }
  });
  return {
    trackProps: {
      ...z(c, f),
      style: {
        ...f.style,
        ...v,
        background: $()
      }
    },
    inputProps: {
      ...p,
      style: {
        ...p.style,
        ...x.style
      }
    },
    thumbProps: {
      ...b,
      style: {
        ...b.style,
        ...v
      }
    },
    labelProps: h,
    outputProps: m
  };
}
function WD(e) {
  let { channel: t, colorSpace: n, value: r, defaultValue: a, onChange: l, locale: i, ...u } = e;
  if (r == null && a == null) throw new Error("useColorSliderState requires a value or defaultValue");
  r && (r = fr(r)), a && (a = fr(a));
  let [o, d] = Pe(r, a, l), s = K(() => n && o ? o.toFormat(n) : o, [
    o,
    n
  ]), [c] = Y(o), f = a ?? c, h = K(() => n && f ? f.toFormat(n) : f, [
    f,
    n
  ]), m = K(() => new Intl.NumberFormat(), []), p = UD({
    ...s.getChannelRange(t),
    ...u,
    numberFormatter: m,
    value: s.getChannelValue(t),
    defaultValue: h.getChannelValue(t),
    onChange($) {
      d(s.withChannelValue(t, $));
    },
    onChangeEnd($) {
      e.onChangeEnd && e.onChangeEnd(s.withChannelValue(t, $));
    }
  }), { step: b, pageSize: y } = s.getChannelRange(t);
  return {
    ...p,
    value: s,
    setValue($) {
      d(fr($));
    },
    getDisplayColor() {
      switch (t) {
        case "hue":
          return Ye(`hsl(${s.getChannelValue("hue")}, 100%, 50%)`);
        case "lightness":
        case "brightness":
        case "saturation":
        case "red":
        case "green":
        case "blue":
          return s.withChannelValue("alpha", 1);
        case "alpha":
          return s;
        default:
          throw new Error("Unknown color channel: " + t);
      }
    },
    getThumbValueLabel() {
      return s.formatChannelValue(t, i);
    },
    getFormattedValue() {
      return s.formatChannelValue(t, i);
    },
    step: b,
    pageSize: y,
    isDragging: p.isThumbDragging(0)
  };
}
const Zm = /* @__PURE__ */ G(null), GD = /* @__PURE__ */ G(null), u9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Zm);
  let { locale: r } = de(), a = WD({
    ...t,
    locale: r
  }), l = g.useRef(null), i = g.useRef(null), [u, o] = Je(!t["aria-label"] && !t["aria-labelledby"]), { trackProps: d, thumbProps: s, inputProps: c, labelProps: f, outputProps: h } = _D({
    ...t,
    label: o,
    trackRef: l,
    inputRef: i
  }, a), m = le({
    ...t,
    values: {
      orientation: a.orientation,
      isDisabled: a.isDisabled,
      state: a
    },
    defaultClassName: "react-aria-ColorSlider"
  }), p = J(t, {
    global: !0
  });
  return delete p.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        GD,
        a
      ],
      [
        qm,
        a
      ],
      [
        Ym,
        {
          ...d,
          ref: l
        }
      ],
      [
        jD,
        h
      ],
      [
        Qe,
        {
          ...f,
          ref: u,
          children: a.value.getChannelName(t.channel, r)
        }
      ],
      [
        Ou,
        {
          state: a,
          thumbProps: s,
          inputXRef: i,
          xInputProps: c,
          isDisabled: t.isDisabled
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...p,
    ...m,
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": a.orientation,
    "data-disabled": a.isDisabled || void 0
  }));
});
function qD(e) {
  return e && e.__esModule ? e.default : e;
}
function YD(e) {
  let { color: t, colorName: n } = e, r = t || "#fff0", a = K(() => typeof r == "string" ? Ye(r) : r, [
    r
  ]), { locale: l } = de(), i = J(e, {
    labelable: !0
  }), u = xe(qD(Hu), "@react-aria/color"), o = ce(e.id);
  return n || (n = a.getChannelValue("alpha") === 0 ? u.format("transparent") : a.getColorName(l)), {
    colorSwatchProps: {
      ...i,
      role: "img",
      "aria-roledescription": u.format("colorSwatch"),
      "aria-label": [
        n,
        e["aria-label"] || ""
      ].filter(Boolean).join(", "),
      "aria-labelledby": e["aria-labelledby"] ? `${o} ${e["aria-labelledby"]}` : void 0,
      id: o,
      style: {
        backgroundColor: a.toString("css"),
        // @ts-ignore
        forcedColorAdjust: "none"
      }
    },
    color: a || null
  };
}
const Gu = /* @__PURE__ */ G(null), o9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Gu);
  let { colorSwatchProps: r, color: a } = YD(t), l = le({
    ...t,
    defaultClassName: "react-aria-ColorSwatch",
    defaultStyle: r.style,
    values: {
      color: a
    }
  }), i = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(i, r, l),
    slot: t.slot || void 0,
    ref: n
  });
});
var Xm = {};
Xm = {
  colorSwatchPicker: "تغييرات الألوان",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "حدد عنصرًا",
  tableResizer: "أداة تغيير الحجم"
};
var Jm = {};
Jm = {
  colorSwatchPicker: "Цветови мостри",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Изберете предмет",
  tableResizer: "Преоразмерител"
};
var Qm = {};
Qm = {
  colorSwatchPicker: "Vzorky barev",
  dropzoneLabel: "Místo pro přetažení",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Změna velikosti"
};
var ep = {};
ep = {
  colorSwatchPicker: "Farveprøver",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vælg et element",
  tableResizer: "Størrelsesændring"
};
var tp = {};
tp = {
  colorSwatchPicker: "Farbfelder",
  dropzoneLabel: "Ablegebereich",
  selectPlaceholder: "Element wählen",
  tableResizer: "Größenanpassung"
};
var np = {};
np = {
  colorSwatchPicker: "Χρωματικά δείγματα",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Επιλέξτε ένα αντικείμενο",
  tableResizer: "Αλλαγή μεγέθους"
};
var rp = {};
rp = {
  selectPlaceholder: "Select an item",
  tableResizer: "Resizer",
  dropzoneLabel: "DropZone",
  colorSwatchPicker: "Color swatches"
};
var ap = {};
ap = {
  colorSwatchPicker: "Muestras de colores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Seleccionar un artículo",
  tableResizer: "Cambiador de tamaño"
};
var lp = {};
lp = {
  colorSwatchPicker: "Värvinäidised",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valige üksus",
  tableResizer: "Suuruse muutja"
};
var ip = {};
ip = {
  colorSwatchPicker: "Värimallit",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Valitse kohde",
  tableResizer: "Koon muuttaja"
};
var up = {};
up = {
  colorSwatchPicker: "Échantillons de couleurs",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Sélectionner un élément",
  tableResizer: "Redimensionneur"
};
var op = {};
op = {
  colorSwatchPicker: "דוגמיות צבע",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "בחר פריט",
  tableResizer: "שינוי גודל"
};
var sp = {};
sp = {
  colorSwatchPicker: "Uzorci boja",
  dropzoneLabel: "Zona spuštanja",
  selectPlaceholder: "Odaberite stavku",
  tableResizer: "Promjena veličine"
};
var dp = {};
dp = {
  colorSwatchPicker: "Színtárak",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Válasszon ki egy elemet",
  tableResizer: "Átméretező"
};
var cp = {};
cp = {
  colorSwatchPicker: "Campioni di colore",
  dropzoneLabel: "Zona di rilascio",
  selectPlaceholder: "Seleziona un elemento",
  tableResizer: "Ridimensionamento"
};
var fp = {};
fp = {
  colorSwatchPicker: "カラースウォッチ",
  dropzoneLabel: "ドロップゾーン",
  selectPlaceholder: "項目を選択",
  tableResizer: "サイズ変更ツール"
};
var hp = {};
hp = {
  colorSwatchPicker: "색상 견본",
  dropzoneLabel: "드롭 영역",
  selectPlaceholder: "항목 선택",
  tableResizer: "크기 조정기"
};
var mp = {};
mp = {
  colorSwatchPicker: "Spalvų pavyzdžiai",
  dropzoneLabel: "„DropZone“",
  selectPlaceholder: "Pasirinkite elementą",
  tableResizer: "Dydžio keitiklis"
};
var pp = {};
pp = {
  colorSwatchPicker: "Krāsu paraugi",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izvēlēties vienumu",
  tableResizer: "Izmēra mainītājs"
};
var bp = {};
bp = {
  colorSwatchPicker: "Fargekart",
  dropzoneLabel: "Droppsone",
  selectPlaceholder: "Velg et element",
  tableResizer: "Størrelsesendrer"
};
var gp = {};
gp = {
  colorSwatchPicker: "kleurstalen",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecteer een item",
  tableResizer: "Resizer"
};
var yp = {};
yp = {
  colorSwatchPicker: "Próbki kolorów",
  dropzoneLabel: "Strefa upuszczania",
  selectPlaceholder: "Wybierz element",
  tableResizer: "Zmiana rozmiaru"
};
var $p = {};
$p = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var vp = {};
vp = {
  colorSwatchPicker: "Amostras de cores",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Selecione um item",
  tableResizer: "Redimensionador"
};
var Dp = {};
Dp = {
  colorSwatchPicker: "Specimene de culoare",
  dropzoneLabel: "Zonă de plasare",
  selectPlaceholder: "Selectați un element",
  tableResizer: "Instrument de redimensionare"
};
var xp = {};
xp = {
  colorSwatchPicker: "Цветовые образцы",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Выберите элемент",
  tableResizer: "Средство изменения размера"
};
var Ep = {};
Ep = {
  colorSwatchPicker: "Vzorkovníky farieb",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Vyberte položku",
  tableResizer: "Nástroj na zmenu veľkosti"
};
var Cp = {};
Cp = {
  colorSwatchPicker: "Barvne palete",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izberite element",
  tableResizer: "Spreminjanje velikosti"
};
var Pp = {};
Pp = {
  colorSwatchPicker: "Uzorci boje",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Izaberite stavku",
  tableResizer: "Promena veličine"
};
var wp = {};
wp = {
  colorSwatchPicker: "Färgrutor",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Välj en artikel",
  tableResizer: "Storleksändrare"
};
var Sp = {};
Sp = {
  colorSwatchPicker: "Renk örnekleri",
  dropzoneLabel: "Bırakma Bölgesi",
  selectPlaceholder: "Bir öğe seçin",
  tableResizer: "Yeniden boyutlandırıcı"
};
var kp = {};
kp = {
  colorSwatchPicker: "Зразки кольорів",
  dropzoneLabel: "DropZone",
  selectPlaceholder: "Виберіть елемент",
  tableResizer: "Засіб змінення розміру"
};
var Bp = {};
Bp = {
  colorSwatchPicker: "颜色色板",
  dropzoneLabel: "放置区域",
  selectPlaceholder: "选择一个项目",
  tableResizer: "尺寸调整器"
};
var Fp = {};
Fp = {
  colorSwatchPicker: "色票",
  dropzoneLabel: "放置區",
  selectPlaceholder: "選取項目",
  tableResizer: "大小調整器"
};
var qu = {};
qu = {
  "ar-AE": Xm,
  "bg-BG": Jm,
  "cs-CZ": Qm,
  "da-DK": ep,
  "de-DE": tp,
  "el-GR": np,
  "en-US": rp,
  "es-ES": ap,
  "et-EE": lp,
  "fi-FI": ip,
  "fr-FR": up,
  "he-IL": op,
  "hr-HR": sp,
  "hu-HU": dp,
  "it-IT": cp,
  "ja-JP": fp,
  "ko-KR": hp,
  "lt-LT": mp,
  "lv-LV": pp,
  "nb-NO": bp,
  "nl-NL": gp,
  "pl-PL": yp,
  "pt-BR": $p,
  "pt-PT": vp,
  "ro-RO": Dp,
  "ru-RU": xp,
  "sk-SK": Ep,
  "sl-SI": Cp,
  "sr-SP": Pp,
  "sv-SE": wp,
  "tr-TR": Sp,
  "uk-UA": kp,
  "zh-CN": Bp,
  "zh-TW": Fp
};
const Nt = /* @__PURE__ */ G({}), Yu = /* @__PURE__ */ G(null), ZD = /* @__PURE__ */ te(function(t, n) {
  let { render: r } = O(Yu);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, r(t, n));
});
function Zu(e, t) {
  let n = e?.renderDropIndicator, r = e?.isVirtualDragging?.(), a = X(
    (l) => {
      if (r || t?.isDropTarget(l)) return n ? n(l) : /* @__PURE__ */ g.createElement(ZD, {
        target: l
      });
    },
    // We invalidate whenever the target changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      t?.target,
      r,
      n
    ]
  );
  return e?.useDropIndicator ? a : void 0;
}
function Ap(e, t, n) {
  let r = e.focusedKey, a = null;
  if (t?.isVirtualDragging?.() && n?.target?.type === "item" && (a = n.target.key, n.target.dropPosition === "after")) {
    let l = n.collection.getKeyAfter(a), i = null;
    if (l != null) {
      let u = n.collection.getItem(a)?.level ?? 0;
      for (; l != null; ) {
        let o = n.collection.getItem(l);
        if (!o) break;
        if (o.type !== "item") {
          l = n.collection.getKeyAfter(l);
          continue;
        }
        if ((o.level ?? 0) <= u) break;
        i = l, l = n.collection.getKeyAfter(l);
      }
    }
    a = l ?? i ?? a;
  }
  return K(() => new Set([
    r,
    a
  ].filter((l) => l != null)), [
    r,
    a
  ]);
}
const Xu = /* @__PURE__ */ G({}), s9 = /* @__PURE__ */ Ct(xi, function(t, n) {
  return [t, n] = oe(t, n, Xu), /* @__PURE__ */ g.createElement(Q.header, {
    className: "react-aria-Header",
    ...t,
    ref: n
  }, t.children);
}), Rp = /* @__PURE__ */ G(null);
function jn(e) {
  let t = T({});
  return /* @__PURE__ */ g.createElement(Rp.Provider, {
    value: t
  }, e.children);
}
const XD = /* @__PURE__ */ te(function(t, n) {
  let { name: r, isVisible: a = !0, children: l, className: i, style: u, render: o, ...d } = t, [s, c] = Y(a ? "visible" : "hidden"), f = O(Rp);
  if (!f) throw new Error("<SharedElement> must be rendered inside a <SharedElementTransition>");
  a && s === "hidden" && c("visible"), n = $e(n), ue(() => {
    let m = n.current, p = f.current, b = p[r], y = null;
    if (m && a && b) {
      c("visible");
      let $ = m.getAnimations(), v = b.style.map(([x, E]) => {
        let P = m.style[x];
        if (x === "translate") {
          let C = b.rect, M = m.getBoundingClientRect(), F = C.left - M?.left, V = C.top - M?.top;
          m.style.translate = `${F}px ${V}px`;
        } else m.style[x] = E;
        return [
          x,
          P
        ];
      });
      for (let x of m.getAnimations()) $.includes(x) || x.cancel();
      y = requestAnimationFrame(() => {
        y = null;
        for (let [x, E] of v) m.style[x] = E;
      }), delete p[r];
    } else m && a && !b ? (queueMicrotask(() => at(() => c("entering"))), y = requestAnimationFrame(() => {
      y = null, c("visible");
    })) : m && !a && queueMicrotask(() => {
      p[r] ? (delete p[r], at(() => c("exiting")), Promise.all(m.getAnimations().map(($) => $.finished)).then(() => c("hidden")).catch(() => {
      })) : c("hidden");
    });
    return () => {
      if (y != null && cancelAnimationFrame(y), m && m.isConnected && !m.hasAttribute("data-exiting")) {
        let $ = window.getComputedStyle(m);
        if ($.transitionProperty !== "none") {
          let v = $.transitionProperty.split(/\s*,\s*/);
          p[r] = {
            rect: m.getBoundingClientRect(),
            style: v.map((x) => [
              x,
              $[x]
            ])
          };
        }
      }
    };
  }, [
    n,
    f,
    r,
    a
  ]);
  let h = le({
    children: l,
    className: i,
    style: u,
    render: o,
    values: {
      isEntering: s === "entering",
      isExiting: s === "exiting"
    }
  });
  return s === "hidden" ? null : /* @__PURE__ */ g.createElement(Q.div, {
    ...d,
    ...h,
    ref: n,
    "data-entering": s === "entering" || void 0,
    "data-exiting": s === "exiting" || void 0
  });
}), _n = /* @__PURE__ */ G({
  isSelected: !1
}), d9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, _n);
  let { isSelected: r, ...a } = t;
  return /* @__PURE__ */ g.createElement(XD, {
    ...a,
    ref: n,
    className: t.className || "react-aria-SelectionIndicator",
    name: "SelectionIndicator",
    isVisible: r
  });
});
function JD(e) {
  let t = J(e, {
    labelable: !0
  }), n;
  return e.orientation === "vertical" && (n = "vertical"), e.elementType !== "hr" ? {
    separatorProps: {
      ...t,
      role: "separator",
      "aria-orientation": n
    }
  } : {
    separatorProps: t
  };
}
const Ju = /* @__PURE__ */ G({}), Bo = class Bo extends st {
  filter(t, n) {
    let r = n.getItem(this.prevKey);
    if (r && r.type !== "separator") {
      let a = this.clone();
      return n.addDescendants(a, t), a;
    }
    return null;
  }
};
Bo.type = "separator";
let Wi = Bo;
const c9 = /* @__PURE__ */ Ct(Wi, function(t, n) {
  [t, n] = oe(t, n, Ju);
  let { elementType: r, orientation: a, style: l, className: i, slot: u, ...o } = t, d = r || "hr";
  d === "hr" && a === "vertical" && (d = "div");
  let s = Q[d], { separatorProps: c } = JD({
    ...o,
    elementType: r,
    orientation: a
  }), f = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(s, {
    render: t.render,
    ...z(f, c),
    style: l,
    className: i ?? "react-aria-Separator",
    ref: n,
    slot: u || void 0
  });
}), Qu = /* @__PURE__ */ new WeakMap();
function QD(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function ex(e, t) {
  let n = Qu.get(e);
  if (!n) throw new Error("Unknown list");
  return `${n.id}-option-${QD(t)}`;
}
class tx {
  constructor(t, n, r, a) {
    this._walkerStack = [], this._currentSetFor = /* @__PURE__ */ new Set(), this._acceptNode = (i) => {
      if (i.nodeType === Node.ELEMENT_NODE) {
        const u = i.shadowRoot;
        if (u) {
          const o = this._doc.createTreeWalker(u, this.whatToShow, {
            acceptNode: this._acceptNode
          });
          return this._walkerStack.unshift(o), NodeFilter.FILTER_ACCEPT;
        } else {
          if (typeof this.filter == "function") return this.filter(i);
          if (this.filter?.acceptNode) return this.filter.acceptNode(i);
          if (this.filter === null) return NodeFilter.FILTER_ACCEPT;
        }
      }
      return NodeFilter.FILTER_SKIP;
    }, this._doc = t, this.root = n, this.filter = a ?? null, this.whatToShow = r ?? NodeFilter.SHOW_ALL, this._currentNode = n, this._walkerStack.unshift(t.createTreeWalker(n, r, this._acceptNode));
    const l = n.shadowRoot;
    if (l) {
      const i = this._doc.createTreeWalker(l, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      this._walkerStack.unshift(i);
    }
  }
  get currentNode() {
    return this._currentNode;
  }
  set currentNode(t) {
    if (!ae(this.root, t)) throw new Error("Cannot set currentNode to a node that is not contained by the root node.");
    const n = [];
    let r = t, a = t;
    for (this._currentNode = t; r && r !== this.root; ) if (r.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
      const i = r, u = this._doc.createTreeWalker(i, this.whatToShow, {
        acceptNode: this._acceptNode
      });
      n.push(u), u.currentNode = a, this._currentSetFor.add(u), r = a = i.host;
    } else r = r.parentNode;
    const l = this._doc.createTreeWalker(this.root, this.whatToShow, {
      acceptNode: this._acceptNode
    });
    n.push(l), l.currentNode = a, this._currentSetFor.add(l), this._walkerStack = n;
  }
  get doc() {
    return this._doc;
  }
  firstChild() {
    let t = this.currentNode, n = this.nextNode();
    return ae(t, n) ? (n && (this.currentNode = n), n) : (this.currentNode = t, null);
  }
  lastChild() {
    let n = this._walkerStack[0].lastChild();
    return n && (this.currentNode = n), n;
  }
  nextNode() {
    const t = this._walkerStack[0].nextNode();
    if (t) {
      if (t.shadowRoot) {
        let r;
        if (typeof this.filter == "function" ? r = this.filter(t) : this.filter?.acceptNode && (r = this.filter.acceptNode(t)), r === NodeFilter.FILTER_ACCEPT)
          return this.currentNode = t, t;
        let a = this.nextNode();
        return a && (this.currentNode = a), a;
      }
      return t && (this.currentNode = t), t;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let n = this.nextNode();
      return n && (this.currentNode = n), n;
    } else return null;
  }
  previousNode() {
    const t = this._walkerStack[0];
    if (t.currentNode === t.root) {
      if (this._currentSetFor.has(t))
        if (this._currentSetFor.delete(t), this._walkerStack.length > 1) {
          this._walkerStack.shift();
          let r = this.previousNode();
          return r && (this.currentNode = r), r;
        } else return null;
      return null;
    }
    const n = t.previousNode();
    if (n) {
      if (n.shadowRoot) {
        let a;
        if (typeof this.filter == "function" ? a = this.filter(n) : this.filter?.acceptNode && (a = this.filter.acceptNode(n)), a === NodeFilter.FILTER_ACCEPT)
          return n && (this.currentNode = n), n;
        let l = this.lastChild();
        return l && (this.currentNode = l), l;
      }
      return n && (this.currentNode = n), n;
    } else if (this._walkerStack.length > 1) {
      this._walkerStack.shift();
      let r = this.previousNode();
      return r && (this.currentNode = r), r;
    } else return null;
  }
  /**
  * @deprecated
  */
  nextSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  previousSibling() {
    return null;
  }
  /**
  * @deprecated
  */
  parentNode() {
    return null;
  }
}
function Tp(e, t, n, r) {
  return Ht() ? new tx(e, t, n, r) : e.createTreeWalker(t, n, r);
}
const Gs = /* @__PURE__ */ g.createContext(null), Gi = "react-aria-focus-scope-restore";
let Ce = null;
function Sl(e) {
  let { children: t, contain: n, restoreFocus: r, autoFocus: a } = e, l = T(null), i = T(null), u = T([]), { parentNode: o } = O(Gs) || {}, d = K(() => new Yi({
    scopeRef: u
  }), [
    u
  ]);
  ue(() => {
    let f = o || Ie.root;
    if (Ie.getTreeNode(f.scopeRef) && Ce && !ol(Ce, f.scopeRef)) {
      let h = Ie.getTreeNode(Ce);
      h && (f = h);
    }
    f.addChild(d), Ie.addNode(d);
  }, [
    d,
    o
  ]), ue(() => {
    let f = Ie.getTreeNode(u);
    f && (f.contain = !!n);
  }, [
    n
  ]), ue(() => {
    let f = l.current?.nextSibling, h = [], m = (p) => p.stopPropagation();
    for (; f && f !== i.current; )
      h.push(f), f.addEventListener(Gi, m), f = f.nextSibling;
    return u.current = h, () => {
      for (let p of h) p.removeEventListener(Gi, m);
    };
  }, [
    t
  ]), ox(u, r, n), lx(u, n), sx(u, r, n), ux(u, a), ee(() => {
    const f = se(he(u.current ? u.current[0] : void 0));
    let h = null;
    if (ut(f, u.current)) {
      for (let m of Ie.traverse()) m.scopeRef && ut(f, m.scopeRef.current) && (h = m);
      h === Ie.getTreeNode(u) && (Ce = h.scopeRef);
    }
  }, [
    u
  ]), ue(() => () => {
    let f = Ie.getTreeNode(u)?.parent?.scopeRef ?? null;
    (u === Ce || ol(u, Ce)) && (!f || Ie.getTreeNode(f)) && (Ce = f), Ie.removeTreeNode(u);
  }, [
    u
  ]);
  let s = K(() => nx(u), []), c = K(() => ({
    focusManager: s,
    parentNode: d
  }), [
    d,
    s
  ]);
  return /* @__PURE__ */ g.createElement(Gs.Provider, {
    value: c
  }, /* @__PURE__ */ g.createElement("span", {
    "data-focus-scope-start": !0,
    hidden: !0,
    ref: l
  }), t, /* @__PURE__ */ g.createElement("span", {
    "data-focus-scope-end": !0,
    hidden: !0,
    ref: i
  }));
}
function nx(e) {
  return {
    focusNext(t = {}) {
      let n = e.current, { from: r, tabbable: a, wrap: l, accept: i } = t, u = r || se(he(n[0] ?? void 0)), o = n[0].previousElementSibling, d = In(n), s = Te(d, {
        tabbable: a,
        accept: i
      }, n);
      s.currentNode = ut(u, n) ? u : o;
      let c = s.nextNode();
      return !c && l && (s.currentNode = o, c = s.nextNode()), c && qe(c, !0), c;
    },
    focusPrevious(t = {}) {
      let n = e.current, { from: r, tabbable: a, wrap: l, accept: i } = t, u = r || se(he(n[0] ?? void 0)), o = n[n.length - 1].nextElementSibling, d = In(n), s = Te(d, {
        tabbable: a,
        accept: i
      }, n);
      s.currentNode = ut(u, n) ? u : o;
      let c = s.previousNode();
      return !c && l && (s.currentNode = o, c = s.previousNode()), c && qe(c, !0), c;
    },
    focusFirst(t = {}) {
      let n = e.current, { tabbable: r, accept: a } = t, l = In(n), i = Te(l, {
        tabbable: r,
        accept: a
      }, n);
      i.currentNode = n[0].previousElementSibling;
      let u = i.nextNode();
      return u && qe(u, !0), u;
    },
    focusLast(t = {}) {
      let n = e.current, { tabbable: r, accept: a } = t, l = In(n), i = Te(l, {
        tabbable: r,
        accept: a
      }, n);
      i.currentNode = n[n.length - 1].nextElementSibling;
      let u = i.previousNode();
      return u && qe(u, !0), u;
    }
  };
}
function In(e) {
  return e[0].parentElement;
}
function Or(e) {
  let t = Ie.getTreeNode(Ce);
  for (; t && t.scopeRef !== e; ) {
    if (t.contain) return !1;
    t = t.parent;
  }
  return !0;
}
function rx(e) {
  if (!e.form)
    return Array.from(he(e).querySelectorAll(`input[type="radio"][name="${CSS.escape(e.name)}"]`)).filter((r) => !r.form);
  const t = e.form.elements.namedItem(e.name);
  let n = ke(e);
  return t instanceof n.RadioNodeList ? Array.from(t).filter((r) => r instanceof n.HTMLInputElement) : t instanceof n.HTMLInputElement ? [
    t
  ] : [];
}
function ax(e) {
  if (e.checked) return !0;
  const t = rx(e);
  return t.length > 0 && !t.some((n) => n.checked);
}
function lx(e, t) {
  let n = T(void 0), r = T(void 0);
  ue(() => {
    let a = e.current;
    if (!t) {
      r.current && (cancelAnimationFrame(r.current), r.current = void 0);
      return;
    }
    const l = he(a ? a[0] : void 0);
    let i = (d) => {
      if (d.key !== "Tab" || d.altKey || d.ctrlKey || d.metaKey || !Or(e) || d.isComposing) return;
      let s = se(l), c = e.current;
      if (!c || !ut(s, c)) return;
      let f = In(c), h = Te(f, {
        tabbable: !0
      }, c);
      if (!s) return;
      h.currentNode = s;
      let m = d.shiftKey ? h.previousNode() : h.nextNode();
      m || (h.currentNode = d.shiftKey ? c[c.length - 1].nextElementSibling : c[0].previousElementSibling, m = d.shiftKey ? h.previousNode() : h.nextNode()), d.preventDefault(), m && (qe(m, !0), m instanceof ke(m).HTMLInputElement && m.select());
    }, u = (d) => {
      (!Ce || ol(Ce, e)) && ut(W(d), e.current) ? (Ce = e, n.current = W(d)) : Or(e) && !hn(W(d), e) ? n.current ? n.current.focus() : Ce && Ce.current && qi(Ce.current) : Or(e) && (n.current = W(d));
    }, o = (d) => {
      r.current && cancelAnimationFrame(r.current), r.current = requestAnimationFrame(() => {
        let s = yt(), c = (s === "virtual" || s === null) && pn() && qd(), f = se(l);
        if (!c && f && Or(e) && !hn(f, e)) {
          Ce = e;
          let h = W(d);
          h && h.isConnected ? (n.current = h, n.current?.focus()) : Ce.current && qi(Ce.current);
        }
      });
    };
    return l.addEventListener("keydown", i, !1), l.addEventListener("focusin", u, !1), a?.forEach((d) => d.addEventListener("focusin", u, !1)), a?.forEach((d) => d.addEventListener("focusout", o, !1)), () => {
      l.removeEventListener("keydown", i, !1), l.removeEventListener("focusin", u, !1), a?.forEach((d) => d.removeEventListener("focusin", u, !1)), a?.forEach((d) => d.removeEventListener("focusout", o, !1));
    };
  }, [
    e,
    t
  ]), ue(() => () => {
    r.current && cancelAnimationFrame(r.current);
  }, [
    r
  ]);
}
function Ip(e) {
  return hn(e);
}
function ut(e, t) {
  return !e || !t ? !1 : t.some((n) => ae(n, e));
}
function hn(e, t = null) {
  if (e instanceof Element && e.closest("[data-react-aria-top-layer]")) return !0;
  for (let { scopeRef: n } of Ie.traverse(Ie.getTreeNode(t)))
    if (n && ut(e, n.current)) return !0;
  return !1;
}
function ix(e) {
  return hn(e, Ce);
}
function ol(e, t) {
  let n = Ie.getTreeNode(t)?.parent;
  for (; n; ) {
    if (n.scopeRef === e) return !0;
    n = n.parent;
  }
  return !1;
}
function qe(e, t = !1) {
  if (e != null && !t) try {
    we(e);
  } catch {
  }
  else if (e != null) try {
    e.focus();
  } catch {
  }
}
function Mp(e, t = !0) {
  let n = e[0].previousElementSibling, r = In(e), a = Te(r, {
    tabbable: t
  }, e);
  a.currentNode = n;
  let l = a.nextNode();
  return t && !l && (r = In(e), a = Te(r, {
    tabbable: !1
  }, e), a.currentNode = n, l = a.nextNode()), l;
}
function qi(e, t = !0) {
  qe(Mp(e, t));
}
function ux(e, t) {
  const n = g.useRef(t);
  ee(() => {
    if (n.current) {
      Ce = e;
      const r = he(e.current ? e.current[0] : void 0);
      !ut(se(r), Ce.current) && e.current && qi(e.current);
    }
    n.current = !1;
  }, [
    e
  ]);
}
function ox(e, t, n) {
  ue(() => {
    if (t || n) return;
    let r = e.current;
    const a = he(r ? r[0] : void 0);
    let l = (i) => {
      let u = W(i);
      ut(u, e.current) ? Ce = e : Ip(u) || (Ce = null);
    };
    return a.addEventListener("focusin", l, !1), r?.forEach((i) => i.addEventListener("focusin", l, !1)), () => {
      a.removeEventListener("focusin", l, !1), r?.forEach((i) => i.removeEventListener("focusin", l, !1));
    };
  }, [
    e,
    t,
    n
  ]);
}
function qs(e) {
  let t = Ie.getTreeNode(Ce);
  for (; t && t.scopeRef !== e; ) {
    if (t.nodeToRestore) return !1;
    t = t.parent;
  }
  return t?.scopeRef === e;
}
function sx(e, t, n) {
  const r = T(typeof document < "u" ? se(he(e.current ? e.current[0] : void 0)) : null);
  ue(() => {
    let a = e.current;
    const l = he(a ? a[0] : void 0);
    if (!t || n) return;
    let i = () => {
      (!Ce || ol(Ce, e)) && ut(se(l), e.current) && (Ce = e);
    };
    return l.addEventListener("focusin", i, !1), a?.forEach((u) => u.addEventListener("focusin", i, !1)), () => {
      l.removeEventListener("focusin", i, !1), a?.forEach((u) => u.removeEventListener("focusin", i, !1));
    };
  }, [
    e,
    n
  ]), ue(() => {
    const a = he(e.current ? e.current[0] : void 0);
    if (!t) return;
    let l = (i) => {
      if (i.key !== "Tab" || i.altKey || i.ctrlKey || i.metaKey || !Or(e) || i.isComposing) return;
      let u = a.activeElement;
      if (!hn(u, e) || !qs(e)) return;
      let o = Ie.getTreeNode(e);
      if (!o) return;
      let d = o.nodeToRestore, s = Te(a.body, {
        tabbable: !0
      });
      s.currentNode = u;
      let c = i.shiftKey ? s.previousNode() : s.nextNode();
      if ((!d || !d.isConnected || d === a.body) && (d = void 0, o.nodeToRestore = void 0), (!c || !hn(c, e)) && d) {
        s.currentNode = d;
        do
          c = i.shiftKey ? s.previousNode() : s.nextNode();
        while (hn(c, e));
        i.preventDefault(), i.stopPropagation(), c ? qe(c, !0) : Ip(d) ? qe(d, !0) : u.blur();
      }
    };
    return n || a.addEventListener("keydown", l, !0), () => {
      n || a.removeEventListener("keydown", l, !0);
    };
  }, [
    e,
    t,
    n
  ]), ue(() => {
    const a = he(e.current ? e.current[0] : void 0);
    if (!t) return;
    let l = Ie.getTreeNode(e);
    if (l)
      return l.nodeToRestore = r.current ?? void 0, () => {
        let i = Ie.getTreeNode(e);
        if (!i) return;
        let u = i.nodeToRestore, o = se(a);
        if (t && u && (o && hn(o, e) || o === a.body && qs(e))) {
          let d = Ie.clone();
          requestAnimationFrame(() => {
            if (a.activeElement === a.body) {
              let s = d.getTreeNode(e);
              for (; s; ) {
                if (s.nodeToRestore && s.nodeToRestore.isConnected) {
                  Ys(s.nodeToRestore);
                  return;
                }
                s = s.parent;
              }
              for (s = d.getTreeNode(e); s; ) {
                if (s.scopeRef && // TODO: this is probably a false positive based on naming, it's not a real ref, rename.
                // oxlint-disable-next-line react-hooks/exhaustive-deps
                s.scopeRef.current && Ie.getTreeNode(s.scopeRef)) {
                  let c = Mp(s.scopeRef.current, !0);
                  Ys(c);
                  return;
                }
                s = s.parent;
              }
            }
          });
        }
      };
  }, [
    e,
    t
  ]);
}
function Ys(e) {
  e.dispatchEvent(new CustomEvent(Gi, {
    bubbles: !0,
    cancelable: !0
  })) && qe(e);
}
function Te(e, t, n) {
  let r = t?.tabbable ? _a : pu, a = e?.nodeType === Node.ELEMENT_NODE ? e : null, l = he(a), i = Tp(l, e || l, NodeFilter.SHOW_ELEMENT, {
    acceptNode(u) {
      return ae(t?.from, u) || t?.tabbable && u.tagName === "INPUT" && u.getAttribute("type") === "radio" && (!ax(u) || i.currentNode.tagName === "INPUT" && i.currentNode.type === "radio" && i.currentNode.name === u.name) ? NodeFilter.FILTER_REJECT : r(u) && (!n || ut(u, n)) && (!t?.accept || t.accept(u)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t?.from && (i.currentNode = t.from), i;
}
function kl(e, t = {}) {
  return {
    focusNext(n = {}) {
      let r = e.current;
      if (!r) return null;
      let { from: a, tabbable: l = t.tabbable, wrap: i = t.wrap, accept: u = t.accept } = n, o = a || se(he(r)), d = Te(r, {
        tabbable: l,
        accept: u
      });
      ae(r, o) && (d.currentNode = o);
      let s = d.nextNode();
      return !s && i && (d.currentNode = r, s = d.nextNode()), s && qe(s, !0), s;
    },
    focusPrevious(n = t) {
      let r = e.current;
      if (!r) return null;
      let { from: a, tabbable: l = t.tabbable, wrap: i = t.wrap, accept: u = t.accept } = n, o = a || se(he(r)), d = Te(r, {
        tabbable: l,
        accept: u
      });
      if (ae(r, o)) d.currentNode = o;
      else {
        let c = ii(d);
        return c && qe(c, !0), c ?? null;
      }
      let s = d.previousNode();
      if (!s && i) {
        d.currentNode = r;
        let c = ii(d);
        if (!c)
          return null;
        s = c;
      }
      return s && qe(s, !0), s ?? null;
    },
    focusFirst(n = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: a = t.tabbable, accept: l = t.accept } = n, u = Te(r, {
        tabbable: a,
        accept: l
      }).nextNode();
      return u && qe(u, !0), u;
    },
    focusLast(n = t) {
      let r = e.current;
      if (!r) return null;
      let { tabbable: a = t.tabbable, accept: l = t.accept } = n, i = Te(r, {
        tabbable: a,
        accept: l
      }), u = ii(i);
      return u && qe(u, !0), u ?? null;
    }
  };
}
function ii(e) {
  let t, n;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
class eo {
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new Yi({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let a = this.fastMap.get(n ?? null);
    if (!a) return;
    let l = new Yi({
      scopeRef: t
    });
    a.addChild(l), l.parent = a, this.fastMap.set(t, l), r && (l.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null) return;
    let n = this.fastMap.get(t);
    if (!n) return;
    let r = n.parent;
    for (let l of this.traverse()) l !== n && n.nodeToRestore && l.nodeToRestore && n.scopeRef && n.scopeRef.current && ut(l.nodeToRestore, n.scopeRef.current) && (l.nodeToRestore = n.nodeToRestore);
    let a = n.children;
    r && (r.removeChild(n), a.size > 0 && a.forEach((l) => r && r.addChild(l))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0) for (let n of t.children) yield* this.traverse(n);
  }
  clone() {
    let t = new eo();
    for (let n of this.traverse()) t.addTreeNode(n.scopeRef, n.parent?.scopeRef ?? null, n.nodeToRestore);
    return t;
  }
}
class Yi {
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
}
let Ie = new eo();
function Zi(e) {
  return p5() ? e.altKey : e.ctrlKey;
}
function Mn(e, t) {
  let n = `[data-key="${CSS.escape(String(t))}"]`, r = e.current?.dataset.collection;
  return r && (n = `[data-collection="${CSS.escape(r)}"]${n}`), e.current?.querySelector(n);
}
const Kp = /* @__PURE__ */ new WeakMap();
function dx(e) {
  let t = ce();
  return Kp.set(e, t), t;
}
function cx(e) {
  return Kp.get(e);
}
const Zs = 1e3;
function Np(e) {
  let { keyboardDelegate: t, selectionManager: n, onTypeSelect: r } = e, a = T({
    search: "",
    timeout: void 0
  }), l = (u) => {
    if (a.current.search.length > 0 && u.key === " ") {
      if (u.preventDefault(), (!("continuePropagation" in u) || "continuePropagation" in u && !u.isPropagationStopped()) && u.stopPropagation(), a.current.search += " ", t.getKeyForSearch != null) {
        let o = t.getKeyForSearch(a.current.search, n.focusedKey);
        o == null && (o = t.getKeyForSearch(a.current.search)), o != null && (n.setFocusedKey(o), r && r(o));
      }
      clearTimeout(a.current.timeout), a.current.timeout = setTimeout(() => {
        a.current.search = "";
      }, Zs);
    }
  }, i = (u) => {
    let o = fx(u.key);
    if (!(!o || u.ctrlKey || u.metaKey || u.altKey || !ae(u.currentTarget, W(u)) || a.current.search.length === 0 && o === " ")) {
      if (a.current.search += o, t.getKeyForSearch != null) {
        let d = t.getKeyForSearch(a.current.search, n.focusedKey);
        if (d == null && (d = t.getKeyForSearch(a.current.search)), d != null)
          n.setFocusedKey(d), r && r(d), u.preventDefault(), "continuePropagation" in u || u.stopPropagation();
        else {
          a.current.search = "", clearTimeout(a.current.timeout), a.current.timeout = void 0;
          return;
        }
      }
      clearTimeout(a.current.timeout), a.current.timeout = setTimeout(() => {
        a.current.search = "";
      }, Zs);
    }
  };
  return ee(() => {
    let u = a.current.timeout;
    return () => {
      clearTimeout(u);
    };
  }, [
    a
  ]), {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? l : void 0,
      onKeyDown: t.getKeyForSearch ? i : void 0
    }
  };
}
function fx(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function Xs(e, t) {
  const n = T(!0), r = T(null);
  ue(() => (n.current = !0, () => {
    n.current = !1;
  }), []), ue(() => {
    n.current ? n.current = !1 : (!r.current || t.some((a, l) => !Object.is(a, r[l]))) && e(), r.current = t;
  }, t);
}
function to(e) {
  let { selectionManager: t, keyboardDelegate: n, ref: r, autoFocus: a = !1, shouldFocusWrap: l = !1, disallowEmptySelection: i = !1, disallowSelectAll: u = !1, escapeKeyBehavior: o = "clearSelection", selectOnFocus: d = t.selectionBehavior === "replace", disallowTypeAhead: s = !1, shouldUseVirtualFocus: c, allowsTabNavigation: f = !1, scrollRef: h = r, linkBehavior: m = "action", UNSTABLE_focusOnEntry: p } = e, { direction: b } = de(), y = Dr(), $ = (w) => {
    if (w.altKey && w.key === "Tab" && w.preventDefault(), !r.current || !ae(r.current, W(w))) return;
    const R = (H, k) => {
      if (H != null) {
        if (t.isLink(H) && m === "selection" && d && !Zi(w)) {
          at(() => {
            t.setFocusedKey(H, k);
          });
          let S = Mn(r, H), j = t.getItemProps(H);
          S && y.open(S, w, j.href, j.routerOptions);
          return;
        }
        if (t.setFocusedKey(H, k), t.isLink(H) && m === "override") return;
        w.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(H) : d && !Zi(w) && t.replaceSelection(H);
      }
    };
    switch (w.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          let H = t.focusedKey != null ? n.getKeyBelow?.(t.focusedKey) : n.getFirstKey?.();
          H == null && l && (H = n.getFirstKey?.(t.focusedKey)), H != null && (w.preventDefault(), R(H));
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          let H = t.focusedKey != null ? n.getKeyAbove?.(t.focusedKey) : n.getLastKey?.();
          H == null && l && (H = n.getLastKey?.(t.focusedKey)), H != null && (w.preventDefault(), R(H));
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          let H = t.focusedKey != null ? n.getKeyLeftOf?.(t.focusedKey) : n.getFirstKey?.();
          H == null && l && (H = b === "rtl" ? n.getFirstKey?.(t.focusedKey) : n.getLastKey?.(t.focusedKey)), H != null && (w.preventDefault(), R(H, b === "rtl" ? "first" : "last"));
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          let H = t.focusedKey != null ? n.getKeyRightOf?.(t.focusedKey) : n.getFirstKey?.();
          H == null && l && (H = b === "rtl" ? n.getLastKey?.(t.focusedKey) : n.getFirstKey?.(t.focusedKey)), H != null && (w.preventDefault(), R(H, b === "rtl" ? "last" : "first"));
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          if (t.focusedKey === null && w.shiftKey) return;
          w.preventDefault();
          let H = n.getFirstKey(t.focusedKey, Bn(w));
          t.setFocusedKey(H), H != null && (Bn(w) && w.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(H) : d && t.replaceSelection(H));
        }
        break;
      case "End":
        if (n.getLastKey) {
          if (t.focusedKey === null && w.shiftKey) return;
          w.preventDefault();
          let H = n.getLastKey(t.focusedKey, Bn(w));
          t.setFocusedKey(H), H != null && (Bn(w) && w.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(H) : d && t.replaceSelection(H));
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow && t.focusedKey != null) {
          let H = n.getKeyPageBelow(t.focusedKey);
          H != null && (w.preventDefault(), R(H));
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove && t.focusedKey != null) {
          let H = n.getKeyPageAbove(t.focusedKey);
          H != null && (w.preventDefault(), R(H));
        }
        break;
      case "a":
        Bn(w) && t.selectionMode === "multiple" && u !== !0 && (w.preventDefault(), t.selectAll());
        break;
      case "Escape":
        o === "clearSelection" && !i && t.selectedKeys.size !== 0 && (w.stopPropagation(), w.preventDefault(), t.clearSelection());
        break;
      case "Tab":
        if (!f) {
          if (w.shiftKey) r.current.focus();
          else {
            let H = Te(r.current, {
              tabbable: !0
            }), k, S;
            do
              S = H.lastChild(), S && (k = S);
            while (S);
            let j = se();
            k && (!qt(k) || j && !_a(j)) && Fe(k);
          }
          break;
        }
    }
  }, v = T({
    top: 0,
    left: 0
  });
  mt(h, "scroll", () => {
    v.current = {
      top: h.current?.scrollTop ?? 0,
      left: h.current?.scrollLeft ?? 0
    };
  });
  let x = (w) => {
    if (t.isFocused) {
      ae(w.currentTarget, W(w)) || t.setFocused(!1);
      return;
    }
    if (!ae(w.currentTarget, W(w))) return;
    let R = yt();
    t.setFocused(!0);
    let H = (k) => {
      k != null && (t.setFocusedKey(k), d && !t.isSelected(k) && t.replaceSelection(k));
    };
    if (p && (R === "keyboard" || R === "virtual"))
      H(p === "first" ? n.getFirstKey?.() : n.getLastKey?.());
    else if (t.focusedKey == null) {
      let k = w.relatedTarget;
      k && w.currentTarget.compareDocumentPosition(k) & Node.DOCUMENT_POSITION_FOLLOWING ? H(t.lastSelectedKey ?? n.getLastKey?.()) : H(t.firstSelectedKey ?? n.getFirstKey?.());
    } else h.current && (h.current.scrollTop = v.current.top, h.current.scrollLeft = v.current.left);
    if (t.focusedKey != null && h.current) {
      let k = Mn(r, t.focusedKey);
      k instanceof HTMLElement && (!qt(k) && !c && Fe(k), (R === "keyboard" || p && R === "virtual") && ze(k, {
        containingElement: r.current
      }));
    }
  }, E = (w) => {
    ae(w.currentTarget, w.relatedTarget) || t.setFocused(!1);
  }, P = T(!1);
  mt(r, gi, c ? (w) => {
    let { detail: R } = w;
    w.stopPropagation(), t.setFocused(!0), R?.focusStrategy === "first" && (P.current = !0);
  } : void 0);
  let C = n.getFirstKey?.() ?? null;
  Xs(() => {
    if (P.current)
      if (C == null) {
        let w = se();
        fu(r.current), ja(w, null), t.collection.size > 0 && (P.current = !1);
      } else
        t.setFocusedKey(C), P.current = !1;
  }, [
    C,
    t.collection.size
  ]), Xs(() => {
    t.collection.size > 0 && (P.current = !1);
  }, [
    t.focusedKey
  ]), mt(r, zd, c ? (w) => {
    w.stopPropagation(), t.setFocused(!1), w.detail?.clearFocusKey && t.setFocusedKey(null);
  } : void 0);
  const M = T(a), F = T(!1);
  ee(() => {
    if (M.current) {
      let w = null;
      a === "first" && (w = n.getFirstKey?.() ?? null), a === "last" && (w = n.getLastKey?.() ?? null);
      let R = t.selectedKeys;
      if (R.size) {
        for (let H of R) if (t.canSelectItem(H)) {
          w = H;
          break;
        }
      }
      t.setFocused(!0), t.setFocusedKey(w), w == null && !c && r.current && we(r.current), t.collection.size > 0 && (M.current = !1, F.current = !0);
    }
  });
  let V = T(t.focusedKey), I = T(null);
  ee(() => {
    if (t.isFocused && t.focusedKey != null && (t.focusedKey !== V.current || F.current) && h.current && r.current) {
      let w = yt(), R = Mn(r, t.focusedKey);
      if (!(R instanceof HTMLElement))
        return;
      (w === "keyboard" || F.current) && (I.current && cancelAnimationFrame(I.current), I.current = requestAnimationFrame(() => {
        h.current && (za(h.current, R), w !== "virtual" && ze(R, {
          containingElement: r.current
        }));
      }));
    }
    !c && t.isFocused && t.focusedKey == null && V.current != null && r.current && we(r.current), V.current = t.focusedKey, F.current = !1;
  }), ee(() => () => {
    I.current && cancelAnimationFrame(I.current);
  }, []), mt(r, "react-aria-focus-scope-restore", (w) => {
    w.preventDefault(), t.setFocused(!0);
  });
  let A = {
    onKeyDown: $,
    onFocus: x,
    onBlur: E,
    onMouseDown(w) {
      h.current === W(w) && w.preventDefault();
    }
  }, { typeSelectProps: U } = Np({
    keyboardDelegate: n,
    selectionManager: t
  });
  s || (A = z(U, A));
  let D;
  c || (D = t.focusedKey == null ? 0 : -1);
  let N = dx(t.collection);
  return {
    collectionProps: z(A, {
      tabIndex: D,
      "data-collection": N
    })
  };
}
class Xi {
  constructor(t) {
    this.ref = t;
  }
  getItemRect(t) {
    let n = this.ref.current;
    if (!n) return null;
    let r = t != null ? Mn(this.ref, t) : null;
    if (!r) return null;
    let a = n.getBoundingClientRect(), l = r.getBoundingClientRect();
    return {
      x: l.left - a.left - n.clientLeft + n.scrollLeft,
      y: l.top - a.top - n.clientTop + n.scrollTop,
      width: l.width,
      height: l.height
    };
  }
  getContentSize() {
    let t = this.ref.current;
    return {
      width: t?.scrollWidth ?? 0,
      height: t?.scrollHeight ?? 0
    };
  }
  getVisibleRect() {
    let t = this.ref.current;
    return {
      x: t?.scrollLeft ?? 0,
      y: t?.scrollTop ?? 0,
      width: t?.clientWidth ?? 0,
      height: t?.clientHeight ?? 0
    };
  }
}
class ya {
  constructor(...t) {
    if (t.length === 1) {
      let n = t[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.disabledBehavior = n.disabledBehavior || "all", this.orientation = n.orientation || "vertical", this.direction = n.direction, this.layout = n.layout || "stack", this.layoutDelegate = n.layoutDelegate || new Xi(n.ref);
    } else
      this.collection = t[0], this.disabledKeys = t[1], this.ref = t[2], this.collator = t[3], this.layout = "stack", this.orientation = "vertical", this.disabledBehavior = "all", this.layoutDelegate = new Xi(this.ref);
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
  isDisabled(t) {
    return this.disabledBehavior === "all" && (t.props?.isDisabled || this.disabledKeys.has(t.key)) && t.props?.disabledBehavior !== "selection";
  }
  findNextNonDisabled(t, n, r = !1) {
    let a = t;
    for (; a != null; ) {
      let l = this.collection.getItem(a);
      if (l?.type === "item" && (r || !this.isDisabled(l))) return a;
      a = n(a);
    }
    return null;
  }
  getNextKey(t, n) {
    let r = t;
    return r = this.collection.getKeyAfter(r), this.findNextNonDisabled(r, (a) => this.collection.getKeyAfter(a), n?.includeDisabled);
  }
  getPreviousKey(t, n) {
    let r = t;
    return r = this.collection.getKeyBefore(r), this.findNextNonDisabled(r, (a) => this.collection.getKeyBefore(a), n?.includeDisabled);
  }
  findKey(t, n, r) {
    let a = t, l = this.layoutDelegate.getItemRect(a);
    if (!l || a == null) return null;
    let i = l;
    do {
      if (a = n(a), a == null) break;
      l = this.layoutDelegate.getItemRect(a);
    } while (l && r(i, l) && a != null);
    return a;
  }
  isSameRow(t, n) {
    return t.y === n.y || t.x !== n.x;
  }
  isSameColumn(t, n) {
    return t.x === n.x || t.y !== n.y;
  }
  // checks to see if the next/prev key is spatially above/below the current key. If not, that means we are in
  // a reversed column layout and need to adjust appropriately
  // TODO: still need to see how this works with virtualizer once there is handling for the reverse layout
  // this felt like a simpler approach then changing getKeyAbove/Below to be purely spatial calculations
  isReversed(t) {
    let n = this.getNextKey(t), r = Mn(this.ref, t);
    if (n != null) {
      let l = Mn(this.ref, n);
      return !r || !l ? !1 : r.getBoundingClientRect().top > l.getBoundingClientRect().top;
    }
    let a = this.getPreviousKey(t);
    if (a != null) {
      let l = Mn(this.ref, a);
      return !r || !l ? !1 : l.getBoundingClientRect().top > r.getBoundingClientRect().top;
    }
    return !1;
  }
  getKeyBelow(t, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getNextKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(t) ? this.getPreviousKey(t, n) : this.getNextKey(t, n) : this.getNextKey(t, n);
  }
  getKeyAbove(t, n) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (r) => this.getPreviousKey(r, n), this.isSameRow) : this.orientation === "vertical" ? this.isReversed(t) ? this.getNextKey(t, n) : this.getPreviousKey(t, n) : this.getPreviousKey(t, n);
  }
  getNextColumn(t, n, r) {
    return n ? this.getPreviousKey(t, r) : this.getNextKey(t, r);
  }
  getKeyRightOf(t, n) {
    let r = this.direction === "ltr" ? "getKeyRightOf" : "getKeyLeftOf";
    return this.layoutDelegate[r] ? (t = this.layoutDelegate[r](t), this.findNextNonDisabled(t, (a) => this.layoutDelegate[r](a), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "rtl", n) : this.findKey(t, (a) => this.getNextColumn(a, this.direction === "rtl", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "rtl", n) : null;
  }
  getKeyLeftOf(t, n) {
    let r = this.direction === "ltr" ? "getKeyLeftOf" : "getKeyRightOf";
    return this.layoutDelegate[r] ? (t = this.layoutDelegate[r](t), this.findNextNonDisabled(t, (a) => this.layoutDelegate[r](a), n?.includeDisabled)) : this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "ltr", n) : this.findKey(t, (a) => this.getNextColumn(a, this.direction === "ltr", n), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "ltr", n) : null;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyAfter(n));
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return this.findNextNonDisabled(t, (n) => this.collection.getKeyBefore(n));
  }
  getKeyPageAbove(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    let a = this.isReversed(t);
    if (n && !gn(n)) return this.getFirstKey();
    let l = t;
    if (this.orientation === "horizontal") {
      let i = Math.max(0, r.x + r.width - this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x > i && l != null; )
        l = this.getKeyAbove(l), r = l == null ? null : this.layoutDelegate.getItemRect(l);
    } else {
      let i = this.layoutDelegate.getVisibleRect(), u = a ? r.y - i.height : Math.max(0, r.y + r.height - i.height);
      for (; r && r.y > u && l != null; )
        l = this.getKeyAbove(l), r = l == null ? null : this.layoutDelegate.getItemRect(l);
    }
    return l ?? (a ? this.getLastKey() : this.getFirstKey());
  }
  getKeyPageBelow(t) {
    let n = this.ref.current, r = this.layoutDelegate.getItemRect(t);
    if (!r) return null;
    let a = this.isReversed(t);
    if (n && !gn(n)) return this.getLastKey();
    let l = t;
    if (this.orientation === "horizontal") {
      let i = Math.min(this.layoutDelegate.getContentSize().width, r.x - r.width + this.layoutDelegate.getVisibleRect().width);
      for (; r && r.x < i && l != null; )
        l = this.getKeyBelow(l), r = l == null ? null : this.layoutDelegate.getItemRect(l);
    } else {
      let i = Math.min(this.layoutDelegate.getContentSize().height, r.y - r.height + this.layoutDelegate.getVisibleRect().height);
      for (; r && r.y < i && l != null; )
        l = this.getKeyBelow(l), r = l == null ? null : this.layoutDelegate.getItemRect(l);
    }
    return l ?? (a ? this.getFirstKey() : this.getLastKey());
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, a = n || this.getFirstKey();
    for (; a != null; ) {
      let l = r.getItem(a);
      if (!l) return null;
      let i = l.textValue.slice(0, t.length);
      if (l.textValue && this.collator.compare(i, t) === 0) return a;
      a = this.getNextKey(a);
    }
    return null;
  }
}
let ui = /* @__PURE__ */ new Map();
function wr(e) {
  let { locale: t } = de(), n = t + (e ? Object.entries(e).sort((a, l) => a[0] < l[0] ? -1 : 1).join() : "");
  if (ui.has(n)) return ui.get(n);
  let r = new Intl.Collator(t, e);
  return ui.set(n, r), r;
}
function no(e) {
  let { selectionManager: t, collection: n, disabledKeys: r, ref: a, keyboardDelegate: l, layoutDelegate: i, orientation: u } = e, o = wr({
    usage: "search",
    sensitivity: "base"
  }), d = t.disabledBehavior, s = K(() => l || new ya({
    collection: n,
    disabledKeys: r,
    disabledBehavior: d,
    ref: a,
    collator: o,
    layoutDelegate: i,
    orientation: u
  }), [
    l,
    i,
    n,
    r,
    a,
    o,
    d,
    u
  ]), { collectionProps: c } = to({
    ...e,
    ref: a,
    selectionManager: t,
    keyboardDelegate: s
  });
  return {
    listProps: c
  };
}
function hx(e, t, n) {
  let r = J(e, {
    labelable: !0
  }), a = e.selectionBehavior || "toggle", l = e.orientation || "vertical", i = e.linkBehavior || (a === "replace" ? "action" : "override");
  a === "toggle" && i === "action" && (i = "override");
  let { listProps: u } = no({
    ...e,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    linkBehavior: i
  }), { focusWithinProps: o } = ct({
    onFocusWithin: e.onFocus,
    onBlurWithin: e.onBlur,
    onFocusWithinChange: e.onFocusChange
  }), d = ce(e.id);
  Qu.set(t, {
    id: d,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp,
    shouldFocusOnHover: e.shouldFocusOnHover,
    isVirtualized: e.isVirtualized,
    onAction: e.onAction,
    linkBehavior: i,
    // @ts-ignore
    UNSTABLE_itemBehavior: e.UNSTABLE_itemBehavior
  });
  let { labelProps: s, fieldProps: c } = ma({
    ...e,
    id: d,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: s,
    listBoxProps: z(r, o, t.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      "aria-orientation": l,
      ...z(c, u)
    })
  };
}
const mx = 500;
function Vp(e) {
  let { isDisabled: t, onLongPressStart: n, onLongPressEnd: r, onLongPress: a, threshold: l = mx, accessibilityDescription: i } = e;
  const u = T(void 0);
  let { addGlobalListener: o, removeGlobalListener: d } = Qt(), { pressProps: s } = Xe({
    isDisabled: t,
    onPressStart(f) {
      if (f.continuePropagation(), (f.pointerType === "mouse" || f.pointerType === "touch") && (n && n({
        ...f,
        type: "longpressstart"
      }), u.current = setTimeout(() => {
        f.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), he(f.target).activeElement !== f.target && Fe(f.target), a && a({
          ...f,
          type: "longpress"
        }), u.current = void 0;
      }, l), f.pointerType === "touch")) {
        let h = (p) => {
          p.preventDefault();
        }, m = ke(f.target);
        o(f.target, "contextmenu", h, {
          once: !0
        }), o(m, "pointerup", () => {
          setTimeout(() => {
            d(f.target, "contextmenu", h);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(f) {
      u.current && clearTimeout(u.current), r && (f.pointerType === "mouse" || f.pointerType === "touch") && r({
        ...f,
        type: "longpressend"
      });
    }
  }), c = en(a && !t ? i : void 0);
  return {
    longPressProps: z(s, c)
  };
}
function Sr(e) {
  let { id: t, selectionManager: n, key: r, ref: a, shouldSelectOnPressUp: l, shouldUseVirtualFocus: i, focus: u, isDisabled: o, onAction: d, allowsDifferentPressOrigin: s, linkBehavior: c = "action" } = e, f = Dr();
  t = ce(t);
  let h = (S) => {
    if (S.pointerType === "keyboard" && Zi(S)) n.toggleSelection(r);
    else {
      if (n.selectionMode === "none") return;
      if (n.isLink(r)) {
        if (c === "selection" && a.current) {
          let j = n.getItemProps(r);
          f.open(a.current, S, j.href, j.routerOptions), n.setSelectedKeys(n.selectedKeys);
          return;
        } else if (c === "override" || c === "none") return;
      }
      n.selectionMode === "single" ? n.isSelected(r) && !n.disallowEmptySelection ? n.toggleSelection(r) : n.replaceSelection(r) : S && S.shiftKey ? n.extendSelection(r) : n.selectionBehavior === "toggle" || S && (Bn(S) || S.pointerType === "touch" || S.pointerType === "virtual") ? n.toggleSelection(r) : n.replaceSelection(r);
    }
  };
  ee(() => {
    r === n.focusedKey && n.isFocused && (i ? fu(a.current) : u ? u() : se() !== a.current && a.current && we(a.current));
  }, [
    a,
    r,
    n.focusedKey,
    n.childFocusStrategy,
    n.isFocused,
    i
  ]), o = o || n.isDisabled(r);
  let m = {};
  !i && !o ? m = {
    tabIndex: r === n.focusedKey ? 0 : -1,
    onFocus(S) {
      W(S) === a.current && n.setFocusedKey(r);
    }
  } : o && (m.onMouseDown = (S) => {
    S.preventDefault();
  }), ee(() => {
    o && n.focusedKey === r && n.setFocusedKey(null);
  }, [
    n,
    o,
    r
  ]);
  let p = n.isLink(r) && c === "override", b = d && e.UNSTABLE_itemBehavior === "action", y = n.isLink(r) && c !== "selection" && c !== "none", $ = !o && n.canSelectItem(r) && !p && !b, v = (d || y) && !o, x = v && (n.selectionBehavior === "replace" ? !$ : !$ || n.isEmpty), E = v && $ && n.selectionBehavior === "replace", P = x || E, C = T(null), M = P && $, F = T(!1), V = T(!1), I = n.getItemProps(r), A = (S) => {
    d && (d(), a.current?.dispatchEvent(new CustomEvent("react-aria-item-action", {
      bubbles: !0
    }))), y && a.current && f.open(a.current, S, I.href, I.routerOptions);
  }, U = {
    ref: a
  };
  if (l ? (U.onPressStart = (S) => {
    C.current = S.pointerType, F.current = M, S.pointerType === "keyboard" && (!P || Qs(S.key)) && h(S);
  }, s ? (U.onPressUp = x ? void 0 : (S) => {
    S.pointerType === "mouse" && $ && h(S);
  }, U.onPress = x ? A : (S) => {
    S.pointerType !== "keyboard" && S.pointerType !== "mouse" && $ && h(S);
  }) : U.onPress = (S) => {
    if (x || E && S.pointerType !== "mouse") {
      if (S.pointerType === "keyboard" && !Js(S.key)) return;
      A(S);
    } else S.pointerType !== "keyboard" && $ && h(S);
  }) : (U.onPressStart = (S) => {
    C.current = S.pointerType, F.current = M, V.current = x, $ && (S.pointerType === "mouse" && !x || S.pointerType === "keyboard" && (!v || Qs(S.key))) && h(S);
  }, U.onPress = (S) => {
    (S.pointerType === "touch" || S.pointerType === "pen" || S.pointerType === "virtual" || S.pointerType === "keyboard" && P && Js(S.key) || S.pointerType === "mouse" && V.current) && (P ? A(S) : $ && h(S));
  }), m["data-collection"] = cx(n.collection), m["data-key"] = r, U.preventFocusOnPress = i, i && (U = z(U, {
    onPressStart(S) {
      S.pointerType !== "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    },
    onPress(S) {
      S.pointerType === "touch" && (n.setFocused(!0), n.setFocusedKey(r));
    }
  })), I)
    for (let S of [
      "onPressStart",
      "onPressEnd",
      "onPressChange",
      "onPress",
      "onPressUp",
      "onClick"
    ]) I[S] && (U[S] = ot(U[S], I[S]));
  let { pressProps: D, isPressed: N } = Xe(U), w = E ? (S) => {
    C.current === "mouse" && (S.stopPropagation(), S.preventDefault(), A(S));
  } : void 0, { longPressProps: R } = Vp({
    isDisabled: !M,
    onLongPress(S) {
      S.pointerType === "touch" && (h(S), n.setSelectionBehavior("toggle"));
    }
  }), H = (S) => {
    C.current === "touch" && F.current && S.preventDefault();
  }, k = c !== "none" && n.isLink(r) ? (S) => {
    It.isOpening || S.preventDefault();
  } : void 0;
  return {
    itemProps: z(
      m,
      $ || x || i && !o ? D : {},
      M ? R : {},
      {
        onDoubleClick: w,
        onDragStartCapture: H,
        onClick: k,
        id: t
      },
      // Prevent DOM focus from moving on mouse down when using virtual focus
      i ? {
        onMouseDown: (S) => S.preventDefault()
      } : void 0
    ),
    isPressed: N,
    isSelected: n.isSelected(r),
    isFocused: n.isFocused && n.focusedKey === r,
    isDisabled: o,
    allowsSelection: $,
    hasAction: P
  };
}
function Js(e) {
  return e === "Enter";
}
function Qs(e) {
  return e === " ";
}
function Me(e, t) {
  return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function jt(e) {
  return Hr(e, 0);
}
function Hr(e, t) {
  if (t < 0) return;
  let n = 0;
  for (let r of e) {
    if (n === t) return r;
    n++;
  }
}
function rr(e) {
  let t;
  for (let n of e) t = n;
  return t;
}
function oi(e, t, n) {
  if (t.parentKey === n.parentKey) return t.index - n.index;
  let r = [
    ...ed(e, t),
    t
  ], a = [
    ...ed(e, n),
    n
  ], l = r.slice(0, a.length).findIndex((i, u) => i !== a[u]);
  return l !== -1 ? (t = r[l], n = a[l], t.index - n.index) : r.findIndex((i) => i === n) >= 0 ? 1 : (a.findIndex((i) => i === t) >= 0, -1);
}
function ed(e, t) {
  let n = [], r = t;
  for (; r?.parentKey != null; )
    r = e.getItem(r.parentKey), r && n.unshift(r);
  return n;
}
const td = /* @__PURE__ */ new WeakMap();
function Lp(e) {
  let t = td.get(e);
  if (t != null) return t;
  let n = 0, r = (a) => {
    for (let l of a)
      l.type === "section" ? r(Me(l, e)) : l.type === "item" && n++;
  };
  return r(e), td.set(e, n), n;
}
function px(e, t, n) {
  let { key: r } = e, a = Qu.get(t), l = e.isDisabled ?? t.selectionManager.isDisabled(r), i = e.isSelected ?? t.selectionManager.isSelected(r), u = e.shouldSelectOnPressUp ?? a?.shouldSelectOnPressUp, o = e.shouldFocusOnHover ?? a?.shouldFocusOnHover, d = e.shouldUseVirtualFocus ?? a?.shouldUseVirtualFocus, s = e.isVirtualized ?? a?.isVirtualized, c = bt(), f = bt(), h = {
    role: "option",
    "aria-disabled": l || void 0,
    "aria-selected": t.selectionManager.selectionMode !== "none" ? i : void 0,
    "aria-label": e["aria-label"],
    "aria-labelledby": c,
    "aria-describedby": f
  }, m = t.collection.getItem(r);
  if (s) {
    let F = Number(m?.index);
    h["aria-posinset"] = Number.isNaN(F) ? void 0 : F + 1, h["aria-setsize"] = Lp(t.collection);
  }
  let p = a?.onAction ? () => a?.onAction?.(r) : void 0, b = ex(t, r), { itemProps: y, isPressed: $, isFocused: v, hasAction: x, allowsSelection: E } = Sr({
    selectionManager: t.selectionManager,
    key: r,
    ref: n,
    shouldSelectOnPressUp: u,
    allowsDifferentPressOrigin: u && o,
    isVirtualized: s,
    shouldUseVirtualFocus: d,
    isDisabled: l,
    onAction: p || m?.props?.onAction ? ot(m?.props?.onAction, p) : void 0,
    linkBehavior: a?.linkBehavior,
    // @ts-ignore
    UNSTABLE_itemBehavior: a?.UNSTABLE_itemBehavior,
    id: b
  }), { hoverProps: P } = ve({
    isDisabled: l || !o,
    onHoverStart() {
      Mt() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(r));
    }
  }), C = J(m?.props);
  delete C.id;
  let M = bl(m?.props);
  return {
    optionProps: {
      ...h,
      ...z(C, y, P, M),
      id: b
    },
    labelProps: {
      id: c
    },
    descriptionProps: {
      id: f
    },
    isFocused: v,
    isFocusVisible: v && t.selectionManager.isFocused && Mt(),
    isSelected: i,
    isDisabled: l,
    isPressed: $,
    allowsSelection: E,
    hasAction: x
  };
}
function bx(e) {
  let { heading: t, "aria-label": n } = e, r = ce();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Technically, listbox cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a visual label for the nested group.
      id: r,
      role: "presentation",
      onMouseDown: (a) => {
        a.preventDefault();
      }
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
function sl(e) {
  const t = Hv.split(".");
  return parseInt(t[0], 10) >= 19 ? e : e ? "true" : void 0;
}
class nd {
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t;
    let n = (i) => {
      if (this.keyMap.set(i.key, i), i.childNodes && i.type === "section") for (let u of i.childNodes) n(u);
    };
    for (let i of t) n(i);
    let r = null, a = 0, l = 0;
    for (let [i, u] of this.keyMap)
      r ? (r.nextKey = i, u.prevKey = r.key) : (this.firstKey = i, u.prevKey = void 0), u.type === "item" && (u.index = a++), (u.type === "section" || u.type === "item") && l++, r = u, r.nextKey = void 0;
    this._size = l, this.lastKey = r?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    return this.keyMap.get(t)?.childNodes || [];
  }
}
class ht extends Set {
  constructor(t, n, r) {
    super(t), t instanceof ht ? (this.anchorKey = n ?? t.anchorKey, this.currentKey = r ?? t.currentKey) : (this.anchorKey = n ?? null, this.currentKey = r ?? null);
  }
}
function gx(e, t) {
  if (e.size !== t.size) return !1;
  for (let n of e)
    if (!t.has(n)) return !1;
  return !0;
}
function $a(e) {
  let { selectionMode: t = "none", disallowEmptySelection: n = !1, allowDuplicateSelectionEvents: r, selectionBehavior: a = "toggle", disabledBehavior: l = "all" } = e, i = T(!1), [, u] = Y(!1), o = T(null), d = T(null), [, s] = Y(null), c = K(() => rd(e.selectedKeys), [
    e.selectedKeys
  ]), f = K(() => rd(e.defaultSelectedKeys, new ht()), [
    e.defaultSelectedKeys
  ]), [h, m] = Pe(c, f, e.onSelectionChange), p = K(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), [b, y] = Y(a);
  a === "replace" && b === "toggle" && typeof h == "object" && h.size === 0 && y("replace");
  let $ = T(a);
  return ee(() => {
    a !== $.current && (y(a), $.current = a);
  }, [
    a
  ]), {
    selectionMode: t,
    disallowEmptySelection: n,
    selectionBehavior: b,
    setSelectionBehavior: y,
    get isFocused() {
      return i.current;
    },
    setFocused(v) {
      i.current = v, u(v);
    },
    get focusedKey() {
      return o.current;
    },
    get childFocusStrategy() {
      return d.current;
    },
    setFocusedKey(v, x = "first") {
      o.current = v, d.current = x, s(v);
    },
    selectedKeys: h,
    setSelectedKeys(v) {
      (r || !gx(v, h)) && m(v);
    },
    disabledKeys: p,
    disabledBehavior: l
  };
}
function rd(e, t) {
  return e ? e === "all" ? "all" : new ht(e) : t;
}
class kr {
  constructor(t, n, r) {
    this.collection = t, this.state = n, this.allowsCellSelection = r?.allowsCellSelection ?? !1, this._isSelectAll = null, this.layoutDelegate = r?.layoutDelegate || null, this.fullCollection = r?.fullCollection || null;
  }
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(t) {
    this.state.setSelectionBehavior(t);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(t) {
    this.state.setFocused(t);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(t, n) {
    (t == null || this.collection.getItem(t)) && this.state.setFocusedKey(t, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(t) {
    if (this.state.selectionMode === "none") return !1;
    let n = this.getKey(t);
    return n == null ? !1 : this.state.selectedKeys === "all" ? this.canSelectItem(n) : this.state.selectedKeys.has(n);
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty) return !1;
    if (this.state.selectedKeys === "all") return !0;
    if (this._isSelectAll != null) return this._isSelectAll;
    let t = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = t.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && oi(this.collection, r, t) < 0) && (t = r);
    }
    return t?.key ?? null;
  }
  get lastSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && oi(this.collection, r, t) > 0) && (t = r);
    }
    return t?.key ?? null;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single") {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r;
    if (this.state.selectedKeys === "all") r = new ht([
      n
    ], n, n);
    else {
      let a = this.state.selectedKeys, l = a.anchorKey ?? n;
      r = new ht(a, l, n);
      for (let i of this.getKeyRange(l, a.currentKey ?? n)) r.delete(i);
      for (let i of this.getKeyRange(n, l)) this.canSelectItem(i) && r.add(i);
    }
    this.state.setSelectedKeys(r);
  }
  getKeyRange(t, n) {
    let r = this.collection.getItem(t), a = this.collection.getItem(n);
    return r && a ? oi(this.collection, r, a) <= 0 ? this.getKeyRangeInternal(t, n) : this.getKeyRangeInternal(n, t) : [];
  }
  getKeyRangeInternal(t, n) {
    if (this.layoutDelegate?.getKeyRange) return this.layoutDelegate.getKeyRange(t, n);
    let r = [], a = t;
    for (; a != null; ) {
      let l = this.collection.getItem(a);
      if (l && (l.type === "item" || l.type === "cell" && this.allowsCellSelection) && r.push(a), a === n) return r;
      a = this.collection.getKeyAfter(a);
    }
    return [];
  }
  getKey(t) {
    let n = this.collection.getItem(t);
    if (!n || n.type === "cell" && this.allowsCellSelection) return t;
    for (; n && n.type !== "item" && n.parentKey != null; ) n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(t) {
    if (this.selectionMode === "none") return;
    if (this.selectionMode === "single" && !this.isSelected(t)) {
      this.replaceSelection(t);
      return;
    }
    let n = this.getKey(t);
    if (n == null) return;
    let r = new ht(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    r.has(n) ? r.delete(n) : this.canSelectItem(n) && (r.add(n), r.anchorKey = n, r.currentKey = n), !(this.disallowEmptySelection && r.size === 0) && this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(t) {
    if (this.selectionMode === "none") return;
    let n = this.getKey(t);
    if (n == null) return;
    let r = this.canSelectItem(n) ? new ht([
      n
    ], n, n) : new ht();
    this.state.setSelectedKeys(r);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(t) {
    if (this.selectionMode === "none") return;
    let n = new ht();
    for (let r of t) {
      let a = this.getKey(r);
      if (a != null && (n.add(a), this.selectionMode === "single"))
        break;
    }
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let t = this.fullCollection ?? this.collection, n = [], r = (a) => {
      for (; a != null; ) {
        if (this.canSelectItemIn(a, t)) {
          let l = t.getItem(a);
          l?.type === "item" && n.push(a), l?.hasChildNodes && (this.allowsCellSelection || l.type !== "item") && r(jt(Me(l, t))?.key ?? null);
        }
        a = t.getKeyAfter(a);
      }
    };
    return r(t.getFirstKey()), n;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new ht());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(t, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(t) && !this.disallowEmptySelection ? this.toggleSelection(t) : this.replaceSelection(t) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(t) : this.replaceSelection(t));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(t) {
    if (t === this.state.selectedKeys) return !0;
    let n = this.selectedKeys;
    if (t.size !== n.size) return !1;
    for (let r of t)
      if (!n.has(r)) return !1;
    for (let r of n)
      if (!t.has(r)) return !1;
    return !0;
  }
  canSelectItem(t) {
    return this.canSelectItemIn(t, this.collection);
  }
  canSelectItemIn(t, n) {
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(t)) return !1;
    let r = n.getItem(t);
    return !(!r || r?.props?.isDisabled || r.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(t) {
    let n = this.collection.getItem(t);
    return this.state.disabledBehavior === "all" && (this.state.disabledKeys.has(t) || !!n?.props?.isDisabled) && n?.props?.disabledBehavior !== "selection";
  }
  isLink(t) {
    return !!this.collection.getItem(t)?.props?.href;
  }
  getItemProps(t) {
    return this.collection.getItem(t)?.props;
  }
  withCollection(t) {
    return new kr(t, this.state, {
      allowsCellSelection: this.allowsCellSelection,
      layoutDelegate: this.layoutDelegate || void 0,
      fullCollection: this.fullCollection ?? this.collection
    });
  }
}
class yx {
  build(t, n) {
    return this.context = n, ad(() => this.iterateCollection(t));
  }
  *iterateCollection(t) {
    let { children: n, items: r } = t;
    if (g.isValidElement(n) && n.type === g.Fragment) yield* this.iterateCollection({
      children: n.props.children,
      items: r
    });
    else if (typeof n == "function") {
      if (!r) throw new Error("props.children was a function but props.items is missing");
      let a = 0;
      for (let l of r)
        yield* this.getFullNode({
          value: l,
          index: a
        }, {
          renderer: n
        }), a++;
    } else {
      let a = [];
      g.Children.forEach(n, (i) => {
        i && a.push(i);
      });
      let l = 0;
      for (let i of a) {
        let u = this.getFullNode({
          element: i,
          index: l
        }, {});
        for (let o of u)
          l++, yield o;
      }
    }
  }
  getKey(t, n, r, a) {
    if (t.key != null) return t.key;
    if (n.type === "cell" && n.key != null) return `${a}${n.key}`;
    let l = n.value;
    if (l != null) {
      let i = l.key ?? l.id;
      if (i == null) throw new Error("No key found for item");
      return i;
    }
    return a ? `${a}.${n.index}` : `$.${n.index}`;
  }
  getChildState(t, n) {
    return {
      renderer: n.renderer || t.renderer
    };
  }
  *getFullNode(t, n, r, a) {
    if (g.isValidElement(t.element) && t.element.type === g.Fragment) {
      let o = [];
      g.Children.forEach(t.element.props.children, (s) => {
        o.push(s);
      });
      let d = t.index ?? 0;
      for (const s of o) yield* this.getFullNode({
        element: s,
        index: d++
      }, n, r, a);
      return;
    }
    let l = t.element;
    if (!l && t.value && n && n.renderer) {
      let o = this.cache.get(t.value);
      if (o && (!o.shouldInvalidate || !o.shouldInvalidate(this.context))) {
        o.index = t.index, o.parentKey = a ? a.key : null, yield o;
        return;
      }
      l = n.renderer(t.value);
    }
    if (g.isValidElement(l)) {
      let o = l.type;
      if (typeof o != "function" && typeof o.getCollectionNode != "function") {
        let f = l.type;
        throw new Error(`Unknown element <${f}> in collection.`);
      }
      let d = o.getCollectionNode(l.props, this.context), s = t.index ?? 0, c = d.next();
      for (; !c.done && c.value; ) {
        let f = c.value;
        t.index = s;
        let h = f.key ?? null;
        h == null && (h = f.element ? null : this.getKey(l, t, n, r));
        let p = [
          ...this.getFullNode({
            ...f,
            key: h,
            index: s,
            wrapper: $x(t.wrapper, f.wrapper)
          }, this.getChildState(n, f), r ? `${r}${l.key}` : l.key, a)
        ];
        for (let b of p) {
          if (b.value = f.value ?? t.value ?? null, b.value && this.cache.set(b.value, b), t.type && b.type !== t.type) throw new Error(`Unsupported type <${si(b.type)}> in <${si(a?.type ?? "unknown parent type")}>. Only <${si(t.type)}> is supported.`);
          s++, yield b;
        }
        c = d.next(p);
      }
      return;
    }
    if (t.key == null || t.type == null) return;
    let i = this, u = {
      type: t.type,
      props: t.props,
      key: t.key,
      parentKey: a ? a.key : null,
      value: t.value ?? null,
      level: (a?.level ?? 0) + (a?.type === "item" ? 1 : 0),
      index: t.index,
      rendered: t.rendered,
      textValue: t.textValue ?? "",
      "aria-label": t["aria-label"],
      wrapper: t.wrapper,
      shouldInvalidate: t.shouldInvalidate,
      hasChildNodes: t.hasChildNodes || !1,
      childNodes: ad(function* () {
        if (!t.hasChildNodes || !t.childNodes) return;
        let o = 0;
        for (let d of t.childNodes()) {
          d.key != null && (d.key = `${u.key}${d.key}`);
          let s = i.getFullNode({
            ...d,
            index: o
          }, i.getChildState(n, d), u.key, u);
          for (let c of s)
            o++, yield c;
        }
      })
    };
    yield u;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function ad(e) {
  let t = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of t) yield r;
      n || (n = e());
      for (let r of n)
        t.push(r), yield r;
    }
  };
}
function $x(e, t) {
  if (e && t) return (n) => e(t(n));
  if (e) return e;
  if (t) return t;
}
function si(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function ro(e, t, n) {
  let r = K(() => new yx(), []), { children: a, items: l, collection: i } = e;
  return K(() => {
    if (i) return i;
    let o = r.build({
      children: a,
      items: l
    }, n);
    return t(o);
  }, [
    r,
    a,
    l,
    i,
    n,
    t
  ]);
}
function Bl(e) {
  let { filter: t, layoutDelegate: n } = e, r = $a(e), a = K(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), l = X((d) => t ? new nd(t(d)) : new nd(d), [
    t
  ]), i = K(() => ({
    suppressTextValueWarning: e.suppressTextValueWarning
  }), [
    e.suppressTextValueWarning
  ]), u = ro(e, l, i), o = K(() => new kr(u, r, {
    layoutDelegate: n
  }), [
    u,
    r,
    n
  ]);
  return Op(u, o), {
    collection: u,
    disabledKeys: a,
    selectionManager: o
  };
}
function zp(e, t) {
  let n = K(() => t ? e.collection.filter(t) : e.collection, [
    e.collection,
    t
  ]), r = e.selectionManager.withCollection(n);
  return Op(n, r), {
    collection: n,
    selectionManager: r,
    disabledKeys: e.disabledKeys
  };
}
function Op(e, t) {
  const n = T(null);
  ee(() => {
    if (t.focusedKey != null && !e.getItem(t.focusedKey) && n.current) {
      let r = n.current.getKeyAfter(t.focusedKey), a = null;
      for (; r != null; ) {
        let l = e.getItem(r);
        if (l && l.type === "item" && !t.isDisabled(r)) {
          a = r;
          break;
        }
        r = n.current.getKeyAfter(r);
      }
      if (a == null)
        for (r = n.current.getKeyBefore(t.focusedKey); r != null; ) {
          let l = e.getItem(r);
          if (l && l.type === "item" && !t.isDisabled(r)) {
            a = r;
            break;
          }
          r = n.current.getKeyBefore(r);
        }
      t.setFocusedKey(a);
    }
    n.current = e;
  }, [
    e,
    t
  ]);
}
function Hp(e, t) {
  let { collection: n, onLoadMore: r, scrollOffset: a = 1 } = e, l = T(null), i = De((u) => {
    for (let o of u)
      o.isIntersecting && r && r();
  });
  ue(() => (t.current && (l.current = new IntersectionObserver(i, {
    root: Le(t?.current),
    rootMargin: `0px ${100 * a}% ${100 * a}% ${100 * a}%`
  }), l.current.observe(t.current)), () => {
    l.current && l.current.disconnect();
  }), [
    n,
    t,
    a
  ]);
}
const ao = /* @__PURE__ */ G(null), Pt = /* @__PURE__ */ G(null), vx = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, ao);
  let r = O(Pt);
  return r ? /* @__PURE__ */ g.createElement(Up, {
    state: r,
    props: t,
    listBoxRef: n
  }) : /* @__PURE__ */ g.createElement(Hn, {
    content: /* @__PURE__ */ g.createElement(Jt, t)
  }, (a) => /* @__PURE__ */ g.createElement(Dx, {
    props: t,
    listBoxRef: n,
    collection: a
  }));
});
function Dx({ props: e, listBoxRef: t, collection: n }) {
  e = {
    ...e,
    collection: n,
    children: null,
    items: null
  };
  let { layoutDelegate: r } = O(ge), a = Bl({
    ...e,
    layoutDelegate: r
  });
  return /* @__PURE__ */ g.createElement(Up, {
    state: a,
    props: e,
    listBoxRef: t
  });
}
function Up({ state: e, props: t, listBoxRef: n }) {
  [t, n] = oe(t, n, Nn);
  let { dragAndDropHooks: r, layout: a = "stack", orientation: l = "vertical", filter: i } = t, u = zp(e, i), { collection: o, selectionManager: d } = u, s = !!r?.useDraggableCollectionState, c = !!r?.useDroppableCollectionState, { direction: f } = de(), { disabledBehavior: h, disabledKeys: m } = d, p = wr({
    usage: "search",
    sensitivity: "base"
  }), { isVirtualized: b, layoutDelegate: y, dropTargetDelegate: $, CollectionRoot: v } = O(ge), x = K(() => t.keyboardDelegate || new ya({
    collection: o,
    collator: p,
    ref: n,
    disabledKeys: m,
    disabledBehavior: h,
    layout: a,
    orientation: l,
    direction: f,
    layoutDelegate: y
  }), [
    o,
    p,
    n,
    h,
    m,
    l,
    f,
    t.keyboardDelegate,
    a,
    y
  ]), { listBoxProps: E } = hx({
    ...t,
    shouldSelectOnPressUp: s || t.shouldSelectOnPressUp,
    keyboardDelegate: x,
    isVirtualized: b
  }, u, n), P = T(s), C = T(c);
  ee(() => {
    process.env.NODE_ENV !== "production" && (P.current !== s && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), C.current !== c && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    s,
    c
  ]);
  let M, F, V, I = !1, A = null, U = T(null);
  if (s && r) {
    M = r.useDraggableCollectionState({
      collection: o,
      selectionManager: d,
      preview: r.renderDragPreview ? U : void 0
    }), r.useDraggableCollection({}, M, n);
    let _ = r.DragPreview;
    A = r.renderDragPreview ? /* @__PURE__ */ g.createElement(_, {
      ref: U
    }, r.renderDragPreview) : null;
  }
  if (c && r) {
    F = r.useDroppableCollectionState({
      collection: o,
      selectionManager: d
    });
    let _ = r.dropTargetDelegate || $ || new r.ListDropTargetDelegate(o, n, {
      orientation: l,
      layout: a,
      direction: f
    });
    V = r.useDroppableCollection({
      keyboardDelegate: x,
      dropTargetDelegate: _
    }, F, n), I = F.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: D, isFocused: N, isFocusVisible: w } = ye(), R = u.collection.size === 0, H = {
    isDropTarget: I,
    isEmpty: R,
    isFocused: N,
    isFocusVisible: w,
    layout: t.layout || "stack",
    orientation: l,
    state: u
  }, k = le({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ListBox",
    values: H
  }), S = null;
  R && t.renderEmptyState && (S = /* @__PURE__ */ g.createElement("div", {
    // eslint-disable-next-line
    role: "option",
    style: {
      display: "contents"
    }
  }, t.renderEmptyState(H)));
  let j = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Sl, null, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(j, k, E, D, V?.collectionProps),
    ref: n,
    slot: t.slot || void 0,
    onScroll: t.onScroll,
    "data-drop-target": I || void 0,
    "data-empty": R || void 0,
    "data-focused": N || void 0,
    "data-focus-visible": w || void 0,
    "data-layout": t.layout || "stack",
    "data-orientation": l
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        ao,
        t
      ],
      [
        Pt,
        u
      ],
      [
        Nt,
        {
          dragAndDropHooks: r,
          dragState: M,
          dropState: F
        }
      ],
      [
        Ju,
        {
          elementType: "div"
        }
      ],
      [
        Yu,
        {
          render: Cx
        }
      ],
      [
        Yc,
        {
          name: "ListBoxSection",
          render: xx
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(jn, null, /* @__PURE__ */ g.createElement(v, {
    collection: o,
    scrollRef: n,
    persistedKeys: Ap(d, r, F),
    renderDropIndicator: Zu(r, F)
  }))), S, A));
}
function xx(e, t, n, r = "react-aria-ListBoxSection") {
  let a = O(Pt), { dragAndDropHooks: l, dropState: i } = O(Nt), { CollectionBranch: u } = O(ge), [o, d] = Je(), { headingProps: s, groupProps: c } = bx({
    heading: d,
    "aria-label": e["aria-label"] ?? void 0
  }), f = le({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    values: void 0
  }), h = J(e, {
    global: !0
  });
  return delete h.id, /* @__PURE__ */ g.createElement(Q.section, {
    ...z(h, f, c),
    ref: t
  }, /* @__PURE__ */ g.createElement(Xu.Provider, {
    value: {
      ...s,
      ref: o
    }
  }, /* @__PURE__ */ g.createElement(u, {
    collection: a.collection,
    parent: n,
    renderDropIndicator: Zu(l, i)
  })));
}
const Ex = /* @__PURE__ */ Ct(Yr, function(t, n, r) {
  let a = $e(n), l = O(Pt), { dragAndDropHooks: i, dragState: u, dropState: o } = O(Nt), d = u && !(u.isDisabled || u.selectionManager.isDisabled(r.key)), { optionProps: s, labelProps: c, descriptionProps: f, ...h } = px({
    key: r.key,
    "aria-label": t?.["aria-label"]
  }, l, a), { hoverProps: m, isHovered: p } = ve({
    isDisabled: !h.allowsSelection && !h.hasAction && !d,
    onHoverStart: r.props.onHoverStart,
    onHoverChange: r.props.onHoverChange,
    onHoverEnd: r.props.onHoverEnd
  }), { keyboardProps: b } = Er(t), { focusProps: y } = mr(t), $ = null;
  u && i && ($ = i.useDraggableItem({
    key: r.key,
    hasAction: h.hasAction
  }, u));
  let v = null;
  o && i && (v = i.useDroppableItem({
    target: {
      type: "item",
      key: r.key,
      dropPosition: "on"
    }
  }, o, a));
  let x = u && u.isDragging(r.key), E = le({
    ...t,
    id: void 0,
    children: t.children,
    defaultClassName: "react-aria-ListBoxItem",
    values: {
      ...h,
      isHovered: p,
      selectionMode: l.selectionManager.selectionMode,
      selectionBehavior: l.selectionManager.selectionBehavior,
      allowsDragging: !!u,
      isDragging: x,
      isDropTarget: v?.isDropTarget
    }
  });
  ee(() => {
    !r.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <ListBoxItem> elements with non-plain text children in order to support accessibility features such as type to select.");
  }, [
    r.textValue
  ]);
  let P = t.href ? Q.a : Q.div, C = J(t, {
    global: !0
  });
  return delete C.id, delete C.onClick, t.href && s.tabIndex == null && (s.tabIndex = -1), /* @__PURE__ */ g.createElement(P, {
    ...z(C, E, s, m, b, y, $?.dragProps, v?.dropProps),
    ref: a,
    "data-allows-dragging": !!u || void 0,
    "data-selected": h.isSelected || void 0,
    "data-disabled": h.isDisabled || void 0,
    "data-hovered": p || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": h.isFocusVisible || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-dragging": x || void 0,
    "data-drop-target": v?.isDropTarget || void 0,
    "data-selection-mode": l.selectionManager.selectionMode === "none" ? void 0 : l.selectionManager.selectionMode
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        _e,
        {
          slots: {
            [gt]: c,
            label: c,
            description: f
          }
        }
      ],
      [
        _n,
        {
          isSelected: h.isSelected
        }
      ]
    ]
  }, E.children));
});
function Cx(e, t) {
  t = $e(t);
  let { dragAndDropHooks: n, dropState: r } = O(Nt), { dropIndicatorProps: a, isHidden: l, isDropTarget: i } = n.useDropIndicator(e, r, t);
  return l ? null : /* @__PURE__ */ g.createElement(wx, {
    ...e,
    dropIndicatorProps: a,
    isDropTarget: i,
    ref: t
  });
}
function Px(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, ...a } = e, l = le({
    ...a,
    defaultClassName: "react-aria-DropIndicator",
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(Q.div, {
    ...n,
    ...l,
    role: "option",
    ref: t,
    "data-drop-target": r || void 0
  }));
}
const wx = /* @__PURE__ */ te(Px), f9 = Ct(Ya, function(t, n, r) {
  let a = O(Pt), { isLoading: l, onLoadMore: i, scrollOffset: u, ...o } = t, d = T(null), s = K(() => ({
    onLoadMore: i,
    collection: a?.collection,
    sentinelRef: d,
    scrollOffset: u
  }), [
    i,
    u,
    a?.collection
  ]);
  Hp(s, d);
  let c = le({
    ...o,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-ListBoxLoadingIndicator",
    values: void 0
  }), f = {
    // For Android talkback
    tabIndex: -1
  };
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("div", {
    style: {
      position: "relative",
      width: 0,
      height: 0
    },
    inert: sl(!0)
  }, /* @__PURE__ */ g.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: d,
    style: {
      position: "absolute",
      height: 1,
      width: 1
    }
  })), l && c.children && /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(J(t, {
      global: !0
    }), f),
    ...c,
    // aria-selected isn't needed here since this option is not selectable.
    role: "option",
    ref: n
  }, c.children)));
});
function jp(e) {
  let t = On(e.value), n = On(e.defaultValue || "#000000"), [r, a] = Pe(t || void 0, n, e.onChange);
  return {
    color: r,
    setColor(l) {
      l != null && a(l || Ye("#000000"));
    }
  };
}
function Sx(e) {
  return e && e.__esModule ? e.default : e;
}
const _p = /* @__PURE__ */ G(null), Wp = /* @__PURE__ */ G(null), h9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, _p);
  let r = jp(t), a = K(() => /* @__PURE__ */ new Map(), []), l = xe(Sx(qu), "react-aria-components");
  return /* @__PURE__ */ g.createElement(vx, {
    ...J(t, {
      labelable: !0
    }),
    ref: n,
    className: t.className || "react-aria-ColorSwatchPicker",
    style: t.style,
    "aria-label": t["aria-label"] || (t["aria-labelledby"] ? void 0 : l.format("colorSwatchPicker")),
    layout: t.layout || "grid",
    selectionMode: "single",
    selectedKeys: [
      r.color.toString("hexa")
    ],
    onSelectionChange: (i) => {
      i !== "all" && r.setColor(a.get([
        ...i
      ][0]));
    },
    disallowEmptySelection: !0
  }, /* @__PURE__ */ g.createElement(Wp.Provider, {
    value: a
  }, t.children));
}), m9 = /* @__PURE__ */ te(function(t, n) {
  let r = t.color || "#0000", a = K(() => typeof r == "string" ? Ye(r) : r, [
    r
  ]), { locale: l } = de(), i = O(Wp);
  ee(() => {
    let o = a.toString("hexa");
    return i.set(o, a), () => {
      i.delete(o);
    };
  }, [
    a,
    i
  ]);
  let u = (o) => typeof o == "function" ? (d) => o({
    ...d,
    color: a
  }) : o;
  return /* @__PURE__ */ g.createElement(Ex, {
    ...t,
    // ColorSwatchPickerItem is never a link.
    render: t.render,
    ref: n,
    id: a.toString("hexa"),
    textValue: a.getColorName(l),
    className: u(t.className || "react-aria-ColorSwatchPickerItem"),
    style: u(t.style)
  }, n5(u(t.children), (o) => /* @__PURE__ */ g.createElement(Gu.Provider, {
    value: {
      color: a
    }
  }, o)));
}), kx = /* @__PURE__ */ G(null), Bx = /* @__PURE__ */ G(null), Fx = /* @__PURE__ */ G(null);
function p9(e) {
  let t = Oe(Bx, e.slot);
  e = z(t, e);
  let n = jp(e), r = le({
    ...e,
    values: {
      color: n.color
    }
  });
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Fx,
        n
      ],
      [
        Zm,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        C3,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        kx,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        Wm,
        {
          value: n.color,
          onChange: n.setColor
        }
      ],
      [
        Gu,
        {
          color: n.color
        }
      ],
      [
        _p,
        {
          value: n.color,
          onChange: n.setColor
        }
      ]
    ]
  }, r.children);
}
const Gp = /* @__PURE__ */ G({
  placement: "bottom"
}), Ax = typeof HTMLElement < "u" && "inert" in HTMLElement.prototype;
function ld(e) {
  return e.dataset.liveAnnouncer === "true" || e.dataset.reactAriaTopLayer !== void 0;
}
let Kr = /* @__PURE__ */ new WeakMap(), We = [];
function qp(e, t) {
  let n = ke(e?.[0]), r = t instanceof n.Element ? {
    root: t
  } : t, a = r?.root ?? document.body, l = r?.shouldUseInert && Ax, i = new Set(e), u = /* @__PURE__ */ new Set(), o = (b) => l && b instanceof n.HTMLElement ? b.inert : b.getAttribute("aria-hidden") === "true", d = (b, y) => {
    l && b instanceof n.HTMLElement ? b.inert = y : y ? b.setAttribute("aria-hidden", "true") : (b.removeAttribute("aria-hidden"), b instanceof n.HTMLElement && (b.inert = !1));
  }, s = /* @__PURE__ */ new Set();
  if (Ht())
    for (let b of e) {
      let y = b;
      for (; y && y !== a; ) {
        let $ = y.getRootNode();
        "shadowRoot" in $ && s.add($.shadowRoot), y = $.parentNode;
      }
    }
  let c = (b) => {
    for (let x of b.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]")) i.add(x);
    let y = (x) => {
      if (u.has(x) || i.has(x) || x.parentElement && u.has(x.parentElement) && x.parentElement.getAttribute("role") !== "row") return NodeFilter.FILTER_REJECT;
      for (let E of i)
        if (ae(x, E)) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, $ = Tp(he(b), b, NodeFilter.SHOW_ELEMENT, {
      acceptNode: y
    }), v = y(b);
    if (v === NodeFilter.FILTER_ACCEPT && f(b), v !== NodeFilter.FILTER_REJECT) {
      let x = $.nextNode();
      for (; x != null; )
        f(x), x = $.nextNode();
    }
  }, f = (b) => {
    let y = Kr.get(b) ?? 0;
    o(b) && y === 0 || (y === 0 && d(b, !0), u.add(b), Kr.set(b, y + 1));
  };
  We.length && We[We.length - 1].disconnect(), c(a);
  let h = new MutationObserver((b) => {
    for (let y of b)
      if (y.type === "childList") {
        if (y.target.isConnected && ![
          ...i,
          ...u
        ].some(($) => ae($, y.target))) for (let $ of y.addedNodes)
          ($ instanceof HTMLElement || $ instanceof SVGElement) && ld($) ? i.add($) : $ instanceof Element && c($);
        if (Ht()) {
          for (let $ of s) if (!$.isConnected) {
            h.disconnect();
            break;
          }
        }
      }
  });
  h.observe(a, {
    childList: !0,
    subtree: !0
  });
  let m = /* @__PURE__ */ new Set();
  if (Ht()) for (let b of s) {
    let y = new MutationObserver(($) => {
      for (let v of $)
        if (v.type === "childList") {
          if (v.target.isConnected && ![
            ...i,
            ...u
          ].some((x) => ae(x, v.target))) for (let x of v.addedNodes)
            (x instanceof HTMLElement || x instanceof SVGElement) && ld(x) ? i.add(x) : x instanceof Element && c(x);
          if (Ht()) {
            for (let x of s) if (!x.isConnected) {
              h.disconnect();
              break;
            }
          }
        }
    });
    y.observe(b, {
      childList: !0,
      subtree: !0
    }), m.add(y);
  }
  let p = {
    visibleNodes: i,
    hiddenNodes: u,
    observe() {
      h.observe(a, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      h.disconnect();
    }
  };
  return We.push(p), () => {
    if (h.disconnect(), Ht()) for (let b of m) b.disconnect();
    for (let b of u) {
      let y = Kr.get(b);
      y != null && (y === 1 ? (d(b, !1), Kr.delete(b)) : Kr.set(b, y - 1));
    }
    p === We[We.length - 1] ? (We.pop(), We.length && We[We.length - 1].observe()) : We.splice(We.indexOf(p), 1);
  };
}
function Rx(e) {
  let t = We[We.length - 1];
  if (t && !t.visibleNodes.has(e))
    return t.visibleNodes.add(e), () => {
      t.visibleNodes.delete(e);
    };
}
const rt = {
  top: "top",
  bottom: "top",
  left: "left",
  right: "left"
}, dl = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
}, Tx = {
  top: "left",
  left: "top"
}, Ji = {
  top: "height",
  left: "width"
}, Yp = {
  width: "totalWidth",
  height: "totalHeight"
}, Aa = {};
let Ix = () => typeof document < "u" ? window.visualViewport : null;
function id(e, t) {
  let n = 0, r = 0, a = 0, l = 0, i = 0, u = 0, o = {}, d = (t?.scale ?? 1) > 1;
  if (e.tagName === "BODY" || e.tagName === "HTML") {
    let s = document.documentElement;
    a = s.clientWidth, l = s.clientHeight, n = t?.width ?? a, r = t?.height ?? l, o.top = s.scrollTop || e.scrollTop, o.left = s.scrollLeft || e.scrollLeft, t && (i = t.offsetTop, u = t.offsetLeft);
  } else
    ({ width: n, height: r, top: i, left: u } = oa(e, !1)), o.top = e.scrollTop, o.left = e.scrollLeft, a = n, l = r;
  return Gd() && (e.tagName === "BODY" || e.tagName === "HTML") && d && (o.top = 0, o.left = 0, i = t?.pageTop ?? 0, u = t?.pageLeft ?? 0), {
    width: n,
    height: r,
    totalWidth: a,
    totalHeight: l,
    scroll: o,
    top: i,
    left: u
  };
}
function Mx(e) {
  return {
    top: e.scrollTop,
    left: e.scrollLeft,
    width: e.scrollWidth,
    height: e.scrollHeight
  };
}
function ud(e, t, n, r, a, l, i) {
  let u = a.scroll[e] ?? 0, o = r[Ji[e]], d = i[e] + r.scroll[rt[e]] + l, s = i[e] + r.scroll[rt[e]] + o - l, c = t - u + r.scroll[rt[e]] + i[e] - r[rt[e]], f = t - u + n + r.scroll[rt[e]] + i[e] - r[rt[e]];
  return c < d ? d - c : f > s ? Math.max(s - f, d - c) : 0;
}
function Kx(e) {
  let t = window.getComputedStyle(e);
  return {
    top: parseInt(t.marginTop, 10) || 0,
    bottom: parseInt(t.marginBottom, 10) || 0,
    left: parseInt(t.marginLeft, 10) || 0,
    right: parseInt(t.marginRight, 10) || 0
  };
}
function od(e) {
  if (Aa[e]) return Aa[e];
  let [t, n] = e.split(" "), r = rt[t] || "right", a = Tx[r];
  rt[n] || (n = "center");
  let l = Ji[r], i = Ji[a];
  return Aa[e] = {
    placement: t,
    crossPlacement: n,
    axis: r,
    crossAxis: a,
    size: l,
    crossSize: i
  }, Aa[e];
}
function di(e, t, n, r, a, l, i, u, o, d, s) {
  let { placement: c, crossPlacement: f, axis: h, crossAxis: m, size: p, crossSize: b } = r, y = {};
  y[m] = e[m] ?? 0, f === "center" ? y[m] += ((e[b] ?? 0) - (n[b] ?? 0)) / 2 : f !== m && (y[m] += (e[b] ?? 0) - (n[b] ?? 0)), y[m] += l;
  const $ = e[m] - n[b] + o + d, v = e[m] + e[b] - o - d;
  if (y[m] = Ve(y[m], $, v), c === h) {
    let x = u ? s[p] : s[Yp[p]];
    y[dl[h]] = Math.floor(x - e[h] + a);
  } else y[h] = Math.floor(e[h] + e[p] + a);
  return y;
}
function Nx(e, t, n, r, a, l, i, u, o, d, s) {
  let c = (e.top != null ? e.top : o[Yp.height] - (e.bottom ?? 0) - i) - (o.scroll.top ?? 0), f = d ? n.top : 0, h = {
    // This should be boundary top in container coord system vs viewport top in container coord system
    // For the viewport top, there are several cases
    // 1. pinchzoom case where we want the viewports offset top as top here
    // 2. case where container is offset from the boundary and is contained by the boundary. In this case the top we want here is NOT 0, we want to take boundary's top even though is is a negative number OR the visual viewport, whichever is more restrictive
    top: Math.max(t.top + f, (s?.offsetTop ?? t.top) + f),
    bottom: Math.min(t.top + t.height + f, (s?.offsetTop ?? 0) + (s?.height ?? 0))
  };
  return u !== "top" ? Math.max(0, h.bottom - // this is the bottom of the boundary
  c - // this is the top of the overlay
  ((a.top ?? 0) + (a.bottom ?? 0) + l)) : Math.max(0, c + i - // this is the bottom of the overlay
  h.top - // this is the top of the boundary
  ((a.top ?? 0) + (a.bottom ?? 0) + l));
}
function sd(e, t, n, r, a, l, i, u) {
  let { placement: o, axis: d, size: s } = l;
  return o === d ? Math.max(0, n[d] - // trigger start
  (i.scroll[d] ?? 0) - // transform trigger position to be with respect to viewport 0,0
  (e[d] + (u ? t[d] : 0)) - // boundary start
  (r[d] ?? 0) - // margins usually for arrows or other decorations
  r[dl[d]] - a) : Math.max(0, e[s] + e[d] + (u ? t[d] : 0) - n[d] - n[s] + (i.scroll[d] ?? 0) - (r[d] ?? 0) - r[dl[d]] - a);
}
function Vx(e, t, n, r, a, l, i, u, o, d, s, c, f, h, m, p, b, y) {
  let $ = od(e), { size: v, crossAxis: x, crossSize: E, placement: P, crossPlacement: C } = $, M = di(t, u, n, $, s, c, d, f, m, p, o), F = s, V = sd(u, d, t, a, l + s, $, o, b);
  if (i && n[v] > V) {
    let Z = od(`${dl[P]} ${C}`), ie = di(t, u, n, Z, s, c, d, f, m, p, o);
    sd(u, d, t, a, l + s, Z, o, b) > V && ($ = Z, M = ie, F = s);
  }
  let I = "bottom";
  $.axis === "top" ? $.placement === "top" ? I = "top" : $.placement === "bottom" && (I = "bottom") : $.crossAxis === "top" && ($.crossPlacement === "top" ? I = "bottom" : $.crossPlacement === "bottom" && (I = "top"));
  let A = ud(x, M[x], n[E], u, o, l, d);
  M[x] += A;
  let U = Nx(M, u, d, f, a, l, n.height, I, o, b, y);
  h && h < U && (U = h), n.height = Math.min(n.height, U), M = di(t, u, n, $, F, c, d, f, m, p, o), A = ud(x, M[x], n[E], u, o, l, d), M[x] += A;
  let D = {}, N = t[x] - M[x] - a[rt[x]], w = N + 0.5 * t[E];
  const R = m / 2 + p, H = rt[x] === "left" ? (a.left ?? 0) + (a.right ?? 0) : (a.top ?? 0) + (a.bottom ?? 0), k = n[E] - H - m / 2 - p, S = t[x] + m / 2 - (M[x] + a[rt[x]]), j = t[x] + t[E] - m / 2 - (M[x] + a[rt[x]]), _ = Ve(w, S, j);
  D[x] = Ve(_, R, k), { placement: P, crossPlacement: C } = $, m ? N = D[x] : C === "right" ? N += t[E] : C === "center" && (N += t[E] / 2);
  let B = P === "left" || P === "top" ? n[v] : 0, L = {
    x: P === "top" || P === "bottom" ? N : B,
    y: P === "left" || P === "right" ? N : B
  };
  return {
    position: M,
    maxHeight: U,
    arrowOffsetLeft: D.left,
    arrowOffsetTop: D.top,
    placement: P,
    triggerAnchorPoint: L
  };
}
function Lx(e) {
  let { placement: t, targetNode: n, overlayNode: r, scrollNode: a, padding: l, shouldFlip: i, boundaryElement: u, offset: o, crossOffset: d, maxHeight: s, arrowSize: c = 0, arrowBoundaryOffset: f = 0, targetRect: h } = e, m = Ix(), p = r instanceof HTMLElement ? zx(r) : document.documentElement, b = p === document.documentElement;
  const y = window.getComputedStyle(p).position;
  let $ = !!y && y !== "static", v = b ? oa(n, !1, h) : dd(n, p, !1, h);
  if (!b) {
    let { marginTop: I, marginLeft: A } = window.getComputedStyle(n);
    v.top += parseInt(I, 10) || 0, v.left += parseInt(A, 10) || 0;
  }
  let x = oa(r, !0), E = Kx(r);
  x.width += (E.left ?? 0) + (E.right ?? 0), x.height += (E.top ?? 0) + (E.bottom ?? 0);
  let P = Mx(a), C = id(u, m), M = id(p, m), F;
  if ((u.tagName === "BODY" || u.tagName === "HTML") && !b) {
    let I = Fl(p, !1);
    F = {
      top: -(I.top - C.top),
      left: -(I.left - C.left),
      width: 0,
      height: 0
    };
  } else (u.tagName === "BODY" || u.tagName === "HTML") && b ? F = {
    top: 0,
    left: 0,
    width: 0,
    height: 0
  } : F = dd(u, p, !1);
  let V = ae(u, p);
  return Vx(t, v, x, P, E, l, i, C, M, F, o, d, $, s, c, f, V, m);
}
function Fl(e, t) {
  let { top: n, left: r, width: a, height: l } = e.getBoundingClientRect();
  return t && e instanceof e.ownerDocument.defaultView.HTMLElement && (a = e.offsetWidth, l = e.offsetHeight), {
    top: n,
    left: r,
    width: a,
    height: l
  };
}
function oa(e, t, n) {
  let { top: r, left: a, width: l, height: i } = n || Fl(e, t), { scrollTop: u, scrollLeft: o, clientTop: d, clientLeft: s } = document.documentElement;
  return {
    top: r + u - d,
    left: a + o - s,
    width: l,
    height: i
  };
}
function dd(e, t, n, r) {
  let a = window.getComputedStyle(e), l;
  if (a.position === "fixed") l = r || Fl(e, n);
  else {
    l = oa(e, n, r);
    let i = oa(t, n), u = window.getComputedStyle(t);
    i.top += (parseInt(u.borderTopWidth, 10) || 0) - t.scrollTop, i.left += (parseInt(u.borderLeftWidth, 10) || 0) - t.scrollLeft, l.top -= i.top, l.left -= i.left;
  }
  return l.top -= parseInt(a.marginTop, 10) || 0, l.left -= parseInt(a.marginLeft, 10) || 0, l;
}
function zx(e) {
  let t = e.offsetParent;
  if (t && t === document.body && window.getComputedStyle(t).position === "static" && !cd(t) && (t = document.documentElement), t == null)
    for (t = e.parentElement; t && !cd(t); ) t = t.parentElement;
  return t || document.documentElement;
}
function cd(e) {
  let t = window.getComputedStyle(e);
  return t.transform !== "none" || /transform|perspective/.test(t.willChange) || t.filter !== "none" || t.contain === "paint" || "backdropFilter" in t && t.backdropFilter !== "none" || "WebkitBackdropFilter" in t && t.WebkitBackdropFilter !== "none";
}
const Zp = /* @__PURE__ */ new WeakMap();
function Ox(e) {
  let { triggerRef: t, isOpen: n, onClose: r } = e;
  ee(() => {
    if (!n || r === null) return;
    let a = (l) => {
      let i = W(l);
      if (!t.current || i instanceof Node && !ae(i, t.current) || i instanceof HTMLInputElement || i instanceof HTMLTextAreaElement) return;
      let u = r || Zp.get(t.current);
      u && u();
    };
    return window.addEventListener("scroll", a, !0), () => {
      window.removeEventListener("scroll", a, !0);
    };
  }, [
    n,
    r,
    t
  ]);
}
function Hx() {
  return typeof window.ResizeObserver < "u";
}
function gr(e) {
  const { ref: t, box: n, onResize: r } = e;
  let a = De(r);
  ee(() => {
    let l = t?.current;
    if (l)
      if (Hx()) {
        const i = new window.ResizeObserver((u) => {
          u.length && a();
        });
        return i.observe(l, {
          box: n
        }), () => {
          l && i.unobserve(l);
        };
      } else
        return window.addEventListener("resize", a, !1), () => {
          window.removeEventListener("resize", a, !1);
        };
  }, [
    t,
    n
  ]);
}
let Cn = typeof document < "u" ? window.visualViewport : null;
function Xp(e) {
  let { direction: t } = de(), { arrowSize: n, targetRef: r, overlayRef: a, arrowRef: l, scrollRef: i = a, placement: u = "bottom", containerPadding: o = 12, shouldFlip: d = !0, boundaryElement: s = typeof document < "u" ? document.body : null, offset: c = 0, crossOffset: f = 0, shouldUpdatePosition: h = !0, isOpen: m = !0, onClose: p, maxHeight: b, arrowBoundaryOffset: y = 0, getTargetRect: $ } = e, [v, x] = Y(null), E = [
    h,
    u,
    a.current,
    r.current,
    l?.current,
    i.current,
    o,
    d,
    s,
    c,
    f,
    m,
    t,
    b,
    y,
    n
  ], P = T(Cn?.scale);
  ee(() => {
    m && (P.current = Cn?.scale);
  }, [
    m
  ]);
  let C = X(() => {
    if (h === !1 || !m || !a.current || !r.current || !s || Cn?.scale !== P.current) return;
    let V = null;
    if (i.current && qt(i.current)) {
      let D = se()?.getBoundingClientRect(), N = i.current.getBoundingClientRect();
      V = {
        type: "top",
        offset: (D?.top ?? 0) - N.top
      }, V.offset > N.height / 2 && (V.type = "bottom", V.offset = (D?.bottom ?? 0) - N.bottom);
    }
    let I = a.current;
    !b && a.current && (I.style.top = "0px", I.style.bottom = "", I.style.maxHeight = (window.visualViewport?.height ?? window.innerHeight) + "px");
    let A = Lx({
      placement: jx(u, t),
      overlayNode: a.current,
      targetNode: r.current,
      scrollNode: i.current || a.current,
      padding: o,
      shouldFlip: d,
      boundaryElement: s,
      offset: c,
      crossOffset: f,
      maxHeight: b,
      arrowSize: n ?? (l?.current ? Fl(l.current, !0).width : 0),
      arrowBoundaryOffset: y,
      targetRect: $?.(r.current)
    });
    if (!A.position) return;
    I.style.top = "", I.style.bottom = "", I.style.left = "", I.style.right = "", Object.keys(A.position).forEach((D) => I.style[D] = A.position[D] + "px"), I.style.maxHeight = A.maxHeight != null ? A.maxHeight + "px" : "";
    let U = se();
    if (V && U && i.current) {
      let D = U.getBoundingClientRect(), N = i.current.getBoundingClientRect(), w = D[V.type] - N[V.type];
      i.current.scrollTop += w - V.offset;
    }
    x(A);
  }, E);
  ue(C, E), Ux(C), gr({
    ref: a,
    onResize: C
  }), gr({
    ref: r,
    onResize: C
  });
  let M = T(!1);
  ue(() => {
    let V, I = () => {
      M.current = !0, clearTimeout(V), V = setTimeout(() => {
        M.current = !1;
      }, 500), C();
    }, A = () => {
      M.current && I();
    };
    return Cn?.addEventListener("resize", I), Cn?.addEventListener("scroll", A), () => {
      Cn?.removeEventListener("resize", I), Cn?.removeEventListener("scroll", A);
    };
  }, [
    C
  ]);
  let F = X(() => {
    M.current || p?.();
  }, [
    p,
    M
  ]);
  return Ox({
    triggerRef: r,
    isOpen: m,
    onClose: p && F
  }), {
    overlayProps: {
      style: {
        position: v ? "absolute" : "fixed",
        top: v ? void 0 : 0,
        left: v ? void 0 : 0,
        zIndex: 1e5,
        ...v?.position,
        maxHeight: v?.maxHeight ?? "100vh"
      }
    },
    placement: v?.placement ?? null,
    triggerAnchorPoint: v?.triggerAnchorPoint ?? null,
    arrowProps: {
      "aria-hidden": "true",
      role: "presentation",
      style: {
        left: v?.arrowOffsetLeft,
        top: v?.arrowOffsetTop
      }
    },
    updatePosition: C
  };
}
function Ux(e) {
  ue(() => (window.addEventListener("resize", e, !1), () => {
    window.removeEventListener("resize", e, !1);
  }), [
    e
  ]);
}
function jx(e, t) {
  return t === "rtl" ? e.replace("start", "right").replace("end", "left") : e.replace("start", "left").replace("end", "right");
}
function _x(e) {
  let { ref: t, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: a } = e, l = T({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), i = De((o) => {
    n && Ra(o, t) && (a && a(o), l.current.isPointerDown = !0);
  }), u = De((o) => {
    n && n(o);
  });
  ee(() => {
    let o = l.current;
    if (r) return;
    const d = t.current, s = he(d);
    if (typeof PointerEvent < "u") {
      let c = (f) => {
        o.isPointerDown && Ra(f, t) && u(f), o.isPointerDown = !1;
      };
      return s.addEventListener("pointerdown", i, !0), s.addEventListener("click", c, !0), () => {
        s.removeEventListener("pointerdown", i, !0), s.removeEventListener("click", c, !0);
      };
    } else if (process.env.NODE_ENV === "test") {
      let c = (h) => {
        o.ignoreEmulatedMouseEvents ? o.ignoreEmulatedMouseEvents = !1 : o.isPointerDown && Ra(h, t) && u(h), o.isPointerDown = !1;
      }, f = (h) => {
        o.ignoreEmulatedMouseEvents = !0, o.isPointerDown && Ra(h, t) && u(h), o.isPointerDown = !1;
      };
      return s.addEventListener("mousedown", i, !0), s.addEventListener("mouseup", c, !0), s.addEventListener("touchstart", i, !0), s.addEventListener("touchend", f, !0), () => {
        s.removeEventListener("mousedown", i, !0), s.removeEventListener("mouseup", c, !0), s.removeEventListener("touchstart", i, !0), s.removeEventListener("touchend", f, !0);
      };
    }
  }, [
    t,
    r
  ]);
}
function Ra(e, t) {
  if (e.button > 0) return !1;
  let n = W(e);
  if (n) {
    const r = n.ownerDocument;
    if (!r || !ae(r.documentElement, n) || n.closest("[data-react-aria-top-layer]")) return !1;
  }
  return t.current ? !e.composedPath().includes(t.current) : !1;
}
const Bt = [];
function Jp(e, t) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: a, isDismissable: l = !1, isKeyboardDismissDisabled: i = !1, shouldCloseOnInteractOutside: u } = e, o = T(void 0);
  ee(() => {
    if (a && !Bt.includes(t))
      return Bt.push(t), () => {
        let m = Bt.indexOf(t);
        m >= 0 && Bt.splice(m, 1);
      };
  }, [
    a,
    t
  ]);
  let d = () => {
    Bt[Bt.length - 1] === t && n && n();
  }, s = (m) => {
    const p = Bt[Bt.length - 1];
    o.current = p, (!u || u(W(m))) && p === t && m.stopPropagation();
  }, c = (m) => {
    (!u || u(W(m))) && (Bt[Bt.length - 1] === t && m.stopPropagation(), o.current === t && d()), o.current = void 0;
  }, f = (m) => {
    m.key === "Escape" && !i && !m.nativeEvent.isComposing && (m.stopPropagation(), m.preventDefault(), d());
  };
  _x({
    ref: t,
    onInteractOutside: l && a ? c : void 0,
    onInteractOutsideStart: s
  });
  let { focusWithinProps: h } = ct({
    isDisabled: !r,
    onBlurWithin: (m) => {
      !m.relatedTarget || ix(m.relatedTarget) || (!u || u(m.relatedTarget)) && n?.();
    }
  });
  return {
    overlayProps: {
      onKeyDown: f,
      ...h
    },
    underlayProps: {}
  };
}
const Wr = typeof document < "u" && window.visualViewport;
let Ta = 0, ci;
function Qp(e = {}) {
  let { isDisabled: t } = e;
  ue(() => {
    if (!t)
      return Ta++, Ta === 1 && (vt() ? ci = Gx() : ci = Wx()), () => {
        Ta--, Ta === 0 && ci();
      };
  }, [
    t
  ]);
}
function Wx() {
  let e = window.innerWidth - document.documentElement.clientWidth;
  return ot(e > 0 && // Use scrollbar-gutter when supported because it also works for fixed positioned elements.
  ("scrollbarGutter" in document.documentElement.style ? Oa(document.documentElement, "scrollbarGutter", "stable") : Oa(document.documentElement, "paddingRight", `${e}px`)), Oa(document.documentElement, "overflow", "hidden"));
}
function Gx() {
  let e = Oa(document.documentElement, "overflow", "hidden"), t, n = !1, r = (s) => {
    let c = W(s);
    t = gn(c) ? c : Le(c, !0), n = !1;
    let f = c.ownerDocument.defaultView.getSelection();
    f && !f.isCollapsed && f.containsNode(c, !0) && (n = !0), s.composedPath().some((h) => h instanceof HTMLInputElement && h.type === "range") && (n = !0), "selectionStart" in c && "selectionEnd" in c && c.selectionStart < c.selectionEnd && c.ownerDocument.activeElement === c && (n = !0);
  }, a = document.createElement("style"), l = Xc();
  l && (a.nonce = l), a.textContent = `
@layer {
  * {
    overscroll-behavior: contain;
  }
}`.trim(), document.head.prepend(a);
  let i = (s) => {
    if (!(s.touches.length === 2 || n)) {
      if (!t || t === document.documentElement || t === document.body) {
        s.preventDefault();
        return;
      }
      t.scrollHeight === t.clientHeight && t.scrollWidth === t.clientWidth && s.preventDefault();
    }
  }, u = (s) => {
    let c = W(s), f = s.relatedTarget;
    f && jr(f) ? (f.focus({
      preventScroll: !0
    }), fd(f, jr(c))) : f || c.parentElement?.closest("[tabindex]")?.focus({
      preventScroll: !0
    });
  }, o = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function(s) {
    let c = se(), f = c != null && jr(c);
    o.call(this, {
      ...s,
      preventScroll: !0
    }), (!s || !s.preventScroll) && fd(this, f);
  };
  let d = ot(fi(document, "touchstart", r, {
    passive: !1,
    capture: !0
  }), fi(document, "touchmove", i, {
    passive: !1,
    capture: !0
  }), fi(document, "blur", u, !0));
  return () => {
    e(), d(), a.remove(), HTMLElement.prototype.focus = o;
  };
}
function Oa(e, t, n) {
  let r = e.style[t];
  return e.style[t] = n, () => {
    e.style[t] = r;
  };
}
function fi(e, t, n, r) {
  return e.addEventListener(t, n, r), () => {
    e.removeEventListener(t, n, r);
  };
}
function fd(e, t) {
  t || !Wr ? hd(e) : Wr.addEventListener("resize", () => hd(e), {
    once: !0
  });
}
function hd(e) {
  let t = document.scrollingElement || document.documentElement, n = e;
  for (; n && n !== t; ) {
    let r = Le(n);
    if (r !== document.documentElement && r !== document.body && r !== n) {
      let a = r.getBoundingClientRect(), l = n.getBoundingClientRect();
      if (l.top < a.top || l.bottom > a.top + n.clientHeight) {
        let i = a.bottom;
        Wr && (i = Math.min(i, Wr.offsetTop + Wr.height));
        let u = l.top - a.top - ((i - a.top) / 2 - l.height / 2);
        r.scrollTo({
          // Clamp to the valid range to prevent over-scrolling.
          top: Math.max(0, Math.min(r.scrollHeight - r.clientHeight, r.scrollTop + u)),
          behavior: "smooth"
        });
      }
    }
    n = r.parentElement;
  }
}
function qx(e, t) {
  let { triggerRef: n, popoverRef: r, groupRef: a, isNonModal: l, isKeyboardDismissDisabled: i, shouldCloseOnInteractOutside: u, ...o } = e, d = o.trigger === "SubmenuTrigger", { overlayProps: s, underlayProps: c } = Jp({
    isOpen: t.isOpen,
    onClose: t.close,
    shouldCloseOnBlur: !0,
    isDismissable: !l || d,
    isKeyboardDismissDisabled: i,
    shouldCloseOnInteractOutside: u
  }, a ?? r), { overlayProps: f, arrowProps: h, placement: m, triggerAnchorPoint: p } = Xp({
    ...o,
    targetRef: n,
    overlayRef: r,
    isOpen: t.isOpen,
    onClose: l && !d ? t.close : null
  });
  return Qp({
    isDisabled: l || !t.isOpen
  }), ee(() => {
    if (t.isOpen && r.current)
      return l ? Rx(a?.current ?? r.current) : qp([
        a?.current ?? r.current
      ], {
        shouldUseInert: !0
      });
  }, [
    l,
    t.isOpen,
    r,
    a
  ]), {
    popoverProps: z(s, f),
    arrowProps: h,
    underlayProps: c,
    placement: m,
    triggerAnchorPoint: p
  };
}
var eb = {};
eb = {
  dismiss: "تجاهل"
};
var tb = {};
tb = {
  dismiss: "Отхвърляне"
};
var nb = {};
nb = {
  dismiss: "Odstranit"
};
var rb = {};
rb = {
  dismiss: "Luk"
};
var ab = {};
ab = {
  dismiss: "Schließen"
};
var lb = {};
lb = {
  dismiss: "Απόρριψη"
};
var ib = {};
ib = {
  dismiss: "Dismiss"
};
var ub = {};
ub = {
  dismiss: "Descartar"
};
var ob = {};
ob = {
  dismiss: "Lõpeta"
};
var sb = {};
sb = {
  dismiss: "Hylkää"
};
var db = {};
db = {
  dismiss: "Rejeter"
};
var cb = {};
cb = {
  dismiss: "התעלם"
};
var fb = {};
fb = {
  dismiss: "Odbaci"
};
var hb = {};
hb = {
  dismiss: "Elutasítás"
};
var mb = {};
mb = {
  dismiss: "Ignora"
};
var pb = {};
pb = {
  dismiss: "閉じる"
};
var bb = {};
bb = {
  dismiss: "무시"
};
var gb = {};
gb = {
  dismiss: "Atmesti"
};
var yb = {};
yb = {
  dismiss: "Nerādīt"
};
var $b = {};
$b = {
  dismiss: "Lukk"
};
var vb = {};
vb = {
  dismiss: "Negeren"
};
var Db = {};
Db = {
  dismiss: "Zignoruj"
};
var xb = {};
xb = {
  dismiss: "Descartar"
};
var Eb = {};
Eb = {
  dismiss: "Dispensar"
};
var Cb = {};
Cb = {
  dismiss: "Revocare"
};
var Pb = {};
Pb = {
  dismiss: "Пропустить"
};
var wb = {};
wb = {
  dismiss: "Zrušiť"
};
var Sb = {};
Sb = {
  dismiss: "Opusti"
};
var kb = {};
kb = {
  dismiss: "Odbaci"
};
var Bb = {};
Bb = {
  dismiss: "Avvisa"
};
var Fb = {};
Fb = {
  dismiss: "Kapat"
};
var Ab = {};
Ab = {
  dismiss: "Скасувати"
};
var Rb = {};
Rb = {
  dismiss: "取消"
};
var Tb = {};
Tb = {
  dismiss: "關閉"
};
var Ib = {};
Ib = {
  "ar-AE": eb,
  "bg-BG": tb,
  "cs-CZ": nb,
  "da-DK": rb,
  "de-DE": ab,
  "el-GR": lb,
  "en-US": ib,
  "es-ES": ub,
  "et-EE": ob,
  "fi-FI": sb,
  "fr-FR": db,
  "he-IL": cb,
  "hr-HR": fb,
  "hu-HU": hb,
  "it-IT": mb,
  "ja-JP": pb,
  "ko-KR": bb,
  "lt-LT": gb,
  "lv-LV": yb,
  "nb-NO": $b,
  "nl-NL": vb,
  "pl-PL": Db,
  "pt-BR": xb,
  "pt-PT": Eb,
  "ro-RO": Cb,
  "ru-RU": Pb,
  "sk-SK": wb,
  "sl-SI": Sb,
  "sr-SP": kb,
  "sv-SE": Bb,
  "tr-TR": Fb,
  "uk-UA": Ab,
  "zh-CN": Rb,
  "zh-TW": Tb
};
function Yx(e) {
  return e && e.__esModule ? e.default : e;
}
function Qi(e) {
  let { onDismiss: t, ...n } = e, r = xe(Yx(Ib), "@react-aria/overlays"), a = it(n, r.format("dismiss")), l = () => {
    t && t();
  };
  return /* @__PURE__ */ g.createElement(br, null, /* @__PURE__ */ g.createElement("button", {
    ...a,
    tabIndex: -1,
    onClick: l,
    style: {
      width: 1,
      height: 1
    }
  }));
}
const Mb = /* @__PURE__ */ g.forwardRef(({ children: e, ...t }, n) => {
  let r = T(!1), a = O(Xr), l = z(a || {}, {
    ...t,
    register() {
      r.current = !0, a && a.register();
    }
  });
  return l.ref = $e(n || a?.ref), Du(a, l.ref), ee(() => {
    r.current || (process.env.NODE_ENV !== "production" && console.warn("A PressResponder was rendered without a pressable child. Either call the usePress hook, or wrap your DOM node with <Pressable> component."), r.current = !0);
  }, []), /* @__PURE__ */ g.createElement(Xr.Provider, {
    value: l
  }, e);
});
function Zx({ children: e }) {
  let t = K(() => ({
    register: () => {
    }
  }), []);
  return /* @__PURE__ */ g.createElement(Xr.Provider, {
    value: t
  }, e);
}
const Xx = /* @__PURE__ */ G({});
function lo() {
  return O(Xx) ?? {};
}
const Kb = /* @__PURE__ */ g.createContext(null);
function eu(e) {
  let t = Dt(), { portalContainer: n = t ? null : document.body, isExiting: r } = e, [a, l] = Y(!1), i = K(() => ({
    contain: a,
    setContain: l
  }), [
    a,
    l
  ]), { getContainer: u } = lo();
  if (!e.portalContainer && u && (n = u()), !n) return null;
  let o = e.children;
  return e.disableFocusManagement || (o = /* @__PURE__ */ g.createElement(Sl, {
    restoreFocus: !0,
    contain: (e.shouldContainFocus || a) && !r
  }, o)), o = /* @__PURE__ */ g.createElement(Kb.Provider, {
    value: i
  }, /* @__PURE__ */ g.createElement(Zx, null, o)), /* @__PURE__ */ cu.createPortal(o, n);
}
function Nb() {
  let t = O(Kb)?.setContain;
  ue(() => {
    t?.(!0);
  }, [
    t
  ]);
}
function Br(e) {
  let [t, n] = Pe(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = X(() => {
    n(!0);
  }, [
    n
  ]), a = X(() => {
    n(!1);
  }, [
    n
  ]), l = X(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: a,
    toggle: l
  };
}
function va(e, t = !0) {
  let [n, r] = Y(!0), a = n && t;
  return ue(() => {
    if (a && e.current && "getAnimations" in e.current)
      for (let l of e.current.getAnimations()) l instanceof CSSTransition && l.cancel();
  }, [
    e,
    a
  ]), Vb(e, a, X(() => r(!1), [])), a;
}
function sa(e, t) {
  let [n, r] = Y(t ? "open" : "closed");
  switch (n) {
    case "open":
      t || r("exiting");
      break;
    case "closed":
    case "exiting":
      t && r("open");
      break;
  }
  let a = n === "exiting";
  return Vb(e, a, X(() => {
    r((l) => l === "exiting" ? "closed" : l);
  }, [])), a;
}
function Vb(e, t, n) {
  ue(() => {
    if (t && e.current) {
      if (!("getAnimations" in e.current)) {
        n();
        return;
      }
      let r = e.current.getAnimations();
      if (r.length === 0) {
        n();
        return;
      }
      let a = !1;
      return Promise.allSettled(r.map((l) => l.finished)).then(() => {
        a || at(() => {
          n();
        });
      }), () => {
        a = !0;
      };
    }
  }, [
    e,
    t,
    n
  ]);
}
const Fr = /* @__PURE__ */ G(null), md = /* @__PURE__ */ G(null), b9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Fr);
  let r = O(Vt), a = Br(t), l = t.isOpen != null || t.defaultOpen != null || !r ? a : r, i = sa(n, l.isOpen) || t.isExiting || !1, u = _c(), { direction: o } = de();
  if (u) {
    let d = t.children;
    return typeof d == "function" && (d = d({
      trigger: t.trigger || null,
      placement: "bottom",
      isEntering: !1,
      isExiting: !1,
      defaultChildren: null
    })), /* @__PURE__ */ g.createElement(g.Fragment, null, d);
  }
  return l && !l.isOpen && !i ? null : /* @__PURE__ */ g.createElement(Jx, {
    ...t,
    triggerRef: t.triggerRef,
    state: l,
    popoverRef: n,
    isExiting: i,
    dir: o
  });
});
function Jx({ state: e, isExiting: t, UNSTABLE_portalContainer: n, clearContexts: r, ...a }) {
  let l = T(null), i = T(null), u = O(md), o = u && a.trigger === "SubmenuTrigger", { popoverProps: d, underlayProps: s, arrowProps: c, placement: f, triggerAnchorPoint: h } = qx({
    ...a,
    offset: a.offset ?? 8,
    arrowRef: l,
    // If this is a submenu/subdialog, use the root popover's container
    // to detect outside interaction and add aria-hidden.
    groupRef: o ? u : i
  }, e), m = a.popoverRef, p = va(m, !!f) || a.isEntering || !1, b = le({
    ...a,
    defaultClassName: "react-aria-Popover",
    values: {
      trigger: a.trigger || null,
      placement: f,
      isEntering: p,
      isExiting: t
    }
  }), y = !a.isNonModal || a.trigger === "SubmenuTrigger", [$, v] = Y(!1);
  ue(() => {
    m.current && v(y && !m.current.querySelector("[role=dialog]"));
  }, [
    m,
    y
  ]), ee(() => {
    $ && (a.trigger !== "SubmenuTrigger" || yt() !== "pointer") && m.current && !qt(m.current) && we(m.current);
  }, [
    $,
    m,
    a.trigger
  ]);
  let x = K(() => {
    let V = b.children;
    if (r) for (let I of r) V = /* @__PURE__ */ g.createElement(I.Provider, {
      value: null
    }, V);
    return V;
  }, [
    b.children,
    r
  ]), [E, P] = Y(null), C = X(() => {
    a.triggerRef.current && P(a.triggerRef.current.getBoundingClientRect().width + "px");
  }, [
    a.triggerRef
  ]);
  ue(C, [
    C
  ]), gr({
    ref: b.style?.["--trigger-width"] ? void 0 : a.triggerRef,
    onResize: C
  });
  let M = {
    ...d.style,
    "--trigger-anchor-point": h ? `${h.x}px ${h.y}px` : void 0,
    ...b.style,
    "--trigger-width": b.style?.["--trigger-width"] || E
  }, F = /* @__PURE__ */ g.createElement(Q.div, {
    ...z(J(a, {
      global: !0
    }), d),
    ...b,
    role: $ ? "dialog" : void 0,
    tabIndex: $ ? -1 : void 0,
    "aria-label": a["aria-label"],
    "aria-labelledby": a["aria-labelledby"],
    ref: m,
    slot: a.slot || void 0,
    style: M,
    dir: a.dir,
    "data-trigger": a.trigger,
    "data-placement": f,
    "data-entering": p || void 0,
    "data-exiting": t || void 0
  }, !a.isNonModal && /* @__PURE__ */ g.createElement(Qi, {
    onDismiss: e.close
  }), /* @__PURE__ */ g.createElement(Gp.Provider, {
    value: {
      ...c,
      placement: f,
      ref: l
    }
  }, x), /* @__PURE__ */ g.createElement(Qi, {
    onDismiss: e.close
  }));
  return o ? /* @__PURE__ */ g.createElement(eu, {
    ...a,
    shouldContainFocus: $,
    isExiting: t,
    portalContainer: n ?? u?.current ?? void 0
  }, F) : /* @__PURE__ */ g.createElement(eu, {
    ...a,
    shouldContainFocus: $,
    isExiting: t,
    portalContainer: n
  }, !a.isNonModal && e.isOpen && /* @__PURE__ */ g.createElement("div", {
    "data-testid": "underlay",
    ...s,
    style: {
      position: "fixed",
      inset: 0
    }
  }), /* @__PURE__ */ g.createElement("div", {
    ref: i,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ g.createElement(md.Provider, {
    value: i
  }, F)));
}
const Qx = /* @__PURE__ */ G({});
var Lb = {};
Lb = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var zb = {};
zb = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var Ob = {};
Ob = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var Hb = {};
Hb = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var Ub = {};
Ub = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var jb = {};
jb = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var _b = {};
_b = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var Wb = {};
Wb = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var Gb = {};
Gb = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var qb = {};
qb = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var Yb = {};
Yb = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var Zb = {};
Zb = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var Xb = {};
Xb = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var Jb = {};
Jb = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var Qb = {};
Qb = {
  longPressMessage: "Premi a lungo o premi Alt + Freccia giù per aprire il menu"
};
var eg = {};
eg = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var tg = {};
tg = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var ng = {};
ng = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var rg = {};
rg = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var ag = {};
ag = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var lg = {};
lg = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var ig = {};
ig = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var ug = {};
ug = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var og = {};
og = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var sg = {};
sg = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var dg = {};
dg = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var cg = {};
cg = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var fg = {};
fg = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var hg = {};
hg = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var mg = {};
mg = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var pg = {};
pg = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var bg = {};
bg = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var gg = {};
gg = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var yg = {};
yg = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
var $g = {};
$g = {
  "ar-AE": Lb,
  "bg-BG": zb,
  "cs-CZ": Ob,
  "da-DK": Hb,
  "de-DE": Ub,
  "el-GR": jb,
  "en-US": _b,
  "es-ES": Wb,
  "et-EE": Gb,
  "fi-FI": qb,
  "fr-FR": Yb,
  "he-IL": Zb,
  "hr-HR": Xb,
  "hu-HU": Jb,
  "it-IT": Qb,
  "ja-JP": eg,
  "ko-KR": tg,
  "lt-LT": ng,
  "lv-LV": rg,
  "nb-NO": ag,
  "nl-NL": lg,
  "pl-PL": ig,
  "pt-BR": ug,
  "pt-PT": og,
  "ro-RO": sg,
  "ru-RU": dg,
  "sk-SK": cg,
  "sl-SI": fg,
  "sr-SP": hg,
  "sv-SE": mg,
  "tr-TR": pg,
  "uk-UA": bg,
  "zh-CN": gg,
  "zh-TW": yg
};
function vg(e, t, n) {
  let { type: r } = e, { isOpen: a } = t;
  ee(() => {
    n && n.current && Zp.set(n.current, t.close);
  });
  let l;
  r === "menu" ? l = !0 : r === "listbox" && (l = "listbox");
  let i = ce();
  return {
    triggerProps: {
      "aria-haspopup": l,
      "aria-expanded": a,
      "aria-controls": a ? i : void 0,
      onPress: t.toggle
    },
    overlayProps: {
      id: i
    }
  };
}
function e7(e) {
  return e && e.__esModule ? e.default : e;
}
function Dg(e, t, n) {
  let { type: r = "menu", isDisabled: a, trigger: l = "press" } = e, i = ce(), { triggerProps: u, overlayProps: o } = vg({
    type: r
  }, t, n), d = (h) => {
    if (!a && !(l === "longPress" && !h.altKey) && n && n.current)
      switch (h.key) {
        case "Enter":
        case " ":
          if (l === "longPress" || h.isDefaultPrevented()) return;
        // fallthrough
        case "ArrowDown":
          "continuePropagation" in h || h.stopPropagation(), h.preventDefault(), t.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in h || h.stopPropagation(), h.preventDefault(), t.toggle("last");
          break;
        default:
          "continuePropagation" in h && h.continuePropagation();
      }
  }, s = xe(e7($g), "@react-aria/menu"), { longPressProps: c } = Vp({
    isDisabled: a || l !== "longPress",
    accessibilityDescription: s.format("longPressMessage"),
    onLongPressStart() {
      t.close();
    },
    onLongPress() {
      t.open("first");
    }
  }), f = {
    preventFocusOnPress: !0,
    onPressStart(h) {
      h.pointerType !== "touch" && h.pointerType !== "keyboard" && !a && (Fe(h.target), t.open(h.pointerType === "virtual" ? "first" : null));
    },
    onPress(h) {
      h.pointerType === "touch" && !a && (Fe(h.target), t.toggle());
    }
  };
  return delete u.onPress, {
    // @ts-ignore - TODO we pass out both DOMAttributes AND AriaButtonProps, but useButton will discard the longPress event handlers, it's only through PressResponder magic that this works for RSP and RAC. it does not work in aria examples
    menuTriggerProps: {
      ...u,
      ...l === "press" ? f : c,
      id: i,
      onKeyDown: d
    },
    menuProps: {
      ...o,
      "aria-labelledby": i,
      autoFocus: t.focusStrategy || !0,
      onClose: t.close
    }
  };
}
const xg = /* @__PURE__ */ new WeakMap();
function t7(e, t, n) {
  let { shouldFocusWrap: r = !0, onKeyDown: a, onKeyUp: l, ...i } = e;
  !e["aria-label"] && !e["aria-labelledby"] && process.env.NODE_ENV !== "production" && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let u = J(e, {
    labelable: !0
  }), { listProps: o } = no({
    ...i,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    shouldFocusWrap: r,
    linkBehavior: "override"
  });
  return xg.set(t, {
    onClose: e.onClose,
    onAction: e.onAction,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus
  }), {
    menuProps: z(u, {
      onKeyDown: a,
      onKeyUp: l
    }, {
      role: "menu",
      ...o,
      onKeyDown: (d) => {
        (d.key !== "Escape" || e.shouldUseVirtualFocus) && o.onKeyDown?.(d);
      }
    })
  };
}
function n7(e, t, n) {
  let { id: r, key: a, closeOnSelect: l, shouldCloseOnSelect: i, isVirtualized: u, "aria-haspopup": o, onPressStart: d, onPressUp: s, onPress: c, onPressChange: f, onPressEnd: h, onClick: m, onHoverStart: p, onHoverChange: b, onHoverEnd: y, onKeyDown: $, onKeyUp: v, onFocus: x, onFocusChange: E, onBlur: P, selectionManager: C = t.selectionManager } = e, M = !!o, F = M && e["aria-expanded"] === "true", V = e.isDisabled ?? C.isDisabled(a), I = e.isSelected ?? C.isSelected(a), A = xg.get(t), U = t.collection.getItem(a), D = e.onClose || A.onClose, N = Dr(), w = () => {
    if (!M && (U?.props?.onAction ? U.props.onAction() : e.onAction && e.onAction(a), A.onAction)) {
      let pe = A.onAction;
      pe(a, U?.value);
    }
  }, R = "menuitem";
  M || (C.selectionMode === "single" ? R = "menuitemradio" : C.selectionMode === "multiple" && (R = "menuitemcheckbox"));
  let H = bt(), k = bt(), S = bt(), j = {
    id: r,
    "aria-disabled": V || void 0,
    role: R,
    "aria-label": e["aria-label"],
    "aria-labelledby": H,
    "aria-describedby": [
      e["aria-describedby"],
      k,
      S
    ].filter(Boolean).join(" ") || void 0,
    "aria-controls": e["aria-controls"],
    "aria-haspopup": o,
    "aria-expanded": e["aria-expanded"]
  };
  if (C.selectionMode !== "none" && !M && (j["aria-checked"] = I), u) {
    let pe = Number(U?.index);
    j["aria-posinset"] = Number.isNaN(pe) ? void 0 : pe + 1, j["aria-setsize"] = Lp(t.collection);
  }
  let _ = T(!1), B = (pe) => {
    f?.(pe), _.current = pe;
  }, L = T(null), Z = (pe) => {
    pe.pointerType !== "keyboard" && (L.current = {
      pointerType: pe.pointerType
    }), pe.pointerType === "mouse" && (_.current || pe.target.click()), s?.(pe);
  }, ie = (pe) => {
    m?.(pe), w(), Jd(pe, N, U.props.href, U?.props.routerOptions);
    let ln = L.current?.pointerType === "keyboard" ? L.current?.key === "Enter" || C.selectionMode === "none" || C.isLink(a) : C.selectionMode !== "multiple" || C.isLink(a);
    ln = i ?? l ?? ln, D && !M && ln && D(), L.current = null;
  }, { itemProps: q, isFocused: re } = Sr({
    id: r,
    selectionManager: C,
    key: a,
    ref: n,
    shouldSelectOnPressUp: !0,
    allowsDifferentPressOrigin: !0,
    // Disable all handling of links in useSelectable item
    // because we handle it ourselves. The behavior of menus
    // is slightly different from other collections because
    // actions are performed on key down rather than key up.
    linkBehavior: "none",
    shouldUseVirtualFocus: A.shouldUseVirtualFocus
  }), { pressProps: fe, isPressed: et } = Xe({
    onPressStart: d,
    onPress: c,
    onPressUp: Z,
    onPressChange: B,
    onPressEnd: h,
    isDisabled: V
  }), { hoverProps: ft } = ve({
    isDisabled: V,
    onHoverStart(pe) {
      !Mt() && !(F && o) && (C.setFocused(!0), C.setFocusedKey(a)), p?.(pe);
    },
    onHoverChange: b,
    onHoverEnd: y
  }), { keyboardProps: Wn } = Er({
    onKeyDown: (pe) => {
      if (pe.repeat) {
        pe.continuePropagation();
        return;
      }
      switch (pe.key) {
        case " ":
          L.current = {
            pointerType: "keyboard",
            key: " "
          }, W(pe).click(), qr("keyboard");
          break;
        case "Enter":
          L.current = {
            pointerType: "keyboard",
            key: "Enter"
          }, W(pe).tagName !== "A" && W(pe).click(), qr("keyboard");
          break;
        default:
          M || pe.continuePropagation(), $?.(pe);
          break;
      }
    },
    onKeyUp: v
  }), { focusableProps: zt } = dt({
    onBlur: P,
    onFocus: x,
    onFocusChange: E
  }, n), Gn = J(U?.props);
  delete Gn.id;
  let qn = bl(U?.props);
  return {
    menuItemProps: {
      ...j,
      ...z(
        Gn,
        qn,
        M ? {
          onFocus: q.onFocus,
          "data-collection": q["data-collection"],
          "data-key": q["data-key"]
        } : q,
        fe,
        ft,
        Wn,
        zt,
        // Prevent DOM focus from moving on mouse down when using virtual focus or this is a submenu/subdialog trigger.
        A.shouldUseVirtualFocus || M ? {
          onMouseDown: (pe) => pe.preventDefault()
        } : void 0,
        V ? void 0 : {
          onClick: ie
        }
      ),
      // If a submenu is expanded, set the tabIndex to -1 so that shift tabbing goes out of the menu instead of the parent menu item.
      tabIndex: q.tabIndex != null && F && !A.shouldUseVirtualFocus ? -1 : q.tabIndex
    },
    labelProps: {
      id: H
    },
    descriptionProps: {
      id: k
    },
    keyboardShortcutProps: {
      id: S
    },
    isFocused: re,
    isFocusVisible: re && C.isFocused && Mt() && !F,
    isSelected: I,
    isPressed: et,
    isDisabled: V
  };
}
function r7(e) {
  let { heading: t, "aria-label": n } = e, r = ce();
  return {
    itemProps: {
      role: "presentation"
    },
    headingProps: t ? {
      // Techincally, menus cannot contain headings according to ARIA.
      // We hide the heading from assistive technology, using role="presentation",
      // and only use it as a label for the nested group.
      id: r,
      role: "presentation"
    } : {},
    groupProps: {
      role: "group",
      "aria-label": n,
      "aria-labelledby": t ? r : void 0
    }
  };
}
const Ia = 2, a7 = 50, l7 = 1e3, pd = Math.PI / 12;
function i7(e) {
  let { menuRef: t, submenuRef: n, isOpen: r, isDisabled: a } = e, l = T(void 0), i = T(void 0), u = T(0), o = T(void 0), d = T(void 0), s = T(void 0), c = T(2), [f, h] = Y(!1);
  gr({
    ref: r ? n : void 0,
    onResize: () => {
      n.current && (i.current = n.current.getBoundingClientRect(), s.current = void 0);
    }
  });
  let p = () => {
    h(!1), c.current = Ia, l.current = void 0;
  }, b = yl(), y = De(($) => {
    f && $.preventDefault();
  });
  ee(() => {
    f && t.current ? t.current.style.pointerEvents = "none" : t.current.style.pointerEvents = "";
  }, [
    t,
    f
  ]), ue(() => {
    let $ = n.current, v = t.current;
    if (a || !$ || !r || b !== "pointer" || !v) {
      p();
      return;
    }
    i.current = $.getBoundingClientRect();
    let x = (E) => {
      if (E.pointerType === "touch" || E.pointerType === "pen") return;
      let P = Date.now();
      if (P - u.current < a7) return;
      clearTimeout(o.current), clearTimeout(d.current);
      let { clientX: C, clientY: M } = E;
      if (!l.current) {
        l.current = {
          x: C,
          y: M
        };
        return;
      }
      if (!i.current) return;
      if (s.current || (s.current = C > i.current.right ? "left" : "right"), C < v.getBoundingClientRect().left || C > v.getBoundingClientRect().right || M < v.getBoundingClientRect().top || M > v.getBoundingClientRect().bottom) {
        p();
        return;
      }
      let F = l.current.x, V = l.current.y, I = s.current === "right" ? i.current.left - F : F - i.current.right, A = Math.atan2(V - i.current.top, I) + pd, U = Math.atan2(V - i.current.bottom, I) - pd, D = Math.atan2(V - M, s.current === "left" ? -(C - F) : C - F), N = D < A && D > U;
      c.current = N ? Math.min(c.current + 1, Ia) : Math.max(c.current - 1, 0), c.current >= Ia ? h(!0) : h(!1), u.current = P, l.current = {
        x: C,
        y: M
      }, N && (o.current = setTimeout(() => {
        p(), d.current = setTimeout(() => {
          let w = document.elementFromPoint(C, M);
          w && ae(v, w) && w.dispatchEvent(new PointerEvent("pointerover", {
            bubbles: !0,
            cancelable: !0
          }));
        }, 100);
      }, l7));
    };
    return window.addEventListener("pointermove", x), process.env.NODE_ENV !== "test" && window.addEventListener("pointerdown", y, !0), () => {
      window.removeEventListener("pointermove", x), process.env.NODE_ENV !== "test" && window.removeEventListener("pointerdown", y, !0), clearTimeout(o.current), clearTimeout(d.current), c.current = Ia;
    };
  }, [
    a,
    r,
    t,
    b,
    h,
    n
  ]);
}
function u7(e, t, n) {
  let { parentMenuRef: r, submenuRef: a, type: l = "menu", isDisabled: i, delay: u = 200, shouldUseVirtualFocus: o } = e, d = ce(), s = ce(), { direction: c } = de(), f = T(void 0), h = X(() => {
    f.current && (clearTimeout(f.current), f.current = void 0);
  }, [
    f
  ]), m = X((C) => {
    h(), t.open(C);
  }, [
    t,
    h
  ]), p = X(() => {
    h(), t.close();
  }, [
    t,
    h
  ]);
  ue(() => () => {
    h();
  }, [
    h
  ]);
  let b = (C) => {
    if (qt(C.currentTarget))
      switch (C.key) {
        case "ArrowLeft":
          c === "ltr" && ae(C.currentTarget, W(C)) && (C.preventDefault(), C.stopPropagation(), p(), !o && n.current && Fe(n.current));
          break;
        case "ArrowRight":
          c === "rtl" && ae(C.currentTarget, W(C)) && (C.preventDefault(), C.stopPropagation(), p(), !o && n.current && Fe(n.current));
          break;
        case "Escape":
          ae(a.current, W(C)) && (C.stopPropagation(), p(), !o && n.current && Fe(n.current));
          break;
      }
  }, y = {
    id: s,
    "aria-labelledby": d,
    submenuLevel: t.submenuLevel,
    ...l === "menu" && {
      onClose: t.closeAll,
      autoFocus: t.focusStrategy ?? void 0,
      onKeyDown: b
    }
  }, $ = (C) => {
    switch (C.key) {
      case "ArrowRight":
        i || (c === "ltr" ? (C.preventDefault(), t.isOpen || m("first"), l === "menu" && a?.current && se() === n?.current && Fe(a.current)) : t.isOpen ? p() : C.continuePropagation());
        break;
      case "ArrowLeft":
        i || (c === "rtl" ? (C.preventDefault(), t.isOpen || m("first"), l === "menu" && a?.current && se() === n?.current && Fe(a.current)) : t.isOpen ? p() : C.continuePropagation());
        break;
      default:
        C.continuePropagation();
        break;
    }
  }, v = (C) => {
    !i && (C.pointerType === "virtual" || C.pointerType === "keyboard") && m("first");
  }, x = (C) => {
    !i && (C.pointerType === "touch" || C.pointerType === "mouse") && m();
  }, E = (C) => {
    i || (C && !t.isOpen ? f.current || (f.current = setTimeout(() => {
      m();
    }, u)) : C || h());
  };
  mt(r, "focusin", (C) => {
    t.isOpen && ae(r.current, W(C)) && W(C) !== n.current && p();
  });
  let P = (C) => C !== n.current;
  return i7({
    menuRef: r,
    submenuRef: a,
    isOpen: t.isOpen,
    isDisabled: i
  }), {
    submenuTriggerProps: {
      id: d,
      "aria-controls": t.isOpen ? s : void 0,
      "aria-haspopup": i ? void 0 : l,
      "aria-expanded": t.isOpen ? "true" : "false",
      onPressStart: v,
      onPress: x,
      onHoverChange: E,
      onKeyDown: $,
      isOpen: t.isOpen
    },
    submenuProps: y,
    popoverProps: {
      isNonModal: !0,
      shouldCloseOnInteractOutside: P
    }
  };
}
function io(e) {
  let t = Br(e), [n, r] = Y(null), [a, l] = Y([]), i = () => {
    l([]), t.close();
  };
  return {
    focusStrategy: n,
    ...t,
    open(d = null) {
      r(d), t.open();
    },
    toggle(d = null) {
      r(d), t.toggle();
    },
    close() {
      i();
    },
    expandedKeysStack: a,
    openSubmenu: (d, s) => {
      l((c) => s > c.length ? c : [
        ...c.slice(0, s),
        d
      ]);
    },
    closeSubmenu: (d, s) => {
      l((c) => c[s] === d ? c.slice(0, s) : c);
    }
  };
}
function o7(e, t) {
  let { triggerKey: n } = e, { expandedKeysStack: r, openSubmenu: a, closeSubmenu: l, close: i } = t, [u] = Y(r?.length), o = K(() => r[u] === n, [
    r,
    n,
    u
  ]), [d, s] = Y(null), c = X((m) => {
    s(m ?? null), a(n, u);
  }, [
    a,
    u,
    n
  ]), f = X(() => {
    s(null), l(n, u);
  }, [
    l,
    u,
    n
  ]), h = X((m) => {
    s(m ?? null), o ? f() : c(m);
  }, [
    f,
    c,
    o
  ]);
  return K(() => ({
    focusStrategy: d,
    isOpen: o,
    open: c,
    close: f,
    closeAll: i,
    submenuLevel: u,
    // TODO: Placeholders that aren't used but give us parity with OverlayTriggerState so we can use this in Popover. Refactor if we update Popover via
    // https://github.com/adobe/react-spectrum/pull/4976#discussion_r1336472863
    setOpen: () => {
    },
    toggle: h
  }), [
    o,
    c,
    f,
    i,
    d,
    h,
    u
  ]);
}
class s7 {
  constructor(t, { expandedKeys: n } = {}) {
    this.keyMap = /* @__PURE__ */ new Map(), this.firstKey = null, this.lastKey = null, this.iterable = t, n = n || /* @__PURE__ */ new Set();
    let r = (i) => {
      if (this.keyMap.set(i.key, i), i.childNodes && (i.type === "section" || n.has(i.key))) for (let u of i.childNodes) r(u);
    };
    for (let i of t) r(i);
    let a = null, l = 0;
    for (let [i, u] of this.keyMap)
      a ? (a.nextKey = i, u.prevKey = a.key) : (this.firstKey = i, u.prevKey = void 0), u.type === "item" && (u.index = l++), a = u, a.nextKey = void 0;
    this.lastKey = a?.key ?? null;
  }
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
}
function d7(e) {
  let { onExpandedChange: t } = e, [n, r] = Pe(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), t), a = $a(e), l = K(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), i = ro(e, X((o) => new s7(o, {
    expandedKeys: n
  }), [
    n
  ]), null);
  return ee(() => {
    a.focusedKey != null && !i.getItem(a.focusedKey) && a.setFocusedKey(null);
  }, [
    i,
    a.focusedKey
  ]), {
    collection: i,
    expandedKeys: n,
    disabledKeys: l,
    toggleKey: (o) => {
      r(c7(n, o));
    },
    setExpandedKeys: r,
    selectionManager: new kr(i, a)
  };
}
function c7(e, t) {
  let n = new Set(e);
  return n.has(t) ? n.delete(t) : n.add(t), n;
}
const uo = /* @__PURE__ */ G(null), Al = /* @__PURE__ */ G(null), da = /* @__PURE__ */ G(null), cl = /* @__PURE__ */ G(null);
function g9(e) {
  let t = io(e), n = T(null), { menuTriggerProps: r, menuProps: a } = Dg({
    ...e,
    type: "menu"
  }, t, n), l = T(null);
  return _c() ? null : /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        uo,
        {
          ...a,
          ref: l
        }
      ],
      [
        Vt,
        t
      ],
      [
        da,
        t
      ],
      [
        Fr,
        {
          trigger: "MenuTrigger",
          triggerRef: n,
          scrollRef: l,
          placement: "bottom start",
          "aria-labelledby": a["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Mb, {
    ...r,
    ref: n,
    isPressed: t.isOpen
  }, e.children));
}
const Eg = /* @__PURE__ */ G(null), Fo = class Fo extends st {
  filter(t, n, r) {
    let a = t.getItem(this.firstChildKey);
    if (a && r(a.textValue, this)) {
      let l = this.clone();
      return n.addDescendants(l, t), l;
    }
    return null;
  }
};
Fo.type = "submenutrigger";
let tu = Fo;
const y9 = /* @__PURE__ */ fa(tu, (e, t, n) => {
  let { CollectionBranch: r } = O(ge), a = O(Al), l = O(da), i = o7({
    triggerKey: n.key
  }, l), u = T(null), o = $e(t), { parentMenuRef: d, shouldUseVirtualFocus: s } = O(Eg), { submenuTriggerProps: c, submenuProps: f, popoverProps: h } = u7({
    parentMenuRef: d,
    submenuRef: u,
    delay: e.delay,
    shouldUseVirtualFocus: s
  }, i, o);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        yr,
        {
          ...c,
          onAction: void 0,
          ref: o
        }
      ],
      [
        uo,
        {
          ref: u,
          ...f
        }
      ],
      [
        Vt,
        i
      ],
      [
        Fr,
        {
          trigger: "SubmenuTrigger",
          triggerRef: o,
          placement: "end top",
          "aria-labelledby": f["aria-labelledby"],
          ...h
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(r, {
    collection: a.collection,
    parent: n
  }), e.children[1]);
}, (e) => e.children[0]), $9 = /* @__PURE__ */ te(function(t, n) {
  return [t, n] = oe(t, n, uo), /* @__PURE__ */ g.createElement(Hn, {
    content: /* @__PURE__ */ g.createElement(Jt, t)
  }, (r) => /* @__PURE__ */ g.createElement(f7, {
    props: t,
    collection: r,
    menuRef: n
  }));
});
function f7({ props: e, collection: t, menuRef: n }) {
  [e, n] = oe(e, n, Nn);
  let { filter: r, ...a } = e, l = K(() => r ? t.filter(r) : t, [
    t,
    r
  ]), i = d7({
    ...e,
    collection: l,
    children: void 0
  }), u = O(da), { isVirtualized: o, CollectionRoot: d } = O(ge), { menuProps: s } = t7({
    ...e,
    isVirtualized: o,
    onClose: e.onClose || u?.close
  }, i, n), c = le({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-Menu",
    values: {
      isEmpty: i.collection.size === 0
    }
  }), f = null;
  i.collection.size === 0 && e.renderEmptyState && (f = /* @__PURE__ */ g.createElement("div", {
    role: "menuitem",
    style: {
      display: "contents"
    }
  }, e.renderEmptyState()));
  let h = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Sl, null, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(h, c, s),
    ref: n,
    slot: e.slot || void 0,
    "data-empty": i.collection.size === 0 || void 0,
    onScroll: e.onScroll
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Al,
        i
      ],
      [
        Ju,
        {
          elementType: "div"
        }
      ],
      [
        Yc,
        {
          name: "MenuSection",
          render: Cg
        }
      ],
      [
        Eg,
        {
          parentMenuRef: n,
          shouldUseVirtualFocus: a?.shouldUseVirtualFocus
        }
      ],
      [
        yr,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect
        }
      ],
      [
        Nn,
        null
      ],
      [
        ca,
        null
      ],
      [
        cl,
        i.selectionManager
      ],
      /* Ensure root MenuTriggerState is defined, in case Menu is rendered outside a MenuTrigger. */
      /* We assume the context can never change between defined and undefined. */
      /* eslint-disable-next-line react-hooks/rules-of-hooks */
      [
        da,
        u ?? io({})
      ]
    ]
  }, /* @__PURE__ */ g.createElement(jn, null, /* @__PURE__ */ g.createElement(d, {
    collection: i.collection,
    persistedKeys: Eu(i.selectionManager.focusedKey),
    scrollRef: n
  }))), f));
}
class h7 extends kr {
  constructor(t, n) {
    super(t.collection, n), this.parent = t;
  }
  get focusedKey() {
    return this.parent.focusedKey;
  }
  get isFocused() {
    return this.parent.isFocused;
  }
  setFocusedKey(t, n) {
    return this.parent.setFocusedKey(t, n);
  }
  setFocused(t) {
    this.parent.setFocused(t);
  }
  get childFocusStrategy() {
    return this.parent.childFocusStrategy;
  }
}
function Cg(e, t, n, r = "react-aria-MenuSection") {
  let a = O(Al), { CollectionBranch: l } = O(ge), [i, u] = Je(), { headingProps: o, groupProps: d } = r7({
    heading: u,
    "aria-label": n.props["aria-label"] ?? void 0
  }), s = le({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: r,
    className: n.props?.className,
    style: n.props?.style,
    values: void 0
  }), c = O(cl), f = $a(e), h = e.selectionMode != null ? new h7(c, f) : c, m = Oe(yr)?.shouldCloseOnSelect, p = J(e, {
    global: !0
  });
  return delete p.id, /* @__PURE__ */ g.createElement(Q.section, {
    ...z(p, s, d),
    ref: t
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Xu,
        {
          ...o,
          ref: i
        }
      ],
      [
        cl,
        h
      ],
      [
        yr,
        {
          shouldCloseOnSelect: e.shouldCloseOnSelect ?? m
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(l, {
    collection: a.collection,
    parent: n
  })));
}
const v9 = /* @__PURE__ */ fa(Ei, Cg), yr = /* @__PURE__ */ G(null), D9 = /* @__PURE__ */ Ct(Yr, function(t, n, r) {
  [t, n] = oe(t, n, yr);
  let a = Oe(yr)?.id, l = O(Al), i = $e(n), u = O(cl), { isVirtualized: o } = O(ge), { menuItemProps: d, labelProps: s, descriptionProps: c, keyboardShortcutProps: f, ...h } = n7({
    ...t,
    id: a,
    key: r.key,
    selectionManager: u,
    isVirtualized: o
  }, l, i), { hoverProps: m, isHovered: p } = ve({
    isDisabled: h.isDisabled
  }), b = le({
    ...t,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-MenuItem",
    values: {
      ...h,
      isHovered: p,
      isFocusVisible: h.isFocusVisible,
      selectionMode: u.selectionMode,
      selectionBehavior: u.selectionBehavior,
      hasSubmenu: !!t["aria-haspopup"],
      isOpen: t["aria-expanded"] === "true"
    }
  }), y = t.href ? Q.a : Q.div, $ = J(t, {
    global: !0
  });
  return delete $.id, delete $.onClick, /* @__PURE__ */ g.createElement(y, {
    ...z($, b, d, m),
    ref: i,
    "data-disabled": h.isDisabled || void 0,
    "data-hovered": p || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": h.isFocusVisible || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-selected": h.isSelected || void 0,
    "data-selection-mode": u.selectionMode === "none" ? void 0 : u.selectionMode,
    "data-has-submenu": !!t["aria-haspopup"] || void 0,
    "data-open": t["aria-expanded"] === "true" || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        _e,
        {
          slots: {
            [gt]: s,
            label: s,
            description: c
          }
        }
      ],
      [
        Qx,
        f
      ],
      [
        _n,
        {
          isSelected: h.isSelected
        }
      ]
    ]
  }, b.children));
});
function m7(e, t) {
  let { role: n = "dialog" } = e, r = bt();
  r = e["aria-label"] ? void 0 : r;
  let a = T(!1);
  ee(() => {
    if (t.current && !qt(t.current)) {
      we(t.current);
      let i = setTimeout(() => {
        (se() === t.current || se() === document.body) && (a.current = !0, t.current && (t.current.blur(), we(t.current)), a.current = !1);
      }, 500);
      return () => {
        clearTimeout(i);
      };
    }
  }, [
    t
  ]), Nb();
  let l = T(!1);
  return ee(() => {
    if (process.env.NODE_ENV !== "production" && !l.current && t.current) {
      let i = t.current, u = i.hasAttribute("aria-label"), o = i.hasAttribute("aria-labelledby");
      !u && !o && (console.warn("A dialog must have a title for accessibility. Either provide an aria-label or aria-labelledby prop, or render a heading element inside the dialog."), l.current = !0);
    }
  }), {
    dialogProps: {
      ...J(e, {
        labelable: !0
      }),
      role: n,
      tabIndex: -1,
      "aria-labelledby": e["aria-labelledby"] || r,
      // Prevent blur events from reaching useOverlay, which may cause
      // popovers to close. Since focus is contained within the dialog,
      // we don't want this to occur due to the above useEffect.
      onBlur: (i) => {
        a.current && i.stopPropagation();
      }
    },
    titleProps: {
      id: r
    }
  };
}
const oo = /* @__PURE__ */ G(null), Vt = /* @__PURE__ */ G(null);
function x9(e) {
  let t = io(e), n = T(null), { triggerProps: r, overlayProps: a } = vg({
    type: "dialog"
  }, t, n);
  return r.id = ce(), a["aria-labelledby"] = r.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Vt,
        t
      ],
      [
        da,
        t
      ],
      [
        oo,
        a
      ],
      [
        Fr,
        {
          trigger: "DialogTrigger",
          triggerRef: n,
          "aria-labelledby": a["aria-labelledby"]
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Mb, {
    ...r,
    ref: n,
    isPressed: t.isOpen
  }, e.children));
}
const E9 = /* @__PURE__ */ te(function(t, n) {
  let r = t["aria-labelledby"];
  [t, n] = oe(t, n, oo);
  let { dialogProps: a, titleProps: l } = m7({
    ...t,
    // Only pass aria-labelledby from props, not context.
    // Context is used as a fallback below.
    "aria-labelledby": r
  }, n), i = O(Vt);
  !a["aria-label"] && !a["aria-labelledby"] && (t["aria-labelledby"] ? a["aria-labelledby"] = t["aria-labelledby"] : process.env.NODE_ENV !== "production" && console.warn('If a Dialog does not contain a <Heading slot="title">, it must have an aria-label or aria-labelledby attribute for accessibility.'));
  let u = le({
    defaultClassName: "react-aria-Dialog",
    className: t.className,
    style: t.style,
    children: t.children,
    values: {
      close: i?.close || (() => {
      })
    }
  }), o = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.section, {
    ...z(o, u, a),
    render: t.render,
    ref: n,
    slot: t.slot || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        wu,
        {
          slots: {
            [gt]: {},
            title: {
              ...l,
              level: 2
            }
          }
        }
      ],
      [
        Ze,
        {
          slots: {
            [gt]: {},
            close: {
              onPress: () => i?.close()
            }
          }
        }
      ]
    ]
  }, u.children));
});
function p7(e) {
  let t = wr({
    usage: "search",
    ...e
  }), n = X((l, i) => i.length === 0 ? !0 : (l = l.normalize("NFC"), i = i.normalize("NFC"), t.compare(l.slice(0, i.length), i) === 0), [
    t
  ]), r = X((l, i) => i.length === 0 ? !0 : (l = l.normalize("NFC"), i = i.normalize("NFC"), t.compare(l.slice(-i.length), i) === 0), [
    t
  ]), a = X((l, i) => {
    if (i.length === 0) return !0;
    l = l.normalize("NFC"), i = i.normalize("NFC");
    let u = 0, o = i.length;
    for (; u + o <= l.length; u++) {
      let d = l.slice(u, u + o);
      if (t.compare(i, d) === 0) return !0;
    }
    return !1;
  }, [
    t
  ]);
  return K(() => ({
    startsWith: n,
    endsWith: r,
    contains: a
  }), [
    n,
    r,
    a
  ]);
}
const b7 = [
  "day",
  "month",
  "year"
], g7 = {
  hour: 1,
  minute: 2,
  second: 3
};
function y7(e, t) {
  let { autoComplete: n, isDisabled: r, name: a } = e, { visuallyHiddenProps: l } = tn({
    style: {
      // Prevent page scrolling.
      position: "fixed",
      top: 0,
      left: 0
    }
  }), i = 60;
  t.granularity === "second" ? i = 1 : t.granularity === "hour" && (i = 3600);
  let u = "";
  t.value && (t.granularity === "day" ? u = lt(t.value).toString() : u = Zt("timeZone" in t.value ? G2(t.value) : t.value).toString());
  let o = t.granularity === "day" ? "date" : "datetime-local", d = [
    "hour",
    "minute",
    "second"
  ], s = 0;
  return d.includes(t.granularity) && (s = g7[t.granularity], d = d.slice(0, s)), {
    containerProps: {
      ...l,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      tabIndex: -1,
      autoComplete: n,
      disabled: r,
      type: o,
      // We set the form prop to an empty string to prevent the hidden date input's value from being submitted
      form: "",
      name: a,
      step: i,
      value: u,
      onChange: (c) => {
        let f = W(c).value.toString();
        if (f) try {
          let h = r6(f);
          if (t.granularity === "day" && (h = n6(f)), "setSegment" in t) for (let m in h)
            b7.includes(m) && t.setSegment(m, h[m]), d.includes(m) && t.setSegment(m, h[m]);
          t.setValue(h);
        } catch {
        }
      }
    }
  };
}
function $7(e) {
  let { state: t } = e, { containerProps: n, inputProps: r } = y7({
    ...e
  }, t);
  return /* @__PURE__ */ g.createElement("div", {
    ...n,
    "data-testid": "hidden-dateinput-container"
  }, /* @__PURE__ */ g.createElement("input", r));
}
var Pg = {};
Pg = {
  calendar: "التقويم",
  day: "يوم",
  dayPeriod: "ص/م",
  endDate: "تاريخ الانتهاء",
  era: "العصر",
  hour: "الساعات",
  minute: "الدقائق",
  month: "الشهر",
  second: "الثواني",
  selectedDateDescription: (e) => `تاريخ محدد: ${e.date}`,
  selectedRangeDescription: (e) => `المدى الزمني المحدد: ${e.startDate} إلى ${e.endDate}`,
  selectedTimeDescription: (e) => `الوقت المحدد: ${e.time}`,
  startDate: "تاريخ البدء",
  timeZoneName: "التوقيت",
  weekday: "اليوم",
  year: "السنة"
};
var wg = {};
wg = {
  calendar: "Календар",
  day: "ден",
  dayPeriod: "пр.об./сл.об.",
  endDate: "Крайна дата",
  era: "ера",
  hour: "час",
  minute: "минута",
  month: "месец",
  second: "секунда",
  selectedDateDescription: (e) => `Избрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Избран диапазон: ${e.startDate} до ${e.endDate}`,
  selectedTimeDescription: (e) => `Избрано време: ${e.time}`,
  startDate: "Начална дата",
  timeZoneName: "часова зона",
  weekday: "ден от седмицата",
  year: "година"
};
var Sg = {};
Sg = {
  calendar: "Kalendář",
  day: "den",
  dayPeriod: "část dne",
  endDate: "Konečné datum",
  era: "letopočet",
  hour: "hodina",
  minute: "minuta",
  month: "měsíc",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybrané datum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybrané období: ${e.startDate} až ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybraný čas: ${e.time}`,
  startDate: "Počáteční datum",
  timeZoneName: "časové pásmo",
  weekday: "den v týdnu",
  year: "rok"
};
var kg = {};
kg = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "AM/PM",
  endDate: "Slutdato",
  era: "æra",
  hour: "time",
  minute: "minut",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt interval: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tidspunkt: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidszone",
  weekday: "ugedag",
  year: "år"
};
var Bg = {};
Bg = {
  calendar: "Kalender",
  day: "Tag",
  dayPeriod: "Tageshälfte",
  endDate: "Enddatum",
  era: "Epoche",
  hour: "Stunde",
  minute: "Minute",
  month: "Monat",
  second: "Sekunde",
  selectedDateDescription: (e) => `Ausgewähltes Datum: ${e.date}`,
  selectedRangeDescription: (e) => `Ausgewählter Bereich: ${e.startDate} bis ${e.endDate}`,
  selectedTimeDescription: (e) => `Ausgewählte Zeit: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "Zeitzone",
  weekday: "Wochentag",
  year: "Jahr"
};
var Fg = {};
Fg = {
  calendar: "Ημερολόγιο",
  day: "ημέρα",
  dayPeriod: "π.μ./μ.μ.",
  endDate: "Ημερομηνία λήξης",
  era: "περίοδος",
  hour: "ώρα",
  minute: "λεπτό",
  month: "μήνας",
  second: "δευτερόλεπτο",
  selectedDateDescription: (e) => `Επιλεγμένη ημερομηνία: ${e.date}`,
  selectedRangeDescription: (e) => `Επιλεγμένο εύρος: ${e.startDate} έως ${e.endDate}`,
  selectedTimeDescription: (e) => `Επιλεγμένη ώρα: ${e.time}`,
  startDate: "Ημερομηνία έναρξης",
  timeZoneName: "ζώνη ώρας",
  weekday: "καθημερινή",
  year: "έτος"
};
var Ag = {};
Ag = {
  era: "era",
  year: "year",
  month: "month",
  day: "day",
  hour: "hour",
  minute: "minute",
  second: "second",
  dayPeriod: "AM/PM",
  calendar: "Calendar",
  startDate: "Start Date",
  endDate: "End Date",
  weekday: "day of the week",
  timeZoneName: "time zone",
  selectedDateDescription: (e) => `Selected Date: ${e.date}`,
  selectedRangeDescription: (e) => `Selected Range: ${e.startDate} to ${e.endDate}`,
  selectedTimeDescription: (e) => `Selected Time: ${e.time}`
};
var Rg = {};
Rg = {
  calendar: "Calendario",
  day: "día",
  dayPeriod: "a. m./p. m.",
  endDate: "Fecha final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mes",
  second: "segundo",
  selectedDateDescription: (e) => `Fecha seleccionada: ${e.date}`,
  selectedRangeDescription: (e) => `Rango seleccionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora seleccionada: ${e.time}`,
  startDate: "Fecha de inicio",
  timeZoneName: "zona horaria",
  weekday: "día de la semana",
  year: "año"
};
var Tg = {};
Tg = {
  calendar: "Kalender",
  day: "päev",
  dayPeriod: "enne/pärast lõunat",
  endDate: "Lõppkuupäev",
  era: "ajastu",
  hour: "tund",
  minute: "minut",
  month: "kuu",
  second: "sekund",
  selectedDateDescription: (e) => `Valitud kuupäev: ${e.date}`,
  selectedRangeDescription: (e) => `Valitud vahemik: ${e.startDate} kuni ${e.endDate}`,
  selectedTimeDescription: (e) => `Valitud aeg: ${e.time}`,
  startDate: "Alguskuupäev",
  timeZoneName: "ajavöönd",
  weekday: "nädalapäev",
  year: "aasta"
};
var Ig = {};
Ig = {
  calendar: "Kalenteri",
  day: "päivä",
  dayPeriod: "vuorokaudenaika",
  endDate: "Päättymispäivä",
  era: "aikakausi",
  hour: "tunti",
  minute: "minuutti",
  month: "kuukausi",
  second: "sekunti",
  selectedDateDescription: (e) => `Valittu päivämäärä: ${e.date}`,
  selectedRangeDescription: (e) => `Valittu aikaväli: ${e.startDate} – ${e.endDate}`,
  selectedTimeDescription: (e) => `Valittu aika: ${e.time}`,
  startDate: "Alkamispäivä",
  timeZoneName: "aikavyöhyke",
  weekday: "viikonpäivä",
  year: "vuosi"
};
var Mg = {};
Mg = {
  calendar: "Calendrier",
  day: "jour",
  dayPeriod: "cadran",
  endDate: "Date de fin",
  era: "ère",
  hour: "heure",
  minute: "minute",
  month: "mois",
  second: "seconde",
  selectedDateDescription: (e) => `Date sélectionnée : ${e.date}`,
  selectedRangeDescription: (e) => `Plage sélectionnée : ${e.startDate} au ${e.endDate}`,
  selectedTimeDescription: (e) => `Heure choisie : ${e.time}`,
  startDate: "Date de début",
  timeZoneName: "fuseau horaire",
  weekday: "jour de la semaine",
  year: "année"
};
var Kg = {};
Kg = {
  calendar: "לוח שנה",
  day: "יום",
  dayPeriod: "לפנה״צ/אחה״צ",
  endDate: "תאריך סיום",
  era: "תקופה",
  hour: "שעה",
  minute: "דקה",
  month: "חודש",
  second: "שנייה",
  selectedDateDescription: (e) => `תאריך נבחר: ${e.date}`,
  selectedRangeDescription: (e) => `טווח נבחר: ${e.startDate} עד ${e.endDate}`,
  selectedTimeDescription: (e) => `זמן נבחר: ${e.time}`,
  startDate: "תאריך התחלה",
  timeZoneName: "אזור זמן",
  weekday: "יום בשבוע",
  year: "שנה"
};
var Ng = {};
Ng = {
  calendar: "Kalendar",
  day: "dan",
  dayPeriod: "AM/PM",
  endDate: "Datum završetka",
  era: "era",
  hour: "sat",
  minute: "minuta",
  month: "mjesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Odabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Odabrani raspon: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Odabrano vrijeme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "vremenska zona",
  weekday: "dan u tjednu",
  year: "godina"
};
var Vg = {};
Vg = {
  calendar: "Naptár",
  day: "nap",
  dayPeriod: "napszak",
  endDate: "Befejező dátum",
  era: "éra",
  hour: "óra",
  minute: "perc",
  month: "hónap",
  second: "másodperc",
  selectedDateDescription: (e) => `Kijelölt dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Kijelölt tartomány: ${e.startDate}–${e.endDate}`,
  selectedTimeDescription: (e) => `Kijelölt idő: ${e.time}`,
  startDate: "Kezdő dátum",
  timeZoneName: "időzóna",
  weekday: "hét napja",
  year: "év"
};
var Lg = {};
Lg = {
  calendar: "Calendario",
  day: "giorno",
  dayPeriod: "AM/PM",
  endDate: "Data finale",
  era: "era",
  hour: "ora",
  minute: "minuto",
  month: "mese",
  second: "secondo",
  selectedDateDescription: (e) => `Data selezionata: ${e.date}`,
  selectedRangeDescription: (e) => `Intervallo selezionato: da ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selezionata: ${e.time}`,
  startDate: "Data iniziale",
  timeZoneName: "fuso orario",
  weekday: "giorno della settimana",
  year: "anno"
};
var zg = {};
zg = {
  calendar: "カレンダー",
  day: "日",
  dayPeriod: "午前/午後",
  endDate: "終了日",
  era: "時代",
  hour: "時",
  minute: "分",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選択した日付 : ${e.date}`,
  selectedRangeDescription: (e) => `選択範囲 : ${e.startDate} から ${e.endDate}`,
  selectedTimeDescription: (e) => `選択した時間 : ${e.time}`,
  startDate: "開始日",
  timeZoneName: "タイムゾーン",
  weekday: "曜日",
  year: "年"
};
var Og = {};
Og = {
  calendar: "달력",
  day: "일",
  dayPeriod: "오전/오후",
  endDate: "종료일",
  era: "연호",
  hour: "시",
  minute: "분",
  month: "월",
  second: "초",
  selectedDateDescription: (e) => `선택 일자: ${e.date}`,
  selectedRangeDescription: (e) => `선택 범위: ${e.startDate} ~ ${e.endDate}`,
  selectedTimeDescription: (e) => `선택 시간: ${e.time}`,
  startDate: "시작일",
  timeZoneName: "시간대",
  weekday: "요일",
  year: "년"
};
var Hg = {};
Hg = {
  calendar: "Kalendorius",
  day: "diena",
  dayPeriod: "iki pietų / po pietų",
  endDate: "Pabaigos data",
  era: "era",
  hour: "valanda",
  minute: "minutė",
  month: "mėnuo",
  second: "sekundė",
  selectedDateDescription: (e) => `Pasirinkta data: ${e.date}`,
  selectedRangeDescription: (e) => `Pasirinktas intervalas: nuo ${e.startDate} iki ${e.endDate}`,
  selectedTimeDescription: (e) => `Pasirinktas laikas: ${e.time}`,
  startDate: "Pradžios data",
  timeZoneName: "laiko juosta",
  weekday: "savaitės diena",
  year: "metai"
};
var Ug = {};
Ug = {
  calendar: "Kalendārs",
  day: "diena",
  dayPeriod: "priekšpusdienā/pēcpusdienā",
  endDate: "Beigu datums",
  era: "ēra",
  hour: "stundas",
  minute: "minūtes",
  month: "mēnesis",
  second: "sekundes",
  selectedDateDescription: (e) => `Atlasītais datums: ${e.date}`,
  selectedRangeDescription: (e) => `Atlasītais diapazons: no ${e.startDate} līdz ${e.endDate}`,
  selectedTimeDescription: (e) => `Atlasītais laiks: ${e.time}`,
  startDate: "Sākuma datums",
  timeZoneName: "laika josla",
  weekday: "nedēļas diena",
  year: "gads"
};
var jg = {};
jg = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Sluttdato",
  era: "tidsalder",
  hour: "time",
  minute: "minutt",
  month: "måned",
  second: "sekund",
  selectedDateDescription: (e) => `Valgt dato: ${e.date}`,
  selectedRangeDescription: (e) => `Valgt område: ${e.startDate} til ${e.endDate}`,
  selectedTimeDescription: (e) => `Valgt tid: ${e.time}`,
  startDate: "Startdato",
  timeZoneName: "tidssone",
  weekday: "ukedag",
  year: "år"
};
var _g = {};
_g = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "a.m./p.m.",
  endDate: "Einddatum",
  era: "tijdperk",
  hour: "uur",
  minute: "minuut",
  month: "maand",
  second: "seconde",
  selectedDateDescription: (e) => `Geselecteerde datum: ${e.date}`,
  selectedRangeDescription: (e) => `Geselecteerd bereik: ${e.startDate} tot ${e.endDate}`,
  selectedTimeDescription: (e) => `Geselecteerde tijd: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tijdzone",
  weekday: "dag van de week",
  year: "jaar"
};
var Wg = {};
Wg = {
  calendar: "Kalendarz",
  day: "dzień",
  dayPeriod: "rano / po południu / wieczorem",
  endDate: "Data końcowa",
  era: "era",
  hour: "godzina",
  minute: "minuta",
  month: "miesiąc",
  second: "sekunda",
  selectedDateDescription: (e) => `Wybrana data: ${e.date}`,
  selectedRangeDescription: (e) => `Wybrany zakres: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Wybrany czas: ${e.time}`,
  startDate: "Data początkowa",
  timeZoneName: "strefa czasowa",
  weekday: "dzień tygodnia",
  year: "rok"
};
var Gg = {};
Gg = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "AM/PM",
  endDate: "Data final",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data inicial",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var qg = {};
qg = {
  calendar: "Calendário",
  day: "dia",
  dayPeriod: "am/pm",
  endDate: "Data de Término",
  era: "era",
  hour: "hora",
  minute: "minuto",
  month: "mês",
  second: "segundo",
  selectedDateDescription: (e) => `Data selecionada: ${e.date}`,
  selectedRangeDescription: (e) => `Intervalo selecionado: ${e.startDate} a ${e.endDate}`,
  selectedTimeDescription: (e) => `Hora selecionada: ${e.time}`,
  startDate: "Data de Início",
  timeZoneName: "fuso horário",
  weekday: "dia da semana",
  year: "ano"
};
var Yg = {};
Yg = {
  calendar: "Calendar",
  day: "zi",
  dayPeriod: "a.m/p.m.",
  endDate: "Dată final",
  era: "eră",
  hour: "oră",
  minute: "minut",
  month: "lună",
  second: "secundă",
  selectedDateDescription: (e) => `Dată selectată: ${e.date}`,
  selectedRangeDescription: (e) => `Interval selectat: de la ${e.startDate} până la ${e.endDate}`,
  selectedTimeDescription: (e) => `Ora selectată: ${e.time}`,
  startDate: "Dată început",
  timeZoneName: "fus orar",
  weekday: "ziua din săptămână",
  year: "an"
};
var Zg = {};
Zg = {
  calendar: "Календарь",
  day: "день",
  dayPeriod: "AM/PM",
  endDate: "Дата окончания",
  era: "эра",
  hour: "час",
  minute: "минута",
  month: "месяц",
  second: "секунда",
  selectedDateDescription: (e) => `Выбранная дата: ${e.date}`,
  selectedRangeDescription: (e) => `Выбранный диапазон: с ${e.startDate} по ${e.endDate}`,
  selectedTimeDescription: (e) => `Выбранное время: ${e.time}`,
  startDate: "Дата начала",
  timeZoneName: "часовой пояс",
  weekday: "день недели",
  year: "год"
};
var Xg = {};
Xg = {
  calendar: "Kalendár",
  day: "deň",
  dayPeriod: "AM/PM",
  endDate: "Dátum ukončenia",
  era: "letopočet",
  hour: "hodina",
  minute: "minúta",
  month: "mesiac",
  second: "sekunda",
  selectedDateDescription: (e) => `Vybratý dátum: ${e.date}`,
  selectedRangeDescription: (e) => `Vybratý rozsah: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Vybratý čas: ${e.time}`,
  startDate: "Dátum začatia",
  timeZoneName: "časové pásmo",
  weekday: "deň týždňa",
  year: "rok"
};
var Jg = {};
Jg = {
  calendar: "Koledar",
  day: "dan",
  dayPeriod: "dop/pop",
  endDate: "Datum konca",
  era: "doba",
  hour: "ura",
  minute: "minuta",
  month: "mesec",
  second: "sekunda",
  selectedDateDescription: (e) => `Izbrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izbrano območje: ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izbrani čas: ${e.time}`,
  startDate: "Datum začetka",
  timeZoneName: "časovni pas",
  weekday: "dan v tednu",
  year: "leto"
};
var Qg = {};
Qg = {
  calendar: "Kalendar",
  day: "дан",
  dayPeriod: "пре подне/по подне",
  endDate: "Datum završetka",
  era: "ера",
  hour: "сат",
  minute: "минут",
  month: "месец",
  second: "секунд",
  selectedDateDescription: (e) => `Izabrani datum: ${e.date}`,
  selectedRangeDescription: (e) => `Izabrani opseg: od ${e.startDate} do ${e.endDate}`,
  selectedTimeDescription: (e) => `Izabrano vreme: ${e.time}`,
  startDate: "Datum početka",
  timeZoneName: "временска зона",
  weekday: "дан у недељи",
  year: "година"
};
var e0 = {};
e0 = {
  calendar: "Kalender",
  day: "dag",
  dayPeriod: "fm/em",
  endDate: "Slutdatum",
  era: "era",
  hour: "timme",
  minute: "minut",
  month: "månad",
  second: "sekund",
  selectedDateDescription: (e) => `Valt datum: ${e.date}`,
  selectedRangeDescription: (e) => `Valt intervall: ${e.startDate} till ${e.endDate}`,
  selectedTimeDescription: (e) => `Vald tid: ${e.time}`,
  startDate: "Startdatum",
  timeZoneName: "tidszon",
  weekday: "veckodag",
  year: "år"
};
var t0 = {};
t0 = {
  calendar: "Takvim",
  day: "gün",
  dayPeriod: "ÖÖ/ÖS",
  endDate: "Bitiş Tarihi",
  era: "çağ",
  hour: "saat",
  minute: "dakika",
  month: "ay",
  second: "saniye",
  selectedDateDescription: (e) => `Seçilen Tarih: ${e.date}`,
  selectedRangeDescription: (e) => `Seçilen Aralık: ${e.startDate} - ${e.endDate}`,
  selectedTimeDescription: (e) => `Seçilen Zaman: ${e.time}`,
  startDate: "Başlangıç Tarihi",
  timeZoneName: "saat dilimi",
  weekday: "haftanın günü",
  year: "yıl"
};
var n0 = {};
n0 = {
  calendar: "Календар",
  day: "день",
  dayPeriod: "дп/пп",
  endDate: "Дата завершення",
  era: "ера",
  hour: "година",
  minute: "хвилина",
  month: "місяць",
  second: "секунда",
  selectedDateDescription: (e) => `Вибрана дата: ${e.date}`,
  selectedRangeDescription: (e) => `Вибраний діапазон: ${e.startDate} — ${e.endDate}`,
  selectedTimeDescription: (e) => `Вибраний час: ${e.time}`,
  startDate: "Дата початку",
  timeZoneName: "часовий пояс",
  weekday: "день тижня",
  year: "рік"
};
var r0 = {};
r0 = {
  calendar: "日历",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "结束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `选定的日期：${e.date}`,
  selectedRangeDescription: (e) => `选定的范围：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `选定的时间：${e.time}`,
  startDate: "开始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var a0 = {};
a0 = {
  calendar: "日曆",
  day: "日",
  dayPeriod: "上午/下午",
  endDate: "結束日期",
  era: "纪元",
  hour: "小时",
  minute: "分钟",
  month: "月",
  second: "秒",
  selectedDateDescription: (e) => `選定的日期：${e.date}`,
  selectedRangeDescription: (e) => `選定的範圍：${e.startDate} 至 ${e.endDate}`,
  selectedTimeDescription: (e) => `選定的時間：${e.time}`,
  startDate: "開始日期",
  timeZoneName: "时区",
  weekday: "工作日",
  year: "年"
};
var Rl = {};
Rl = {
  "ar-AE": Pg,
  "bg-BG": wg,
  "cs-CZ": Sg,
  "da-DK": kg,
  "de-DE": Bg,
  "el-GR": Fg,
  "en-US": Ag,
  "es-ES": Rg,
  "et-EE": Tg,
  "fi-FI": Ig,
  "fr-FR": Mg,
  "he-IL": Kg,
  "hr-HR": Ng,
  "hu-HU": Vg,
  "it-IT": Lg,
  "ja-JP": zg,
  "ko-KR": Og,
  "lt-LT": Hg,
  "lv-LV": Ug,
  "nb-NO": jg,
  "nl-NL": _g,
  "pl-PL": Wg,
  "pt-BR": Gg,
  "pt-PT": qg,
  "ro-RO": Yg,
  "ru-RU": Zg,
  "sk-SK": Xg,
  "sl-SI": Jg,
  "sr-SP": Qg,
  "sv-SE": e0,
  "tr-TR": t0,
  "uk-UA": n0,
  "zh-CN": r0,
  "zh-TW": a0
};
function l0(e, t, n) {
  let { direction: r } = de(), a = K(() => kl(t), [
    t
  ]), l = (o) => {
    if (ae(o.currentTarget, W(o)) && (o.altKey && (o.key === "ArrowDown" || o.key === "ArrowUp") && "setOpen" in e && (o.preventDefault(), o.stopPropagation(), e.setOpen(!0)), !n))
      switch (o.key) {
        case "ArrowLeft":
          if (o.preventDefault(), o.stopPropagation(), r === "rtl") {
            if (t.current) {
              let d = W(o), s = bd(t.current, d.getBoundingClientRect().left, -1);
              s && s.focus();
            }
          } else a.focusPrevious();
          break;
        case "ArrowRight":
          if (o.preventDefault(), o.stopPropagation(), r === "rtl") {
            if (t.current) {
              let d = W(o), s = bd(t.current, d.getBoundingClientRect().left, 1);
              s && s.focus();
            }
          } else a.focusNext();
          break;
      }
  }, i = () => {
    if (!t.current) return;
    let o = window.event ? W(window.event) : null, d = Te(t.current, {
      tabbable: !0
    });
    if (o && (d.currentNode = o, o = d.previousNode()), !o) {
      let s;
      do
        s = d.lastChild(), s && (o = s);
      while (s);
    }
    for (; o?.hasAttribute("data-placeholder"); ) {
      let s = d.previousNode();
      if (s && s.hasAttribute("data-placeholder")) o = s;
      else break;
    }
    o && o.focus();
  }, { pressProps: u } = Xe({
    preventFocusOnPress: !0,
    allowTextSelectionOnPress: !0,
    onPressStart(o) {
      o.pointerType === "mouse" && i();
    },
    onPress(o) {
      (o.pointerType === "touch" || o.pointerType === "pen") && i();
    }
  });
  return z(u, {
    onKeyDown: l
  });
}
function bd(e, t, n) {
  let r = Te(e, {
    tabbable: !0
  }), a = r.nextNode(), l = null, i = 1 / 0;
  for (; a; ) {
    let o = a.getBoundingClientRect().left - t, d = Math.abs(o);
    Math.sign(o) === n && d < i && (l = a, i = d), a = r.nextNode();
  }
  return l;
}
function v7(e) {
  return e && e.__esModule ? e.default : e;
}
const i0 = /* @__PURE__ */ new WeakMap(), Ha = "__reactAriaDateFieldRole", D7 = "__reactAriaDateFieldFocusManager";
function x7(e, t, n) {
  let { isInvalid: r, validationErrors: a, validationDetails: l } = t.displayValidation, { labelProps: i, fieldProps: u, descriptionProps: o, errorMessageProps: d } = Cr({
    ...e,
    labelElementType: "span",
    isInvalid: r,
    errorMessage: e.errorMessage || a
  }), s = T(null), { focusWithinProps: c } = ct({
    ...e,
    onFocusWithin(F) {
      s.current = t.value, e.onFocus?.(F);
    },
    onBlurWithin: (F) => {
      t.confirmPlaceholder(), t.value !== s.current && t.commitValidation(), e.onBlur?.(F);
    },
    onFocusWithinChange: e.onFocusChange
  }), f = xe(v7(Rl), "@react-aria/datepicker"), h = t.maxGranularity === "hour" ? "selectedTimeDescription" : "selectedDateDescription", m = t.maxGranularity === "hour" ? "time" : "date", p = t.value ? f.format(h, {
    [m]: t.formatValue({
      month: "long"
    })
  }) : "", b = en(p), y = e[Ha] === "presentation" ? u["aria-describedby"] : [
    b["aria-describedby"],
    u["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, $ = e[D7], v = K(() => $ || kl(n), [
    $,
    n
  ]), x = l0(t, n, e[Ha] === "presentation");
  i0.set(t, {
    ariaLabel: e["aria-label"],
    ariaLabelledBy: [
      i.id,
      e["aria-labelledby"]
    ].filter(Boolean).join(" ") || void 0,
    ariaDescribedBy: y,
    focusManager: v
  });
  let E = T(e.autoFocus), P;
  e[Ha] === "presentation" ? P = {
    role: "presentation"
  } : P = z(u, {
    role: "group",
    "aria-disabled": e.isDisabled || void 0,
    "aria-describedby": y
  }), ee(() => {
    E.current && v.focusFirst(), E.current = !1;
  }, [
    v
  ]), an(e.inputRef, t.defaultValue, t.setValue), ga({
    ...e,
    focus() {
      v.focusFirst();
    }
  }, t, e.inputRef);
  let C = {
    type: "hidden",
    name: e.name,
    form: e.form,
    value: t.value?.toString() || "",
    disabled: e.isDisabled
  };
  e.validationBehavior === "native" && (C.type = "text", C.hidden = !0, C.required = e.isRequired, C.onChange = () => {
  });
  let M = J(e);
  return {
    labelProps: {
      ...i,
      onClick: () => {
        v.focusFirst();
      }
    },
    fieldProps: z(M, P, x, c, {
      onKeyDown(F) {
        e.onKeyDown && e.onKeyDown(F);
      },
      onKeyUp(F) {
        e.onKeyUp && e.onKeyUp(F);
      },
      style: {
        unicodeBidi: "isolate"
      }
    }),
    inputProps: C,
    descriptionProps: o,
    errorMessageProps: d,
    isInvalid: r,
    validationErrors: a,
    validationDetails: l
  };
}
function E7(e) {
  return e && e.__esModule ? e.default : e;
}
function C7() {
  let { locale: e } = de(), t = zc(E7(Rl), "@react-aria/datepicker");
  return K(() => {
    try {
      return new Intl.DisplayNames(e, {
        type: "dateTimeField"
      });
    } catch {
      return new P7(e, t);
    }
  }, [
    e,
    t
  ]);
}
class P7 {
  constructor(t, n) {
    this.locale = t, this.dictionary = n;
  }
  of(t) {
    return this.dictionary.getStringForLocale(t, this.locale);
  }
}
function w7(e, t, n) {
  let r = T(""), { locale: a, direction: l } = de(), i = C7(), { ariaLabel: u, ariaLabelledBy: o, ariaDescribedBy: d, focusManager: s } = i0.get(t), c = e.isPlaceholder ? "" : e.text, f = K(() => t.dateFormatter.resolvedOptions(), [
    t.dateFormatter
  ]), h = Tt({
    month: "long",
    timeZone: f.timeZone
  }), m = Tt({
    hour: "numeric",
    hour12: f.hour12,
    timeZone: f.timeZone
  });
  if (e.type === "month" && !e.isPlaceholder) {
    let S = h.format(t.dateValue);
    c = S !== c ? `${c} – ${S}` : S;
  } else e.type === "hour" && !e.isPlaceholder && (c = m.format(t.dateValue));
  let { spinButtonProps: p } = _u({
    // The ARIA spec says aria-valuenow is optional if there's no value, but aXe seems to require it.
    // This doesn't seem to have any negative effects with real AT since we also use aria-valuetext.
    // https://github.com/dequelabs/axe-core/issues/3505
    value: e.value ?? void 0,
    textValue: c,
    minValue: e.minValue,
    maxValue: e.maxValue,
    isDisabled: t.isDisabled,
    isReadOnly: t.isReadOnly || !e.isEditable,
    isRequired: t.isRequired,
    onIncrement: () => {
      r.current = "", t.increment(e.type);
    },
    onDecrement: () => {
      r.current = "", t.decrement(e.type);
    },
    onIncrementPage: () => {
      r.current = "", t.incrementPage(e.type);
    },
    onDecrementPage: () => {
      r.current = "", t.decrementPage(e.type);
    },
    onIncrementToMax: () => {
      r.current = "", t.incrementToMax(e.type);
    },
    onDecrementToMin: () => {
      r.current = "", t.decrementToMin(e.type);
    }
  }), b = K(() => new Pu(a, {
    maximumFractionDigits: 0
  }), [
    a
  ]), y = () => {
    if (e.text === e.placeholder && s.focusPrevious(), b.isValidPartialNumber(e.text) && !t.isReadOnly && !e.isPlaceholder) {
      let S = e.text.slice(0, -1), j = b.parse(S);
      S = j === 0 ? "" : S, S.length === 0 || j === 0 ? t.clearSegment(e.type) : t.setSegment(e.type, j), r.current = S;
    } else (e.type === "dayPeriod" || e.type === "era") && t.clearSegment(e.type);
  }, $ = (S) => {
    if (S.key === "a" && (mn() ? S.metaKey : S.ctrlKey) && S.preventDefault(), !(S.ctrlKey || S.metaKey || S.shiftKey || S.altKey))
      switch (S.key) {
        case "Backspace":
        case "Delete":
          S.preventDefault(), S.stopPropagation(), y();
          break;
      }
  }, { startsWith: v } = p7({
    sensitivity: "base"
  }), x = Tt({
    hour: "numeric",
    hour12: !0
  }), E = K(() => {
    let S = /* @__PURE__ */ new Date();
    return S.setHours(0), x.formatToParts(S).find((j) => j.type === "dayPeriod").value;
  }, [
    x
  ]), P = K(() => {
    let S = /* @__PURE__ */ new Date();
    return S.setHours(12), x.formatToParts(S).find((j) => j.type === "dayPeriod").value;
  }, [
    x
  ]), C = Tt({
    year: "numeric",
    era: "narrow",
    timeZone: "UTC"
  }), M = K(() => {
    if (e.type !== "era") return [];
    let S = Se(new Re(1, 1, 1), t.calendar), j = t.calendar.getEras().map((B) => {
      let L = S.set({
        year: 1,
        month: 1,
        day: 1,
        era: B
      }).toDate("UTC"), ie = C.formatToParts(L).find((q) => q.type === "era").value;
      return {
        era: B,
        formatted: ie
      };
    }), _ = S7(j.map((B) => B.formatted));
    if (_) for (let B of j) B.formatted = B.formatted.slice(_);
    return j;
  }, [
    C,
    t.calendar,
    e.type
  ]), F = (S) => {
    if (t.isDisabled || t.isReadOnly) return;
    let j = r.current + S;
    switch (e.type) {
      case "dayPeriod":
        if (v(E, S)) t.setSegment("dayPeriod", 0);
        else if (v(P, S)) t.setSegment("dayPeriod", 1);
        else break;
        s.focusNext();
        break;
      case "era": {
        let _ = M.find((B) => v(B.formatted, S));
        _ && (t.setSegment("era", _.era), s.focusNext());
        break;
      }
      case "day":
      case "hour":
      case "minute":
      case "second":
      case "month":
      case "year": {
        if (!b.isValidPartialNumber(j)) return;
        let _ = b.parse(j), B = _;
        if (e.maxValue !== void 0 && _ > e.maxValue && (B = b.parse(S)), isNaN(_)) return;
        t.setSegment(e.type, B), e.maxValue !== void 0 && (+(_ + "0") > e.maxValue || j.length >= String(e.maxValue).length) ? (r.current = "", s.focusNext()) : r.current = j;
        break;
      }
    }
  }, V = () => {
    r.current = "", n.current && ze(n.current, {
      containingElement: Le(n.current)
    }), window.getSelection()?.collapse(n.current);
  }, I = T(typeof document < "u" ? document : null);
  mt(I, "selectionchange", () => {
    let S = window.getSelection();
    S?.anchorNode && ae(n.current, S?.anchorNode) && S.collapse(n.current);
  });
  let A = T("");
  mt(n, "beforeinput", (S) => {
    if (n.current)
      switch (S.preventDefault(), S.inputType) {
        case "deleteContentBackward":
        case "deleteContentForward":
          b.isValidPartialNumber(e.text) && !t.isReadOnly && y();
          break;
        case "insertCompositionText":
          A.current = n.current.textContent, n.current.textContent = n.current.textContent;
          break;
        default:
          S.data != null && F(S.data);
          break;
      }
  }), mt(n, "input", (S) => {
    let { inputType: j, data: _ } = S;
    j === "insertCompositionText" && (n.current && (n.current.textContent = A.current), _ != null && (v(E, _) || v(P, _)) && F(_));
  }), ue(() => {
    let S = n.current;
    return () => {
      se() === S && (s.focusPrevious() || s.focusNext());
    };
  }, [
    n,
    s
  ]);
  let U = vt() || e.type === "timeZoneName" ? {
    role: "textbox",
    "aria-valuemax": null,
    "aria-valuemin": null,
    "aria-valuetext": null,
    "aria-valuenow": null
  } : {}, D = K(() => t.segments.find((S) => S.isEditable), [
    t.segments
  ]);
  e !== D && !t.isInvalid && (d = void 0);
  let N = ce(), w = !t.isDisabled && !t.isReadOnly && e.isEditable, R = e.type === "literal" ? "" : i.of(e.type), H = it({
    "aria-label": `${R}${u ? `, ${u}` : ""}${o ? ", " : ""}`,
    "aria-labelledby": o
  });
  if (e.type === "literal") return {
    segmentProps: {
      "aria-hidden": !0
    }
  };
  let k = {
    caretColor: "transparent"
  };
  if (l === "rtl") {
    k.unicodeBidi = "embed";
    let S = f[e.type];
    (S === "numeric" || S === "2-digit") && (k.direction = "ltr");
  }
  return {
    segmentProps: z(p, H, {
      id: N,
      ...U,
      "aria-invalid": t.isInvalid ? "true" : void 0,
      "aria-describedby": d,
      "aria-readonly": t.isReadOnly || !e.isEditable ? "true" : void 0,
      "data-placeholder": e.isPlaceholder || void 0,
      contentEditable: w,
      suppressContentEditableWarning: w,
      spellCheck: w ? "false" : void 0,
      autoCorrect: w ? "off" : void 0,
      // Capitalization was changed in React 17...
      [parseInt(g.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: w ? "next" : void 0,
      inputMode: t.isDisabled || e.type === "dayPeriod" || e.type === "era" || !w ? void 0 : "numeric",
      tabIndex: t.isDisabled ? void 0 : 0,
      onKeyDown: $,
      onFocus: V,
      style: k,
      // Prevent pointer events from reaching useDatePickerGroup, and allow native browser behavior to focus the segment.
      onPointerDown(S) {
        S.stopPropagation();
      },
      onMouseDown(S) {
        S.stopPropagation();
      }
    })
  };
}
function S7(e) {
  e.sort();
  let t = e[0], n = e[e.length - 1];
  for (let r = 0; r < t.length; r++)
    if (t[r] !== n[r]) return r;
  return 0;
}
var u0 = {};
u0 = {
  rangeOverflow: (e) => `يجب أن تكون القيمة ${e.maxValue} أو قبل ذلك.`,
  rangeReversed: "تاريخ البدء يجب أن يكون قبل تاريخ الانتهاء.",
  rangeUnderflow: (e) => `يجب أن تكون القيمة ${e.minValue} أو بعد ذلك.`,
  unavailableDate: "البيانات المحددة غير متاحة."
};
var o0 = {};
o0 = {
  rangeOverflow: (e) => `Стойността трябва да е ${e.maxValue} или по-ранна.`,
  rangeReversed: "Началната дата трябва да е преди крайната.",
  rangeUnderflow: (e) => `Стойността трябва да е ${e.minValue} или по-късно.`,
  unavailableDate: "Избраната дата не е налична."
};
var s0 = {};
s0 = {
  rangeOverflow: (e) => `Hodnota musí být ${e.maxValue} nebo dřívější.`,
  rangeReversed: "Datum zahájení musí předcházet datu ukončení.",
  rangeUnderflow: (e) => `Hodnota musí být ${e.minValue} nebo pozdější.`,
  unavailableDate: "Vybrané datum není k dispozici."
};
var d0 = {};
d0 = {
  rangeOverflow: (e) => `Værdien skal være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen skal være før slutdatoen.",
  rangeUnderflow: (e) => `Værdien skal være ${e.minValue} eller nyere.`,
  unavailableDate: "Den valgte dato er ikke tilgængelig."
};
var c0 = {};
c0 = {
  rangeOverflow: (e) => `Der Wert muss ${e.maxValue} oder früher sein.`,
  rangeReversed: "Das Startdatum muss vor dem Enddatum liegen.",
  rangeUnderflow: (e) => `Der Wert muss ${e.minValue} oder später sein.`,
  unavailableDate: "Das ausgewählte Datum ist nicht verfügbar."
};
var f0 = {};
f0 = {
  rangeOverflow: (e) => `Η τιμή πρέπει να είναι ${e.maxValue} ή παλαιότερη.`,
  rangeReversed: "Η ημερομηνία έναρξης πρέπει να είναι πριν από την ημερομηνία λήξης.",
  rangeUnderflow: (e) => `Η τιμή πρέπει να είναι ${e.minValue} ή μεταγενέστερη.`,
  unavailableDate: "Η επιλεγμένη ημερομηνία δεν είναι διαθέσιμη."
};
var h0 = {};
h0 = {
  rangeUnderflow: (e) => `Value must be ${e.minValue} or later.`,
  rangeOverflow: (e) => `Value must be ${e.maxValue} or earlier.`,
  rangeReversed: "Start date must be before end date.",
  unavailableDate: "Selected date unavailable."
};
var m0 = {};
m0 = {
  rangeOverflow: (e) => `El valor debe ser ${e.maxValue} o anterior.`,
  rangeReversed: "La fecha de inicio debe ser anterior a la fecha de finalización.",
  rangeUnderflow: (e) => `El valor debe ser ${e.minValue} o posterior.`,
  unavailableDate: "Fecha seleccionada no disponible."
};
var p0 = {};
p0 = {
  rangeOverflow: (e) => `Väärtus peab olema ${e.maxValue} või varasem.`,
  rangeReversed: "Alguskuupäev peab olema enne lõppkuupäeva.",
  rangeUnderflow: (e) => `Väärtus peab olema ${e.minValue} või hilisem.`,
  unavailableDate: "Valitud kuupäev pole saadaval."
};
var b0 = {};
b0 = {
  rangeOverflow: (e) => `Arvon on oltava ${e.maxValue} tai sitä aikaisempi.`,
  rangeReversed: "Aloituspäivän on oltava ennen lopetuspäivää.",
  rangeUnderflow: (e) => `Arvon on oltava ${e.minValue} tai sitä myöhäisempi.`,
  unavailableDate: "Valittu päivämäärä ei ole käytettävissä."
};
var g0 = {};
g0 = {
  rangeOverflow: (e) => `La valeur doit être ${e.maxValue} ou antérieure.`,
  rangeReversed: "La date de début doit être antérieure à la date de fin.",
  rangeUnderflow: (e) => `La valeur doit être ${e.minValue} ou ultérieure.`,
  unavailableDate: "La date sélectionnée n’est pas disponible."
};
var y0 = {};
y0 = {
  rangeOverflow: (e) => `הערך חייב להיות ${e.maxValue} או מוקדם יותר.`,
  rangeReversed: "תאריך ההתחלה חייב להיות לפני תאריך הסיום.",
  rangeUnderflow: (e) => `הערך חייב להיות ${e.minValue} או מאוחר יותר.`,
  unavailableDate: "התאריך הנבחר אינו זמין."
};
var $0 = {};
$0 = {
  rangeOverflow: (e) => `Vrijednost mora biti ${e.maxValue} ili ranije.`,
  rangeReversed: "Datum početka mora biti prije datuma završetka.",
  rangeUnderflow: (e) => `Vrijednost mora biti ${e.minValue} ili kasnije.`,
  unavailableDate: "Odabrani datum nije dostupan."
};
var v0 = {};
v0 = {
  rangeOverflow: (e) => `Az értéknek ${e.maxValue} vagy korábbinak kell lennie.`,
  rangeReversed: "A kezdő dátumnak a befejező dátumnál korábbinak kell lennie.",
  rangeUnderflow: (e) => `Az értéknek ${e.minValue} vagy későbbinek kell lennie.`,
  unavailableDate: "A kiválasztott dátum nem érhető el."
};
var D0 = {};
D0 = {
  rangeOverflow: (e) => `Il valore deve essere ${e.maxValue} o precedente.`,
  rangeReversed: "La data di inizio deve essere antecedente alla data di fine.",
  rangeUnderflow: (e) => `Il valore deve essere ${e.minValue} o successivo.`,
  unavailableDate: "Data selezionata non disponibile."
};
var x0 = {};
x0 = {
  rangeOverflow: (e) => `値は ${e.maxValue} 以下にする必要があります。`,
  rangeReversed: "開始日は終了日より前にする必要があります。",
  rangeUnderflow: (e) => `値は ${e.minValue} 以上にする必要があります。`,
  unavailableDate: "選択した日付は使用できません。"
};
var E0 = {};
E0 = {
  rangeOverflow: (e) => `값은 ${e.maxValue} 이전이어야 합니다.`,
  rangeReversed: "시작일은 종료일 이전이어야 합니다.",
  rangeUnderflow: (e) => `값은 ${e.minValue} 이후여야 합니다.`,
  unavailableDate: "선택한 날짜를 사용할 수 없습니다."
};
var C0 = {};
C0 = {
  rangeOverflow: (e) => `Reikšmė turi būti ${e.maxValue} arba ankstesnė.`,
  rangeReversed: "Pradžios data turi būti ankstesnė nei pabaigos data.",
  rangeUnderflow: (e) => `Reikšmė turi būti ${e.minValue} arba naujesnė.`,
  unavailableDate: "Pasirinkta data nepasiekiama."
};
var P0 = {};
P0 = {
  rangeOverflow: (e) => `Vērtībai ir jābūt ${e.maxValue} vai agrākai.`,
  rangeReversed: "Sākuma datumam ir jābūt pirms beigu datuma.",
  rangeUnderflow: (e) => `Vērtībai ir jābūt ${e.minValue} vai vēlākai.`,
  unavailableDate: "Atlasītais datums nav pieejams."
};
var w0 = {};
w0 = {
  rangeOverflow: (e) => `Verdien må være ${e.maxValue} eller tidligere.`,
  rangeReversed: "Startdatoen må være før sluttdatoen.",
  rangeUnderflow: (e) => `Verdien må være ${e.minValue} eller senere.`,
  unavailableDate: "Valgt dato utilgjengelig."
};
var S0 = {};
S0 = {
  rangeOverflow: (e) => `Waarde moet ${e.maxValue} of eerder zijn.`,
  rangeReversed: "De startdatum moet voor de einddatum liggen.",
  rangeUnderflow: (e) => `Waarde moet ${e.minValue} of later zijn.`,
  unavailableDate: "Geselecteerde datum niet beschikbaar."
};
var k0 = {};
k0 = {
  rangeOverflow: (e) => `Wartość musi mieć wartość ${e.maxValue} lub wcześniejszą.`,
  rangeReversed: "Data rozpoczęcia musi być wcześniejsza niż data zakończenia.",
  rangeUnderflow: (e) => `Wartość musi mieć wartość ${e.minValue} lub późniejszą.`,
  unavailableDate: "Wybrana data jest niedostępna."
};
var B0 = {};
B0 = {
  rangeOverflow: (e) => `O valor deve ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data inicial deve ser anterior à data final.",
  rangeUnderflow: (e) => `O valor deve ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var F0 = {};
F0 = {
  rangeOverflow: (e) => `O valor tem de ser ${e.maxValue} ou anterior.`,
  rangeReversed: "A data de início deve ser anterior à data de fim.",
  rangeUnderflow: (e) => `O valor tem de ser ${e.minValue} ou posterior.`,
  unavailableDate: "Data selecionada indisponível."
};
var A0 = {};
A0 = {
  rangeOverflow: (e) => `Valoarea trebuie să fie ${e.maxValue} sau anterioară.`,
  rangeReversed: "Data de început trebuie să fie anterioară datei de sfârșit.",
  rangeUnderflow: (e) => `Valoarea trebuie să fie ${e.minValue} sau ulterioară.`,
  unavailableDate: "Data selectată nu este disponibilă."
};
var R0 = {};
R0 = {
  rangeOverflow: (e) => `Значение должно быть не позже ${e.maxValue}.`,
  rangeReversed: "Дата начала должна предшествовать дате окончания.",
  rangeUnderflow: (e) => `Значение должно быть не раньше ${e.minValue}.`,
  unavailableDate: "Выбранная дата недоступна."
};
var T0 = {};
T0 = {
  rangeOverflow: (e) => `Hodnota musí byť ${e.maxValue} alebo skoršia.`,
  rangeReversed: "Dátum začiatku musí byť skorší ako dátum konca.",
  rangeUnderflow: (e) => `Hodnota musí byť ${e.minValue} alebo neskoršia.`,
  unavailableDate: "Vybratý dátum je nedostupný."
};
var I0 = {};
I0 = {
  rangeOverflow: (e) => `Vrednost mora biti ${e.maxValue} ali starejša.`,
  rangeReversed: "Začetni datum mora biti pred končnim datumom.",
  rangeUnderflow: (e) => `Vrednost mora biti ${e.minValue} ali novejša.`,
  unavailableDate: "Izbrani datum ni na voljo."
};
var M0 = {};
M0 = {
  rangeOverflow: (e) => `Vrednost mora da bude ${e.maxValue} ili starija.`,
  rangeReversed: "Datum početka mora biti pre datuma završetka.",
  rangeUnderflow: (e) => `Vrednost mora da bude ${e.minValue} ili novija.`,
  unavailableDate: "Izabrani datum nije dostupan."
};
var K0 = {};
K0 = {
  rangeOverflow: (e) => `Värdet måste vara ${e.maxValue} eller tidigare.`,
  rangeReversed: "Startdatumet måste vara före slutdatumet.",
  rangeUnderflow: (e) => `Värdet måste vara ${e.minValue} eller senare.`,
  unavailableDate: "Det valda datumet är inte tillgängligt."
};
var N0 = {};
N0 = {
  rangeOverflow: (e) => `Değer, ${e.maxValue} veya öncesi olmalıdır.`,
  rangeReversed: "Başlangıç tarihi bitiş tarihinden önce olmalıdır.",
  rangeUnderflow: (e) => `Değer, ${e.minValue} veya sonrası olmalıdır.`,
  unavailableDate: "Seçilen tarih kullanılamıyor."
};
var V0 = {};
V0 = {
  rangeOverflow: (e) => `Значення має бути не пізніше ${e.maxValue}.`,
  rangeReversed: "Дата початку має передувати даті завершення.",
  rangeUnderflow: (e) => `Значення має бути не раніше ${e.minValue}.`,
  unavailableDate: "Вибрана дата недоступна."
};
var L0 = {};
L0 = {
  rangeOverflow: (e) => `值必须是 ${e.maxValue} 或更早日期。`,
  rangeReversed: "开始日期必须早于结束日期。",
  rangeUnderflow: (e) => `值必须是 ${e.minValue} 或更晚日期。`,
  unavailableDate: "所选日期不可用。"
};
var z0 = {};
z0 = {
  rangeOverflow: (e) => `值必須是 ${e.maxValue} 或更早。`,
  rangeReversed: "開始日期必須在結束日期之前。",
  rangeUnderflow: (e) => `值必須是 ${e.minValue} 或更晚。`,
  unavailableDate: "所選日期無法使用。"
};
var O0 = {};
O0 = {
  "ar-AE": u0,
  "bg-BG": o0,
  "cs-CZ": s0,
  "da-DK": d0,
  "de-DE": c0,
  "el-GR": f0,
  "en-US": h0,
  "es-ES": m0,
  "et-EE": p0,
  "fi-FI": b0,
  "fr-FR": g0,
  "he-IL": y0,
  "hr-HR": $0,
  "hu-HU": v0,
  "it-IT": D0,
  "ja-JP": x0,
  "ko-KR": E0,
  "lt-LT": C0,
  "lv-LV": P0,
  "nb-NO": w0,
  "nl-NL": S0,
  "pl-PL": k0,
  "pt-BR": B0,
  "pt-PT": F0,
  "ro-RO": A0,
  "ru-RU": R0,
  "sk-SK": T0,
  "sl-SI": I0,
  "sr-SP": M0,
  "sv-SE": K0,
  "tr-TR": N0,
  "uk-UA": V0,
  "zh-CN": L0,
  "zh-TW": z0
};
function k7(e) {
  return e && e.__esModule ? e.default : e;
}
const B7 = new $t(k7(O0));
function F7() {
  let e = (
    // @ts-ignore
    typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US"
  );
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return e;
}
function H0(e, t, n, r, a) {
  let l = e != null && n != null && e.compare(n) > 0, i = e != null && t != null && e.compare(t) < 0, u = e != null && r?.(e) || !1, o = l || i || u, d = [];
  if (o) {
    let s = F7(), c = $t.getGlobalDictionaryForPackage("@react-stately/datepicker") || B7, f = new $u(s, c), h = new Gt(s, hr({}, a)), m = h.resolvedOptions().timeZone;
    i && t != null && d.push(f.format("rangeUnderflow", {
      minValue: h.format(t.toDate(m))
    })), l && n != null && d.push(f.format("rangeOverflow", {
      maxValue: h.format(n.toDate(m))
    })), u && d.push(f.format("unavailableDate"));
  }
  return {
    isInvalid: o,
    validationErrors: d,
    validationDetails: {
      badInput: u,
      customError: !1,
      patternMismatch: !1,
      rangeOverflow: l,
      rangeUnderflow: i,
      stepMismatch: !1,
      tooLong: !1,
      tooShort: !1,
      typeMismatch: !1,
      valueMissing: !1,
      valid: !o
    }
  };
}
const A7 = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "numeric",
  minute: "2-digit",
  second: "2-digit"
}, R7 = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
};
function hr(e, t) {
  e = {
    ...t.shouldForceLeadingZeros ? R7 : A7,
    ...e
  };
  let r = t.granularity || "minute", a = Object.keys(e), l = a.indexOf(t.maxGranularity ?? "year");
  l < 0 && (l = 0);
  let i = a.indexOf(r);
  if (i < 0 && (i = 2), l > i) throw new Error("maxGranularity must be greater than granularity");
  let u = a.slice(l, i + 1).reduce((d, s) => (d[s] = e[s], d), {});
  return t.hourCycle != null && (u.hour12 = t.hourCycle === 12), u.timeZone = t.timeZone || "UTC", (r === "hour" || r === "minute" || r === "second") && t.timeZone && !t.hideTimeZone && (u.timeZoneName = "short"), t.showEra && l === 0 && (u.era = "short"), u;
}
function gd(e) {
  return e && "hour" in e ? e : new Iu();
}
function U0(e, t) {
  if (e === null) return null;
  if (e)
    return Se(e, t);
}
function T7(e, t, n, r) {
  if (e) return U0(e, n);
  let a = Se(E4(r ?? xl()).set({
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  }), n);
  return t === "year" || t === "month" || t === "day" ? lt(a) : r ? a : Zt(a);
}
function j0(e, t) {
  let n = e && "timeZone" in e ? e.timeZone : void 0, r = e && "minute" in e ? "minute" : "day";
  if (e && t && !(t in e)) throw new Error("Invalid granularity " + t + " for value " + e.toString());
  let [a, l] = Y([
    r,
    n
  ]);
  e && (a[0] !== r || a[1] !== n) && l([
    r,
    n
  ]), t || (t = e ? r : a[0]);
  let i = e ? n : a[1];
  return [
    t,
    i
  ];
}
const I7 = new $t({
  ach: {
    year: "mwaka",
    month: "dwe",
    day: "nino"
  },
  af: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  am: {
    year: "ዓዓዓዓ",
    month: "ሚሜ",
    day: "ቀቀ"
  },
  an: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ar: {
    year: "سنة",
    month: "شهر",
    day: "يوم"
  },
  ast: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  az: {
    year: "iiii",
    month: "aa",
    day: "gg"
  },
  be: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bg: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  bn: {
    year: "yyyy",
    month: "মিমি",
    day: "dd"
  },
  br: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  bs: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  ca: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  cak: {
    year: "jjjj",
    month: "ii",
    day: "q'q'"
  },
  ckb: {
    year: "ساڵ",
    month: "مانگ",
    day: "ڕۆژ"
  },
  cs: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  cy: {
    year: "bbbb",
    month: "mm",
    day: "dd"
  },
  da: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  de: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  dsb: {
    year: "llll",
    month: "mm",
    day: "źź"
  },
  el: {
    year: "εεεε",
    month: "μμ",
    day: "ηη"
  },
  en: {
    year: "yyyy",
    month: "mm",
    day: "dd"
  },
  eo: {
    year: "jjjj",
    month: "mm",
    day: "tt"
  },
  es: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  et: {
    year: "aaaa",
    month: "kk",
    day: "pp"
  },
  eu: {
    year: "uuuu",
    month: "hh",
    day: "ee"
  },
  fa: {
    year: "سال",
    month: "ماه",
    day: "روز"
  },
  ff: {
    year: "hhhh",
    month: "ll",
    day: "ññ"
  },
  fi: {
    year: "vvvv",
    month: "kk",
    day: "pp"
  },
  fr: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  fy: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  ga: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gd: {
    year: "bbbb",
    month: "mm",
    day: "ll"
  },
  gl: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  he: {
    year: "שנה",
    month: "חודש",
    day: "יום"
  },
  hr: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  hsb: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  hu: {
    year: "éééé",
    month: "hh",
    day: "nn"
  },
  ia: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  id: {
    year: "tttt",
    month: "bb",
    day: "hh"
  },
  is: {
    year: "áááá",
    month: "mm",
    day: "dd"
  },
  it: {
    year: "aaaa",
    month: "mm",
    day: "gg"
  },
  ja: {
    year: "年",
    month: "月",
    day: "日"
  },
  ka: {
    year: "წწწწ",
    month: "თთ",
    day: "რრ"
  },
  kk: {
    year: "жжжж",
    month: "аа",
    day: "кк"
  },
  kn: {
    year: "ವವವವ",
    month: "ಮಿಮೀ",
    day: "ದಿದಿ"
  },
  ko: {
    year: "연도",
    month: "월",
    day: "일"
  },
  lb: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  lo: {
    year: "ປປປປ",
    month: "ດດ",
    day: "ວວ"
  },
  lt: {
    year: "mmmm",
    month: "mm",
    day: "dd"
  },
  lv: {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  meh: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  ml: {
    year: "വർഷം",
    month: "മാസം",
    day: "തീയതി"
  },
  ms: {
    year: "tttt",
    month: "mm",
    day: "hh"
  },
  nb: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  nl: {
    year: "jjjj",
    month: "mm",
    day: "dd"
  },
  nn: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  no: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  oc: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  pl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  pt: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  rm: {
    year: "oooo",
    month: "mm",
    day: "dd"
  },
  ro: {
    year: "aaaa",
    month: "ll",
    day: "zz"
  },
  ru: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  sc: {
    year: "aaaa",
    month: "mm",
    day: "dd"
  },
  scn: {
    year: "aaaa",
    month: "mm",
    day: "jj"
  },
  sk: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  sl: {
    year: "llll",
    month: "mm",
    day: "dd"
  },
  sr: {
    year: "гггг",
    month: "мм",
    day: "дд"
  },
  "sr-Latn": {
    year: "gggg",
    month: "mm",
    day: "dd"
  },
  sv: {
    year: "åååå",
    month: "mm",
    day: "dd"
  },
  szl: {
    year: "rrrr",
    month: "mm",
    day: "dd"
  },
  tg: {
    year: "сссс",
    month: "мм",
    day: "рр"
  },
  th: {
    year: "ปปปป",
    month: "ดด",
    day: "วว"
  },
  tr: {
    year: "yyyy",
    month: "aa",
    day: "gg"
  },
  uk: {
    year: "рррр",
    month: "мм",
    day: "дд"
  },
  "zh-CN": {
    year: "年",
    month: "月",
    day: "日"
  },
  "zh-TW": {
    year: "年",
    month: "月",
    day: "日"
  }
}, "en");
function M7(e, t, n) {
  return e === "era" || e === "dayPeriod" ? t : e === "year" || e === "month" || e === "day" ? I7.getStringForLocale(e, n) : "––";
}
class At {
  constructor(t, n, r) {
    if (this.era = r?.era ?? null, this.calendar = t, this.year = r?.year ?? null, this.month = r?.month ?? null, this.day = r?.day ?? null, this.hour = r?.hour ?? null, this.hourCycle = n, this.dayPeriod = null, this.minute = r?.minute ?? null, this.second = r?.second ?? null, this.millisecond = r?.millisecond ?? null, this.offset = "offset" in (r ?? {}) ? r.offset : null, this.hour != null) {
      let [a, l] = Qn(this.hour, n);
      this.dayPeriod = a, this.hour = l;
    }
  }
  copy() {
    let t = new At(this.calendar, this.hourCycle);
    return t.era = this.era, t.year = this.year, t.month = this.month, t.day = this.day, t.hour = this.hour, t.dayPeriod = this.dayPeriod, t.minute = this.minute, t.second = this.second, t.millisecond = this.millisecond, t.offset = this.offset, t;
  }
  /** Checks whether all the specified segments have a value. */
  isComplete(t) {
    return t.every((n) => this[n] != null);
  }
  /** Checks whether the given date value matches this value for the specified segments. */
  validate(t, n) {
    return n.every((r) => {
      if ((r === "hour" || r === "dayPeriod") && "hour" in t) {
        let [a, l] = Qn(t.hour, this.hourCycle);
        return this.dayPeriod === a && this.hour === l;
      }
      return this[r] === t[r];
    });
  }
  /** Checks if the date is empty (i.e. all specified segments are null). */
  isCleared(t) {
    return t.every((n) => this[n] === null);
  }
  /** Sets the given field. */
  set(t, n, r) {
    let a = this.copy();
    return a[t] = n, t === "hour" && a.dayPeriod == null && "hour" in r && (a.dayPeriod = Qn(r.hour, this.hourCycle)[0]), t === "year" && a.era == null && (a.era = r.era), t !== "second" && t !== "literal" && t !== "timeZoneName" && (a.offset = null), a;
  }
  /** Sets the given field to null. */
  clear(t) {
    let n = this.copy();
    return n[t] = null, t === "year" && (n.era = null), n.offset = null, n;
  }
  /**
  * Increments or decrements the given field. If it is null, then it is set to the placeholder
  * value.
  */
  cycle(t, n, r, a) {
    let l = this.copy();
    if (l[t] == null && t !== "dayPeriod" && t !== "era") {
      if (t === "hour" && "hour" in r) {
        let [i, u] = Qn(r.hour, this.hourCycle);
        l.dayPeriod = i, l.hour = u;
      } else l[t] = r[t];
      return t === "year" && l.era == null && (l.era = r.era), l;
    }
    switch (t) {
      case "era": {
        let i = this.calendar.getEras(), u = i.indexOf(l.era);
        u = Pn(u, n, 0, i.length - 1), l.era = i[u];
        break;
      }
      case "year": {
        let i = new Re(this.calendar, this.era ?? r.era, this.year ?? r.year, this.month ?? 1, this.day ?? 1);
        i = i.cycle(t, n, {
          round: t === "year"
        }), l.era = i.era, l.year = i.year;
        break;
      }
      case "month":
        l.month = Pn(l.month ?? 1, n, 1, this.calendar.getMaximumMonthsInYear());
        break;
      case "day":
        l.day = Pn(l.day ?? 1, n, 1, this.calendar.getMaximumDaysInMonth());
        break;
      case "hour": {
        let i = a.some((u) => [
          "year",
          "month",
          "day"
        ].includes(u));
        if ("timeZone" in r && (!i || l.year != null && l.month != null && l.day != null)) {
          let u = this.toValue(r);
          u = u.cycle("hour", n, {
            hourCycle: this.hourCycle === "h12" ? 12 : 24,
            round: !1
          });
          let [o, d] = Qn(u.hour, this.hourCycle);
          l.hour = d, l.dayPeriod = o, l.offset = u.offset;
        } else {
          let u = l.hour ?? 0, o = this.getSegmentLimits("hour");
          l.hour = Pn(u, n, o.minValue, o.maxValue), l.dayPeriod == null && "hour" in r && (l.dayPeriod = Qn(r.hour, this.hourCycle)[0]);
        }
        break;
      }
      case "dayPeriod":
        l.dayPeriod = Pn(l.dayPeriod ?? 0, n, 0, 1);
        break;
      case "minute":
        l.minute = Pn(l.minute ?? 0, n, 0, 59, !0);
        break;
      case "second":
        l.second = Pn(l.second ?? 0, n, 0, 59, !0);
        break;
    }
    return l;
  }
  /**
  * Converts the incomplete date to a full date value, using the provided value for any unset
  * fields.
  */
  toValue(t) {
    if ("hour" in t) {
      let n = this.hour;
      n != null ? n = K7(n, this.dayPeriod ?? 0, this.hourCycle) : (this.hourCycle === "h12" || this.hourCycle === "h11") && (n = this.dayPeriod === 1 ? 12 : 0);
      let r = t.set({
        era: this.era ?? t.era,
        year: this.year ?? t.year,
        month: this.month ?? t.month,
        day: this.day ?? t.day,
        hour: n ?? t.hour,
        minute: this.minute ?? t.minute,
        second: this.second ?? t.second,
        millisecond: this.millisecond ?? t.millisecond
      });
      return "offset" in r && this.offset != null && r.offset !== this.offset && (r = r.add({
        milliseconds: r.offset - this.offset
      })), r;
    } else return t.set({
      era: this.era ?? t.era,
      year: this.year ?? t.year,
      month: this.month ?? t.month,
      day: this.day ?? t.day
    });
  }
  getSegmentLimits(t) {
    switch (t) {
      case "era": {
        let n = this.calendar.getEras();
        return {
          value: this.era != null ? n.indexOf(this.era) : n.length - 1,
          minValue: 0,
          maxValue: n.length - 1
        };
      }
      case "year":
        return {
          value: this.year,
          minValue: 1,
          maxValue: 9999
        };
      case "month":
        return {
          value: this.month,
          minValue: 1,
          maxValue: this.calendar.getMaximumMonthsInYear()
        };
      case "day":
        return {
          value: this.day,
          minValue: 1,
          maxValue: this.calendar.getMaximumDaysInMonth()
        };
      case "dayPeriod":
        return {
          value: this.dayPeriod,
          minValue: 0,
          maxValue: 1
        };
      case "hour": {
        let n = 0, r = 23;
        return this.hourCycle === "h12" ? (n = 1, r = 12) : this.hourCycle === "h11" && (n = 0, r = 11), {
          value: this.hour,
          minValue: n,
          maxValue: r
        };
      }
      case "minute":
        return {
          value: this.minute,
          minValue: 0,
          maxValue: 59
        };
      case "second":
        return {
          value: this.second,
          minValue: 0,
          maxValue: 59
        };
    }
  }
}
function Pn(e, t, n, r, a = !1) {
  if (a) {
    e += Math.sign(t), e < n && (e = r);
    let l = Math.abs(t);
    t > 0 ? e = Math.ceil(e / l) * l : e = Math.floor(e / l) * l, e > r && (e = n);
  } else
    e += t, e < n ? e = r - (n - e - 1) : e > r && (e = n + (e - r - 1));
  return e;
}
function Qn(e, t) {
  let n = e >= 12 ? 1 : 0;
  switch (t) {
    case "h11":
      e >= 12 && (e -= 12);
      break;
    case "h12":
      e === 0 ? e = 12 : e > 12 && (e -= 12);
      break;
    case "h23":
      n = null;
      break;
    case "h24":
      e += 1, n = null;
  }
  return [
    n,
    e
  ];
}
function K7(e, t, n) {
  switch (n) {
    case "h11":
      t === 1 && (e += 12);
      break;
    case "h12":
      e === 12 && (e = 0), t === 1 && (e += 12);
      break;
    case "h24":
      e -= 1;
      break;
  }
  return e;
}
const hi = {
  year: !0,
  month: !0,
  day: !0,
  hour: !0,
  minute: !0,
  second: !0,
  dayPeriod: !0,
  era: !0
}, yd = {
  year: 5,
  month: 2,
  day: 7,
  hour: 2,
  minute: 15,
  second: 15
}, N7 = {
  // Node seems to convert everything to lowercase...
  dayperiod: "dayPeriod",
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts#named_years
  relatedYear: "year",
  yearName: "literal",
  unknown: "literal"
};
function V7(e) {
  let { locale: t, createCalendar: n, hideTimeZone: r, isDisabled: a = !1, isReadOnly: l = !1, isRequired: i = !1, minValue: u, maxValue: o, isDateUnavailable: d } = e, s = e.value || e.defaultValue || e.placeholderValue || null, [c, f] = j0(s, e.granularity), h = f || "UTC";
  if (s && !(c in s)) throw new Error("Invalid granularity " + c + " for value " + s.toString());
  let [m, p] = K(() => {
    let re = new Gt(t, {
      dateStyle: "short",
      timeStyle: "short",
      hour12: e.hourCycle != null ? e.hourCycle === 12 : void 0
    }).resolvedOptions();
    return [
      n(re.calendar),
      re.hourCycle
    ];
  }, [
    t,
    e.hourCycle,
    n
  ]), [b, y] = Pe(e.value, e.defaultValue ?? null, e.onChange), [$] = Y(b), v = K(() => U0(b, m) ?? null, [
    b,
    m
  ]), [x, E] = Y(() => new At(m, p, v)), P = m.identifier === "gregory" && x.era === "BC", C = K(() => ({
    granularity: c,
    maxGranularity: e.maxGranularity ?? "year",
    timeZone: f,
    hideTimeZone: r,
    hourCycle: e.hourCycle,
    showEra: P,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros
  }), [
    e.maxGranularity,
    c,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    f,
    r,
    P
  ]), M = K(() => hr({}, C), [
    C
  ]), F = K(() => new Gt(t, M), [
    t,
    M
  ]), V = K(() => F.resolvedOptions(), [
    F
  ]), I = K(() => T7(e.placeholderValue, c, m, f), [
    e.placeholderValue,
    c,
    m,
    f
  ]), A = K(() => {
    let q = p === "h11" || p === "h12", re = [
      "era",
      "year",
      "month",
      "day",
      "hour",
      ...q ? [
        "dayPeriod"
      ] : [],
      "minute",
      "second"
    ], fe = re.indexOf(e.maxGranularity || "era"), et = re.indexOf(c === "hour" && q ? "dayPeriod" : c);
    return re.slice(fe, et + 1);
  }, [
    e.maxGranularity,
    c,
    p
  ]), [U, D] = Y(v), [N, w] = Y(m), [R, H] = Y(p);
  (v !== U || p !== R || !Dl(m, N)) && (x = new At(m, p, v), D(v), w(m), H(p), E(x));
  let k = (q) => {
    if (!(e.isDisabled || e.isReadOnly))
      if (q == null || q instanceof At && q.isCleared(A))
        E(new At(m, p, v)), y(null);
      else if (!(q instanceof At))
        q = Se(q, s?.calendar || new je()), E(new At(m, p, v)), y(q);
      else {
        if (q.isComplete(A)) {
          let re = q.toValue(v ?? I);
          if (q.validate(re, A)) {
            let fe = Se(re, s?.calendar || new je());
            if (!b || fe.compare(b) !== 0) {
              E(new At(m, p, v)), y(fe);
              return;
            }
          }
        }
        E(q);
      }
  }, S = K(() => x.toValue(v ?? I).toDate(h), [
    x,
    h,
    v,
    I
  ]), j = K(() => L7(S, x, F, V, m, t, c), [
    S,
    F,
    V,
    x,
    m,
    t,
    c
  ]), _ = (q, re) => {
    k(x.cycle(q, re, I, A));
  }, B = K(() => H0(b, u, o, d, C), [
    b,
    u,
    o,
    d,
    C
  ]), L = rn({
    ...e,
    value: b,
    builtinValidation: B
  }), Z = L.displayValidation.isInvalid, ie = e.validationState || (Z ? "invalid" : null);
  return {
    ...L,
    value: v,
    defaultValue: e.defaultValue ?? $,
    dateValue: S,
    calendar: m,
    setValue: k,
    segments: j,
    dateFormatter: F,
    validationState: ie,
    isInvalid: Z,
    granularity: c,
    maxGranularity: e.maxGranularity ?? "year",
    isDisabled: a,
    isReadOnly: l,
    isRequired: i,
    increment(q) {
      _(q, 1);
    },
    decrement(q) {
      _(q, -1);
    },
    incrementPage(q) {
      _(q, yd[q] || 1);
    },
    decrementPage(q) {
      _(q, -(yd[q] || 1));
    },
    incrementToMax(q) {
      let re = q === "hour" && p === "h12" ? 11 : x.getSegmentLimits(q).maxValue;
      k(x.set(q, re, I));
    },
    decrementToMin(q) {
      let re = q === "hour" && p === "h12" ? 12 : x.getSegmentLimits(q).minValue;
      k(x.set(q, re, I));
    },
    setSegment(q, re) {
      k(x.set(q, re, I));
    },
    confirmPlaceholder() {
      if (!(e.isDisabled || e.isReadOnly) && x.isComplete(A)) {
        let q = x.toValue(v ?? I), re = Se(q, s?.calendar || new je());
        (!b || re.compare(b) !== 0) && y(re), E(new At(m, p, v));
      }
    },
    clearSegment(q) {
      let re = x;
      q !== "timeZoneName" && q !== "literal" && (re = x.clear(q)), k(re);
    },
    formatValue(q) {
      if (!v) return "";
      let re = hr(q, C);
      return new Gt(t, re).format(S);
    },
    getDateFormatter(q, re) {
      let fe = {
        ...C,
        ...re
      }, et = hr({}, fe);
      return new Gt(q, et);
    }
  };
}
function L7(e, t, n, r, a, l, i) {
  let u = [
    "hour",
    "minute",
    "second"
  ], o = n.formatToParts(e), d = new Kt(l, {
    useGrouping: !1
  }), s = new Kt(l, {
    useGrouping: !1,
    minimumIntegerDigits: 2
  });
  for (let f of o) if (f.type === "year" || f.type === "month" || f.type === "day" || f.type === "hour") {
    let h = t[f.type] ?? 0;
    r[f.type] === "2-digit" ? f.value = s.format(h) : f.value = d.format(h);
  }
  let c = [];
  for (let f of o) {
    let h = N7[f.type] || f.type, m = hi[h];
    h === "era" && a.getEras().length === 1 && (m = !1);
    let p = hi[h] && t[f.type] == null, b = hi[h] ? M7(h, f.value, l) : null, y = {
      type: h,
      text: p ? b : f.value,
      ...t.getSegmentLimits(h),
      isPlaceholder: p,
      placeholder: b,
      isEditable: m
    };
    h === "hour" ? (c.push({
      type: "literal",
      text: "⁦",
      isPlaceholder: !1,
      placeholder: "",
      isEditable: !1
    }), c.push(y), h === i && c.push({
      type: "literal",
      text: "⁩",
      isPlaceholder: !1,
      placeholder: "",
      isEditable: !1
    })) : u.includes(h) && h === i ? (c.push(y), c.push({
      type: "literal",
      text: "⁩",
      isPlaceholder: !1,
      placeholder: "",
      isEditable: !1
    })) : c.push(y);
  }
  return c;
}
const _0 = /* @__PURE__ */ G(null), Tl = /* @__PURE__ */ G(null), so = /* @__PURE__ */ G(null), C9 = /* @__PURE__ */ te(function(t, n) {
  let r = O(Tl), a = O(so);
  return r || a ? /* @__PURE__ */ g.createElement(W0, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(z7, {
    ...t,
    ref: n
  });
}), z7 = /* @__PURE__ */ te((e, t) => {
  let [n, r] = oe({
    slot: e.slot
  }, t, _0), { locale: a } = de(), l = V7({
    ...n,
    locale: a,
    createCalendar: X4
  }), i = T(null), { fieldProps: u, inputProps: o } = x7({
    ...n,
    inputRef: i
  }, l, r);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Tl,
        l
      ],
      [
        Pr,
        {
          ...o,
          ref: i
        }
      ],
      [
        vn,
        {
          ...u,
          ref: r,
          isInvalid: l.isInvalid,
          isDisabled: l.isDisabled
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(W0, e));
}), W0 = /* @__PURE__ */ te((e, t) => {
  let { className: n, children: r } = e, a = O(Tl), l = O(so), i = a ?? l;
  return /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement(xD, {
    ...e,
    ref: t,
    slot: e.slot || void 0,
    className: n ?? "react-aria-DateInput",
    isReadOnly: i.isReadOnly,
    isInvalid: i.isInvalid,
    isDisabled: i.isDisabled
  }, i.segments.map((u, o) => /* @__PURE__ */ du(r(u), {
    key: o
  }))), /* @__PURE__ */ g.createElement(CD, {
    className: ""
  }));
}), P9 = /* @__PURE__ */ te(function({ segment: t, ...n }, r) {
  let a = O(Tl), l = O(so), i = a ?? l, u = $e(r), { segmentProps: o } = w7(t, i, u), { focusProps: d, isFocused: s, isFocusVisible: c } = ye(), { hoverProps: f, isHovered: h } = ve({
    ...n,
    isDisabled: i.isDisabled || t.type === "literal"
  }), m = le({
    ...n,
    values: {
      ...t,
      isReadOnly: i.isReadOnly,
      isInvalid: i.isInvalid,
      isDisabled: i.isDisabled,
      isHovered: h,
      isFocused: s,
      isFocusVisible: c
    },
    defaultChildren: t.text,
    defaultClassName: "react-aria-DateSegment"
  });
  return /* @__PURE__ */ g.createElement(Q.span, {
    ...z(J(n, {
      global: !0
    }), o, d, f),
    ...m,
    style: o.style,
    ref: u,
    "data-placeholder": t.isPlaceholder || void 0,
    "data-invalid": i.isInvalid || void 0,
    "data-readonly": i.isReadOnly || void 0,
    "data-disabled": i.isDisabled || void 0,
    "data-type": t.type,
    "data-hovered": h || void 0,
    "data-focused": s || void 0,
    "data-focus-visible": c || void 0
  });
});
function O7(e) {
  return e && e.__esModule ? e.default : e;
}
function H7(e, t, n) {
  let r = ce(), a = ce(), l = ce(), i = xe(O7(Rl), "@react-aria/datepicker"), { isInvalid: u, validationErrors: o, validationDetails: d } = t.displayValidation, { labelProps: s, fieldProps: c, descriptionProps: f, errorMessageProps: h } = Cr({
    ...e,
    labelElementType: "span",
    isInvalid: u,
    errorMessage: e.errorMessage || o
  }), m = l0(t, n), p = c["aria-labelledby"] || c.id, { locale: b } = de(), y = t.formatValue(b, {
    month: "long"
  }), $ = y ? i.format("selectedDateDescription", {
    date: y
  }) : "", v = en($), x = [
    v["aria-describedby"],
    c["aria-describedby"]
  ].filter(Boolean).join(" ") || void 0, E = J(e), P = K(() => kl(n), [
    n
  ]), C = T(!1), { focusWithinProps: M } = ct({
    ...e,
    isDisabled: t.isOpen,
    onBlurWithin: (F) => {
      let V = document.getElementById(a);
      ae(V, F.relatedTarget) || (C.current = !1, e.onBlur?.(F), e.onFocusChange?.(!1));
    },
    onFocusWithin: (F) => {
      C.current || (C.current = !0, e.onFocus?.(F), e.onFocusChange?.(!0));
    }
  });
  return {
    groupProps: z(E, m, c, v, M, {
      role: "group",
      "aria-disabled": e.isDisabled || null,
      "aria-labelledby": p,
      "aria-describedby": x,
      onKeyDown(F) {
        t.isOpen || e.onKeyDown && e.onKeyDown(F);
      },
      onKeyUp(F) {
        t.isOpen || e.onKeyUp && e.onKeyUp(F);
      }
    }),
    labelProps: {
      ...s,
      onClick: () => {
        P.focusFirst();
      }
    },
    fieldProps: {
      ...c,
      id: l,
      [Ha]: "presentation",
      "aria-describedby": x,
      value: t.value,
      defaultValue: t.defaultValue,
      onChange: t.setValue,
      placeholderValue: e.placeholderValue,
      hideTimeZone: e.hideTimeZone,
      hourCycle: e.hourCycle,
      shouldForceLeadingZeros: e.shouldForceLeadingZeros,
      granularity: e.granularity,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isRequired: e.isRequired,
      validationBehavior: e.validationBehavior,
      // DatePicker owns the validation state for the date field.
      [zn]: t,
      autoFocus: e.autoFocus,
      name: e.name,
      form: e.form
    },
    descriptionProps: f,
    errorMessageProps: h,
    buttonProps: {
      ...v,
      id: r,
      "aria-haspopup": "dialog",
      "aria-label": i.format("calendar"),
      "aria-labelledby": `${r} ${p}`,
      "aria-describedby": x,
      "aria-expanded": t.isOpen,
      isDisabled: e.isDisabled || e.isReadOnly,
      onPress: () => t.setOpen(!0)
    },
    dialogProps: {
      id: a,
      "aria-labelledby": `${r} ${p}`
    },
    calendarProps: {
      autoFocus: !0,
      value: t.dateValue,
      onChange: t.setDateValue,
      minValue: e.minValue,
      maxValue: e.maxValue,
      isDisabled: e.isDisabled,
      isReadOnly: e.isReadOnly,
      isDateUnavailable: e.isDateUnavailable,
      defaultFocusedValue: t.dateValue ? void 0 : e.placeholderValue,
      isInvalid: t.isInvalid,
      errorMessage: typeof e.errorMessage == "function" ? e.errorMessage(t.displayValidation) : e.errorMessage || t.displayValidation.validationErrors.join(" "),
      firstDayOfWeek: e.firstDayOfWeek,
      pageBehavior: e.pageBehavior
    },
    isInvalid: u,
    validationErrors: o,
    validationDetails: d
  };
}
function U7(e) {
  let t = Br(e), [n, r] = Pe(e.value, e.defaultValue || null, e.onChange), [a] = Y(n), l = n || e.placeholderValue || null, [i, u] = j0(l, e.granularity), o = n != null ? n.toDate(u ?? "UTC") : null, d = i === "hour" || i === "minute" || i === "second", s = e.shouldCloseOnSelect ?? !0, [c, f] = Y(null), [h, m] = Y(null);
  if (n && (c = n, "hour" in n && (h = n)), l && !(i in l)) throw new Error("Invalid granularity " + i + " for value " + l.toString());
  let p = n?.calendar.identifier === "gregory" && n.era === "BC", b = K(() => ({
    granularity: i,
    timeZone: u,
    hideTimeZone: e.hideTimeZone,
    hourCycle: e.hourCycle,
    shouldForceLeadingZeros: e.shouldForceLeadingZeros,
    showEra: p
  }), [
    i,
    e.hourCycle,
    e.shouldForceLeadingZeros,
    u,
    e.hideTimeZone,
    p
  ]), { minValue: y, maxValue: $, isDateUnavailable: v } = e, x = K(() => H0(n, y, $, v, b), [
    n,
    y,
    $,
    v,
    b
  ]), E = rn({
    ...e,
    value: n,
    builtinValidation: x
  }), P = E.displayValidation.isInvalid, C = e.validationState || (P ? "invalid" : null), M = (I, A) => {
    r("timeZone" in A ? A.set(lt(I)) : Zt(I, A)), f(null), m(null), E.commitValidation();
  }, F = (I) => {
    let A = typeof s == "function" ? s() : s;
    d ? h || A ? M(I, h || gd(e.defaultValue || e.placeholderValue)) : f(I) : (r(I), E.commitValidation()), A && t.setOpen(!1);
  }, V = (I) => {
    c && I ? M(c, I) : m(I);
  };
  return {
    ...E,
    value: n,
    defaultValue: e.defaultValue ?? a,
    setValue: r,
    dateValue: c,
    timeValue: h,
    setDateValue: F,
    setTimeValue: V,
    granularity: i,
    hasTime: d,
    ...t,
    setOpen(I) {
      !I && !n && c && d && M(c, h || gd(e.defaultValue || e.placeholderValue)), t.setOpen(I);
    },
    validationState: C,
    isInvalid: P,
    formatValue(I, A) {
      if (!o) return "";
      let U = hr(A, b);
      return new Gt(I, U).format(o);
    },
    getDateFormatter(I, A) {
      let U = {
        ...b,
        ...A
      }, D = hr({}, U);
      return new Gt(I, D);
    }
  };
}
const j7 = /* @__PURE__ */ G(null), _7 = /* @__PURE__ */ G(null), W7 = [
  vn,
  Ze,
  Qe,
  _e
], w9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, j7);
  let { validationBehavior: r } = Oe(Un) || {}, a = t.validationBehavior ?? r ?? "native", l = U7({
    ...t,
    validationBehavior: a
  }), i = T(null), [u, o] = Je(!t["aria-label"] && !t["aria-labelledby"]), { groupProps: d, labelProps: s, fieldProps: c, buttonProps: f, dialogProps: h, calendarProps: m, descriptionProps: p, errorMessageProps: b, ...y } = H7({
    ...Et(t),
    label: o,
    validationBehavior: a
  }, l, i), { focusProps: $, isFocused: v, isFocusVisible: x } = ye({
    within: !0
  }), E = le({
    ...t,
    values: {
      state: l,
      isFocusWithin: v,
      isFocusVisible: x,
      isDisabled: t.isDisabled || !1,
      isInvalid: l.isInvalid,
      isOpen: l.isOpen,
      isReadOnly: t.isReadOnly || !1,
      isRequired: t.isRequired || !1
    },
    defaultClassName: "react-aria-DatePicker"
  }), P = J(t, {
    global: !0
  });
  return delete P.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        _7,
        l
      ],
      [
        vn,
        {
          ...d,
          ref: i,
          isInvalid: l.isInvalid
        }
      ],
      [
        _0,
        c
      ],
      [
        Ze,
        {
          ...f,
          isPressed: l.isOpen
        }
      ],
      [
        Qe,
        {
          ...s,
          ref: u,
          elementType: "span"
        }
      ],
      [
        il,
        m
      ],
      [
        Vt,
        l
      ],
      [
        Fr,
        {
          trigger: "DatePicker",
          triggerRef: i,
          placement: "bottom start",
          clearContexts: W7
        }
      ],
      [
        oo,
        h
      ],
      [
        _e,
        {
          slots: {
            description: p,
            errorMessage: b
          }
        }
      ],
      [
        nn,
        y
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(P, E, $),
    ref: n,
    slot: t.slot || void 0,
    "data-focus-within": v || void 0,
    "data-invalid": l.isInvalid || void 0,
    "data-focus-visible": x || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0,
    "data-open": l.isOpen || void 0
  }), /* @__PURE__ */ g.createElement($7, {
    autoComplete: t.autoComplete,
    name: t.name,
    isDisabled: t.isDisabled,
    state: l
  }));
});
function G7(e, t, n) {
  let { isDisabled: r } = e, a = ce(), l = ce(), i = Dt(), u = T(null), o = X(() => {
    u.current = requestAnimationFrame(() => {
      n.current && n.current.setAttribute("hidden", "until-found");
    }), at(() => {
      t.toggle();
    });
  }, [
    n,
    t
  ]);
  mt(n, "beforematch", o);
  let d = T(null);
  return ue(() => {
    if (u.current && cancelAnimationFrame(u.current), n.current && !i) {
      let s = n.current;
      d.current == null || typeof s.getAnimations != "function" ? t.isExpanded ? (s.removeAttribute("hidden"), s.style.setProperty("--disclosure-panel-width", "auto"), s.style.setProperty("--disclosure-panel-height", "auto")) : (s.setAttribute("hidden", "until-found"), s.style.setProperty("--disclosure-panel-width", "0px"), s.style.setProperty("--disclosure-panel-height", "0px")) : t.isExpanded !== d.current && (t.isExpanded ? (s.removeAttribute("hidden"), s.style.setProperty("--disclosure-panel-width", s.scrollWidth + "px"), s.style.setProperty("--disclosure-panel-height", s.scrollHeight + "px"), Promise.all(s.getAnimations().map((c) => c.finished)).then(() => {
        s.style.setProperty("--disclosure-panel-width", "auto"), s.style.setProperty("--disclosure-panel-height", "auto");
      }).catch(() => {
      })) : (s.style.setProperty("--disclosure-panel-width", s.scrollWidth + "px"), s.style.setProperty("--disclosure-panel-height", s.scrollHeight + "px"), window.getComputedStyle(s).height, s.style.setProperty("--disclosure-panel-width", "0px"), s.style.setProperty("--disclosure-panel-height", "0px"), Promise.all(s.getAnimations().map((c) => c.finished)).then(() => s.setAttribute("hidden", "until-found")).catch(() => {
      }))), d.current = t.isExpanded;
    }
  }, [
    r,
    n,
    t.isExpanded,
    i
  ]), ee(() => () => {
    u.current && cancelAnimationFrame(u.current);
  }, []), {
    buttonProps: {
      id: a,
      "aria-expanded": t.isExpanded,
      "aria-controls": l,
      onPress: (s) => {
        !r && s.pointerType !== "keyboard" && t.toggle();
      },
      isDisabled: r,
      onPressStart(s) {
        s.pointerType === "keyboard" && !r && t.toggle();
      }
    },
    panelProps: {
      id: l,
      // This can be overridden at the panel element level.
      role: "group",
      "aria-labelledby": a,
      "aria-hidden": !t.isExpanded,
      hidden: i ? !t.isExpanded : void 0
    }
  };
}
function q7(e) {
  let { allowsMultipleExpanded: t = !1, isDisabled: n = !1 } = e, [r, a] = Pe(K(() => e.expandedKeys ? new Set(e.expandedKeys) : void 0, [
    e.expandedKeys
  ]), K(() => e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), [
    e.defaultExpandedKeys
  ]), e.onExpandedChange);
  return ee(() => {
    if (!t && r.size > 1) {
      let l = r.values().next().value;
      l != null && a(/* @__PURE__ */ new Set([
        l
      ]));
    }
  }), {
    allowsMultipleExpanded: t,
    isDisabled: n,
    expandedKeys: r,
    setExpandedKeys: a,
    toggleKey(l) {
      let i;
      t ? (i = new Set(r), i.has(l) ? i.delete(l) : i.add(l)) : i = new Set(r.has(l) ? [] : [
        l
      ]), a(i);
    }
  };
}
function Y7(e) {
  let [t, n] = Pe(e.isExpanded, e.defaultExpanded || !1, e.onExpandedChange);
  const r = X(() => {
    n(!0);
  }, [
    n
  ]), a = X(() => {
    n(!1);
  }, [
    n
  ]), l = X(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isExpanded: t,
    setExpanded: n,
    expand: r,
    collapse: a,
    toggle: l
  };
}
const G0 = /* @__PURE__ */ G(null), S9 = /* @__PURE__ */ te(function(t, n) {
  let r = q7(t), a = le({
    ...t,
    defaultClassName: "react-aria-DisclosureGroup",
    values: {
      isDisabled: r.isDisabled,
      state: r
    }
  }), l = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...l,
    ...a,
    ref: n,
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ g.createElement(G0.Provider, {
    value: r
  }, a.children));
}), Z7 = /* @__PURE__ */ G(null), X7 = /* @__PURE__ */ G(null), q0 = /* @__PURE__ */ G(null), k9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Z7);
  let r = O(G0), { id: a, ...l } = t, i = ce();
  a ||= i;
  let u = r ? r.expandedKeys.has(a) : t.isExpanded, o = Y7({
    ...t,
    isExpanded: u,
    onExpandedChange(y) {
      r && r.toggleKey(a), t.onExpandedChange?.(y);
    }
  }), d = g.useRef(null), s = t.isDisabled || r?.isDisabled || !1, { buttonProps: c, panelProps: f } = G7({
    ...t,
    isExpanded: u,
    isDisabled: s
  }, o, d), { isFocusVisible: h, focusProps: m } = ye({
    within: !0
  }), p = le({
    ...t,
    id: void 0,
    defaultClassName: "react-aria-Disclosure",
    values: {
      isExpanded: o.isExpanded,
      isDisabled: s,
      isFocusVisibleWithin: h,
      state: o
    }
  }), b = J(l, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Ze,
        {
          slots: {
            [gt]: {},
            trigger: c
          }
        }
      ],
      [
        q0,
        {
          panelProps: f,
          panelRef: d
        }
      ],
      [
        X7,
        o
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(b, p, m),
    ref: n,
    "data-expanded": o.isExpanded || void 0,
    "data-disabled": s || void 0,
    "data-focus-visible-within": h || void 0
  }, p.children));
}), B9 = /* @__PURE__ */ te(function(t, n) {
  let { role: r = "group" } = t, { panelProps: a, panelRef: l } = O(q0), { isFocusVisible: i, focusProps: u } = ye({
    within: !0
  }), o = le({
    ...t,
    defaultClassName: "react-aria-DisclosurePanel",
    values: {
      isFocusVisibleWithin: i
    }
  }), d = J(t, {
    global: !0,
    labelable: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(d, o, a, u),
    ref: xt(n, l),
    role: r,
    "data-focus-visible-within": i || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Ze,
        null
      ]
    ]
  }, t.children));
}), co = /* @__PURE__ */ new WeakMap();
function $d(e, t) {
  let { id: n } = co.get(e) ?? {};
  if (!n) throw new Error("Unknown list");
  return `${n}-${J7(t)}`;
}
function J7(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
var Y0 = {};
Y0 = {
  deselectedItem: (e) => `${e.item} غير المحدد`,
  longPressToSelect: "اضغط مطولًا للدخول إلى وضع التحديد.",
  select: "تحديد",
  selectedAll: "جميع العناصر المحددة.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "لم يتم تحديد عناصر",
    one: () => `${t.number(e.count)} عنصر محدد`,
    other: () => `${t.number(e.count)} عنصر محدد`
  })}.`,
  selectedItem: (e) => `${e.item} المحدد`
};
var Z0 = {};
Z0 = {
  deselectedItem: (e) => `${e.item} не е избран.`,
  longPressToSelect: "Натиснете и задръжте за да влезете в избирателен режим.",
  select: "Изберете",
  selectedAll: "Всички елементи са избрани.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Няма избрани елементи",
    one: () => `${t.number(e.count)} избран елемент`,
    other: () => `${t.number(e.count)} избрани елементи`
  })}.`,
  selectedItem: (e) => `${e.item} избран.`
};
var X0 = {};
X0 = {
  deselectedItem: (e) => `Položka ${e.item} není vybrána.`,
  longPressToSelect: "Dlouhým stisknutím přejdete do režimu výběru.",
  select: "Vybrat",
  selectedAll: "Vybrány všechny položky.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nevybrány žádné položky",
    one: () => `Vybrána ${t.number(e.count)} položka`,
    other: () => `Vybráno ${t.number(e.count)} položek`
  })}.`,
  selectedItem: (e) => `Vybrána položka ${e.item}.`
};
var J0 = {};
J0 = {
  deselectedItem: (e) => `${e.item} ikke valgt.`,
  longPressToSelect: "Lav et langt tryk for at aktivere valgtilstand.",
  select: "Vælg",
  selectedAll: "Alle elementer valgt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ingen elementer valgt",
    one: () => `${t.number(e.count)} element valgt`,
    other: () => `${t.number(e.count)} elementer valgt`
  })}.`,
  selectedItem: (e) => `${e.item} valgt.`
};
var Q0 = {};
Q0 = {
  deselectedItem: (e) => `${e.item} nicht ausgewählt.`,
  longPressToSelect: "Gedrückt halten, um Auswahlmodus zu öffnen.",
  select: "Auswählen",
  selectedAll: "Alle Elemente ausgewählt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Keine Elemente ausgewählt",
    one: () => `${t.number(e.count)} Element ausgewählt`,
    other: () => `${t.number(e.count)} Elemente ausgewählt`
  })}.`,
  selectedItem: (e) => `${e.item} ausgewählt.`
};
var ey = {};
ey = {
  deselectedItem: (e) => `Δεν επιλέχθηκε το στοιχείο ${e.item}.`,
  longPressToSelect: "Πατήστε παρατεταμένα για να μπείτε σε λειτουργία επιλογής.",
  select: "Επιλογή",
  selectedAll: "Επιλέχθηκαν όλα τα στοιχεία.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Δεν επιλέχθηκαν στοιχεία",
    one: () => `Επιλέχθηκε ${t.number(e.count)} στοιχείο`,
    other: () => `Επιλέχθηκαν ${t.number(e.count)} στοιχεία`
  })}.`,
  selectedItem: (e) => `Επιλέχθηκε το στοιχείο ${e.item}.`
};
var ty = {};
ty = {
  deselectedItem: (e) => `${e.item} not selected.`,
  select: "Select",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "No items selected",
    one: () => `${t.number(e.count)} item selected`,
    other: () => `${t.number(e.count)} items selected`
  })}.`,
  selectedAll: "All items selected.",
  selectedItem: (e) => `${e.item} selected.`,
  longPressToSelect: "Long press to enter selection mode."
};
var ny = {};
ny = {
  deselectedItem: (e) => `${e.item} no seleccionado.`,
  longPressToSelect: "Mantenga pulsado para abrir el modo de selección.",
  select: "Seleccionar",
  selectedAll: "Todos los elementos seleccionados.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ningún elemento seleccionado",
    one: () => `${t.number(e.count)} elemento seleccionado`,
    other: () => `${t.number(e.count)} elementos seleccionados`
  })}.`,
  selectedItem: (e) => `${e.item} seleccionado.`
};
var ry = {};
ry = {
  deselectedItem: (e) => `${e.item} pole valitud.`,
  longPressToSelect: "Valikurežiimi sisenemiseks vajutage pikalt.",
  select: "Vali",
  selectedAll: "Kõik üksused valitud.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Üksusi pole valitud",
    one: () => `${t.number(e.count)} üksus valitud`,
    other: () => `${t.number(e.count)} üksust valitud`
  })}.`,
  selectedItem: (e) => `${e.item} valitud.`
};
var ay = {};
ay = {
  deselectedItem: (e) => `Kohdetta ${e.item} ei valittu.`,
  longPressToSelect: "Siirry valintatilaan painamalla pitkään.",
  select: "Valitse",
  selectedAll: "Kaikki kohteet valittu.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ei yhtään kohdetta valittu",
    one: () => `${t.number(e.count)} kohde valittu`,
    other: () => `${t.number(e.count)} kohdetta valittu`
  })}.`,
  selectedItem: (e) => `${e.item} valittu.`
};
var ly = {};
ly = {
  deselectedItem: (e) => `${e.item} non sélectionné.`,
  longPressToSelect: "Appuyez de manière prolongée pour passer en mode de sélection.",
  select: "Sélectionner",
  selectedAll: "Tous les éléments sélectionnés.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Aucun élément sélectionné",
    one: () => `${t.number(e.count)} élément sélectionné`,
    other: () => `${t.number(e.count)} éléments sélectionnés`
  })}.`,
  selectedItem: (e) => `${e.item} sélectionné.`
};
var iy = {};
iy = {
  deselectedItem: (e) => `${e.item} לא נבחר.`,
  longPressToSelect: "הקשה ארוכה לכניסה למצב בחירה.",
  select: "בחר",
  selectedAll: "כל הפריטים נבחרו.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "לא נבחרו פריטים",
    one: () => `פריט ${t.number(e.count)} נבחר`,
    other: () => `${t.number(e.count)} פריטים נבחרו`
  })}.`,
  selectedItem: (e) => `${e.item} נבחר.`
};
var uy = {};
uy = {
  deselectedItem: (e) => `Stavka ${e.item} nije odabrana.`,
  longPressToSelect: "Dugo pritisnite za ulazak u način odabira.",
  select: "Odaberite",
  selectedAll: "Odabrane su sve stavke.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nije odabrana nijedna stavka",
    one: () => `Odabrana je ${t.number(e.count)} stavka`,
    other: () => `Odabrano je ${t.number(e.count)} stavki`
  })}.`,
  selectedItem: (e) => `Stavka ${e.item} je odabrana.`
};
var oy = {};
oy = {
  deselectedItem: (e) => `${e.item} nincs kijelölve.`,
  longPressToSelect: "Nyomja hosszan a kijelöléshez.",
  select: "Kijelölés",
  selectedAll: "Az összes elem kijelölve.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Egy elem sincs kijelölve",
    one: () => `${t.number(e.count)} elem kijelölve`,
    other: () => `${t.number(e.count)} elem kijelölve`
  })}.`,
  selectedItem: (e) => `${e.item} kijelölve.`
};
var sy = {};
sy = {
  deselectedItem: (e) => `${e.item} non selezionato.`,
  longPressToSelect: "Premi a lungo per passare alla modalità di selezione.",
  select: "Seleziona",
  selectedAll: "Tutti gli elementi selezionati.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nessun elemento selezionato",
    one: () => `${t.number(e.count)} elemento selezionato`,
    other: () => `${t.number(e.count)} elementi selezionati`
  })}.`,
  selectedItem: (e) => `${e.item} selezionato.`
};
var dy = {};
dy = {
  deselectedItem: (e) => `${e.item} が選択されていません。`,
  longPressToSelect: "長押しして選択モードを開きます。",
  select: "選択",
  selectedAll: "すべての項目を選択しました。",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "項目が選択されていません",
    one: () => `${t.number(e.count)} 項目を選択しました`,
    other: () => `${t.number(e.count)} 項目を選択しました`
  })}。`,
  selectedItem: (e) => `${e.item} を選択しました。`
};
var cy = {};
cy = {
  deselectedItem: (e) => `${e.item}이(가) 선택되지 않았습니다.`,
  longPressToSelect: "선택 모드로 들어가려면 길게 누르십시오.",
  select: "선택",
  selectedAll: "모든 항목이 선택되었습니다.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "선택된 항목이 없습니다",
    one: () => `${t.number(e.count)}개 항목이 선택되었습니다`,
    other: () => `${t.number(e.count)}개 항목이 선택되었습니다`
  })}.`,
  selectedItem: (e) => `${e.item}이(가) 선택되었습니다.`
};
var fy = {};
fy = {
  deselectedItem: (e) => `${e.item} nepasirinkta.`,
  longPressToSelect: "Norėdami įjungti pasirinkimo režimą, paspauskite ir palaikykite.",
  select: "Pasirinkti",
  selectedAll: "Pasirinkti visi elementai.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nepasirinktas nė vienas elementas",
    one: () => `Pasirinktas ${t.number(e.count)} elementas`,
    other: () => `Pasirinkta elementų: ${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `Pasirinkta: ${e.item}.`
};
var hy = {};
hy = {
  deselectedItem: (e) => `Vienums ${e.item} nav atlasīts.`,
  longPressToSelect: "Ilgi turiet nospiestu. lai ieslēgtu atlases režīmu.",
  select: "Atlasīt",
  selectedAll: "Atlasīti visi vienumi.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nav atlasīts neviens vienums",
    one: () => `Atlasīto vienumu skaits: ${t.number(e.count)}`,
    other: () => `Atlasīto vienumu skaits: ${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `Atlasīts vienums ${e.item}.`
};
var my = {};
my = {
  deselectedItem: (e) => `${e.item} er ikke valgt.`,
  longPressToSelect: "Bruk et langt trykk for å gå inn i valgmodus.",
  select: "Velg",
  selectedAll: "Alle elementer er valgt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Ingen elementer er valgt",
    one: () => `${t.number(e.count)} element er valgt`,
    other: () => `${t.number(e.count)} elementer er valgt`
  })}.`,
  selectedItem: (e) => `${e.item} er valgt.`
};
var py = {};
py = {
  deselectedItem: (e) => `${e.item} niet geselecteerd.`,
  longPressToSelect: "Druk lang om de selectiemodus te openen.",
  select: "Selecteren",
  selectedAll: "Alle items geselecteerd.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Geen items geselecteerd",
    one: () => `${t.number(e.count)} item geselecteerd`,
    other: () => `${t.number(e.count)} items geselecteerd`
  })}.`,
  selectedItem: (e) => `${e.item} geselecteerd.`
};
var by = {};
by = {
  deselectedItem: (e) => `Nie zaznaczono ${e.item}.`,
  longPressToSelect: "Naciśnij i przytrzymaj, aby wejść do trybu wyboru.",
  select: "Zaznacz",
  selectedAll: "Wszystkie zaznaczone elementy.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nie zaznaczono żadnych elementów",
    one: () => `${t.number(e.count)} zaznaczony element`,
    other: () => `${t.number(e.count)} zaznaczonych elementów`
  })}.`,
  selectedItem: (e) => `Zaznaczono ${e.item}.`
};
var gy = {};
gy = {
  deselectedItem: (e) => `${e.item} não selecionado.`,
  longPressToSelect: "Mantenha pressionado para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${t.number(e.count)} item selecionado`,
    other: () => `${t.number(e.count)} itens selecionados`
  })}.`,
  selectedItem: (e) => `${e.item} selecionado.`
};
var yy = {};
yy = {
  deselectedItem: (e) => `${e.item} não selecionado.`,
  longPressToSelect: "Prima continuamente para entrar no modo de seleção.",
  select: "Selecionar",
  selectedAll: "Todos os itens selecionados.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nenhum item selecionado",
    one: () => `${t.number(e.count)} item selecionado`,
    other: () => `${t.number(e.count)} itens selecionados`
  })}.`,
  selectedItem: (e) => `${e.item} selecionado.`
};
var $y = {};
$y = {
  deselectedItem: (e) => `${e.item} neselectat.`,
  longPressToSelect: "Apăsați lung pentru a intra în modul de selectare.",
  select: "Selectare",
  selectedAll: "Toate elementele selectate.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Niciun element selectat",
    one: () => `${t.number(e.count)} element selectat`,
    other: () => `${t.number(e.count)} elemente selectate`
  })}.`,
  selectedItem: (e) => `${e.item} selectat.`
};
var vy = {};
vy = {
  deselectedItem: (e) => `${e.item} не выбрано.`,
  longPressToSelect: "Нажмите и удерживайте для входа в режим выбора.",
  select: "Выбрать",
  selectedAll: "Выбраны все элементы.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Нет выбранных элементов",
    one: () => `${t.number(e.count)} элемент выбран`,
    other: () => `${t.number(e.count)} элементов выбрано`
  })}.`,
  selectedItem: (e) => `${e.item} выбрано.`
};
var Dy = {};
Dy = {
  deselectedItem: (e) => `Nevybraté položky: ${e.item}.`,
  longPressToSelect: "Dlhším stlačením prejdite do režimu výberu.",
  select: "Vybrať",
  selectedAll: "Všetky vybraté položky.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Žiadne vybraté položky",
    one: () => `${t.number(e.count)} vybratá položka`,
    other: () => `Počet vybratých položiek:${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `Vybraté položky: ${e.item}.`
};
var xy = {};
xy = {
  deselectedItem: (e) => `Element ${e.item} ni izbran.`,
  longPressToSelect: "Za izbirni način pritisnite in dlje časa držite.",
  select: "Izberite",
  selectedAll: "Vsi elementi so izbrani.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Noben element ni izbran",
    one: () => `${t.number(e.count)} element je izbran`,
    other: () => `${t.number(e.count)} elementov je izbranih`
  })}.`,
  selectedItem: (e) => `Element ${e.item} je izbran.`
};
var Ey = {};
Ey = {
  deselectedItem: (e) => `${e.item} nije izabrano.`,
  longPressToSelect: "Dugo pritisnite za ulazak u režim biranja.",
  select: "Izaberite",
  selectedAll: "Izabrane su sve stavke.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Nije izabrana nijedna stavka",
    one: () => `Izabrana je ${t.number(e.count)} stavka`,
    other: () => `Izabrano je ${t.number(e.count)} stavki`
  })}.`,
  selectedItem: (e) => `${e.item} je izabrano.`
};
var Cy = {};
Cy = {
  deselectedItem: (e) => `${e.item} ej markerat.`,
  longPressToSelect: "Tryck länge när du vill öppna väljarläge.",
  select: "Markera",
  selectedAll: "Alla markerade objekt.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Inga markerade objekt",
    one: () => `${t.number(e.count)} markerat objekt`,
    other: () => `${t.number(e.count)} markerade objekt`
  })}.`,
  selectedItem: (e) => `${e.item} markerat.`
};
var Py = {};
Py = {
  deselectedItem: (e) => `${e.item} seçilmedi.`,
  longPressToSelect: "Seçim moduna girmek için uzun basın.",
  select: "Seç",
  selectedAll: "Tüm ögeler seçildi.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Hiçbir öge seçilmedi",
    one: () => `${t.number(e.count)} öge seçildi`,
    other: () => `${t.number(e.count)} öge seçildi`
  })}.`,
  selectedItem: (e) => `${e.item} seçildi.`
};
var wy = {};
wy = {
  deselectedItem: (e) => `${e.item} не вибрано.`,
  longPressToSelect: "Виконайте довге натиснення, щоб перейти в режим вибору.",
  select: "Вибрати",
  selectedAll: "Усі елементи вибрано.",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "Жодних елементів не вибрано",
    one: () => `${t.number(e.count)} елемент вибрано`,
    other: () => `Вибрано елементів: ${t.number(e.count)}`
  })}.`,
  selectedItem: (e) => `${e.item} вибрано.`
};
var Sy = {};
Sy = {
  deselectedItem: (e) => `未选择 ${e.item}。`,
  longPressToSelect: "长按以进入选择模式。",
  select: "选择",
  selectedAll: "已选择所有项目。",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "未选择项目",
    one: () => `已选择 ${t.number(e.count)} 个项目`,
    other: () => `已选择 ${t.number(e.count)} 个项目`
  })}。`,
  selectedItem: (e) => `已选择 ${e.item}。`
};
var ky = {};
ky = {
  deselectedItem: (e) => `未選取「${e.item}」。`,
  longPressToSelect: "長按以進入選擇模式。",
  select: "選取",
  selectedAll: "已選取所有項目。",
  selectedCount: (e, t) => `${t.plural(e.count, {
    "=0": "未選取任何項目",
    one: () => `已選取 ${t.number(e.count)} 個項目`,
    other: () => `已選取 ${t.number(e.count)} 個項目`
  })}。`,
  selectedItem: (e) => `已選取「${e.item}」。`
};
var Il = {};
Il = {
  "ar-AE": Y0,
  "bg-BG": Z0,
  "cs-CZ": X0,
  "da-DK": J0,
  "de-DE": Q0,
  "el-GR": ey,
  "en-US": ty,
  "es-ES": ny,
  "et-EE": ry,
  "fi-FI": ay,
  "fr-FR": ly,
  "he-IL": iy,
  "hr-HR": uy,
  "hu-HU": oy,
  "it-IT": sy,
  "ja-JP": dy,
  "ko-KR": cy,
  "lt-LT": fy,
  "lv-LV": hy,
  "nb-NO": my,
  "nl-NL": py,
  "pl-PL": by,
  "pt-BR": gy,
  "pt-PT": yy,
  "ro-RO": $y,
  "ru-RU": vy,
  "sk-SK": Dy,
  "sl-SI": xy,
  "sr-SP": Ey,
  "sv-SE": Cy,
  "tr-TR": Py,
  "uk-UA": wy,
  "zh-CN": Sy,
  "zh-TW": ky
};
function Q7(e) {
  return e && e.__esModule ? e.default : e;
}
function By(e, t) {
  let { getRowText: n = (u) => t.collection.getTextValue?.(u) ?? t.collection.getItem(u)?.textValue } = e, r = xe(Q7(Il), "@react-aria/grid"), a = t.selectionManager.rawSelection, l = T(a), i = X(() => {
    if (!t.selectionManager.isFocused || a === l.current) {
      l.current = a;
      return;
    }
    let u = vd(a, l.current), o = vd(l.current, a), d = t.selectionManager.selectionBehavior === "replace", s = [];
    if (t.selectionManager.selectedKeys.size === 1 && d) {
      let c = t.selectionManager.selectedKeys.keys().next().value;
      if (c != null && t.collection.getItem(c)) {
        let f = n(c);
        f && s.push(r.format("selectedItem", {
          item: f
        }));
      }
    } else if (u.size === 1 && o.size === 0) {
      let c = u.keys().next().value;
      if (c != null) {
        let f = n(c);
        f && s.push(r.format("selectedItem", {
          item: f
        }));
      }
    } else if (o.size === 1 && u.size === 0) {
      let c = o.keys().next().value;
      if (c != null && t.collection.getItem(c)) {
        let f = n(c);
        f && s.push(r.format("deselectedItem", {
          item: f
        }));
      }
    }
    t.selectionManager.selectionMode === "multiple" && (s.length === 0 || a === "all" || a.size > 1 || l.current === "all" || l.current?.size > 1) && s.push(a === "all" ? r.format("selectedAll") : r.format("selectedCount", {
      count: a.size
    })), s.length > 0 && bn(s.join(" ")), l.current = a;
  }, [
    a,
    t.selectionManager.selectedKeys,
    t.selectionManager.isFocused,
    t.selectionManager.selectionBehavior,
    t.selectionManager.selectionMode,
    t.collection,
    n,
    r
  ]);
  ll(() => {
    if (t.selectionManager.isFocused) i();
    else {
      let u = requestAnimationFrame(i);
      return () => cancelAnimationFrame(u);
    }
  }, [
    a,
    t.selectionManager.isFocused
  ]);
}
function vd(e, t) {
  let n = /* @__PURE__ */ new Set();
  if (e === "all" || t === "all") return n;
  for (let r of e.keys()) t.has(r) || n.add(r);
  return n;
}
function fo(e, t) {
  let n = t?.isDisabled, [r, a] = Y(!1);
  return ue(() => {
    if (e?.current && !n) {
      let l = () => {
        if (e.current) {
          let u = Te(e.current, {
            tabbable: !0
          });
          a(!!u.nextNode());
        }
      };
      l();
      let i = new MutationObserver(l);
      return i.observe(e.current, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: [
          "tabIndex",
          "disabled"
        ]
      }), () => {
        i.disconnect();
      };
    }
  }), n ? !1 : r;
}
function eE(e) {
  return e && e.__esModule ? e.default : e;
}
function Fy(e) {
  let t = xe(eE(Il), "@react-aria/grid"), n = yl(), r = (n === "pointer" || n === "virtual" || n == null) && typeof window < "u" && "ontouchstart" in window, a = K(() => {
    let i = e.selectionManager.selectionMode, u = e.selectionManager.selectionBehavior, o;
    return r && (o = t.format("longPressToSelect")), u === "replace" && i !== "none" && e.hasItemActions ? o : void 0;
  }, [
    e.selectionManager.selectionMode,
    e.selectionManager.selectionBehavior,
    e.hasItemActions,
    t,
    r
  ]);
  return en(a);
}
function tE(e, t, n) {
  let { isVirtualized: r, keyboardDelegate: a, layoutDelegate: l, onAction: i, disallowTypeAhead: u, linkBehavior: o = "action", keyboardNavigationBehavior: d = "arrow", escapeKeyBehavior: s = "clearSelection", shouldSelectOnPressUp: c } = e;
  !e["aria-label"] && !e["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let { listProps: f } = no({
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    ref: n,
    keyboardDelegate: a,
    layoutDelegate: l,
    isVirtualized: r,
    selectOnFocus: t.selectionManager.selectionBehavior === "replace",
    shouldFocusWrap: e.shouldFocusWrap,
    linkBehavior: o,
    disallowTypeAhead: u,
    autoFocus: e.autoFocus,
    escapeKeyBehavior: s,
    UNSTABLE_focusOnEntry: e.UNSTABLE_focusOnEntry
  }), h = ce(e.id);
  co.set(t, {
    id: h,
    onAction: i,
    linkBehavior: o,
    keyboardNavigationBehavior: d,
    shouldSelectOnPressUp: c
  });
  let m = Fy({
    selectionManager: t.selectionManager,
    hasItemActions: !!i
  }), p = fo(n, {
    isDisabled: t.collection.size !== 0
  }), b = J(e, {
    labelable: !0
  }), y = z(
    b,
    {
      role: "grid",
      id: h,
      "aria-multiselectable": t.selectionManager.selectionMode === "multiple" ? "true" : void 0
    },
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    t.collection.size === 0 ? {
      tabIndex: p ? -1 : 0
    } : f,
    m
  );
  return r && (y["aria-rowcount"] = t.collection.size, y["aria-colcount"] = 1), By({}, t), {
    gridProps: y
  };
}
const Dd = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function nE(e, t, n) {
  let { node: r, isVirtualized: a } = e, { direction: l } = de(), { onAction: i, linkBehavior: u, keyboardNavigationBehavior: o, shouldSelectOnPressUp: d } = co.get(t), s = bt(), c = T(null), f = () => {
    n.current !== null && (c.current != null && r.key !== c.current || !qt(n.current)) && we(n.current);
  }, h = {}, m = e.hasChildItems, p = t.selectionManager.isLink(r.key);
  if (r != null && "expandedKeys" in t) {
    let A = t.collection.getChildren?.(r.key);
    m = m || [
      ...A ?? []
    ].length > 1, i == null && !p && t.selectionManager.selectionMode === "none" && m && (i = () => t.toggleKey(r.key));
    let U = m ? t.expandedKeys.has(r.key) : void 0, D = 1, N = r.index;
    if (r.level >= 0 && r?.parentKey != null) {
      let w = t.collection.getItem(r.parentKey);
      if (w) {
        let R = rE(w, t.collection);
        D = [
          ...R
        ].filter((H) => H.type === "item").length, N > 0 && R[0].type !== "item" && (N -= 1);
      }
    } else D = [
      ...t.collection
    ].filter((w) => w.level === 0 && w.type === "item").length;
    h = {
      "aria-expanded": U,
      "aria-level": r.level + 1,
      "aria-posinset": N + 1,
      "aria-setsize": D
    };
  }
  let { itemProps: b, ...y } = Sr({
    selectionManager: t.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: a,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp || d,
    onAction: i || r.props?.onAction ? ot(r.props?.onAction, i ? () => i(r.key) : void 0) : void 0,
    focus: f,
    linkBehavior: u
  }), $ = (A) => {
    let U = se();
    if (!ae(A.currentTarget, W(A)) || !n.current || !U) return;
    let D = Te(n.current);
    if (D.currentNode = U, !xd(A, t, r, m, l, U, n.current))
      switch (A.key) {
        case "ArrowLeft":
          if (o === "arrow") {
            let N = l === "rtl" ? D.nextNode() : D.previousNode();
            if (N)
              A.preventDefault(), A.stopPropagation(), we(N), ze(N, {
                containingElement: Le(n.current)
              });
            else if (A.preventDefault(), A.stopPropagation(), l === "rtl")
              we(n.current), ze(n.current, {
                containingElement: Le(n.current)
              });
            else {
              D.currentNode = n.current;
              let w = Ed(D);
              w && (we(w), ze(w, {
                containingElement: Le(n.current)
              }));
            }
          }
          break;
        case "ArrowRight":
          if (o === "arrow") {
            let N = l === "rtl" ? D.previousNode() : D.nextNode();
            if (N)
              A.preventDefault(), A.stopPropagation(), we(N), ze(N, {
                containingElement: Le(n.current)
              });
            else if (A.preventDefault(), A.stopPropagation(), l === "ltr")
              we(n.current), ze(n.current, {
                containingElement: Le(n.current)
              });
            else {
              D.currentNode = n.current;
              let w = Ed(D);
              w && (we(w), ze(w, {
                containingElement: Le(n.current)
              }));
            }
          }
          break;
        case "ArrowUp":
        case "ArrowDown":
          !A.altKey && ae(n.current, W(A)) && (A.stopPropagation(), A.preventDefault(), n.current.parentElement?.dispatchEvent(new KeyboardEvent(A.nativeEvent.type, A.nativeEvent)));
          break;
      }
  }, v = (A) => {
    if (c.current = r.key, W(A) !== n.current) {
      Mt() || t.selectionManager.setFocusedKey(r.key);
      return;
    }
  }, x = (A) => {
    let U = se();
    if (!(!ae(A.currentTarget, W(A)) || !n.current || !U)) {
      if (o === "tab") {
        if (W(A) !== n.current && A.key !== "Tab") {
          A.stopPropagation();
          return;
        }
        if (xd(A, t, r, m, l, U, n.current)) return;
      }
      switch (A.key) {
        case "Tab":
          if (o === "tab") {
            let D = Te(n.current, {
              tabbable: !0
            });
            D.currentNode = U, (A.shiftKey ? D.previousNode() : D.nextNode()) && A.stopPropagation();
          }
      }
    }
  }, E = yu(r.props), P = y.hasAction ? E : {}, C = z(b, P, {
    role: "row",
    onKeyDownCapture: o === "arrow" ? $ : void 0,
    onFocus: v,
    // 'aria-label': [(node.textValue || undefined), rowAnnouncement].filter(Boolean).join(', '),
    "aria-label": r["aria-label"] || r.textValue || void 0,
    "aria-selected": t.selectionManager.canSelectItem(r.key) ? t.selectionManager.isSelected(r.key) : void 0,
    "aria-disabled": t.selectionManager.isDisabled(r.key) || void 0,
    "aria-labelledby": s && (r["aria-label"] || r.textValue) ? `${$d(t, r.key)} ${s}` : void 0,
    id: $d(t, r.key)
  }), M = C.onKeyDown;
  C.onKeyDown = (A) => {
    x(A), A.isPropagationStopped() || M?.(A);
  };
  let F = C.onPointerDown;
  C.onPointerDown = (A) => {
    let U = W(A);
    if (U && U !== n.current && _a(U)) {
      A.stopPropagation();
      return;
    }
    F?.(A);
  };
  let V = C.onMouseDown;
  if (C.onMouseDown = (A) => {
    let U = W(A);
    if (U && U !== n.current && _a(U)) {
      A.stopPropagation();
      return;
    }
    V?.(A);
  }, a) {
    let { collection: A } = t, U = [
      ...A
    ];
    C["aria-rowindex"] = U.find((D) => D.type === "section") ? [
      ...A.getKeys()
    ].filter((D) => A.getItem(D)?.type !== "section").findIndex((D) => D === r.key) + 1 : r.index + 1;
  }
  let I = {
    role: "gridcell",
    "aria-colindex": 1
  };
  return {
    rowProps: {
      ...z(C, h)
    },
    gridCellProps: I,
    descriptionProps: {
      id: s
    },
    ...y
  };
}
function xd(e, t, n, r, a, l, i) {
  if (!("expandedKeys" in t) || l !== i) return !1;
  if (e.key === Dd.expand[a] && t.selectionManager.focusedKey === n.key && r && !t.expandedKeys.has(n.key))
    return t.toggleKey(n.key), e.stopPropagation(), !0;
  if (e.key === Dd.collapse[a] && t.selectionManager.focusedKey === n.key) {
    if (r && t.expandedKeys.has(n.key))
      return t.toggleKey(n.key), e.stopPropagation(), !0;
    if (!t.expandedKeys.has(n.key) && n.parentKey && t.collection.getItem(n.parentKey)?.type === "item")
      return t.selectionManager.setFocusedKey(n.parentKey), e.stopPropagation(), !0;
  }
  return !1;
}
function Ed(e) {
  let t = null, n = null;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
function rE(e, t) {
  let n = t.getChildren?.(e.key), r = n ? Array.from(n) : [], a = r.length > 0 ? r[0] : null, l = [];
  for (; a; )
    l.push(a), a = a.nextKey != null ? t.getItem(a.nextKey) : null;
  return l;
}
function aE(e) {
  return e && e.__esModule ? e.default : e;
}
function lE(e, t) {
  let { key: n } = e, r = t.selectionManager, a = ce(), l = !t.selectionManager.canSelectItem(n), i = t.selectionManager.isSelected(n), u = () => r.toggleSelection(n);
  const o = xe(aE(Il), "@react-aria/grid");
  return {
    checkboxProps: {
      id: a,
      "aria-label": o.format("select"),
      isSelected: i,
      isDisabled: l,
      onChange: u
    }
  };
}
function iE(e, t, n) {
  let { overlayProps: r, underlayProps: a } = Jp({
    ...e,
    isOpen: t.isOpen,
    onClose: t.close
  }, n);
  return Qp({
    isDisabled: !t.isOpen
  }), Nb(), ee(() => {
    if (t.isOpen && n.current) return qp([
      n.current
    ], {
      shouldUseInert: !0
    });
  }, [
    t.isOpen,
    n
  ]), {
    modalProps: z(r),
    underlayProps: a
  };
}
let Ge = typeof document < "u" && window.visualViewport;
function uE() {
  let e = Dt(), [t, n] = Y(() => e ? {
    width: 0,
    height: 0
  } : mi());
  return ee(() => {
    let r = (u) => {
      n((o) => u.width === o.width && u.height === o.height ? o : u);
    }, a = () => {
      Ge && Ge.scale > 1 || r(mi());
    }, l, i = (u) => {
      Ge && Ge.scale > 1 || jr(W(u)) && (l = requestAnimationFrame(() => {
        let o = se();
        (!o || !jr(o)) && r({
          width: document.documentElement.clientWidth,
          height: document.documentElement.clientHeight
        });
      }));
    };
    return r(mi()), vt() && window.addEventListener("blur", i, !0), Ge ? Ge.addEventListener("resize", a) : window.addEventListener("resize", a), () => {
      cancelAnimationFrame(l), vt() && window.removeEventListener("blur", i, !0), Ge ? Ge.removeEventListener("resize", a) : window.removeEventListener("resize", a);
    };
  }, []), t;
}
function mi() {
  return {
    // Multiply by the visualViewport scale to get the "natural" size, unaffected by pinch zooming.
    width: Ge ? (
      // the visual viewport and the document element to ensure that the scrollbar width is always excluded.
      // See: https://github.com/w3c/csswg-drafts/issues/8099
      Math.min(Ge.width * Ge.scale, document.documentElement.clientWidth)
    ) : document.documentElement.clientWidth,
    height: Ge ? Ge.height * Ge.scale : document.documentElement.clientHeight
  };
}
const oE = /* @__PURE__ */ G(null), ho = /* @__PURE__ */ G(null), F9 = /* @__PURE__ */ te(function(t, n) {
  if (O(ho)) {
    if (process.env.NODE_ENV !== "production" && (t.onOpenChange || t.defaultOpen !== void 0 || t.isOpen !== void 0)) {
      const p = /* @__PURE__ */ new Set([
        "isDismissable",
        "isKeyboardDismissDisabled",
        "isOpen",
        "defaultOpen",
        "onOpenChange",
        "isEntering",
        "isExiting",
        "UNSTABLE_portalContainer",
        "shouldCloseOnInteractOutside"
      ]), b = Object.keys(t).filter((y) => p.has(y));
      console.warn(`This modal is already wrapped in a ModalOverlay, props [${b.join(", ")}] should be placed on the ModalOverlay instead.`);
    }
    return /* @__PURE__ */ g.createElement(Cd, {
      ...t,
      modalRef: n
    }, t.children);
  }
  let { isDismissable: a, isKeyboardDismissDisabled: l, isOpen: i, defaultOpen: u, onOpenChange: o, children: d, isEntering: s, isExiting: c, UNSTABLE_portalContainer: f, shouldCloseOnInteractOutside: h, ...m } = t;
  return /* @__PURE__ */ g.createElement(dE, {
    isDismissable: a,
    isKeyboardDismissDisabled: l,
    isOpen: i,
    defaultOpen: u,
    onOpenChange: o,
    isEntering: s,
    isExiting: c,
    UNSTABLE_portalContainer: f,
    shouldCloseOnInteractOutside: h
  }, /* @__PURE__ */ g.createElement(Cd, {
    ...m,
    modalRef: n
  }, d));
});
function sE(e, t) {
  [e, t] = oe(e, t, oE);
  let n = O(Vt), r = Br(e), a = e.isOpen != null || e.defaultOpen != null || !n ? r : n;
  a === n && process.env.NODE_ENV !== "production" && (e.onOpenChange || e.defaultOpen !== void 0 || e.isOpen !== void 0) && console.warn("This modals state is controlled by a trigger, place onOpenChange on the trigger instead.");
  let l = $e(t), i = T(null), u = sa(l, a.isOpen), o = sa(i, a.isOpen), d = u || o || e.isExiting || !1, s = Dt();
  return !a.isOpen && !d || s ? null : /* @__PURE__ */ g.createElement(cE, {
    ...e,
    state: a,
    isExiting: d,
    overlayRef: l,
    modalRef: i
  });
}
const dE = /* @__PURE__ */ te(sE);
function cE({ UNSTABLE_portalContainer: e, ...t }) {
  let n = t.modalRef, { state: r } = t, { modalProps: a, underlayProps: l } = iE(t, r, n), i = va(t.overlayRef) || t.isEntering || !1, u = le({
    ...t,
    defaultClassName: "react-aria-ModalOverlay",
    values: {
      isEntering: i,
      isExiting: t.isExiting,
      state: r
    }
  }), o = uE(), d, s;
  if (typeof document < "u") {
    let f = gn(document.body) ? document.body : document.scrollingElement || document.documentElement, h = f.getBoundingClientRect().width % 1, m = f.getBoundingClientRect().height % 1;
    d = f.scrollWidth - h, s = f.scrollHeight - m;
  }
  let c = {
    ...u.style,
    "--visual-viewport-width": o.width + "px",
    "--visual-viewport-height": o.height + "px",
    "--page-width": d !== void 0 ? d + "px" : void 0,
    "--page-height": s !== void 0 ? s + "px" : void 0
  };
  return /* @__PURE__ */ g.createElement(eu, {
    isExiting: t.isExiting,
    portalContainer: e
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(J(t, {
      global: !0
    }), l),
    ...u,
    style: c,
    ref: t.overlayRef,
    "data-entering": i || void 0,
    "data-exiting": t.isExiting || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        ho,
        {
          modalProps: a,
          modalRef: n,
          isExiting: t.isExiting,
          isDismissable: t.isDismissable
        }
      ],
      [
        Vt,
        r
      ]
    ]
  }, u.children)));
}
function Cd(e) {
  let { modalProps: t, modalRef: n, isExiting: r, isDismissable: a } = O(ho), l = O(Vt), i = K(() => xt(e.modalRef, n), [
    e.modalRef,
    n
  ]), u = $e(i), o = va(u), d = le({
    ...e,
    defaultClassName: "react-aria-Modal",
    values: {
      isEntering: o,
      isExiting: r,
      state: l
    }
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(J(e, {
      global: !0
    }), t),
    ...d,
    ref: u,
    "data-entering": o || void 0,
    "data-exiting": r || void 0
  }, a && /* @__PURE__ */ g.createElement(Qi, {
    onDismiss: l.close
  }), d.children);
}
const fE = /* @__PURE__ */ G(null), hE = /* @__PURE__ */ G(null), A9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, fE);
  let { validationBehavior: r } = Oe(Un) || {}, a = t.validationBehavior ?? r ?? "native", { locale: l } = de(), i = _m({
    ...t,
    locale: l,
    validationBehavior: a
  }), u = T(null), [o, d] = Je(!t["aria-label"] && !t["aria-labelledby"]), { labelProps: s, groupProps: c, inputProps: f, incrementButtonProps: h, decrementButtonProps: m, descriptionProps: p, errorMessageProps: b, ...y } = Um({
    ...Et(t),
    label: d,
    validationBehavior: a
  }, i, u), $ = le({
    ...t,
    values: {
      state: i,
      isDisabled: t.isDisabled || !1,
      isInvalid: y.isInvalid || !1,
      isRequired: t.isRequired || !1,
      isReadOnly: t.isReadOnly || !1
    },
    defaultClassName: "react-aria-NumberField"
  }), v = J(t, {
    global: !0
  });
  return delete v.id, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        hE,
        i
      ],
      [
        vn,
        c
      ],
      [
        Pr,
        {
          ...f,
          ref: u
        }
      ],
      [
        Qe,
        {
          ...s,
          ref: o
        }
      ],
      [
        Ze,
        {
          slots: {
            increment: h,
            decrement: m
          }
        }
      ],
      [
        _e,
        {
          slots: {
            description: p,
            errorMessage: b
          }
        }
      ],
      [
        nn,
        y
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...v,
    ...$,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0,
    "data-invalid": y.isInvalid || void 0
  }), t.name && /* @__PURE__ */ g.createElement("input", {
    type: "hidden",
    name: t.name,
    form: t.form,
    value: isNaN(i.numberValue) ? "" : i.numberValue,
    disabled: t.isDisabled || void 0
  }));
}), Ay = /* @__PURE__ */ new WeakMap();
function mE(e, t, n) {
  let { value: r, children: a, "aria-label": l, "aria-labelledby": i, onPressStart: u, onPressEnd: o, onPressChange: d, onPress: s, onPressUp: c, onClick: f } = e;
  const h = e.isDisabled || t.isDisabled;
  let m = a != null, p = l != null || i != null;
  !m && !p && process.env.NODE_ENV !== "production" && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let b = t.selectedValue === r, y = (w) => {
    w.stopPropagation(), t.setSelectedValue(r);
  }, { pressProps: $, isPressed: v } = Xe({
    onPressStart: u,
    onPressEnd: o,
    onPressChange: d,
    onPress: s,
    onPressUp: c,
    onClick: f,
    isDisabled: h
  }), { pressProps: x, isPressed: E } = Xe({
    onPressStart: u,
    onPressEnd: o,
    onPressChange: d,
    onPressUp: c,
    onClick: f,
    isDisabled: h,
    onPress(w) {
      s?.(w), t.setSelectedValue(r), n.current?.focus();
    }
  }), { focusableProps: P } = dt(z(e, {
    onFocus: () => t.setLastFocusedValue(r)
  }), n), C = z($, P), M = J(e, {
    labelable: !0
  }), F = -1;
  t.selectedValue != null ? t.selectedValue === r && (F = 0) : (t.lastFocusedValue === r || t.lastFocusedValue == null) && (F = 0), h && (F = void 0);
  let { name: V, form: I, descriptionId: A, errorMessageId: U, validationBehavior: D } = Ay.get(t);
  an(n, t.defaultSelectedValue, t.setSelectedValue), ga({
    validationBehavior: D
  }, t, n);
  let N = Ui();
  return {
    labelProps: z(x, K(() => ({
      onClick: (w) => w.preventDefault(),
      // Prevent label from being focused when mouse down on it.
      // Note, this does not prevent the input from being focused in the `click` event.
      onMouseDown: (w) => w.preventDefault()
    }), [])),
    inputProps: z(M, {
      ...C,
      type: "radio",
      name: V,
      form: I,
      tabIndex: F,
      disabled: h,
      required: t.isRequired && D === "native",
      checked: b,
      value: r,
      onChange: y,
      "aria-describedby": [
        e["aria-describedby"],
        N.id,
        t.isInvalid ? U : null,
        A
      ].filter(Boolean).join(" ") || void 0
    }),
    descriptionProps: N,
    isDisabled: h,
    isSelected: b,
    isPressed: v || E
  };
}
function pE(e, t) {
  let { name: n, form: r, isReadOnly: a, isRequired: l, isDisabled: i, orientation: u = "vertical", validationBehavior: o = "aria" } = e, { direction: d } = de(), { isInvalid: s, validationErrors: c, validationDetails: f } = t.displayValidation, { labelProps: h, fieldProps: m, descriptionProps: p, errorMessageProps: b } = Cr({
    ...e,
    // Radio group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: t.isInvalid,
    errorMessage: e.errorMessage || c
  }), y = J(e, {
    labelable: !0
  }), { focusWithinProps: $ } = ct({
    onBlurWithin(E) {
      e.onBlur?.(E), t.selectedValue || t.setLastFocusedValue(null);
    },
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  }), v = (E) => {
    let P;
    switch (E.key) {
      case "ArrowRight":
        d === "rtl" && u !== "vertical" ? P = "prev" : P = "next";
        break;
      case "ArrowLeft":
        d === "rtl" && u !== "vertical" ? P = "next" : P = "prev";
        break;
      case "ArrowDown":
        P = "next";
        break;
      case "ArrowUp":
        P = "prev";
        break;
      default:
        return;
    }
    E.preventDefault();
    let C = Te(E.currentTarget, {
      from: W(E),
      accept: (F) => F instanceof ke(F).HTMLInputElement && F.type === "radio"
    }), M;
    P === "next" ? (M = C.nextNode(), M || (C.currentNode = E.currentTarget, M = C.firstChild())) : (M = C.previousNode(), M || (C.currentNode = E.currentTarget, M = C.lastChild())), M && (M.focus(), t.setSelectedValue(M.value));
  }, x = ce(n);
  return Ay.set(t, {
    name: x,
    form: r,
    descriptionId: p.id,
    errorMessageId: b.id,
    validationBehavior: o
  }), {
    radioGroupProps: z(y, {
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: "radiogroup",
      onKeyDown: v,
      "aria-invalid": t.isInvalid || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-readonly": a || void 0,
      "aria-required": l || void 0,
      "aria-disabled": i || void 0,
      "aria-orientation": u,
      ...m,
      ...$
    }),
    labelProps: h,
    descriptionProps: p,
    errorMessageProps: b,
    isInvalid: s,
    validationErrors: c,
    validationDetails: f
  };
}
let bE = Math.round(Math.random() * 1e10), gE = 0;
function yE(e) {
  let t = K(() => e.name || `radio-group-${bE}-${++gE}`, [
    e.name
  ]), [n, r] = Pe(e.value, e.defaultValue ?? null, e.onChange), [a] = Y(n), [l, i] = Y(null), u = rn({
    ...e,
    value: n
  }), o = (s) => {
    !e.isReadOnly && !e.isDisabled && (r(s), u.commitValidation());
  }, d = u.displayValidation.isInvalid;
  return {
    ...u,
    name: t,
    selectedValue: n,
    defaultSelectedValue: e.value !== void 0 ? a : e.defaultValue ?? null,
    setSelectedValue: o,
    lastFocusedValue: l,
    setLastFocusedValue: i,
    isDisabled: e.isDisabled || !1,
    isReadOnly: e.isReadOnly || !1,
    isRequired: e.isRequired || !1,
    validationState: e.validationState || (d ? "invalid" : null),
    isInvalid: d
  };
}
const $E = /* @__PURE__ */ G(null), vE = /* @__PURE__ */ G(null), mo = /* @__PURE__ */ G(null), R9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, $E);
  let { validationBehavior: r } = Oe(Un) || {}, a = t.validationBehavior ?? r ?? "native", l = yE({
    ...t,
    validationBehavior: a
  }), [i, u] = Je(!t["aria-label"] && !t["aria-labelledby"]), { radioGroupProps: o, labelProps: d, descriptionProps: s, errorMessageProps: c, ...f } = pE({
    ...t,
    label: u,
    validationBehavior: a
  }, l), h = le({
    ...t,
    values: {
      orientation: t.orientation || "vertical",
      isDisabled: l.isDisabled,
      isReadOnly: l.isReadOnly,
      isRequired: l.isRequired,
      isInvalid: l.isInvalid,
      state: l
    },
    defaultClassName: "react-aria-RadioGroup"
  }), m = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(m, h, o),
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": t.orientation || "vertical",
    "data-invalid": l.isInvalid || void 0,
    "data-disabled": l.isDisabled || void 0,
    "data-readonly": l.isReadOnly || void 0,
    "data-required": l.isRequired || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        mo,
        l
      ],
      [
        Qe,
        {
          ...d,
          ref: i,
          elementType: "span"
        }
      ],
      [
        _e,
        {
          slots: {
            description: s,
            errorMessage: c
          }
        }
      ],
      [
        nn,
        f
      ]
    ]
  }, /* @__PURE__ */ g.createElement(jn, null, h.children)));
}), T9 = /* @__PURE__ */ te(function(t, n) {
  let { inputRef: r = null, ...a } = t;
  [t, n] = oe(a, n, vE);
  let l = g.useContext(mo), i = $e(K(() => xt(r, t.inputRef !== void 0 ? t.inputRef : null), [
    r,
    t.inputRef
  ])), u = mE({
    ...Et(t),
    // ReactNode type doesn't allow function children.
    children: typeof t.children == "function" ? !0 : t.children
  }, l, i);
  return /* @__PURE__ */ g.createElement(Ry.Provider, {
    value: {
      ...u,
      inputRef: i,
      defaultClassName: "react-aria-Radio"
    }
  }, /* @__PURE__ */ g.createElement(DE, {
    ...t,
    ref: n
  }));
}), Ry = /* @__PURE__ */ G(null), DE = /* @__PURE__ */ te(function(t, n) {
  let { labelProps: r, inputProps: a, isSelected: l, isDisabled: i, isPressed: u, defaultClassName: o, inputRef: d } = O(Ry), s = g.useContext(mo), { isFocused: c, isFocusVisible: f, focusProps: h } = ye(), m = i || s.isReadOnly, { hoverProps: p, isHovered: b } = ve({
    ...t,
    isDisabled: m
  }), y = le({
    ...t,
    defaultClassName: o,
    values: {
      isSelected: l,
      isPressed: u,
      isHovered: b,
      isFocused: c,
      isFocusVisible: f,
      isDisabled: i,
      isReadOnly: s.isReadOnly,
      isInvalid: s.isInvalid,
      isRequired: s.isRequired
    }
  }), $ = J(t, {
    global: !0
  });
  return delete $.id, delete $.onClick, /* @__PURE__ */ g.createElement(Q.label, {
    ...z($, r, p, y),
    ref: n,
    "data-selected": l || void 0,
    "data-pressed": u || void 0,
    "data-hovered": b || void 0,
    "data-focused": c || void 0,
    "data-focus-visible": f || void 0,
    "data-disabled": i || void 0,
    "data-readonly": s.isReadOnly || void 0,
    "data-invalid": s.isInvalid || void 0,
    "data-required": s.isRequired || void 0
  }, /* @__PURE__ */ g.createElement(br, {
    elementType: "span"
  }, /* @__PURE__ */ g.createElement("input", {
    ...z(a, h),
    ref: d
  })), y.children);
});
var Ty = {};
Ty = {
  "Clear search": "مسح البحث"
};
var Iy = {};
Iy = {
  "Clear search": "Изчистване на търсене"
};
var My = {};
My = {
  "Clear search": "Vymazat hledání"
};
var Ky = {};
Ky = {
  "Clear search": "Ryd søgning"
};
var Ny = {};
Ny = {
  "Clear search": "Suche zurücksetzen"
};
var Vy = {};
Vy = {
  "Clear search": "Απαλοιφή αναζήτησης"
};
var Ly = {};
Ly = {
  "Clear search": "Clear search"
};
var zy = {};
zy = {
  "Clear search": "Borrar búsqueda"
};
var Oy = {};
Oy = {
  "Clear search": "Tühjenda otsing"
};
var Hy = {};
Hy = {
  "Clear search": "Tyhjennä haku"
};
var Uy = {};
Uy = {
  "Clear search": "Effacer la recherche"
};
var jy = {};
jy = {
  "Clear search": "נקה חיפוש"
};
var _y = {};
_y = {
  "Clear search": "Obriši pretragu"
};
var Wy = {};
Wy = {
  "Clear search": "Keresés törlése"
};
var Gy = {};
Gy = {
  "Clear search": "Cancella ricerca"
};
var qy = {};
qy = {
  "Clear search": "検索をクリア"
};
var Yy = {};
Yy = {
  "Clear search": "검색 지우기"
};
var Zy = {};
Zy = {
  "Clear search": "Išvalyti iešką"
};
var Xy = {};
Xy = {
  "Clear search": "Notīrīt meklēšanu"
};
var Jy = {};
Jy = {
  "Clear search": "Tøm søk"
};
var Qy = {};
Qy = {
  "Clear search": "Zoekactie wissen"
};
var e$ = {};
e$ = {
  "Clear search": "Wyczyść zawartość wyszukiwania"
};
var t$ = {};
t$ = {
  "Clear search": "Limpar pesquisa"
};
var n$ = {};
n$ = {
  "Clear search": "Limpar pesquisa"
};
var r$ = {};
r$ = {
  "Clear search": "Ştergeţi căutarea"
};
var a$ = {};
a$ = {
  "Clear search": "Очистить поиск"
};
var l$ = {};
l$ = {
  "Clear search": "Vymazať vyhľadávanie"
};
var i$ = {};
i$ = {
  "Clear search": "Počisti iskanje"
};
var u$ = {};
u$ = {
  "Clear search": "Obriši pretragu"
};
var o$ = {};
o$ = {
  "Clear search": "Rensa sökning"
};
var s$ = {};
s$ = {
  "Clear search": "Aramayı temizle"
};
var d$ = {};
d$ = {
  "Clear search": "Очистити пошук"
};
var c$ = {};
c$ = {
  "Clear search": "清除搜索"
};
var f$ = {};
f$ = {
  "Clear search": "清除搜尋條件"
};
var h$ = {};
h$ = {
  "ar-AE": Ty,
  "bg-BG": Iy,
  "cs-CZ": My,
  "da-DK": Ky,
  "de-DE": Ny,
  "el-GR": Vy,
  "en-US": Ly,
  "es-ES": zy,
  "et-EE": Oy,
  "fi-FI": Hy,
  "fr-FR": Uy,
  "he-IL": jy,
  "hr-HR": _y,
  "hu-HU": Wy,
  "it-IT": Gy,
  "ja-JP": qy,
  "ko-KR": Yy,
  "lt-LT": Zy,
  "lv-LV": Xy,
  "nb-NO": Jy,
  "nl-NL": Qy,
  "pl-PL": e$,
  "pt-BR": t$,
  "pt-PT": n$,
  "ro-RO": r$,
  "ru-RU": a$,
  "sk-SK": l$,
  "sl-SI": i$,
  "sr-SP": u$,
  "sv-SE": o$,
  "tr-TR": s$,
  "uk-UA": d$,
  "zh-CN": c$,
  "zh-TW": f$
};
function xE(e) {
  return e && e.__esModule ? e.default : e;
}
function EE(e, t, n) {
  let r = xe(xE(h$), "@react-aria/searchfield"), { isDisabled: a, isReadOnly: l, onSubmit: i, onClear: u, type: o = "search" } = e, d = (y) => {
    const $ = y.key;
    $ === "Enter" && (a || l) && y.preventDefault(), !(a || l) && ($ === "Enter" && i && (y.preventDefault(), i(t.value)), $ === "Escape" && (t.value === "" && (!n.current || n.current.value === "") ? y.continuePropagation() : (y.preventDefault(), t.setValue(""), u && u())));
  }, s = () => {
    t.setValue(""), u && u();
  }, c = () => {
    n.current?.focus();
  }, { labelProps: f, inputProps: h, descriptionProps: m, errorMessageProps: p, ...b } = ju({
    ...e,
    value: t.value,
    onChange: t.setValue,
    onKeyDown: l ? e.onKeyDown : ot(d, e.onKeyDown),
    type: o
  }, n);
  return {
    labelProps: f,
    inputProps: {
      ...h,
      // already handled by useSearchFieldState
      defaultValue: void 0
    },
    clearButtonProps: {
      "aria-label": r.format("Clear search"),
      excludeFromTabOrder: !0,
      preventFocusOnPress: !0,
      isDisabled: a || l,
      onPress: s,
      onPressStart: c
    },
    descriptionProps: m,
    errorMessageProps: p,
    ...b
  };
}
function CE(e) {
  let [t, n] = Pe(Pd(e.value), Pd(e.defaultValue) || "", e.onChange);
  return {
    value: t,
    setValue: n
  };
}
function Pd(e) {
  if (e != null)
    return e.toString();
}
const PE = /* @__PURE__ */ G(null), I9 = /* @__PURE__ */ $n(function(t, n) {
  [t, n] = oe(t, n, PE);
  let { validationBehavior: r } = Oe(Un) || {}, a = t.validationBehavior ?? r ?? "native", l = T(null);
  [t, l] = oe(t, l, ca);
  let [i, u] = Je(!t["aria-label"] && !t["aria-labelledby"]), o = CE({
    ...t,
    validationBehavior: a
  }), { labelProps: d, inputProps: s, clearButtonProps: c, descriptionProps: f, errorMessageProps: h, ...m } = EE({
    ...Et(t),
    label: u,
    validationBehavior: a
  }, o, l), p = le({
    ...t,
    values: {
      isEmpty: o.value === "",
      isDisabled: t.isDisabled || !1,
      isInvalid: m.isInvalid || !1,
      isReadOnly: t.isReadOnly || !1,
      isRequired: t.isRequired || !1,
      state: o
    },
    defaultClassName: "react-aria-SearchField"
  }), b = J(t, {
    global: !0
  });
  return delete b.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...b,
    ...p,
    ref: n,
    slot: t.slot || void 0,
    "data-empty": o.value === "" || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": m.isInvalid || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Qe,
        {
          ...d,
          ref: i
        }
      ],
      [
        Pr,
        {
          ...s,
          ref: l
        }
      ],
      [
        Ze,
        c
      ],
      [
        _e,
        {
          slots: {
            description: f,
            errorMessage: h
          }
        }
      ],
      [
        vn,
        {
          isInvalid: m.isInvalid,
          isDisabled: t.isDisabled || !1
        }
      ],
      [
        nn,
        m
      ]
    ]
  }, p.children));
}), po = /* @__PURE__ */ new WeakMap();
function wE(e, t, n) {
  let { keyboardDelegate: r, isDisabled: a, isRequired: l, name: i, form: u, validationBehavior: o = "aria" } = e, d = wr({
    usage: "search",
    sensitivity: "base"
  }), s = K(() => r || new ya(t.collection, t.disabledKeys, n, d), [
    r,
    t.collection,
    t.disabledKeys,
    d,
    n
  ]), { menuTriggerProps: c, menuProps: f } = Dg({
    isDisabled: a,
    type: "listbox"
  }, t, n), h = (F) => {
    if (t.selectionManager.selectionMode !== "multiple")
      switch (F.key) {
        case "ArrowLeft": {
          F.preventDefault();
          let V = t.selectedKey != null ? s.getKeyAbove?.(t.selectedKey) : s.getFirstKey?.();
          V != null && t.setSelectedKey(V);
          break;
        }
        case "ArrowRight": {
          F.preventDefault();
          let V = t.selectedKey != null ? s.getKeyBelow?.(t.selectedKey) : s.getFirstKey?.();
          V != null && t.setSelectedKey(V);
          break;
        }
      }
  }, { typeSelectProps: m } = Np({
    keyboardDelegate: s,
    selectionManager: t.selectionManager,
    onTypeSelect(F) {
      t.setSelectedKey(F);
    }
  }), { isInvalid: p, validationErrors: b, validationDetails: y } = t.displayValidation, { labelProps: $, fieldProps: v, descriptionProps: x, errorMessageProps: E } = Cr({
    ...e,
    labelElementType: "span",
    isInvalid: p,
    errorMessage: e.errorMessage || b
  });
  t.selectionManager.selectionMode === "multiple" && (m = {});
  let P = J(e, {
    labelable: !0
  }), C = z(m, c, v), M = ce();
  return po.set(t, {
    isDisabled: a,
    isRequired: l,
    name: i,
    form: u,
    validationBehavior: o
  }), {
    labelProps: {
      ...$,
      onClick: () => {
        e.isDisabled || (n.current?.focus(), qr("keyboard"));
      }
    },
    triggerProps: z(P, {
      ...C,
      isDisabled: a,
      onKeyDown: ot(C.onKeyDown, h, e.onKeyDown),
      onKeyUp: e.onKeyUp,
      "aria-labelledby": [
        M,
        C["aria-labelledby"],
        C["aria-label"] && !C["aria-labelledby"] ? C.id : null
      ].filter(Boolean).join(" "),
      onFocus(F) {
        t.isFocused || (e.onFocus && e.onFocus(F), e.onFocusChange && e.onFocusChange(!0), t.setFocused(!0));
      },
      onBlur(F) {
        t.isOpen || (e.onBlur && e.onBlur(F), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      }
    }),
    valueProps: {
      id: M
    },
    menuProps: {
      ...f,
      onAction: void 0,
      autoFocus: t.focusStrategy || !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      disallowEmptySelection: !0,
      linkBehavior: "selection",
      onBlur: (F) => {
        ae(F.currentTarget, F.relatedTarget) || (e.onBlur && e.onBlur(F), e.onFocusChange && e.onFocusChange(!1), t.setFocused(!1));
      },
      "aria-labelledby": [
        v["aria-labelledby"],
        C["aria-label"] && !v["aria-labelledby"] ? C.id : null
      ].filter(Boolean).join(" ")
    },
    descriptionProps: x,
    errorMessageProps: E,
    isInvalid: p,
    validationErrors: b,
    validationDetails: y,
    hiddenSelectProps: {
      isDisabled: a,
      name: i,
      label: e.label,
      state: t,
      triggerRef: n,
      form: u
    }
  };
}
function SE(e, t, n) {
  let r = po.get(t) || {}, { autoComplete: a, name: l = r.name, form: i = r.form, isDisabled: u = r.isDisabled } = e, { validationBehavior: o, isRequired: d } = r, { visuallyHiddenProps: s } = tn({
    style: {
      // Prevent page scrolling.
      position: "fixed",
      top: 0,
      left: 0
    }
  });
  an(e.selectRef, t.defaultValue, t.setValue), ga({
    validationBehavior: o,
    focus: () => n.current?.focus()
  }, t, e.selectRef);
  let c = t.setValue, f = X((h) => {
    let m = W(h);
    m.multiple ? c(Array.from(m.selectedOptions, (p) => p.value)) : c(h.currentTarget.value);
  }, [
    c
  ]);
  return {
    containerProps: {
      ...s,
      "aria-hidden": !0,
      // @ts-ignore
      "data-react-aria-prevent-focus": !0,
      // @ts-ignore
      "data-a11y-ignore": "aria-hidden-focus"
    },
    inputProps: {
      style: {
        display: "none"
      }
    },
    selectProps: {
      tabIndex: -1,
      autoComplete: a,
      disabled: u,
      multiple: t.selectionManager.selectionMode === "multiple",
      required: o === "native" && d,
      name: l,
      form: i,
      value: t.value ?? "",
      onChange: f,
      onInput: f
    }
  };
}
function kE(e) {
  let { state: t, triggerRef: n, label: r, name: a, form: l, isDisabled: i } = e, u = T(null), o = T(null), { containerProps: d, selectProps: s } = SE({
    ...e,
    selectRef: t.collection.size <= 300 ? u : o
  }, t, n), c = Array.isArray(t.value) ? t.value : [
    t.value
  ];
  if (t.collection.size <= 300) return /* @__PURE__ */ g.createElement("div", {
    ...d,
    "data-testid": "hidden-select-container"
  }, /* @__PURE__ */ g.createElement("label", null, r, /* @__PURE__ */ g.createElement("select", {
    ...s,
    ref: u
  }, /* @__PURE__ */ g.createElement("option", {
    value: "",
    label: " "
  }, " "), [
    ...t.collection.getKeys()
  ].map((f) => {
    let h = t.collection.getItem(f);
    if (h && h.type === "item") return /* @__PURE__ */ g.createElement("option", {
      key: h.key,
      value: h.key
    }, h.textValue);
  }), t.collection.size === 0 && a && c.map((f, h) => /* @__PURE__ */ g.createElement("option", {
    key: h,
    value: f ?? ""
  })))));
  if (a) {
    let f = po.get(t) || {}, { validationBehavior: h } = f;
    c.length === 0 && (c = [
      null
    ]);
    let m = c.map((p, b) => {
      let y = {
        type: "hidden",
        autoComplete: s.autoComplete,
        name: a,
        form: l,
        disabled: i,
        value: p ?? ""
      };
      return h === "native" ? /* @__PURE__ */ g.createElement("input", {
        key: b,
        ...y,
        ref: b === 0 ? o : null,
        style: {
          display: "none"
        },
        type: "text",
        required: b === 0 ? s.required : !1,
        onChange: () => {
        }
      }) : /* @__PURE__ */ g.createElement("input", {
        key: b,
        ...y,
        ref: b === 0 ? o : null
      });
    });
    return /* @__PURE__ */ g.createElement(g.Fragment, null, m);
  }
  return null;
}
function BE(e) {
  let { selectionMode: t = "single", shouldCloseOnSelect: n = t === "single" } = e, r = Br(e), [a, l] = Y(null), i = K(() => e.defaultValue !== void 0 ? e.defaultValue : t === "single" ? e.defaultSelectedKey ?? null : [], [
    e.defaultValue,
    e.defaultSelectedKey,
    t
  ]), u = K(() => e.value !== void 0 ? e.value : t === "single" ? e.selectedKey : void 0, [
    e.value,
    e.selectedKey,
    t
  ]), [o, d] = Pe(u, i, e.onChange), s = t === "single" && Array.isArray(o) ? o[0] : o, c = (v) => {
    if (t === "single") {
      let x = Array.isArray(v) ? v[0] ?? null : v;
      d(x), x !== s && e.onSelectionChange?.(x);
    } else {
      let x = [];
      Array.isArray(v) ? x = v : v != null && (x = [
        v
      ]), d(x);
    }
  }, f = Bl({
    ...e,
    selectionMode: t,
    disallowEmptySelection: t === "single",
    allowDuplicateSelectionEvents: !0,
    selectedKeys: K(() => FE(s), [
      s
    ]),
    onSelectionChange: (v) => {
      if (v !== "all") {
        if (t === "single") {
          let x = v.values().next().value ?? null;
          c(x);
        } else c([
          ...v
        ]);
        n && r.close(), p.commitValidation();
      }
    }
  }), h = f.selectionManager.firstSelectedKey, m = K(() => [
    ...f.selectionManager.selectedKeys
  ].map((v) => f.collection.getItem(v)).filter((v) => v != null), [
    f.selectionManager.selectedKeys,
    f.collection
  ]), p = rn({
    ...e,
    value: Array.isArray(s) && s.length === 0 ? null : s
  }), [b, y] = Y(!1), [$] = Y(s);
  return {
    ...p,
    ...f,
    ...r,
    value: s,
    defaultValue: i ?? $,
    setValue: c,
    selectedKey: h,
    setSelectedKey: c,
    selectedItem: m[0] ?? null,
    selectedItems: m,
    defaultSelectedKey: e.defaultSelectedKey ?? (e.selectionMode === "single" ? $ : null),
    focusStrategy: a,
    open(v = null) {
      (f.collection.size !== 0 || e.allowsEmptyCollection) && (l(v), r.open());
    },
    toggle(v = null) {
      (f.collection.size !== 0 || e.allowsEmptyCollection) && (l(v), r.toggle());
    },
    isFocused: b,
    setFocused: y
  };
}
function FE(e) {
  if (e !== void 0)
    return e === null ? [] : Array.isArray(e) ? e : [
      e
    ];
}
const m$ = /* @__PURE__ */ G(null), AE = /* @__PURE__ */ G(null), M9 = /* @__PURE__ */ $n(function(t, n) {
  [t, n] = oe(t, n, m$);
  let { children: r, isDisabled: a = !1, isInvalid: l = !1, isRequired: i = !1 } = t, u = K(() => typeof r == "function" ? r({
    isOpen: !1,
    isDisabled: a,
    isInvalid: l,
    isRequired: i,
    isFocused: !1,
    isFocusVisible: !1,
    defaultChildren: null
  }) : r, [
    r,
    a,
    l,
    i
  ]);
  return /* @__PURE__ */ g.createElement(Hn, {
    content: u
  }, (o) => /* @__PURE__ */ g.createElement(TE, {
    props: t,
    collection: o,
    selectRef: n
  }));
}), RE = [
  Qe,
  Ze,
  _e
];
function TE({ props: e, selectRef: t, collection: n }) {
  let { validationBehavior: r } = Oe(Un) || {}, a = e.validationBehavior ?? r ?? "native", l = BE({
    ...e,
    collection: n,
    children: void 0,
    validationBehavior: a
  }), { isFocusVisible: i, focusProps: u } = ye({
    within: !0
  }), o = T(null), [d, s] = Je(!e["aria-label"] && !e["aria-labelledby"]), { labelProps: c, triggerProps: f, valueProps: h, menuProps: m, descriptionProps: p, errorMessageProps: b, hiddenSelectProps: y, ...$ } = wE({
    ...Et(e),
    label: s,
    validationBehavior: a
  }, l, o), v = K(() => ({
    isOpen: l.isOpen,
    isFocused: l.isFocused,
    isFocusVisible: i,
    isDisabled: e.isDisabled || !1,
    isInvalid: $.isInvalid || !1,
    isRequired: e.isRequired || !1
  }), [
    l.isOpen,
    l.isFocused,
    i,
    e.isDisabled,
    $.isInvalid,
    e.isRequired
  ]), x = le({
    ...e,
    values: v,
    defaultClassName: "react-aria-Select"
  }), E = J(e, {
    global: !0
  });
  delete E.id;
  let P = T(null);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        m$,
        e
      ],
      [
        AE,
        l
      ],
      [
        IE,
        h
      ],
      [
        Qe,
        {
          ...c,
          ref: d,
          elementType: "span"
        }
      ],
      [
        Ze,
        {
          ...f,
          ref: o,
          isPressed: l.isOpen,
          autoFocus: e.autoFocus
        }
      ],
      [
        Vt,
        l
      ],
      [
        Fr,
        {
          trigger: "Select",
          triggerRef: o,
          scrollRef: P,
          placement: "bottom start",
          "aria-labelledby": m["aria-labelledby"],
          clearContexts: RE
        }
      ],
      [
        ao,
        {
          ...m,
          ref: P
        }
      ],
      [
        Pt,
        l
      ],
      [
        _e,
        {
          slots: {
            description: p,
            errorMessage: b
          }
        }
      ],
      [
        nn,
        $
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(E, x, u),
    ref: t,
    slot: e.slot || void 0,
    "data-focused": l.isFocused || void 0,
    "data-focus-visible": i || void 0,
    "data-open": l.isOpen || void 0,
    "data-disabled": e.isDisabled || void 0,
    "data-invalid": $.isInvalid || void 0,
    "data-required": e.isRequired || void 0
  }, x.children, /* @__PURE__ */ g.createElement(kE, {
    ...y,
    autoComplete: e.autoComplete
  })));
}
const IE = /* @__PURE__ */ G(null);
function ME(e, t, n) {
  let { labelProps: r, inputProps: a, isSelected: l, ...i } = nh(e, t, n);
  return {
    labelProps: r,
    inputProps: {
      ...a,
      role: "switch",
      checked: l
    },
    isSelected: l,
    ...i
  };
}
const KE = /* @__PURE__ */ G(null), p$ = /* @__PURE__ */ G(null), K9 = /* @__PURE__ */ te(function(t, n) {
  let { inputRef: r = null, ...a } = t;
  [t, n] = oe(a, n, KE);
  let l = $e(xt(r, t.inputRef !== void 0 ? t.inputRef : null)), i = wl(t), u = ME({
    ...Et(t),
    // ReactNode type doesn't allow function children.
    children: typeof t.children == "function" ? !0 : t.children
  }, i, l);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        p$,
        i
      ],
      [
        b$,
        {
          ...u,
          inputRef: l,
          defaultClassName: "react-aria-Switch"
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(NE, {
    ...t,
    ref: n
  }));
}), b$ = /* @__PURE__ */ G(null), NE = /* @__PURE__ */ te(function(t, n) {
  let { labelProps: r, inputProps: a, isSelected: l, isDisabled: i, isReadOnly: u, isPressed: o, isInvalid: d, inputRef: s, defaultClassName: c, isRequired: f } = O(b$), { isFocused: h, isFocusVisible: m, focusProps: p } = ye(), b = i || u, y = O(p$), { hoverProps: $, isHovered: v } = ve({
    ...t,
    isDisabled: b
  }), x = le({
    ...t,
    defaultClassName: c,
    values: {
      isSelected: l,
      isPressed: o,
      isHovered: v,
      isFocused: h,
      isFocusVisible: m,
      isDisabled: i,
      isReadOnly: u,
      isInvalid: d,
      isRequired: f || !1,
      state: y
    }
  }), E = J(t, {
    global: !0
  });
  return delete E.id, delete E.onClick, /* @__PURE__ */ g.createElement(Q.label, {
    ...z(E, r, $, x),
    ref: n,
    slot: t.slot || void 0,
    "data-selected": l || void 0,
    "data-pressed": o || void 0,
    "data-hovered": v || void 0,
    "data-focused": h || void 0,
    "data-focus-visible": m || void 0,
    "data-disabled": i || void 0,
    "data-readonly": u || void 0,
    "data-invalid": d || void 0,
    "data-required": f || void 0
  }, /* @__PURE__ */ g.createElement(br, {
    elementType: "span"
  }, /* @__PURE__ */ g.createElement("input", {
    ...z(a, p),
    ref: s
  })), x.children);
}), wd = 10, Sd = 5;
class VE {
  setup(t, n, r) {
    this.delegate = t, this.state = n, this.direction = r;
  }
  getDropTargetFromPoint(t, n, r) {
    let a = this.delegate.getDropTargetFromPoint(t, n, r);
    return !a || a.type === "root" ? a : this.resolveDropTarget(a, t, n, r);
  }
  resolveDropTarget(t, n, r, a) {
    let l = this.pointerTracking, i = r - l.lastY, u = n - l.lastX, o = l.yDirection, d = l.xDirection;
    if (Math.abs(i) > Sd && (o = i > 0 ? "down" : "up", l.yDirection = o, l.lastY = r), Math.abs(u) > wd && (d = u > 0 ? "right" : "left", l.xDirection = d, l.lastX = n), t.dropPosition === "before") {
      let f = this.state.collection.getKeyBefore(t.key);
      for (; f != null; ) {
        let h = this.state.collection.getItem(f);
        if (h?.type === "item") break;
        f = h?.parentKey ?? null;
      }
      if (f != null) {
        let h = {
          type: "item",
          key: f,
          dropPosition: "after"
        };
        a(h) && (t = h);
      }
    }
    let s = this.getPotentialTargets(t, a);
    if (s.length === 0) return {
      type: "root"
    };
    let c;
    return s.length > 1 ? c = this.selectTarget(s, t, n, r, o, d) : (c = s[0], l.boundaryContext = null), c;
  }
  // Returns potential targets for an ambiguous drop position (e.g. after the last child of a parent, or after the parent itself)
  // Ordered by level, from innermost to outermost.
  getPotentialTargets(t, n) {
    if (t.dropPosition === "on") return [
      t
    ];
    let r = t, a = this.state.collection, l = a.getItem(r.key);
    for (; l && l?.type !== "item" && l.nextKey != null; )
      r.key = l.nextKey, l = a.getItem(l.nextKey);
    let i = [
      r
    ];
    if (l && l.hasChildNodes && this.state.expandedKeys.has(l.key) && a.getChildren && r.dropPosition === "after") {
      let d = l.firstChildKey != null ? a.getItem(l.firstChildKey) : null;
      for (; d && d.type !== "item"; ) d = d.nextKey != null ? a.getItem(d.nextKey) : null;
      if (d?.type === "item") {
        const s = {
          type: "item",
          key: d.key,
          dropPosition: "before"
        };
        return n(s) ? [
          s
        ] : [];
      }
    }
    if (l?.nextKey != null) return [
      t
    ];
    let u = l?.parentKey, o = [];
    for (; u != null; ) {
      let d = a.getItem(u), s = d?.nextKey != null ? a.getItem(d.nextKey) : null;
      if (!s || s.parentKey !== u) {
        let f = {
          type: "item",
          key: u,
          dropPosition: "after"
        };
        if (n(f) && o.push(f), s) break;
      }
      u = d?.parentKey;
    }
    if (o.length > 0 && i.push(...o), i.length === 1) {
      let d = a.getKeyAfter(r.key), s = d != null ? a.getItem(d) : null;
      if (d != null && s && l && s.level != null && l.level != null && s.level > l.level) {
        let c = {
          type: "item",
          key: d,
          dropPosition: "before"
        };
        if (n(c)) return [
          c
        ];
      }
    }
    return i.filter(n);
  }
  selectTarget(t, n, r, a, l, i) {
    if (t.length < 2) return t[0];
    let u = this.pointerTracking, d = this.state.collection.getItem(n.key)?.parentKey;
    if (d == null) return t[0];
    if (!u.boundaryContext || u.boundaryContext.parentKey !== d) {
      let m = u.yDirection === "up" ? t.length - 1 : 0;
      u.boundaryContext = {
        parentKey: d,
        preferredTargetIndex: m,
        lastSwitchY: a,
        lastSwitchX: r
      };
    }
    let s = u.boundaryContext, c = Math.abs(r - s.lastSwitchX);
    if (Math.abs(a - s.lastSwitchY) > Sd && l) {
      let m = s.preferredTargetIndex || 0;
      l === "down" && m === 0 ? s.preferredTargetIndex = t.length - 1 : l === "up" && m === t.length - 1 && (s.preferredTargetIndex = 0), u.xDirection = null;
    }
    if (c > wd && i) {
      let m = s.preferredTargetIndex || 0;
      i === "left" ? this.direction === "ltr" ? m < t.length - 1 && (s.preferredTargetIndex = m + 1, s.lastSwitchX = r) : m > 0 && (s.preferredTargetIndex = m - 1, s.lastSwitchX = r) : i === "right" && (this.direction === "ltr" ? m > 0 && (s.preferredTargetIndex = m - 1, s.lastSwitchX = r) : m < t.length - 1 && (s.preferredTargetIndex = m + 1, s.lastSwitchX = r)), u.yDirection = null;
    }
    let h = Math.max(0, Math.min(s.preferredTargetIndex || 0, t.length - 1));
    return t[h];
  }
  constructor() {
    this.delegate = null, this.state = null, this.direction = "ltr", this.pointerTracking = {
      lastY: 0,
      lastX: 0,
      yDirection: null,
      xDirection: null,
      boundaryContext: null
    };
  }
}
class LE {
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.keyMap = /* @__PURE__ */ new Map(), this.columnCount = t?.columnCount, this.rows = [];
    let n = (l) => {
      let i = this.keyMap.get(l.key);
      t.visitNode && (l = t.visitNode(l)), this.keyMap.set(l.key, l);
      let u = /* @__PURE__ */ new Set(), o = null, d = !1;
      if (l.type === "item") {
        for (let s of l.childNodes) if (s.props?.colSpan !== void 0) {
          d = !0;
          break;
        }
      }
      for (let s of l.childNodes)
        s.type === "cell" && d && (s.colspan = s.props?.colSpan, s.colSpan = s.props?.colSpan, s.colIndex = o ? (o.colIndex ?? o.index) + (o.colSpan ?? 1) : s.index), s.type === "cell" && s.parentKey == null && (s.parentKey = l.key), u.add(s.key), o ? (o.nextKey = s.key, s.prevKey = o.key) : s.prevKey = null, n(s), o = s;
      if (o && (o.nextKey = null), i)
        for (let s of i.childNodes) u.has(s.key) || r(s);
    }, r = (l) => {
      this.keyMap.delete(l.key);
      for (let i of l.childNodes) this.keyMap.get(i.key) === i && r(i);
    }, a = null;
    for (let [l, i] of t.items.entries()) {
      let u = {
        ...i,
        level: i.level ?? 0,
        key: i.key ?? "row-" + l,
        type: i.type ?? "row",
        value: i.value ?? null,
        hasChildNodes: !0,
        childNodes: [
          ...i.childNodes
        ],
        rendered: i.rendered,
        textValue: i.textValue ?? "",
        index: i.index ?? l
      };
      a ? (a.nextKey = u.key, u.prevKey = a.key) : u.prevKey = null, this.rows.push(u), n(u), a = u;
    }
    a && (a.nextKey = null);
  }
  *[Symbol.iterator]() {
    yield* [
      ...this.rows
    ];
  }
  get size() {
    return [
      ...this.rows
    ].length;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey ?? null : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey ?? null : null;
  }
  getFirstKey() {
    return [
      ...this.rows
    ][0]?.key;
  }
  getLastKey() {
    let t = [
      ...this.rows
    ];
    return t[t.length - 1]?.key;
  }
  getItem(t) {
    return this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    return this.keyMap.get(t)?.childNodes || [];
  }
}
const g$ = "row-header-column-" + Math.random().toString(36).slice(2);
let nu = "row-header-column-" + Math.random().toString(36).slice(2);
for (; g$ === nu; ) nu = "row-header-column-" + Math.random().toString(36).slice(2);
function y$(e, t) {
  if (t.length === 0) return [];
  let n = [], r = /* @__PURE__ */ new Map();
  for (let o of t) {
    let d = o.parentKey, s = [
      o
    ];
    for (; d != null; ) {
      let c = e.get(d);
      if (!c) break;
      if (r.has(c)) {
        c.colSpan ??= 0, c.colSpan++, c.colspan = c.colSpan;
        let { column: f, index: h } = r.get(c);
        if (h > s.length) break;
        for (let m = h; m < s.length; m++) f.splice(m, 0, null);
        for (let m = s.length; m < f.length; m++)
          f[m] && r.has(f[m]) && (r.get(f[m]).index = m);
      } else
        c.colSpan = 1, c.colspan = 1, s.push(c), r.set(c, {
          column: s,
          index: s.length - 1
        });
      d = c.parentKey;
    }
    n.push(s), o.index = n.length - 1;
  }
  let a = Math.max(...n.map((o) => o.length)), l = Array(a).fill(0).map(() => []), i = 0;
  for (let o of n) {
    let d = a - 1;
    for (let s of o) {
      if (s) {
        let c = l[d], f = c.reduce((h, m) => h + (m.colSpan ?? 1), 0);
        if (f < i) {
          let h = {
            type: "placeholder",
            key: "placeholder-" + s.key,
            colspan: i - f,
            colSpan: i - f,
            index: f,
            value: null,
            rendered: null,
            level: d,
            hasChildNodes: !1,
            childNodes: [],
            textValue: ""
          };
          c.length > 0 && (c[c.length - 1].nextKey = h.key, h.prevKey = c[c.length - 1].key), c.push(h);
        }
        c.length > 0 && (c[c.length - 1].nextKey = s.key, s.prevKey = c[c.length - 1].key), s.level = d, s.colIndex = i, c.push(s);
      }
      d--;
    }
    i++;
  }
  let u = 0;
  for (let o of l) {
    let d = o.reduce((s, c) => s + (c.colSpan ?? 1), 0);
    if (d < t.length) {
      let s = {
        type: "placeholder",
        key: "placeholder-" + o[o.length - 1].key,
        colSpan: t.length - d,
        colspan: t.length - d,
        index: d,
        value: null,
        rendered: null,
        level: u,
        hasChildNodes: !1,
        childNodes: [],
        textValue: "",
        prevKey: o[o.length - 1].key
      };
      o.push(s);
    }
    u++;
  }
  return l.map((o, d) => ({
    type: "headerrow",
    key: "headerrow-" + d,
    index: d,
    value: null,
    rendered: null,
    level: 0,
    hasChildNodes: !0,
    childNodes: o,
    textValue: ""
  }));
}
class zE extends LE {
  constructor(t, n, r) {
    let a = /* @__PURE__ */ new Set(), l = null, i = [];
    if (r?.showSelectionCheckboxes) {
      let c = {
        type: "column",
        key: g$,
        value: null,
        textValue: "",
        level: 0,
        index: r?.showDragButtons ? 1 : 0,
        hasChildNodes: !1,
        rendered: null,
        childNodes: [],
        props: {
          isSelectionCell: !0
        }
      };
      i.unshift(c);
    }
    if (r?.showDragButtons) {
      let c = {
        type: "column",
        key: nu,
        value: null,
        textValue: "",
        level: 0,
        index: 0,
        hasChildNodes: !1,
        rendered: null,
        childNodes: [],
        props: {
          isDragButtonCell: !0
        }
      };
      i.unshift(c);
    }
    let u = [], o = /* @__PURE__ */ new Map(), d = (c) => {
      switch (c.type) {
        case "body":
          l = c;
          break;
        case "column":
          o.set(c.key, c), c.hasChildNodes || (i.push(c), c.props.isRowHeader && a.add(c.key));
          break;
        case "item":
          u.push(c);
          return;
      }
      for (let f of c.childNodes) d(f);
    };
    for (let c of t) d(c);
    let s = y$(o, i);
    if (s.forEach((c, f) => u.splice(f, 0, c)), super({
      columnCount: i.length,
      items: u,
      visitNode: (c) => (c.column = i[c.index], c)
    }), this._size = 0, this.columns = i, this.rowHeaderColumnKeys = a, this.body = l, this.headerRows = s, this._size = [
      ...l.childNodes
    ].length, this.rowHeaderColumnKeys.size === 0) {
      let c = this.columns.find((f) => !f.props?.isDragButtonCell && !f.props?.isSelectionCell);
      c && this.rowHeaderColumnKeys.add(c.key);
    }
  }
  *[Symbol.iterator]() {
    yield* this.body.childNodes;
  }
  get size() {
    return this._size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    return this.keyMap.get(t)?.prevKey ?? null;
  }
  getKeyAfter(t) {
    return this.keyMap.get(t)?.nextKey ?? null;
  }
  getFirstKey() {
    return jt(this.body.childNodes)?.key ?? null;
  }
  getLastKey() {
    return rr(this.body.childNodes)?.key ?? null;
  }
  getItem(t) {
    return t === this.body.key ? this.body : this.keyMap.get(t) ?? null;
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    if (t === this.body.key) return this.body.childNodes;
    let n = this.getItem(t);
    return n?.type === "item" ? [
      ...n.childNodes
    ].filter((r) => r.type === "cell") : super.getChildren(t);
  }
  getTextValue(t) {
    let n = this.getItem(t);
    if (!n) return "";
    if (n.textValue) return n.textValue;
    let r = this.rowHeaderColumnKeys;
    if (r) {
      let a = [];
      for (let l of n.childNodes) {
        let i = this.columns[l.index];
        if (r.has(i.key) && l.textValue && a.push(l.textValue), a.length === r.size) break;
      }
      return a.join(" ");
    }
    return "";
  }
}
function OE(e) {
  return e != null && (!isNaN(e) || String(e).match(/^(\d+)(?=%$)/) !== null);
}
function HE(e) {
  if (!e || typeof e == "number") return 1;
  let t = e.match(/^(.+)(?=fr$)/);
  return t ? parseFloat(t[0]) : (process.env.NODE_ENV !== "production" && console.warn(`width: ${e} is not a supported format, width should be a number (ex. 150), percentage (ex. '50%') or fr unit (ex. '2fr')`, "defaulting to '1fr'"), 1);
}
function bo(e, t) {
  if (typeof e == "string") {
    let n = e.match(/^(\d+)(?=%$)/);
    if (!n) throw new Error("Only percentages or numbers are supported for static column widths");
    return t * (parseFloat(n[0]) / 100);
  }
  return e;
}
function $$(e, t) {
  return e != null ? bo(e, t) : Number.MAX_SAFE_INTEGER;
}
function v$(e, t) {
  return e != null ? bo(e, t) : 0;
}
function UE(e, t, n, r, a) {
  let l = !1, i = t.map((u, o) => {
    let d = n.get(u.key) != null ? n.get(u.key) ?? "1fr" : u.width ?? u.defaultWidth ?? r?.(o) ?? "1fr", s = !1, c = 0, f = 0, h = 0;
    OE(d) ? (c = bo(d, e), s = !0) : (f = HE(d), f <= 0 && (s = !0));
    let m = v$(u.minWidth ?? a?.(o) ?? 0, e), p = $$(u.maxWidth, e), b = Math.max(m, Math.min(c, p));
    return s ? h = b : c > b && (s = !0, h = b), s || (l = !0), {
      frozen: s,
      baseSize: c,
      hypotheticalMainSize: b,
      min: m,
      max: p,
      flex: f,
      targetMainSize: h,
      violation: 0
    };
  });
  for (; l; ) {
    let u = 0, o = 0;
    i.forEach((c) => {
      c.frozen ? u += c.targetMainSize : (u += c.baseSize, o += c.flex);
    });
    let d = e - u;
    d > 0 && i.forEach((c) => {
      if (!c.frozen) {
        let f = c.flex / o;
        c.targetMainSize = c.baseSize + f * d;
      }
    });
    let s = 0;
    i.forEach((c) => {
      if (c.violation = 0, !c.frozen) {
        let { min: f, max: h, targetMainSize: m } = c;
        c.targetMainSize = Math.max(f, Math.min(m, h)), c.violation = c.targetMainSize - m, s += c.violation;
      }
    }), l = !1, i.forEach((c) => {
      s === 0 || Math.sign(s) === Math.sign(c.violation) ? c.frozen = !0 : c.frozen || (l = !0);
    });
  }
  return jE(i);
}
function jE(e) {
  let t = 0, n = 0, r = [];
  return e.forEach(function(a) {
    let l = a.targetMainSize, i = Math.round(l + t) - n;
    t += l, n += i, r.push(i);
  }), r;
}
class _E {
  constructor(t) {
    this.columnWidths = /* @__PURE__ */ new Map(), this.columnMinWidths = /* @__PURE__ */ new Map(), this.columnMaxWidths = /* @__PURE__ */ new Map(), this.getDefaultWidth = t?.getDefaultWidth ?? (() => "1fr"), this.getDefaultMinWidth = t?.getDefaultMinWidth ?? (() => 75);
  }
  /**
  * Takes an array of columns and splits it into 2 maps of columns with controlled and columns with
  * uncontrolled widths.
  */
  splitColumnsIntoControlledAndUncontrolled(t) {
    return t.reduce((n, r) => (r.props.width != null ? n[0].set(r.key, r) : n[1].set(r.key, r), n), [
      /* @__PURE__ */ new Map(),
      /* @__PURE__ */ new Map()
    ]);
  }
  /** Takes uncontrolled and controlled widths and joins them into a single Map. */
  recombineColumns(t, n, r, a) {
    return new Map(t.map((l) => r.has(l.key) ? [
      l.key,
      n.get(l.key)
    ] : [
      l.key,
      a.get(l.key).props.width
    ]));
  }
  /** Used to make an initial Map of the uncontrolled widths based on default widths. */
  getInitialUncontrolledWidths(t) {
    return new Map(Array.from(t).map(([n, r]) => [
      n,
      r.props.defaultWidth ?? this.getDefaultWidth?.(r) ?? "1fr"
    ]));
  }
  getColumnWidth(t) {
    return this.columnWidths.get(t) ?? 0;
  }
  getColumnMinWidth(t) {
    return this.columnMinWidths.get(t) ?? 0;
  }
  getColumnMaxWidth(t) {
    return this.columnMaxWidths.get(t) ?? 0;
  }
  resizeColumnWidth(t, n, r, a) {
    let l = this.columnWidths, i = !0, u = /* @__PURE__ */ new Map();
    return a = Math.max(this.getColumnMinWidth(r), Math.min(this.getColumnMaxWidth(r), Math.floor(a))), t.columns.forEach((o) => {
      o.key === r ? (u.set(o.key, a), i = !1) : i ? u.set(o.key, l.get(o.key) ?? 0) : u.set(o.key, o.props.width ?? n.get(o.key));
    }), u;
  }
  buildColumnWidths(t, n, r) {
    return this.columnWidths = /* @__PURE__ */ new Map(), this.columnMinWidths = /* @__PURE__ */ new Map(), this.columnMaxWidths = /* @__PURE__ */ new Map(), UE(t, n.columns.map((l) => ({
      ...l.props,
      key: l.key
    })), r, (l) => this.getDefaultWidth(n.columns[l]), (l) => this.getDefaultMinWidth(n.columns[l])).forEach((l, i) => {
      let u = n.columns[i].key, o = n.columns[i];
      this.columnWidths.set(u, l), this.columnMinWidths.set(u, v$(o.props.minWidth ?? this.getDefaultMinWidth(o), t)), this.columnMaxWidths.set(u, $$(o.props.maxWidth, t));
    }), this.columnWidths;
  }
}
function WE(e, t) {
  let { getDefaultWidth: n, getDefaultMinWidth: r, tableWidth: a = 0 } = e, [l, i] = Y(null), u = K(() => new _E({
    getDefaultWidth: n,
    getDefaultMinWidth: r
  }), [
    n,
    r
  ]), [o, d] = K(() => u.splitColumnsIntoControlledAndUncontrolled(t.collection.columns), [
    t.collection.columns,
    u
  ]), [s, c] = Y(() => u.getInitialUncontrolledWidths(d)), [f, h] = Y(t.collection.columns);
  if (t.collection.columns !== f) {
    if (t.collection.columns.length !== f.length || t.collection.columns.some((v, x) => v.key !== f[x].key)) {
      let v = u.getInitialUncontrolledWidths(d);
      c(v);
    }
    h(t.collection.columns);
  }
  let m = K(() => u.recombineColumns(t.collection.columns, s, d, o), [
    t.collection.columns,
    s,
    d,
    o,
    u
  ]), p = X((v) => {
    i(v);
  }, [
    i
  ]), b = X((v, x) => {
    let E = u.resizeColumnWidth(t.collection, s, v, x), P = new Map(Array.from(d).map(([C]) => [
      C,
      E.get(C)
    ]));
    return P.set(v, x), c(P), E;
  }, [
    d,
    c,
    u,
    t.collection,
    s
  ]), y = X(() => {
    i(null);
  }, [
    i
  ]), $ = K(() => u.buildColumnWidths(a, t.collection, m), [
    a,
    t.collection,
    m,
    u
  ]);
  return K(() => ({
    resizingColumn: l,
    updateResizedColumns: b,
    startResize: p,
    endResize: y,
    getColumnWidth: (v) => u.getColumnWidth(v),
    getColumnMinWidth: (v) => u.getColumnMinWidth(v),
    getColumnMaxWidth: (v) => u.getColumnMaxWidth(v),
    tableState: t,
    columnWidths: $
  }), [
    u,
    $,
    l,
    b,
    p,
    y,
    t
  ]);
}
function GE(e) {
  let { collection: t, focusMode: n } = e, r = e.UNSAFE_selectionState || $a(e), a = K(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), l = r.setFocusedKey;
  r.setFocusedKey = (o, d) => {
    if (n === "cell" && o != null) {
      let s = t.getItem(o);
      if (s?.type === "item") {
        let c = Me(s, t);
        d === "last" ? o = rr(c)?.key ?? null : o = jt(c)?.key ?? null;
      }
    }
    l(o, d);
  };
  let i = K(() => new kr(t, r), [
    t,
    r
  ]);
  const u = T(null);
  return ee(() => {
    if (r.focusedKey != null && u.current && !t.getItem(r.focusedKey)) {
      const o = u.current.getItem(r.focusedKey), d = o?.parentKey != null && (o.type === "cell" || o.type === "rowheader" || o.type === "column") ? u.current.getItem(o.parentKey) : o;
      if (!d) {
        r.setFocusedKey(null);
        return;
      }
      const s = u.current.rows, c = t.rows, f = s.length - c.length;
      let h = Math.min(f > 1 ? Math.max(d.index - f + 1, 0) : d.index, c.length - 1), m = null;
      for (; h >= 0; ) {
        if (!i.isDisabled(c[h].key) && c[h].type !== "headerrow") {
          m = c[h];
          break;
        }
        h < c.length - 1 ? h++ : (h > d.index && (h = d.index), h--);
      }
      if (m) {
        const p = m.hasChildNodes ? [
          ...Me(m, t)
        ] : [], b = m.hasChildNodes && d !== o && o && o.index < p.length ? p[o.index].key : m.key;
        r.setFocusedKey(b);
      } else r.setFocusedKey(null);
    }
    u.current = t;
  }, [
    t,
    i,
    r,
    r.focusedKey
  ]), {
    collection: t,
    disabledKeys: a,
    isKeyboardNavigationDisabled: !1,
    selectionManager: i
  };
}
const qE = {
  ascending: "descending",
  descending: "ascending"
};
function YE(e) {
  let [t, n] = Y(!1), { selectionMode: r = "none", showSelectionCheckboxes: a, showDragButtons: l, treeColumn: i = null } = e, u = K(
    () => ({
      showSelectionCheckboxes: a && r !== "none",
      showDragButtons: l,
      selectionMode: r,
      columns: []
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      e.children,
      a,
      r,
      l
    ]
  ), o = ro(e, X((h) => new zE(h, null, u), [
    u
  ]), u), { disabledKeys: d, selectionManager: s } = GE({
    ...e,
    collection: o,
    disabledBehavior: e.disabledBehavior || "selection"
  }), [c, f] = Pe(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), e.onExpandedChange);
  return {
    collection: o,
    disabledKeys: d,
    selectionManager: s,
    showSelectionCheckboxes: e.showSelectionCheckboxes || !1,
    sortDescriptor: e.sortDescriptor ?? null,
    isKeyboardNavigationDisabled: o.size === 0 || t,
    setKeyboardNavigationDisabled: n,
    sort(h, m) {
      e.onSortChange?.({
        column: h,
        direction: m ?? (e.sortDescriptor?.column === h ? qE[e.sortDescriptor.direction] : "ascending")
      });
    },
    expandedKeys: c,
    toggleKey(h) {
      f((m) => {
        let p = new Set(m);
        return p.has(h) ? p.delete(h) : p.add(h), p;
      });
    },
    treeColumn: i
  };
}
function ZE(e, t) {
  let n = K(() => t ? e.collection.filter(t) : e.collection, [
    e.collection,
    t
  ]), r = e.selectionManager.withCollection(n);
  return {
    ...e,
    collection: n,
    selectionManager: r
  };
}
class D$ {
  constructor(t) {
    if (this.collection = t.collection, this.disabledKeys = t.disabledKeys, this.disabledBehavior = t.disabledBehavior || "all", this.direction = t.direction, this.collator = t.collator, !t.layout && !t.ref) throw new Error("Either a layout or a ref must be specified.");
    this.layoutDelegate = t.layoutDelegate || (t.layout ? new XE(t.layout) : new Xi(t.ref)), this.focusMode = t.focusMode ?? "row";
  }
  isCell(t) {
    return t.type === "cell";
  }
  isRow(t) {
    return t.type === "row" || t.type === "item";
  }
  isDisabled(t) {
    return this.disabledBehavior === "all" && (t.props?.isDisabled || this.disabledKeys.has(t.key)) && t.props?.disabledBehavior !== "selection";
  }
  findPreviousKey(t, n, r = !1) {
    let a = t != null ? this.collection.getKeyBefore(t) : this.collection.getLastKey();
    for (; a != null; ) {
      let l = this.collection.getItem(a);
      if (!l) return null;
      if ((r || !this.isDisabled(l)) && (!n || n(l))) return a;
      a = this.collection.getKeyBefore(a);
    }
    return null;
  }
  findNextKey(t, n, r = !1) {
    let a = t != null ? this.collection.getKeyAfter(t) : this.collection.getFirstKey();
    for (; a != null; ) {
      let l = this.collection.getItem(a);
      if (!l) return null;
      if ((r || !this.isDisabled(l)) && (!n || n(l))) return a;
      if (a = this.collection.getKeyAfter(a), a == null) return null;
    }
    return null;
  }
  getKeyForItemInRowByIndex(t, n = 0) {
    if (n < 0) return null;
    let r = this.collection.getItem(t);
    if (!r) return null;
    let a = 0;
    for (let l of Me(r, this.collection)) {
      if (l.colSpan && l.colSpan + a > n || (l.colSpan && (a = a + l.colSpan - 1), a === n)) return l.key ?? null;
      a++;
    }
    return null;
  }
  getKeyBelow(t, n) {
    let r = t, a = this.collection.getItem(r);
    if (!a || (this.isCell(a) && (r = a.parentKey ?? null), r == null)) return null;
    if (r = this.findNextKey(r, (l) => l.type === "item", n?.includeDisabled), r != null) {
      if (this.isCell(a)) {
        let l = a.colIndex ? a.colIndex : a.index;
        return this.getKeyForItemInRowByIndex(r, l);
      }
      if (this.focusMode === "row") return r;
    }
    return null;
  }
  getKeyAbove(t, n) {
    let r = t, a = this.collection.getItem(r);
    if (!a || (this.isCell(a) && (r = a.parentKey ?? null), r == null)) return null;
    if (r = this.findPreviousKey(r, (l) => l.type === "item", n?.includeDisabled), r != null) {
      if (this.isCell(a)) {
        let l = a.colIndex ? a.colIndex : a.index;
        return this.getKeyForItemInRowByIndex(r, l);
      }
      if (this.focusMode === "row") return r;
    }
    return null;
  }
  getKeyRightOf(t) {
    let n = this.collection.getItem(t);
    if (!n) return null;
    if (this.isRow(n)) {
      let r = Me(n, this.collection);
      return (this.direction === "rtl" ? rr(r)?.key : jt(r)?.key) ?? null;
    }
    if (this.isCell(n) && n.parentKey != null) {
      let r = this.collection.getItem(n.parentKey);
      if (!r) return null;
      let a = Me(r, this.collection), l = (this.direction === "rtl" ? Hr(a, n.index - 1) : Hr(a, n.index + 1)) ?? null;
      return l ? l.key ?? null : this.focusMode === "row" ? n.parentKey ?? null : (this.direction === "rtl" ? this.getFirstKey(t) : this.getLastKey(t)) ?? null;
    }
    return null;
  }
  getKeyLeftOf(t) {
    let n = this.collection.getItem(t);
    if (!n) return null;
    if (this.isRow(n)) {
      let r = Me(n, this.collection);
      return (this.direction === "rtl" ? jt(r)?.key : rr(r)?.key) ?? null;
    }
    if (this.isCell(n) && n.parentKey != null) {
      let r = this.collection.getItem(n.parentKey);
      if (!r) return null;
      let a = Me(r, this.collection), l = (this.direction === "rtl" ? Hr(a, n.index + 1) : Hr(a, n.index - 1)) ?? null;
      return l ? l.key ?? null : this.focusMode === "row" ? n.parentKey ?? null : (this.direction === "rtl" ? this.getLastKey(t) : this.getFirstKey(t)) ?? null;
    }
    return null;
  }
  getFirstKey(t, n) {
    let r = t ?? null, a;
    if (r != null) {
      if (a = this.collection.getItem(r), !a) return null;
      if (this.isCell(a) && !n && a.parentKey != null) {
        let l = this.collection.getItem(a.parentKey);
        return l ? jt(Me(l, this.collection))?.key ?? null : null;
      }
    }
    if (r = this.findNextKey(void 0, (l) => l.type === "item"), r != null && (a && this.isCell(a) && n || this.focusMode === "cell")) {
      let l = this.collection.getItem(r);
      if (!l) return null;
      r = jt(Me(l, this.collection))?.key ?? null;
    }
    return r;
  }
  getLastKey(t, n) {
    let r = t ?? null, a;
    if (r != null) {
      if (a = this.collection.getItem(r), !a) return null;
      if (this.isCell(a) && !n && a.parentKey != null) {
        let l = this.collection.getItem(a.parentKey);
        if (!l) return null;
        let i = Me(l, this.collection);
        return rr(i)?.key ?? null;
      }
    }
    if (r = this.findPreviousKey(void 0, (l) => l.type === "item"), r != null && (a && this.isCell(a) && n || this.focusMode === "cell")) {
      let l = this.collection.getItem(r);
      if (!l) return null;
      let i = Me(l, this.collection);
      r = rr(i)?.key ?? null;
    }
    return r;
  }
  getKeyPageAbove(t) {
    let n = t, r = this.layoutDelegate.getItemRect(n);
    if (!r) return null;
    let a = Math.max(0, r.y + r.height - this.layoutDelegate.getVisibleRect().height);
    for (; r && r.y > a && n != null && (n = this.getKeyAbove(n) ?? null, n != null); )
      r = this.layoutDelegate.getItemRect(n);
    return n;
  }
  getKeyPageBelow(t) {
    let n = t, r = this.layoutDelegate.getItemRect(n);
    if (!r) return null;
    let a = this.layoutDelegate.getVisibleRect().height, l = Math.min(this.layoutDelegate.getContentSize().height, r.y + a);
    for (; r && r.y + r.height < l; ) {
      let i = this.getKeyBelow(n);
      if (i == null) break;
      r = this.layoutDelegate.getItemRect(i), n = i;
    }
    return n;
  }
  getKeyForSearch(t, n) {
    let r = n ?? null;
    if (!this.collator) return null;
    let a = this.collection;
    if (r = n ?? this.getFirstKey(), r == null) return null;
    let l = a.getItem(r);
    if (!l) return null;
    l.type === "cell" && (r = l.parentKey ?? null);
    let i = !1;
    for (; r != null; ) {
      let u = a.getItem(r);
      if (!u) return null;
      if (u.textValue) {
        let o = u.textValue.slice(0, t.length);
        if (this.collator.compare(o, t) === 0)
          return this.isRow(u) && this.focusMode === "cell" ? jt(Me(u, this.collection))?.key ?? null : u.key;
      }
      r = this.findNextKey(r, (o) => o.type === "item"), r == null && !i && (r = this.getFirstKey(), i = !0);
    }
    return null;
  }
}
class XE {
  constructor(t) {
    this.layout = t;
  }
  getContentSize() {
    return this.layout.getContentSize();
  }
  getItemRect(t) {
    return this.layout.getLayoutInfo(t)?.rect || null;
  }
  getVisibleRect() {
    return this.layout.virtualizer.visibleRect;
  }
}
const go = /* @__PURE__ */ new WeakMap();
function JE(e, t, n) {
  let { isVirtualized: r, disallowTypeAhead: a, keyboardDelegate: l, focusMode: i, scrollRef: u, getRowText: o, onRowAction: d, onCellAction: s, escapeKeyBehavior: c = "clearSelection", shouldSelectOnPressUp: f } = e, { selectionManager: h } = t;
  !e["aria-label"] && !e["aria-labelledby"] && console.warn("An aria-label or aria-labelledby prop is required for accessibility.");
  let m = wr({
    usage: "search",
    sensitivity: "base"
  }), { direction: p } = de(), b = t.selectionManager.disabledBehavior, y = K(() => l || new D$({
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    disabledBehavior: b,
    ref: n,
    direction: p,
    collator: m,
    focusMode: i
  }), [
    l,
    t.collection,
    t.disabledKeys,
    b,
    n,
    p,
    m,
    i
  ]), { collectionProps: $ } = to({
    ref: n,
    selectionManager: h,
    keyboardDelegate: y,
    isVirtualized: r,
    scrollRef: u,
    disallowTypeAhead: a,
    escapeKeyBehavior: c
  }), v = ce(e.id);
  go.set(t, {
    keyboardDelegate: y,
    actions: {
      onRowAction: d,
      onCellAction: s
    },
    shouldSelectOnPressUp: f
  });
  let x = Fy({
    selectionManager: h,
    hasItemActions: !!(d || s)
  }), E = J(e, {
    labelable: !0
  }), P = X((V) => {
    if (h.isFocused) {
      ae(V.currentTarget, W(V)) || h.setFocused(!1);
      return;
    }
    ae(V.currentTarget, W(V)) && h.setFocused(!0);
  }, [
    h
  ]), C = K(() => ({
    onBlur: $.onBlur,
    onFocus: P
  }), [
    P,
    $.onBlur
  ]), M = fo(n, {
    isDisabled: t.collection.size !== 0
  }), F = z(
    E,
    {
      role: "grid",
      id: v,
      "aria-multiselectable": h.selectionMode === "multiple" ? "true" : void 0
    },
    t.isKeyboardNavigationDisabled ? C : $,
    // If collection is empty, make sure the grid is tabbable unless there is a child tabbable element.
    t.collection.size === 0 && {
      tabIndex: M ? -1 : 0
    } || void 0,
    x
  );
  return r && (F["aria-rowcount"] = t.collection.size, F["aria-colcount"] = t.collection.columnCount), By({
    getRowText: o
  }, t), {
    gridProps: F
  };
}
const yo = /* @__PURE__ */ new WeakMap();
function ru(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function x$(e, t) {
  let n = yo.get(e);
  if (!n) throw new Error("Unknown grid");
  return `${n}-${ru(t)}`;
}
function E$(e, t, n) {
  let r = yo.get(e);
  if (!r) throw new Error("Unknown grid");
  return `${r}-${ru(t)}-${ru(n)}`;
}
function au(e, t) {
  return [
    ...e.collection.rowHeaderColumnKeys
  ].map((n) => E$(e, t, n)).join(" ");
}
var C$ = {};
C$ = {
  ascending: "تصاعدي",
  ascendingSort: (e) => `ترتيب حسب العمود ${e.columnName} بترتيب تصاعدي`,
  columnSize: (e) => `${e.value} بالبكسل`,
  descending: "تنازلي",
  descendingSort: (e) => `ترتيب حسب العمود ${e.columnName} بترتيب تنازلي`,
  resizerDescription: "اضغط على مفتاح Enter لبدء تغيير الحجم",
  select: "تحديد",
  selectAll: "تحديد الكل",
  sortable: "عمود قابل للترتيب",
  collapse: "طي",
  expand: "تمديد"
};
var P$ = {};
P$ = {
  ascending: "възходящ",
  ascendingSort: (e) => `сортирано по колона ${e.columnName} във възходящ ред`,
  columnSize: (e) => `${e.value} пиксела`,
  descending: "низходящ",
  descendingSort: (e) => `сортирано по колона ${e.columnName} в низходящ ред`,
  resizerDescription: "Натиснете „Enter“, за да започнете да преоразмерявате",
  select: "Изберете",
  selectAll: "Изберете всичко",
  sortable: "сортираща колона",
  collapse: "Свиване",
  expand: "Разширяване"
};
var w$ = {};
w$ = {
  ascending: "vzestupně",
  ascendingSort: (e) => `řazeno vzestupně podle sloupce ${e.columnName}`,
  columnSize: (e) => `${e.value} pixelů`,
  descending: "sestupně",
  descendingSort: (e) => `řazeno sestupně podle sloupce ${e.columnName}`,
  resizerDescription: "Stisknutím klávesy Enter začnete měnit velikost",
  select: "Vybrat",
  selectAll: "Vybrat vše",
  sortable: "sloupec s možností řazení",
  collapse: "Sbalit",
  expand: "Roztáhnout"
};
var S$ = {};
S$ = {
  ascending: "stigende",
  ascendingSort: (e) => `sorteret efter kolonne ${e.columnName} i stigende rækkefølge`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "faldende",
  descendingSort: (e) => `sorteret efter kolonne ${e.columnName} i faldende rækkefølge`,
  resizerDescription: "Tryk på Enter for at ændre størrelse",
  select: "Vælg",
  selectAll: "Vælg alle",
  sortable: "sorterbar kolonne",
  collapse: "Skjul",
  expand: "Udvid"
};
var k$ = {};
k$ = {
  ascending: "aufsteigend",
  ascendingSort: (e) => `sortiert nach Spalte ${e.columnName} in aufsteigender Reihenfolge`,
  columnSize: (e) => `${e.value} Pixel`,
  descending: "absteigend",
  descendingSort: (e) => `sortiert nach Spalte ${e.columnName} in absteigender Reihenfolge`,
  resizerDescription: "Eingabetaste zum Starten der Größenänderung drücken",
  select: "Auswählen",
  selectAll: "Alles auswählen",
  sortable: "sortierbare Spalte",
  collapse: "Reduzieren",
  expand: "Erweitern"
};
var B$ = {};
B$ = {
  ascending: "αύξουσα",
  ascendingSort: (e) => `διαλογή ανά στήλη ${e.columnName} σε αύξουσα σειρά`,
  columnSize: (e) => `${e.value} pixel`,
  descending: "φθίνουσα",
  descendingSort: (e) => `διαλογή ανά στήλη ${e.columnName} σε φθίνουσα σειρά`,
  resizerDescription: "Πατήστε Enter για έναρξη της αλλαγής μεγέθους",
  select: "Επιλογή",
  selectAll: "Επιλογή όλων",
  sortable: "Στήλη διαλογής",
  collapse: "Σύμπτυξη",
  expand: "Ανάπτυξη"
};
var F$ = {};
F$ = {
  select: "Select",
  selectAll: "Select All",
  sortable: "sortable column",
  ascending: "ascending",
  descending: "descending",
  ascendingSort: (e) => `sorted by column ${e.columnName} in ascending order`,
  descendingSort: (e) => `sorted by column ${e.columnName} in descending order`,
  columnSize: (e) => `${e.value} pixels`,
  resizerDescription: "Press Enter to start resizing",
  expand: "Expand",
  collapse: "Collapse"
};
var A$ = {};
A$ = {
  ascending: "ascendente",
  ascendingSort: (e) => `ordenado por columna ${e.columnName} en sentido ascendente`,
  columnSize: (e) => `${e.value} píxeles`,
  descending: "descendente",
  descendingSort: (e) => `ordenado por columna ${e.columnName} en orden descendente`,
  resizerDescription: "Pulse Intro para empezar a redimensionar",
  select: "Seleccionar",
  selectAll: "Seleccionar todos",
  sortable: "columna ordenable",
  collapse: "Contraer",
  expand: "Ampliar"
};
var R$ = {};
R$ = {
  ascending: "tõusev järjestus",
  ascendingSort: (e) => `sorditud veeru järgi ${e.columnName} tõusvas järjestuses`,
  columnSize: (e) => `${e.value} pikslit`,
  descending: "laskuv järjestus",
  descendingSort: (e) => `sorditud veeru järgi ${e.columnName} laskuvas järjestuses`,
  resizerDescription: "Suuruse muutmise alustamiseks vajutage klahvi Enter",
  select: "Vali",
  selectAll: "Vali kõik",
  sortable: "sorditav veerg",
  collapse: "Ahenda",
  expand: "Laienda"
};
var T$ = {};
T$ = {
  ascending: "nouseva",
  ascendingSort: (e) => `lajiteltu sarakkeen ${e.columnName} mukaan nousevassa järjestyksessä`,
  columnSize: (e) => `${e.value} pikseliä`,
  descending: "laskeva",
  descendingSort: (e) => `lajiteltu sarakkeen ${e.columnName} mukaan laskevassa järjestyksessä`,
  resizerDescription: "Aloita koon muutos painamalla Enter-näppäintä",
  select: "Valitse",
  selectAll: "Valitse kaikki",
  sortable: "lajiteltava sarake",
  collapse: "Pienennä",
  expand: "Laajenna"
};
var I$ = {};
I$ = {
  ascending: "croissant",
  ascendingSort: (e) => `trié en fonction de la colonne ${e.columnName} par ordre croissant`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "décroissant",
  descendingSort: (e) => `trié en fonction de la colonne ${e.columnName} par ordre décroissant`,
  resizerDescription: "Appuyez sur Entrée pour commencer le redimensionnement.",
  select: "Sélectionner",
  selectAll: "Sélectionner tout",
  sortable: "colonne triable",
  collapse: "Réduire",
  expand: "Développer"
};
var M$ = {};
M$ = {
  ascending: "עולה",
  ascendingSort: (e) => `מוין לפי עמודה ${e.columnName} בסדר עולה`,
  columnSize: (e) => `${e.value} פיקסלים`,
  descending: "יורד",
  descendingSort: (e) => `מוין לפי עמודה ${e.columnName} בסדר יורד`,
  resizerDescription: "הקש Enter כדי לשנות את הגודל",
  select: "בחר",
  selectAll: "בחר הכול",
  sortable: "עמודה שניתן למיין",
  collapse: "כווץ",
  expand: "הרחב"
};
var K$ = {};
K$ = {
  ascending: "rastući",
  ascendingSort: (e) => `razvrstano po stupcima ${e.columnName} rastućem redoslijedom`,
  columnSize: (e) => `${e.value} piksela`,
  descending: "padajući",
  descendingSort: (e) => `razvrstano po stupcima ${e.columnName} padajućim redoslijedom`,
  resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
  select: "Odaberite",
  selectAll: "Odaberite sve",
  sortable: "stupac koji se može razvrstati",
  collapse: "Sažmi",
  expand: "Proširi"
};
var N$ = {};
N$ = {
  ascending: "növekvő",
  ascendingSort: (e) => `rendezve a(z) ${e.columnName} oszlop szerint, növekvő sorrendben`,
  columnSize: (e) => `${e.value} képpont`,
  descending: "csökkenő",
  descendingSort: (e) => `rendezve a(z) ${e.columnName} oszlop szerint, csökkenő sorrendben`,
  resizerDescription: "Nyomja le az Enter billentyűt az átméretezés megkezdéséhez",
  select: "Kijelölés",
  selectAll: "Összes kijelölése",
  sortable: "rendezendő oszlop",
  collapse: "Összecsukás",
  expand: "Kibontás"
};
var V$ = {};
V$ = {
  ascending: "crescente",
  ascendingSort: (e) => `in ordine crescente in base alla colonna ${e.columnName}`,
  columnSize: (e) => `${e.value} pixel`,
  descending: "decrescente",
  descendingSort: (e) => `in ordine decrescente in base alla colonna ${e.columnName}`,
  resizerDescription: "Premi Invio per iniziare a ridimensionare",
  select: "Seleziona",
  selectAll: "Seleziona tutto",
  sortable: "colonna ordinabile",
  collapse: "Comprimi",
  expand: "Espandi"
};
var L$ = {};
L$ = {
  ascending: "昇順",
  ascendingSort: (e) => `列 ${e.columnName} を昇順で並べ替え`,
  columnSize: (e) => `${e.value} ピクセル`,
  descending: "降順",
  descendingSort: (e) => `列 ${e.columnName} を降順で並べ替え`,
  resizerDescription: "Enter キーを押してサイズ変更を開始",
  select: "選択",
  selectAll: "すべて選択",
  sortable: "並べ替え可能な列",
  collapse: "折りたたむ",
  expand: "展開"
};
var z$ = {};
z$ = {
  ascending: "오름차순",
  ascendingSort: (e) => `${e.columnName} 열을 기준으로 오름차순으로 정렬됨`,
  columnSize: (e) => `${e.value} 픽셀`,
  descending: "내림차순",
  descendingSort: (e) => `${e.columnName} 열을 기준으로 내림차순으로 정렬됨`,
  resizerDescription: "크기 조정을 시작하려면 Enter를 누르세요.",
  select: "선택",
  selectAll: "모두 선택",
  sortable: "정렬 가능한 열",
  collapse: "접기",
  expand: "펼치기"
};
var O$ = {};
O$ = {
  ascending: "didėjančia tvarka",
  ascendingSort: (e) => `surikiuota pagal stulpelį ${e.columnName} didėjančia tvarka`,
  columnSize: (e) => `${e.value} piks.`,
  descending: "mažėjančia tvarka",
  descendingSort: (e) => `surikiuota pagal stulpelį ${e.columnName} mažėjančia tvarka`,
  resizerDescription: "Paspauskite „Enter“, kad pradėtumėte keisti dydį",
  select: "Pasirinkti",
  selectAll: "Pasirinkti viską",
  sortable: "rikiuojamas stulpelis",
  collapse: "Sutraukti",
  expand: "Išskleisti"
};
var H$ = {};
H$ = {
  ascending: "augošā secībā",
  ascendingSort: (e) => `kārtots pēc kolonnas ${e.columnName} augošā secībā`,
  columnSize: (e) => `${e.value} pikseļi`,
  descending: "dilstošā secībā",
  descendingSort: (e) => `kārtots pēc kolonnas ${e.columnName} dilstošā secībā`,
  resizerDescription: "Nospiediet Enter, lai sāktu izmēru mainīšanu",
  select: "Atlasīt",
  selectAll: "Atlasīt visu",
  sortable: "kārtojamā kolonna",
  collapse: "Sakļaut",
  expand: "Izvērst"
};
var U$ = {};
U$ = {
  ascending: "stigende",
  ascendingSort: (e) => `sortert etter kolonne ${e.columnName} i stigende rekkefølge`,
  columnSize: (e) => `${e.value} piksler`,
  descending: "synkende",
  descendingSort: (e) => `sortert etter kolonne ${e.columnName} i synkende rekkefølge`,
  resizerDescription: "Trykk på Enter for å starte størrelsesendring",
  select: "Velg",
  selectAll: "Velg alle",
  sortable: "kolonne som kan sorteres",
  collapse: "Skjul",
  expand: "Utvid"
};
var j$ = {};
j$ = {
  ascending: "oplopend",
  ascendingSort: (e) => `gesorteerd in oplopende volgorde in kolom ${e.columnName}`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "aflopend",
  descendingSort: (e) => `gesorteerd in aflopende volgorde in kolom ${e.columnName}`,
  resizerDescription: "Druk op Enter om het formaat te wijzigen",
  select: "Selecteren",
  selectAll: "Alles selecteren",
  sortable: "sorteerbare kolom",
  collapse: "Samenvouwen",
  expand: "Uitvouwen"
};
var _$ = {};
_$ = {
  ascending: "rosnąco",
  ascendingSort: (e) => `posortowano według kolumny ${e.columnName} w porządku rosnącym`,
  columnSize: (e) => `Liczba pikseli: ${e.value}`,
  descending: "malejąco",
  descendingSort: (e) => `posortowano według kolumny ${e.columnName} w porządku malejącym`,
  resizerDescription: "Naciśnij Enter, aby rozpocząć zmienianie rozmiaru",
  select: "Zaznacz",
  selectAll: "Zaznacz wszystko",
  sortable: "kolumna z możliwością sortowania",
  collapse: "Zwiń",
  expand: "Rozwiń"
};
var W$ = {};
W$ = {
  ascending: "crescente",
  ascendingSort: (e) => `classificado pela coluna ${e.columnName} em ordem crescente`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "decrescente",
  descendingSort: (e) => `classificado pela coluna ${e.columnName} em ordem decrescente`,
  resizerDescription: "Pressione Enter para começar a redimensionar",
  select: "Selecionar",
  selectAll: "Selecionar tudo",
  sortable: "coluna classificável",
  collapse: "Recolher",
  expand: "Expandir"
};
var G$ = {};
G$ = {
  ascending: "ascendente",
  ascendingSort: (e) => `Ordenar por coluna ${e.columnName} em ordem ascendente`,
  columnSize: (e) => `${e.value} pixels`,
  descending: "descendente",
  descendingSort: (e) => `Ordenar por coluna ${e.columnName} em ordem descendente`,
  resizerDescription: "Prima Enter para iniciar o redimensionamento",
  select: "Selecionar",
  selectAll: "Selecionar tudo",
  sortable: "Coluna ordenável",
  collapse: "Colapsar",
  expand: "Expandir"
};
var q$ = {};
q$ = {
  ascending: "crescătoare",
  ascendingSort: (e) => `sortate după coloana ${e.columnName} în ordine crescătoare`,
  columnSize: (e) => `${e.value} pixeli`,
  descending: "descrescătoare",
  descendingSort: (e) => `sortate după coloana ${e.columnName} în ordine descrescătoare`,
  resizerDescription: "Apăsați pe Enter pentru a începe redimensionarea",
  select: "Selectare",
  selectAll: "Selectare totală",
  sortable: "coloană sortabilă",
  collapse: "Restrângeți",
  expand: "Extindeți"
};
var Y$ = {};
Y$ = {
  ascending: "возрастание",
  ascendingSort: (e) => `сортировать столбец ${e.columnName} в порядке возрастания`,
  columnSize: (e) => `${e.value} пикс.`,
  descending: "убывание",
  descendingSort: (e) => `сортировать столбец ${e.columnName} в порядке убывания`,
  resizerDescription: "Нажмите клавишу Enter для начала изменения размеров",
  select: "Выбрать",
  selectAll: "Выбрать все",
  sortable: "сортируемый столбец",
  collapse: "Свернуть",
  expand: "Развернуть"
};
var Z$ = {};
Z$ = {
  ascending: "vzostupne",
  ascendingSort: (e) => `zoradené zostupne podľa stĺpca ${e.columnName}`,
  columnSize: (e) => `Počet pixelov: ${e.value}`,
  descending: "zostupne",
  descendingSort: (e) => `zoradené zostupne podľa stĺpca ${e.columnName}`,
  resizerDescription: "Stlačením klávesu Enter začnete zmenu veľkosti",
  select: "Vybrať",
  selectAll: "Vybrať všetko",
  sortable: "zoraditeľný stĺpec",
  collapse: "Zbaliť",
  expand: "Rozbaliť"
};
var X$ = {};
X$ = {
  ascending: "naraščajoče",
  ascendingSort: (e) => `razvrščeno po stolpcu ${e.columnName} v naraščajočem vrstnem redu`,
  columnSize: (e) => `${e.value} slikovnih pik`,
  descending: "padajoče",
  descendingSort: (e) => `razvrščeno po stolpcu ${e.columnName} v padajočem vrstnem redu`,
  resizerDescription: "Pritisnite tipko Enter da začnete spreminjati velikost",
  select: "Izberite",
  selectAll: "Izberite vse",
  sortable: "razvrstljivi stolpec",
  collapse: "Strni",
  expand: "Razširi"
};
var J$ = {};
J$ = {
  ascending: "rastući",
  ascendingSort: (e) => `sortirano po kolonama ${e.columnName} rastućim redosledom`,
  columnSize: (e) => `${e.value} piksela`,
  descending: "padajući",
  descendingSort: (e) => `sortirano po kolonama ${e.columnName} padajućim redosledom`,
  resizerDescription: "Pritisnite Enter da biste započeli promenu veličine",
  select: "Izaberite",
  selectAll: "Izaberite sve",
  sortable: "kolona koja se može sortirati",
  collapse: " Skupi",
  expand: "Proširi"
};
var Q$ = {};
Q$ = {
  ascending: "stigande",
  ascendingSort: (e) => `sorterat på kolumn ${e.columnName} i stigande ordning`,
  columnSize: (e) => `${e.value} pixlar`,
  descending: "fallande",
  descendingSort: (e) => `sorterat på kolumn ${e.columnName} i fallande ordning`,
  resizerDescription: "Tryck på Retur för att börja ändra storlek",
  select: "Markera",
  selectAll: "Markera allt",
  sortable: "sorterbar kolumn",
  collapse: "Dölj",
  expand: "Expandera"
};
var e1 = {};
e1 = {
  ascending: "artan sırada",
  ascendingSort: (e) => `${e.columnName} sütuna göre artan düzende sırala`,
  columnSize: (e) => `${e.value} piksel`,
  descending: "azalan sırada",
  descendingSort: (e) => `${e.columnName} sütuna göre azalan düzende sırala`,
  resizerDescription: "Yeniden boyutlandırmak için Enter'a basın",
  select: "Seç",
  selectAll: "Tümünü Seç",
  sortable: "Sıralanabilir sütun",
  collapse: "Daralt",
  expand: "Genişlet"
};
var t1 = {};
t1 = {
  ascending: "висхідний",
  ascendingSort: (e) => `відсортовано за стовпцем ${e.columnName} у висхідному порядку`,
  columnSize: (e) => `${e.value} пікс.`,
  descending: "низхідний",
  descendingSort: (e) => `відсортовано за стовпцем ${e.columnName} у низхідному порядку`,
  resizerDescription: "Натисніть Enter, щоб почати зміну розміру",
  select: "Вибрати",
  selectAll: "Вибрати все",
  sortable: "сортувальний стовпець",
  collapse: "Згорнути",
  expand: "Розгорнути"
};
var n1 = {};
n1 = {
  ascending: "升序",
  ascendingSort: (e) => `按列 ${e.columnName} 升序排序`,
  columnSize: (e) => `${e.value} 像素`,
  descending: "降序",
  descendingSort: (e) => `按列 ${e.columnName} 降序排序`,
  resizerDescription: "按“输入”键开始调整大小。",
  select: "选择",
  selectAll: "全选",
  sortable: "可排序的列",
  collapse: "折叠",
  expand: "扩展"
};
var r1 = {};
r1 = {
  ascending: "遞增",
  ascendingSort: (e) => `已依據「${e.columnName}」欄遞增排序`,
  columnSize: (e) => `${e.value} 像素`,
  descending: "遞減",
  descendingSort: (e) => `已依據「${e.columnName}」欄遞減排序`,
  resizerDescription: "按 Enter 鍵以開始調整大小",
  select: "選取",
  selectAll: "全選",
  sortable: "可排序的欄",
  collapse: "收合",
  expand: "展開"
};
var Ar = {};
Ar = {
  "ar-AE": C$,
  "bg-BG": P$,
  "cs-CZ": w$,
  "da-DK": S$,
  "de-DE": k$,
  "el-GR": B$,
  "en-US": F$,
  "es-ES": A$,
  "et-EE": R$,
  "fi-FI": T$,
  "fr-FR": I$,
  "he-IL": M$,
  "hr-HR": K$,
  "hu-HU": N$,
  "it-IT": V$,
  "ja-JP": L$,
  "ko-KR": z$,
  "lt-LT": O$,
  "lv-LV": H$,
  "nb-NO": U$,
  "nl-NL": j$,
  "pl-PL": _$,
  "pt-BR": W$,
  "pt-PT": G$,
  "ro-RO": q$,
  "ru-RU": Y$,
  "sk-SK": Z$,
  "sl-SI": X$,
  "sr-SP": J$,
  "sv-SE": Q$,
  "tr-TR": e1,
  "uk-UA": t1,
  "zh-CN": n1,
  "zh-TW": r1
};
class QE extends D$ {
  isCell(t) {
    return t.type === "cell" || t.type === "rowheader" || t.type === "column";
  }
  getKeyBelow(t, n) {
    let r = this.collection.getItem(t);
    if (!r) return null;
    if (r.type === "column") {
      let a = jt(Me(r, this.collection));
      if (a) return a.key;
      let l = this.getFirstKey();
      return l == null || !this.collection.getItem(l) ? null : super.getKeyForItemInRowByIndex(l, r.index);
    }
    return super.getKeyBelow(t, n);
  }
  getKeyAbove(t, n) {
    let r = this.collection.getItem(t);
    if (!r) return null;
    if (r.type === "column") {
      let i = r.parentKey != null ? this.collection.getItem(r.parentKey) : null;
      return i && i.type === "column" ? i.key : null;
    }
    let a = super.getKeyAbove(t, n), l = a != null ? this.collection.getItem(a) : null;
    return l && l.type !== "headerrow" ? a : this.isCell(r) ? this.collection.columns[r.index].key : this.collection.columns[0].key;
  }
  findNextColumnKey(t) {
    let n = this.findNextKey(t.key, (a) => a.type === "column");
    if (n != null) return n;
    let r = this.collection.headerRows[t.level];
    for (let a of Me(r, this.collection))
      if (a.type === "column") return a.key;
    return null;
  }
  findPreviousColumnKey(t) {
    let n = this.findPreviousKey(t.key, (l) => l.type === "column");
    if (n != null) return n;
    let r = this.collection.headerRows[t.level], a = [
      ...Me(r, this.collection)
    ];
    for (let l = a.length - 1; l >= 0; l--) {
      let i = a[l];
      if (i.type === "column") return i.key;
    }
    return null;
  }
  getKeyRightOf(t) {
    let n = this.collection.getItem(t);
    return n ? n.type === "column" ? this.direction === "rtl" ? this.findPreviousColumnKey(n) : this.findNextColumnKey(n) : super.getKeyRightOf(t) : null;
  }
  getKeyLeftOf(t) {
    let n = this.collection.getItem(t);
    return n ? n.type === "column" ? this.direction === "rtl" ? this.findNextColumnKey(n) : this.findPreviousColumnKey(n) : super.getKeyLeftOf(t) : null;
  }
  getKeyForSearch(t, n) {
    if (!this.collator) return null;
    let r = this.collection, a = n ?? this.getFirstKey();
    if (a == null) return null;
    let l = r.getItem(a);
    l?.type === "cell" && (a = l.parentKey ?? null);
    let i = !1;
    for (; a != null; ) {
      let u = r.getItem(a);
      if (!u) return null;
      if (u.textValue) {
        let o = u.textValue.slice(0, t.length);
        if (this.collator.compare(o, t) === 0) return u.key;
      }
      for (let o of Me(u, this.collection)) {
        let d = r.columns[o.index];
        if (r.rowHeaderColumnKeys.has(d.key) && o.textValue) {
          let s = o.textValue.slice(0, t.length);
          if (this.collator.compare(s, t) === 0)
            return (n != null ? r.getItem(n) : l)?.type === "cell" ? o.key : u.key;
        }
      }
      a = this.getKeyBelow(a), a == null && !i && (a = this.getFirstKey(), i = !0);
    }
    return null;
  }
}
function e8(e) {
  return e && e.__esModule ? e.default : e;
}
function t8(e, t, n) {
  let { keyboardDelegate: r, isVirtualized: a, layoutDelegate: l, layout: i } = e, u = wr({
    usage: "search",
    sensitivity: "base"
  }), { direction: o } = de(), d = t.selectionManager.disabledBehavior, s = K(() => r || new QE({
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    disabledBehavior: d,
    ref: n,
    direction: o,
    collator: u,
    layoutDelegate: l,
    layout: i
  }), [
    r,
    t.collection,
    t.disabledKeys,
    d,
    n,
    o,
    u,
    l,
    i
  ]), c = ce(e.id);
  yo.set(t, c);
  let { gridProps: f } = JE({
    ...e,
    id: c,
    keyboardDelegate: s
  }, t, n);
  a && (f["aria-rowcount"] = t.collection.size + t.collection.headerRows.length), t.treeColumn != null && (f.role = "treegrid");
  let { column: h, direction: m } = t.sortDescriptor || {}, p = xe(e8(Ar), "@react-aria/table"), b = K(() => {
    let $ = t.collection.columns.find((v) => v.key === h)?.textValue ?? "";
    return m && h ? p.format(`${m}Sort`, {
      columnName: $
    }) : void 0;
  }, [
    m,
    h,
    t.collection.columns
  ]), y = en(b);
  return ll(() => {
    b && bn(b, "assertive", 500);
  }, [
    b
  ]), {
    gridProps: z(f, y, {
      // merge sort description with long press information
      "aria-describedby": [
        y["aria-describedby"],
        f["aria-describedby"]
      ].filter(Boolean).join(" ")
    })
  };
}
function a1(e, t, n) {
  let { node: r, isVirtualized: a, focusMode: l = "child", shouldSelectOnPressUp: i, onAction: u } = e, { direction: o } = de(), { keyboardDelegate: d, actions: { onCellAction: s } } = go.get(t), c = T(null), f = () => {
    if (n.current) {
      let $ = Te(n.current);
      if (l === "child") {
        if (qt(n.current) && n.current !== se()) return;
        let v = t.selectionManager.childFocusStrategy === "last" ? pi($) : $.firstChild();
        if (v) {
          we(v);
          return;
        }
      }
      (c.current != null && r.key !== c.current || !qt(n.current)) && we(n.current);
    }
  }, { itemProps: h, isPressed: m } = Sr({
    selectionManager: t.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: a,
    focus: f,
    shouldSelectOnPressUp: i,
    onAction: s ? () => s(r.key) : u,
    isDisabled: t.collection.size === 0
  }), p = ($) => {
    let v = se();
    if (!ae($.currentTarget, W($)) || t.isKeyboardNavigationDisabled || !n.current || !v) return;
    let x = Te(n.current);
    switch (x.currentNode = v, $.key) {
      case "ArrowLeft": {
        let E = o === "rtl" ? x.nextNode() : x.previousNode();
        if (l === "child" && E === n.current && (E = null), $.preventDefault(), $.stopPropagation(), E)
          we(E), ze(E, {
            containingElement: Le(n.current)
          });
        else {
          if (d.getKeyLeftOf?.(r.key) !== r.key) {
            n.current.parentElement?.dispatchEvent(new KeyboardEvent($.nativeEvent.type, $.nativeEvent));
            break;
          }
          l === "cell" && o === "rtl" ? (we(n.current), ze(n.current, {
            containingElement: Le(n.current)
          })) : (x.currentNode = n.current, E = o === "rtl" ? x.firstChild() : pi(x), E && (we(E), ze(E, {
            containingElement: Le(n.current)
          })));
        }
        break;
      }
      case "ArrowRight": {
        let E = o === "rtl" ? x.previousNode() : x.nextNode();
        if (l === "child" && E === n.current && (E = null), $.preventDefault(), $.stopPropagation(), E)
          we(E), ze(E, {
            containingElement: Le(n.current)
          });
        else {
          if (d.getKeyRightOf?.(r.key) !== r.key) {
            n.current.parentElement?.dispatchEvent(new KeyboardEvent($.nativeEvent.type, $.nativeEvent));
            break;
          }
          l === "cell" && o === "ltr" ? (we(n.current), ze(n.current, {
            containingElement: Le(n.current)
          })) : (x.currentNode = n.current, E = o === "rtl" ? pi(x) : x.firstChild(), E && (we(E), ze(E, {
            containingElement: Le(n.current)
          })));
        }
        break;
      }
      case "ArrowUp":
      case "ArrowDown":
        !$.altKey && ae(n.current, W($)) && ($.stopPropagation(), $.preventDefault(), n.current.parentElement?.dispatchEvent(new KeyboardEvent($.nativeEvent.type, $.nativeEvent)));
        break;
    }
  }, b = ($) => {
    if (c.current = r.key, W($) !== n.current) {
      Mt() || t.selectionManager.setFocusedKey(r.key);
      return;
    }
    requestAnimationFrame(() => {
      l === "child" && se() === n.current && f();
    });
  }, y = z(h, {
    role: "gridcell",
    onKeyDownCapture: p,
    "aria-colspan": r.colSpan,
    "aria-colindex": r.colIndex != null ? r.colIndex + 1 : void 0,
    colSpan: a ? void 0 : r.colSpan,
    onFocus: b
  });
  return a && (y["aria-colindex"] = (r.colIndex ?? r.index) + 1), i && y.tabIndex != null && y.onPointerDown == null && (y.onPointerDown = ($) => {
    let v = $.currentTarget, x = v.getAttribute("tabindex");
    v.removeAttribute("tabindex"), requestAnimationFrame(() => {
      x != null && v.setAttribute("tabindex", x);
    });
  }), {
    gridCellProps: y,
    isPressed: m
  };
}
function pi(e) {
  let t = null, n = null;
  do
    n = e.lastChild(), n && (t = n);
  while (n);
  return t;
}
function n8(e) {
  return e && e.__esModule ? e.default : e;
}
function r8(e, t, n) {
  let { node: r } = e, a = r.props.allowsSorting, { gridCellProps: l } = a1({
    ...e,
    focusMode: "child"
  }, t, n), i = r.props.isSelectionCell && t.selectionManager.selectionMode === "single", { pressProps: u, isPressed: o } = Xe({
    isDisabled: !a || i,
    onPress() {
      t.sort(r.key);
    },
    ref: n
  }), { focusableProps: d } = dt({}, n), s, c = t.sortDescriptor?.column === r.key, f = t.sortDescriptor?.direction;
  r.props.allowsSorting && !pn() && (s = c ? f : "none");
  let h = xe(n8(Ar), "@react-aria/table"), m;
  a && (m = `${h.format("sortable")}`, c && f && pn() && (m = `${m}, ${h.format(f)}`));
  let p = en(m), b = t.collection.size === 0;
  return ee(() => {
    b && t.selectionManager.focusedKey === r.key && t.selectionManager.setFocusedKey(null);
  }, [
    b,
    t.selectionManager,
    r.key
  ]), {
    columnHeaderProps: {
      ...z(
        d,
        l,
        u,
        p,
        // If the table is empty, make all column headers untabbable
        b ? {
          tabIndex: -1
        } : null
      ),
      role: "columnheader",
      id: x$(t, r.key),
      "aria-colspan": r.colSpan && r.colSpan > 1 ? r.colSpan : void 0,
      "aria-sort": s
    },
    isPressed: o
  };
}
function a8(e, t, n) {
  let { node: r, isVirtualized: a, shouldSelectOnPressUp: l, onAction: i } = e, { actions: u, shouldSelectOnPressUp: o } = go.get(t), d = u.onRowAction ? () => u.onRowAction?.(r.key) : i, { itemProps: s, ...c } = Sr({
    selectionManager: t.selectionManager,
    key: r.key,
    ref: n,
    isVirtualized: a,
    shouldSelectOnPressUp: o || l,
    onAction: d || r?.props?.onAction ? ot(r?.props?.onAction, d) : void 0,
    isDisabled: t.collection.size === 0
  }), f = t.selectionManager.isSelected(r.key), h = {
    role: "row",
    "aria-selected": t.selectionManager.selectionMode !== "none" ? f : void 0,
    "aria-disabled": c.isDisabled || void 0,
    ...s
  };
  return a && (h["aria-rowindex"] = r.index + 1), {
    rowProps: h,
    ...c
  };
}
function l8(e) {
  return e && e.__esModule ? e.default : e;
}
const kd = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function i8(e, t, n) {
  let { node: r, isVirtualized: a } = e, { rowProps: l, ...i } = a8(e, t, n), { direction: u } = de();
  a && t.treeColumn == null ? l["aria-rowindex"] = r.index + 1 + t.collection.headerRows.length : delete l["aria-rowindex"];
  let o = t.treeColumn != null && (t.expandedKeys === "all" || t.expandedKeys.has(r.key)), d = xe(l8(Ar), "@react-aria/table"), s = it({
    "aria-label": o ? d.format("collapse") : d.format("expand"),
    "aria-labelledby": au(t, r.key)
  }), c = {}, f = {};
  if (t.treeColumn != null) {
    let p = t.collection.getItem(r.key);
    if (p != null) {
      let b = Bd(t.collection, r), y = p.props?.hasChildRows || p.props?.UNSTABLE_childItems || b?.type !== "cell", $ = t.collection.getItem(r.parentKey), v = $.type === "tablebody" || $.type === "body", x = Bd(t.collection, $);
      for (; x && x.type !== "item" && x.prevKey != null; ) x = t.collection.getItem(x.prevKey);
      c = {
        onKeyDown: (E) => {
          E.key === kd.expand[u] && t.selectionManager.focusedKey === p.key && y && t.expandedKeys !== "all" && !t.expandedKeys.has(p.key) ? (t.toggleKey(p.key), E.stopPropagation()) : E.key === kd.collapse[u] && t.selectionManager.focusedKey === p.key && (t.expandedKeys !== "all" ? y && t.expandedKeys.has(p.key) ? (t.toggleKey(p.key), E.stopPropagation()) : !t.expandedKeys.has(p.key) && p.parentKey != null && p.level > 0 && (t.selectionManager.setFocusedKey(p.parentKey), E.stopPropagation()) : t.expandedKeys === "all" && (t.toggleKey(p.key), E.stopPropagation()));
        },
        "aria-expanded": y ? t.expandedKeys === "all" || t.expandedKeys.has(r.key) : void 0,
        "aria-level": p.level + 1,
        "aria-posinset": p.index - (v ? 0 : t.collection.columnCount) + 1,
        "aria-setsize": x.index - (v ? 0 : t.collection.columnCount) + 1
      }, f = {
        isDisabled: i.isDisabled,
        onPress: () => {
          i.isDisabled || (t.toggleKey(r.key), t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(r.key));
        },
        excludeFromTabOrder: !0,
        preventFocusOnPress: !0,
        // @ts-ignore
        "data-react-aria-prevent-focus": !0,
        ...s
      };
    }
  }
  let h = yu(r.props), m = i.hasAction ? h : {};
  return {
    rowProps: {
      ...z(l, c, m),
      "aria-labelledby": au(t, r.key)
    },
    expandButtonProps: f,
    ...i
  };
}
function Bd(e, t) {
  return "lastChildKey" in t ? t.lastChildKey != null ? e.getItem(t.lastChildKey) : null : Array.from(t.childNodes).findLast((n) => n.parentKey === t.key);
}
function u8(e, t, n) {
  let { node: r, isVirtualized: a } = e, l = {
    role: "row"
  };
  return a && t.treeColumn == null && (l["aria-rowindex"] = r.index + 1), {
    rowProps: l
  };
}
function o8(e, t, n) {
  let { gridCellProps: r, isPressed: a } = a1(e, t, n), l = e.node.column?.key;
  return l != null && t.collection.rowHeaderColumnKeys.has(l) && (r.role = "rowheader", r.id = E$(t, e.node.parentKey, l)), {
    gridCellProps: r,
    isPressed: a
  };
}
function s8(e) {
  return e && e.__esModule ? e.default : e;
}
function d8(e, t) {
  let { key: n } = e;
  const { checkboxProps: r } = lE(e, t);
  return {
    checkboxProps: {
      ...r,
      "aria-labelledby": `${r.id} ${au(t, n)}`
    }
  };
}
function c8(e) {
  let { isEmpty: t, isSelectAll: n, selectionMode: r } = e.selectionManager;
  return {
    checkboxProps: {
      "aria-label": xe(s8(Ar), "@react-aria/table").format(r === "single" ? "select" : "selectAll"),
      isSelected: n,
      isDisabled: r !== "multiple" || e.collection.size === 0 || e.collection.rows.length === 1 && e.collection.rows[0].type === "loader",
      isIndeterminate: !t && !n,
      onChange: () => e.selectionManager.toggleSelectAll()
    }
  };
}
function f8(e) {
  return e && e.__esModule ? e.default : e;
}
function h8(e, t, n) {
  let { column: r, triggerRef: a, isDisabled: l, onResizeStart: i, onResize: u, onResizeEnd: o, "aria-label": d } = e;
  const s = xe(f8(Ar), "@react-aria/table");
  let c = ce(), f = t.resizingColumn === r.key, h = T(f), m = T(null), p = T(!1), b = t.tableState.isKeyboardNavigationDisabled, { direction: y } = de(), $ = X((B) => {
    h.current || (m.current = t.updateResizedColumns(B.key, t.getColumnWidth(B.key)), t.startResize(B.key), t.tableState.setKeyboardNavigationDisabled(!0), i?.(m.current)), h.current = !0;
  }, [
    t,
    i
  ]), v = X((B, L) => {
    let Z = t.updateResizedColumns(B.key, L);
    u?.(Z), m.current = Z;
  }, [
    t,
    u
  ]), x = X((B) => {
    h.current && (m.current == null && (m.current = t.updateResizedColumns(B.key, t.getColumnWidth(B.key))), t.endResize(), t.tableState.setKeyboardNavigationDisabled(!1), o?.(m.current), h.current = !1, a?.current && !p.current && we(a.current)), m.current = null;
  }, [
    t,
    a,
    o
  ]), { keyboardProps: E } = Er({
    onKeyDown: (B) => {
      b ? (B.key === "Escape" || B.key === "Enter" || B.key === " " || B.key === "Tab") && (B.preventDefault(), x(r)) : (B.continuePropagation(), B.key === "Enter" && $(r));
    }
  });
  const P = T(0), { moveProps: C } = ua({
    onMoveStart() {
      P.current = t.getColumnWidth(r.key), $(r);
    },
    onMove(B) {
      let { deltaX: L, deltaY: Z, pointerType: ie } = B;
      y === "rtl" && (L *= -1), ie === "keyboard" && (Z !== 0 && L === 0 && (L = Z * -1), L *= 10), L !== 0 && (P.current += L, v(r, P.current));
    },
    onMoveEnd(B) {
      let { pointerType: L } = B;
      P.current = 0, (L === "mouse" || L === "touch" && p.current) && x(r);
    }
  });
  let M = X((B) => {
    b && C.onKeyDown?.(B);
  }, [
    b,
    C
  ]), F = Math.floor(t.getColumnMinWidth(r.key)), V = Math.floor(t.getColumnMaxWidth(r.key));
  V === 1 / 0 && (V = Number.MAX_SAFE_INTEGER);
  let I = Math.floor(t.getColumnWidth(r.key)), A = yl();
  A === "virtual" && typeof window < "u" && "ontouchstart" in window && (A = "touch");
  let U = a?.current == null && (A === "keyboard" || A === "virtual") && !f ? s.format("resizerDescription") : void 0, D = en(U), N = {
    "aria-label": d,
    "aria-orientation": "horizontal",
    "aria-labelledby": `${c} ${x$(t.tableState, r.key)}`,
    "aria-valuetext": s.format("columnSize", {
      value: I
    }),
    type: "range",
    min: F,
    max: V,
    value: I,
    ...D
  };
  const w = X(() => {
    n.current && we(n.current);
  }, [
    n
  ]);
  let R = t.resizingColumn, H = T(null), k = De($);
  ee(() => {
    if (H.current !== R && R != null && R === r.key) {
      p.current = se() === n.current, k(r);
      let B = setTimeout(() => w(), 0), L = setTimeout(w, 400);
      return () => {
        clearTimeout(B), clearTimeout(L);
      };
    }
    H.current = R;
  }, [
    R,
    r,
    w,
    n
  ]);
  let S = (B) => {
    let L = t.getColumnWidth(r.key), Z = parseFloat(W(B).value);
    Z > L ? Z = L + 10 : Z = L - 10, v(r, Z);
  }, { pressProps: j } = Xe({
    preventFocusOnPress: !0,
    onPressStart: (B) => {
      if (!(B.ctrlKey || B.altKey || B.metaKey || B.shiftKey || B.pointerType === "keyboard")) {
        if (B.pointerType === "virtual" && t.resizingColumn != null) {
          x(r);
          return;
        }
        w(), B.pointerType !== "virtual" && $(r);
      }
    },
    onPress: (B) => {
      (B.pointerType === "touch" && p.current || B.pointerType === "mouse") && t.resizingColumn != null && x(r);
    }
  }), { visuallyHiddenProps: _ } = tn();
  return {
    resizerProps: z(E, {
      ...C,
      onKeyDown: M
    }, j, {
      style: {
        touchAction: "none"
      }
    }),
    inputProps: z(_, {
      id: c,
      onBlur: () => {
        x(r);
      },
      onChange: S,
      disabled: l
    }, N),
    isResizing: f
  };
}
function m8() {
  return {
    rowGroupProps: {
      role: "rowgroup"
    }
  };
}
function l1() {
  return m8();
}
function p8(e) {
  return e && e.__esModule ? e.default : e;
}
class b8 extends Oc {
  withExpandedKeys(t) {
    let n = this.clone();
    return n.expandedKeys = t, n.frozen = this.frozen, n.rows = Array.from(n.getRows()), n;
  }
  addNode(t) {
    super.addNode(t), this.columnsDirty ||= t.type === "column", t.type === "tableheader" && (this.head = t);
  }
  getRows() {
    let t = [];
    for (let n of this) (n.type === "tablebody" || n.type === "tablefooter") && t.push(...this.getChildren(n.key));
    return t;
  }
  // backward compatibility
  get body() {
    for (let t of this)
      if (t.type === "tablebody") return t;
    return new hl(-2);
  }
  commit(t, n, r = !1) {
    this.updateColumns(r), this.firstKey = t, this.lastKey = n, this.rows = [];
    for (let a of this.getRows()) {
      let l = a.lastChildKey;
      if (l != null) {
        let i = this.getItem(l);
        for (; i && i.type !== "cell"; ) i = i.prevKey != null ? this.getItem(i.prevKey) : null;
        if (i) {
          let u = (i.colIndex ?? i.index) + (i.colSpan ?? 1);
          if (u !== this.columns.length && !r) throw new Error(`Cell count must match column count. Found ${u} cells and ${this.columns.length} columns.`);
        }
      }
      this.rows.push(a);
    }
    super.commit(t, n, r);
  }
  updateColumns(t) {
    if (!this.columnsDirty) return;
    this.rowHeaderColumnKeys = /* @__PURE__ */ new Set(), this.columns = [];
    let n = /* @__PURE__ */ new Map(), r = (a) => {
      a.type === "column" && (n.set(a.key, a), a.hasChildNodes || (a.index = this.columns.length, this.columns.push(a), a.props.isRowHeader && this.rowHeaderColumnKeys.add(a.key)));
      for (let l of this.getChildren(a.key)) r(l);
    };
    for (let a of this.getChildren(this.head.key)) r(a);
    if (this.headerRows = y$(n, this.columns), this.columnsDirty = !1, this.rowHeaderColumnKeys.size === 0 && this.columns.length > 0 && !t) throw new Error("A table must have at least one Column with the isRowHeader prop set to true");
  }
  get columnCount() {
    return this.columns.length;
  }
  *[Symbol.iterator]() {
    let t = this.firstKey;
    for (; t != null; ) {
      let n = this.getItem(t);
      n && (yield n), t = n?.nextKey ?? null;
    }
  }
  getFirstKey() {
    for (let t of this)
      if (t.type === "tablebody") return t.firstChildKey ?? null;
    return null;
  }
  getLastKey() {
    let t = this.lastKey;
    if (t == null) return null;
    let n = this.getItem(t);
    for (; n?.lastChildKey != null && (n.type !== "item" || this.expandedKeys.has(n.key)); ) n = this.getItem(n.lastChildKey);
    return n?.key;
  }
  getKeyAfter(t) {
    let n = this.getItem(t);
    if (n?.type === "column") return n.nextKey ?? null;
    if (!n) return null;
    if (n.type === "item" && n.firstChildKey != null && this.expandedKeys.has(n.key)) {
      let r = this.getItem(n.firstChildKey);
      for (; r; ) {
        if (r.type === "item") return r.key;
        r = r.nextKey != null ? this.getItem(r.nextKey) : null;
      }
    }
    return super.getKeyAfter(t);
  }
  getKeyBefore(t) {
    let n = this.getItem(t);
    if (n?.type === "column") return n.prevKey ?? null;
    if (!n) return null;
    let r = null;
    if (n.prevKey != null) {
      for (n = this.getItem(n.prevKey); n && (n.type !== "item" || this.expandedKeys.has(n.key)) && n.lastChildKey != null; ) n = this.getItem(n.lastChildKey);
      r = n?.key ?? null;
    }
    return r == null && (r = n.parentKey), r != null && this.getItem(r)?.type === "tableheader" ? null : r;
  }
  getChildren(t) {
    let n = this.getItem(t);
    if (!n) {
      for (let a of this.headerRows)
        if (a.key === t) return a.childNodes;
    }
    let r = this;
    return n?.type === "tablebody" || n?.type === "tablefooter" ? {
      *[Symbol.iterator]() {
        let a = n.firstChildKey, l = a != null ? r.getItem(a) : null;
        for (; l; ) {
          yield l;
          let i = r.getKeyAfter(l.key);
          if (l = i != null ? r.getItem(i) : null, l && l.parentKey === n.parentKey) break;
        }
      }
    } : {
      *[Symbol.iterator]() {
        let a = r.getItem(t), l = a?.firstChildKey != null ? r.getItem(a.firstChildKey) : null;
        for (; l && (yield l, l = l.nextKey != null ? r.getItem(l.nextKey) : null, !(a?.type === "item" && l?.type !== "cell")); )
          ;
      }
    };
  }
  clone() {
    let t = super.clone();
    return t.headerRows = this.headerRows, t.columns = this.columns, t.rows = this.rows, t.rowHeaderColumnKeys = this.rowHeaderColumnKeys, t.head = this.head, t;
  }
  getTextValue(t) {
    let n = this.getItem(t);
    if (!n) return "";
    if (n.textValue) return n.textValue;
    let r = this.rowHeaderColumnKeys, a = [];
    for (let l of this.getChildren(t)) {
      let i = this.columns[l.index];
      if (r.has(i.key) && l.textValue && a.push(l.textValue), a.length === r.size) break;
    }
    return a.join(" ");
  }
  constructor(...t) {
    super(...t), this.headerRows = [], this.columns = [], this.rows = [], this.rowHeaderColumnKeys = /* @__PURE__ */ new Set(), this.head = new fl(-1), this.columnsDirty = !0, this.expandedKeys = /* @__PURE__ */ new Set();
  }
}
const $o = /* @__PURE__ */ G(null), N9 = /* @__PURE__ */ te(function(t, n) {
  let r = $e(n), a = T(null), l = T(null), [i, u] = Y(0);
  ue(() => {
    let d = a.current;
    for (; d && d !== r.current && !gn(d); ) d = d.parentElement;
    l.current = d;
  }, [
    r
  ]), gr({
    ref: l,
    box: "border-box",
    onResize() {
      u(l.current?.clientWidth ?? 0);
    }
  }), ue(() => {
    u(l.current?.clientWidth ?? 0);
  }, []);
  let o = K(() => ({
    tableRef: a,
    scrollRef: l,
    tableWidth: i,
    useTableColumnResizeState: WE,
    onResizeStart: t.onResizeStart,
    onResize: t.onResize,
    onResizeEnd: t.onResizeEnd
  }), [
    a,
    i,
    t.onResizeStart,
    t.onResize,
    t.onResizeEnd
  ]);
  return /* @__PURE__ */ g.createElement(Q.div, {
    render: t.render,
    ...J(t, {
      global: !0
    }),
    ref: r,
    className: t.className || "react-aria-ResizableTableContainer",
    style: t.style,
    onScroll: t.onScroll
  }, /* @__PURE__ */ g.createElement($o.Provider, {
    value: o
  }, t.children));
}), g8 = /* @__PURE__ */ G(null), Lt = /* @__PURE__ */ G(null), vo = /* @__PURE__ */ G(null), V9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, g8);
  let r = $a(t), { selectionBehavior: a, selectionMode: l, disallowEmptySelection: i } = r, u = !!t.dragAndDropHooks?.useDraggableCollectionState, o = K(() => ({
    selectionBehavior: l === "none" ? null : a,
    selectionMode: l,
    disallowEmptySelection: i,
    allowsDragging: u
  }), [
    a,
    l,
    i,
    u
  ]), d = /* @__PURE__ */ g.createElement(i1.Provider, {
    value: o
  }, /* @__PURE__ */ g.createElement(Jt, t));
  return /* @__PURE__ */ g.createElement(Hn, {
    content: d,
    createCollection: () => new b8()
  }, (s) => /* @__PURE__ */ g.createElement($8, {
    props: t,
    forwardedRef: n,
    selectionState: r,
    collection: s
  }));
});
let y8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.table, {
    ...t,
    ref: n
  });
});
const Fd = {
  expand: {
    ltr: "ArrowRight",
    rtl: "ArrowLeft"
  },
  collapse: {
    ltr: "ArrowLeft",
    rtl: "ArrowRight"
  }
};
function $8({ props: e, forwardedRef: t, selectionState: n, collection: r }) {
  [e, t] = oe(e, t, Nn);
  let { shouldUseVirtualFocus: a, disallowTypeAhead: l, filter: i, ...u } = e, o = O($o);
  t = $e(K(() => xt(t, o?.tableRef), [
    t,
    o?.tableRef
  ]));
  let [d, s] = Pe(e.expandedKeys ? new Set(e.expandedKeys) : void 0, e.defaultExpandedKeys ? new Set(e.defaultExpandedKeys) : /* @__PURE__ */ new Set(), e.onExpandedChange);
  r = K(() => r.withExpandedKeys(d), [
    r,
    d
  ]);
  let c = YE({
    ...u,
    collection: r,
    children: void 0,
    UNSAFE_selectionState: n,
    expandedKeys: d,
    onExpandedChange: s
  }), f = ZE(c, i), { isVirtualized: h, layoutDelegate: m, dropTargetDelegate: p, CollectionRoot: b } = O(ge), { dragAndDropHooks: y } = e, { gridProps: $ } = t8({
    ...u,
    layoutDelegate: m,
    isVirtualized: h
  }, f, t), v = f.selectionManager, x = !!y?.useDraggableCollectionState, E = !!y?.useDroppableCollectionState, P = T(x), C = T(E);
  ee(() => {
    process.env.NODE_ENV !== "production" && (P.current !== x && console.warn("Drag hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."), C.current !== E && console.warn("Drop hooks were provided during one render, but not another. This should be avoided as it may produce unexpected behavior."));
  }, [
    x,
    E
  ]);
  let M, F, V, I = !1, A = null, U = T(null), { direction: D } = de(), [N] = Y(() => new VE());
  if (x && y) {
    M = y.useDraggableCollectionState({
      collection: f.collection,
      selectionManager: v,
      preview: y.renderDragPreview ? U : void 0
    }), y.useDraggableCollection({}, M, t);
    let L = y.DragPreview;
    A = y.renderDragPreview ? /* @__PURE__ */ g.createElement(L, {
      ref: U
    }, y.renderDragPreview) : null;
  }
  if (E && y) {
    F = y.useDroppableCollectionState({
      collection: f.collection,
      selectionManager: v
    });
    let L = new ya({
      collection: f.collection,
      disabledKeys: v.disabledKeys,
      disabledBehavior: v.disabledBehavior,
      ref: t,
      layoutDelegate: m
    }), Z = y.dropTargetDelegate || p || new y.ListDropTargetDelegate(r.rows, t);
    N.setup(Z, c, D), V = y.useDroppableCollection({
      keyboardDelegate: L,
      dropTargetDelegate: N,
      onDropActivate: (ie) => {
        if (ie.target.type === "item") {
          let q = ie.target.key, re = c.collection.getItem(q), fe = d.has(q);
          re && re.hasChildNodes && (!fe || y?.isVirtualDragging?.()) && c.toggleKey(q);
        }
      },
      onKeyDown: (ie) => {
        let q = F?.target;
        if (q && q.type === "item" && q.dropPosition === "on") {
          let re = c.collection.getItem(q.key);
          (ie.key === Fd.expand[D] && re?.hasChildNodes && !c.expandedKeys.has(q.key) || ie.key === Fd.collapse[D] && re?.hasChildNodes && c.expandedKeys.has(q.key)) && c.toggleKey(q.key);
        }
      }
    }, F, t), I = F.isDropTarget({
      type: "root"
    });
  }
  let { focusProps: w, isFocused: R, isFocusVisible: H } = ye(), k = le({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-Table",
    values: {
      isDropTarget: I,
      isFocused: R,
      isFocusVisible: H,
      state: f
    }
  }), S = !!(x && !M?.isDisabled), j = k.style, _ = null;
  o && (_ = o.useTableColumnResizeState({
    tableWidth: o.tableWidth
  }, f), h || (j = {
    ...j,
    tableLayout: "fixed",
    // due to https://bugzilla.mozilla.org/show_bug.cgi?id=1959353, we can't use "fit-content".
    // Causes the table columns to grow to fill the available space in Firefox, ignoring user set column widths
    width: "min-content"
  }));
  let B = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Lt,
        f
      ],
      [
        vo,
        _
      ],
      [
        Nt,
        {
          dragAndDropHooks: y,
          dragState: M,
          dropState: F
        }
      ],
      [
        Yu,
        {
          render: P8
        }
      ],
      [
        Nn,
        null
      ],
      [
        ca,
        null
      ]
    ]
  }, /* @__PURE__ */ g.createElement(Sl, null, /* @__PURE__ */ g.createElement(y8, {
    ...z(B, k, $, w, V?.collectionProps),
    style: j,
    ref: t,
    slot: e.slot || void 0,
    onScroll: e.onScroll,
    "data-allows-dragging": S || void 0,
    "data-drop-target": I || void 0,
    "data-focused": R || void 0,
    "data-focus-visible": H || void 0
  }, /* @__PURE__ */ g.createElement(jn, null, /* @__PURE__ */ g.createElement(b, {
    collection: f.collection,
    scrollRef: o?.scrollRef ?? t,
    persistedKeys: Ap(v, y, F)
  })))), A);
}
const i1 = /* @__PURE__ */ G(null);
function L9() {
  return O(i1);
}
const Ao = class Ao extends st {
};
Ao.type = "tableheader";
let fl = Ao, v8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.thead, {
    ...t,
    ref: n
  });
});
const z9 = /* @__PURE__ */ fa(fl, (e, t) => {
  let n = O(Lt).collection, r = vu({
    items: n.headerRows,
    children: X((o) => {
      if (o.type === "headerrow")
        return /* @__PURE__ */ g.createElement(x8, {
          item: o
        });
      throw new Error("Unsupported node type in TableHeader: " + o.type);
    }, [])
  }), { rowGroupProps: a } = l1(), { hoverProps: l, isHovered: i } = ve({
    onHoverStart: e.onHoverStart,
    onHoverChange: e.onHoverChange,
    onHoverEnd: e.onHoverEnd
  }), u = le({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-TableHeader",
    values: {
      isHovered: i
    }
  });
  return /* @__PURE__ */ g.createElement(v8, {
    ...z(J(e, {
      global: !0
    }), a, l),
    ...u,
    ref: t,
    "data-hovered": i || void 0
  }, r);
}, (e) => /* @__PURE__ */ g.createElement(Jt, {
  dependencies: e.dependencies,
  items: e.columns
}, e.children));
let D8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement("div", {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement("tr", {
    ...t,
    ref: n
  });
});
function x8({ item: e }) {
  let t = T(null), n = O(Lt), { isVirtualized: r, CollectionBranch: a } = O(ge), { rowProps: l } = u8({
    node: e,
    isVirtualized: r
  }, n, t), { checkboxProps: i } = c8(n);
  return /* @__PURE__ */ g.createElement(D8, {
    ...l,
    ref: t
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        zu,
        {
          slots: {
            selection: i
          }
        }
      ],
      [
        ah,
        {
          slots: {
            selection: i
          }
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(a, {
    collection: n.collection,
    parent: e
  })));
}
const Ro = class Ro extends st {
};
Ro.type = "column";
let lu = Ro, E8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.th, {
    ...t,
    ref: n
  });
});
const O9 = /* @__PURE__ */ Ct(lu, (e, t, n) => {
  let r = $e(t), a = O(Lt), { isVirtualized: l } = O(ge), { columnHeaderProps: i, isPressed: u } = r8({
    node: n,
    isVirtualized: l
  }, a, r), { isFocused: o, isFocusVisible: d, focusProps: s } = ye(), c = O(vo), f = !1;
  if (c) f = c.resizingColumn === n.key;
  else if (process.env.NODE_ENV !== "production")
    for (let $ in [
      "width",
      "defaultWidth",
      "minWidth",
      "maxWidth"
    ]) $ in n.props && console.warn(`The ${$} prop on a <Column> only applies when a <Table> is wrapped in a <ResizableTableContainer>. If you aren't using column resizing, you can set the width of a column with CSS.`);
  let { hoverProps: h, isHovered: m } = ve({
    isDisabled: !e.allowsSorting
  }), p = le({
    ...e,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Column",
    values: {
      isHovered: m,
      isPressed: u,
      isFocused: o,
      isFocusVisible: d,
      allowsSorting: n.props.allowsSorting,
      sortDirection: a.sortDescriptor?.column === n.key ? a.sortDescriptor.direction : void 0,
      isResizing: f,
      startResize: () => {
        if (c)
          c.startResize(n.key), a.setKeyboardNavigationDisabled(!0);
        else throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
      },
      sort: ($) => {
        a.sort(n.key, $);
      }
    }
  }), b = p.style;
  c && (b = {
    ...b,
    width: c.getColumnWidth(n.key)
  });
  let y = J(e, {
    global: !0
  });
  return delete y.id, /* @__PURE__ */ g.createElement(E8, {
    ...z(y, i, s, h),
    ...p,
    style: b,
    ref: r,
    "data-hovered": m || void 0,
    "data-pressed": u || void 0,
    "data-focused": o || void 0,
    "data-focus-visible": d || void 0,
    "data-resizing": f || void 0,
    "data-allows-sorting": n.props.allowsSorting || void 0,
    "data-sort-direction": a.sortDescriptor?.column === n.key ? a.sortDescriptor.direction : void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        u1,
        {
          column: n,
          triggerRef: r
        }
      ],
      [
        ge,
        ha
      ]
    ]
  }, p.children));
}), u1 = /* @__PURE__ */ G(null), H9 = /* @__PURE__ */ te(function(t, n) {
  let r = O(vo);
  if (!r) throw new Error("Wrap your <Table> in a <ResizableTableContainer> to enable column resizing");
  let a = xe(p8(qu), "react-aria-components"), { onResizeStart: l, onResize: i, onResizeEnd: u } = O($o), { column: o, triggerRef: d } = O(u1), s = T(null), { resizerProps: c, inputProps: f, isResizing: h } = h8({
    column: o,
    "aria-label": t["aria-label"] || a.format("tableResizer"),
    onResizeStart: l,
    onResize: i,
    onResizeEnd: u,
    triggerRef: d
  }, r, s), { focusProps: m, isFocused: p, isFocusVisible: b } = ye(), { hoverProps: y, isHovered: $ } = ve(t), v = r.getColumnMinWidth(o.key) >= r.getColumnWidth(o.key), x = r.getColumnMaxWidth(o.key) <= r.getColumnWidth(o.key), { direction: E } = de(), P = "both";
  v ? P = E === "rtl" ? "right" : "left" : x ? P = E === "rtl" ? "left" : "right" : P = "both";
  let C = $e(n), [M, F] = Y("");
  ee(() => {
    if (!C.current) return;
    let N = window.getComputedStyle(C.current);
    F(N.cursor);
  }, [
    C,
    P
  ]);
  let V = le({
    ...t,
    defaultClassName: "react-aria-ColumnResizer",
    values: {
      isFocused: p,
      isFocusVisible: b,
      isResizing: h,
      isHovered: $,
      resizableDirection: P
    }
  }), [I, A] = Y(!1), U = (N) => {
    N.pointerType === "mouse" && A(!0);
  };
  !h && I && A(!1);
  let D = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ref: C,
    role: "presentation",
    ...z(D, V, c, {
      onPointerDown: U
    }, y),
    "data-hovered": $ || void 0,
    "data-focused": p || void 0,
    "data-focus-visible": b || void 0,
    "data-resizing": h || void 0,
    "data-resizable-direction": P
  }, V.children, /* @__PURE__ */ g.createElement("input", {
    ref: s,
    ...z(f, m)
  }), h && I && /* @__PURE__ */ cu.createPortal(/* @__PURE__ */ g.createElement("div", {
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      cursor: M
    }
  }), document.body));
}), To = class To extends $l {
};
To.type = "tablebody";
let hl = To, C8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.tbody, {
    ...t,
    ref: n
  });
});
const U9 = /* @__PURE__ */ fa(hl, (e, t, n) => {
  let r = O(Lt), { isVirtualized: a } = O(ge), l = r.collection, { CollectionBranch: i } = O(ge), { dragAndDropHooks: u, dropState: o } = O(Nt), d = !!u?.useDroppableCollectionState && !o?.isDisabled, s = d && !!o && (o.isDropTarget({
    type: "root"
  }) ?? !1), c = l.size === 0, f = {
    isDropTarget: s,
    isEmpty: c
  }, h = le({
    ...e,
    id: void 0,
    children: void 0,
    defaultClassName: "react-aria-TableBody",
    values: f
  }), m, p = l.columnCount;
  if (c && e.renderEmptyState && r) {
    let $ = {}, v = {}, x = {};
    a ? (v["aria-colspan"] = p, x = {
      display: "contents"
    }) : v.colSpan = p, m = /* @__PURE__ */ g.createElement($r, {
      role: "row",
      ...$,
      style: x
    }, /* @__PURE__ */ g.createElement(vr, {
      role: "rowheader",
      ...v,
      style: x
    }, e.renderEmptyState(f)));
  }
  let { rowGroupProps: b } = l1(), y = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(C8, {
    ...z(y, h, b),
    ref: t,
    "data-empty": c || void 0
  }, d && /* @__PURE__ */ g.createElement(F8, null), /* @__PURE__ */ g.createElement(i, {
    collection: l,
    parent: n,
    renderDropIndicator: Zu(u, o)
  }), m);
}), Io = class Io extends $l {
};
Io.type = "tablefooter";
let Ad = Io;
const o1 = /* @__PURE__ */ G({
  isFocusVisibleWithinRow: !1
}), Mo = class Mo extends st {
  filter(t, n, r) {
    let a = t.getChildren(this.key);
    for (let l of a) if (r(l.textValue, l)) {
      let i = this.clone();
      return n.addDescendants(i, t), i;
    }
    return null;
  }
};
Mo.type = "item";
let iu = Mo, $r = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.tr, {
    ...t,
    ref: n
  });
});
const j9 = /* @__PURE__ */ fa(iu, (e, t, n) => {
  let r = $e(t), a = O(Lt), { dragAndDropHooks: l, dragState: i, dropState: u } = O(Nt), { isVirtualized: o, CollectionBranch: d } = O(ge), s = i && !(i.isDisabled || i.selectionManager.isDisabled(n.key)), { rowProps: c, expandButtonProps: f, ...h } = i8({
    node: n,
    shouldSelectOnPressUp: !!i,
    isVirtualized: o
  }, a, r), { isFocused: m, isFocusVisible: p, focusProps: b } = ye(), { isFocusVisible: y, focusProps: $ } = ye({
    within: !0
  }), { hoverProps: v, isHovered: x } = ve({
    // because of https://bugs.webkit.org/show_bug.cgi?id=214609, supporting hover styles when a item is ONLY isDraggable
    // results in hover styles sticking around after a reorder/drop operation...
    isDisabled: !h.allowsSelection && !h.hasAction && !s,
    onHoverStart: e.onHoverStart,
    onHoverChange: e.onHoverChange,
    onHoverEnd: e.onHoverEnd
  }), { checkboxProps: E } = d8({
    key: n.key
  }, a), P;
  i && l && (P = l.useDraggableItem({
    key: n.key,
    hasDragButton: !0
  }, i));
  let C, M = T(null), { visuallyHiddenProps: F } = tn();
  u && l && (C = l.useDropIndicator({
    target: {
      type: "item",
      key: n.key,
      dropPosition: "on"
    }
  }, u, M));
  let V = T(null);
  ee(() => {
    i && !V.current && process.env.NODE_ENV !== "production" && console.warn('Draggable items in a Table must contain a <Button slot="drag"> element so that keyboard and screen reader users can drag them.');
  }, []);
  let I = i && i.isDragging(n.key), { children: A, ...U } = e, D = e.hasChildItems || a.collection.getItem(n.lastChildKey)?.type !== "cell", N = D && a.expandedKeys.has(n.key), w = le({
    ...U,
    id: void 0,
    defaultClassName: "react-aria-Row",
    defaultStyle: {
      // @ts-ignore
      "--table-row-level": n.level + 1
    },
    values: {
      ...h,
      state: a,
      isHovered: x,
      isFocused: m,
      isFocusVisible: p,
      selectionMode: a.selectionManager.selectionMode,
      selectionBehavior: a.selectionManager.selectionBehavior,
      isDragging: I,
      isDropTarget: C?.isDropTarget,
      isFocusVisibleWithin: y,
      id: n.key,
      hasChildItems: D,
      isExpanded: N,
      level: n.level + 1
    }
  }), R = J(e, {
    global: !0
  });
  return delete R.id, delete R.onClick, /* @__PURE__ */ g.createElement(g.Fragment, null, C && !C.isHidden && /* @__PURE__ */ g.createElement($r, {
    role: "row",
    style: {
      height: 0
    }
  }, /* @__PURE__ */ g.createElement(vr, {
    role: "gridcell",
    colSpan: a.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ g.createElement("div", {
    role: "button",
    ...F,
    ...C.dropIndicatorProps,
    ref: M
  }))), /* @__PURE__ */ g.createElement($r, {
    ...z(R, w, c, b, v, P?.dragProps, $),
    ref: r,
    "data-disabled": h.isDisabled || void 0,
    "data-selected": h.isSelected || void 0,
    "data-hovered": x || void 0,
    "data-focused": h.isFocused || void 0,
    "data-focus-visible": p || void 0,
    "data-pressed": h.isPressed || void 0,
    "data-dragging": I || void 0,
    "data-drop-target": C?.isDropTarget || void 0,
    "data-selection-mode": a.selectionManager.selectionMode === "none" ? void 0 : a.selectionManager.selectionMode,
    "data-focus-visible-within": y || void 0,
    "data-expanded": N || void 0,
    "data-has-child-items": D || void 0,
    "data-level": n.level + 1
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        zu,
        {
          slots: {
            [gt]: {},
            selection: E
          }
        }
      ],
      [
        ah,
        {
          slots: {
            [gt]: {},
            selection: E
          }
        }
      ],
      [
        Ze,
        {
          slots: {
            [gt]: {},
            chevron: f,
            drag: {
              ...P?.dragButtonProps,
              ref: V,
              style: {
                pointerEvents: "none"
              }
            }
          }
        }
      ],
      [
        _n,
        {
          isSelected: h.isSelected
        }
      ],
      [
        o1,
        {
          isFocusVisibleWithinRow: y
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(d, {
    collection: a.collection,
    parent: n
  }))));
}, (e) => {
  if (e.id == null && typeof e.children == "function") throw new Error("No id detected for the Row element. The Row element requires a id to be provided to it when the cells are rendered dynamically.");
  let t = [
    e.value
  ].concat(e.dependencies);
  return /* @__PURE__ */ g.createElement(Jt, {
    dependencies: t,
    items: e.columns,
    idScope: e.id
  }, e.children);
}), Ko = class Ko extends st {
};
Ko.type = "cell";
let uu = Ko, vr = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.td, {
    ...t,
    ref: n
  });
});
const _9 = /* @__PURE__ */ Ct(uu, (e, t, n) => {
  let r = $e(t), a = O(Lt), { dragState: l } = O(Nt), { isVirtualized: i } = O(ge);
  n.column = a.collection.columns[n.index];
  let { gridCellProps: u, isPressed: o } = o8({
    node: n,
    shouldSelectOnPressUp: !!l,
    isVirtualized: i
  }, a, r), { isFocused: d, isFocusVisible: s, focusProps: c } = ye(), { hoverProps: f, isHovered: h } = ve({}), { isFocusVisibleWithinRow: m } = O(o1), p = n.parentKey != null ? a.selectionManager.isSelected(n.parentKey) : !1, b = n.colIndex || n.index, y = a.collection.getItem(n.parentKey), $ = y.props.hasChildItems || a.collection.getItem(y.lastChildKey)?.type !== "cell", v = $ && a.expandedKeys.has(n.parentKey), x = a.selectionManager.isDisabled(n.parentKey), E = le({
    ...e,
    id: void 0,
    defaultClassName: "react-aria-Cell",
    values: {
      isFocused: d,
      isFocusVisible: s,
      isFocusVisibleWithinRow: m,
      isPressed: o,
      isHovered: h,
      isSelected: p,
      id: n.key,
      columnIndex: b,
      hasChildItems: $,
      isExpanded: v,
      isDisabled: x,
      level: y.level + 1,
      isTreeColumn: n.column.key === a.treeColumn
    }
  }), P = J(e, {
    global: !0
  });
  return delete P.id, /* @__PURE__ */ g.createElement(vr, {
    ...z(P, E, u, c, f),
    ref: r,
    "data-focused": d || void 0,
    "data-focus-visible": s || void 0,
    "data-focus-visible-within-row": m || void 0,
    "data-pressed": o || void 0,
    "data-selected": p || void 0,
    "data-column-index": b,
    "data-expanded": v || void 0,
    "data-has-child-items": $ || void 0,
    "data-level": y.level + 1,
    "data-tree-column": n.column.key === a.treeColumn || void 0,
    "data-disabled": x || void 0
  }, /* @__PURE__ */ g.createElement(ge.Provider, {
    value: ha
  }, E.children));
});
function P8(e, t) {
  t = $e(t);
  let { dragAndDropHooks: n, dropState: r } = O(Nt), a = T(null), { dropIndicatorProps: l, isHidden: i, isDropTarget: u } = n.useDropIndicator(e, r, a);
  if (i) return null;
  let o = r && e.target.type === "item" ? (r.collection.getItem(e.target.key)?.level || 0) + 1 : 1;
  return /* @__PURE__ */ g.createElement(B8, {
    ...e,
    dropIndicatorProps: l,
    isDropTarget: u,
    buttonRef: a,
    level: o,
    ref: t
  });
}
let w8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.tr, {
    ...t,
    ref: n
  });
}), S8 = /* @__PURE__ */ te(function(t, n) {
  let { isVirtualized: r } = O(ge);
  return r ? /* @__PURE__ */ g.createElement(Q.div, {
    ...t,
    ref: n
  }) : /* @__PURE__ */ g.createElement(Q.td, {
    ...t,
    ref: n
  });
});
function k8(e, t) {
  let { dropIndicatorProps: n, isDropTarget: r, buttonRef: a, level: l, ...i } = e, u = O(Lt), { visuallyHiddenProps: o } = tn(), d = le({
    ...i,
    defaultClassName: "react-aria-DropIndicator",
    defaultStyle: {
      // @ts-ignore
      "--table-row-level": l + 1
    },
    values: {
      isDropTarget: r
    }
  });
  return /* @__PURE__ */ g.createElement(w8, {
    ...J(e, {
      global: !0
    }),
    ...d,
    role: "row",
    ref: t,
    "data-drop-target": r || void 0,
    "aria-level": l
  }, /* @__PURE__ */ g.createElement(S8, {
    role: "gridcell",
    colSpan: u.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ g.createElement("div", {
    ...o,
    role: "button",
    ...n,
    ref: a
  }), d.children));
}
const B8 = /* @__PURE__ */ te(k8);
function F8() {
  let e = O(Lt), { dragAndDropHooks: t, dropState: n } = O(Nt), r = T(null), { dropIndicatorProps: a } = t.useDropIndicator({
    target: {
      type: "root"
    }
  }, n, r), l = n.isDropTarget({
    type: "root"
  }), { visuallyHiddenProps: i } = tn();
  return !l && a["aria-hidden"] ? null : /* @__PURE__ */ g.createElement($r, {
    role: "row",
    "aria-hidden": a["aria-hidden"],
    style: {
      height: 0
    }
  }, /* @__PURE__ */ g.createElement(vr, {
    role: "gridcell",
    colSpan: e.collection.columnCount,
    style: {
      padding: 0
    }
  }, /* @__PURE__ */ g.createElement("div", {
    role: "button",
    ...i,
    ...a,
    ref: r
  })));
}
Ct(Ya, function(t, n, r) {
  let a = O(Lt), { isVirtualized: l } = O(ge), { isLoading: i, onLoadMore: u, scrollOffset: o, ...d } = t, s = a.collection.columns.length, c = T(null), f = K(() => ({
    onLoadMore: u,
    collection: a?.collection,
    sentinelRef: c,
    scrollOffset: o
  }), [
    u,
    o,
    a?.collection
  ]);
  Hp(f, c);
  let h = le({
    ...d,
    id: void 0,
    children: r.rendered,
    defaultClassName: "react-aria-TableLoadingIndicator",
    defaultStyle: {
      // @ts-ignore
      "--table-row-level": r.level + 1
    },
    values: void 0
  }), m = {}, p = {}, b = {};
  return l ? (p["aria-colspan"] = s, b = {
    display: "contents"
  }) : p.colSpan = s, /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement($r, {
    style: {
      height: 0
    },
    inert: sl(!0)
  }, /* @__PURE__ */ g.createElement(vr, {
    style: {
      padding: 0,
      border: 0
    }
  }, /* @__PURE__ */ g.createElement("div", {
    "data-testid": "loadMoreSentinel",
    ref: c,
    style: {
      position: "relative",
      height: 1,
      width: 1
    }
  }))), i && h.children && /* @__PURE__ */ g.createElement($r, {
    ...z(J(t, {
      global: !0
    }), m),
    ...h,
    role: "row",
    ref: n,
    "aria-level": r.level + 1,
    "data-level": r.level + 1
  }, /* @__PURE__ */ g.createElement(vr, {
    role: "rowheader",
    ...p,
    style: b
  }, h.children)));
});
class pt {
  constructor(t = 0, n = 0) {
    this.x = t, this.y = n;
  }
  /**
  * Returns a copy of this point.
  */
  copy() {
    return new pt(this.x, this.y);
  }
  /**
  * Checks if two points are equal.
  */
  equals(t) {
    return this.x === t.x && this.y === t.y;
  }
  /**
  * Returns true if this point is the origin.
  */
  isOrigin() {
    return this.x === 0 && this.y === 0;
  }
}
class be {
  constructor(t = 0, n = 0, r = 0, a = 0) {
    this.x = t, this.y = n, this.width = r, this.height = a;
  }
  /**
  * The maximum x-coordinate in the rectangle.
  */
  get maxX() {
    return this.x + this.width;
  }
  /**
  * The maximum y-coordinate in the rectangle.
  */
  get maxY() {
    return this.y + this.height;
  }
  /**
  * The area of the rectangle.
  */
  get area() {
    return this.width * this.height;
  }
  /**
  * The top left corner of the rectangle.
  */
  get topLeft() {
    return new pt(this.x, this.y);
  }
  /**
  * The top right corner of the rectangle.
  */
  get topRight() {
    return new pt(this.maxX, this.y);
  }
  /**
  * The bottom left corner of the rectangle.
  */
  get bottomLeft() {
    return new pt(this.x, this.maxY);
  }
  /**
  * The bottom right corner of the rectangle.
  */
  get bottomRight() {
    return new pt(this.maxX, this.maxY);
  }
  /**
  * Returns whether this rectangle intersects another rectangle.
  *
  * @param rect - The rectangle to check.
  */
  intersects(t) {
    return (process.env.NODE_ENV === "test" && !process.env.VIRT_ON || this.area > 0 && t.area > 0) && this.x <= t.x + t.width && t.x <= this.x + this.width && this.y <= t.y + t.height && t.y <= this.y + this.height;
  }
  /**
  * Returns whether this rectangle fully contains another rectangle.
  *
  * @param rect - The rectangle to check.
  */
  containsRect(t) {
    return this.x <= t.x && this.y <= t.y && this.maxX >= t.maxX && this.maxY >= t.maxY;
  }
  /**
  * Returns whether the rectangle contains the given point.
  *
  * @param point - The point to check.
  */
  containsPoint(t) {
    return this.x <= t.x && this.y <= t.y && this.maxX >= t.x && this.maxY >= t.y;
  }
  /**
  * Returns the first corner of this rectangle (from top to bottom, left to right)
  * that is contained in the given rectangle, or null of the rectangles do not intersect.
  *
  * @param rect - The rectangle to check.
  */
  getCornerInRect(t) {
    for (let n of [
      "topLeft",
      "topRight",
      "bottomLeft",
      "bottomRight"
    ])
      if (t.containsPoint(this[n])) return n;
    return null;
  }
  equals(t) {
    return t.x === this.x && t.y === this.y && t.width === this.width && t.height === this.height;
  }
  pointEquals(t) {
    return this.x === t.x && this.y === t.y;
  }
  sizeEquals(t) {
    return this.width === t.width && this.height === t.height;
  }
  /**
  * Returns the union of this Rect and another.
  */
  union(t) {
    let n = Math.min(this.x, t.x), r = Math.min(this.y, t.y), a = Math.max(this.maxX, t.maxX) - n, l = Math.max(this.maxY, t.maxY) - r;
    return new be(n, r, a, l);
  }
  /**
  * Returns the intersection of this Rect with another.
  * If the rectangles do not intersect, an all zero Rect is returned.
  */
  intersection(t) {
    if (!this.intersects(t)) return new be(0, 0, 0, 0);
    let n = Math.max(this.x, t.x), r = Math.max(this.y, t.y);
    return new be(n, r, Math.min(this.maxX, t.maxX) - n, Math.min(this.maxY, t.maxY) - r);
  }
  /**
  * Returns a copy of this rectangle.
  */
  copy() {
    return new be(this.x, this.y, this.width, this.height);
  }
}
class Ue {
  constructor(t = 0, n = 0) {
    this.width = Math.max(t, 0), this.height = Math.max(n, 0);
  }
  /**
  * Returns a copy of this size.
  */
  copy() {
    return new Ue(this.width, this.height);
  }
  /**
  * Returns whether this size is equal to another one.
  */
  equals(t) {
    return this.width === t.width && this.height === t.height;
  }
  /**
  * The total area of the Size.
  */
  get area() {
    return this.width * this.height;
  }
}
let A8 = 0;
class s1 {
  constructor(t, n) {
    this.virtualizer = t, this.key = ++A8, this.viewType = n, this.children = /* @__PURE__ */ new Set(), this.reusableViews = /* @__PURE__ */ new Map(), this.layoutInfo = null, this.content = null, this.rendered = null;
  }
  /**
  * Prepares the view for reuse. Called just before the view is removed from the DOM.
  */
  prepareForReuse() {
    this.content = null, this.rendered = null, this.layoutInfo = null;
  }
  getReusableView(t) {
    let n = this.reusableViews.get(t);
    return n && n.length > 0 ? n.shift() : new T8(this.virtualizer, this, t);
  }
  reuseChild(t) {
    t.prepareForReuse();
    let n = this.reusableViews.get(t.viewType);
    n || (n = [], this.reusableViews.set(t.viewType, n)), n.push(t);
  }
}
class R8 extends s1 {
  constructor(t) {
    super(t, "root");
  }
}
class T8 extends s1 {
  constructor(t, n, r) {
    super(t, r), this.parent = n;
  }
}
function I8(e, t) {
  if (e === t) return !0;
  if (e.size !== t.size) return !1;
  for (let n of e)
    if (!t.has(n)) return !1;
  return !0;
}
class M8 {
  setVisibleRect(t) {
    let n = performance.now() - this.startTime;
    n < 500 && (t.x !== this.visibleRect.x && n > 0 && (this.velocity.x = (t.x - this.visibleRect.x) / n), t.y !== this.visibleRect.y && n > 0 && (this.velocity.y = (t.y - this.visibleRect.y) / n)), this.startTime = performance.now(), this.visibleRect = t;
  }
  getOverscannedRect() {
    let t = this.visibleRect.copy(), n = this.visibleRect.height / 3;
    t.height += n, this.velocity.y < 0 && (t.y -= n);
    let r = this.visibleRect.width / 3;
    return t.width += r, this.velocity.x < 0 && (t.x -= r), t;
  }
  constructor() {
    this.startTime = 0, this.velocity = new pt(0, 0), this.visibleRect = new be();
  }
}
class K8 {
  constructor(t) {
    this.delegate = t.delegate, this.collection = t.collection, this.layout = t.layout, this.contentSize = new Ue(), this.visibleRect = new be(), this.size = new Ue(), this.persistedKeys = /* @__PURE__ */ new Set(), this._visibleViews = /* @__PURE__ */ new Map(), this._renderedContent = /* @__PURE__ */ new WeakMap(), this._rootView = new R8(this), this._isScrolling = !1, this._invalidationContext = {}, this._overscanManager = new M8();
  }
  /** Returns whether the given key, or an ancestor, is persisted. */
  isPersistedKey(t) {
    if (this.persistedKeys.has(t)) return !0;
    for (let n of this.persistedKeys) for (; n != null; ) {
      let r = this.layout.getLayoutInfo(n);
      if (!r || r.parentKey == null) break;
      if (n = r.parentKey, n === t) return !0;
    }
    return !1;
  }
  getParentView(t) {
    return t.parentKey != null ? this._visibleViews.get(t.parentKey) : this._rootView;
  }
  getReusableView(t) {
    let r = this.getParentView(t).getReusableView(t.type);
    return r.layoutInfo = t, this._renderView(r), r;
  }
  _renderView(t) {
    if (t.layoutInfo) {
      let { type: n, key: r, content: a } = t.layoutInfo;
      t.content = a || this.collection.getItem(r), t.rendered = this._renderContent(n, t.content);
    }
  }
  _renderContent(t, n) {
    let r = n != null ? this._renderedContent.get(n) : null;
    if (r != null) return r;
    let a = this.delegate.renderView(t, n);
    return n && this._renderedContent.set(n, a), a;
  }
  /**
  * Returns the key for the item view currently at the given point.
  */
  keyAtPoint(t) {
    let n = new be(t.x, t.y, 1, 1), r = n.area === 0 ? [] : this.layout.getVisibleLayoutInfos(n);
    for (let a of r)
      if (a.rect.intersects(n)) return a.key;
    return null;
  }
  relayout(t = {}) {
    this.layout.update(t), this.contentSize = this.layout.getContentSize();
    let n = this.visibleRect, r = t.contentChanged ? 0 : n.x, a = t.contentChanged ? 0 : n.y;
    if (r = Math.max(0, Math.min(this.contentSize.width - n.width, r)), a = Math.max(0, Math.min(this.contentSize.height - n.height, a)), r !== n.x || a !== n.y) {
      let l = new be(r, a, n.width, n.height);
      this.delegate.setVisibleRect(l);
    } else this.updateSubviews();
  }
  getVisibleLayoutInfos() {
    let t = process.env.NODE_ENV === "test" && !process.env.VIRT_ON, n = t && typeof HTMLElement < "u" && Object.getOwnPropertyNames(HTMLElement.prototype).includes("clientWidth"), r = t && typeof HTMLElement < "u" && Object.getOwnPropertyNames(HTMLElement.prototype).includes("clientHeight"), a;
    t && !(n && r) ? a = new be(0, 0, this.contentSize.width, this.contentSize.height) : a = this._overscanManager.getOverscannedRect();
    let l = this.layout.getVisibleLayoutInfos(a), i = /* @__PURE__ */ new Map();
    for (let u of l) i.set(u.key, u);
    return i;
  }
  updateSubviews() {
    let t = this.getVisibleLayoutInfos(), n = /* @__PURE__ */ new Set();
    for (let [r, a] of this._visibleViews) {
      let l = t.get(r);
      (!l || a.parent !== this.getParentView(l)) && (this._visibleViews.delete(r), a.parent.reuseChild(a), n.add(a));
    }
    for (let [r, a] of t) {
      let l = this._visibleViews.get(r);
      if (!l)
        l = this.getReusableView(a), l.parent.children.add(l), this._visibleViews.set(r, l), n.delete(l);
      else {
        l.layoutInfo = a;
        let i = this.collection.getItem(a.key);
        l.content !== i && (l.content != null && this._renderedContent.delete(l.content), this._renderView(l));
      }
    }
    for (let r of n)
      r.parent.children.delete(r), r.parent.reusableViews.clear();
    if (!this._isScrolling)
      for (let r of t.keys()) {
        let a = this._visibleViews.get(r);
        a.parent.children.delete(a), a.parent.children.add(a);
      }
  }
  /** Performs layout and updates visible views as needed. */
  render(t) {
    let n = this, r = !1, a = !1, l = !1, i = !1, u = !1, o = !1;
    if (t.collection !== this.collection && (n.collection = t.collection, r = !0), (t.layout !== this.layout || this.layout.virtualizer !== this) && (this.layout && (this.layout.virtualizer = null), t.layout.virtualizer = this, n.layout = t.layout, r = !0), t.persistedKeys && !I8(t.persistedKeys, this.persistedKeys) && (n.persistedKeys = t.persistedKeys, o = !0), !this.visibleRect.equals(t.visibleRect) || !this.size.equals(t.size)) {
      this._overscanManager.setVisibleRect(t.visibleRect);
      let d = new be(this.visibleRect.x, this.visibleRect.y, this.size.width, this.size.height), s = new be(t.visibleRect.x, t.visibleRect.y, t.size.width, t.size.height);
      this.layout.shouldInvalidate(s, d) ? (a = !t.visibleRect.pointEquals(this.visibleRect), l = !this.size.equals(t.size), r = !0) : o = !0, n.visibleRect = t.visibleRect, n.size = t.size;
    }
    return t.invalidationContext !== this._invalidationContext && (t.invalidationContext && (l ||= t.invalidationContext.sizeChanged || !1, a ||= t.invalidationContext.offsetChanged || !1, i ||= t.invalidationContext.itemSizeChanged || !1, u ||= t.invalidationContext.layoutOptions != null && this._invalidationContext.layoutOptions != null && t.invalidationContext.layoutOptions !== this._invalidationContext.layoutOptions && this.layout.shouldInvalidateLayoutOptions(t.invalidationContext.layoutOptions, this._invalidationContext.layoutOptions), r ||= i || l || a || u), this._invalidationContext = t.invalidationContext), t.isScrolling !== this._isScrolling && (this._isScrolling = t.isScrolling, t.isScrolling || (o = !0)), r ? this.relayout({
      offsetChanged: a,
      sizeChanged: l,
      itemSizeChanged: i,
      layoutOptionsChanged: u,
      layoutOptions: this._invalidationContext.layoutOptions
    }) : o && this.updateSubviews(), Array.from(this._rootView.children);
  }
  getVisibleView(t) {
    return this._visibleViews.get(t);
  }
  invalidate(t) {
    this.delegate.invalidate(t);
  }
  updateItemSize(t, n) {
    if (!this.layout.updateItemSize) return;
    this.layout.updateItemSize(t, n) && this.invalidate({
      itemSizeChanged: !0
    });
  }
}
const N8 = typeof document < "u" ? g.useLayoutEffect : () => {
};
function V8(e) {
  let [t, n] = Y(new be(0, 0, 0, 0)), [r, a] = Y(new Ue()), [l, i] = Y(!1), [u, o] = Y({}), d = T(!1), [s] = Y(() => new K8({
    collection: e.collection,
    layout: e.layout,
    delegate: {
      setVisibleRect(y) {
        n(y), d.current = !0;
      },
      // TODO: should changing these invalidate the entire cache?
      renderView: e.renderView,
      invalidate: o
    }
  }));
  N8(() => {
    d.current && (d.current = !1, e.onVisibleRectChange(t));
  });
  let c = K(() => e.layoutOptions != null ? {
    ...u,
    layoutOptions: e.layoutOptions
  } : u, [
    u,
    e.layoutOptions
  ]), f = s.render({
    layout: e.layout,
    collection: e.collection,
    persistedKeys: e.persistedKeys,
    layoutOptions: e.layoutOptions,
    visibleRect: t,
    size: e.allowsWindowScrolling ? r : t,
    invalidationContext: c,
    isScrolling: l
  }), h = s.contentSize, m = X(() => {
    i(!0);
  }, []), p = X(() => {
    i(!1);
  }, []);
  return K(() => ({
    virtualizer: s,
    visibleViews: f,
    setVisibleRect: n,
    size: r,
    setSize: a,
    contentSize: h,
    isScrolling: l,
    startScrolling: m,
    endScrolling: p
  }), [
    s,
    f,
    n,
    r,
    a,
    h,
    l,
    m,
    p
  ]);
}
class L8 {
  /**
  * Returns whether the layout should invalidate in response to
  * visible rectangle changes. By default, it only invalidates
  * when the virtualizer's size changes. Return true always
  * to make the layout invalidate while scrolling (e.g. sticky headers).
  */
  shouldInvalidate(t, n) {
    return t.width !== n.width || t.height !== n.height;
  }
  /**
  * Returns whether the layout should invalidate when the layout options change.
  * By default it invalidates when the object identity changes. Override this
  * method to optimize layout updates based on specific option changes.
  */
  shouldInvalidateLayoutOptions(t, n) {
    return t !== n;
  }
  /**
  * This method allows the layout to perform any pre-computation
  * it needs to in order to prepare LayoutInfos for retrieval.
  * Called by the virtualizer before `getVisibleLayoutInfos`
  * or `getLayoutInfo` are called.
  */
  update(t) {
  }
  /** @private */
  getItemRect(t) {
    return this.getLayoutInfo(t)?.rect ?? null;
  }
  /** @private */
  getVisibleRect() {
    return this.virtualizer.visibleRect;
  }
  constructor() {
    this.virtualizer = null;
  }
}
class An {
  /**
  * @param type The type of element represented by this LayoutInfo. Should match the `type` of the
  *   corresponding collection node.
  * @param key A unique key for this LayoutInfo. Should match the `key` of the corresponding
  *   collection node.
  * @param rect The rectangle describing the size and position of this element.
  */
  constructor(t, n, r) {
    this.type = t, this.key = n, this.parentKey = null, this.content = null, this.rect = r, this.estimatedSize = !1, this.isSticky = !1, this.opacity = 1, this.transform = null, this.zIndex = 0, this.allowOverflow = !1;
  }
  /**
  * Returns a copy of the LayoutInfo.
  */
  copy() {
    let t = new An(this.type, this.key, this.rect.copy());
    return t.estimatedSize = this.estimatedSize, t.opacity = this.opacity, t.transform = this.transform, t.parentKey = this.parentKey, t.content = this.content, t.isSticky = this.isSticky, t.zIndex = this.zIndex, t.allowOverflow = this.allowOverflow, t;
  }
}
const wn = 48;
class W9 extends L8 {
  /**
  * Creates a new ListLayout with options. See the list of properties below for a description
  * of the options that can be provided.
  */
  constructor(t = {}) {
    super(), this.rowSize = t?.rowSize ?? t?.rowHeight ?? null, this.orientation = t.orientation ?? "vertical", this.estimatedRowSize = t?.estimatedRowSize ?? t?.estimatedRowHeight ?? null, this.headingSize = t?.headingSize ?? t?.headingHeight ?? null, this.estimatedHeadingSize = t?.estimatedHeadingSize ?? t?.estimatedHeadingHeight ?? null, this.loaderSize = t?.loaderSize ?? t?.loaderHeight ?? null, this.dropIndicatorThickness = t.dropIndicatorThickness || 2, this.gap = t.gap || 0, this.padding = t.padding || 0, this.layoutNodes = /* @__PURE__ */ new Map(), this.rootNodes = [], this.lastCollection = null, this.invalidateEverything = !1, this.validRect = new be(), this.requestedRect = new be(), this.contentSize = new Ue();
  }
  // Backward compatibility for subclassing.
  get collection() {
    return this.virtualizer.collection;
  }
  /** @deprecated Use `rowSize` instead. */
  get rowHeight() {
    return this.rowSize;
  }
  /** @deprecated Use `estimatedRowSize` instead. */
  get estimatedRowHeight() {
    return this.estimatedRowSize;
  }
  /** @deprecated Use `headingSize` instead. */
  get headingHeight() {
    return this.headingSize;
  }
  /** @deprecated Use `estimatedHeadingSize` instead. */
  get estimatedHeadingHeight() {
    return this.estimatedHeadingSize;
  }
  /** @deprecated Use `loaderSize` instead. */
  get loaderHeight() {
    return this.loaderSize;
  }
  getLayoutInfo(t) {
    return this.ensureLayoutInfo(t), this.layoutNodes.get(t)?.layoutInfo || null;
  }
  getVisibleLayoutInfos(t) {
    let n = this.orientation === "horizontal" ? "x" : "y", r = this.orientation === "horizontal" ? "width" : "height";
    if (t[r] > 1) {
      let i = (this.rowSize ?? this.estimatedRowSize ?? wn) + this.gap;
      t = t.copy();
      let u = Math.floor(t[n] / i) * i, o = t[r] + t[n] - u;
      t[n] = u, t[r] = Math.ceil(o / i) * i;
    }
    this.layoutIfNeeded(t);
    let a = [], l = (i) => {
      for (let u of i) this.isVisible(u, t) && (a.push(u.layoutInfo), u.children && l(u.children));
    };
    return l(this.rootNodes), a;
  }
  layoutIfNeeded(t) {
    if (this.lastCollection) {
      this.requestedRect.containsRect(t) || (this.requestedRect = this.requestedRect.union(t), this.rootNodes = this.buildCollection());
      for (let n of this.virtualizer.persistedKeys)
        if (this.ensureLayoutInfo(n)) return;
    }
  }
  ensureLayoutInfo(t) {
    return !this.layoutNodes.has(t) && this.requestedRect.area < this.contentSize.area && this.lastCollection ? (this.requestedRect = new be(0, 0, 1 / 0, 1 / 0), this.rootNodes = this.buildCollection(), this.requestedRect = new be(0, 0, this.contentSize.width, this.contentSize.height), !0) : !1;
  }
  isVisible(t, n) {
    return t.layoutInfo.rect.intersects(n) || t.layoutInfo.isSticky || t.layoutInfo.type === "header" || t.layoutInfo.type === "loader" || this.virtualizer.isPersistedKey(t.layoutInfo.key);
  }
  shouldInvalidateEverything(t) {
    let n = t.layoutOptions;
    return t.sizeChanged || this.rowSize !== (n?.rowSize ?? n?.rowHeight ?? this.rowSize) || this.orientation !== (n?.orientation ?? this.orientation) || this.headingSize !== (n?.headingSize ?? n?.headingHeight ?? this.headingSize) || this.loaderSize !== (n?.loaderSize ?? n?.loaderHeight ?? this.loaderSize) || this.gap !== (n?.gap ?? this.gap) || this.padding !== (n?.padding ?? this.padding);
  }
  shouldInvalidateLayoutOptions(t, n) {
    return (t?.rowSize ?? t?.rowHeight) !== (n?.rowSize ?? n?.rowHeight) || t.orientation !== n.orientation || (t?.estimatedRowSize ?? t?.estimatedRowHeight) !== (n?.estimatedRowSize ?? n?.estimatedRowHeight) || (t?.headingSize ?? t?.headingHeight) !== (n?.headingSize ?? n?.headingHeight) || (t?.estimatedHeadingSize ?? t?.estimatedHeadingHeight) !== (n?.estimatedHeadingSize ?? n?.estimatedHeadingHeight) || (t?.loaderSize ?? t?.loaderHeight) !== (n?.loaderSize ?? n?.loaderHeight) || t.dropIndicatorThickness !== n.dropIndicatorThickness || t.gap !== n.gap || t.padding !== n.padding;
  }
  update(t) {
    let n = this.virtualizer.collection;
    this.invalidateEverything = this.shouldInvalidateEverything(t), this.invalidateEverything && (this.requestedRect = this.virtualizer.visibleRect.copy(), this.layoutNodes.clear());
    let r = t.layoutOptions;
    if (this.rowSize = r?.rowSize ?? r?.rowHeight ?? this.rowSize, this.orientation = r?.orientation ?? this.orientation, this.estimatedRowSize = r?.estimatedRowSize ?? r?.estimatedRowHeight ?? this.estimatedRowSize, this.headingSize = r?.headingSize ?? r?.headingHeight ?? this.headingSize, this.estimatedHeadingSize = r?.estimatedHeadingSize ?? r?.estimatedHeadingHeight ?? this.estimatedHeadingSize, this.loaderSize = r?.loaderSize ?? r?.loaderHeight ?? this.loaderSize, this.dropIndicatorThickness = r?.dropIndicatorThickness ?? this.dropIndicatorThickness, this.gap = r?.gap ?? this.gap, this.padding = r?.padding ?? this.padding, this.rootNodes = this.buildCollection(), this.lastCollection && n !== this.lastCollection)
      for (let a of this.lastCollection.getKeys()) n.getItem(a) || this.layoutNodes.get(a) && this.layoutNodes.delete(a);
    this.lastCollection = n, this.invalidateEverything = !1, this.validRect = this.requestedRect.copy();
  }
  buildCollection(t = this.padding) {
    let n = this.virtualizer.collection, r = this.orientation === "horizontal" ? "x" : "y", a = this.orientation === "horizontal" ? "maxX" : "maxY", l = z8(n, (d) => d.type !== "content"), i = l.filter((d) => d.type === "loader"), u = [], o = n?.size === 0;
    o && (t = 0);
    for (let d of l) {
      let s = (this.rowSize ?? this.estimatedRowSize ?? wn) + this.gap;
      if (d.type === "item" && t + s < this.requestedRect[r] && !this.isValid(d, t)) {
        t += s;
        continue;
      }
      let c = this.orientation === "horizontal" ? this.buildChild(d, t, this.padding, null) : this.buildChild(d, this.padding, t, null);
      if (t = c.layoutInfo.rect[a] + this.gap, u.push(c), d.type === "loader") {
        let f = i.indexOf(d);
        i.splice(f, 1);
      }
      if ((d.type === "item" || d.type === "loader") && t > this.requestedRect[a]) {
        let f = l.indexOf(d);
        for (let h of i) {
          let m = l.indexOf(h);
          t += (m - f - 1) * s;
          let p = this.orientation === "horizontal" ? this.buildChild(h, t, this.padding, null) : this.buildChild(h, this.padding, t, null);
          u.push(p), t = p.layoutInfo.rect[a], f = m;
        }
        t += (l.length - f - 1) * s;
        break;
      }
    }
    return t = Math.max(t - this.gap, 0), t += o ? 0 : this.padding, this.contentSize = this.orientation === "horizontal" ? new Ue(t, this.virtualizer.size.height) : new Ue(this.virtualizer.size.width, t), u;
  }
  isValid(t, n) {
    let r = this.layoutNodes.get(t.key), a = this.orientation === "horizontal" ? "x" : "y";
    return !this.invalidateEverything && !!r && r.node === t && n === r.layoutInfo.rect[a] && r.layoutInfo.rect.intersects(this.validRect) && r.validRect.containsRect(r.layoutInfo.rect.intersection(this.requestedRect));
  }
  buildChild(t, n, r, a) {
    if (this.isValid(t, this.orientation === "horizontal" ? n : r)) return this.layoutNodes.get(t.key);
    let l = this.buildNode(t, n, r);
    return l.layoutInfo.parentKey = a ?? null, l.layoutInfo.allowOverflow = !0, this.layoutNodes.set(t.key, l), l;
  }
  buildNode(t, n, r) {
    switch (t.type) {
      case "section":
        return this.buildSection(t, n, r);
      case "item":
        return this.buildItem(t, n, r);
      case "header":
        return this.buildSectionHeader(t, n, r);
      case "loader":
        return this.buildLoader(t, n, r);
      case "separator":
        return this.buildItem(t, n, r);
      default:
        throw new Error("Unsupported node type: " + t.type);
    }
  }
  buildLoader(t, n, r) {
    let a = new be(n, r, this.padding, 0), l = new An(t.type, t.key, a);
    return this.orientation === "horizontal" ? (a.height = this.virtualizer.contentSize.height - this.padding - r, a.width = t.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? wn : 0) : (a.width = this.virtualizer.contentSize.width - this.padding - n, a.height = t.props.isLoading ? this.loaderSize ?? this.rowSize ?? this.estimatedRowSize ?? wn : 0), {
      layoutInfo: l,
      validRect: a.intersection(this.requestedRect)
    };
  }
  buildSection(t, n, r) {
    let a = this.virtualizer.collection, l = this.virtualizer.size.width - this.padding - n, i = this.virtualizer.size.height - this.padding - r, u = this.orientation === "horizontal" ? new be(n, r, 0, i) : new be(n, r, l, 0), o = new An(t.type, t.key, u), d = this.orientation === "horizontal" ? n : r, s = this.orientation === "horizontal" ? "x" : "y", c = this.orientation === "horizontal" ? "maxX" : "maxY", f = this.orientation === "horizontal" ? "width" : "height", h = 0, m = [];
    for (let p of Me(t, a)) {
      if (p.type === "content") continue;
      let b = (this.rowSize ?? this.estimatedRowSize ?? wn) + this.gap;
      if (d + b < this.requestedRect[s] && !this.isValid(t, d)) {
        d += b, h++;
        continue;
      }
      let y = this.orientation === "horizontal" ? this.buildChild(p, d, r, o.key) : this.buildChild(p, n, d, o.key);
      if (d = y.layoutInfo.rect[c] + this.gap, m.push(y), d > this.requestedRect[c]) {
        d += ([
          ...Me(t, a)
        ].length - (m.length + h)) * b;
        break;
      }
    }
    return d -= this.gap, u[f] = d - (this.orientation === "horizontal" ? n : r), {
      layoutInfo: o,
      children: m,
      validRect: o.rect.intersection(this.requestedRect),
      node: t
    };
  }
  buildSectionHeader(t, n, r) {
    let a = this.orientation === "horizontal" ? "height" : "width", l = this.orientation === "horizontal" ? "width" : "height", i = this.virtualizer.size[a] - this.padding - (this.orientation === "horizontal" ? r : n), u = this.headingSize, o = !1;
    if (u == null) {
      let c = this.layoutNodes.get(t.key), f = c?.layoutInfo;
      if (f) {
        let h = this.virtualizer.collection.getItem(t.key), m = this.lastCollection ? this.lastCollection.getItem(t.key) : null;
        u = c.layoutInfo.rect[l], o = i !== f.rect[a] || h !== m || f.estimatedSize;
      } else
        u = t.rendered ? this.estimatedHeadingSize : 0, o = !0;
    }
    u == null && (u = wn);
    let d = this.orientation === "horizontal" ? new be(n, r, u, i - r) : new be(n, r, i - n, u), s = new An("header", t.key, d);
    return s.estimatedSize = o, {
      layoutInfo: s,
      children: [],
      validRect: s.rect.intersection(this.requestedRect),
      node: t
    };
  }
  buildItem(t, n, r) {
    let a = this.orientation === "horizontal" ? "height" : "width", l = this.orientation === "horizontal" ? "width" : "height", i = this.virtualizer.size[a] - this.padding - (this.orientation === "horizontal" ? r : n), u = this.rowSize, o = !1;
    if (u == null) {
      let c = this.layoutNodes.get(t.key);
      c ? (u = c.layoutInfo.rect[l], o = i !== c.layoutInfo.rect[a] || t !== c.node || c.layoutInfo.estimatedSize) : (u = this.estimatedRowSize, o = !0);
    }
    u == null && (u = wn);
    let d = this.orientation === "horizontal" ? new be(n, r, u, i) : new be(n, r, i, u), s = new An(t.type, t.key, d);
    return s.estimatedSize = o, {
      layoutInfo: s,
      children: [],
      validRect: s.rect.intersection(this.requestedRect),
      node: t
    };
  }
  updateItemSize(t, n) {
    let r = this.layoutNodes.get(t);
    if (!r) return !1;
    let a = this.virtualizer.collection, l = r.layoutInfo, i = this.orientation === "horizontal" ? "x" : "y", u = this.orientation === "horizontal" ? "width" : "height";
    if (l.estimatedSize = !1, l.rect[u] !== n[u]) {
      let o = l.copy();
      o.rect[u] = n[u], r.layoutInfo = o, this.validRect[u] = Math.min(this.validRect[u], l.rect[i] - this.validRect[i]), r.node?.type === "item" && (this.requestedRect[u] += o.rect[u] - l.rect[u]), this.updateLayoutNode(t, l, o);
      let d = l.parentKey != null ? a.getItem(l.parentKey) : null;
      for (; d; )
        this.updateLayoutNode(d.key, l, o), d = d.parentKey != null ? a.getItem(d.parentKey) : null;
      return !0;
    }
    return !1;
  }
  updateLayoutNode(t, n, r) {
    let a = this.layoutNodes.get(t);
    a && (a.validRect = a.validRect.intersection(this.validRect), a.layoutInfo === n && (a.layoutInfo = r));
  }
  getContentSize() {
    return this.contentSize;
  }
  getDropTargetFromPoint(t, n, r) {
    t += this.virtualizer.visibleRect.x, n += this.virtualizer.visibleRect.y;
    let a = new be(t, Math.max(0, n - this.gap), 1, Math.max(1, this.gap * 2)), l = this.getVisibleLayoutInfos(a), i = null, u = 1 / 0;
    for (let c of l) {
      if (!c.rect.intersects(a)) continue;
      let f = Math.abs(c.rect.y - n), h = Math.abs(c.rect.maxY - n), m = Math.min(f, h);
      m < u && (u = m, i = c.key);
    }
    if (i == null || this.virtualizer.collection.size === 0) return {
      type: "root"
    };
    let o = this.getLayoutInfo(i);
    if (!o) return null;
    let d = o.rect, s = {
      type: "item",
      key: o.key,
      dropPosition: "on"
    };
    return r(s) ? n <= d.y + 10 && r({
      ...s,
      dropPosition: "before"
    }) ? s.dropPosition = "before" : n >= d.maxY - 10 && r({
      ...s,
      dropPosition: "after"
    }) && (s.dropPosition = "after") : n <= d.y + d.height / 2 && r({
      ...s,
      dropPosition: "before"
    }) ? s.dropPosition = "before" : r({
      ...s,
      dropPosition: "after"
    }) && (s.dropPosition = "after"), s;
  }
  getDropTargetLayoutInfo(t) {
    let n = this.getLayoutInfo(t.key), r;
    if (t.dropPosition === "before") r = this.orientation === "horizontal" ? new be(Math.max(0, n.rect.x - this.dropIndicatorThickness / 2), n.rect.y, this.dropIndicatorThickness, n.rect.height) : new be(n.rect.x, Math.max(0, n.rect.y - this.dropIndicatorThickness / 2), n.rect.width, this.dropIndicatorThickness);
    else if (t.dropPosition === "after") {
      let a = this.collection.getItem(t.key);
      if (a) {
        let l = a.level ?? 0, i = this.collection.getKeyAfter(t.key);
        for (; i != null; ) {
          let u = this.collection.getItem(i);
          if (!u || u.level <= l) break;
          n = this.getLayoutInfo(i) || n, i = this.collection.getKeyAfter(i);
        }
      }
      r = this.orientation === "horizontal" ? new be(n.rect.maxX - this.dropIndicatorThickness / 2, n.rect.y, this.dropIndicatorThickness, n.rect.height) : new be(n.rect.x, n.rect.maxY - this.dropIndicatorThickness / 2, n.rect.width, this.dropIndicatorThickness);
    } else r = n.rect;
    return new An("dropIndicator", t.key + ":" + t.dropPosition, r);
  }
}
function z8(e, t) {
  const n = [];
  for (const r of e) t(r) && n.push(r);
  return n;
}
const d1 = /* @__PURE__ */ new WeakMap();
function ml(e, t, n) {
  if (!e)
    return "";
  typeof t == "string" && (t = t.replace(/\s+/g, ""));
  let r = d1.get(e);
  return process.env.NODE_ENV !== "production" && !r && console.error("There is no tab id, please check if you have rendered the tab panel before the tab list."), `${r}-${n}-${t}`;
}
function O8(e, t, n) {
  let { key: r, isDisabled: a, shouldSelectOnPressUp: l } = e, { selectionManager: i, selectedKey: u } = t, o = r === u, d = a || t.isDisabled || t.selectionManager.isDisabled(r), s = t.collection.getItem(r), { itemProps: c, isPressed: f } = Sr({
    selectionManager: i,
    key: r,
    ref: n,
    isDisabled: d,
    // Link tabs should behave like native anchors (navigate on press up)
    // This avoids reopening beforeunload dialogs when browsers replay
    // queued pointer enter/leave events after cancellation.
    shouldSelectOnPressUp: l ?? s?.props.href != null,
    linkBehavior: "selection"
  }), h = ml(t, r, "tab"), m = ml(t, r, "tabpanel"), { tabIndex: p } = c, b = J(s?.props, {
    labelable: !0
  });
  delete b.id;
  let y = bl(s?.props), { focusableProps: $ } = dt({
    ...s?.props,
    isDisabled: d
  }, n);
  return {
    tabProps: z(b, $, y, c, {
      id: h,
      "aria-selected": o,
      "aria-disabled": d || void 0,
      "aria-controls": o ? m : void 0,
      tabIndex: d ? void 0 : p,
      role: "tab"
    }),
    isSelected: o,
    isDisabled: d,
    isPressed: f
  };
}
function H8(e, t, n) {
  let r = fo(n) ? void 0 : 0;
  const a = ml(t, e.id ?? t?.selectedKey, "tabpanel"), l = it({
    ...e,
    id: a,
    "aria-labelledby": ml(t, t?.selectedKey, "tab")
  });
  return {
    tabPanelProps: z(l, {
      tabIndex: r,
      role: "tabpanel",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"]
    })
  };
}
class U8 {
  constructor(t, n, r, a = /* @__PURE__ */ new Set()) {
    this.collection = t, this.flipDirection = n === "rtl" && r === "horizontal", this.disabledKeys = a, this.tabDirection = r === "horizontal";
  }
  getKeyLeftOf(t) {
    return this.flipDirection ? this.getNextKey(t) : this.getPreviousKey(t);
  }
  getKeyRightOf(t) {
    return this.flipDirection ? this.getPreviousKey(t) : this.getNextKey(t);
  }
  isDisabled(t) {
    return this.disabledKeys.has(t) || !!this.collection.getItem(t)?.props?.isDisabled;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return t != null && this.isDisabled(t) && (t = this.getNextKey(t)), t;
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return t != null && this.isDisabled(t) && (t = this.getPreviousKey(t)), t;
  }
  getKeyAbove(t) {
    return this.tabDirection ? null : this.getPreviousKey(t);
  }
  getKeyBelow(t) {
    return this.tabDirection ? null : this.getNextKey(t);
  }
  getNextKey(t) {
    let n = t;
    do
      n = this.collection.getKeyAfter(n), n == null && (n = this.collection.getFirstKey());
    while (n != null && this.isDisabled(n) && n !== t);
    return n;
  }
  getPreviousKey(t) {
    let n = t;
    do
      n = this.collection.getKeyBefore(n), n == null && (n = this.collection.getLastKey());
    while (n != null && this.isDisabled(n) && n !== t);
    return n;
  }
}
function j8(e, t, n) {
  let { orientation: r = "horizontal", keyboardActivation: a = "automatic" } = e, { collection: l, selectionManager: i, disabledKeys: u } = t, { direction: o } = de(), d = K(() => new U8(l, o, r, u), [
    l,
    u,
    r,
    o
  ]), { collectionProps: s } = to({
    ref: n,
    selectionManager: i,
    keyboardDelegate: d,
    selectOnFocus: a === "automatic",
    disallowEmptySelection: !0,
    scrollRef: n,
    linkBehavior: "selection"
  }), c = ce();
  d1.set(t, c);
  let f = it({
    ...e,
    id: c
  });
  return {
    tabListProps: {
      ...z(s, f),
      role: "tablist",
      "aria-orientation": r,
      tabIndex: void 0
    }
  };
}
function _8(e) {
  let [t, n] = Pe(e.selectedKey, e.defaultSelectedKey ?? null, e.onSelectionChange), r = K(() => t != null ? [
    t
  ] : [], [
    t
  ]), { collection: a, disabledKeys: l, selectionManager: i } = Bl({
    ...e,
    selectionMode: "single",
    disallowEmptySelection: !0,
    allowDuplicateSelectionEvents: !0,
    selectedKeys: r,
    onSelectionChange: (o) => {
      if (o === "all") return;
      let d = o.values().next().value ?? null;
      d === t && e.onSelectionChange && e.onSelectionChange(d), n(d);
    }
  }), u = t != null ? a.getItem(t) : null;
  return {
    collection: a,
    disabledKeys: l,
    selectionManager: i,
    selectedKey: t,
    setSelectedKey: n,
    selectedItem: u
  };
}
function W8(e) {
  let t = _8({
    ...e,
    onSelectionChange: e.onSelectionChange ? (i) => {
      i != null && e.onSelectionChange?.(i);
    } : void 0,
    suppressTextValueWarning: !0,
    defaultSelectedKey: e.defaultSelectedKey ?? Rd(e.collection, e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set()) ?? void 0
  }), { selectionManager: n, collection: r, selectedKey: a } = t, l = T(a);
  return ee(() => {
    let i = a;
    e.selectedKey == null && (n.isEmpty || i == null || !r.getItem(i)) && (i = Rd(r, t.disabledKeys), i != null && n.setSelectedKeys([
      i
    ])), (i != null && n.focusedKey == null || !n.isFocused && i !== l.current) && n.setFocusedKey(i), l.current = i;
  }), {
    ...t,
    isDisabled: e.isDisabled || !1
  };
}
function Rd(e, t) {
  let n = null;
  if (e) {
    for (n = e.getFirstKey(); n != null && (t.has(n) || e.getItem(n)?.props?.isDisabled) && n !== e.getLastKey(); ) n = e.getKeyAfter(n);
    n != null && (t.has(n) || e.getItem(n)?.props?.isDisabled) && n === e.getLastKey() && (n = e.getFirstKey());
  }
  return n;
}
const Ml = /* @__PURE__ */ G(null), yn = /* @__PURE__ */ G(null), G9 = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, Ml);
  let { children: r, orientation: a = "horizontal" } = t;
  return r = K(() => typeof r == "function" ? r({
    orientation: a,
    defaultChildren: null
  }) : r, [
    r,
    a
  ]), /* @__PURE__ */ g.createElement(Hn, {
    content: r
  }, (l) => /* @__PURE__ */ g.createElement(G8, {
    props: t,
    collection: l,
    tabsRef: n
  }));
});
function G8({ props: e, tabsRef: t, collection: n }) {
  let { orientation: r = "horizontal" } = e, a = W8({
    ...e,
    collection: n,
    children: void 0
  }), { focusProps: l, isFocused: i, isFocusVisible: u } = ye({
    within: !0
  }), o = K(() => ({
    orientation: r,
    isFocusWithin: i,
    isFocusVisible: u
  }), [
    r,
    i,
    u
  ]), d = le({
    ...e,
    defaultClassName: "react-aria-Tabs",
    values: o
  }), s = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(s, d, l),
    ref: t,
    slot: e.slot || void 0,
    "data-focused": i || void 0,
    "data-orientation": r,
    "data-focus-visible": u || void 0,
    "data-disabled": a.isDisabled || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Ml,
        e
      ],
      [
        yn,
        a
      ]
    ]
  }, d.children));
}
const q9 = /* @__PURE__ */ te(function(t, n) {
  return O(yn) ? /* @__PURE__ */ g.createElement(q8, {
    props: t,
    forwardedRef: n
  }) : /* @__PURE__ */ g.createElement(Jt, t);
});
function q8({ props: e, forwardedRef: t }) {
  let n = O(yn), { CollectionRoot: r } = O(ge), { orientation: a = "horizontal", keyboardActivation: l = "automatic" } = Oe(Ml), i = $e(t), { tabListProps: u } = j8({
    ...e,
    orientation: a,
    keyboardActivation: l
  }, n, i), o = le({
    ...e,
    children: null,
    defaultClassName: "react-aria-TabList",
    values: {
      orientation: a,
      state: n
    }
  }), d = J(e, {
    global: !0
  });
  return delete d.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(d, o, u),
    ref: i,
    "data-orientation": a || void 0
  }, /* @__PURE__ */ g.createElement(jn, null, /* @__PURE__ */ g.createElement(r, {
    collection: n.collection,
    persistedKeys: Eu(n.selectionManager.focusedKey)
  })));
}
const No = class No extends st {
};
No.type = "item";
let ou = No;
const Y9 = /* @__PURE__ */ Ct(ou, (e, t, n) => {
  let r = O(yn), a = $e(t), { tabProps: l, isSelected: i, isDisabled: u, isPressed: o } = O8({
    key: n.key,
    ...e
  }, r, a), { focusProps: d, isFocused: s, isFocusVisible: c } = ye(), { hoverProps: f, isHovered: h } = ve({
    isDisabled: u,
    onHoverStart: e.onHoverStart,
    onHoverEnd: e.onHoverEnd,
    onHoverChange: e.onHoverChange
  }), m = le({
    ...e,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tab",
    values: {
      isSelected: i,
      isDisabled: u,
      isFocused: s,
      isFocusVisible: c,
      isPressed: o,
      isHovered: h
    }
  }), p = n.props.href ? Q.a : Q.div, b = J(e, {
    global: !0
  });
  return delete b.id, delete b.onClick, /* @__PURE__ */ g.createElement(p, {
    ...z(b, m, l, d, f),
    ref: a,
    "data-selected": i || void 0,
    "data-disabled": u || void 0,
    "data-focused": s || void 0,
    "data-focus-visible": c || void 0,
    "data-pressed": o || void 0,
    "data-hovered": h || void 0
  }, /* @__PURE__ */ g.createElement(_n.Provider, {
    value: {
      isSelected: i
    }
  }, m.children));
}), Z9 = /* @__PURE__ */ $n(function(t, n) {
  let r = O(yn), a = $e(n), l = T(r.selectedKey), i = T(null), u = T(null);
  ue(() => {
    let d = a.current;
    if (d) {
      if (u.current == null && (u.current = /width|height|block-size|inline-size|all/.test(window.getComputedStyle(d).transition)), u.current && l.current != null && l.current !== r.selectedKey) {
        d.style.setProperty("--tab-panel-width", "auto"), d.style.setProperty("--tab-panel-height", "auto");
        let { width: s, height: c } = d.getBoundingClientRect();
        i.current && (i.current.width !== s || i.current.height !== c) && (d.style.setProperty("--tab-panel-width", i.current.width + "px"), d.style.setProperty("--tab-panel-height", i.current.height + "px"), window.getComputedStyle(d).height, d.style.setProperty("--tab-panel-width", s + "px"), d.style.setProperty("--tab-panel-height", c + "px"), Promise.all(d.getAnimations().map((f) => f.finished)).then(() => {
          d.style.setProperty("--tab-panel-width", "auto"), d.style.setProperty("--tab-panel-height", "auto");
        }).catch(() => {
        }));
      }
      l.current = r.selectedKey;
    }
  }, [
    a,
    r.selectedKey
  ]), r.selectedKey != null && // eslint-disable-next-line rsp-rules/pure-render
  r.selectedKey !== l.current && a.current && // eslint-disable-next-line rsp-rules/pure-render
  u.current && (i.current = a.current.getBoundingClientRect());
  let o = J(t, {
    labelable: !0,
    global: !0
  });
  return delete o.id, /* @__PURE__ */ g.createElement(Q.div, {
    render: t.render,
    ...o,
    ref: a,
    style: t.style,
    className: t.className || "react-aria-TabPanels"
  }, /* @__PURE__ */ g.createElement(Jt, t));
}), X9 = /* @__PURE__ */ $n(function(t, n) {
  const r = O(yn);
  let a = $e(n), l = r.selectedKey === t.id, [i, u] = Y(r.selectedKey != null ? l : null);
  i == null && r.selectedKey != null ? u(l) : !l && i && u(!1);
  let o = sa(a, l);
  return !l && !t.shouldForceMount && !o ? null : /* @__PURE__ */ g.createElement(Y8, {
    ...t,
    tabPanelRef: a,
    isInitiallySelected: i || !1,
    isExiting: o
  });
});
function Y8(e) {
  let t = O(yn), { id: n, tabPanelRef: r, isInitiallySelected: a, isExiting: l, ...i } = e, { tabPanelProps: u } = H8(e, t, r), { focusProps: o, isFocused: d, isFocusVisible: s } = ye(), c = t.selectedKey === e.id, f = va(r) && !a, h = le({
    ...e,
    defaultClassName: "react-aria-TabPanel",
    values: {
      isFocused: d,
      isFocusVisible: s,
      // @ts-ignore - compatibility with React < 19
      isInert: sl(!c),
      isEntering: f,
      isExiting: l,
      state: t
    }
  }), m = J(i, {
    global: !0
  });
  delete m.id;
  let p = c ? z(m, u, o, h) : z(m, h);
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...p,
    ref: r,
    "data-focused": d || void 0,
    "data-focus-visible": s || void 0,
    // @ts-ignore
    inert: sl(!c || e.inert),
    "data-inert": c ? void 0 : "true",
    "data-entering": f || void 0,
    "data-exiting": l || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Ml,
        null
      ],
      [
        yn,
        null
      ]
    ]
  }, /* @__PURE__ */ g.createElement(ge.Provider, {
    value: ha
  }, h.children)));
}
const c1 = /* @__PURE__ */ new WeakMap();
function Z8(e, t, n) {
  let { direction: r } = de(), a = e.keyboardDelegate || new ya({
    collection: t.collection,
    ref: n,
    orientation: "horizontal",
    direction: r,
    disabledKeys: t.disabledKeys,
    disabledBehavior: t.selectionManager.disabledBehavior
  }), { labelProps: l, fieldProps: i, descriptionProps: u, errorMessageProps: o } = Cr({
    ...e,
    labelElementType: "span"
  }), { gridProps: d } = tE({
    ...e,
    ...i,
    keyboardDelegate: a,
    shouldFocusWrap: !0,
    linkBehavior: "override",
    keyboardNavigationBehavior: "tab"
  }, t, n), [s, c] = Y(!1), { focusWithinProps: f } = ct({
    onFocusWithinChange: c
  }), h = J(e), m = T(t.collection.size);
  return ee(() => {
    n.current && m.current > 0 && t.collection.size === 0 && s && n.current.focus(), m.current = t.collection.size;
  }, [
    t.collection.size,
    s,
    n
  ]), c1.set(t, {
    onRemove: e.onRemove
  }), {
    gridProps: z(d, h, {
      role: t.collection.size ? "grid" : "group",
      "aria-atomic": !1,
      "aria-relevant": "additions",
      "aria-live": s ? "polite" : "off",
      ...f,
      ...i
    }),
    labelProps: l,
    descriptionProps: u,
    errorMessageProps: o
  };
}
var f1 = {};
f1 = {
  removeButtonLabel: "إزالة",
  removeDescription: "اضغط على مفتاح DELETE لإزالة علامة."
};
var h1 = {};
h1 = {
  removeButtonLabel: "Премахване",
  removeDescription: "Натиснете Delete, за да премахнете маркера."
};
var m1 = {};
m1 = {
  removeButtonLabel: "Odebrat",
  removeDescription: "Stisknutím klávesy Delete odeberete značku."
};
var p1 = {};
p1 = {
  removeButtonLabel: "Fjern",
  removeDescription: "Tryk på Slet for at fjerne tag."
};
var b1 = {};
b1 = {
  removeButtonLabel: "Entfernen",
  removeDescription: "Auf „Löschen“ drücken, um das Tag zu entfernen."
};
var g1 = {};
g1 = {
  removeButtonLabel: "Κατάργηση",
  removeDescription: "Πατήστε Διαγραφή για να καταργήσετε την ετικέτα."
};
var y1 = {};
y1 = {
  removeDescription: "Press Delete to remove tag.",
  removeButtonLabel: "Remove"
};
var $1 = {};
$1 = {
  removeButtonLabel: "Quitar",
  removeDescription: "Pulse Eliminar para quitar la etiqueta."
};
var v1 = {};
v1 = {
  removeButtonLabel: "Eemalda",
  removeDescription: "Sildi eemaldamiseks vajutage kustutusklahvi Delete."
};
var D1 = {};
D1 = {
  removeButtonLabel: "Poista",
  removeDescription: "Poista tunniste painamalla Poista-painiketta."
};
var x1 = {};
x1 = {
  removeButtonLabel: "Supprimer",
  removeDescription: "Appuyez sur Supprimer pour supprimer l’étiquette."
};
var E1 = {};
E1 = {
  removeButtonLabel: "הסר",
  removeDescription: "לחץ על מחק כדי להסיר תג."
};
var C1 = {};
C1 = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Delete za uklanjanje oznake."
};
var P1 = {};
P1 = {
  removeButtonLabel: "Eltávolítás",
  removeDescription: "Nyomja meg a Delete billentyűt a címke eltávolításához."
};
var w1 = {};
w1 = {
  removeButtonLabel: "Rimuovi",
  removeDescription: "Premi Elimina per rimuovere il tag."
};
var S1 = {};
S1 = {
  removeButtonLabel: "削除",
  removeDescription: "タグを削除するには、Delete キーを押します。"
};
var k1 = {};
k1 = {
  removeButtonLabel: "제거",
  removeDescription: "태그를 제거하려면 Delete 키를 누르십시오."
};
var B1 = {};
B1 = {
  removeButtonLabel: "Pašalinti",
  removeDescription: "Norėdami pašalinti žymą, paspauskite „Delete“ klavišą."
};
var F1 = {};
F1 = {
  removeButtonLabel: "Noņemt",
  removeDescription: "Nospiediet Delete [Dzēst], lai noņemtu tagu."
};
var A1 = {};
A1 = {
  removeButtonLabel: "Fjern",
  removeDescription: "Trykk på Slett for å fjerne taggen."
};
var R1 = {};
R1 = {
  removeButtonLabel: "Verwijderen",
  removeDescription: "Druk op Verwijderen om de tag te verwijderen."
};
var T1 = {};
T1 = {
  removeButtonLabel: "Usuń",
  removeDescription: "Naciśnij Usuń, aby usunąć znacznik."
};
var I1 = {};
I1 = {
  removeButtonLabel: "Remover",
  removeDescription: "Pressione Delete para remover a tag."
};
var M1 = {};
M1 = {
  removeButtonLabel: "Eliminar",
  removeDescription: "Prima Delete para eliminar a tag."
};
var K1 = {};
K1 = {
  removeButtonLabel: "Îndepărtaţi",
  removeDescription: "Apăsați pe Delete (Ștergere) pentru a elimina eticheta."
};
var N1 = {};
N1 = {
  removeButtonLabel: "Удалить",
  removeDescription: "Нажмите DELETE, чтобы удалить тег."
};
var V1 = {};
V1 = {
  removeButtonLabel: "Odstrániť",
  removeDescription: "Ak chcete odstrániť značku, stlačte kláves Delete."
};
var L1 = {};
L1 = {
  removeButtonLabel: "Odstrani",
  removeDescription: "Pritisnite Delete, da odstranite oznako."
};
var z1 = {};
z1 = {
  removeButtonLabel: "Ukloni",
  removeDescription: "Pritisnite Obriši da biste uklonili oznaku."
};
var O1 = {};
O1 = {
  removeButtonLabel: "Ta bort",
  removeDescription: "Tryck på Radera för att ta bort taggen."
};
var H1 = {};
H1 = {
  removeButtonLabel: "Kaldır",
  removeDescription: "Etiketi kaldırmak için Sil tuşuna basın."
};
var U1 = {};
U1 = {
  removeButtonLabel: "Вилучити",
  removeDescription: "Натисніть Delete, щоб вилучити тег."
};
var j1 = {};
j1 = {
  removeButtonLabel: "删除",
  removeDescription: "按下“删除”以删除标记。"
};
var _1 = {};
_1 = {
  removeButtonLabel: "移除",
  removeDescription: "按 Delete 鍵以移除標記。"
};
var W1 = {};
W1 = {
  "ar-AE": f1,
  "bg-BG": h1,
  "cs-CZ": m1,
  "da-DK": p1,
  "de-DE": b1,
  "el-GR": g1,
  "en-US": y1,
  "es-ES": $1,
  "et-EE": v1,
  "fi-FI": D1,
  "fr-FR": x1,
  "he-IL": E1,
  "hr-HR": C1,
  "hu-HU": P1,
  "it-IT": w1,
  "ja-JP": S1,
  "ko-KR": k1,
  "lt-LT": B1,
  "lv-LV": F1,
  "nb-NO": A1,
  "nl-NL": R1,
  "pl-PL": T1,
  "pt-BR": I1,
  "pt-PT": M1,
  "ro-RO": K1,
  "ru-RU": N1,
  "sk-SK": V1,
  "sl-SI": L1,
  "sr-SP": z1,
  "sv-SE": O1,
  "tr-TR": H1,
  "uk-UA": U1,
  "zh-CN": j1,
  "zh-TW": _1
};
function X8(e) {
  return e && e.__esModule ? e.default : e;
}
function J8(e, t, n) {
  let { item: r } = e, a = xe(X8(W1), "@react-aria/tag"), l = ce(), { onRemove: i } = c1.get(t) || {}, { rowProps: u, gridCellProps: o, ...d } = nE({
    node: r
  }, t, n), { descriptionProps: s, ...c } = d, f = t.disabledKeys.has(r.key) || r.props.isDisabled, h = (C) => {
    if (C.key === "Delete" || C.key === "Backspace") {
      if (f) return;
      C.preventDefault(), t.selectionManager.isSelected(r.key) ? i?.(new Set(t.selectionManager.selectedKeys)) : i?.(/* @__PURE__ */ new Set([
        r.key
      ]));
    }
  }, m = yl();
  m === "virtual" && typeof window < "u" && "ontouchstart" in window && (m = "pointer");
  let p = i && (m === "keyboard" || m === "virtual") ? a.format("removeDescription") : "", b = en(p), y = r.key === t.selectionManager.focusedKey, $ = t.selectionManager.focusedKey != null, v = -1;
  !f && (y || !$) && (v = 0);
  let x = J(r.props), E = yu(r.props), { focusableProps: P } = dt({
    ...r.props,
    isDisabled: f
  }, n);
  return {
    removeButtonProps: {
      "aria-label": a.format("removeButtonLabel"),
      "aria-labelledby": `${l} ${u.id}`,
      isDisabled: f,
      id: l,
      onPress: () => i ? i(/* @__PURE__ */ new Set([
        r.key
      ])) : null
    },
    rowProps: z(P, u, x, E, {
      tabIndex: v,
      onKeyDown: i ? h : void 0,
      "aria-describedby": b["aria-describedby"]
    }),
    gridCellProps: z(o, {
      "aria-errormessage": e["aria-errormessage"],
      "aria-label": e["aria-label"]
    }),
    ...c,
    allowsRemoving: !!i
  };
}
const Q8 = /* @__PURE__ */ G(null), G1 = /* @__PURE__ */ G(null), J9 = /* @__PURE__ */ te(function(t, n) {
  return [t, n] = oe(t, n, Q8), /* @__PURE__ */ g.createElement(Pt.Provider, {
    value: null
  }, /* @__PURE__ */ g.createElement(Hn, {
    content: t.children
  }, (r) => /* @__PURE__ */ g.createElement(eC, {
    props: t,
    forwardedRef: n,
    collection: r
  })));
});
function eC({ props: e, forwardedRef: t, collection: n }) {
  let r = T(null), { id: a, ...l } = e;
  [l, r] = oe(l, r, Nn);
  let { filter: i, shouldUseVirtualFocus: u, ...o } = l, [d, s] = Je(!e["aria-label"] && !e["aria-labelledby"]), c = Bl({
    ...o,
    children: void 0,
    collection: n
  }), f = zp(c, i), h = J(l, {
    global: !0
  }), m = Object.fromEntries(Object.entries(h).map(([v, x]) => [
    v,
    v === "id" ? x : void 0
  ])), { gridProps: p, labelProps: b, descriptionProps: y, errorMessageProps: $ } = Z8({
    ...o,
    ...m,
    label: s
  }, f, r);
  return /* @__PURE__ */ g.createElement(Q.div, {
    render: e.render,
    ...h,
    id: a,
    ref: t,
    slot: e.slot || void 0,
    className: e.className ?? "react-aria-TagGroup",
    style: e.style
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Qe,
        {
          ...b,
          elementType: "span",
          ref: d
        }
      ],
      [
        G1,
        {
          ...p,
          ref: r
        }
      ],
      [
        Pt,
        f
      ],
      [
        _e,
        {
          slots: {
            description: y,
            errorMessage: $
          }
        }
      ]
    ]
  }, e.children));
}
const Q9 = /* @__PURE__ */ te(function(t, n) {
  return O(Pt) ? /* @__PURE__ */ g.createElement(tC, {
    props: t,
    forwardedRef: n
  }) : /* @__PURE__ */ g.createElement(Jt, t);
});
function tC({ props: e, forwardedRef: t }) {
  let n = O(Pt), { CollectionRoot: r } = O(ge), [a, l] = oe({}, t, G1), { focusProps: i, isFocused: u, isFocusVisible: o } = ye(), d = {
    isEmpty: n.collection.size === 0,
    isFocused: u,
    isFocusVisible: o,
    state: n
  }, s = le({
    ...e,
    children: void 0,
    defaultClassName: "react-aria-TagList",
    values: d
  }), c = Eu(n.selectionManager.focusedKey), f = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(f, s, a, i),
    ref: l,
    "data-empty": n.collection.size === 0 || void 0,
    "data-focused": u || void 0,
    "data-focus-visible": o || void 0
  }, /* @__PURE__ */ g.createElement(jn, null, n.collection.size === 0 && e.renderEmptyState ? e.renderEmptyState(d) : /* @__PURE__ */ g.createElement(r, {
    collection: n.collection,
    persistedKeys: c
  })));
}
const eP = /* @__PURE__ */ Ct(Yr, (e, t, n) => {
  let r = O(Pt), a = $e(t), { focusProps: l, isFocusVisible: i } = ye({
    within: !1
  }), { rowProps: u, gridCellProps: o, removeButtonProps: d, ...s } = J8({
    item: n
  }, r, a), { hoverProps: c, isHovered: f } = ve({
    isDisabled: !s.allowsSelection && !s.hasAction,
    onHoverStart: n.props.onHoverStart,
    onHoverChange: n.props.onHoverChange,
    onHoverEnd: n.props.onHoverEnd
  }), h = le({
    ...e,
    id: void 0,
    children: n.rendered,
    defaultClassName: "react-aria-Tag",
    values: {
      ...s,
      isFocusVisible: i,
      isHovered: f,
      selectionMode: r.selectionManager.selectionMode,
      selectionBehavior: r.selectionManager.selectionBehavior
    }
  });
  ee(() => {
    !n.textValue && process.env.NODE_ENV !== "production" && console.warn("A `textValue` prop is required for <Tag> elements with non-plain text children for accessibility.");
  }, [
    n.textValue
  ]);
  let m = J(e, {
    global: !0
  });
  return delete m.id, delete m.onClick, /* @__PURE__ */ g.createElement(Q.div, {
    ref: a,
    ...z(m, h, u, l, c),
    "data-selected": s.isSelected || void 0,
    "data-disabled": s.isDisabled || void 0,
    "data-hovered": f || void 0,
    "data-focused": s.isFocused || void 0,
    "data-focus-visible": i || void 0,
    "data-pressed": s.isPressed || void 0,
    "data-allows-removing": s.allowsRemoving || void 0,
    "data-selection-mode": r.selectionManager.selectionMode === "none" ? void 0 : r.selectionManager.selectionMode
  }, /* @__PURE__ */ g.createElement("div", {
    ...o,
    style: {
      display: "contents"
    }
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Ze,
        {
          slots: {
            remove: d
          }
        }
      ],
      [
        ge,
        ha
      ],
      [
        _n,
        {
          isSelected: s.isSelected
        }
      ]
    ]
  }, h.children)));
}), q1 = /* @__PURE__ */ G({});
let nC = (e) => {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, ...a } = e;
  return a;
};
const tP = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, q1);
  let { hoverProps: r, isHovered: a } = ve(t), { isFocused: l, isFocusVisible: i, focusProps: u } = ye({
    isTextInput: !0,
    autoFocus: t.autoFocus
  }), o = !!t["aria-invalid"] && t["aria-invalid"] !== "false", d = le({
    ...t,
    values: {
      isHovered: a,
      isFocused: l,
      isFocusVisible: i,
      isDisabled: t.disabled || !1,
      isInvalid: o
    },
    defaultClassName: "react-aria-TextArea"
  });
  return /* @__PURE__ */ g.createElement(Q.textarea, {
    ...z(nC(t), u, r),
    ...d,
    ref: n,
    "data-focused": l || void 0,
    "data-disabled": t.disabled || void 0,
    "data-hovered": a || void 0,
    "data-focus-visible": i || void 0,
    "data-invalid": o || void 0
  });
}), rC = /* @__PURE__ */ G(null), nP = /* @__PURE__ */ $n(function(t, n) {
  [t, n] = oe(t, n, rC);
  let { validationBehavior: r } = Oe(Un) || {}, a = t.validationBehavior ?? r ?? "native", l = T(null);
  [t, l] = oe(t, l, ca);
  let [i, u] = Je(!t["aria-label"] && !t["aria-labelledby"]), [o, d] = Y("input"), { labelProps: s, inputProps: c, descriptionProps: f, errorMessageProps: h, ...m } = ju({
    ...Et(t),
    inputElementType: o,
    label: u,
    validationBehavior: a
  }, l), p = X(($) => {
    l.current = $, $ && d($ instanceof HTMLTextAreaElement ? "textarea" : "input");
  }, [
    l
  ]), b = le({
    ...t,
    values: {
      isDisabled: t.isDisabled || !1,
      isInvalid: m.isInvalid,
      isReadOnly: t.isReadOnly || !1,
      isRequired: t.isRequired || !1
    },
    defaultClassName: "react-aria-TextField"
  }), y = J(t, {
    global: !0
  });
  return delete y.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...y,
    ...b,
    ref: n,
    slot: t.slot || void 0,
    "data-disabled": t.isDisabled || void 0,
    "data-invalid": m.isInvalid || void 0,
    "data-readonly": t.isReadOnly || void 0,
    "data-required": t.isRequired || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Qe,
        {
          ...s,
          ref: i
        }
      ],
      [
        Pr,
        {
          ...c,
          ref: p
        }
      ],
      [
        q1,
        {
          ...c,
          ref: p
        }
      ],
      [
        vn,
        {
          role: "presentation",
          isInvalid: m.isInvalid,
          isDisabled: t.isDisabled || !1
        }
      ],
      [
        _e,
        {
          slots: {
            description: f,
            errorMessage: h
          }
        }
      ],
      [
        nn,
        m
      ]
    ]
  }, b.children));
});
var Y1 = {};
Y1 = {
  close: "إغلاق",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} إشعار`,
    other: () => `${t.number(e.count)} إشعارات`
  })}.`
};
var Z1 = {};
Z1 = {
  close: "Затвори",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} известие`,
    other: () => `${t.number(e.count)} известия`
  })}.`
};
var X1 = {};
X1 = {
  close: "Zavřít",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} oznámení`,
    other: () => `${t.number(e.count)} oznámení`
  })}.`
};
var J1 = {};
J1 = {
  close: "Luk",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} besked`,
    other: () => `${t.number(e.count)} beskeder`
  })}.`
};
var Q1 = {};
Q1 = {
  close: "Schließen",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} Benachrichtigung`,
    other: () => `${t.number(e.count)} Benachrichtigungen`
  })}.`
};
var ev = {};
ev = {
  close: "Κλείσιμο",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} ειδοποίηση`,
    other: () => `${t.number(e.count)} ειδοποιήσεις`
  })}.`
};
var tv = {};
tv = {
  close: "Close",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notification`,
    other: () => `${t.number(e.count)} notifications`
  })}.`
};
var nv = {};
nv = {
  close: "Cerrar",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notificación`,
    other: () => `${t.number(e.count)} notificaciones`
  })}.`
};
var rv = {};
rv = {
  close: "Sule",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} teatis`,
    other: () => `${t.number(e.count)} teatist`
  })}.`
};
var av = {};
av = {
  close: "Sulje",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} ilmoitus`,
    other: () => `${t.number(e.count)} ilmoitusta`
  })}.`
};
var lv = {};
lv = {
  close: "Fermer",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notification`,
    other: () => `${t.number(e.count)} notifications`
  })}.`
};
var iv = {};
iv = {
  close: "סגור",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} התראה`,
    other: () => `${t.number(e.count)} התראות`
  })}.`
};
var uv = {};
uv = {
  close: "Zatvori",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} obavijest`,
    other: () => `${t.number(e.count)} obavijesti`
  })}.`
};
var ov = {};
ov = {
  close: "Bezárás",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} értesítés`,
    other: () => `${t.number(e.count)} értesítés`
  })}.`
};
var sv = {};
sv = {
  close: "Chiudi",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notifica`,
    other: () => `${t.number(e.count)} notifiche`
  })}.`
};
var dv = {};
dv = {
  close: "閉じる",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} 個の通知`,
    other: () => `${t.number(e.count)} 個の通知`
  })}。`
};
var cv = {};
cv = {
  close: "닫기",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)}개 알림`,
    other: () => `${t.number(e.count)}개 알림`
  })}.`
};
var fv = {};
fv = {
  close: "Uždaryti",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} pranešimas`,
    other: () => `${t.number(e.count)} pranešimai`
  })}.`
};
var hv = {};
hv = {
  close: "Aizvērt",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} paziņojums`,
    other: () => `${t.number(e.count)} paziņojumi`
  })}.`
};
var mv = {};
mv = {
  close: "Lukk",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} varsling`,
    other: () => `${t.number(e.count)} varsler`
  })}.`
};
var pv = {};
pv = {
  close: "Sluiten",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} melding`,
    other: () => `${t.number(e.count)} meldingen`
  })}.`
};
var bv = {};
bv = {
  close: "Zamknij",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} powiadomienie`,
    few: () => `${t.number(e.count)} powiadomienia`,
    many: () => `${t.number(e.count)} powiadomień`,
    other: () => `${t.number(e.count)} powiadomienia`
  })}.`
};
var gv = {};
gv = {
  close: "Fechar",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notificação`,
    other: () => `${t.number(e.count)} notificações`
  })}.`
};
var yv = {};
yv = {
  close: "Fechar",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notificação`,
    other: () => `${t.number(e.count)} notificações`
  })}.`
};
var $v = {};
$v = {
  close: "Închideţi",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} notificare`,
    other: () => `${t.number(e.count)} notificări`
  })}.`
};
var vv = {};
vv = {
  close: "Закрыть",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} уведомление`,
    other: () => `${t.number(e.count)} уведомления`
  })}.`
};
var Dv = {};
Dv = {
  close: "Zatvoriť",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} oznámenie`,
    few: () => `${t.number(e.count)} oznámenia`,
    other: () => `${t.number(e.count)} oznámení`
  })}.`
};
var xv = {};
xv = {
  close: "Zapri",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} obvestilo`,
    two: () => `${t.number(e.count)} obvestili`,
    few: () => `${t.number(e.count)} obvestila`,
    other: () => `${t.number(e.count)} obvestil`
  })}.`
};
var Ev = {};
Ev = {
  close: "Zatvori",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} obaveštenje`,
    other: () => `${t.number(e.count)} obaveštenja`
  })}.`
};
var Cv = {};
Cv = {
  close: "Stäng",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} meddelande`,
    other: () => `${t.number(e.count)} meddelanden`
  })}.`
};
var Pv = {};
Pv = {
  close: "Kapat",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} bildirim`,
    other: () => `${t.number(e.count)} bildirim`
  })}.`
};
var wv = {};
wv = {
  close: "Закрити",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} сповіщення`,
    other: () => `${t.number(e.count)} сповіщення`
  })}.`
};
var Sv = {};
Sv = {
  close: "关闭",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} 个通知`,
    other: () => `${t.number(e.count)} 个通知`
  })}。`
};
var kv = {};
kv = {
  close: "關閉",
  notifications: (e, t) => `${t.plural(e.count, {
    one: () => `${t.number(e.count)} 個通知`,
    other: () => `${t.number(e.count)} 個通知`
  })}。`
};
var Do = {};
Do = {
  "ar-AE": Y1,
  "bg-BG": Z1,
  "cs-CZ": X1,
  "da-DK": J1,
  "de-DE": Q1,
  "el-GR": ev,
  "en-US": tv,
  "es-ES": nv,
  "et-EE": rv,
  "fi-FI": av,
  "fr-FR": lv,
  "he-IL": iv,
  "hr-HR": uv,
  "hu-HU": ov,
  "it-IT": sv,
  "ja-JP": dv,
  "ko-KR": cv,
  "lt-LT": fv,
  "lv-LV": hv,
  "nb-NO": mv,
  "nl-NL": pv,
  "pl-PL": bv,
  "pt-BR": gv,
  "pt-PT": yv,
  "ro-RO": $v,
  "ru-RU": vv,
  "sk-SK": Dv,
  "sl-SI": xv,
  "sr-SP": Ev,
  "sv-SE": Cv,
  "tr-TR": Pv,
  "uk-UA": wv,
  "zh-CN": Sv,
  "zh-TW": kv
};
function aC(e) {
  return e && e.__esModule ? e.default : e;
}
function lC(e, t, n) {
  let { key: r, timer: a, timeout: l } = e.toast;
  ee(() => {
    if (!(a == null || l == null))
      return a.reset(l), () => {
        a.pause();
      };
  }, [
    a,
    l
  ]);
  let i = ce(), u = bt(), o = xe(aC(Do), "@react-aria/toast"), [d, s] = Y(!1);
  return ue(() => {
    s(!0);
  }, []), {
    toastProps: {
      ...J(e, {
        labelable: !0
      }),
      role: "alertdialog",
      "aria-modal": "false",
      "aria-labelledby": e["aria-labelledby"] || i,
      "aria-describedby": e["aria-describedby"] || u,
      tabIndex: 0
    },
    contentProps: {
      role: "alert",
      "aria-atomic": "true",
      "aria-hidden": d ? void 0 : "true"
    },
    titleProps: {
      id: i
    },
    descriptionProps: {
      id: u
    },
    closeButtonProps: {
      "aria-label": o.format("close"),
      onPress: () => t.close(r)
    }
  };
}
const Bv = 1, bi = /* @__PURE__ */ Symbol.for("react-aria-landmark-manager");
function iC(e) {
  return document.addEventListener("react-aria-landmark-manager-change", e), () => document.removeEventListener("react-aria-landmark-manager-change", e);
}
function Td() {
  if (typeof document > "u") return null;
  let e = document[bi];
  return e && e.version >= Bv ? e : (document[bi] = new oC(), document.dispatchEvent(new CustomEvent("react-aria-landmark-manager-change")), document[bi]);
}
function uC() {
  return xu.useSyncExternalStore(iC, Td, Td);
}
class oC {
  constructor() {
    this.landmarks = [], this.isListening = !1, this.refCount = 0, this.version = Bv, this.f6Handler = this.f6Handler.bind(this), this.focusinHandler = this.focusinHandler.bind(this), this.focusoutHandler = this.focusoutHandler.bind(this);
  }
  setupIfNeeded() {
    this.isListening || (document.addEventListener("keydown", this.f6Handler, {
      capture: !0
    }), document.addEventListener("focusin", this.focusinHandler, {
      capture: !0
    }), document.addEventListener("focusout", this.focusoutHandler, {
      capture: !0
    }), this.isListening = !0);
  }
  teardownIfNeeded() {
    !this.isListening || this.landmarks.length > 0 || this.refCount > 0 || (document.removeEventListener("keydown", this.f6Handler, {
      capture: !0
    }), document.removeEventListener("focusin", this.focusinHandler, {
      capture: !0
    }), document.removeEventListener("focusout", this.focusoutHandler, {
      capture: !0
    }), this.isListening = !1);
  }
  focusLandmark(t, n) {
    this.landmarks.find((r) => r.ref.current === t)?.focus?.(n);
  }
  /**
  * Return set of landmarks with a specific role.
  */
  getLandmarksByRole(t) {
    return new Set(this.landmarks.filter((n) => n.role === t));
  }
  /**
  * Return first landmark with a specific role.
  */
  getLandmarkByRole(t) {
    return this.landmarks.find((n) => n.role === t);
  }
  addLandmark(t) {
    if (this.setupIfNeeded(), this.landmarks.find((a) => a.ref === t.ref) || !t.ref.current) return;
    if (this.landmarks.filter((a) => a.role === "main").length > 1 && process.env.NODE_ENV !== "production" && console.error('Page can contain no more than one landmark with the role "main".'), this.landmarks.length === 0) {
      this.landmarks = [
        t
      ], this.checkLabels(t.role);
      return;
    }
    let n = 0, r = this.landmarks.length - 1;
    for (; n <= r; ) {
      let a = Math.floor((n + r) / 2), l = t.ref.current.compareDocumentPosition(this.landmarks[a].ref.current);
      !!(l & Node.DOCUMENT_POSITION_PRECEDING || l & Node.DOCUMENT_POSITION_CONTAINS) ? n = a + 1 : r = a - 1;
    }
    this.landmarks.splice(n, 0, t), this.checkLabels(t.role);
  }
  updateLandmark(t) {
    let n = this.landmarks.findIndex((r) => r.ref === t.ref);
    n >= 0 && (this.landmarks[n] = {
      ...this.landmarks[n],
      ...t
    }, this.checkLabels(this.landmarks[n].role));
  }
  removeLandmark(t) {
    this.landmarks = this.landmarks.filter((n) => n.ref !== t), this.teardownIfNeeded();
  }
  /**
  * Warn if there are 2+ landmarks with the same role but no label.
  * Labels for landmarks with the same role must also be unique.
  *
  * See https://www.w3.org/WAI/ARIA/apg/practices/landmark-regions/.
  */
  checkLabels(t) {
    let n = this.getLandmarksByRole(t);
    if (n.size > 1) {
      let r = [
        ...n
      ].filter((a) => !a.label);
      if (r.length > 0 && process.env.NODE_ENV !== "production") console.warn(`Page contains more than one landmark with the '${t}' role. If two or more landmarks on a page share the same role, all must be labeled with an aria-label or aria-labelledby attribute: `, r.map((a) => a.ref.current));
      else if (process.env.NODE_ENV !== "production") {
        let a = [
          ...n
        ].map((i) => i.label);
        a.filter((i, u) => a.indexOf(i) !== u).forEach((i) => {
          console.warn(`Page contains more than one landmark with the '${t}' role and '${i}' label. If two or more landmarks on a page share the same role, they must have unique labels: `, [
            ...n
          ].filter((u) => u.label === i).map((u) => u.ref.current));
        });
      }
    }
  }
  /**
  * Get the landmark that is the closest parent in the DOM.
  * Returns undefined if no parent is a landmark.
  */
  closestLandmark(t) {
    let n = new Map(this.landmarks.map((a) => [
      a.ref.current,
      a
    ])), r = t;
    for (; r && !n.has(r) && r !== document.body && r.parentElement; ) r = r.parentElement;
    return n.get(r);
  }
  /**
  * Gets the next landmark, in DOM focus order, or previous if backwards is specified.
  * If last landmark, next should be the first landmark.
  * If not inside a landmark, will return first landmark.
  * Returns undefined if there are no landmarks.
  */
  getNextLandmark(t, { backward: n }) {
    let r = this.closestLandmark(t), a = n ? this.landmarks.length - 1 : 0;
    r && (a = this.landmarks.indexOf(r) + (n ? -1 : 1));
    let l = () => {
      if (a < 0) {
        if (!t.dispatchEvent(new CustomEvent("react-aria-landmark-navigation", {
          detail: {
            direction: "backward"
          },
          bubbles: !0,
          cancelable: !0
        }))) return !0;
        a = this.landmarks.length - 1;
      } else if (a >= this.landmarks.length) {
        if (!t.dispatchEvent(new CustomEvent("react-aria-landmark-navigation", {
          detail: {
            direction: "forward"
          },
          bubbles: !0,
          cancelable: !0
        }))) return !0;
        a = 0;
      }
      return a < 0 || a >= this.landmarks.length;
    };
    if (l()) return;
    let i = a;
    for (; this.landmarks[a].ref.current?.closest("[aria-hidden=true]"); ) {
      if (a += n ? -1 : 1, l()) return;
      if (a === i) break;
    }
    return this.landmarks[a];
  }
  /**
  * Look at next landmark. If an element was previously focused inside, restore focus there.
  * If not, focus the landmark itself.
  * If no landmarks at all, or none with focusable elements, don't move focus.
  */
  f6Handler(t) {
    t.key === "F6" && (t.altKey ? this.focusMain() : this.navigate(W(t), t.shiftKey)) && (t.preventDefault(), t.stopPropagation());
  }
  focusMain() {
    let t = this.getLandmarkByRole("main");
    return t && t.ref.current && t.ref.current.isConnected ? (this.focusLandmark(t.ref.current, "forward"), !0) : !1;
  }
  navigate(t, n) {
    let r = this.getNextLandmark(t, {
      backward: n
    });
    if (!r) return !1;
    if (r.lastFocused) {
      let a = r.lastFocused;
      if (ae(document.body, a))
        return a.focus(), !0;
    }
    return r.ref.current && r.ref.current.isConnected ? (this.focusLandmark(r.ref.current, n ? "backward" : "forward"), !0) : !1;
  }
  /**
  * Sets lastFocused for a landmark, if focus is moved within that landmark.
  * Lets the last focused landmark know it was blurred if something else is focused.
  */
  focusinHandler(t) {
    let n = this.closestLandmark(W(t));
    n && n.ref.current !== W(t) && this.updateLandmark({
      ref: n.ref,
      lastFocused: W(t)
    });
    let r = t.relatedTarget;
    if (r) {
      let a = this.closestLandmark(r);
      a && a.ref.current === r && a.blur();
    }
  }
  /**
  * Track if the focus is lost to the body. If it is, do cleanup on the landmark that last had
  * focus.
  */
  focusoutHandler(t) {
    let n = W(t), r = t.relatedTarget;
    if (!r || r === document) {
      let a = this.closestLandmark(n);
      a && a.ref.current === n && a.blur();
    }
  }
  createLandmarkController() {
    let t = this;
    return t.refCount++, t.setupIfNeeded(), {
      navigate(n, r) {
        let a = r?.from || document.activeElement;
        return t.navigate(a, n === "backward");
      },
      focusNext(n) {
        let r = n?.from || document.activeElement;
        return t.navigate(r, !1);
      },
      focusPrevious(n) {
        let r = n?.from || document.activeElement;
        return t.navigate(r, !0);
      },
      focusMain() {
        return t.focusMain();
      },
      dispose() {
        t && (t.refCount--, t.teardownIfNeeded(), t = null);
      }
    };
  }
  registerLandmark(t) {
    return this.landmarks.find((n) => n.ref === t.ref) ? this.updateLandmark(t) : this.addLandmark(t), () => this.removeLandmark(t.ref);
  }
}
function sC(e, t) {
  const { role: n, "aria-label": r, "aria-labelledby": a, focus: l } = e;
  let i = uC(), u = r || a, [o, d] = Y(!1), s = X(() => {
    d(!0);
  }, [
    d
  ]), c = X(() => {
    d(!1);
  }, [
    d
  ]);
  return ue(() => {
    if (i) return i.registerLandmark({
      ref: t,
      label: u,
      role: n,
      focus: l || s,
      blur: c
    });
  }, [
    i,
    u,
    t,
    n,
    l,
    s,
    c
  ]), ee(() => {
    o && t.current?.focus();
  }, [
    o,
    t
  ]), {
    landmarkProps: {
      role: n,
      tabIndex: o ? -1 : void 0,
      "aria-label": r,
      "aria-labelledby": a
    }
  };
}
function dC(e) {
  return e && e.__esModule ? e.default : e;
}
function cC(e, t, n) {
  let r = xe(dC(Do), "@react-aria/toast"), { landmarkProps: a } = sC({
    role: "region",
    "aria-label": e["aria-label"] || r.format("notifications", {
      count: t.visibleToasts.length
    })
  }, n), l = T(!1), i = T(!1), u = X(() => {
    l.current || i.current ? t.pauseAll() : t.resumeAll();
  }, [
    t
  ]), { hoverProps: o } = ve({
    onHoverStart: () => {
      l.current = !0, u();
    },
    onHoverEnd: () => {
      l.current = !1, u();
    }
  }), d = T([]), s = T(t.visibleToasts), c = T(null);
  ue(() => {
    if (c.current === -1 || t.visibleToasts.length === 0 || !n.current) {
      d.current = [], s.current = t.visibleToasts;
      return;
    }
    if (d.current = [
      ...n.current.querySelectorAll('[role="alertdialog"]')
    ], s.current.length === t.visibleToasts.length && t.visibleToasts.every((b, y) => b.key === s.current[y].key)) {
      s.current = t.visibleToasts;
      return;
    }
    let m = s.current.map((b, y) => ({
      ...b,
      i: y,
      isRemoved: !t.visibleToasts.some(($) => b.key === $.key)
    })), p = m.findIndex((b) => b.i === c.current && b.isRemoved);
    if (p > -1)
      if (yt() === "pointer" && f.current?.isConnected) Fe(f.current);
      else {
        let b = 0, y, $;
        for (; b <= p; )
          m[b].isRemoved || ($ = Math.max(0, b - 1)), b++;
        for (; b < m.length; ) {
          if (!m[b].isRemoved) {
            y = b - 1;
            break;
          }
          b++;
        }
        $ === void 0 && y === void 0 && ($ = 0), $ >= 0 && $ < d.current.length ? Fe(d.current[$]) : y >= 0 && y < d.current.length && Fe(d.current[y]);
      }
    s.current = t.visibleToasts;
  }, [
    t.visibleToasts,
    n
  ]);
  let f = T(null), { focusWithinProps: h } = ct({
    onFocusWithin: (m) => {
      i.current = !0, f.current = m.relatedTarget, u();
    },
    onBlurWithin: () => {
      i.current = !1, f.current = null, u();
    }
  });
  return ee(() => {
    t.visibleToasts.length === 0 && f.current?.isConnected && (yt() === "pointer" ? Fe(f.current) : f.current.focus(), f.current = null);
  }, [
    n,
    t.visibleToasts.length
  ]), ee(() => () => {
    f.current?.isConnected && (yt() === "pointer" ? Fe(f.current) : f.current.focus(), f.current = null);
  }, [
    n
  ]), {
    regionProps: z(a, o, h, {
      tabIndex: -1,
      // Mark the toast region as a "top layer", so that it:
      //   - is not aria-hidden when opening an overlay
      //   - allows focus even outside a containing focus scope
      //   - doesn’t dismiss overlays when clicking on it, even though it is outside
      // @ts-ignore
      "data-react-aria-top-layer": !0,
      // listen to focus events separate from focuswithin because that will only fire once
      // and we need to follow all focus changes
      onFocus: (m) => {
        let p = W(m).closest('[role="alertdialog"]');
        c.current = d.current.findIndex((b) => b === p);
      },
      onBlur: () => {
        c.current = -1;
      }
    })
  };
}
function fC(e) {
  let t = X((a) => e.subscribe(a), [
    e
  ]), n = X(() => e.visibleToasts, [
    e
  ]);
  return {
    visibleToasts: xu.useSyncExternalStore(t, n, n),
    add: (a, l) => e.add(a, l),
    close: (a) => e.close(a),
    pauseAll: () => e.pauseAll(),
    resumeAll: () => e.resumeAll()
  };
}
class rP {
  constructor(t) {
    this.queue = [], this.subscriptions = /* @__PURE__ */ new Set(), this.visibleToasts = [], this.maxVisibleToasts = t?.maxVisibleToasts ?? 1 / 0, this.wrapUpdate = t?.wrapUpdate;
  }
  runWithWrapUpdate(t, n) {
    this.wrapUpdate ? this.wrapUpdate(t, n) : t();
  }
  /** Subscribes to updates to the visible toasts. */
  subscribe(t) {
    return this.subscriptions.add(t), () => this.subscriptions.delete(t);
  }
  /** Adds a new toast to the queue. */
  add(t, n = {}) {
    let r = "_" + Math.random().toString(36).slice(2), a = {
      ...n,
      content: t,
      key: r,
      timer: n.timeout ? new hC(() => this.close(r), n.timeout) : void 0
    };
    return this.queue.unshift(a), this.updateVisibleToasts("add"), r;
  }
  /**
  * Closes a toast.
  */
  close(t) {
    let n = this.queue.findIndex((r) => r.key === t);
    n >= 0 && (this.queue[n].onClose?.(), this.queue.splice(n, 1)), this.updateVisibleToasts("remove");
  }
  updateVisibleToasts(t) {
    this.visibleToasts = this.queue.slice(0, this.maxVisibleToasts), this.runWithWrapUpdate(() => {
      for (let n of this.subscriptions) n();
    }, t);
  }
  /** Pauses the timers for all visible toasts. */
  pauseAll() {
    for (let t of this.visibleToasts) t.timer && t.timer.pause();
  }
  /** Resumes the timers for all visible toasts. */
  resumeAll() {
    for (let t of this.visibleToasts) t.timer && t.timer.resume();
  }
  clear() {
    this.queue = [], this.updateVisibleToasts("clear");
  }
}
class hC {
  constructor(t, n) {
    this.startTime = null, this.remaining = n, this.callback = t;
  }
  reset(t) {
    this.remaining = t, this.resume();
  }
  pause() {
    this.timerId != null && (clearTimeout(this.timerId), this.timerId = null, this.remaining -= Date.now() - this.startTime);
  }
  resume() {
    this.remaining <= 0 || (this.startTime = Date.now(), this.timerId = setTimeout(() => {
      this.timerId = null, this.remaining = 0, this.callback();
    }, this.remaining));
  }
}
const xo = /* @__PURE__ */ G(null), aP = /* @__PURE__ */ te(function(t, n) {
  let r = Dt(), a = fC(t.queue), l = $e(n), { regionProps: i } = cC(t, a, l), { focusProps: u, isFocused: o, isFocusVisible: d } = ye(), { hoverProps: s, isHovered: c } = ve({}), f = le({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ToastRegion",
    values: {
      visibleToasts: a.visibleToasts,
      isHovered: c,
      isFocused: o,
      isFocusVisible: d
    }
  }), { direction: h } = de(), m, { getContainer: p } = lo();
  r || (m = document.body, p && (m = p()));
  let b = J(t, {
    global: !0
  }), y = /* @__PURE__ */ g.createElement(xo.Provider, {
    value: a
  }, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(b, f, i, u, s),
    dir: h,
    ref: l,
    "data-hovered": c || void 0,
    "data-focused": o || void 0,
    "data-focus-visible": d || void 0
  }, typeof t.children == "function" ? /* @__PURE__ */ g.createElement(mC, {
    ...t,
    render: void 0,
    className: void 0,
    style: {
      display: "contents"
    }
  }, t.children) : t.children));
  return a.visibleToasts.length > 0 && m ? /* @__PURE__ */ Nd(y, m) : null;
}), mC = /* @__PURE__ */ te(function(t, n) {
  let r = O(xo), { hoverProps: a, isHovered: l } = ve({}), i = le({
    ...t,
    children: void 0,
    defaultClassName: "react-aria-ToastList",
    values: {
      visibleToasts: r.visibleToasts,
      isFocused: !1,
      isFocusVisible: !1,
      isHovered: l
    }
  });
  return /* @__PURE__ */ g.createElement(Q.ol, {
    ...a,
    ...i,
    ref: n
  }, r.visibleToasts.map((u) => /* @__PURE__ */ g.createElement("li", {
    key: u.key,
    style: {
      display: "contents"
    }
  }, t.children({
    toast: u
  }))));
}), lP = /* @__PURE__ */ te(function(t, n) {
  let r = O(xo), a = $e(n), { toastProps: l, contentProps: i, titleProps: u, descriptionProps: o, closeButtonProps: d } = lC(t, r, a), { focusProps: s, isFocused: c, isFocusVisible: f } = ye(), h = le({
    ...t,
    defaultClassName: "react-aria-Toast",
    values: {
      toast: t.toast,
      isFocused: c,
      isFocusVisible: f
    }
  }), m = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(m, h, l, s),
    ref: a,
    "data-focused": c || void 0,
    "data-focus-visible": f || void 0
  }, /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Fv,
        i
      ],
      [
        _e,
        {
          slots: {
            [gt]: {},
            title: u,
            description: o
          }
        }
      ],
      [
        Ze,
        {
          slots: {
            [gt]: {},
            close: d
          }
        }
      ]
    ]
  }, h.children));
}), Fv = /* @__PURE__ */ G({}), iP = /* @__PURE__ */ te(function(t, n) {
  return [t, n] = oe(t, n, Fv), /* @__PURE__ */ g.createElement(Q.div, {
    render: t.render,
    className: "react-aria-ToastContent",
    ...t,
    ref: n
  }, t.children);
});
function Av(e, t, n) {
  const { isSelected: r } = t, { isPressed: a, buttonProps: l } = Lf({
    ...e,
    onPress: ot(t.toggle, e.onPress)
  }, n);
  return {
    isPressed: a,
    isSelected: r,
    isDisabled: e.isDisabled || !1,
    buttonProps: z(l, {
      "aria-pressed": r
    })
  };
}
function Rv(e, t) {
  const { "aria-label": n, "aria-labelledby": r, orientation: a = "horizontal" } = e;
  let [l, i] = Y(!1);
  ue(() => {
    i(!!(t.current && t.current.parentElement?.closest('[role="toolbar"]')));
  });
  const { direction: u } = de(), o = u === "rtl" && a === "horizontal";
  let d = kl(t);
  const s = (m) => {
    if (ae(m.currentTarget, W(m))) {
      if (a === "horizontal" && m.key === "ArrowRight" || a === "vertical" && m.key === "ArrowDown")
        o ? d.focusPrevious() : d.focusNext();
      else if (a === "horizontal" && m.key === "ArrowLeft" || a === "vertical" && m.key === "ArrowUp")
        o ? d.focusNext() : d.focusPrevious();
      else if (m.key === "Tab") {
        c.current = se(), m.shiftKey ? d.focusFirst() : d.focusLast();
        return;
      } else
        return;
      m.stopPropagation(), m.preventDefault();
    }
  }, c = T(null), f = (m) => {
    !ae(m.currentTarget, m.relatedTarget) && !c.current && (c.current = W(m));
  }, h = (m) => {
    c.current && !ae(m.currentTarget, m.relatedTarget) && ae(t.current, W(m)) && (c.current?.focus(), c.current = null);
  };
  return {
    toolbarProps: {
      ...J(e, {
        labelable: !0
      }),
      role: l ? "group" : "toolbar",
      "aria-orientation": a,
      "aria-label": n,
      "aria-labelledby": n == null ? r : void 0,
      onKeyDownCapture: l ? void 0 : s,
      onFocusCapture: l ? void 0 : h,
      onBlurCapture: l ? void 0 : f
    }
  };
}
function pC(e, t, n) {
  let { isDisabled: r } = e, { toolbarProps: a } = Rv(e, n);
  return {
    groupProps: {
      ...a,
      role: t.selectionMode === "single" ? "radiogroup" : a.role,
      "aria-disabled": r
    }
  };
}
function bC(e, t, n) {
  let r = {
    isSelected: t.selectedKeys.has(e.id),
    defaultSelected: !1,
    setSelected(o) {
      t.setSelected(e.id, o);
    },
    toggle() {
      t.toggleKey(e.id);
    }
  }, { isPressed: a, isSelected: l, isDisabled: i, buttonProps: u } = Av({
    ...e,
    id: void 0,
    isDisabled: e.isDisabled || t.isDisabled
  }, r, n);
  return t.selectionMode === "single" && (u.role = "radio", u["aria-checked"] = r.isSelected, delete u["aria-pressed"]), {
    isPressed: a,
    isSelected: l,
    isDisabled: i,
    buttonProps: u
  };
}
function gC(e) {
  let { selectionMode: t = "single", disallowEmptySelection: n, isDisabled: r = !1 } = e, [a, l] = Pe(K(() => e.selectedKeys ? new Set(e.selectedKeys) : void 0, [
    e.selectedKeys
  ]), K(() => e.defaultSelectedKeys ? new Set(e.defaultSelectedKeys) : /* @__PURE__ */ new Set(), [
    e.defaultSelectedKeys
  ]), e.onSelectionChange);
  return {
    selectionMode: t,
    isDisabled: r,
    selectedKeys: a,
    setSelectedKeys: l,
    toggleKey(i) {
      let u;
      t === "multiple" ? (u = new Set(a), u.has(i) && (!n || u.size > 1) ? u.delete(i) : u.add(i)) : u = new Set(a.has(i) && !n ? [] : [
        i
      ]), l(u);
    },
    setSelected(i, u) {
      u !== a.has(i) && this.toggleKey(i);
    }
  };
}
const yC = /* @__PURE__ */ G({}), Tv = /* @__PURE__ */ G(null), uP = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, yC);
  let r = gC(t), { groupProps: a } = pC(t, r, n), l = le({
    ...t,
    values: {
      orientation: t.orientation || "horizontal",
      isDisabled: r.isDisabled,
      state: r
    },
    defaultClassName: "react-aria-ToggleButtonGroup"
  }), i = J(t, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(i, l, a),
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": t.orientation || "horizontal",
    "data-disabled": t.isDisabled || void 0
  }, /* @__PURE__ */ g.createElement(Tv.Provider, {
    value: r
  }, /* @__PURE__ */ g.createElement(jn, null, l.children)));
}), $C = /* @__PURE__ */ G({}), oP = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, $C);
  let r = O(Tv), a = wl(r && t.id != null ? {
    isSelected: r.selectedKeys.has(t.id),
    onChange(b) {
      r.setSelected(t.id, b);
    }
  } : t), { buttonProps: l, isPressed: i, isSelected: u, isDisabled: o } = r && t.id != null ? bC({
    ...t,
    id: t.id
  }, r, n) : Av({
    ...t,
    id: t.id != null ? String(t.id) : void 0
  }, a, n), { focusProps: d, isFocused: s, isFocusVisible: c } = ye(t), { hoverProps: f, isHovered: h } = ve({
    ...t,
    isDisabled: o
  }), m = le({
    ...t,
    id: void 0,
    values: {
      isHovered: h,
      isPressed: i,
      isFocused: s,
      isSelected: a.isSelected,
      isFocusVisible: c,
      isDisabled: o,
      state: a
    },
    defaultClassName: "react-aria-ToggleButton"
  }), p = J(t, {
    global: !0
  });
  return delete p.id, delete p.onClick, /* @__PURE__ */ g.createElement(Q.button, {
    ...z(p, m, l, d, f),
    ref: n,
    slot: t.slot || void 0,
    "data-focused": s || void 0,
    "data-disabled": o || void 0,
    "data-pressed": i || void 0,
    "data-selected": u || void 0,
    "data-hovered": h || void 0,
    "data-focus-visible": c || void 0
  }, /* @__PURE__ */ g.createElement(_n.Provider, {
    value: {
      isSelected: u
    }
  }, m.children));
}), vC = /* @__PURE__ */ G({}), sP = /* @__PURE__ */ te(function(t, n) {
  [t, n] = oe(t, n, vC);
  let { toolbarProps: r } = Rv(t, n), a = le({
    ...t,
    values: {
      orientation: t.orientation || "horizontal"
    },
    defaultClassName: "react-aria-Toolbar"
  }), l = J(t, {
    global: !0
  });
  return delete l.id, /* @__PURE__ */ g.createElement(Q.div, {
    ...z(l, a, r),
    ref: n,
    slot: t.slot || void 0,
    "data-orientation": t.orientation || "horizontal"
  }, a.children);
}), su = /* @__PURE__ */ g.createContext(null);
function DC(e) {
  let { children: t } = e, n = O(su), [r, a] = Y(0), l = K(() => ({
    parent: n,
    modalCount: r,
    addModal() {
      a((i) => i + 1), n && n.addModal();
    },
    removeModal() {
      a((i) => i - 1), n && n.removeModal();
    }
  }), [
    n,
    r
  ]);
  return /* @__PURE__ */ g.createElement(su.Provider, {
    value: l
  }, t);
}
function xC() {
  let e = O(su);
  return {
    modalProviderProps: {
      "aria-hidden": e && e.modalCount > 0 ? !0 : void 0
    }
  };
}
function EC(e) {
  let { modalProviderProps: t } = xC();
  return /* @__PURE__ */ g.createElement("div", {
    "data-overlay-container": !0,
    ...e,
    ...t
  });
}
function CC(e) {
  return /* @__PURE__ */ g.createElement(DC, null, /* @__PURE__ */ g.createElement(EC, e));
}
function PC(e) {
  let t = Dt(), { portalContainer: n = t ? null : document.body, ...r } = e, { getContainer: a } = lo();
  if (!e.portalContainer && a && (n = a()), g.useEffect(() => {
    if (n?.closest("[data-overlay-container]")) throw new Error("An OverlayContainer must not be inside another container. Please change the portalContainer prop.");
  }, [
    n
  ]), !n) return null;
  let l = /* @__PURE__ */ g.createElement(CC, r);
  return /* @__PURE__ */ cu.createPortal(l, n);
}
const wC = 1500, Id = 500;
let Sn = {}, SC = 0, Nr = !1, Ft = null, kn = null;
function Iv(e = {}) {
  let { delay: t = wC, closeDelay: n = Id } = e, { isOpen: r, open: a, close: l } = Br(e), i = K(() => `${++SC}`, []), u = T(null), o = T(l), d = () => {
    Sn[i] = f;
  }, s = () => {
    for (let m in Sn) m !== i && (Sn[m](!0), delete Sn[m]);
  }, c = () => {
    u.current && clearTimeout(u.current), u.current = null, s(), d(), Nr = !0, a(), Ft && (clearTimeout(Ft), Ft = null), kn && (clearTimeout(kn), kn = null);
  }, f = (m) => {
    m || n <= 0 ? (u.current && clearTimeout(u.current), u.current = null, o.current()) : u.current || (u.current = setTimeout(() => {
      u.current = null, o.current();
    }, n)), Ft && (clearTimeout(Ft), Ft = null), Nr && (kn && clearTimeout(kn), kn = setTimeout(() => {
      delete Sn[i], kn = null, Nr = !1;
    }, Math.max(Id, n)));
  }, h = () => {
    s(), d(), !r && !Nr ? (Ft && clearTimeout(Ft), Ft = setTimeout(() => {
      Ft = null, Nr = !0, c();
    }, t)) : r || c();
  };
  return ee(() => {
    o.current = l;
  }, [
    l
  ]), ee(() => () => {
    u.current && clearTimeout(u.current), Sn[i] && delete Sn[i];
  }, [
    i
  ]), {
    isOpen: r,
    open: (m) => {
      !m && t > 0 && !u.current ? h() : c();
    },
    close: f
  };
}
function kC(e, t) {
  let n = J(e, {
    labelable: !0
  }), { hoverProps: r } = ve({
    onHoverStart: () => t?.open(!0),
    onHoverEnd: () => t?.close()
  });
  return {
    tooltipProps: z(n, r, {
      role: "tooltip"
    })
  };
}
function BC(e, t, n) {
  let { isDisabled: r, trigger: a, shouldCloseOnPress: l = !0 } = e, i = ce(), u = T(!1), o = T(!1), d = () => {
    (u.current || o.current) && t.open(o.current);
  }, s = ($) => {
    !u.current && !o.current && t.close($);
  };
  ee(() => {
    let $ = (v) => {
      n && n.current && v.key === "Escape" && (v.stopPropagation(), t.close(!0));
    };
    if (t.isOpen)
      return document.addEventListener("keydown", $, !0), () => {
        document.removeEventListener("keydown", $, !0);
      };
  }, [
    n,
    t
  ]);
  let c = () => {
    a !== "focus" && (yt() === "pointer" ? u.current = !0 : u.current = !1, d());
  }, f = () => {
    a !== "focus" && (o.current = !1, u.current = !1, s());
  }, h = () => {
    l && (o.current = !1, u.current = !1, s(!0));
  }, m = () => {
    Mt() && (o.current = !0, d());
  }, p = () => {
    o.current = !1, u.current = !1, s(!0);
  }, { hoverProps: b } = ve({
    isDisabled: r,
    onHoverStart: c,
    onHoverEnd: f
  }), { focusableProps: y } = dt({
    isDisabled: r,
    onFocus: m,
    onBlur: p
  }, n);
  return {
    triggerProps: {
      "aria-describedby": t.isOpen ? i : void 0,
      ...z(y, b, {
        onPointerDown: h,
        onKeyDown: h
      }),
      tabIndex: void 0
    },
    tooltipProps: {
      id: i
    }
  };
}
const Eo = /* @__PURE__ */ G(null), Mv = /* @__PURE__ */ G(null);
function dP(e) {
  let t = Iv(e), n = T(null), { triggerProps: r, tooltipProps: a } = BC(e, t, n);
  return /* @__PURE__ */ g.createElement(me, {
    values: [
      [
        Eo,
        t
      ],
      [
        Mv,
        {
          ...a,
          triggerRef: n
        }
      ]
    ]
  }, /* @__PURE__ */ g.createElement(q5, {
    ...r,
    ref: n
  }, e.children));
}
const cP = /* @__PURE__ */ te(function({ UNSTABLE_portalContainer: t, ...n }, r) {
  [n, r] = oe(n, r, Mv);
  let a = O(Eo), l = Iv(n), i = n.isOpen != null || n.defaultOpen != null || !a ? l : a, u = sa(r, i.isOpen) || n.isExiting || !1;
  return !i.isOpen && !u ? null : /* @__PURE__ */ g.createElement(PC, {
    portalContainer: t
  }, /* @__PURE__ */ g.createElement(FC, {
    ...n,
    tooltipRef: r,
    isExiting: u
  }));
});
function FC(e) {
  let t = O(Eo), n = T(null), { overlayProps: r, arrowProps: a, placement: l, triggerAnchorPoint: i } = Xp({
    placement: e.placement || "top",
    targetRef: e.triggerRef,
    overlayRef: e.tooltipRef,
    arrowRef: n,
    offset: e.offset,
    crossOffset: e.crossOffset,
    isOpen: t.isOpen,
    arrowBoundaryOffset: e.arrowBoundaryOffset,
    shouldFlip: e.shouldFlip,
    containerPadding: e.containerPadding,
    onClose: () => t.close(!0)
  }), u = va(e.tooltipRef, !!l) || e.isEntering || !1, o = le({
    ...e,
    defaultClassName: "react-aria-Tooltip",
    values: {
      placement: l,
      isEntering: u,
      isExiting: e.isExiting,
      state: t
    }
  });
  e = z(e, r);
  let { tooltipProps: d } = kC(e, t), s = J(e, {
    global: !0
  });
  return /* @__PURE__ */ g.createElement(Q.div, {
    ...z(s, o, d),
    ref: e.tooltipRef,
    style: {
      ...r.style,
      "--trigger-anchor-point": i ? `${i.x}px ${i.y}px` : void 0,
      ...o.style
    },
    "data-placement": l ?? void 0,
    "data-entering": u || void 0,
    "data-exiting": e.isExiting || void 0
  }, /* @__PURE__ */ g.createElement(Gp.Provider, {
    value: {
      ...a,
      placement: l,
      ref: n
    }
  }, o.children));
}
let er = null;
function AC(e = !1) {
  if (er === null || e) {
    const t = document.createElement("div"), n = t.style;
    n.width = "50px", n.height = "50px", n.overflow = "scroll", n.direction = "rtl";
    const r = document.createElement("div"), a = r.style;
    return a.width = "100px", a.height = "100px", t.appendChild(r), document.body.appendChild(t), t.scrollLeft > 0 ? er = "positive-descending" : (t.scrollLeft = 1, t.scrollLeft === 0 ? er = "negative" : er = "positive-ascending"), document.body.removeChild(t), er;
  }
  return er;
}
function RC(e, t) {
  let { scrollLeft: n } = e;
  if (t === "rtl") {
    let { scrollWidth: r, clientWidth: a } = e;
    switch (AC()) {
      case "negative":
        n = -n;
        break;
      case "positive-descending":
        n = r - a - n;
        break;
    }
  }
  return n;
}
function TC(e, t) {
  let { contentSize: n, onVisibleRectChange: r, onSizeChange: a, innerStyle: l, onScrollStart: i, onScrollEnd: u, scrollDirection: o = "both", onScroll: d, allowsWindowScrolling: s, ...c } = e, f = T({
    // Internal scroll position of the scroll view.
    scrollPosition: new pt(),
    // Size of the scroll view.
    size: new Ue(),
    // Offset of the scroll view relative to the window viewport.
    viewportOffset: new pt(),
    // Size of the window viewport.
    viewportSize: new Ue(),
    scrollEndTime: 0,
    scrollTimeout: null,
    isScrolling: !1,
    lastVisibleRect: new be()
  }).current, { direction: h } = de(), m = X(() => {
    let V = s ? new be(f.viewportOffset.x + f.scrollPosition.x, f.viewportOffset.y + f.scrollPosition.y, Math.max(0, Math.min(f.size.width - f.viewportOffset.x, f.viewportSize.width)), Math.max(0, Math.min(f.size.height - f.viewportOffset.y, f.viewportSize.height))) : new be(f.scrollPosition.x, f.scrollPosition.y, f.size.width, f.size.height);
    (V.area > 0 || f.lastVisibleRect.area > 0) && (r(V), f.lastVisibleRect = V);
  }, [
    f,
    s,
    r
  ]), [p, b] = Y(!1), y = X((V) => {
    let I = W(V);
    if (ae(I, t.current)) {
      if (d && I === t.current && d(V), I !== t.current) {
        let A = t.current.getBoundingClientRect(), U = A.x < 0 ? -A.x : 0, D = A.y < 0 ? -A.y : 0;
        if (U === f.viewportOffset.x && D === f.viewportOffset.y) return;
        f.viewportOffset = new pt(U, D);
      } else {
        let A = I.scrollTop, U = RC(I, h);
        f.scrollPosition = new pt(Math.max(0, Math.min(U, n.width - f.size.width)), Math.max(0, Math.min(A, n.height - f.size.height)));
      }
      at(() => {
        m(), f.isScrolling || (f.isScrolling = !0, b(!0), window.dispatchEvent(new Event("tk.disconnect-observer")), i && i());
        let A = Date.now();
        f.scrollEndTime <= A + 50 && (f.scrollEndTime = A + 300, f.scrollTimeout != null && clearTimeout(f.scrollTimeout), f.scrollTimeout = setTimeout(() => {
          f.isScrolling = !1, b(!1), f.scrollTimeout = null, window.dispatchEvent(new Event("tk.connect-observer")), u && u();
        }, 300));
      });
    }
  }, [
    d,
    t,
    h,
    f,
    n,
    m,
    i,
    u
  ]);
  ee(() => (document.addEventListener("scroll", y, !0), () => document.removeEventListener("scroll", y, !0)), [
    y
  ]), ee(() => () => {
    f.scrollTimeout != null && clearTimeout(f.scrollTimeout), f.isScrolling && window.dispatchEvent(new Event("tk.connect-observer"));
  }, []);
  let $ = T(!1), v = X((V) => {
    let I = t.current;
    if (!I || $.current) return;
    $.current = !0;
    let A = process.env.NODE_ENV === "test" && !process.env.VIRT_ON, U = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientWidth"), D = Object.getOwnPropertyNames(window.HTMLElement.prototype).includes("clientHeight"), N = I.clientWidth, w = I.clientHeight, R = A && !U ? 1 / 0 : N, H = A && !D ? 1 / 0 : w, k = window.innerWidth, S = window.innerHeight, j = f.viewportSize.width !== k || f.viewportSize.height !== S;
    j && (f.viewportSize = new Ue(k, S)), (f.size.width !== R || f.size.height !== H || j) && (f.size = new Ue(R, H), V(() => {
      m(), a?.(f.size);
    }), (!A && N !== I.clientWidth || w !== I.clientHeight) && (f.size = new Ue(I.clientWidth, I.clientHeight), V(() => {
      m(), a?.(f.size);
    }))), $.current = !1;
  }, [
    t,
    f,
    m,
    a
  ]), x = De(v);
  ue(() => {
    f.viewportSize = new Ue(window.innerWidth, window.innerHeight);
    let V = () => {
      x(at);
    };
    return window.addEventListener("resize", V), () => window.removeEventListener("resize", V);
  }, [
    f
  ]);
  let E = T(null), [P, C] = Y({});
  ue(() => {
    if (!$.current && (E.current == null || !n.equals(E.current)))
      if (
        // @ts-ignore
        typeof IS_REACT_ACT_ENVIRONMENT == "boolean" ? IS_REACT_ACT_ENVIRONMENT : typeof jest < "u"
      ) {
        C({}), E.current = n;
        return;
      } else queueMicrotask(() => x(at));
    E.current = n;
  }), ue(() => {
    x((V) => V());
  }, [
    P
  ]);
  let M = X(() => {
    v(at);
  }, [
    v
  ]);
  gr({
    ref: t,
    box: "border-box",
    onResize: M
  });
  let F = {
    // Reset padding so that relative positioning works correctly. Padding will be done in JS layout.
    padding: 0,
    ...c.style
  };
  return o === "horizontal" ? (F.overflowX = "auto", F.overflowY = "hidden") : o === "vertical" || n.width === f.size.width ? (F.overflowY = "auto", F.overflowX = "hidden") : F.overflow = "auto", l = {
    width: Number.isFinite(n.width) ? n.width : void 0,
    height: Number.isFinite(n.height) ? n.height : void 0,
    pointerEvents: p ? "none" : "auto",
    position: "relative",
    ...l
  }, {
    isScrolling: p,
    scrollViewProps: {
      ...c,
      style: F
    },
    contentProps: {
      role: "presentation",
      style: l
    }
  };
}
function IC(e) {
  let { layoutInfo: t, virtualizer: n, ref: r } = e, a = t?.key, l = X(() => {
    if (a != null && r.current) {
      let i = MC(r.current);
      n.updateItemSize(a, i);
    }
  }, [
    n,
    a,
    r
  ]);
  return ue(() => {
    t?.estimatedSize && l();
  }), {
    updateSize: l
  };
}
function MC(e) {
  let t = e.style.height;
  e.style.height = "";
  let n = new Ue(e.scrollWidth, e.scrollHeight);
  return e.style.height = t, n;
}
function Kv(e) {
  let { style: t, className: n, layoutInfo: r, virtualizer: a, parent: l, children: i } = e, { direction: u } = de(), o = T(null);
  return IC({
    layoutInfo: r,
    virtualizer: a,
    ref: o
  }), /* @__PURE__ */ g.createElement("div", {
    role: "presentation",
    ref: o,
    className: n,
    style: {
      ...KC(r, u, l),
      ...t
    }
  }, i);
}
let Md = /* @__PURE__ */ new WeakMap();
function KC(e, t, n) {
  let r = t === "rtl" ? "right" : "left", a = Md.get(e);
  if (a && a[r] != null) {
    if (!n) return a;
    let u = e.rect.y - n.rect.y, o = e.rect.x - n.rect.x;
    if (a.top === u && a[r] === o) return a;
  }
  let l = {
    // TODO: For layoutInfos that are sticky that have parents with overflow visible, their "top" will be relative to the to the nearest scrolling container
    // which WON'T be the parent since the parent has overflow visible. This means we shouldn't offset the height by the parent's position
    // Not 100% about this change here since it is quite ambigious what the scrolling container maybe and how its top is positioned with respect to the
    // calculated layoutInfo.y here
    top: e.rect.y - (n && !(n.allowOverflow && e.isSticky) ? n.rect.y : 0),
    [r]: e.rect.x - (n && !(n.allowOverflow && e.isSticky) ? n.rect.x : 0),
    width: e.rect.width,
    height: e.rect.height
  };
  Object.entries(l).forEach(([u, o]) => {
    Number.isFinite(o) || (l[u] = void 0);
  });
  let i = {
    position: e.isSticky ? "sticky" : "absolute",
    // Sticky elements are positioned in normal document flow. Display inline-block so that they don't push other sticky columns onto the following rows.
    display: e.isSticky ? "inline-block" : void 0,
    overflow: e.allowOverflow ? "visible" : "hidden",
    opacity: e.opacity,
    zIndex: e.zIndex,
    transform: e.transform ?? void 0,
    contain: "size layout style",
    ...l
  };
  return Md.set(e, i), i;
}
const Nv = /* @__PURE__ */ G(null), Vv = /* @__PURE__ */ G(null);
function fP(e) {
  let { children: t, layout: n, layoutOptions: r } = e, a = K(() => typeof n == "function" ? new n() : n, [
    n
  ]), l = K(() => ({
    isVirtualized: !0,
    layoutDelegate: a,
    dropTargetDelegate: a.getDropTargetFromPoint ? a : void 0,
    CollectionRoot: NC,
    CollectionBranch: VC
  }), [
    a
  ]);
  return /* @__PURE__ */ g.createElement(ge.Provider, {
    value: l
  }, /* @__PURE__ */ g.createElement(Vv.Provider, {
    value: {
      layout: a,
      layoutOptions: r
    }
  }, t));
}
function NC({ collection: e, persistedKeys: t, scrollRef: n, renderDropIndicator: r }) {
  let { layout: a, layoutOptions: l } = O(Vv), i = a.useLayoutOptions?.(), u = V8({
    allowsWindowScrolling: !0,
    layout: a,
    collection: e,
    renderView: (d, s) => s?.render?.(s),
    onVisibleRectChange(d) {
      let s = n?.current;
      s && (s.scrollLeft = d.x, s.scrollTop = d.y);
    },
    persistedKeys: t,
    layoutOptions: K(() => l && i ? {
      ...l,
      ...i
    } : l || i, [
      l,
      i
    ])
  }), { contentProps: o } = TC({
    onVisibleRectChange: u.setVisibleRect,
    onSizeChange: u.setSize,
    contentSize: u.contentSize,
    onScrollStart: u.startScrolling,
    onScrollEnd: u.endScrolling,
    allowsWindowScrolling: !0
  }, n);
  return /* @__PURE__ */ g.createElement("div", o, /* @__PURE__ */ g.createElement(Nv.Provider, {
    value: u
  }, Lv(null, u.visibleViews, r)));
}
function VC({ parent: e, renderDropIndicator: t }) {
  let r = O(Nv).virtualizer.getVisibleView(e.key);
  return Lv(r, Array.from(r.children), t);
}
function Lv(e, t, n) {
  return t.map((r) => LC(e, r, n));
}
function LC(e, t, n) {
  let r = /* @__PURE__ */ g.createElement(Kv, {
    key: t.key,
    layoutInfo: t.layoutInfo,
    virtualizer: t.virtualizer,
    parent: e?.layoutInfo
  }, t.rendered), { collection: a, layout: l } = t.virtualizer, i = t.content;
  return i?.type === "item" && n && l.getDropTargetLayoutInfo && (r = /* @__PURE__ */ g.createElement(g.Fragment, {
    key: t.key
  }, Kd(e, t, {
    type: "item",
    key: t.content.key,
    dropPosition: "before"
  }, n), r, Zc(a, i, (u) => Kd(e, t, u, n)))), r;
}
function Kd(e, t, n, r) {
  let a = r(n);
  if (a) {
    let l = t.virtualizer.layout.getDropTargetLayoutInfo(n);
    a = /* @__PURE__ */ g.createElement(Kv, {
      layoutInfo: l,
      virtualizer: t.virtualizer,
      parent: e?.layoutInfo
    }, a);
  }
  return a;
}
export {
  tn as $,
  H6 as A,
  j6 as B,
  W6 as C,
  e9 as D,
  D9 as E,
  p5 as F,
  g9 as G,
  y9 as H,
  AE as I,
  ve as J,
  Xe as K,
  J9 as L,
  Q9 as M,
  U9 as N,
  _9 as O,
  O9 as P,
  H9 as Q,
  L9 as R,
  z9 as S,
  Jt as T,
  Ri as U,
  j9 as V,
  N9 as W,
  V9 as X,
  sP as Y,
  ue as Z,
  gr as _,
  Pe as a,
  v4 as a0,
  de as a1,
  eP as a2,
  ce as a3,
  jC as a4,
  xt as a5,
  _C as a6,
  YC as a7,
  WC as a8,
  GC as a9,
  f9 as aA,
  UC as aB,
  Ex as aC,
  vx as aD,
  fP as aE,
  W9 as aF,
  M9 as aG,
  K9 as aH,
  G9 as aI,
  q9 as aJ,
  Y9 as aK,
  n5 as aL,
  Z9 as aM,
  X9 as aN,
  d9 as aO,
  q1 as aP,
  tP as aQ,
  nP as aR,
  aP as aS,
  rP as aT,
  lP as aU,
  iP as aV,
  oP as aW,
  uP as aX,
  p7 as aY,
  wr as aZ,
  HC as aa,
  cP as ab,
  dP as ac,
  $e as ad,
  n9 as ae,
  CD as af,
  dE as ag,
  F9 as ah,
  XC as ai,
  Cl as aj,
  Se as ak,
  A2 as al,
  t9 as am,
  oe as an,
  Qe as ao,
  k9 as ap,
  B9 as aq,
  S9 as ar,
  $9 as as,
  s9 as at,
  v9 as au,
  c9 as av,
  A9 as aw,
  R9 as ax,
  T9 as ay,
  I9 as az,
  l9 as b,
  qC as c,
  t5 as d,
  h9 as e,
  m9 as f,
  o9 as g,
  r9 as h,
  Ye as i,
  ZC as j,
  p9 as k,
  a9 as l,
  u9 as m,
  i9 as n,
  x9 as o,
  ye as p,
  ua as q,
  z as r,
  w9 as s,
  xD as t,
  C9 as u,
  P9 as v,
  b9 as w,
  E9 as x,
  JC as y,
  QC as z
};
